var f_ = Object.defineProperty;
var p_ = (e, t, n) => t in e ? f_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Wn = (e, t, n) => p_(e, typeof t != "symbol" ? t + "" : t, n);
import * as R from "react";
import gt, { createElement as rh, useEffect as gn, Children as K0, useState as oi, useRef as gr, createRef as rf, cloneElement as ag, useReducer as og, useCallback as Ln, isValidElement as X0, useMemo as Ld, Component as h_, useContext as m_, createContext as g_ } from "react";
import { useLocation as sg, Navigate as y_, NavLink as $c, useNavigate as Ol, useSearchParams as Z0, Link as wn } from "react-router";
import * as v_ from "react-dom";
import { createPortal as b_ } from "react-dom";
import { Grid as il, Menu as Ni, Image as J0, Button as Ah, Modal as ih, Input as A0, Dropdown as ah } from "semantic-ui-react";
import Zt from "prop-types";
import w_ from "classnames";
function x_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Td = { exports: {} }, pc = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a2;
function __() {
  if (a2) return pc;
  a2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, a) {
    var o = null;
    if (a !== void 0 && (o = "" + a), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      a = {};
      for (var s in i)
        s !== "key" && (a[s] = i[s]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return pc.Fragment = t, pc.jsx = n, pc.jsxs = n, pc;
}
var hc = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var o2;
function N_() {
  return o2 || (o2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(T) {
      if (T == null) return null;
      if (typeof T == "function")
        return T.$$typeof === oe ? null : T.displayName || T.name || null;
      if (typeof T == "string") return T;
      switch (T) {
        case q:
          return "Fragment";
        case F:
          return "Portal";
        case x:
          return "Profiler";
        case j:
          return "StrictMode";
        case L:
          return "Suspense";
        case H:
          return "SuspenseList";
      }
      if (typeof T == "object")
        switch (typeof T.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), T.$$typeof) {
          case D:
            return (T.displayName || "Context") + ".Provider";
          case C:
            return (T._context.displayName || "Context") + ".Consumer";
          case P:
            var fe = T.render;
            return T = T.displayName, T || (T = fe.displayName || fe.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
          case $:
            return fe = T.displayName || null, fe !== null ? fe : e(T.type) || "Memo";
          case ae:
            fe = T._payload, T = T._init;
            try {
              return e(T(fe));
            } catch {
            }
        }
      return null;
    }
    function t(T) {
      return "" + T;
    }
    function n(T) {
      try {
        t(T);
        var fe = !1;
      } catch {
        fe = !0;
      }
      if (fe) {
        fe = console;
        var xe = fe.error, Fe = typeof Symbol == "function" && Symbol.toStringTag && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return xe.call(
          fe,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Fe
        ), t(T);
      }
    }
    function r() {
    }
    function i() {
      if (G === 0) {
        K = console.log, A = console.info, ee = console.warn, te = console.error, ne = console.group, ve = console.groupCollapsed, _e = console.groupEnd;
        var T = {
          configurable: !0,
          enumerable: !0,
          value: r,
          writable: !0
        };
        Object.defineProperties(console, {
          info: T,
          log: T,
          warn: T,
          error: T,
          group: T,
          groupCollapsed: T,
          groupEnd: T
        });
      }
      G++;
    }
    function a() {
      if (G--, G === 0) {
        var T = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: re({}, T, { value: K }),
          info: re({}, T, { value: A }),
          warn: re({}, T, { value: ee }),
          error: re({}, T, { value: te }),
          group: re({}, T, { value: ne }),
          groupCollapsed: re({}, T, { value: ve }),
          groupEnd: re({}, T, { value: _e })
        });
      }
      0 > G && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function o(T) {
      if (pe === void 0)
        try {
          throw Error();
        } catch (xe) {
          var fe = xe.stack.trim().match(/\n( *(at )?)/);
          pe = fe && fe[1] || "", je = -1 < xe.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < xe.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + pe + T + je;
    }
    function s(T, fe) {
      if (!T || Se) return "";
      var xe = be.get(T);
      if (xe !== void 0) return xe;
      Se = !0, xe = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var Fe = null;
      Fe = se.H, se.H = null, i();
      try {
        var Ge = {
          DetermineComponentFrameRoot: function() {
            try {
              if (fe) {
                var dt = function() {
                  throw Error();
                };
                if (Object.defineProperty(dt.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(dt, []);
                  } catch (Le) {
                    var Ut = Le;
                  }
                  Reflect.construct(T, [], dt);
                } else {
                  try {
                    dt.call();
                  } catch (Le) {
                    Ut = Le;
                  }
                  T.call(dt.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Le) {
                  Ut = Le;
                }
                (dt = T()) && typeof dt.catch == "function" && dt.catch(function() {
                });
              }
            } catch (Le) {
              if (Le && Ut && typeof Le.stack == "string")
                return [Le.stack, Ut.stack];
            }
            return [null, null];
          }
        };
        Ge.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var Me = Object.getOwnPropertyDescriptor(
          Ge.DetermineComponentFrameRoot,
          "name"
        );
        Me && Me.configurable && Object.defineProperty(
          Ge.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var Ie = Ge.DetermineComponentFrameRoot(), ct = Ie[0], at = Ie[1];
        if (ct && at) {
          var Je = ct.split(`
`), $e = at.split(`
`);
          for (Ie = Me = 0; Me < Je.length && !Je[Me].includes(
            "DetermineComponentFrameRoot"
          ); )
            Me++;
          for (; Ie < $e.length && !$e[Ie].includes(
            "DetermineComponentFrameRoot"
          ); )
            Ie++;
          if (Me === Je.length || Ie === $e.length)
            for (Me = Je.length - 1, Ie = $e.length - 1; 1 <= Me && 0 <= Ie && Je[Me] !== $e[Ie]; )
              Ie--;
          for (; 1 <= Me && 0 <= Ie; Me--, Ie--)
            if (Je[Me] !== $e[Ie]) {
              if (Me !== 1 || Ie !== 1)
                do
                  if (Me--, Ie--, 0 > Ie || Je[Me] !== $e[Ie]) {
                    var _t = `
` + Je[Me].replace(
                      " at new ",
                      " at "
                    );
                    return T.displayName && _t.includes("<anonymous>") && (_t = _t.replace("<anonymous>", T.displayName)), typeof T == "function" && be.set(T, _t), _t;
                  }
                while (1 <= Me && 0 <= Ie);
              break;
            }
        }
      } finally {
        Se = !1, se.H = Fe, a(), Error.prepareStackTrace = xe;
      }
      return Je = (Je = T ? T.displayName || T.name : "") ? o(Je) : "", typeof T == "function" && be.set(T, Je), Je;
    }
    function l(T) {
      if (T == null) return "";
      if (typeof T == "function") {
        var fe = T.prototype;
        return s(
          T,
          !(!fe || !fe.isReactComponent)
        );
      }
      if (typeof T == "string") return o(T);
      switch (T) {
        case L:
          return o("Suspense");
        case H:
          return o("SuspenseList");
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case P:
            return T = s(T.render, !1), T;
          case $:
            return l(T.type);
          case ae:
            fe = T._payload, T = T._init;
            try {
              return l(T(fe));
            } catch {
            }
        }
      return "";
    }
    function c() {
      var T = se.A;
      return T === null ? null : T.getOwner();
    }
    function d(T) {
      if (J.call(T, "key")) {
        var fe = Object.getOwnPropertyDescriptor(T, "key").get;
        if (fe && fe.isReactWarning) return !1;
      }
      return T.key !== void 0;
    }
    function p(T, fe) {
      function xe() {
        Ye || (Ye = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          fe
        ));
      }
      xe.isReactWarning = !0, Object.defineProperty(T, "key", {
        get: xe,
        configurable: !0
      });
    }
    function y() {
      var T = e(this.type);
      return Re[T] || (Re[T] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), T = this.props.ref, T !== void 0 ? T : null;
    }
    function f(T, fe, xe, Fe, Ge, Me) {
      return xe = Me.ref, T = {
        $$typeof: M,
        type: T,
        key: fe,
        props: Me,
        _owner: Ge
      }, (xe !== void 0 ? xe : null) !== null ? Object.defineProperty(T, "ref", {
        enumerable: !1,
        get: y
      }) : Object.defineProperty(T, "ref", { enumerable: !1, value: null }), T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(T, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    }
    function N(T, fe, xe, Fe, Ge, Me) {
      if (typeof T == "string" || typeof T == "function" || T === q || T === x || T === j || T === L || T === H || T === ce || typeof T == "object" && T !== null && (T.$$typeof === ae || T.$$typeof === $ || T.$$typeof === D || T.$$typeof === C || T.$$typeof === P || T.$$typeof === I || T.getModuleId !== void 0)) {
        var Ie = fe.children;
        if (Ie !== void 0)
          if (Fe)
            if (U(Ie)) {
              for (Fe = 0; Fe < Ie.length; Fe++)
                b(Ie[Fe], T);
              Object.freeze && Object.freeze(Ie);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else b(Ie, T);
      } else
        Ie = "", (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), T === null ? Fe = "null" : U(T) ? Fe = "array" : T !== void 0 && T.$$typeof === M ? (Fe = "<" + (e(T.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof T, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          Fe,
          Ie
        );
      if (J.call(fe, "key")) {
        Ie = e(T);
        var ct = Object.keys(fe).filter(function(Je) {
          return Je !== "key";
        });
        Fe = 0 < ct.length ? "{key: someKey, " + ct.join(": ..., ") + ": ...}" : "{key: someKey}", Te[Ie + Fe] || (ct = 0 < ct.length ? "{" + ct.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Fe,
          Ie,
          ct,
          Ie
        ), Te[Ie + Fe] = !0);
      }
      if (Ie = null, xe !== void 0 && (n(xe), Ie = "" + xe), d(fe) && (n(fe.key), Ie = "" + fe.key), "key" in fe) {
        xe = {};
        for (var at in fe)
          at !== "key" && (xe[at] = fe[at]);
      } else xe = fe;
      return Ie && p(
        xe,
        typeof T == "function" ? T.displayName || T.name || "Unknown" : T
      ), f(T, Ie, Me, Ge, c(), xe);
    }
    function b(T, fe) {
      if (typeof T == "object" && T && T.$$typeof !== X) {
        if (U(T))
          for (var xe = 0; xe < T.length; xe++) {
            var Fe = T[xe];
            S(Fe) && _(Fe, fe);
          }
        else if (S(T))
          T._store && (T._store.validated = 1);
        else if (T === null || typeof T != "object" ? xe = null : (xe = le && T[le] || T["@@iterator"], xe = typeof xe == "function" ? xe : null), typeof xe == "function" && xe !== T.entries && (xe = xe.call(T), xe !== T))
          for (; !(T = xe.next()).done; )
            S(T.value) && _(T.value, fe);
      }
    }
    function S(T) {
      return typeof T == "object" && T !== null && T.$$typeof === M;
    }
    function _(T, fe) {
      if (T._store && !T._store.validated && T.key == null && (T._store.validated = 1, fe = E(fe), !Ue[fe])) {
        Ue[fe] = !0;
        var xe = "";
        T && T._owner != null && T._owner !== c() && (xe = null, typeof T._owner.tag == "number" ? xe = e(T._owner.type) : typeof T._owner.name == "string" && (xe = T._owner.name), xe = " It was passed a child from " + xe + ".");
        var Fe = se.getCurrentStack;
        se.getCurrentStack = function() {
          var Ge = l(T.type);
          return Fe && (Ge += Fe() || ""), Ge;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          fe,
          xe
        ), se.getCurrentStack = Fe;
      }
    }
    function E(T) {
      var fe = "", xe = c();
      return xe && (xe = e(xe.type)) && (fe = `

Check the render method of \`` + xe + "`."), fe || (T = e(T)) && (fe = `

Check the top-level render call using <` + T + ">."), fe;
    }
    var k = gt, M = Symbol.for("react.transitional.element"), F = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), j = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), D = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), H = Symbol.for("react.suspense_list"), $ = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), ce = Symbol.for("react.offscreen"), le = Symbol.iterator, oe = Symbol.for("react.client.reference"), se = k.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J = Object.prototype.hasOwnProperty, re = Object.assign, I = Symbol.for("react.client.reference"), U = Array.isArray, G = 0, K, A, ee, te, ne, ve, _e;
    r.__reactDisabledLog = !0;
    var pe, je, Se = !1, be = new (typeof WeakMap == "function" ? WeakMap : Map)(), X = Symbol.for("react.client.reference"), Ye, Re = {}, Te = {}, Ue = {};
    hc.Fragment = q, hc.jsx = function(T, fe, xe, Fe, Ge) {
      return N(T, fe, xe, !1, Fe, Ge);
    }, hc.jsxs = function(T, fe, xe, Fe, Ge) {
      return N(T, fe, xe, !0, Fe, Ge);
    };
  }()), hc;
}
var s2;
function S_() {
  return s2 || (s2 = 1, process.env.NODE_ENV === "production" ? Td.exports = __() : Td.exports = N_()), Td.exports;
}
var me = S_(), Fd = { exports: {} }, oh = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l2;
function E_() {
  if (l2) return oh;
  l2 = 1;
  var e = gt;
  function t(l, c) {
    return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, o = e.useMemo, s = e.useDebugValue;
  return oh.useSyncExternalStoreWithSelector = function(l, c, d, p, y) {
    var f = i(null);
    if (f.current === null) {
      var N = { hasValue: !1, value: null };
      f.current = N;
    } else N = f.current;
    f = o(
      function() {
        function S(F) {
          if (!_) {
            if (_ = !0, E = F, F = p(F), y !== void 0 && N.hasValue) {
              var q = N.value;
              if (y(q, F))
                return k = q;
            }
            return k = F;
          }
          if (q = k, n(E, F)) return q;
          var j = p(F);
          return y !== void 0 && y(q, j) ? (E = F, q) : (E = F, k = j);
        }
        var _ = !1, E, k, M = d === void 0 ? null : d;
        return [
          function() {
            return S(c());
          },
          M === null ? void 0 : function() {
            return S(M());
          }
        ];
      },
      [c, d, p, y]
    );
    var b = r(l, f[0], f[1]);
    return a(
      function() {
        N.hasValue = !0, N.value = b;
      },
      [b]
    ), s(b), b;
  }, oh;
}
var sh = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c2;
function C_() {
  return c2 || (c2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, c) {
      return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = gt, n = typeof Object.is == "function" ? Object.is : e, r = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, o = t.useMemo, s = t.useDebugValue;
    sh.useSyncExternalStoreWithSelector = function(l, c, d, p, y) {
      var f = i(null);
      if (f.current === null) {
        var N = { hasValue: !1, value: null };
        f.current = N;
      } else N = f.current;
      f = o(
        function() {
          function S(F) {
            if (!_) {
              if (_ = !0, E = F, F = p(F), y !== void 0 && N.hasValue) {
                var q = N.value;
                if (y(q, F))
                  return k = q;
              }
              return k = F;
            }
            if (q = k, n(E, F))
              return q;
            var j = p(F);
            return y !== void 0 && y(q, j) ? (E = F, q) : (E = F, k = j);
          }
          var _ = !1, E, k, M = d === void 0 ? null : d;
          return [
            function() {
              return S(c());
            },
            M === null ? void 0 : function() {
              return S(M());
            }
          ];
        },
        [c, d, p, y]
      );
      var b = r(l, f[0], f[1]);
      return a(
        function() {
          N.hasValue = !0, N.value = b;
        },
        [b]
      ), s(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), sh;
}
var u2;
function O_() {
  return u2 || (u2 = 1, process.env.NODE_ENV === "production" ? Fd.exports = E_() : Fd.exports = C_()), Fd.exports;
}
O_();
var ev = /* @__PURE__ */ R.version.startsWith("19"), j_ = /* @__PURE__ */ Symbol.for(
  ev ? "react.transitional.element" : "react.element"
), P_ = /* @__PURE__ */ Symbol.for("react.portal"), tv = /* @__PURE__ */ Symbol.for("react.fragment"), nv = /* @__PURE__ */ Symbol.for("react.strict_mode"), rv = /* @__PURE__ */ Symbol.for("react.profiler"), lg = /* @__PURE__ */ Symbol.for("react.consumer"), cg = /* @__PURE__ */ Symbol.for("react.context"), ug = /* @__PURE__ */ Symbol.for("react.forward_ref"), iv = /* @__PURE__ */ Symbol.for("react.suspense"), av = /* @__PURE__ */ Symbol.for(
  "react.suspense_list"
), Rf = /* @__PURE__ */ Symbol.for("react.memo"), ov = /* @__PURE__ */ Symbol.for("react.lazy"), L_ = /* @__PURE__ */ Symbol.for("react.offscreen"), T_ = /* @__PURE__ */ Symbol.for(
  "react.client.reference"
), F_ = ug, I_ = Rf;
function k_(e) {
  return typeof e == "string" || typeof e == "function" || e === tv || e === rv || e === nv || e === iv || e === av || e === L_ || typeof e == "object" && e !== null && (e.$$typeof === ov || e.$$typeof === Rf || e.$$typeof === cg || e.$$typeof === lg || e.$$typeof === ug || e.$$typeof === T_ || e.getModuleId !== void 0);
}
function em(e) {
  if (typeof e == "object" && e !== null) {
    const { $$typeof: t } = e;
    switch (t) {
      case j_:
        switch (e = e.type, e) {
          case tv:
          case rv:
          case nv:
          case iv:
          case av:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case cg:
              case ug:
              case ov:
              case Rf:
                return e;
              case lg:
                return e;
              default:
                return t;
            }
        }
      case P_:
        return t;
    }
  }
}
function D_(e) {
  return ev ? em(e) === lg : em(e) === cg;
}
function R_(e) {
  return em(e) === Rf;
}
function dg(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function lh(e, t) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || dg(
      `The selector for ${t} of connect did not specify a value for dependsOnOwnProps.`
    ));
  else throw new Error(`Unexpected value for ${t} in connect.`);
}
function M_(e, t, n) {
  lh(e, "mapStateToProps"), lh(t, "mapDispatchToProps"), lh(n, "mergeProps");
}
function U_(e, t, n, r, {
  areStatesEqual: i,
  areOwnPropsEqual: a,
  areStatePropsEqual: o
}) {
  let s = !1, l, c, d, p, y;
  function f(E, k) {
    return l = E, c = k, d = e(l, c), p = t(r, c), y = n(d, p, c), s = !0, y;
  }
  function N() {
    return d = e(l, c), t.dependsOnOwnProps && (p = t(r, c)), y = n(d, p, c), y;
  }
  function b() {
    return e.dependsOnOwnProps && (d = e(l, c)), t.dependsOnOwnProps && (p = t(r, c)), y = n(d, p, c), y;
  }
  function S() {
    const E = e(l, c), k = !o(E, d);
    return d = E, k && (y = n(d, p, c)), y;
  }
  function _(E, k) {
    const M = !a(k, c), F = !i(
      E,
      l,
      k,
      c
    );
    return l = E, c = k, M && F ? N() : M ? b() : F ? S() : y;
  }
  return function(k, M) {
    return s ? _(k, M) : f(k, M);
  };
}
function B_(e, {
  initMapStateToProps: t,
  initMapDispatchToProps: n,
  initMergeProps: r,
  ...i
}) {
  const a = t(e, i), o = n(e, i), s = r(e, i);
  return process.env.NODE_ENV !== "production" && M_(a, o, s), U_(a, o, s, e, i);
}
function z_(e, t) {
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = (...a) => t(i(...a)));
  }
  return n;
}
function q_(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null) return !0;
  let n = t;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function V_(e, t, n) {
  q_(e) || dg(
    `${n}() in ${t} must return a plain object. Instead received ${e}.`
  );
}
function tm(e) {
  return function(n) {
    const r = e(n);
    function i() {
      return r;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function d2(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function sv(e, t) {
  return function(r, { displayName: i }) {
    const a = function(s, l) {
      return a.dependsOnOwnProps ? a.mapToProps(s, l) : a.mapToProps(s, void 0);
    };
    return a.dependsOnOwnProps = !0, a.mapToProps = function(s, l) {
      a.mapToProps = e, a.dependsOnOwnProps = d2(e);
      let c = a(s, l);
      return typeof c == "function" && (a.mapToProps = c, a.dependsOnOwnProps = d2(c), c = a(s, l)), process.env.NODE_ENV !== "production" && V_(c, i, t), c;
    }, a;
  };
}
function lv(e, t) {
  return (n, r) => {
    throw new Error(
      `Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`
    );
  };
}
function W_(e) {
  return e && typeof e == "object" ? tm(
    (t) => (
      // @ts-ignore
      z_(e, t)
    )
  ) : e ? typeof e == "function" ? (
    // @ts-ignore
    sv(e, "mapDispatchToProps")
  ) : lv(e, "mapDispatchToProps") : tm((t) => ({
    dispatch: t
  }));
}
function H_(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    sv(e, "mapStateToProps")
  ) : lv(e, "mapStateToProps") : tm(() => ({}));
}
function $_(e, t, n) {
  return { ...n, ...e, ...t };
}
function G_(e) {
  return () => $_;
}
function Q_(e) {
  e();
}
function Y_() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      Q_(() => {
        let n = e;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      const n = [];
      let r = e;
      for (; r; )
        n.push(r), r = r.next;
      return n;
    },
    subscribe(n) {
      let r = !0;
      const i = t = {
        callback: n,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !r || e === null || (r = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var f2 = {
  notify() {
  },
  get: () => []
};
function K_(e, t) {
  let n, r = f2, i = 0, a = !1;
  function o(b) {
    d();
    const S = r.subscribe(b);
    let _ = !1;
    return () => {
      _ || (_ = !0, S(), p());
    };
  }
  function s() {
    r.notify();
  }
  function l() {
    N.onStateChange && N.onStateChange();
  }
  function c() {
    return a;
  }
  function d() {
    i++, n || (n = t ? t.addNestedSub(l) : e.subscribe(l), r = Y_());
  }
  function p() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = f2);
  }
  function y() {
    a || (a = !0, d());
  }
  function f() {
    a && (a = !1, p());
  }
  const N = {
    addNestedSub: o,
    notifyNestedSubs: s,
    handleChangeWrapper: l,
    isSubscribed: c,
    trySubscribe: y,
    tryUnsubscribe: f,
    getListeners: () => r
  };
  return N;
}
var X_ = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Z_ = /* @__PURE__ */ X_(), J_ = () => typeof navigator < "u" && navigator.product === "ReactNative", A_ = /* @__PURE__ */ J_(), eN = () => Z_ || A_ ? R.useLayoutEffect : R.useEffect, nm = /* @__PURE__ */ eN();
function p2(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function ch(e, t) {
  if (p2(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let i = 0; i < n.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, n[i]) || !p2(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
var tN = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, nN = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, rN = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, cv = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, iN = {
  [F_]: rN,
  [I_]: cv
};
function h2(e) {
  return R_(e) ? cv : iN[e.$$typeof] || tN;
}
var aN = Object.defineProperty, oN = Object.getOwnPropertyNames, m2 = Object.getOwnPropertySymbols, sN = Object.getOwnPropertyDescriptor, lN = Object.getPrototypeOf, g2 = Object.prototype;
function rm(e, t) {
  if (typeof t != "string") {
    if (g2) {
      const a = lN(t);
      a && a !== g2 && rm(e, a);
    }
    let n = oN(t);
    m2 && (n = n.concat(m2(t)));
    const r = h2(e), i = h2(t);
    for (let a = 0; a < n.length; ++a) {
      const o = n[a];
      if (!nN[o] && !(i && i[o]) && !(r && r[o])) {
        const s = sN(t, o);
        try {
          aN(e, o, s);
        } catch {
        }
      }
    }
  }
  return e;
}
var uh = /* @__PURE__ */ Symbol.for("react-redux-context"), dh = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function cN() {
  if (!R.createContext) return {};
  const e = dh[uh] ?? (dh[uh] = /* @__PURE__ */ new Map());
  let t = e.get(R.createContext);
  return t || (t = R.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(R.createContext, t)), t;
}
var uN = /* @__PURE__ */ cN(), dN = [null, null], fN = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
};
function pN(e, t, n) {
  nm(() => e(...t), n);
}
function hN(e, t, n, r, i, a) {
  e.current = r, n.current = !1, i.current && (i.current = null, a());
}
function mN(e, t, n, r, i, a, o, s, l, c, d) {
  if (!e) return () => {
  };
  let p = !1, y = null;
  const f = () => {
    if (p || !s.current)
      return;
    const b = t.getState();
    let S, _;
    try {
      S = r(
        b,
        i.current
      );
    } catch (E) {
      _ = E, y = E;
    }
    _ || (y = null), S === a.current ? o.current || c() : (a.current = S, l.current = S, o.current = !0, d());
  };
  return n.onStateChange = f, n.trySubscribe(), f(), () => {
    if (p = !0, n.tryUnsubscribe(), n.onStateChange = null, y)
      throw y;
  };
}
function gN(e, t) {
  return e === t;
}
var y2 = !1;
function yN(e, t, n, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: i = gN,
  areOwnPropsEqual: a = ch,
  areStatePropsEqual: o = ch,
  areMergedPropsEqual: s = ch,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: l = !1,
  // the context consumer to use
  context: c = uN
} = {}) {
  process.env.NODE_ENV !== "production" && r !== void 0 && !y2 && (y2 = !0, dg(
    'The `pure` option has been removed. `connect` is now always a "pure/memoized" component'
  ));
  const d = c, p = H_(e), y = W_(t), f = G_(), N = !!e;
  return (S) => {
    if (process.env.NODE_ENV !== "production" && !/* @__PURE__ */ k_(S))
      throw new Error(
        `You must pass a component to the function returned by connect. Instead received ${fN(
          S
        )}`
      );
    const _ = S.displayName || S.name || "Component", E = `Connect(${_})`, k = {
      shouldHandleStateChanges: N,
      displayName: E,
      wrappedComponentName: _,
      WrappedComponent: S,
      // @ts-ignore
      initMapStateToProps: p,
      initMapDispatchToProps: y,
      initMergeProps: f,
      areStatesEqual: i,
      areStatePropsEqual: o,
      areOwnPropsEqual: a,
      areMergedPropsEqual: s
    };
    function M(j) {
      const [x, C, D] = R.useMemo(() => {
        const { reactReduxForwardedRef: pe, ...je } = j;
        return [j.context, pe, je];
      }, [j]), P = R.useMemo(() => {
        let pe = d;
        if (x != null && x.Consumer && process.env.NODE_ENV !== "production") {
          if (!/* @__PURE__ */ D_(
            // @ts-ignore
            /* @__PURE__ */ R.createElement(x.Consumer, null)
          ))
            throw new Error(
              "You must pass a valid React context consumer as `props.context`"
            );
          pe = x;
        }
        return pe;
      }, [x, d]), L = R.useContext(P), H = !!j.store && !!j.store.getState && !!j.store.dispatch, $ = !!L && !!L.store;
      if (process.env.NODE_ENV !== "production" && !H && !$)
        throw new Error(
          `Could not find "store" in the context of "${E}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${E} in connect options.`
        );
      const ae = H ? j.store : L.store, ce = $ ? L.getServerState : ae.getState, le = R.useMemo(() => B_(ae.dispatch, k), [ae]), [oe, se] = R.useMemo(() => {
        if (!N) return dN;
        const pe = K_(
          ae,
          H ? void 0 : L.subscription
        ), je = pe.notifyNestedSubs.bind(pe);
        return [pe, je];
      }, [ae, H, L]), J = R.useMemo(() => H ? L : {
        ...L,
        subscription: oe
      }, [H, L, oe]), re = R.useRef(void 0), I = R.useRef(D), U = R.useRef(void 0), G = R.useRef(!1), K = R.useRef(!1), A = R.useRef(
        void 0
      );
      nm(() => (K.current = !0, () => {
        K.current = !1;
      }), []);
      const ee = R.useMemo(() => () => U.current && D === I.current ? U.current : le(ae.getState(), D), [ae, D]), te = R.useMemo(() => (je) => oe ? mN(
        N,
        ae,
        oe,
        // @ts-ignore
        le,
        I,
        re,
        G,
        K,
        U,
        se,
        je
      ) : () => {
      }, [oe]);
      pN(hN, [
        I,
        re,
        G,
        D,
        U,
        se
      ]);
      let ne;
      try {
        ne = R.useSyncExternalStore(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          te,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          ee,
          ce ? () => le(ce(), D) : ee
        );
      } catch (pe) {
        throw A.current && (pe.message += `
The error may be correlated with this previous error:
${A.current.stack}

`), pe;
      }
      nm(() => {
        A.current = void 0, U.current = void 0, re.current = ne;
      });
      const ve = R.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ R.createElement(
          S,
          {
            ...ne,
            ref: C
          }
        )
      ), [C, S, ne]);
      return R.useMemo(() => N ? /* @__PURE__ */ R.createElement(P.Provider, { value: J }, ve) : ve, [P, ve, J]);
    }
    const q = R.memo(M);
    if (q.WrappedComponent = S, q.displayName = M.displayName = E, l) {
      const x = R.forwardRef(
        function(D, P) {
          return /* @__PURE__ */ R.createElement(q, { ...D, reactReduxForwardedRef: P });
        }
      );
      return x.displayName = E, x.WrappedComponent = S, /* @__PURE__ */ rm(x, S);
    }
    return /* @__PURE__ */ rm(q, S);
  };
}
var vN = yN;
function yf(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var fh = () => Math.random().toString(36).substring(7).split("").join("."), bN = {
  INIT: `@@redux/INIT${/* @__PURE__ */ fh()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ fh()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${fh()}`
}, Fc = bN;
function wN(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function xN(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (SN(e))
    return "date";
  if (NN(e))
    return "error";
  const n = _N(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function _N(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function NN(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function SN(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function uv(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = xN(e)), t;
}
function v2(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function EN(e, t, n, r) {
  const i = Object.keys(t), a = n && n.type === Fc.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!wN(e))
    return `The ${a} has unexpected type of "${uv(e)}". Expected argument to be an object with the following keys: "${i.join('", "')}"`;
  const o = Object.keys(e).filter((s) => !t.hasOwnProperty(s) && !r[s]);
  if (o.forEach((s) => {
    r[s] = !0;
  }), !(n && n.type === Fc.REPLACE) && o.length > 0)
    return `Unexpected ${o.length > 1 ? "keys" : "key"} "${o.join('", "')}" found in ${a}. Expected to find one of the known reducer keys instead: "${i.join('", "')}". Unexpected keys will be ignored.`;
}
function CN(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: Fc.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? yf(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Fc.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? yf(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${Fc.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function ON(e) {
  const t = Object.keys(e), n = {};
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    process.env.NODE_ENV !== "production" && typeof e[s] > "u" && v2(`No reducer provided for key "${s}"`), typeof e[s] == "function" && (n[s] = e[s]);
  }
  const r = Object.keys(n);
  let i;
  process.env.NODE_ENV !== "production" && (i = {});
  let a;
  try {
    CN(n);
  } catch (o) {
    a = o;
  }
  return function(s = {}, l) {
    if (a)
      throw a;
    if (process.env.NODE_ENV !== "production") {
      const p = EN(s, n, l, i);
      p && v2(p);
    }
    let c = !1;
    const d = {};
    for (let p = 0; p < r.length; p++) {
      const y = r[p], f = n[y], N = s[y], b = f(N, l);
      if (typeof b > "u") {
        const S = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? yf(14) : `When called with an action of type ${S ? `"${String(S)}"` : "(unknown type)"}, the slice reducer for key "${y}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      d[y] = b, c = c || b !== N;
    }
    return c = c || r.length !== Object.keys(s).length, c ? d : s;
  };
}
function b2(e, t) {
  return function(...n) {
    return t(e.apply(this, n));
  };
}
function jN(e, t) {
  if (typeof e == "function")
    return b2(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? yf(16) : `bindActionCreators expected an object or a function, but instead received: '${uv(e)}'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = b2(i, t));
  }
  return n;
}
var PN = Object.defineProperty, LN = (e, t, n) => t in e ? PN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, et = (e, t, n) => LN(e, typeof t != "symbol" ? t + "" : t, n), xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ha(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var im = { exports: {} }, ph = { exports: {} }, tn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w2;
function TN() {
  if (w2) return tn;
  w2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function k(F) {
    if (typeof F == "object" && F !== null) {
      var q = F.$$typeof;
      switch (q) {
        case t:
          switch (F = F.type, F) {
            case l:
            case c:
            case r:
            case a:
            case i:
            case p:
              return F;
            default:
              switch (F = F && F.$$typeof, F) {
                case s:
                case d:
                case N:
                case f:
                case o:
                  return F;
                default:
                  return q;
              }
          }
        case n:
          return q;
      }
    }
  }
  function M(F) {
    return k(F) === c;
  }
  return tn.AsyncMode = l, tn.ConcurrentMode = c, tn.ContextConsumer = s, tn.ContextProvider = o, tn.Element = t, tn.ForwardRef = d, tn.Fragment = r, tn.Lazy = N, tn.Memo = f, tn.Portal = n, tn.Profiler = a, tn.StrictMode = i, tn.Suspense = p, tn.isAsyncMode = function(F) {
    return M(F) || k(F) === l;
  }, tn.isConcurrentMode = M, tn.isContextConsumer = function(F) {
    return k(F) === s;
  }, tn.isContextProvider = function(F) {
    return k(F) === o;
  }, tn.isElement = function(F) {
    return typeof F == "object" && F !== null && F.$$typeof === t;
  }, tn.isForwardRef = function(F) {
    return k(F) === d;
  }, tn.isFragment = function(F) {
    return k(F) === r;
  }, tn.isLazy = function(F) {
    return k(F) === N;
  }, tn.isMemo = function(F) {
    return k(F) === f;
  }, tn.isPortal = function(F) {
    return k(F) === n;
  }, tn.isProfiler = function(F) {
    return k(F) === a;
  }, tn.isStrictMode = function(F) {
    return k(F) === i;
  }, tn.isSuspense = function(F) {
    return k(F) === p;
  }, tn.isValidElementType = function(F) {
    return typeof F == "string" || typeof F == "function" || F === r || F === c || F === a || F === i || F === p || F === y || typeof F == "object" && F !== null && (F.$$typeof === N || F.$$typeof === f || F.$$typeof === o || F.$$typeof === s || F.$$typeof === d || F.$$typeof === S || F.$$typeof === _ || F.$$typeof === E || F.$$typeof === b);
  }, tn.typeOf = k, tn;
}
var sn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x2;
function FN() {
  return x2 || (x2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function k(pe) {
      return typeof pe == "string" || typeof pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      pe === r || pe === c || pe === a || pe === i || pe === p || pe === y || typeof pe == "object" && pe !== null && (pe.$$typeof === N || pe.$$typeof === f || pe.$$typeof === o || pe.$$typeof === s || pe.$$typeof === d || pe.$$typeof === S || pe.$$typeof === _ || pe.$$typeof === E || pe.$$typeof === b);
    }
    function M(pe) {
      if (typeof pe == "object" && pe !== null) {
        var je = pe.$$typeof;
        switch (je) {
          case t:
            var Se = pe.type;
            switch (Se) {
              case l:
              case c:
              case r:
              case a:
              case i:
              case p:
                return Se;
              default:
                var be = Se && Se.$$typeof;
                switch (be) {
                  case s:
                  case d:
                  case N:
                  case f:
                  case o:
                    return be;
                  default:
                    return je;
                }
            }
          case n:
            return je;
        }
      }
    }
    var F = l, q = c, j = s, x = o, C = t, D = d, P = r, L = N, H = f, $ = n, ae = a, ce = i, le = p, oe = !1;
    function se(pe) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(pe) || M(pe) === l;
    }
    function J(pe) {
      return M(pe) === c;
    }
    function re(pe) {
      return M(pe) === s;
    }
    function I(pe) {
      return M(pe) === o;
    }
    function U(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === t;
    }
    function G(pe) {
      return M(pe) === d;
    }
    function K(pe) {
      return M(pe) === r;
    }
    function A(pe) {
      return M(pe) === N;
    }
    function ee(pe) {
      return M(pe) === f;
    }
    function te(pe) {
      return M(pe) === n;
    }
    function ne(pe) {
      return M(pe) === a;
    }
    function ve(pe) {
      return M(pe) === i;
    }
    function _e(pe) {
      return M(pe) === p;
    }
    sn.AsyncMode = F, sn.ConcurrentMode = q, sn.ContextConsumer = j, sn.ContextProvider = x, sn.Element = C, sn.ForwardRef = D, sn.Fragment = P, sn.Lazy = L, sn.Memo = H, sn.Portal = $, sn.Profiler = ae, sn.StrictMode = ce, sn.Suspense = le, sn.isAsyncMode = se, sn.isConcurrentMode = J, sn.isContextConsumer = re, sn.isContextProvider = I, sn.isElement = U, sn.isForwardRef = G, sn.isFragment = K, sn.isLazy = A, sn.isMemo = ee, sn.isPortal = te, sn.isProfiler = ne, sn.isStrictMode = ve, sn.isSuspense = _e, sn.isValidElementType = k, sn.typeOf = M;
  }()), sn;
}
var _2;
function dv() {
  return _2 || (_2 = 1, process.env.NODE_ENV === "production" ? ph.exports = TN() : ph.exports = FN()), ph.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hh, N2;
function IN() {
  if (N2) return hh;
  N2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return hh = i() ? Object.assign : function(a, o) {
    for (var s, l = r(a), c, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var p in s)
        t.call(s, p) && (l[p] = s[p]);
      if (e) {
        c = e(s);
        for (var y = 0; y < c.length; y++)
          n.call(s, c[y]) && (l[c[y]] = s[c[y]]);
      }
    }
    return l;
  }, hh;
}
var mh, S2;
function fg() {
  if (S2) return mh;
  S2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return mh = e, mh;
}
var E2, C2;
function fv() {
  return C2 || (C2 = 1, E2 = Function.call.bind(Object.prototype.hasOwnProperty)), E2;
}
var gh, O2;
function kN() {
  if (O2) return gh;
  O2 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = fg(), n = {}, r = fv();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var p;
          try {
            if (typeof a[d] != "function") {
              var y = Error(
                (l || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            p = a[d](o, d, l, s, null, t);
          } catch (N) {
            p = N;
          }
          if (p && !(p instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var f = c ? c() : "";
            e(
              "Failed " + s + " type: " + p.message + (f ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, gh = i, gh;
}
var yh, j2;
function DN() {
  if (j2) return yh;
  j2 = 1;
  var e = dv(), t = IN(), n = fg(), r = fv(), i = kN(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return yh = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function p(J) {
      var re = J && (c && J[c] || J[d]);
      if (typeof re == "function")
        return re;
    }
    var y = "<<anonymous>>", f = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: E(),
      arrayOf: k,
      element: M(),
      elementType: F(),
      instanceOf: q,
      node: D(),
      objectOf: x,
      oneOf: j,
      oneOfType: C,
      shape: L,
      exact: H
    };
    function N(J, re) {
      return J === re ? J !== 0 || 1 / J === 1 / re : J !== J && re !== re;
    }
    function b(J, re) {
      this.message = J, this.data = re && typeof re == "object" ? re : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function S(J) {
      if (process.env.NODE_ENV !== "production")
        var re = {}, I = 0;
      function U(K, A, ee, te, ne, ve, _e) {
        if (te = te || y, ve = ve || ee, _e !== n) {
          if (l) {
            var pe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw pe.name = "Invariant Violation", pe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var je = te + ":" + ee;
            !re[je] && // Avoid spamming the console because they are often not actionable except for lib authors
            I < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ve + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), re[je] = !0, I++);
          }
        }
        return A[ee] == null ? K ? A[ee] === null ? new b("The " + ne + " `" + ve + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new b("The " + ne + " `" + ve + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : J(A, ee, te, ne, ve);
      }
      var G = U.bind(null, !1);
      return G.isRequired = U.bind(null, !0), G;
    }
    function _(J) {
      function re(I, U, G, K, A, ee) {
        var te = I[U], ne = ce(te);
        if (ne !== J) {
          var ve = le(te);
          return new b(
            "Invalid " + K + " `" + A + "` of type " + ("`" + ve + "` supplied to `" + G + "`, expected ") + ("`" + J + "`."),
            { expectedType: J }
          );
        }
        return null;
      }
      return S(re);
    }
    function E() {
      return S(o);
    }
    function k(J) {
      function re(I, U, G, K, A) {
        if (typeof J != "function")
          return new b("Property `" + A + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var ee = I[U];
        if (!Array.isArray(ee)) {
          var te = ce(ee);
          return new b("Invalid " + K + " `" + A + "` of type " + ("`" + te + "` supplied to `" + G + "`, expected an array."));
        }
        for (var ne = 0; ne < ee.length; ne++) {
          var ve = J(ee, ne, G, K, A + "[" + ne + "]", n);
          if (ve instanceof Error)
            return ve;
        }
        return null;
      }
      return S(re);
    }
    function M() {
      function J(re, I, U, G, K) {
        var A = re[I];
        if (!s(A)) {
          var ee = ce(A);
          return new b("Invalid " + G + " `" + K + "` of type " + ("`" + ee + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(J);
    }
    function F() {
      function J(re, I, U, G, K) {
        var A = re[I];
        if (!e.isValidElementType(A)) {
          var ee = ce(A);
          return new b("Invalid " + G + " `" + K + "` of type " + ("`" + ee + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(J);
    }
    function q(J) {
      function re(I, U, G, K, A) {
        if (!(I[U] instanceof J)) {
          var ee = J.name || y, te = se(I[U]);
          return new b("Invalid " + K + " `" + A + "` of type " + ("`" + te + "` supplied to `" + G + "`, expected ") + ("instance of `" + ee + "`."));
        }
        return null;
      }
      return S(re);
    }
    function j(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function re(I, U, G, K, A) {
        for (var ee = I[U], te = 0; te < J.length; te++)
          if (N(ee, J[te]))
            return null;
        var ne = JSON.stringify(J, function(ve, _e) {
          var pe = le(_e);
          return pe === "symbol" ? String(_e) : _e;
        });
        return new b("Invalid " + K + " `" + A + "` of value `" + String(ee) + "` " + ("supplied to `" + G + "`, expected one of " + ne + "."));
      }
      return S(re);
    }
    function x(J) {
      function re(I, U, G, K, A) {
        if (typeof J != "function")
          return new b("Property `" + A + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var ee = I[U], te = ce(ee);
        if (te !== "object")
          return new b("Invalid " + K + " `" + A + "` of type " + ("`" + te + "` supplied to `" + G + "`, expected an object."));
        for (var ne in ee)
          if (r(ee, ne)) {
            var ve = J(ee, ne, G, K, A + "." + ne, n);
            if (ve instanceof Error)
              return ve;
          }
        return null;
      }
      return S(re);
    }
    function C(J) {
      if (!Array.isArray(J))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var re = 0; re < J.length; re++) {
        var I = J[re];
        if (typeof I != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(I) + " at index " + re + "."
          ), o;
      }
      function U(G, K, A, ee, te) {
        for (var ne = [], ve = 0; ve < J.length; ve++) {
          var _e = J[ve], pe = _e(G, K, A, ee, te, n);
          if (pe == null)
            return null;
          pe.data && r(pe.data, "expectedType") && ne.push(pe.data.expectedType);
        }
        var je = ne.length > 0 ? ", expected one of type [" + ne.join(", ") + "]" : "";
        return new b("Invalid " + ee + " `" + te + "` supplied to " + ("`" + A + "`" + je + "."));
      }
      return S(U);
    }
    function D() {
      function J(re, I, U, G, K) {
        return $(re[I]) ? null : new b("Invalid " + G + " `" + K + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return S(J);
    }
    function P(J, re, I, U, G) {
      return new b(
        (J || "React class") + ": " + re + " type `" + I + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`."
      );
    }
    function L(J) {
      function re(I, U, G, K, A) {
        var ee = I[U], te = ce(ee);
        if (te !== "object")
          return new b("Invalid " + K + " `" + A + "` of type `" + te + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var ne in J) {
          var ve = J[ne];
          if (typeof ve != "function")
            return P(G, K, A, ne, le(ve));
          var _e = ve(ee, ne, G, K, A + "." + ne, n);
          if (_e)
            return _e;
        }
        return null;
      }
      return S(re);
    }
    function H(J) {
      function re(I, U, G, K, A) {
        var ee = I[U], te = ce(ee);
        if (te !== "object")
          return new b("Invalid " + K + " `" + A + "` of type `" + te + "` " + ("supplied to `" + G + "`, expected `object`."));
        var ne = t({}, I[U], J);
        for (var ve in ne) {
          var _e = J[ve];
          if (r(J, ve) && typeof _e != "function")
            return P(G, K, A, ve, le(_e));
          if (!_e)
            return new b(
              "Invalid " + K + " `" + A + "` key `" + ve + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(I[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(J), null, "  ")
            );
          var pe = _e(ee, ve, G, K, A + "." + ve, n);
          if (pe)
            return pe;
        }
        return null;
      }
      return S(re);
    }
    function $(J) {
      switch (typeof J) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !J;
        case "object":
          if (Array.isArray(J))
            return J.every($);
          if (J === null || s(J))
            return !0;
          var re = p(J);
          if (re) {
            var I = re.call(J), U;
            if (re !== J.entries) {
              for (; !(U = I.next()).done; )
                if (!$(U.value))
                  return !1;
            } else
              for (; !(U = I.next()).done; ) {
                var G = U.value;
                if (G && !$(G[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(J, re) {
      return J === "symbol" ? !0 : re ? re["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && re instanceof Symbol : !1;
    }
    function ce(J) {
      var re = typeof J;
      return Array.isArray(J) ? "array" : J instanceof RegExp ? "object" : ae(re, J) ? "symbol" : re;
    }
    function le(J) {
      if (typeof J > "u" || J === null)
        return "" + J;
      var re = ce(J);
      if (re === "object") {
        if (J instanceof Date)
          return "date";
        if (J instanceof RegExp)
          return "regexp";
      }
      return re;
    }
    function oe(J) {
      var re = le(J);
      switch (re) {
        case "array":
        case "object":
          return "an " + re;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + re;
        default:
          return re;
      }
    }
    function se(J) {
      return !J.constructor || !J.constructor.name ? y : J.constructor.name;
    }
    return f.checkPropTypes = i, f.resetWarningCache = i.resetWarningCache, f.PropTypes = f, f;
  }, yh;
}
var vh, P2;
function RN() {
  if (P2) return vh;
  P2 = 1;
  var e = fg();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, vh = function() {
    function r(o, s, l, c, d, p) {
      if (p !== e) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, vh;
}
if (process.env.NODE_ENV !== "production") {
  var MN = dv(), UN = !0;
  im.exports = DN()(MN.isElement, UN);
} else
  im.exports = RN()();
var pv = im.exports;
const g = /* @__PURE__ */ ha(pv);
function vf(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var bh = () => Math.random().toString(36).substring(7).split("").join("."), BN = {
  INIT: `@@redux/INIT${/* @__PURE__ */ bh()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ bh()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${bh()}`
}, Ic = BN;
function zN(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function qN(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (HN(e))
    return "date";
  if (WN(e))
    return "error";
  const n = VN(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function VN(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function WN(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function HN(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function hv(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = qN(e)), t;
}
function L2(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function $N(e, t, n, r) {
  const i = Object.keys(t), a = n && n.type === Ic.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!zN(e))
    return `The ${a} has unexpected type of "${hv(e)}". Expected argument to be an object with the following keys: "${i.join('", "')}"`;
  const o = Object.keys(e).filter((s) => !t.hasOwnProperty(s) && !r[s]);
  if (o.forEach((s) => {
    r[s] = !0;
  }), !(n && n.type === Ic.REPLACE) && o.length > 0)
    return `Unexpected ${o.length > 1 ? "keys" : "key"} "${o.join('", "')}" found in ${a}. Expected to find one of the known reducer keys instead: "${i.join('", "')}". Unexpected keys will be ignored.`;
}
function GN(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: Ic.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? vf(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Ic.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? vf(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${Ic.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function nu(e) {
  const t = Object.keys(e), n = {};
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    process.env.NODE_ENV !== "production" && typeof e[s] > "u" && L2(`No reducer provided for key "${s}"`), typeof e[s] == "function" && (n[s] = e[s]);
  }
  const r = Object.keys(n);
  let i;
  process.env.NODE_ENV !== "production" && (i = {});
  let a;
  try {
    GN(n);
  } catch (o) {
    a = o;
  }
  return function(o = {}, s) {
    if (a)
      throw a;
    if (process.env.NODE_ENV !== "production") {
      const d = $N(o, n, s, i);
      d && L2(d);
    }
    let l = !1;
    const c = {};
    for (let d = 0; d < r.length; d++) {
      const p = r[d], y = n[p], f = o[p], N = y(f, s);
      if (typeof N > "u") {
        const b = s && s.type;
        throw new Error(process.env.NODE_ENV === "production" ? vf(14) : `When called with an action of type ${b ? `"${String(b)}"` : "(unknown type)"}, the slice reducer for key "${p}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      c[p] = N, l = l || N !== f;
    }
    return l = l || r.length !== Object.keys(o).length, l ? c : o;
  };
}
function T2(e, t) {
  return function(...n) {
    return t(e.apply(this, n));
  };
}
function Kt(e, t) {
  if (typeof e == "function")
    return T2(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? vf(16) : `bindActionCreators expected an object or a function, but instead received: '${hv(e)}'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = T2(i, t));
  }
  return n;
}
const mv = "LOG_IN_PROCESS_REQUEST", gv = "LOG_IN_PROCESS_SUCCESS", yv = "LOG_IN_PROCESS_FAILURE", QN = "USER_DATA_RETRIEVAL_REQUEST", YN = "USER_DATA_RETRIEVAL_SUCCESS", KN = "USER_DATA_RETRIEVAL_FAILURE", vv = "LOG_IN_REQUEST", bv = "LOG_IN_SUCCESS", wv = "LOG_IN_FAILURE", xv = "LOG_OUT_REQUEST", ys = "LOG_OUT_SUCCESS", _v = "LOG_OUT_FAILURE", Nv = "FORGOT_PASSWORD_REQUEST", Sv = "FORGOT_PASSWORD_SUCCESS", Ev = "FORGOT_PASSWORD_FAILURE", XN = "DECODE_TOKEN_REQUEST", ZN = "DECODE_TOKEN_SUCCESS", Cv = "DECODE_TOKEN_FAILURE", Ov = "REFRESH_TOKEN_REQUEST", jv = "REFRESH_TOKEN_SUCCESS", pg = "REFRESH_TOKEN_FAILURE", Pv = "RESET_PASSWORD_REQUEST", Lv = "RESET_PASSWORD_SUCCESS", Tv = "RESET_PASSWORD_FAILURE", JN = "USER_REGISTER_REQUEST", Fv = "USER_REGISTER_SUCCESS", Iv = "USER_REGISTER_FAILURE", AN = "READ_USER_DETAILS_REQUEST", e6 = "READ_USER_DETAILS_SUCCESS", t6 = "READ_USER_DETAILS_FAILURE", n6 = "USER_VERIFY_REQUEST", r6 = "USER_VERIFY_SUCCESS", i6 = "USER_VERIFY_FAILURE", a6 = "SELF_REGISTER_REQUEST", o6 = "SELF_REGISTER_SUCCESS", s6 = "SELF_REGISTER_FAILURE", l6 = "SUBMIT_SELF_REGISTRATION_REQUEST", c6 = "SUBMIT_SELF_REGISTRATION_SUCCESS", u6 = "SUBMIT_SELF_REGISTRATION_FAILURE", hg = "CLEAR_LOGIN_FORM", kv = "USER_ORGANISATIONS_LOAD_REQUEST", Dv = "USER_ORGANISATIONS_LOAD_SUCCESS", Rv = "USER_ORGANISATIONS_LOAD_FAILURE", Mv = "NO_ACCESS_USER_ORGANISATIONS_LOAD_REQUEST", Uv = "NO_ACCESS_USER_ORGANISATIONS_LOAD_SUCCESS", Bv = "NO_ACCESS_USER_ORGANISATIONS_LOAD_FAILURE", mg = "USER_ORGANISATION_CHANGE", ro = {
  INTERNAL_ADMIN: "internalAdmin",
  BUSINESS_ADMIN: "businessAdmin",
  SUPPORT_ADMIN: "supportAdmin",
  ACCOUNT_MANAGER_ADMIN: "accountManagerAdmin",
  STANDARD_USER: "standardUser",
  NO_ACCESS: "noAccess"
}, Lc = {
  SUPER_ADMIN: 1,
  BUSINESS_ADMIN: 2,
  SUPPORT_ADMIN: 4,
  STANDARD: 3
}, d6 = "USER_PRODUCTS_LOAD_REQUEST", zv = "USER_PRODUCTS_LOAD_SUCCESS", f6 = "USER_PRODUCTS_LOAD_FAILURE", p6 = "USER_FEATURE_ACCESS_REQUEST", qv = "USER_FEATURE_ACCESS_SUCCESS", h6 = "USER_FEATURE_ACCESS_FAILURE", m6 = "USER_PRODUCT_SETTINGS_LOAD_REQUEST", Vv = "USER_PRODUCT_SETTINGS_LOAD_SUCCESS", g6 = "USER_PRODUCT_SETTINGS_LOAD_FAILURE", Wv = "USER_TEAMS_LOAD_REQUEST", Hv = "USER_TEAMS_LOAD_SUCCESS", $v = "USER_TEAMS_LOAD_FAILURE", Gv = "LOAD_NO_ACCESS_TEAMS_REQUEST", Qv = "LOAD_NO_ACCESS_TEAMS_SUCCESS", Yv = "LOAD_NO_ACCESS_TEAMS_FAILURE", Kv = "USER_TEAM_CHANGE", y6 = "USER_UPDATE_SUCCESS", ur = (e, t) => {
  const n = t ? v6(t) + "/" : "", r = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : "dev";
  return e === "v1" ? Xv(r) : `https://liveapi.${gg(r)}.com/${n}${e}`;
}, gg = (e) => {
  switch (e) {
    case "prod":
      return "roymorgan";
    case "uat":
      return "roymorganuat";
    case "local":
    case "dev":
    default:
      return "roymorgandev";
  }
}, Xv = (e) => `https://liveapi.${gg(e || "dev")}.com/v1`, kc = () => !!(process.env.REACT_APP_DATA_ENDPOINT === "nz-helix" || window.location.host.includes("nz")), v6 = (e) => e !== "helix" ? e : kc() ? "nz-helix" : "helix", yg = (e, t = "id") => e.reduce((n, r) => (n[r[t]] = r, n), {}), vg = (e, t = "id") => {
  const n = [];
  for (let r = 0; r < e.length; r++)
    n.push(e[r][t]);
  return n;
}, ru = (e, t = "id") => ({
  byId: yg(e, t),
  order: vg(e, t)
});
/*! js-cookie v3.0.5 | MIT */
function Id(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var b6 = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function am(e, t) {
  function n(i, a, o) {
    if (!(typeof document > "u")) {
      o = Id({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in o)
        o[l] && (s += "; " + l, o[l] !== !0 && (s += "=" + o[l].split(";")[0]));
      return document.cookie = i + "=" + e.write(a, i) + s;
    }
  }
  function r(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var a = document.cookie ? document.cookie.split("; ") : [], o = {}, s = 0; s < a.length; s++) {
        var l = a[s].split("="), c = l.slice(1).join("=");
        try {
          var d = decodeURIComponent(l[0]);
          if (o[d] = e.read(c, d), i === d)
            break;
        } catch {
        }
      }
      return i ? o[i] : o;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, a) {
        n(
          i,
          "",
          Id({}, a, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return am(this.converter, Id({}, this.attributes, i));
      },
      withConverter: function(i) {
        return am(Id({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var om = am(b6, { path: "/" });
const Yn = () => om.get("token"), w6 = () => parseInt(document.cookie.replace(
  // eslint-disable-next-line no-useless-escape
  /(?:(?:^|.*;\s*)currentOrganisationId\s*\=\s*([^;]*).*$)|^.*$/,
  "$1"
)), F2 = () => parseInt(document.cookie.replace(
  // eslint-disable-next-line no-useless-escape
  /(?:(?:^|.*;\s*)currentTeamId\s*\=\s*([^;]*).*$)|^.*$/,
  "$1"
)), sm = (e) => {
  switch (process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV) {
    case "dev":
      document.cookie = "currentOrganisationId=" + e + ";domain=.roymorgandev.com;path=/";
      break;
    case "uat":
      document.cookie = "currentOrganisationId=" + e + ";domain=.roymorganuat.com;path=/";
      break;
    case "production":
    case "prod":
      document.cookie = "currentOrganisationId=" + e + ";domain=.roymorgan.com;path=/";
      break;
    case "local":
    default:
      document.cookie = "currentOrganisationId=" + e + ";path=/";
      break;
  }
}, wh = (e) => {
  switch (process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV) {
    case "dev":
      document.cookie = "currentTeamId=" + e + ";domain=.roymorgandev.com;path=/";
      break;
    case "uat":
      document.cookie = "currentTeamId=" + e + ";domain=.roymorganuat.com;path=/";
      break;
    case "production":
    case "prod":
      document.cookie = "currentTeamId=" + e + ";domain=.roymorgan.com;path=/";
      break;
    case "local":
    default:
      document.cookie = "currentTeamId=" + e + ";path=/";
      break;
  }
};
function x6(e) {
  switch (e) {
    case "dev":
    case "uat":
    case "production":
    case "prod":
      return `.${gg(e)}.com`;
    case "local":
    default:
      return;
  }
}
function _6(e) {
  if (typeof e < "u")
    return new Date(e);
  {
    const t = (/* @__PURE__ */ new Date()).getTime(), n = 8 * 60 * 60 * 1e3;
    return new Date(t + n);
  }
}
const Mf = (e, t) => {
  const n = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV, r = x6(n), i = _6(t);
  r ? om.set("token", e, {
    domain: r,
    expires: i
  }) : om.set("token", e, {
    expires: i
  });
}, N6 = () => {
  switch (process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV) {
    case "dev":
      document.cookie = "currentOrganisationId=0;expires=0;domain=.roymorgandev.com;path=/", document.cookie = "currentTeamId=0;expires=0;domain=.roymorgandev.com;path=/";
      break;
    case "uat":
      document.cookie = "currentOrganisationId=0;expires=0;domain=.roymorganuat.com;path=/", document.cookie = "currentTeamId=0;expires=0;domain=.roymorganuat.com;path=/";
      break;
    case "production":
    case "prod":
      document.cookie = "currentOrganisationId=0;expires=0;domain=.roymorgan.com;path=/", document.cookie = "currentTeamId=0;expires=0;domain=.roymorgan.com;path=/";
      break;
    case "local":
    default:
      document.cookie = "currentOrganisationId=0;expires=0;path=/", document.cookie = "currentTeamId=0;expires=0;path=/";
      break;
  }
}, Zv = () => {
  switch (process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV) {
    case "dev":
      document.cookie = "token=0;expires=0;domain=.roymorgandev.com;path=/";
      break;
    case "uat":
      document.cookie = "token=0;expires=0;domain=.roymorganuat.com;path=/";
      break;
    case "production":
    case "prod":
      document.cookie = "token=0;expires=0;domain=.roymorgan.com;path=/";
      break;
    case "local":
    default:
      document.cookie = "token=0;expires=0;path=/";
      break;
  }
}, S6 = (e, t = Lc.STANDARD, n = !1) => {
  switch (t) {
    case Lc.SUPER_ADMIN:
      return ro.INTERNAL_ADMIN;
    case Lc.BUSINESS_ADMIN:
      return e ? ro.BUSINESS_ADMIN : ro.NO_ACCESS;
    case Lc.SUPPORT_ADMIN:
      return e ? ro.SUPPORT_ADMIN : ro.NO_ACCESS;
    default: {
      let r = n ? ro.ACCOUNT_MANAGER_ADMIN : ro.STANDARD_USER;
      return e ? r : ro.NO_ACCESS;
    }
  }
}, Jv = (e, t) => {
  switch (e) {
    case "1":
      return "/";
    case "2":
      switch (t) {
        case "dev":
          return "//audiences.roymorgandev.com";
        case "uat":
          return "//audiences.roymorganuat.com";
        default:
          return "//audiences.roymorgan.com";
      }
    case "3":
      switch (t) {
        case "dev":
          return "//search.roymorgandev.com";
        case "uat":
          return "//search.roymorganuat.com";
        default:
          return "//search.roymorgan.com";
      }
    case "4":
      switch (t) {
        case "prod":
          return "//mapping.roymorgan.com";
        case "uat":
          return "//livemapping.roymorganuat.com";
        case "dev":
        default:
          return "//mapping.roymorgandev.com";
      }
    case "5":
      return "/";
    case "6":
      switch (t) {
        case "prod":
          return "//helix.roymorgan.com";
        case "uat":
          return "//helix.roymorganuat.com";
        default:
          return "//helix.roymorgandev.com";
      }
    case "9":
      switch (t) {
        case "prod":
          return "//store.roymorgan.com";
        case "uat":
          return "//store.roymorganuat.com";
        default:
          return "//store.roymorgandev.com";
      }
    case "10":
      switch (t) {
        case "prod":
          return "//premium.roymorgan.com";
        case "uat":
          return "//premium.roymorganuat.com";
        default:
          return "//premium.roymorgandev.com";
      }
    case "-1":
      return "/no-access";
    default:
      return "/";
  }
};
/*! (c) Andrea Giammarchi - ISC */
var lm = {};
try {
  (function(e, t) {
    if (new e("q=%2B").get("q") !== t || new e({ q: t }).get("q") !== t || new e([["q", t]]).get("q") !== t || new e(`q=
`).toString() !== "q=%0A" || new e({ q: " &" }).toString() !== "q=+%26" || new e({ q: "%zx" }).toString() !== "q=%25zx")
      throw e;
    lm.URLSearchParams = e;
  })(URLSearchParams, "+");
} catch {
  (function(e, t, n) {
    var r = e.create, i = e.defineProperty, a = /[!'\(\)~]|%20|%00/g, o = /%(?![0-9a-fA-F]{2})/g, s = /\+/g, l = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    }, c = {
      append: function(_, E) {
        f(this._ungap, _, E);
      },
      delete: function(_) {
        delete this._ungap[_];
      },
      get: function(_) {
        return this.has(_) ? this._ungap[_][0] : null;
      },
      getAll: function(_) {
        return this.has(_) ? this._ungap[_].slice(0) : [];
      },
      has: function(_) {
        return _ in this._ungap;
      },
      set: function(_, E) {
        this._ungap[_] = [t(E)];
      },
      forEach: function(_, E) {
        var k = this;
        for (var M in k._ungap)
          k._ungap[M].forEach(F, M);
        function F(q) {
          _.call(E, q, t(M), k);
        }
      },
      toJSON: function() {
        return {};
      },
      toString: function() {
        var _ = [];
        for (var E in this._ungap)
          for (var k = b(E), M = 0, F = this._ungap[E]; M < F.length; M++)
            _.push(k + "=" + b(F[M]));
        return _.join("&");
      }
    };
    for (var d in c)
      i(p.prototype, d, {
        configurable: !0,
        writable: !0,
        value: c[d]
      });
    lm.URLSearchParams = p;
    function p(_) {
      var E = r(null);
      switch (i(this, "_ungap", { value: E }), !0) {
        case !_:
          break;
        case typeof _ == "string":
          _.charAt(0) === "?" && (_ = _.slice(1));
          for (var k = _.split("&"), M = 0, F = k.length; M < F; M++) {
            var q = k[M], j = q.indexOf("=");
            -1 < j ? f(
              E,
              N(q.slice(0, j)),
              N(q.slice(j + 1))
            ) : q.length && f(
              E,
              N(q),
              ""
            );
          }
          break;
        case n(_):
          for (var M = 0, F = _.length; M < F; M++) {
            var q = _[M];
            f(E, q[0], q[1]);
          }
          break;
        case "forEach" in _:
          _.forEach(y, E);
          break;
        default:
          for (var x in _)
            f(E, x, _[x]);
      }
    }
    function y(_, E) {
      f(this, E, _);
    }
    function f(_, E, k) {
      var M = n(k) ? k.join(",") : k;
      E in _ ? _[E].push(M) : _[E] = [M];
    }
    function N(_) {
      return decodeURIComponent(_.replace(o, "%25").replace(s, " "));
    }
    function b(_) {
      return encodeURIComponent(_).replace(a, S);
    }
    function S(_) {
      return l[_];
    }
  })(Object, String, Array.isArray);
}
(function(e) {
  var t = !1;
  try {
    t = !!Symbol.iterator;
  } catch {
  }
  "forEach" in e || (e.forEach = function(r, i) {
    var a = this, o = /* @__PURE__ */ Object.create(null);
    this.toString().replace(/=[\s\S]*?(?:&|$)/g, "=").split("=").forEach(function(s) {
      !s.length || s in o || (o[s] = a.getAll(s)).forEach(function(l) {
        r.call(i, l, s, a);
      });
    });
  }), "keys" in e || (e.keys = function() {
    return n(this, function(r, i) {
      this.push(i);
    });
  }), "values" in e || (e.values = function() {
    return n(this, function(r, i) {
      this.push(r);
    });
  }), "entries" in e || (e.entries = function() {
    return n(this, function(r, i) {
      this.push([i, r]);
    });
  }), t && !(Symbol.iterator in e) && (e[Symbol.iterator] = e.entries), "sort" in e || (e.sort = function() {
    for (var r = this.entries(), i = r.next(), a = i.done, o = [], s = /* @__PURE__ */ Object.create(null), l, c, d; !a; )
      d = i.value, c = d[0], o.push(c), c in s || (s[c] = []), s[c].push(d[1]), i = r.next(), a = i.done;
    for (o.sort(), l = 0; l < o.length; l++)
      this.delete(o[l]);
    for (l = 0; l < o.length; l++)
      c = o[l], this.append(c, s[c].shift());
  });
  function n(r, i) {
    var a = [];
    return r.forEach(i, a), t ? a[Symbol.iterator]() : {
      next: function() {
        var o = a.shift();
        return { done: o === void 0, value: o };
      }
    };
  }
  (function(r) {
    var i = r.defineProperty, a = r.getOwnPropertyDescriptor, o = function(p) {
      function y(b, S) {
        e.append.call(this, b, S), b = this.toString(), p.set.call(this._usp, b ? "?" + b : "");
      }
      function f(b) {
        e.delete.call(this, b), b = this.toString(), p.set.call(this._usp, b ? "?" + b : "");
      }
      function N(b, S) {
        e.set.call(this, b, S), b = this.toString(), p.set.call(this._usp, b ? "?" + b : "");
      }
      return function(b, S) {
        return b.append = y, b.delete = f, b.set = N, i(b, "_usp", {
          configurable: !0,
          writable: !0,
          value: S
        });
      };
    }, s = function(p) {
      return function(y, f) {
        return i(
          y,
          "_searchParams",
          {
            configurable: !0,
            writable: !0,
            value: p(f, y)
          }
        ), f;
      };
    }, l = function(p) {
      var y = p.append;
      p.append = e.append, URLSearchParams.call(p, p._usp.search.slice(1)), p.append = y;
    }, c = function(p, y) {
      if (!(p instanceof y)) throw new TypeError(
        "'searchParams' accessed on an object that does not implement interface " + y.name
      );
    }, d = function(p) {
      var y = p.prototype, f = a(y, "searchParams"), N = a(y, "href"), b = a(y, "search"), S;
      !f && b && b.set && (S = s(
        o(b)
      ), r.defineProperties(
        y,
        {
          href: {
            get: function() {
              return N.get.call(this);
            },
            set: function(_) {
              var E = this._searchParams;
              N.set.call(this, _), E && l(E);
            }
          },
          search: {
            get: function() {
              return b.get.call(this);
            },
            set: function(_) {
              var E = this._searchParams;
              b.set.call(this, _), E && l(E);
            }
          },
          searchParams: {
            get: function() {
              return c(this, p), this._searchParams || S(
                this,
                new URLSearchParams(this.search.slice(1))
              );
            },
            set: function(_) {
              c(this, p), S(this, _);
            }
          }
        }
      ));
    };
    try {
      d(HTMLAnchorElement), /^function|object$/.test(typeof URL) && URL.prototype && d(URL);
    } catch {
    }
  })(Object);
})(lm.URLSearchParams.prototype);
const kd = {
  token: void 0,
  tokenContent: void 0,
  isFetching: !1,
  user: void 0,
  error: void 0
}, E6 = (e = kd, t) => {
  switch (t.type) {
    case vv:
    case l6:
    case Pv:
    case AN:
    case n6:
    case a6:
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case Lv:
    case c6:
    case Fv:
    case o6:
      return {
        ...e,
        ...t.payload,
        isFetching: !1,
        error: void 0
      };
    case bv:
      return sm(t.payload.user.myOrganisationId), {
        ...e,
        user: {
          ...t.payload.user
        },
        isFetching: !1,
        error: void 0
      };
    case e6:
      return {
        ...e,
        user: {
          ...t.payload
        },
        isFetching: !1,
        error: void 0
      };
    case u6:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case wv:
    case t6:
    case i6:
    case s6:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case Tv:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case xv:
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case ys:
      return kd;
    case pg:
      return {
        ...kd,
        error: "User session expired"
      };
    case Iv:
      return {
        ...kd,
        error: "Registration failed. " + t.error + " If issue persists, please contact your account administrator."
      };
    case _v:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case Nv:
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case Sv:
      return {
        ...e,
        isFetching: !1,
        error: void 0
      };
    case Ev:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case XN:
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case ZN:
      return {
        ...e,
        tokenContent: t.payload,
        isFetching: !1,
        error: void 0
      };
    case Cv:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case Ov:
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case hg:
    case jv:
      return {
        ...e,
        isFetching: !1,
        error: void 0
      };
    case y6:
    case r6:
      return {
        ...e,
        user: {
          ...t.payload
        },
        isFetching: !1,
        error: void 0
      };
    default:
      return e;
  }
}, I2 = {
  byId: {},
  order: [],
  currentOrganisation: void 0
}, C6 = (e = I2, t) => {
  let n;
  switch (t.type) {
    case kv:
      return e;
    case Dv:
      return n = w6(), (!t.payload.order.find((r) => r === Number(n)) || !n) && (n = t.payload.order[0], sm(n.toString())), {
        ...e,
        ...t.payload,
        currentOrganisation: n
      };
    case Rv:
      return e;
    case mg:
      return sm(t.currentOrganisation.toString()), {
        ...e,
        currentOrganisation: t.currentOrganisation
      };
    case ys:
      return I2;
    default:
      return e;
  }
}, k2 = [], O6 = (e = k2, t) => {
  switch (t.type) {
    case zv:
      return t.payload;
    case ys:
      return k2;
    default:
      return e;
  }
}, D2 = {
  headerLogoLocation: "",
  customProperties: {}
}, j6 = (e = D2, t) => {
  switch (t.type) {
    case Vv:
      return t.payload;
    case ys:
      return D2;
    default:
      return e;
  }
}, xh = {
  byId: {},
  order: [],
  currentTeam: void 0,
  hasFetched: !1
}, P6 = (e = xh, t) => {
  let n;
  switch (t.type) {
    case Wv:
      return {
        ...e,
        hasFetched: !1
      };
    case Hv:
      return t.payload.order.length > 0 ? (e.currentTeam ? n = e.currentTeam : F2() && (n = F2()), (!n || !t.payload.order.find((r) => r === Number(n))) && (n = t.payload.order[0]), n && wh(n.toString())) : (n = null, wh("0")), {
        ...e,
        ...t.payload,
        currentTeam: n,
        hasFetched: !0
      };
    case $v:
      return {
        ...e,
        hasFetched: !0
      };
    case Kv:
      return wh(t.currentTeam.toString()), {
        ...e,
        currentTeam: t.currentTeam
      };
    case mg:
      return xh;
    case ys:
      return xh;
    default:
      return e;
  }
}, R2 = {};
function L6(e = R2, t) {
  switch (t.type) {
    case qv:
      return t.payload;
    case Cv:
    case pg:
    case ys:
      return N6(), R2;
    default:
      return e;
  }
}
const T6 = {
  isFetching: !1
}, F6 = (e = T6, t) => {
  switch (t.type) {
    case mv:
      return {
        isFetching: !0
      };
    case yv:
    case gv:
    case hg:
      return {
        isFetching: !1
      };
    default:
      return e;
  }
}, I6 = {
  isFetching: !1
}, k6 = (e = I6, t) => {
  switch (t.type) {
    case QN:
      return {
        isFetching: !0
      };
    case KN:
    case YN:
      return {
        isFetching: !1
      };
    default:
      return e;
  }
}, D6 = {
  byId: {},
  order: [],
  fetched: !1
}, R6 = (e = D6, t) => {
  switch (t.type) {
    case Mv:
      return {
        ...e
      };
    case Uv:
      return {
        ...e,
        ...t.payload,
        fetched: !0
      };
    case Bv:
      return {
        ...e,
        fetched: !0
      };
    default:
      return e;
  }
}, M6 = {
  byId: {},
  order: [],
  fetched: !1
}, U6 = (e = M6, t) => {
  switch (t.type) {
    case Gv:
      return {
        ...e
      };
    case Qv:
      return {
        ...e,
        ...t.payload,
        fetched: !0
      };
    case Yv:
      return {
        ...e,
        fetched: !0
      };
    default:
      return e;
  }
};
nu({
  user: E6,
  organisations: C6,
  teams: P6,
  authorisation: L6,
  products: O6,
  loginStatus: F6,
  userDataRetrievalStatus: k6,
  noAccessUserOrganisations: R6,
  noAccessUserTeams: U6,
  settings: j6
});
const B6 = () => ({
  type: hg
}), Dc = "8.51.0", La = globalThis;
function bg(e, t, n) {
  const r = La, i = r.__SENTRY__ = r.__SENTRY__ || {}, a = i[Dc] = i[Dc] || {};
  return a[e] || (a[e] = t());
}
const Av = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, z6 = "Sentry Logger ", M2 = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], U2 = {};
function q6(e) {
  if (!("console" in La))
    return e();
  const t = La.console, n = {}, r = Object.keys(U2);
  r.forEach((i) => {
    const a = U2[i];
    n[i] = t[i], t[i] = a;
  });
  try {
    return e();
  } finally {
    r.forEach((i) => {
      t[i] = n[i];
    });
  }
}
function V6() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Av ? M2.forEach((n) => {
    t[n] = (...r) => {
      e && q6(() => {
        La.console[n](`${z6}[${n}]:`, ...r);
      });
    };
  }) : M2.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
const af = bg("logger", V6);
function eb() {
  return wg(La), La;
}
function wg(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || Dc, t[Dc] = t[Dc] || {};
}
const W6 = Object.prototype.toString;
function H6(e, t) {
  return W6.call(e) === `[object ${t}]`;
}
function $6(e) {
  return H6(e, "Object");
}
function G6(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function Q6(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    Av && af.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
const tb = 1e3;
function nb() {
  return Date.now() / tb;
}
function Y6() {
  const { performance: e } = La;
  if (!e || !e.now)
    return nb;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / tb;
}
const K6 = Y6();
(() => {
  const { performance: e } = La;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, a = i < t, o = e.timing && e.timing.navigationStart, s = typeof o == "number" ? Math.abs(o + n - r) : t, l = s < t;
  return a || l ? i <= s ? e.timeOrigin : o : r;
})();
function fl() {
  const e = La, t = e.crypto || e.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return t.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function X6(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || K6(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : fl()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function B2() {
  return fl();
}
function z2() {
  return fl().substring(16);
}
function rb(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && t && Object.keys(t).length === 0)
    return e;
  const r = { ...e };
  for (const i in t)
    Object.prototype.hasOwnProperty.call(t, i) && (r[i] = rb(r[i], t[i], n - 1));
  return r;
}
const cm = "_sentrySpan";
function q2(e, t) {
  t ? Q6(e, cm, t) : delete e[cm];
}
function V2(e) {
  return e[cm];
}
const Z6 = 100;
class xg {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  // eslint-disable-next-line deprecation/deprecation
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: B2(),
      spanId: z2()
    };
  }
  /**
   * @inheritDoc
   */
  clone() {
    const t = new xg();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, q2(t, V2(this)), t;
  }
  /**
   * @inheritDoc
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && X6(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, [r, i] = n instanceof Gc ? (
      // eslint-disable-next-line deprecation/deprecation
      [n.getScopeData(), n.getRequestSession()]
    ) : $6(n) ? [t, t.requestSession] : [], { tags: a, extra: o, user: s, contexts: l, level: c, fingerprint: d = [], propagationContext: p } = r || {};
    return this._tags = { ...this._tags, ...a }, this._extra = { ...this._extra, ...o }, this._contexts = { ...this._contexts, ...l }, s && Object.keys(s).length && (this._user = s), c && (this._level = c), d.length && (this._fingerprint = d), p && (this._propagationContext = p), i && (this._requestSession = i), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, q2(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: B2() }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : Z6;
    if (r <= 0)
      return this;
    const i = {
      timestamp: nb(),
      ...t
    }, a = this._breadcrumbs;
    return a.push(i), this._breadcrumbs = a.length > r ? a.slice(-r) : a, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: V2(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = rb(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(t) {
    return this._propagationContext = {
      // eslint-disable-next-line deprecation/deprecation
      spanId: z2(),
      ...t
    }, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(t, n) {
    const r = n && n.event_id ? n.event_id : fl();
    if (!this._client)
      return af.warn("No client configured on scope - will not capture exception!"), r;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: i,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r) {
    const i = r && r.event_id ? r.event_id : fl();
    if (!this._client)
      return af.warn("No client configured on scope - will not capture message!"), i;
    const a = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : fl();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (af.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
const Gc = xg;
function J6() {
  return bg("defaultCurrentScope", () => new Gc());
}
function A6() {
  return bg("defaultIsolationScope", () => new Gc());
}
class eS {
  constructor(t, n) {
    let r;
    t ? r = t : r = new Gc();
    let i;
    n ? i = n : i = new Gc(), this._stack = [{ scope: r }], this._isolationScope = i;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let r;
    try {
      r = t(n);
    } catch (i) {
      throw this._popScope(), i;
    }
    return G6(r) ? r.then(
      (i) => (this._popScope(), i),
      (i) => {
        throw this._popScope(), i;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function bl() {
  const e = eb(), t = wg(e);
  return t.stack = t.stack || new eS(J6(), A6());
}
function tS(e) {
  return bl().withScope(e);
}
function nS(e, t) {
  const n = bl();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function W2(e) {
  return bl().withScope(() => e(bl().getIsolationScope()));
}
function rS() {
  return {
    withIsolationScope: W2,
    withScope: tS,
    withSetScope: nS,
    withSetIsolationScope: (e, t) => W2(t),
    getCurrentScope: () => bl().getScope(),
    getIsolationScope: () => bl().getIsolationScope()
  };
}
function iS(e) {
  const t = wg(e);
  return t.acs ? t.acs : rS();
}
function aS() {
  const e = eb();
  return iS(e).getCurrentScope();
}
function Tn(e, t) {
  return aS().captureException(e, void 0);
}
const ci = async ({
  method: e,
  targetUrl: t,
  token: n,
  body: r,
  organisationId: i,
  teamId: a
}) => {
  const o = n ? new Headers({
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    token: n,
    "context-organisation": i || "0",
    "context-team": a || "0"
  }) : new Headers({
    "Cache-Control": "no-cache",
    "Content-Type": "application/json"
  }), s = await fetch(t, {
    method: e,
    headers: o,
    body: JSON.stringify(r)
  });
  if (!s.ok) {
    const l = await s.json(), c = Error("Invalid API Response");
    throw c.msg = l.errors ? l.errors[0].message : l.statusMessage ? l.statusMessage : "API Error", c;
  }
  return await s.json();
}, oS = () => ({
  type: Nv
}), sS = () => ({
  type: Sv
}), lS = (e) => ({
  type: Ev,
  error: e
}), cS = (e, t) => async (n, r) => {
  n(oS());
  try {
    let i = {
      email: e
    };
    return t && (i = {
      ...i,
      productId: t
    }), await ci({
      method: "POST",
      targetUrl: `${ur("v2", "management")}/account/password/forgot`,
      body: i
    }), n(sS()), !0;
  } catch (i) {
    return n(lS(i)), console.error(i), Tn(i), !1;
  }
}, uS = () => ({
  type: vv
}), dS = (e) => ({
  type: bv,
  payload: e
}), fS = (e) => ({
  type: wv,
  error: e
}), pS = (e, t) => async (n, r) => {
  try {
    n(uS());
    const i = {
      email: e,
      password: t
    }, a = await ci({
      method: "POST",
      targetUrl: `${ur("v2", "management")}/account/auth/login`,
      body: i
    });
    return n(dS(a)), Mf(a.token, a.tokenExpiry), !0;
  } catch (i) {
    throw n(fS(i.msg)), i;
  }
}, hS = () => ({
  type: xv
}), mS = () => ({
  type: ys
}), gS = (e) => ({
  type: _v,
  error: e
}), ib = (e) => async (t, n) => {
  t(hS()), Zv();
  try {
    return await t(mS()), e && await t(e()), !0;
  } catch (r) {
    t(gS(r)), Tn(r), console.error(r);
  }
}, yS = () => ({
  type: Ov
}), vS = (e) => ({
  type: jv,
  payload: e
}), bS = (e) => ({
  type: pg,
  error: e
}), Ra = () => async (e, t) => {
  e(yS());
  try {
    const n = Yn();
    if (n === "" || n === "0")
      throw new Error("Invalid token");
    const r = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}/account/auth/refreshtoken`,
      token: n
    });
    return e(vS(r)), Mf(r.token, r.tokenExpiry), !0;
  } catch (n) {
    return e(bS(n)), Zv(), console.error(n), Tn(n), !1;
  }
}, wS = () => ({
  type: Pv
}), xS = (e) => ({
  type: Lv,
  payload: e
}), _S = (e) => ({
  type: Tv,
  error: e
}), NS = (e, t) => async (n, r) => {
  n(wS());
  try {
    const i = {
      newPassword: e
    }, a = await ci({
      method: "POST",
      targetUrl: `${ur("v2", "management")}/account/password/reset?token=${t}`,
      body: i
    });
    return n(xS(a)), Mf(a.token, a.tokenExpiry), !0;
  } catch (i) {
    throw n(_S(i.msg)), i;
  }
}, SS = () => ({
  type: JN
}), ES = (e) => ({
  type: Fv,
  payload: e
}), CS = (e) => ({
  type: Iv,
  error: e
}), OS = (e, t, n, r) => async (i, a) => {
  i(SS());
  try {
    const o = {
      name: e,
      phone: t,
      password: n
    }, s = await ci({
      method: "PUT",
      targetUrl: `${ur("v2", "management")}/account/register/invited?token=${r}`,
      body: o
    });
    return i(ES(s)), Mf(s.token, s.tokenExpiry), !0;
  } catch (o) {
    throw i(CS(o.msg)), o;
  }
}, jS = (e, t) => async (n, r) => {
  try {
    n(IS(parseInt(e, 10))), t && n(eE(parseInt(t, 10)));
  } catch {
    return !1;
  }
}, PS = () => ({
  type: mv
}), LS = () => ({
  type: gv
}), TS = () => ({
  type: yv
}), FS = (e, t, n) => async (r, i) => {
  try {
    return r(PS()), await r(pS(e, t)), await r(MS()), await r(iE()), await r($S()), n && (await r(KS(n)), await r(AS(n))), r(LS()), !0;
  } catch {
    return r(TS()), !1;
  }
}, IS = (e) => ({
  type: mg,
  currentOrganisation: e
}), kS = () => ({
  type: kv
}), DS = (e) => ({
  type: Dv,
  payload: e
}), RS = (e) => ({
  type: Rv,
  error: e
}), MS = () => async (e, t) => {
  try {
    e(kS());
    const n = Yn();
    if (!n)
      throw new Error("No user token");
    const r = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}/active-user/organisations`,
      token: n
    }), i = ru(r);
    return e(DS(i)), !0;
  } catch (n) {
    return e(RS(n.toString())), console.error(n), Tn(n), !1;
  }
}, US = () => ({
  type: Mv
}), BS = (e) => ({
  type: Uv,
  payload: e
}), zS = (e) => ({
  type: Bv,
  error: e
}), qS = (e) => async (t, n) => {
  try {
    t(US());
    const r = Yn();
    if (!r)
      throw new Error("No user token");
    const i = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}/active-user/products/${e}/organisations`,
      token: r
    }), a = ru(i, "id");
    return t(BS(a)), !0;
  } catch (r) {
    return t(zS(r.toString())), process.env.NODE_ENV !== "test" && (console.error(r), Tn(r)), !1;
  }
}, VS = () => ({
  type: d6
}), WS = (e) => ({
  type: zv,
  payload: e
}), HS = (e) => ({
  type: f6,
  error: e
}), $S = () => async (e, t) => {
  try {
    e(VS());
    const n = Yn();
    if (!n)
      throw new Error("No user token");
    const r = t().auth.organisations.currentOrganisation;
    if (!r)
      throw new Error("No organisation set");
    const i = t().auth.teams.currentTeam;
    let a = `/active-user/organisations/${r}`;
    i && (a += `/teams/${i}`), a += "/product-access";
    const o = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}${a}`,
      token: n
    });
    e(WS(o));
  } catch (n) {
    return e(HS(n.toString())), console.error(n), Tn(n), !1;
  }
}, GS = () => ({
  type: p6
}), QS = (e) => ({
  type: qv,
  payload: e
}), YS = (e) => ({
  type: h6,
  error: e
}), KS = (e) => async (t, n) => {
  try {
    t(GS());
    const r = Yn();
    if (!r)
      throw new Error("No user token");
    const i = n().auth.organisations.currentOrganisation;
    if (!i)
      throw new Error("No organisation set");
    const a = n().auth.teams.currentTeam;
    let o = `/active-user/organisations/${i}`;
    a && (o += `/teams/${a}`), o += "/feature-access";
    const s = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}${o}`,
      token: r
    });
    let l = n().auth.user.user ? (
      // $FlowFixMe
      n().auth.user.user.accountTypeId
    ) : Lc.STANDARD, c = n().auth.organisations.byId[i], d = c ? c.isAccountManager : !1, p = s.filter((y) => y.productId === e).map((y) => (y.permission = S6(y.hasAccess, l, d), y));
    t(QS(yg(p)));
  } catch (r) {
    return t(YS(r.toString())), console.error(r), Tn(r), !1;
  }
}, XS = () => ({
  type: m6
}), ZS = (e) => ({
  type: Vv,
  payload: e
}), JS = (e) => ({
  type: g6,
  error: e
}), AS = (e) => async (t, n) => {
  try {
    t(XS());
    const r = Yn();
    if (!r)
      throw new Error("No user token");
    const i = n().auth.organisations.currentOrganisation;
    if (!i)
      throw new Error("No organisation set");
    let a = `/products/${e}/settings`;
    const o = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}${a}`,
      token: r,
      organisationId: i
    });
    t(ZS(o));
  } catch (r) {
    return t(JS(r.toString())), console.error(r), Tn(r), !1;
  }
}, eE = (e) => ({
  type: Kv,
  currentTeam: e
}), tE = () => ({
  type: Wv
}), nE = (e) => ({
  type: Hv,
  payload: e
}), rE = (e) => ({
  type: $v,
  error: e
}), iE = () => async (e, t) => {
  try {
    e(tE());
    const n = Yn();
    if (!n)
      throw new Error("No user token");
    const r = t().auth.organisations.currentOrganisation;
    if (!r)
      throw new Error("No organisation set");
    const i = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}/active-user/organisations/${r}/teams`,
      token: n
    }), a = ru(i);
    return e(nE(a)), a;
  } catch (n) {
    return e(rE(n.toString())), console.error(n), Tn(n), !1;
  }
}, aE = () => ({
  type: Gv
}), oE = (e) => ({
  type: Qv,
  payload: e
}), sE = (e) => ({
  type: Yv,
  error: e
}), lE = (e, t) => async (n, r) => {
  try {
    n(aE());
    const i = Yn();
    if (!i)
      throw new Error("No user token");
    const a = await ci({
      method: "GET",
      targetUrl: `${ur("v2", "management")}/active-user/products/${e}/organisations/${t}/teams`,
      token: i
    }), o = ru(a, "id");
    return n(oE(o)), o;
  } catch (i) {
    return n(sE(i.toString())), console.error(i), Tn(i), !1;
  }
};
function cE(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function H2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H2(Object(n), !0).forEach(function(r) {
      cE(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var as = function(e) {
  return e.type ? $2($2({}, e), {}, {
    globalAction: !0
  }) : e;
};
const uE = "FEATURE_ACCESS_REQUEST", dE = "FEATURE_ACCESS_SUCCESS", fE = "FEATURE_ACCESS_FAILURE";
function pE() {
  return {
    type: uE
  };
}
function hE(e) {
  return {
    type: dE,
    payload: e
  };
}
function mE(e) {
  return {
    type: fE,
    error: e
  };
}
function ui() {
  return async (e, t) => {
    try {
      e(as(pE()));
      let n = "";
      const r = Yn(), i = t(), a = i.auth.organisations.currentOrganisation, o = i.auth.teams.currentTeam;
      a && o ? n = `${ur("v2", "management")}/active-user/organisations/${a}/teams/${o}/feature-access` : a && (n = `${ur("v2", "management")}/active-user/organisations/${a}/feature-access`);
      const s = await ci({
        method: "GET",
        targetUrl: n,
        token: r
      }), l = ru(s);
      e(as(hE(l)));
    } catch (n) {
      Tn(n), e(as(mE(n.message))), process.env.NODE_ENV !== "test" && console.error(n);
    }
  };
}
var um = { exports: {} }, mc = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G2;
function gE() {
  if (G2) return mc;
  G2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, a) {
    var o = null;
    if (a !== void 0 && (o = "" + a), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      a = {};
      for (var s in i)
        s !== "key" && (a[s] = i[s]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return mc.Fragment = t, mc.jsx = n, mc.jsxs = n, mc;
}
var Dd = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q2;
function yE() {
  return Q2 || (Q2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(T) {
      if (T == null) return null;
      if (typeof T == "function")
        return T.$$typeof === oe ? null : T.displayName || T.name || null;
      if (typeof T == "string") return T;
      switch (T) {
        case q:
          return "Fragment";
        case F:
          return "Portal";
        case x:
          return "Profiler";
        case j:
          return "StrictMode";
        case L:
          return "Suspense";
        case H:
          return "SuspenseList";
      }
      if (typeof T == "object")
        switch (typeof T.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), T.$$typeof) {
          case D:
            return (T.displayName || "Context") + ".Provider";
          case C:
            return (T._context.displayName || "Context") + ".Consumer";
          case P:
            var fe = T.render;
            return T = T.displayName, T || (T = fe.displayName || fe.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
          case $:
            return fe = T.displayName || null, fe !== null ? fe : e(T.type) || "Memo";
          case ae:
            fe = T._payload, T = T._init;
            try {
              return e(T(fe));
            } catch {
            }
        }
      return null;
    }
    function t(T) {
      return "" + T;
    }
    function n(T) {
      try {
        t(T);
        var fe = !1;
      } catch {
        fe = !0;
      }
      if (fe) {
        fe = console;
        var xe = fe.error, Fe = typeof Symbol == "function" && Symbol.toStringTag && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return xe.call(
          fe,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Fe
        ), t(T);
      }
    }
    function r() {
    }
    function i() {
      if (G === 0) {
        K = console.log, A = console.info, ee = console.warn, te = console.error, ne = console.group, ve = console.groupCollapsed, _e = console.groupEnd;
        var T = {
          configurable: !0,
          enumerable: !0,
          value: r,
          writable: !0
        };
        Object.defineProperties(console, {
          info: T,
          log: T,
          warn: T,
          error: T,
          group: T,
          groupCollapsed: T,
          groupEnd: T
        });
      }
      G++;
    }
    function a() {
      if (G--, G === 0) {
        var T = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: re({}, T, { value: K }),
          info: re({}, T, { value: A }),
          warn: re({}, T, { value: ee }),
          error: re({}, T, { value: te }),
          group: re({}, T, { value: ne }),
          groupCollapsed: re({}, T, { value: ve }),
          groupEnd: re({}, T, { value: _e })
        });
      }
      0 > G && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function o(T) {
      if (pe === void 0)
        try {
          throw Error();
        } catch (xe) {
          var fe = xe.stack.trim().match(/\n( *(at )?)/);
          pe = fe && fe[1] || "", je = -1 < xe.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < xe.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + pe + T + je;
    }
    function s(T, fe) {
      if (!T || Se) return "";
      var xe = be.get(T);
      if (xe !== void 0) return xe;
      Se = !0, xe = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var Fe = null;
      Fe = se.H, se.H = null, i();
      try {
        var Ge = {
          DetermineComponentFrameRoot: function() {
            try {
              if (fe) {
                var dt = function() {
                  throw Error();
                };
                if (Object.defineProperty(dt.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(dt, []);
                  } catch (Le) {
                    var Ut = Le;
                  }
                  Reflect.construct(T, [], dt);
                } else {
                  try {
                    dt.call();
                  } catch (Le) {
                    Ut = Le;
                  }
                  T.call(dt.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Le) {
                  Ut = Le;
                }
                (dt = T()) && typeof dt.catch == "function" && dt.catch(function() {
                });
              }
            } catch (Le) {
              if (Le && Ut && typeof Le.stack == "string")
                return [Le.stack, Ut.stack];
            }
            return [null, null];
          }
        };
        Ge.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var Me = Object.getOwnPropertyDescriptor(
          Ge.DetermineComponentFrameRoot,
          "name"
        );
        Me && Me.configurable && Object.defineProperty(
          Ge.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var Ie = Ge.DetermineComponentFrameRoot(), ct = Ie[0], at = Ie[1];
        if (ct && at) {
          var Je = ct.split(`
`), $e = at.split(`
`);
          for (Ie = Me = 0; Me < Je.length && !Je[Me].includes(
            "DetermineComponentFrameRoot"
          ); )
            Me++;
          for (; Ie < $e.length && !$e[Ie].includes(
            "DetermineComponentFrameRoot"
          ); )
            Ie++;
          if (Me === Je.length || Ie === $e.length)
            for (Me = Je.length - 1, Ie = $e.length - 1; 1 <= Me && 0 <= Ie && Je[Me] !== $e[Ie]; )
              Ie--;
          for (; 1 <= Me && 0 <= Ie; Me--, Ie--)
            if (Je[Me] !== $e[Ie]) {
              if (Me !== 1 || Ie !== 1)
                do
                  if (Me--, Ie--, 0 > Ie || Je[Me] !== $e[Ie]) {
                    var _t = `
` + Je[Me].replace(
                      " at new ",
                      " at "
                    );
                    return T.displayName && _t.includes("<anonymous>") && (_t = _t.replace("<anonymous>", T.displayName)), typeof T == "function" && be.set(T, _t), _t;
                  }
                while (1 <= Me && 0 <= Ie);
              break;
            }
        }
      } finally {
        Se = !1, se.H = Fe, a(), Error.prepareStackTrace = xe;
      }
      return Je = (Je = T ? T.displayName || T.name : "") ? o(Je) : "", typeof T == "function" && be.set(T, Je), Je;
    }
    function l(T) {
      if (T == null) return "";
      if (typeof T == "function") {
        var fe = T.prototype;
        return s(
          T,
          !(!fe || !fe.isReactComponent)
        );
      }
      if (typeof T == "string") return o(T);
      switch (T) {
        case L:
          return o("Suspense");
        case H:
          return o("SuspenseList");
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case P:
            return T = s(T.render, !1), T;
          case $:
            return l(T.type);
          case ae:
            fe = T._payload, T = T._init;
            try {
              return l(T(fe));
            } catch {
            }
        }
      return "";
    }
    function c() {
      var T = se.A;
      return T === null ? null : T.getOwner();
    }
    function d(T) {
      if (J.call(T, "key")) {
        var fe = Object.getOwnPropertyDescriptor(T, "key").get;
        if (fe && fe.isReactWarning) return !1;
      }
      return T.key !== void 0;
    }
    function p(T, fe) {
      function xe() {
        Ye || (Ye = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          fe
        ));
      }
      xe.isReactWarning = !0, Object.defineProperty(T, "key", {
        get: xe,
        configurable: !0
      });
    }
    function y() {
      var T = e(this.type);
      return Re[T] || (Re[T] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), T = this.props.ref, T !== void 0 ? T : null;
    }
    function f(T, fe, xe, Fe, Ge, Me) {
      return xe = Me.ref, T = {
        $$typeof: M,
        type: T,
        key: fe,
        props: Me,
        _owner: Ge
      }, (xe !== void 0 ? xe : null) !== null ? Object.defineProperty(T, "ref", {
        enumerable: !1,
        get: y
      }) : Object.defineProperty(T, "ref", { enumerable: !1, value: null }), T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(T, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    }
    function N(T, fe, xe, Fe, Ge, Me) {
      if (typeof T == "string" || typeof T == "function" || T === q || T === x || T === j || T === L || T === H || T === ce || typeof T == "object" && T !== null && (T.$$typeof === ae || T.$$typeof === $ || T.$$typeof === D || T.$$typeof === C || T.$$typeof === P || T.$$typeof === I || T.getModuleId !== void 0)) {
        var Ie = fe.children;
        if (Ie !== void 0)
          if (Fe)
            if (U(Ie)) {
              for (Fe = 0; Fe < Ie.length; Fe++)
                b(Ie[Fe], T);
              Object.freeze && Object.freeze(Ie);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else b(Ie, T);
      } else
        Ie = "", (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), T === null ? Fe = "null" : U(T) ? Fe = "array" : T !== void 0 && T.$$typeof === M ? (Fe = "<" + (e(T.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof T, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          Fe,
          Ie
        );
      if (J.call(fe, "key")) {
        Ie = e(T);
        var ct = Object.keys(fe).filter(function(Je) {
          return Je !== "key";
        });
        Fe = 0 < ct.length ? "{key: someKey, " + ct.join(": ..., ") + ": ...}" : "{key: someKey}", Te[Ie + Fe] || (ct = 0 < ct.length ? "{" + ct.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Fe,
          Ie,
          ct,
          Ie
        ), Te[Ie + Fe] = !0);
      }
      if (Ie = null, xe !== void 0 && (n(xe), Ie = "" + xe), d(fe) && (n(fe.key), Ie = "" + fe.key), "key" in fe) {
        xe = {};
        for (var at in fe)
          at !== "key" && (xe[at] = fe[at]);
      } else xe = fe;
      return Ie && p(
        xe,
        typeof T == "function" ? T.displayName || T.name || "Unknown" : T
      ), f(T, Ie, Me, Ge, c(), xe);
    }
    function b(T, fe) {
      if (typeof T == "object" && T && T.$$typeof !== X) {
        if (U(T))
          for (var xe = 0; xe < T.length; xe++) {
            var Fe = T[xe];
            S(Fe) && _(Fe, fe);
          }
        else if (S(T))
          T._store && (T._store.validated = 1);
        else if (T === null || typeof T != "object" ? xe = null : (xe = le && T[le] || T["@@iterator"], xe = typeof xe == "function" ? xe : null), typeof xe == "function" && xe !== T.entries && (xe = xe.call(T), xe !== T))
          for (; !(T = xe.next()).done; )
            S(T.value) && _(T.value, fe);
      }
    }
    function S(T) {
      return typeof T == "object" && T !== null && T.$$typeof === M;
    }
    function _(T, fe) {
      if (T._store && !T._store.validated && T.key == null && (T._store.validated = 1, fe = E(fe), !Ue[fe])) {
        Ue[fe] = !0;
        var xe = "";
        T && T._owner != null && T._owner !== c() && (xe = null, typeof T._owner.tag == "number" ? xe = e(T._owner.type) : typeof T._owner.name == "string" && (xe = T._owner.name), xe = " It was passed a child from " + xe + ".");
        var Fe = se.getCurrentStack;
        se.getCurrentStack = function() {
          var Ge = l(T.type);
          return Fe && (Ge += Fe() || ""), Ge;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          fe,
          xe
        ), se.getCurrentStack = Fe;
      }
    }
    function E(T) {
      var fe = "", xe = c();
      return xe && (xe = e(xe.type)) && (fe = `

Check the render method of \`` + xe + "`."), fe || (T = e(T)) && (fe = `

Check the top-level render call using <` + T + ">."), fe;
    }
    var k = gt, M = Symbol.for("react.transitional.element"), F = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), j = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), D = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), H = Symbol.for("react.suspense_list"), $ = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), ce = Symbol.for("react.offscreen"), le = Symbol.iterator, oe = Symbol.for("react.client.reference"), se = k.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J = Object.prototype.hasOwnProperty, re = Object.assign, I = Symbol.for("react.client.reference"), U = Array.isArray, G = 0, K, A, ee, te, ne, ve, _e;
    r.__reactDisabledLog = !0;
    var pe, je, Se = !1, be = new (typeof WeakMap == "function" ? WeakMap : Map)(), X = Symbol.for("react.client.reference"), Ye, Re = {}, Te = {}, Ue = {};
    Dd.Fragment = q, Dd.jsx = function(T, fe, xe, Fe, Ge) {
      return N(T, fe, xe, !1, Fe, Ge);
    }, Dd.jsxs = function(T, fe, xe, Fe, Ge) {
      return N(T, fe, xe, !0, Fe, Ge);
    };
  }()), Dd;
}
process.env.NODE_ENV === "production" ? um.exports = gE() : um.exports = yE();
var m = um.exports;
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pe.apply(null, arguments);
}
var vE = Object.prototype, bE = vE.hasOwnProperty;
function wE(e, t) {
  return e != null && bE.call(e, t);
}
var Rn = Array.isArray, ab = typeof global == "object" && global && global.Object === Object && global, xE = typeof self == "object" && self && self.Object === Object && self, Ma = ab || xE || Function("return this")(), la = Ma.Symbol, ob = Object.prototype, _E = ob.hasOwnProperty, NE = ob.toString, gc = la ? la.toStringTag : void 0;
function SE(e) {
  var t = _E.call(e, gc), n = e[gc];
  try {
    e[gc] = void 0;
    var r = !0;
  } catch {
  }
  var i = NE.call(e);
  return r && (t ? e[gc] = n : delete e[gc]), i;
}
var EE = Object.prototype, CE = EE.toString;
function OE(e) {
  return CE.call(e);
}
var jE = "[object Null]", PE = "[object Undefined]", Y2 = la ? la.toStringTag : void 0;
function ma(e) {
  return e == null ? e === void 0 ? PE : jE : Y2 && Y2 in Object(e) ? SE(e) : OE(e);
}
function ji(e) {
  return e != null && typeof e == "object";
}
var LE = "[object Symbol]";
function ds(e) {
  return typeof e == "symbol" || ji(e) && ma(e) == LE;
}
var TE = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, FE = /^\w*$/;
function _g(e, t) {
  if (Rn(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ds(e) ? !0 : FE.test(e) || !TE.test(e) || t != null && e in Object(t);
}
function Ta(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var IE = "[object AsyncFunction]", kE = "[object Function]", DE = "[object GeneratorFunction]", RE = "[object Proxy]";
function wl(e) {
  if (!Ta(e))
    return !1;
  var t = ma(e);
  return t == kE || t == DE || t == IE || t == RE;
}
var _h = Ma["__core-js_shared__"], K2 = function() {
  var e = /[^.]+$/.exec(_h && _h.keys && _h.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ME(e) {
  return !!K2 && K2 in e;
}
var UE = Function.prototype, BE = UE.toString;
function vs(e) {
  if (e != null) {
    try {
      return BE.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var zE = /[\\^$.*+?()[\]{}|]/g, qE = /^\[object .+?Constructor\]$/, VE = Function.prototype, WE = Object.prototype, HE = VE.toString, $E = WE.hasOwnProperty, GE = RegExp(
  "^" + HE.call($E).replace(zE, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function QE(e) {
  if (!Ta(e) || ME(e))
    return !1;
  var t = wl(e) ? GE : qE;
  return t.test(vs(e));
}
function YE(e, t) {
  return e == null ? void 0 : e[t];
}
function bs(e, t) {
  var n = YE(e, t);
  return QE(n) ? n : void 0;
}
var Qc = bs(Object, "create");
function KE() {
  this.__data__ = Qc ? Qc(null) : {}, this.size = 0;
}
function XE(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ZE = "__lodash_hash_undefined__", JE = Object.prototype, AE = JE.hasOwnProperty;
function eC(e) {
  var t = this.__data__;
  if (Qc) {
    var n = t[e];
    return n === ZE ? void 0 : n;
  }
  return AE.call(t, e) ? t[e] : void 0;
}
var tC = Object.prototype, nC = tC.hasOwnProperty;
function rC(e) {
  var t = this.__data__;
  return Qc ? t[e] !== void 0 : nC.call(t, e);
}
var iC = "__lodash_hash_undefined__";
function aC(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Qc && t === void 0 ? iC : t, this;
}
function fs(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
fs.prototype.clear = KE;
fs.prototype.delete = XE;
fs.prototype.get = eC;
fs.prototype.has = rC;
fs.prototype.set = aC;
function oC() {
  this.__data__ = [], this.size = 0;
}
function Uf(e, t) {
  return e === t || e !== e && t !== t;
}
function Bf(e, t) {
  for (var n = e.length; n--; )
    if (Uf(e[n][0], t))
      return n;
  return -1;
}
var sC = Array.prototype, lC = sC.splice;
function cC(e) {
  var t = this.__data__, n = Bf(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : lC.call(t, n, 1), --this.size, !0;
}
function uC(e) {
  var t = this.__data__, n = Bf(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function dC(e) {
  return Bf(this.__data__, e) > -1;
}
function fC(e, t) {
  var n = this.__data__, r = Bf(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Ua(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ua.prototype.clear = oC;
Ua.prototype.delete = cC;
Ua.prototype.get = uC;
Ua.prototype.has = dC;
Ua.prototype.set = fC;
var Yc = bs(Ma, "Map");
function pC() {
  this.size = 0, this.__data__ = {
    hash: new fs(),
    map: new (Yc || Ua)(),
    string: new fs()
  };
}
function hC(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function zf(e, t) {
  var n = e.__data__;
  return hC(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function mC(e) {
  var t = zf(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function gC(e) {
  return zf(this, e).get(e);
}
function yC(e) {
  return zf(this, e).has(e);
}
function vC(e, t) {
  var n = zf(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Ba(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ba.prototype.clear = pC;
Ba.prototype.delete = mC;
Ba.prototype.get = gC;
Ba.prototype.has = yC;
Ba.prototype.set = vC;
var bC = "Expected a function";
function iu(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(bC);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (iu.Cache || Ba)(), n;
}
iu.Cache = Ba;
var wC = 500;
function xC(e) {
  var t = iu(e, function(r) {
    return n.size === wC && n.clear(), r;
  }), n = t.cache;
  return t;
}
var _C = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, NC = /\\(\\)?/g, SC = xC(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(_C, function(n, r, i, a) {
    t.push(i ? a.replace(NC, "$1") : r || n);
  }), t;
});
function os(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var X2 = la ? la.prototype : void 0, Z2 = X2 ? X2.toString : void 0;
function qf(e) {
  if (typeof e == "string")
    return e;
  if (Rn(e))
    return os(e, qf) + "";
  if (ds(e))
    return Z2 ? Z2.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function ws(e) {
  return e == null ? "" : qf(e);
}
function au(e, t) {
  return Rn(e) ? e : _g(e, t) ? [e] : SC(ws(e));
}
var EC = "[object Arguments]";
function J2(e) {
  return ji(e) && ma(e) == EC;
}
var sb = Object.prototype, CC = sb.hasOwnProperty, OC = sb.propertyIsEnumerable, Vf = J2(/* @__PURE__ */ function() {
  return arguments;
}()) ? J2 : function(e) {
  return ji(e) && CC.call(e, "callee") && !OC.call(e, "callee");
}, jC = 9007199254740991, PC = /^(?:0|[1-9]\d*)$/;
function Wf(e, t) {
  var n = typeof e;
  return t = t ?? jC, !!t && (n == "number" || n != "symbol" && PC.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var LC = 9007199254740991;
function Ng(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= LC;
}
function jl(e) {
  if (typeof e == "string" || ds(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function lb(e, t, n) {
  t = au(t, e);
  for (var r = -1, i = t.length, a = !1; ++r < i; ) {
    var o = jl(t[r]);
    if (!(a = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return a || ++r != i ? a : (i = e == null ? 0 : e.length, !!i && Ng(i) && Wf(o, i) && (Rn(e) || Vf(e)));
}
function dm(e, t) {
  return e != null && lb(e, t, wE);
}
function cb(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function TC(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function ou(e, t) {
  t = au(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[jl(t[n++])];
  return n && n == r ? e : void 0;
}
function Hf(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var a = Array(i); ++r < i; )
    a[r] = e[r + t];
  return a;
}
function FC(e, t) {
  return t.length < 2 ? e : ou(e, Hf(t, 0, -1));
}
function IC(e, t, n) {
  t = au(t, e), e = FC(e, t);
  var r = e == null ? e : e[jl(TC(t))];
  return r == null ? void 0 : cb(r, e, n);
}
function Io(e) {
  return e;
}
var A2 = Math.max;
function ub(e, t, n) {
  return t = A2(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, a = A2(r.length - t, 0), o = Array(a); ++i < a; )
      o[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(o), cb(e, this, s);
  };
}
function db(e) {
  return function() {
    return e;
  };
}
var bf = function() {
  try {
    var e = bs(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), kC = bf ? function(e, t) {
  return bf(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: db(t),
    writable: !0
  });
} : Io, DC = 800, RC = 16, MC = Date.now;
function UC(e) {
  var t = 0, n = 0;
  return function() {
    var r = MC(), i = RC - (r - n);
    if (n = r, i > 0) {
      if (++t >= DC)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var fb = UC(kC);
function Pl(e, t) {
  return fb(ub(e, t, Io), e + "");
}
var Ze = Pl(IC);
function BC(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fm(e, t) {
  return fm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, fm(e, t);
}
function Sg(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, fm(e, t);
}
function pl(e) {
  return e === void 0;
}
function zC(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), e = e >= t ? e : t), e;
}
var qC = /\s/;
function VC(e) {
  for (var t = e.length; t-- && qC.test(e.charAt(t)); )
    ;
  return t;
}
var WC = /^\s+/;
function pb(e) {
  return e && e.slice(0, VC(e) + 1).replace(WC, "");
}
var e5 = NaN, HC = /^[-+]0x[0-9a-f]+$/i, $C = /^0b[01]+$/i, GC = /^0o[0-7]+$/i, QC = parseInt;
function hb(e) {
  if (typeof e == "number")
    return e;
  if (ds(e))
    return e5;
  if (Ta(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ta(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = pb(e);
  var n = $C.test(e);
  return n || GC.test(e) ? QC(e.slice(2), n ? 2 : 8) : HC.test(e) ? e5 : +e;
}
var YC = 1 / 0, KC = 17976931348623157e292;
function pm(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = hb(e), e === YC || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * KC;
  }
  return e === e ? e : 0;
}
function su(e) {
  var t = pm(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function XC(e, t, n) {
  return e = ws(e), n = n == null ? 0 : zC(su(n), 0, e.length), t = qf(t), e.slice(n, n + t.length) == t;
}
function mb(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (a[i++] = o);
  }
  return a;
}
function ZC(e) {
  return function(t, n, r) {
    for (var i = -1, a = Object(t), o = r(t), s = o.length; s--; ) {
      var l = o[++i];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var JC = ZC();
function AC(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function e8() {
  return !1;
}
var gb = typeof exports == "object" && exports && !exports.nodeType && exports, t5 = gb && typeof module == "object" && module && !module.nodeType && module, t8 = t5 && t5.exports === gb, n5 = t8 ? Ma.Buffer : void 0, n8 = n5 ? n5.isBuffer : void 0, wf = n8 || e8, r8 = "[object Arguments]", i8 = "[object Array]", a8 = "[object Boolean]", o8 = "[object Date]", s8 = "[object Error]", l8 = "[object Function]", c8 = "[object Map]", u8 = "[object Number]", d8 = "[object Object]", f8 = "[object RegExp]", p8 = "[object Set]", h8 = "[object String]", m8 = "[object WeakMap]", g8 = "[object ArrayBuffer]", y8 = "[object DataView]", v8 = "[object Float32Array]", b8 = "[object Float64Array]", w8 = "[object Int8Array]", x8 = "[object Int16Array]", _8 = "[object Int32Array]", N8 = "[object Uint8Array]", S8 = "[object Uint8ClampedArray]", E8 = "[object Uint16Array]", C8 = "[object Uint32Array]", Sn = {};
Sn[v8] = Sn[b8] = Sn[w8] = Sn[x8] = Sn[_8] = Sn[N8] = Sn[S8] = Sn[E8] = Sn[C8] = !0;
Sn[r8] = Sn[i8] = Sn[g8] = Sn[a8] = Sn[y8] = Sn[o8] = Sn[s8] = Sn[l8] = Sn[c8] = Sn[u8] = Sn[d8] = Sn[f8] = Sn[p8] = Sn[h8] = Sn[m8] = !1;
function O8(e) {
  return ji(e) && Ng(e.length) && !!Sn[ma(e)];
}
function yb(e) {
  return function(t) {
    return e(t);
  };
}
var vb = typeof exports == "object" && exports && !exports.nodeType && exports, Rc = vb && typeof module == "object" && module && !module.nodeType && module, j8 = Rc && Rc.exports === vb, Nh = j8 && ab.process, r5 = function() {
  try {
    var e = Rc && Rc.require && Rc.require("util").types;
    return e || Nh && Nh.binding && Nh.binding("util");
  } catch {
  }
}(), i5 = r5 && r5.isTypedArray, Eg = i5 ? yb(i5) : O8, P8 = Object.prototype, L8 = P8.hasOwnProperty;
function T8(e, t) {
  var n = Rn(e), r = !n && Vf(e), i = !n && !r && wf(e), a = !n && !r && !i && Eg(e), o = n || r || i || a, s = o ? AC(e.length, String) : [], l = s.length;
  for (var c in e)
    L8.call(e, c) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Wf(c, l))) && s.push(c);
  return s;
}
var F8 = Object.prototype;
function bb(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || F8;
  return e === n;
}
function wb(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var I8 = wb(Object.keys, Object), k8 = Object.prototype, D8 = k8.hasOwnProperty;
function Cg(e) {
  if (!bb(e))
    return I8(e);
  var t = [];
  for (var n in Object(e))
    D8.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function za(e) {
  return e != null && Ng(e.length) && !wl(e);
}
function Si(e) {
  return za(e) ? T8(e) : Cg(e);
}
function xb(e, t) {
  return e && JC(e, t, Si);
}
function R8(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!za(n))
      return e(n, r);
    for (var i = n.length, a = -1, o = Object(n); ++a < i && r(o[a], a, o) !== !1; )
      ;
    return n;
  };
}
var Ll = R8(xb);
function M8(e, t) {
  var n = [];
  return Ll(e, function(r, i, a) {
    t(r, i, a) && n.push(r);
  }), n;
}
function U8() {
  this.__data__ = new Ua(), this.size = 0;
}
function B8(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function z8(e) {
  return this.__data__.get(e);
}
function q8(e) {
  return this.__data__.has(e);
}
var V8 = 200;
function W8(e, t) {
  var n = this.__data__;
  if (n instanceof Ua) {
    var r = n.__data__;
    if (!Yc || r.length < V8 - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Ba(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Pa(e) {
  var t = this.__data__ = new Ua(e);
  this.size = t.size;
}
Pa.prototype.clear = U8;
Pa.prototype.delete = B8;
Pa.prototype.get = z8;
Pa.prototype.has = q8;
Pa.prototype.set = W8;
var H8 = "__lodash_hash_undefined__";
function $8(e) {
  return this.__data__.set(e, H8), this;
}
function G8(e) {
  return this.__data__.has(e);
}
function ps(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Ba(); ++t < n; )
    this.add(e[t]);
}
ps.prototype.add = ps.prototype.push = $8;
ps.prototype.has = G8;
function _b(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function Kc(e, t) {
  return e.has(t);
}
var Q8 = 1, Y8 = 2;
function Nb(e, t, n, r, i, a) {
  var o = n & Q8, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = a.get(e), d = a.get(t);
  if (c && d)
    return c == t && d == e;
  var p = -1, y = !0, f = n & Y8 ? new ps() : void 0;
  for (a.set(e, t), a.set(t, e); ++p < s; ) {
    var N = e[p], b = t[p];
    if (r)
      var S = o ? r(b, N, p, t, e, a) : r(N, b, p, e, t, a);
    if (S !== void 0) {
      if (S)
        continue;
      y = !1;
      break;
    }
    if (f) {
      if (!_b(t, function(_, E) {
        if (!Kc(f, E) && (N === _ || i(N, _, n, r, a)))
          return f.push(E);
      })) {
        y = !1;
        break;
      }
    } else if (!(N === b || i(N, b, n, r, a))) {
      y = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), y;
}
var a5 = Ma.Uint8Array;
function K8(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function Og(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var X8 = 1, Z8 = 2, J8 = "[object Boolean]", A8 = "[object Date]", e7 = "[object Error]", t7 = "[object Map]", n7 = "[object Number]", r7 = "[object RegExp]", i7 = "[object Set]", a7 = "[object String]", o7 = "[object Symbol]", s7 = "[object ArrayBuffer]", l7 = "[object DataView]", o5 = la ? la.prototype : void 0, Sh = o5 ? o5.valueOf : void 0;
function c7(e, t, n, r, i, a, o) {
  switch (n) {
    case l7:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case s7:
      return !(e.byteLength != t.byteLength || !a(new a5(e), new a5(t)));
    case J8:
    case A8:
    case n7:
      return Uf(+e, +t);
    case e7:
      return e.name == t.name && e.message == t.message;
    case r7:
    case a7:
      return e == t + "";
    case t7:
      var s = K8;
    case i7:
      var l = r & X8;
      if (s || (s = Og), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      r |= Z8, o.set(e, t);
      var d = Nb(s(e), s(t), r, i, a, o);
      return o.delete(e), d;
    case o7:
      if (Sh)
        return Sh.call(e) == Sh.call(t);
  }
  return !1;
}
function Sb(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
function u7(e, t, n) {
  var r = t(e);
  return Rn(e) ? r : Sb(r, n(e));
}
function d7() {
  return [];
}
var f7 = Object.prototype, p7 = f7.propertyIsEnumerable, s5 = Object.getOwnPropertySymbols, h7 = s5 ? function(e) {
  return e == null ? [] : (e = Object(e), mb(s5(e), function(t) {
    return p7.call(e, t);
  }));
} : d7;
function l5(e) {
  return u7(e, Si, h7);
}
var m7 = 1, g7 = Object.prototype, y7 = g7.hasOwnProperty;
function v7(e, t, n, r, i, a) {
  var o = n & m7, s = l5(e), l = s.length, c = l5(t), d = c.length;
  if (l != d && !o)
    return !1;
  for (var p = l; p--; ) {
    var y = s[p];
    if (!(o ? y in t : y7.call(t, y)))
      return !1;
  }
  var f = a.get(e), N = a.get(t);
  if (f && N)
    return f == t && N == e;
  var b = !0;
  a.set(e, t), a.set(t, e);
  for (var S = o; ++p < l; ) {
    y = s[p];
    var _ = e[y], E = t[y];
    if (r)
      var k = o ? r(E, _, y, t, e, a) : r(_, E, y, e, t, a);
    if (!(k === void 0 ? _ === E || i(_, E, n, r, a) : k)) {
      b = !1;
      break;
    }
    S || (S = y == "constructor");
  }
  if (b && !S) {
    var M = e.constructor, F = t.constructor;
    M != F && "constructor" in e && "constructor" in t && !(typeof M == "function" && M instanceof M && typeof F == "function" && F instanceof F) && (b = !1);
  }
  return a.delete(e), a.delete(t), b;
}
var hm = bs(Ma, "DataView"), mm = bs(Ma, "Promise"), hl = bs(Ma, "Set"), gm = bs(Ma, "WeakMap"), c5 = "[object Map]", b7 = "[object Object]", u5 = "[object Promise]", d5 = "[object Set]", f5 = "[object WeakMap]", p5 = "[object DataView]", w7 = vs(hm), x7 = vs(Yc), _7 = vs(mm), N7 = vs(hl), S7 = vs(gm), na = ma;
(hm && na(new hm(new ArrayBuffer(1))) != p5 || Yc && na(new Yc()) != c5 || mm && na(mm.resolve()) != u5 || hl && na(new hl()) != d5 || gm && na(new gm()) != f5) && (na = function(e) {
  var t = ma(e), n = t == b7 ? e.constructor : void 0, r = n ? vs(n) : "";
  if (r)
    switch (r) {
      case w7:
        return p5;
      case x7:
        return c5;
      case _7:
        return u5;
      case N7:
        return d5;
      case S7:
        return f5;
    }
  return t;
});
var E7 = 1, h5 = "[object Arguments]", m5 = "[object Array]", Rd = "[object Object]", C7 = Object.prototype, g5 = C7.hasOwnProperty;
function O7(e, t, n, r, i, a) {
  var o = Rn(e), s = Rn(t), l = o ? m5 : na(e), c = s ? m5 : na(t);
  l = l == h5 ? Rd : l, c = c == h5 ? Rd : c;
  var d = l == Rd, p = c == Rd, y = l == c;
  if (y && wf(e)) {
    if (!wf(t))
      return !1;
    o = !0, d = !1;
  }
  if (y && !d)
    return a || (a = new Pa()), o || Eg(e) ? Nb(e, t, n, r, i, a) : c7(e, t, l, n, r, i, a);
  if (!(n & E7)) {
    var f = d && g5.call(e, "__wrapped__"), N = p && g5.call(t, "__wrapped__");
    if (f || N) {
      var b = f ? e.value() : e, S = N ? t.value() : t;
      return a || (a = new Pa()), i(b, S, n, r, a);
    }
  }
  return y ? (a || (a = new Pa()), v7(e, t, n, r, i, a)) : !1;
}
function $f(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !ji(e) && !ji(t) ? e !== e && t !== t : O7(e, t, n, r, $f, i);
}
var j7 = 1, P7 = 2;
function L7(e, t, n, r) {
  var i = n.length, a = i;
  if (e == null)
    return !a;
  for (e = Object(e); i--; ) {
    var o = n[i];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++i < a; ) {
    o = n[i];
    var s = o[0], l = e[s], c = o[1];
    if (o[2]) {
      if (l === void 0 && !(s in e))
        return !1;
    } else {
      var d = new Pa(), p;
      if (!(p === void 0 ? $f(c, l, j7 | P7, r, d) : p))
        return !1;
    }
  }
  return !0;
}
function Eb(e) {
  return e === e && !Ta(e);
}
function T7(e) {
  for (var t = Si(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, Eb(i)];
  }
  return t;
}
function Cb(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function F7(e) {
  var t = T7(e);
  return t.length == 1 && t[0][2] ? Cb(t[0][0], t[0][1]) : function(n) {
    return n === e || L7(n, e, t);
  };
}
function Hi(e, t, n) {
  var r = e == null ? void 0 : ou(e, t);
  return r === void 0 ? n : r;
}
function I7(e, t) {
  return e != null && t in Object(e);
}
function Ob(e, t) {
  return e != null && lb(e, t, I7);
}
var k7 = 1, D7 = 2;
function R7(e, t) {
  return _g(e) && Eb(t) ? Cb(jl(e), t) : function(n) {
    var r = Hi(n, e);
    return r === void 0 && r === t ? Ob(n, e) : $f(t, r, k7 | D7);
  };
}
function jb(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function M7(e) {
  return function(t) {
    return ou(t, e);
  };
}
function U7(e) {
  return _g(e) ? jb(jl(e)) : M7(e);
}
function ko(e) {
  return typeof e == "function" ? e : e == null ? Io : typeof e == "object" ? Rn(e) ? R7(e[0], e[1]) : F7(e) : U7(e);
}
function ym(e, t) {
  var n = Rn(e) ? mb : M8;
  return n(e, ko(t));
}
var B7 = "[object Map]", z7 = "[object Set]", q7 = Object.prototype, V7 = q7.hasOwnProperty;
function al(e) {
  if (e == null)
    return !0;
  if (za(e) && (Rn(e) || typeof e == "string" || typeof e.splice == "function" || wf(e) || Eg(e) || Vf(e)))
    return !e.length;
  var t = na(e);
  if (t == B7 || t == z7)
    return !e.size;
  if (bb(e))
    return !Cg(e).length;
  for (var n in e)
    if (V7.call(e, n))
      return !1;
  return !0;
}
function Pb(e, t, n, r) {
  for (var i = e.length, a = n + -1; ++a < i; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
function W7(e) {
  return e !== e;
}
function H7(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
function Gf(e, t, n) {
  return t === t ? H7(e, t, n) : Pb(e, W7, n);
}
function jg(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && Gf(e, t, 0) > -1;
}
var $7 = Math.min;
function G7(e, t, n) {
  for (var r = jg, i = e[0].length, a = e.length, o = a, s = Array(a), l = 1 / 0, c = []; o--; ) {
    var d = e[o];
    l = $7(d.length, l), s[o] = i >= 120 && d.length >= 120 ? new ps(o && d) : void 0;
  }
  d = e[0];
  var p = -1, y = s[0];
  e:
    for (; ++p < i && c.length < l; ) {
      var f = d[p], N = f;
      if (f = f !== 0 ? f : 0, !(y ? Kc(y, N) : r(c, N))) {
        for (o = a; --o; ) {
          var b = s[o];
          if (!(b ? Kc(b, N) : r(e[o], N)))
            continue e;
        }
        y && y.push(N), c.push(f);
      }
    }
  return c;
}
function Xc(e) {
  return ji(e) && za(e);
}
function Q7(e) {
  return Xc(e) ? e : [];
}
var Y7 = Pl(function(e) {
  var t = os(e, Q7);
  return t.length && t[0] === e[0] ? G7(t) : [];
});
function K7(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function X7(e) {
  return typeof e == "function" ? e : Io;
}
function Lb(e, t) {
  var n = Rn(e) ? K7 : Ll;
  return n(e, X7(t));
}
var vm = function(e) {
  return "default" + (e[0].toUpperCase() + e.slice(1));
}, Z7 = function(e, t, n, r) {
  var i = t[e];
  if (i !== void 0) return i;
  {
    var a = t[vm(e)];
    if (a !== void 0) return a;
    {
      var o = n[e];
      if (o !== void 0) return o;
    }
  }
  if (e === "checked") return !1;
  if (e === "value") return t.multiple ? [] : "";
}, J7 = /* @__PURE__ */ function(e) {
  Sg(t, e);
  function t() {
    for (var n, r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    n = e.call.apply(e, [this].concat(i)) || this;
    var o = n.constructor, s = o.autoControlledProps, l = o.getAutoControlledStateFromProps, c = Ze(BC(n), "getInitialAutoControlledState", n.props) || {};
    if (process.env.NODE_ENV !== "production") {
      var d = n.constructor, p = d.defaultProps, y = d.name, f = d.propTypes, N = d.getDerivedStateFromProps;
      N !== t.getDerivedStateFromProps && console.error("Auto controlled " + y + " must specify a static getAutoControlledStateFromProps() instead of getDerivedStateFromProps()."), Lb(s, function(E) {
        var k = vm(E);
        dm(f, k) || console.error(y + ' is missing "' + k + '" propTypes validation for auto controlled prop "' + E + '".'), dm(f, E) || console.error(y + ' is missing propTypes validation for auto controlled prop "' + E + '".');
      });
      var b = Y7(s, Si(p));
      al(b) || console.error(["Do not set defaultProps for autoControlledProps. You can set defaults by", "setting state in the constructor or using an ES7 property initializer", "(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)", "See " + y + ' props: "' + b + '".'].join(" "));
      var S = ym(s, function(E) {
        return XC(E, "default");
      });
      al(S) || console.error(["Do not add default props to autoControlledProps.", "Default props are automatically handled.", "See " + y + ' autoControlledProps: "' + S + '".'].join(" "));
    }
    var _ = s.reduce(function(E, k) {
      if (E[k] = Z7(k, n.props, c), process.env.NODE_ENV !== "production") {
        var M = vm(k), F = n.constructor.name;
        !pl(n.props[M]) && !pl(n.props[k]) && console.error(F + ' prop "' + k + '" is auto controlled. Specify either ' + M + " or " + k + ", but not both.");
      }
      return E;
    }, {});
    return n.state = Pe({}, c, _, {
      autoControlledProps: s,
      getAutoControlledStateFromProps: l
    }), n;
  }
  return t.getDerivedStateFromProps = function(n, r) {
    var i = r.autoControlledProps, a = r.getAutoControlledStateFromProps, o = i.reduce(function(l, c) {
      var d = !pl(n[c]);
      return d && (l[c] = n[c]), l;
    }, {});
    if (a) {
      var s = a(n, Pe({}, r, o), r);
      return Pe({}, o, s);
    }
    return o;
  }, t.getAutoControlledStateFromProps = function() {
    return null;
  }, t;
}(R.Component);
function A7(e) {
  return function(t, n, r) {
    var i = Object(t);
    if (!za(t)) {
      var a = ko(n);
      t = Si(t), n = function(s) {
        return a(i[s], s, i);
      };
    }
    var o = e(t, n, r);
    return o > -1 ? i[a ? t[o] : o] : void 0;
  };
}
var eO = Math.max;
function bm(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : su(n);
  return i < 0 && (i = eO(r + i, 0)), Pb(e, ko(t), i);
}
var Tb = A7(bm);
function tO(e, t) {
  var n;
  return Ll(e, function(r, i, a) {
    return n = t(r, i, a), !n;
  }), !!n;
}
function y5(e, t, n) {
  if (!Ta(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? za(n) && Wf(t, n.length) : r == "string" && t in n) ? Uf(n[t], e) : !1;
}
function Mc(e, t, n) {
  var r = Rn(e) ? _b : tO;
  return r(e, ko(t));
}
var nO = function(e, t) {
  return Mc(K0.toArray(e), {
    type: t
  });
}, vt = function(e) {
  return e == null || Array.isArray(e) && e.length === 0;
}, of = {
  1: "one",
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine",
  10: "ten",
  11: "eleven",
  12: "twelve",
  13: "thirteen",
  14: "fourteen",
  15: "fifteen",
  16: "sixteen"
};
function v5(e) {
  var t = typeof e;
  return t === "string" || t === "number" ? of[e] || e : "";
}
var ue = function(e, t) {
  return e && t;
}, Dr = function(e, t) {
  return e && e !== !0 && e + " " + t;
}, mn = function(e, t) {
  return e && (e === !0 ? t : e + " " + t);
}, xf = function(e, t) {
  return !e || e === !0 ? null : e.replace("large screen", "large-screen").replace(/ vertically/g, "-vertically").split(" ").map(function(n) {
    return n.replace("-", " ") + " " + t;
  }).join(" ");
}, Do = function(e) {
  return e === "justified" ? "justified" : Dr(e, "aligned");
}, Ro = function(e) {
  return Dr(e, "aligned");
}, kr = function(e, t, n) {
  if (t === void 0 && (t = ""), n === void 0 && (n = !1), n && e === "equal")
    return "equal width";
  var r = typeof e;
  return (r === "string" || r === "number") && t ? v5(e) + " " + t : v5(e);
}, rO = 200;
function Fb(e, t, n, r) {
  var i = -1, a = jg, o = !0, s = e.length, l = [], c = t.length;
  if (!s)
    return l;
  t.length >= rO && (a = Kc, o = !1, t = new ps(t));
  e:
    for (; ++i < s; ) {
      var d = e[i], p = d;
      if (d = d !== 0 ? d : 0, o && p === p) {
        for (var y = c; y--; )
          if (t[y] === p)
            continue e;
        l.push(d);
      } else a(t, p, r) || l.push(d);
    }
  return l;
}
var b5 = la ? la.isConcatSpreadable : void 0;
function iO(e) {
  return Rn(e) || Vf(e) || !!(b5 && e && e[b5]);
}
function Qf(e, t, n, r, i) {
  var a = -1, o = e.length;
  for (n || (n = iO), i || (i = []); ++a < o; ) {
    var s = e[a];
    n(s) ? Sb(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var wm = Pl(function(e, t) {
  return Xc(e) ? Fb(e, Qf(t, 1, Xc, !0)) : [];
});
function Ib(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Hf(e, t, n);
}
function aO(e, t) {
  for (var n = e.length; n-- && Gf(t, e[n], 0) > -1; )
    ;
  return n;
}
function oO(e, t) {
  for (var n = -1, r = e.length; ++n < r && Gf(t, e[n], 0) > -1; )
    ;
  return n;
}
function sO(e) {
  return e.split("");
}
var lO = "\\ud800-\\udfff", cO = "\\u0300-\\u036f", uO = "\\ufe20-\\ufe2f", dO = "\\u20d0-\\u20ff", fO = cO + uO + dO, pO = "\\ufe0e\\ufe0f", hO = "\\u200d", mO = RegExp("[" + hO + lO + fO + pO + "]");
function Pg(e) {
  return mO.test(e);
}
var kb = "\\ud800-\\udfff", gO = "\\u0300-\\u036f", yO = "\\ufe20-\\ufe2f", vO = "\\u20d0-\\u20ff", bO = gO + yO + vO, wO = "\\ufe0e\\ufe0f", xO = "[" + kb + "]", xm = "[" + bO + "]", _m = "\\ud83c[\\udffb-\\udfff]", _O = "(?:" + xm + "|" + _m + ")", Db = "[^" + kb + "]", Rb = "(?:\\ud83c[\\udde6-\\uddff]){2}", Mb = "[\\ud800-\\udbff][\\udc00-\\udfff]", NO = "\\u200d", Ub = _O + "?", Bb = "[" + wO + "]?", SO = "(?:" + NO + "(?:" + [Db, Rb, Mb].join("|") + ")" + Bb + Ub + ")*", EO = Bb + Ub + SO, CO = "(?:" + [Db + xm + "?", xm, Rb, Mb, xO].join("|") + ")", OO = RegExp(_m + "(?=" + _m + ")|" + CO + EO, "g");
function jO(e) {
  return e.match(OO) || [];
}
function Nm(e) {
  return Pg(e) ? jO(e) : sO(e);
}
function PO(e, t, n) {
  if (e = ws(e), e && t === void 0)
    return pb(e);
  if (!e || !(t = qf(t)))
    return e;
  var r = Nm(e), i = Nm(t), a = oO(r, i), o = aO(r, i) + 1;
  return Ib(r, a, o).join("");
}
function LO(e, t, n) {
  t == "__proto__" && bf ? bf(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var TO = Object.prototype, FO = TO.hasOwnProperty;
function IO(e, t, n) {
  var r = e[t];
  (!(FO.call(e, t) && Uf(r, n)) || n === void 0 && !(t in e)) && LO(e, t, n);
}
function kO(e, t, n, r) {
  if (!Ta(e))
    return e;
  t = au(t, e);
  for (var i = -1, a = t.length, o = a - 1, s = e; s != null && ++i < a; ) {
    var l = jl(t[i]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (i != o) {
      var d = s[l];
      c = void 0, c === void 0 && (c = Ta(d) ? d : Wf(t[i + 1]) ? [] : {});
    }
    IO(s, l, c), s = s[l];
  }
  return e;
}
function DO(e, t, n) {
  for (var r = -1, i = t.length, a = {}; ++r < i; ) {
    var o = t[r], s = ou(e, o);
    n(s, o) && kO(a, au(o, e), s);
  }
  return a;
}
function RO(e, t) {
  return DO(e, t, function(n, r) {
    return Ob(e, r);
  });
}
function MO(e) {
  var t = e == null ? 0 : e.length;
  return t ? Qf(e) : [];
}
function UO(e) {
  return fb(ub(e, void 0, MO), e + "");
}
var Yf = UO(function(e, t) {
  return e == null ? {} : RO(e, t);
}), BO = wb(Object.getPrototypeOf, Object), zO = "[object Object]", qO = Function.prototype, VO = Object.prototype, zb = qO.toString, WO = VO.hasOwnProperty, HO = zb.call(Object);
function Kf(e) {
  if (!ji(e) || ma(e) != zO)
    return !1;
  var t = BO(e);
  if (t === null)
    return !0;
  var n = WO.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && zb.call(n) == HO;
}
function Tt(e) {
  return e == null;
}
function $O(e, t, n) {
  for (var r = -1, i = e.length; ++r < i; ) {
    var a = e[r], o = t(a);
    if (o != null && (s === void 0 ? o === o && !ds(o) : n(o, s)))
      var s = o, l = a;
  }
  return l;
}
function GO(e, t) {
  return e < t;
}
function w5(e) {
  return e && e.length ? $O(e, Io, GO) : void 0;
}
function QO(e, t) {
  for (var n, r = -1, i = e.length; ++r < i; ) {
    var a = t(e[r]);
    a !== void 0 && (n = n === void 0 ? a : n + a);
  }
  return n;
}
function x5(e) {
  return e && e.length ? QO(e, Io) : 0;
}
function qb(e, t) {
  var n = -1, r = za(e) ? Array(e.length) : [];
  return Ll(e, function(i, a, o) {
    r[++n] = t(i, a, o);
  }), r;
}
function Hn(e, t) {
  var n = Rn(e) ? os : qb;
  return n(e, ko(t));
}
function YO(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
function KO(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, a = ds(e), o = t !== void 0, s = t === null, l = t === t, c = ds(t);
    if (!s && !c && !a && e > t || a && o && l && !s && !c || r && o && l || !n && l || !i)
      return 1;
    if (!r && !a && !c && e < t || c && n && i && !r && !a || s && n && i || !o && i || !l)
      return -1;
  }
  return 0;
}
function XO(e, t, n) {
  for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o; ) {
    var l = KO(i[r], a[r]);
    if (l) {
      if (r >= s)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
function ZO(e, t, n) {
  t.length ? t = os(t, function(a) {
    return Rn(a) ? function(o) {
      return ou(o, a.length === 1 ? a[0] : a);
    } : a;
  }) : t = [Io];
  var r = -1;
  t = os(t, yb(ko));
  var i = qb(e, function(a, o, s) {
    var l = os(t, function(c) {
      return c(a);
    });
    return { criteria: l, index: ++r, value: a };
  });
  return YO(i, function(a, o) {
    return XO(a, o, n);
  });
}
var JO = Pl(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && y5(e, t[0], t[1]) ? t = [] : n > 2 && y5(t[0], t[1], t[2]) && (t = [t[0]]), ZO(e, Qf(t), []);
});
function AO(e, t, n) {
  return e && e.length ? (t = t === void 0 ? 1 : su(t), Hf(e, 0, t < 0 ? 0 : t)) : [];
}
var Sm = function() {
  return 0;
};
if (process.env.NODE_ENV !== "production") {
  var Eh = [], _5 = [];
  Sm = function(e, t) {
    if (e === t) return 0;
    var n = e.length, r = t.length;
    if (n === 0) return r;
    if (r === 0) return n;
    for (var i, a, o, s, l = 0, c = 0; l < n; )
      _5[l] = e.charCodeAt(l), Eh[l] = ++l;
    for (; c < r; )
      for (i = t.charCodeAt(c), o = c++, a = c, l = 0; l < n; l++)
        s = i === _5[l] ? o : o + 1, o = Eh[l], a = Eh[l] = o > a ? s > a ? a + 1 : s : s > o ? o + 1 : s;
    return a;
  };
}
var ej = function() {
  var e;
  return (e = Object.prototype.toString).call.apply(e, arguments);
}, Vb = function(e) {
  if (!Array.isArray(e))
    throw new Error("Invalid argument supplied to suggest, expected an instance of array.");
  var t = iu(function(r) {
    var i = r.split(" ");
    return AO(JO(Hn(e, function(a) {
      var o = a.split(" "), s = x5(Hn(Hn(i, function(c) {
        return Hn(o, function(d) {
          return Sm(c, d);
        });
      }), w5)), l = x5(Hn(Hn(o, function(c) {
        return Hn(i, function(d) {
          return Sm(c, d);
        });
      }), w5));
      return {
        suggestion: a,
        score: s + l
      };
    }), ["score", "suggestion"]), 3);
  }), n = e.reduce(function(r, i) {
    return r[i.split(" ").sort().join(" ")] = !0, r;
  }, {});
  return function(r, i, a) {
    var o = r[i];
    if (!(!o || n[o])) {
      var s = o.split(" ").sort().join(" ");
      if (!n[s]) {
        var l = t(o);
        if (!l.some(function(c) {
          return c.score === 0;
        }))
          return new Error(["Invalid prop `" + i + "` of value `" + o + "` supplied to `" + a + "`.", `

Instead of \`` + o + "`, did you mean:", l.map(function(c) {
            return `
  - ` + c.suggestion;
          }).join(""), `
`].join(""));
      }
    }
  };
}, Jt = function(e) {
  return function(t, n, r) {
    if (!Array.isArray(e))
      throw new Error(["Invalid argument supplied to disallow, expected an instance of array.", " See `" + n + "` prop in `" + r + "`."].join(""));
    if (!(Tt(t[n]) || t[n] === !1)) {
      var i = e.reduce(function(a, o) {
        return !Tt(t[o]) && t[o] !== !1 ? [].concat(a, [o]) : a;
      }, []);
      if (i.length > 0)
        return new Error(["Prop `" + n + "` in `" + r + "` conflicts with props: `" + i.join("`, `") + "`.", "They cannot be defined together, choose one or the other."].join(" "));
    }
  };
}, qt = function(e) {
  return function(t, n, r) {
    for (var i = arguments.length, a = new Array(i > 3 ? i - 3 : 0), o = 3; o < i; o++)
      a[o - 3] = arguments[o];
    if (!Array.isArray(e))
      throw new Error(["Invalid argument supplied to every, expected an instance of array.", "See `" + n + "` prop in `" + r + "`."].join(" "));
    var s = [];
    return e.forEach(function(l) {
      if (typeof l != "function")
        throw new Error('every() argument "validators" should contain functions, found: ' + ej(l) + ".");
      var c = l.apply(void 0, [t, n, r].concat(a));
      c && s.push(c);
    }), s[0];
  };
}, Wb = function(e, t) {
  return function(n, r, i) {
    for (var a = arguments.length, o = new Array(a > 3 ? a - 3 : 0), s = 3; s < a; s++)
      o[s - 3] = arguments[s];
    if (!Kf(e))
      throw new Error(["Invalid argument supplied to givenProps, expected an object.", "See `" + r + "` prop in `" + i + "`."].join(" "));
    if (typeof t != "function")
      throw new Error(["Invalid argument supplied to givenProps, expected a function.", "See `" + r + "` prop in `" + i + "`."].join(" "));
    var l = Si(e).every(function(p) {
      var y = e[p];
      return typeof y == "function" ? !y.apply(void 0, [n, p, i].concat(o)) : y === n[r];
    });
    if (l) {
      var c = t.apply(void 0, [n, r, i].concat(o));
      if (c) {
        var d = "{ " + Si(Yf(Si(e), n)).map(function(p) {
          var y = n[p], f = y;
          return typeof y == "string" ? f = '"' + y + '"' : Array.isArray(y) ? f = "[" + y.join(", ") + "]" : Ta(y) && (f = "{...}"), p + ": " + f;
        }).join(", ") + " }";
        return c.message = "Given props " + d + ": " + c.message, c;
      }
    }
  };
}, oo = function(e) {
  return function(t, n, r) {
    if (!Array.isArray(e))
      throw new Error(["Invalid `requiredProps` argument supplied to require, expected an instance of array.", " See `" + n + "` prop in `" + r + "`."].join(""));
    if (t[n] !== void 0) {
      var i = e.filter(function(a) {
        return t[a] === void 0;
      });
      if (i.length > 0)
        return new Error("`" + n + "` prop in `" + r + "` requires props: `" + i.join("`, `") + "`.");
    }
  };
}, _f = function(e) {
  return function(t, n, r) {
    if (!Array.isArray(e))
      throw new Error(["Invalid argument supplied to some, expected an instance of array.", "See `" + n + "` prop in `" + r + "`."].join(" "));
    var i = t[n];
    if (!(Tt(i) || i === !1)) {
      var a = i.replace("large screen", "large-screen").replace(/ vertically/g, "-vertically").split(" ").map(function(s) {
        return PO(s).replace("-", " ");
      }), o = wm(a, e);
      if (o.length > 0)
        return new Error("`" + n + "` prop in `" + r + "` has invalid values: `" + o.join("`, `") + "`.");
    }
  };
}, Lt = function() {
  return qt([Jt(["children"]), g.node]).apply(void 0, arguments);
}, kt = function() {
  return qt([Jt(["children"]), g.oneOfType([g.func, g.node, g.object, g.arrayOf(g.oneOfType([g.node, g.object]))])]).apply(void 0, arguments);
}, xs = function() {
  return qt([Jt(["children"]), g.arrayOf(kt)]).apply(void 0, arguments);
}, Hb = g.shape({
  current: g.object
}), tj = g.oneOfType([g.func, Hb]), Lg = { exports: {} }, yc = {}, N5 = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var S5;
function $b() {
  return S5 || (S5 = 1, function(e) {
    (function() {
      var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
        canUseDOM: t,
        canUseWorkers: typeof Worker < "u",
        canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
        canUseViewport: t && !!window.screen
      };
      e.exports ? e.exports = n : window.ExecutionEnvironment = n;
    })();
  }(N5)), N5.exports;
}
var E5;
function nj() {
  if (E5) return yc;
  E5 = 1, Object.defineProperty(yc, "__esModule", { value: !0 });
  var e = $b(), t = gt;
  function n(q) {
    return (n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
      return typeof j;
    } : function(j) {
      return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
    })(q);
  }
  function r(q, j) {
    if (!(q instanceof j)) throw new TypeError("Cannot call a class as a function");
  }
  function i(q, j) {
    for (var x = 0; x < j.length; x++) {
      var C = j[x];
      C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(q, C.key, C);
    }
  }
  function a(q, j, x) {
    return j && i(q.prototype, j), q;
  }
  function o(q, j, x) {
    return j in q ? Object.defineProperty(q, j, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : q[j] = x, q;
  }
  function s(q, j) {
    if (typeof j != "function" && j !== null) throw new TypeError("Super expression must either be null or a function");
    q.prototype = Object.create(j && j.prototype, { constructor: { value: q, writable: !0, configurable: !0 } }), j && c(q, j);
  }
  function l(q) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(j) {
      return j.__proto__ || Object.getPrototypeOf(j);
    })(q);
  }
  function c(q, j) {
    return (c = Object.setPrototypeOf || function(x, C) {
      return x.__proto__ = C, x;
    })(q, j);
  }
  function d(q) {
    if (q === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return q;
  }
  function p(q, j) {
    return !j || typeof j != "object" && typeof j != "function" ? d(q) : j;
  }
  var y = function() {
    function q(j) {
      r(this, q), o(this, "handlers", void 0), this.handlers = j.slice(0);
    }
    return a(q, [{ key: "addHandlers", value: function(j) {
      for (var x = this.handlers.slice(0), C = j.length, D = 0; D < C; D += 1) x.push(j[D]);
      return new q(x);
    } }, { key: "dispatchEvent", value: function(j, x) {
      var C = this.handlers.length - 1;
      if (x) {
        for (var D = C; D >= 0; D -= 1) this.handlers[D].called || (this.handlers[D].called = !0, this.handlers[D](j));
        for (var P = C; P >= 0; P -= 1) this.handlers[P].called = !1;
      } else
        (0, this.handlers[C])(j);
    } }, { key: "hasHandlers", value: function() {
      return this.handlers.length > 0;
    } }, { key: "removeHandlers", value: function(j) {
      for (var x = [], C = this.handlers.length, D = 0; D < C; D += 1) {
        var P = this.handlers[D];
        j.indexOf(P) === -1 && x.push(P);
      }
      return new q(x);
    } }]), q;
  }();
  function f(q) {
    var j = /* @__PURE__ */ new Map();
    return q.forEach(function(x, C) {
      j.set(C, x);
    }), j;
  }
  function N(q) {
    return Array.isArray(q) ? q : [q];
  }
  var b = function(q) {
    return q !== null && n(q) === "object" && q.hasOwnProperty("current");
  };
  function S(q) {
    return q === "document" ? document : q === "window" ? window : b(q) ? q.current || document : q || document;
  }
  var _ = function() {
    function q(j, x) {
      r(this, q), o(this, "handlerSets", void 0), o(this, "poolName", void 0), this.handlerSets = x, this.poolName = j;
    }
    return a(q, [{ key: "addHandlers", value: function(j, x) {
      var C = f(this.handlerSets);
      if (C.has(j)) {
        var D = C.get(j);
        C.set(j, D.addHandlers(x));
      } else C.set(j, new y(x));
      return new q(this.poolName, C);
    } }, { key: "dispatchEvent", value: function(j, x) {
      var C = this.handlerSets.get(j), D = this.poolName === "default";
      C && C.dispatchEvent(x, D);
    } }, { key: "hasHandlers", value: function(j) {
      if (!j) return this.handlerSets.size > 0;
      var x = this.handlerSets.get(j);
      return !!x && x.hasHandlers();
    } }, { key: "removeHandlers", value: function(j, x) {
      var C = f(this.handlerSets);
      if (!C.has(j)) return new q(this.poolName, C);
      var D = C.get(j).removeHandlers(x);
      return D.hasHandlers() ? C.set(j, D) : C.delete(j), new q(this.poolName, C);
    } }]), q;
  }();
  o(_, "createByType", function(q, j, x) {
    var C = /* @__PURE__ */ new Map();
    return C.set(j, new y(x)), new _(q, C);
  });
  var E = function() {
    function q(j) {
      var x = this;
      r(this, q), o(this, "handlers", /* @__PURE__ */ new Map()), o(this, "pools", /* @__PURE__ */ new Map()), o(this, "target", void 0), o(this, "createEmitter", function(C) {
        return function(D) {
          x.pools.forEach(function(P) {
            P.dispatchEvent(C, D);
          });
        };
      }), this.target = j;
    }
    return a(q, [{ key: "addHandlers", value: function(j, x, C) {
      if (this.pools.has(j)) {
        var D = this.pools.get(j);
        this.pools.set(j, D.addHandlers(x, C));
      } else this.pools.set(j, _.createByType(j, x, C));
      this.handlers.has(x) || this.addTargetHandler(x);
    } }, { key: "hasHandlers", value: function() {
      return this.handlers.size > 0;
    } }, { key: "removeHandlers", value: function(j, x, C) {
      if (this.pools.has(j)) {
        var D = this.pools.get(j).removeHandlers(x, C);
        D.hasHandlers() ? this.pools.set(j, D) : this.pools.delete(j);
        var P = !1;
        this.pools.forEach(function(L) {
          return P = P || L.hasHandlers(x);
        }), P || this.removeTargetHandler(x);
      }
    } }, { key: "addTargetHandler", value: function(j) {
      var x = this.createEmitter(j);
      this.handlers.set(j, x), this.target.addEventListener(j, x, !0);
    } }, { key: "removeTargetHandler", value: function(j) {
      this.handlers.has(j) && (this.target.removeEventListener(j, this.handlers.get(j), !0), this.handlers.delete(j));
    } }]), q;
  }(), k = function() {
    function q() {
      var j = this;
      r(this, q), o(this, "targets", /* @__PURE__ */ new Map()), o(this, "getTarget", function(x) {
        var C = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], D = S(x);
        if (j.targets.has(D)) return j.targets.get(D);
        if (!C) return null;
        var P = new E(D);
        return j.targets.set(D, P), P;
      }), o(this, "removeTarget", function(x) {
        j.targets.delete(S(x));
      });
    }
    return a(q, [{ key: "sub", value: function(j, x) {
      var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (e.canUseDOM) {
        var D = C.target, P = D === void 0 ? document : D, L = C.pool, H = L === void 0 ? "default" : L;
        this.getTarget(P).addHandlers(H, j, N(x));
      }
    } }, { key: "unsub", value: function(j, x) {
      var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (e.canUseDOM) {
        var D = C.target, P = D === void 0 ? document : D, L = C.pool, H = L === void 0 ? "default" : L, $ = this.getTarget(P, !1);
        $ && ($.removeHandlers(H, j, N(x)), $.hasHandlers() || this.removeTarget(P));
      }
    } }]), q;
  }(), M = new k(), F = function(q) {
    function j() {
      return r(this, j), p(this, l(j).apply(this, arguments));
    }
    return s(j, t.PureComponent), a(j, [{ key: "componentDidMount", value: function() {
      this.subscribe(this.props);
    } }, { key: "componentDidUpdate", value: function(x) {
      this.unsubscribe(x), this.subscribe(this.props);
    } }, { key: "componentWillUnmount", value: function() {
      this.unsubscribe(this.props);
    } }, { key: "subscribe", value: function(x) {
      var C = x.name, D = x.on, P = x.pool, L = x.target;
      M.sub(C, D, { pool: P, target: L });
    } }, { key: "unsubscribe", value: function(x) {
      var C = x.name, D = x.on, P = x.pool, L = x.target;
      M.unsub(C, D, { pool: P, target: L });
    } }, { key: "render", value: function() {
      return null;
    } }]), j;
  }();
  return o(F, "defaultProps", { pool: "default", target: "document" }), F.propTypes = {}, yc.instance = M, yc.default = F, yc;
}
var vc = {}, C5;
function rj() {
  if (C5) return vc;
  C5 = 1, Object.defineProperty(vc, "__esModule", { value: !0 });
  var e = $b(), t = pv, n = gt;
  function r(j) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(x) {
      return typeof x;
    } : r = function(x) {
      return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
    }, r(j);
  }
  function i(j, x) {
    if (!(j instanceof x))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(j, x) {
    for (var C = 0; C < x.length; C++) {
      var D = x[C];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(j, D.key, D);
    }
  }
  function o(j, x, C) {
    return x && a(j.prototype, x), j;
  }
  function s(j, x, C) {
    return x in j ? Object.defineProperty(j, x, {
      value: C,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : j[x] = C, j;
  }
  function l(j, x) {
    if (typeof x != "function" && x !== null)
      throw new TypeError("Super expression must either be null or a function");
    j.prototype = Object.create(x && x.prototype, {
      constructor: {
        value: j,
        writable: !0,
        configurable: !0
      }
    }), x && d(j, x);
  }
  function c(j) {
    return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
      return x.__proto__ || Object.getPrototypeOf(x);
    }, c(j);
  }
  function d(j, x) {
    return d = Object.setPrototypeOf || function(C, D) {
      return C.__proto__ = D, C;
    }, d(j, x);
  }
  function p(j) {
    if (j === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return j;
  }
  function y(j, x) {
    return x && (typeof x == "object" || typeof x == "function") ? x : p(j);
  }
  var f = /* @__PURE__ */ function() {
    function j(x) {
      i(this, j), s(this, "handlers", void 0), this.handlers = x.slice(0);
    }
    return o(j, [{
      key: "addHandlers",
      value: function(x) {
        for (var C = this.handlers.slice(0), D = x.length, P = 0; P < D; P += 1)
          C.push(x[P]);
        return new j(C);
      }
      /**
       * @see https://jsperf.com/suir-eventset-dispatchsingle
       * @see https://jsperf.com/suir-eventset-dispatchmultiple2
       */
    }, {
      key: "dispatchEvent",
      value: function(x, C) {
        var D = this.handlers.length - 1;
        if (!C) {
          var P = this.handlers[D];
          P(x);
          return;
        }
        for (var L = D; L >= 0; L -= 1)
          this.handlers[L].called || (this.handlers[L].called = !0, this.handlers[L](x));
        for (var H = D; H >= 0; H -= 1)
          this.handlers[H].called = !1;
      }
    }, {
      key: "hasHandlers",
      value: function() {
        return this.handlers.length > 0;
      }
      /**
       * @see https://jsperf.com/suir-eventset-removehandlers
       */
    }, {
      key: "removeHandlers",
      value: function(x) {
        for (var C = [], D = this.handlers.length, P = 0; P < D; P += 1) {
          var L = this.handlers[P];
          x.indexOf(L) === -1 && C.push(L);
        }
        return new j(C);
      }
    }]), j;
  }();
  function N(j) {
    var x = /* @__PURE__ */ new Map();
    return j.forEach(function(C, D) {
      x.set(D, C);
    }), x;
  }
  function b(j) {
    return Array.isArray(j) ? j : [j];
  }
  var S = function(j) {
    return j !== null && r(j) === "object" && j.hasOwnProperty("current");
  };
  function _(j) {
    return j === "document" ? document : j === "window" ? window : S(j) ? j.current || document : j || document;
  }
  var E = /* @__PURE__ */ function() {
    function j(x, C) {
      i(this, j), s(this, "handlerSets", void 0), s(this, "poolName", void 0), this.handlerSets = C, this.poolName = x;
    }
    return o(j, [{
      key: "addHandlers",
      value: function(x, C) {
        var D = N(this.handlerSets);
        if (D.has(x)) {
          var P = D.get(x);
          D.set(x, P.addHandlers(C));
        } else
          D.set(x, new f(C));
        return new j(this.poolName, D);
      }
    }, {
      key: "dispatchEvent",
      value: function(x, C) {
        var D = this.handlerSets.get(x), P = this.poolName === "default";
        D && D.dispatchEvent(C, P);
      }
    }, {
      key: "hasHandlers",
      value: function(x) {
        if (!x)
          return this.handlerSets.size > 0;
        var C = this.handlerSets.get(x);
        return C ? C.hasHandlers() : !1;
      }
    }, {
      key: "removeHandlers",
      value: function(x, C) {
        var D = N(this.handlerSets);
        if (!D.has(x))
          return new j(this.poolName, D);
        var P = D.get(x), L = P.removeHandlers(C);
        return L.hasHandlers() ? D.set(x, L) : D.delete(x), new j(this.poolName, D);
      }
    }]), j;
  }();
  s(E, "createByType", function(j, x, C) {
    var D = /* @__PURE__ */ new Map();
    return D.set(x, new f(C)), new E(j, D);
  });
  var k = /* @__PURE__ */ function() {
    function j(x) {
      var C = this;
      i(this, j), s(this, "handlers", /* @__PURE__ */ new Map()), s(this, "pools", /* @__PURE__ */ new Map()), s(this, "target", void 0), s(this, "createEmitter", function(D) {
        return function(P) {
          C.pools.forEach(function(L) {
            L.dispatchEvent(D, P);
          });
        };
      }), this.target = x;
    }
    return o(j, [{
      key: "addHandlers",
      value: function(x, C, D) {
        if (this.pools.has(x)) {
          var P = this.pools.get(x);
          this.pools.set(x, P.addHandlers(C, D));
        } else
          this.pools.set(x, E.createByType(x, C, D));
        this.handlers.has(C) || this.addTargetHandler(C);
      }
    }, {
      key: "hasHandlers",
      value: function() {
        return this.handlers.size > 0;
      }
    }, {
      key: "removeHandlers",
      value: function(x, C, D) {
        if (this.pools.has(x)) {
          var P = this.pools.get(x), L = P.removeHandlers(C, D);
          L.hasHandlers() ? this.pools.set(x, L) : this.pools.delete(x);
          var H = !1;
          this.pools.forEach(function($) {
            return H = H || $.hasHandlers(C);
          }), H || this.removeTargetHandler(C);
        }
      }
    }, {
      key: "addTargetHandler",
      value: function(x) {
        var C = this.createEmitter(x);
        this.handlers.set(x, C), this.target.addEventListener(x, C, !0);
      }
    }, {
      key: "removeTargetHandler",
      value: function(x) {
        this.handlers.has(x) && (this.target.removeEventListener(x, this.handlers.get(x), !0), this.handlers.delete(x));
      }
    }]), j;
  }(), M = /* @__PURE__ */ function() {
    function j() {
      var x = this;
      i(this, j), s(this, "targets", /* @__PURE__ */ new Map()), s(this, "getTarget", function(C) {
        var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, P = _(C);
        if (x.targets.has(P))
          return x.targets.get(P);
        if (!D) return null;
        var L = new k(P);
        return x.targets.set(P, L), L;
      }), s(this, "removeTarget", function(C) {
        x.targets.delete(_(C));
      });
    }
    return o(j, [{
      key: "sub",
      value: function(x, C) {
        var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e.canUseDOM) {
          var P = D.target, L = P === void 0 ? document : P, H = D.pool, $ = H === void 0 ? "default" : H, ae = this.getTarget(L);
          ae.addHandlers($, x, b(C));
        }
      }
    }, {
      key: "unsub",
      value: function(x, C) {
        var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e.canUseDOM) {
          var P = D.target, L = P === void 0 ? document : P, H = D.pool, $ = H === void 0 ? "default" : H, ae = this.getTarget(L, !1);
          ae && (ae.removeHandlers($, x, b(C)), ae.hasHandlers() || this.removeTarget(L));
        }
      }
    }]), j;
  }(), F = new M(), q = /* @__PURE__ */ function(j) {
    l(x, j);
    function x() {
      return i(this, x), y(this, c(x).apply(this, arguments));
    }
    return o(x, [{
      key: "componentDidMount",
      value: function() {
        this.subscribe(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function(C) {
        this.unsubscribe(C), this.subscribe(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.unsubscribe(this.props);
      }
    }, {
      key: "subscribe",
      value: function(C) {
        var D = C.name, P = C.on, L = C.pool, H = C.target;
        F.sub(D, P, {
          pool: L,
          target: H
        });
      }
    }, {
      key: "unsubscribe",
      value: function(C) {
        var D = C.name, P = C.on, L = C.pool, H = C.target;
        F.unsub(D, P, {
          pool: L,
          target: H
        });
      }
    }, {
      key: "render",
      value: function() {
        return null;
      }
    }]), x;
  }(n.PureComponent);
  return s(q, "defaultProps", {
    pool: "default",
    target: "document"
  }), q.propTypes = {
    /** An event name on which we will subscribe. */
    name: t.string.isRequired,
    /** An event handler or array of event handlers. */
    on: t.oneOfType([t.func, t.arrayOf(t.func)]).isRequired,
    /** A name of pool. */
    pool: t.string,
    /** A DOM element on which we will subscribe. */
    target: t.oneOfType([
      t.oneOf(["document", "window"]),
      // Heads up!
      // This condition for SSR safety.
      t.instanceOf(e.canUseDOM ? HTMLElement : Object),
      t.shape({
        current: t.object
      })
    ])
  }, vc.instance = F, vc.default = q, vc;
}
var Nf;
process.env.NODE_ENV === "production" ? Nf = nj() : Nf = rj();
Lg.exports = Nf.default;
var Md = Lg.exports.instance = Nf.instance, ij = Lg.exports;
const ja = /* @__PURE__ */ ha(ij);
function Gb() {
}
var aj = 1 / 0, oj = hl && 1 / Og(new hl([, -0]))[1] == aj ? function(e) {
  return new hl(e);
} : Gb, sj = 200;
function Qb(e, t, n) {
  var r = -1, i = jg, a = e.length, o = !0, s = [], l = s;
  if (a >= sj) {
    var c = oj(e);
    if (c)
      return Og(c);
    o = !1, i = Kc, l = new ps();
  } else
    l = s;
  e:
    for (; ++r < a; ) {
      var d = e[r], p = d;
      if (d = d !== 0 ? d : 0, o && p === p) {
        for (var y = l.length; y--; )
          if (l[y] === p)
            continue e;
        s.push(d);
      } else i(l, p, n) || (l !== s && l.push(p), s.push(d));
    }
  return s;
}
function Xf(e) {
  return e && e.length ? Qb(e) : [];
}
var lj = "[object Number]";
function cj(e) {
  return typeof e == "number" || ji(e) && ma(e) == lj;
}
var uj = "[object String]";
function Tg(e) {
  return typeof e == "string" || !Rn(e) && ji(e) && ma(e) == uj;
}
var dj = "[object Boolean]";
function fj(e) {
  return e === !0 || e === !1 || ji(e) && ma(e) == dj;
}
function Yb(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Yb(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function rt() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = Yb(e)) && (r && (r += " "), r += t);
  return r;
}
var Em = { exports: {} }, nn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O5;
function pj() {
  if (O5) return nn;
  O5 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), N;
  N = Symbol.for("react.module.reference");
  function b(S) {
    if (typeof S == "object" && S !== null) {
      var _ = S.$$typeof;
      switch (_) {
        case e:
          switch (S = S.type, S) {
            case n:
            case i:
            case r:
            case c:
            case d:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case o:
                case l:
                case y:
                case p:
                case a:
                  return S;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return nn.ContextConsumer = o, nn.ContextProvider = a, nn.Element = e, nn.ForwardRef = l, nn.Fragment = n, nn.Lazy = y, nn.Memo = p, nn.Portal = t, nn.Profiler = i, nn.StrictMode = r, nn.Suspense = c, nn.SuspenseList = d, nn.isAsyncMode = function() {
    return !1;
  }, nn.isConcurrentMode = function() {
    return !1;
  }, nn.isContextConsumer = function(S) {
    return b(S) === o;
  }, nn.isContextProvider = function(S) {
    return b(S) === a;
  }, nn.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, nn.isForwardRef = function(S) {
    return b(S) === l;
  }, nn.isFragment = function(S) {
    return b(S) === n;
  }, nn.isLazy = function(S) {
    return b(S) === y;
  }, nn.isMemo = function(S) {
    return b(S) === p;
  }, nn.isPortal = function(S) {
    return b(S) === t;
  }, nn.isProfiler = function(S) {
    return b(S) === i;
  }, nn.isStrictMode = function(S) {
    return b(S) === r;
  }, nn.isSuspense = function(S) {
    return b(S) === c;
  }, nn.isSuspenseList = function(S) {
    return b(S) === d;
  }, nn.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === i || S === r || S === c || S === d || S === f || typeof S == "object" && S !== null && (S.$$typeof === y || S.$$typeof === p || S.$$typeof === a || S.$$typeof === o || S.$$typeof === l || S.$$typeof === N || S.getModuleId !== void 0);
  }, nn.typeOf = b, nn;
}
var ln = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j5;
function hj() {
  return j5 || (j5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), N = !1, b = !1, S = !1, _ = !1, E = !1, k;
    k = Symbol.for("react.module.reference");
    function M(Se) {
      return !!(typeof Se == "string" || typeof Se == "function" || Se === n || Se === i || E || Se === r || Se === c || Se === d || _ || Se === f || N || b || S || typeof Se == "object" && Se !== null && (Se.$$typeof === y || Se.$$typeof === p || Se.$$typeof === a || Se.$$typeof === o || Se.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Se.$$typeof === k || Se.getModuleId !== void 0));
    }
    function F(Se) {
      if (typeof Se == "object" && Se !== null) {
        var be = Se.$$typeof;
        switch (be) {
          case e:
            var X = Se.type;
            switch (X) {
              case n:
              case i:
              case r:
              case c:
              case d:
                return X;
              default:
                var Ye = X && X.$$typeof;
                switch (Ye) {
                  case s:
                  case o:
                  case l:
                  case y:
                  case p:
                  case a:
                    return Ye;
                  default:
                    return be;
                }
            }
          case t:
            return be;
        }
      }
    }
    var q = o, j = a, x = e, C = l, D = n, P = y, L = p, H = t, $ = i, ae = r, ce = c, le = d, oe = !1, se = !1;
    function J(Se) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function re(Se) {
      return se || (se = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(Se) {
      return F(Se) === o;
    }
    function U(Se) {
      return F(Se) === a;
    }
    function G(Se) {
      return typeof Se == "object" && Se !== null && Se.$$typeof === e;
    }
    function K(Se) {
      return F(Se) === l;
    }
    function A(Se) {
      return F(Se) === n;
    }
    function ee(Se) {
      return F(Se) === y;
    }
    function te(Se) {
      return F(Se) === p;
    }
    function ne(Se) {
      return F(Se) === t;
    }
    function ve(Se) {
      return F(Se) === i;
    }
    function _e(Se) {
      return F(Se) === r;
    }
    function pe(Se) {
      return F(Se) === c;
    }
    function je(Se) {
      return F(Se) === d;
    }
    ln.ContextConsumer = q, ln.ContextProvider = j, ln.Element = x, ln.ForwardRef = C, ln.Fragment = D, ln.Lazy = P, ln.Memo = L, ln.Portal = H, ln.Profiler = $, ln.StrictMode = ae, ln.Suspense = ce, ln.SuspenseList = le, ln.isAsyncMode = J, ln.isConcurrentMode = re, ln.isContextConsumer = I, ln.isContextProvider = U, ln.isElement = G, ln.isForwardRef = K, ln.isFragment = A, ln.isLazy = ee, ln.isMemo = te, ln.isPortal = ne, ln.isProfiler = ve, ln.isStrictMode = _e, ln.isSuspense = pe, ln.isSuspenseList = je, ln.isValidElementType = M, ln.typeOf = F;
  }()), ln;
}
process.env.NODE_ENV === "production" ? Em.exports = pj() : Em.exports = hj();
var Zf = Em.exports;
const mj = /* @__PURE__ */ ha(Zf);
var P5 = {};
function Cm(e, t, n, r) {
  if (r === void 0 && (r = {}), !Zf.isValidElementType(e))
    throw new Error("createShorthand(): Component should be a valid element type.");
  if (Tt(n) || fj(n))
    return null;
  var i = Tg(n), a = cj(n), o = wl(n), s = /* @__PURE__ */ R.isValidElement(n), l = Kf(n), c = i || a || Rn(n);
  if (!o && !s && !l && !c)
    return process.env.NODE_ENV !== "production" && console.error(["Shorthand value must be a string|number|array|object|ReactElement|function.", " Use null|undefined|boolean for none", " Received " + typeof n + "."].join("")), null;
  var d = r, p = d.defaultProps, y = p === void 0 ? {} : p, f = s && n.props || l && n || c && t(n), N = r, b = N.overrideProps, S = b === void 0 ? {} : b;
  S = wl(S) ? S(Pe({}, y, f)) : S;
  var _ = Pe({}, y, f, S);
  if (y.className || S.className || f.className) {
    var E = rt(y.className, S.className, f.className);
    _.className = Xf(E.split(" ")).join(" ");
  }
  if ((y.style || S.style || f.style) && (_.style = Pe({}, y.style, f.style, S.style)), Tt(_.key)) {
    var k = _.childKey, M = r, F = M.autoGenerateKey, q = F === void 0 ? !0 : F;
    Tt(k) ? q && (i || a) && (_.key = n) : (_.key = typeof k == "function" ? k(_) : k, delete _.childKey);
  }
  if (s)
    return /* @__PURE__ */ R.cloneElement(n, _);
  if (typeof _.children == "function")
    return _.children(e, Pe({}, _, {
      children: void 0
    }));
  if (c || l)
    return /* @__PURE__ */ R.createElement(e, _);
  if (o)
    return process.env.NODE_ENV !== "production" && (P5[e] || (P5[e] = !0, console.warn('Warning: There is a deprecated shorthand function usage for "' + e + '". It is deprecated and will be removed in v3 release. Please follow our upgrade guide: https://github.com/Semantic-Org/Semantic-UI-React/pull/4029'))), n(e, _, _.children);
}
function Vt(e, t) {
  if (!Zf.isValidElementType(e))
    throw new Error("createShorthandFactory(): Component should be a valid element type.");
  return function(n, r) {
    return Cm(e, t, n, r);
  };
}
var gj = /* @__PURE__ */ Vt("div", function(e) {
  return {
    children: e
  };
}), yj = /* @__PURE__ */ Vt("input", function(e) {
  return {
    type: e
  };
}), Om = /* @__PURE__ */ Vt("label", function(e) {
  return {
    children: e
  };
}), vj = /* @__PURE__ */ Vt("p", function(e) {
  return {
    children: e
  };
});
function lt(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.defaultAs, i = n.getDefault;
  if (e.as && e.as !== r) return e.as;
  if (i) {
    var a = i();
    if (a) return a;
  }
  return e.href ? "a" : r || "div";
}
var nt = function(e, t) {
  var n = e.handledProps, r = n === void 0 ? [] : n;
  return Object.keys(t).reduce(function(i, a) {
    return a === "childKey" || a === "innerRef" || r.indexOf(a) === -1 && (i[a] = t[a]), i;
  }, {});
};
function bj(e, t) {
  return os(t, function(n) {
    return e[n];
  });
}
function Kb(e) {
  return e == null ? [] : bj(e, Si(e));
}
var wj = Math.max;
function Ei(e, t, n, r) {
  e = za(e) ? e : Kb(e), n = n ? su(n) : 0;
  var i = e.length;
  return n < 0 && (n = wj(i + n, 0)), Tg(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && Gf(e, t, n) > -1;
}
var Xb = [
  // REACT
  "selected",
  "defaultValue",
  "defaultChecked",
  // LIMITED HTML PROPS
  "accept",
  "autoCapitalize",
  "autoComplete",
  "autoCorrect",
  "autoFocus",
  "checked",
  "disabled",
  "enterKeyHint",
  "form",
  "id",
  "inputMode",
  "lang",
  "list",
  "max",
  "maxLength",
  "min",
  "minLength",
  "multiple",
  "name",
  "pattern",
  "placeholder",
  "readOnly",
  "required",
  "step",
  "title",
  "type",
  "value"
], xj = [
  // EVENTS
  // keyboard
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  // focus
  "onFocus",
  "onBlur",
  // form
  "onChange",
  "onInput",
  // mouse
  "onClick",
  "onContextMenu",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  // selection
  "onSelect",
  // touch
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart"
], _j = [].concat(Xb, xj), Nj = ["alt", "height", "src", "srcSet", "width", "loading"], Fg = function(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.htmlProps, i = r === void 0 ? _j : r, a = n.includeAria, o = a === void 0 ? !0 : a, s = {}, l = {};
  return Lb(e, function(c, d) {
    var p = o && (/^aria-.*$/.test(d) || d === "role"), y = Ei(i, d) || p ? s : l;
    y[d] = c;
  }), [s, l];
}, Sj = typeof document == "object" && document !== null, Ej = typeof window == "object" && window !== null && window.self === window, ss = function e() {
  return Tt(e.override) ? Sj && Ej : e.override;
}, Cj = Math.max, Oj = Math.min;
function jj(e, t, n) {
  return e >= Oj(t, n) && e < Cj(t, n);
}
function L5(e, t, n) {
  return t = pm(t), n === void 0 ? (n = t, t = 0) : n = pm(n), e = hb(e), jj(e, t, n);
}
function Pj(e) {
  return e && e.length ? e[0] : void 0;
}
var ls = function(e, t) {
  if (Mc([t, e], Tt))
    return !1;
  if (t.target && (Ze(t.target, "setAttribute", "data-suir-click-target", !0), document.querySelector("[data-suir-click-target=true]") && (Ze(t.target, "removeAttribute", "data-suir-click-target"), typeof e.contains == "function")))
    return e.contains(t.target);
  var n = t.clientX, r = t.clientY;
  if (Mc([n, r], Tt) || typeof e.getClientRects != "function")
    return !1;
  var i = e.getClientRects();
  if (!e.offsetWidth || !e.offsetHeight || !i || !i.length)
    return !1;
  var a = Pj(i), o = a.top, s = a.bottom, l = a.left, c = a.right;
  return Mc([o, s, l, c], Tt) ? !1 : L5(r, o, s + 1e-3) && L5(n, l, c + 1e-3);
}, Fi = ["red", "orange", "yellow", "olive", "green", "teal", "blue", "violet", "purple", "pink", "brown", "grey", "black"], lu = ["left", "right"], Or = ["mini", "tiny", "small", "medium", "large", "big", "huge", "massive"], Mo = ["left", "center", "right", "justified"], _s = ["bottom", "middle", "top"], Zb = ["mobile", "tablet", "computer", "large screen", "widescreen"], Yr = [].concat(Si(of), Si(of).map(Number), Kb(of)), Lj = ["american sign language interpreting", "assistive listening systems", "audio description", "blind", "braille", "closed captioning", "closed captioning outline", "deaf", "low vision", "phone volume", "question circle", "question circle outline", "sign language", "tty", "universal access", "wheelchair"], Tj = ["angle double down", "angle double left", "angle double right", "angle double up", "angle down", "angle left", "angle right", "angle up", "arrow alternate circle down", "arrow alternate circle down outline", "arrow alternate circle left", "arrow alternate circle left outline", "arrow alternate circle right", "arrow alternate circle right outline", "arrow alternate circle up", "arrow alternate circle up outline", "arrow circle down", "arrow circle left", "arrow circle right", "arrow circle up", "arrow down", "arrow left", "arrow right", "arrow up", "arrows alternate", "arrows alternate horizontal", "arrows alternate vertical", "caret down", "caret left", "caret right", "caret square down", "caret square down outline", "caret square left", "caret square left outline", "caret square right", "caret square right outline", "caret square up", "caret square up outline", "caret up", "cart arrow down", "chart line", "chevron circle down", "chevron circle left", "chevron circle right", "chevron circle up", "chevron down", "chevron left", "chevron right", "chevron up", "cloud download", "cloud upload", "download", "exchange", "expand arrows alternate", "external alternate", "external square alternate", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "history", "level down alternate", "level up alternate", "location arrow", "long arrow alternate down", "long arrow alternate left", "long arrow alternate right", "long arrow alternate up", "mouse pointer", "play", "random", "recycle", "redo", "redo alternate", "reply", "reply all", "retweet", "share", "share square", "share square outline", "sign-in", "sign-out", "sign-in alternate", "sign-out alternate", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "sync", "sync alternate", "text height", "text width", "undo", "undo alternate", "upload", "zoom-in", "zoom-out"], Fj = ["audio description", "backward", "circle", "circle outline", "closed captioning", "closed captioning outline", "compress", "eject", "expand", "expand arrows alternate", "fast backward", "fast forward", "file audio", "file audio outline", "file video", "file video outline", "film", "forward", "headphones", "microphone", "microphone slash", "music", "pause", "pause circle", "pause circle outline", "phone volume", "play", "play circle", "play circle outline", "podcast", "random", "redo", "redo alternate", "rss", "rss square", "step backward", "step forward", "stop", "stop circle", "stop circle outline", "sync", "sync alternate", "undo", "undo alternate", "video", "volume down", "volume off", "volume up"], Ij = ["address book", "address book outline", "address card", "address card outline", "archive", "balance scale", "birthday cake", "book", "briefcase", "building", "building outline", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "certificate", "chart area", "chart bar", "chart bar outline", "chart line", "chart pie", "clipboard", "clipboard outline", "coffee", "columns", "compass", "compass outline", "copy", "copy outline", "copyright", "copyright outline", "cut", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "eraser", "fax", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "globe", "industry", "paperclip", "paste", "pen square", "pencil alternate", "percent", "phone", "phone square", "phone volume", "registered", "registered outline", "save", "save outline", "sitemap", "sticky note", "sticky note outline", "suitcase", "table", "tag", "tags", "tasks", "thumbtack", "trademark"], kj = ["chess", "chess bishop", "chess board", "chess king", "chess knight", "chess pawn", "chess queen", "chess rook", "square full"], Dj = ["archive", "barcode", "bath", "bug", "code", "code branch", "coffee", "file", "file outline", "file alternate", "file alternate outline", "file code", "file code outline", "filter", "fire extinguisher", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "microchip", "qrcode", "shield alternate", "sitemap", "terminal", "user secret", "window close", "window close outline", "window maximize", "window maximize outline", "window minimize", "window minimize outline", "window restore", "window restore outline"], Rj = ["address book", "address book outline", "address card", "address card outline", "american sign language interpreting", "assistive listening systems", "at", "bell", "bell outline", "bell slash", "bell slash outline", "bullhorn", "comment", "comment outline", "comment alternate", "comment alternate outline", "comments", "comments outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "fax", "inbox", "language", "microphone", "microphone slash", "mobile", "mobile alternate", "paper plane", "paper plane outline", "phone", "phone square", "phone volume", "rss", "rss square", "tty", "wifi"], Mj = ["desktop", "download", "hdd", "hdd outline", "headphones", "keyboard", "keyboard outline", "laptop", "microchip", "mobile", "mobile alternate", "plug", "power off", "print", "save", "save outline", "server", "tablet", "tablet alternate", "tv", "upload"], Uj = ["dollar sign", "euro sign", "lira sign", "money bill alternate", "money bill alternate outline", "pound sign", "ruble sign", "rupee sign", "shekel sign", "won sign", "yen sign"], Bj = ["bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "clock", "clock outline", "hourglass", "hourglass outline", "hourglass end", "hourglass half", "hourglass start", "stopwatch"], zj = ["adjust", "clone", "clone outline", "copy", "copy outline", "crop", "crosshairs", "cut", "edit", "edit outline", "eraser", "eye", "eye dropper", "eye slash", "eye slash outline", "object group", "object group outline", "object ungroup", "object ungroup outline", "paint brush", "paste", "pencil alternate", "save", "save outline", "tint"], qj = ["align center", "align justify", "align left", "align right", "bold", "clipboard", "clipboard outline", "clone", "clone outline", "columns", "copy", "copy outline", "cut", "edit", "edit outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "font", "heading", "i cursor", "indent", "italic", "linkify", "list", "list alternate", "list alternate outline", "list ol", "list ul", "outdent", "paper plane", "paper plane outline", "paperclip", "paragraph", "paste", "pencil alternate", "print", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "share", "strikethrough", "subscript", "superscript", "sync", "sync alternate", "table", "tasks", "text height", "text width", "th", "th large", "th list", "trash", "trash alternate", "trash alternate outline", "underline", "undo", "undo alternate", "unlink"], Vj = ["archive", "clone", "clone outline", "copy", "copy outline", "cut", "file", "file outline", "file alternate", "file alternate outline", "file archive", "file archive outline", "file audio", "file audio outline", "file code", "file code outline", "file excel", "file excel outline", "file image", "file image outline", "file pdf", "file pdf outline", "file powerpoint", "file powerpoint outline", "file video", "file video outline", "file word", "file word outline", "folder", "folder outline", "folder open", "folder open outline", "paste", "save", "save outline", "sticky note", "sticky note outline"], Wj = ["genderless", "mars", "mars double", "mars stroke", "mars stroke horizontal", "mars stroke vertical", "mercury", "neuter", "transgender", "transgender alternate", "venus", "venus double", "venus mars"], Hj = ["hand lizard", "hand lizard outline", "hand paper", "hand paper outline", "hand peace", "hand peace outline", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "hand rock", "hand rock outline", "hand scissors", "hand scissors outline", "hand spock", "hand spock outline", "handshake", "handshake outline", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline"], $j = ["ambulance", "h square", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "medkit", "plus square", "plus square outline", "stethoscope", "user md", "wheelchair"], Gj = ["adjust", "bolt", "camera", "camera retro", "clone", "clone outline", "compress", "expand", "eye", "eye dropper", "eye slash", "eye slash outline", "file image", "file image outline", "film", "id badge", "id badge outline", "id card", "id card outline", "image", "image outline", "images", "images outline", "sliders horizontal", "tint"], Qj = ["ban", "barcode", "bars", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bug", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "certificate", "check", "check circle", "check circle outline", "check square", "check square outline", "circle", "circle outline", "clipboard", "clipboard outline", "clone", "clone outline", "cloud", "cloud download", "cloud upload", "coffee", "cog", "cogs", "copy", "copy outline", "cut", "database", "dot circle", "dot circle outline", "download", "edit", "edit outline", "ellipsis horizontal", "ellipsis vertical", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "exclamation", "exclamation circle", "exclamation triangle", "external alternate", "external square alternate", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "filter", "flag", "flag outline", "flag checkered", "folder", "folder outline", "folder open", "folder open outline", "frown", "frown outline", "hashtag", "heart", "heart outline", "history", "home", "i cursor", "info", "info circle", "language", "magic", "meh", "meh outline", "microphone", "microphone slash", "minus", "minus circle", "minus square", "minus square outline", "paste", "pencil alternate", "plus", "plus circle", "plus square", "plus square outline", "qrcode", "question", "question circle", "question circle outline", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "rss", "rss square", "save", "save outline", "search", "search minus", "search plus", "share", "share alternate", "share alternate square", "share square", "share square outline", "shield alternate", "sign-in", "sign-out", "signal", "sitemap", "sliders horizontal", "smile", "smile outline", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "star", "star outline", "star half", "star half outline", "sync", "sync alternate", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "times", "times circle", "times circle outline", "toggle off", "toggle on", "trash", "trash alternate", "trash alternate outline", "trophy", "undo", "undo alternate", "upload", "user", "user outline", "user circle", "user circle outline", "wifi"], Yj = ["box", "boxes", "clipboard check", "clipboard list", "dolly", "dolly flatbed", "pallet", "shipping fast", "truck", "warehouse"], Kj = ["ambulance", "anchor", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bicycle", "binoculars", "birthday cake", "blind", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "building", "building outline", "car", "coffee", "crosshairs", "dollar sign", "eye", "eye slash", "eye slash outline", "fighter jet", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "gamepad", "gavel", "gift", "glass martini", "globe", "graduation cap", "h square", "heart", "heart outline", "heartbeat", "home", "hospital", "hospital outline", "image", "image outline", "images", "images outline", "industry", "info", "info circle", "key", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "location arrow", "low vision", "magnet", "male", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "money bill alternate", "money bill alternate outline", "motorcycle", "music", "newspaper", "newspaper outline", "paw", "phone", "phone square", "phone volume", "plane", "plug", "plus", "plus square", "plus square outline", "print", "recycle", "road", "rocket", "search", "search minus", "search plus", "ship", "shopping bag", "shopping basket", "shopping cart", "shower", "street view", "subway", "suitcase", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "tint", "train", "tree", "trophy", "truck", "tty", "umbrella", "university", "utensil spoon", "utensils", "wheelchair", "wifi", "wrench"], Xj = ["ambulance", "band aid", "dna", "first aid", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "hospital symbol", "pills", "plus", "stethoscope", "syringe", "thermometer", "user md", "weight"], Zj = ["ambulance", "anchor", "archive", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bicycle", "binoculars", "birthday cake", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "bug", "building", "building outline", "bullhorn", "bullseye", "bus", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "camera", "camera retro", "car", "clipboard", "clipboard outline", "cloud", "coffee", "cog", "cogs", "compass", "compass outline", "copy", "copy outline", "cube", "cubes", "cut", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "eye", "eye dropper", "fax", "fighter jet", "file", "file outline", "file alternate", "file alternate outline", "film", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "futbol", "futbol outline", "gamepad", "gavel", "gem", "gem outline", "gift", "glass martini", "globe", "graduation cap", "hdd", "hdd outline", "headphones", "heart", "heart outline", "home", "hospital", "hospital outline", "hourglass", "hourglass outline", "image", "image outline", "images", "images outline", "industry", "key", "keyboard", "keyboard outline", "laptop", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "lock", "lock open", "magic", "magnet", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "microchip", "microphone", "mobile", "mobile alternate", "money bill alternate", "money bill alternate outline", "moon", "moon outline", "motorcycle", "newspaper", "newspaper outline", "paint brush", "paper plane", "paper plane outline", "paperclip", "paste", "paw", "pencil alternate", "phone", "plane", "plug", "print", "puzzle piece", "road", "rocket", "save", "save outline", "search", "shield alternate", "shopping bag", "shopping basket", "shopping cart", "shower", "snowflake", "snowflake outline", "space shuttle", "star", "star outline", "sticky note", "sticky note outline", "stopwatch", "subway", "suitcase", "sun", "sun outline", "tablet", "tablet alternate", "tachometer alternate", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "train", "trash", "trash alternate", "trash alternate outline", "tree", "trophy", "truck", "tv", "umbrella", "university", "unlock", "unlock alternate", "utensil spoon", "utensils", "wheelchair", "wrench"], Jj = ["bell", "bell outline", "bookmark", "bookmark outline", "bullhorn", "camera", "camera retro", "cart arrow down", "cart plus", "certificate", "credit card", "credit card outline", "gem", "gem outline", "gift", "handshake", "handshake outline", "heart", "heart outline", "key", "shopping bag", "shopping basket", "shopping cart", "star", "star outline", "tag", "tags", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "trophy"], Aj = ["bookmark", "bookmark outline", "calendar", "calendar outline", "certificate", "circle", "circle outline", "cloud", "comment", "comment outline", "file", "file outline", "folder", "folder outline", "heart", "heart outline", "map marker", "play", "square", "square outline", "star", "star outline"], eP = ["asterisk", "certificate", "circle notch", "cog", "compass", "compass outline", "crosshairs", "life ring", "life ring outline", "snowflake", "snowflake outline", "spinner", "sun", "sun outline", "sync"], tP = ["baseball ball", "basketball ball", "bowling ball", "football ball", "futbol", "futbol outline", "golf ball", "hockey puck", "quidditch", "table tennis", "volleyball ball"], nP = ["ban", "battery empty", "battery full", "battery half", "battery quarter", "battery three quarters", "bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "cart arrow down", "cart plus", "exclamation", "exclamation circle", "exclamation triangle", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "info", "info circle", "lock", "lock open", "minus", "minus circle", "minus square", "minus square outline", "plus", "plus circle", "plus square", "plus square outline", "question", "question circle", "question circle outline", "shield alternate", "shopping cart", "sign in alternate", "sign out alternate", "thermometer empty", "thermometer full", "thermometer half", "thermometer quarter", "thermometer three quarters", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "toggle off", "toggle on", "unlock", "unlock alternate"], rP = ["address book", "address book outline", "address card", "address card outline", "bed", "blind", "child", "female", "frown", "frown outline", "id badge", "id badge outline", "id card", "id card outline", "male", "meh", "meh outline", "power off", "smile", "smile outline", "street view", "user", "user outline", "user circle", "user circle outline", "user md", "user plus", "user secret", "user times", "users", "wheelchair"], iP = ["ambulance", "bicycle", "bus", "car", "fighter jet", "motorcycle", "paper plane", "paper plane outline", "plane", "rocket", "ship", "shopping cart", "space shuttle", "subway", "taxi", "train", "truck", "wheelchair"], aP = ["archive", "book", "bookmark", "bookmark outline", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "newspaper", "newspaper outline", "paper plane", "paper plane outline", "paperclip", "paragraph", "pen square", "pencil alternate", "quote left", "quote right", "sticky note", "sticky note outline", "thumbtack"], oP = ["500px", "accessible", "accusoft", "adn", "adversal", "affiliatetheme", "algolia", "amazon", "amazon pay", "amilia", "android", "angellist", "angrycreative", "angular", "app store", "app store ios", "apper", "apple", "apple pay", "asymmetrik", "audible", "autoprefixer", "avianex", "aviato", "aws", "bandcamp", "behance", "behance square", "bimobject", "bitbucket", "bitcoin", "bity", "black tie", "blackberry", "blogger", "blogger b", "bluetooth", "bluetooth b", "btc", "buromobelexperte", "buysellads", "cc amazon pay", "cc amex", "cc apple pay", "cc diners club", "cc discover", "cc jcb", "cc mastercard", "cc paypal", "cc stripe", "cc visa", "centercode", "chrome", "cloudscale", "cloudsmith", "cloudversify", "codepen", "codiepie", "connectdevelop", "contao", "cpanel", "creative commons", "css3", "css3 alternate", "cuttlefish", "d and d", "dashcube", "delicious", "deploydog", "deskpro", "deviantart", "digg", "digital ocean", "discord", "discourse", "dochub", "docker", "draft2digital", "dribbble", "dribbble square", "dropbox", "drupal", "dyalog", "earlybirds", "edge", "elementor", "ember", "empire", "envira", "erlang", "ethereum", "etsy", "expeditedssl", "facebook", "facebook f", "facebook messenger", "facebook square", "firefox", "first order", "firstdraft", "flickr", "flipboard", "fly", "font awesome", "font awesome alternate", "font awesome flag", "fonticons", "fonticons fi", "fort awesome", "fort awesome alternate", "forumbee", "foursquare", "free code camp", "freebsd", "get pocket", "gg", "gg circle", "git", "git square", "github", "github alternate", "github square", "gitkraken", "gitlab", "gitter", "glide", "glide g", "gofore", "goodreads", "goodreads g", "google", "google drive", "google play", "google plus", "google plus g", "google plus square", "google wallet", "gratipay", "grav", "gripfire", "grunt", "gulp", "hacker news", "hacker news square", "hips", "hire a helper", "hooli", "hotjar", "houzz", "html5", "hubspot", "imdb", "instagram", "internet explorer", "ioxhost", "itunes", "itunes note", "jenkins", "joget", "joomla", "js", "js square", "jsfiddle", "keycdn", "kickstarter", "kickstarter k", "korvue", "laravel", "lastfm", "lastfm square", "leanpub", "less", "linechat", "linkedin", "linkedin alternate", "linode", "linux", "lyft", "magento", "maxcdn", "medapps", "medium", "medium m", "medrt", "meetup", "microsoft", "mix", "mixcloud", "mizuni", "modx", "monero", "napster", "nintendo switch", "node", "node js", "npm", "ns8", "nutritionix", "odnoklassniki", "odnoklassniki square", "opencart", "openid", "opera", "optin monster", "osi", "page4", "pagelines", "palfed", "patreon", "paypal", "periscope", "phabricator", "phoenix framework", "php", "pied piper", "pied piper alternate", "pied piper pp", "pinterest", "pinterest p", "pinterest square", "playstation", "product hunt", "pushed", "python", "qq", "quinscape", "quora", "ravelry", "react", "rebel", "redriver", "reddit", "reddit alien", "reddit square", "rendact", "renren", "replyd", "resolving", "rocketchat", "rockrms", "safari", "sass", "schlix", "scribd", "searchengin", "sellcast", "sellsy", "servicestack", "shirtsinbulk", "simplybuilt", "sistrix", "skyatlas", "skype", "slack", "slack hash", "slideshare", "snapchat", "snapchat ghost", "snapchat square", "soundcloud", "speakap", "spotify", "stack exchange", "stack overflow", "staylinked", "steam", "steam square", "steam symbol", "sticker mule", "strava", "stripe", "stripe s", "studiovinari", "stumbleupon", "stumbleupon circle", "superpowers", "supple", "telegram", "telegram plane", "tencent weibo", "themeisle", "trello", "tripadvisor", "tumblr", "tumblr square", "twitch", "twitter", "twitter square", "typo3", "uber", "uikit", "uniregistry", "untappd", "usb", "ussunnah", "vaadin", "viacoin", "viadeo", "viadeo square", "viber", "vimeo", "vimeo square", "vimeo v", "vine", "vk", "vnv", "vuejs", "wechat", "weibo", "weixin", "whatsapp", "whatsapp square", "whmcs", "wikipedia w", "windows", "wordpress", "wordpress simple", "wpbeginner", "wpexplorer", "wpforms", "xbox", "xing", "xing square", "y combinator", "yahoo", "yandex", "yandex international", "yelp", "yoast", "youtube", "youtube square"], sP = Xf([].concat(Lj, Tj, Fj, Ij, kj, Dj, Rj, Mj, Uj, Bj, zj, qj, Vj, Wj, Hj, $j, Gj, Qj, Yj, Kj, Xj, Zj, Jj, Aj, eP, tP, nP, rP, iP, aP, oP)), lP = ["chess rock", "ordered list", "unordered list", "user doctor", "shield", "puzzle", "add circle", "add square", "add to calendar", "add to cart", "add user", "add", "alarm mute", "alarm", "ald", "als", "announcement", "area chart", "area graph", "arrow down cart", "asexual", "asl interpreting", "asl", "assistive listening devices", "attach", "attention", "balance", "bar", "bathtub", "battery four", "battery high", "battery low", "battery one", "battery three", "battery two", "battery zero", "birthday", "block layout", "bluetooth alternative", "broken chain", "browser", "call square", "call", "cancel", "cart", "cc", "chain", "chat", "checked calendar", "checkmark", "circle notched", "close", "cny", "cocktail", "commenting", "computer", "configure", "content", "deafness", "delete calendar", "delete", "detective", "discussions", "doctor", "dollar", "dont", "drivers license", "dropdown", "emergency", "envira gallery", "erase", "eur", "euro", "eyedropper", "factory", "favorite", "feed", "female homosexual", "file text", "file text outline", "find", "first aid", "fork", "game", "gay", "gbp", "google plus circle", "google plus official", "grab", "graduation", "grid layout", "group", "h", "hand victory", "handicap", "hard of hearing", "header", "help circle", "help", "heterosexual", "hide", "hotel", "hourglass four", "hourglass full", "hourglass one", "hourglass three", "hourglass two", "idea", "ils", "in cart", "inr", "intergender", "intersex", "jpy", "krw", "lab", "law", "legal", "lesbian", "lightning", "like", "line graph", "linkedin square", "linkify", "lira", "list layout", "magnify", "mail forward", "mail outline", "mail square", "mail", "male homosexual", "man", "marker", "mars alternate", "mars horizontal", "mars vertical", "microsoft edge", "military", "ms edge", "mute", "new pied piper", "non binary transgender", "numbered list", "options", "other gender horizontal", "other gender vertical", "other gender", "payment", "paypal card", "pencil square", "photo", "picture", "pie chart", "pie graph", "pied piper hat", "pin", "plus cart", "point", "pointing down", "pointing left", "pointing right", "pointing up", "pound", "power cord", "power", "privacy", "r circle", "rain", "record", "refresh", "remove circle", "remove from calendar", "remove user", "remove", "repeat", "rmb", "rouble", "rub", "ruble", "rupee", "s15", "selected radio", "send", "setting", "settings", "shekel", "sheqel", "shipping", "shop", "shuffle", "shutdown", "sidebar", "signing", "signup", "sliders", "soccer", "sort alphabet ascending", "sort alphabet descending", "sort ascending", "sort content ascending", "sort content descending", "sort descending", "sort numeric ascending", "sort numeric descending", "sound", "spy", "stripe card", "student", "talk", "target", "teletype", "television", "text cursor", "text telephone", "theme", "thermometer", "thumb tack", "time", "tm", "toggle down", "toggle left", "toggle right", "toggle up", "translate", "travel", "treatment", "triangle down", "triangle left", "triangle right", "triangle up", "try", "unhide", "unlinkify", "unmute", "usd", "user cancel", "user close", "user delete", "user x", "vcard", "video camera", "video play", "volume control phone", "wait", "warning circle", "warning sign", "warning", "wi-fi", "winner", "wizard", "woman", "won", "wordpress beginner", "wordpress forms", "world", "write square", "x", "yen", "zip", "zoom in", "zoom out", "zoom", "bitbucket square", "checkmark box", "circle thin", "cloud download", "cloud upload", "compose", "conversation", "credit card alternative", "currency", "dashboard", "diamond", "disk", "exchange", "external share", "external square", "external", "facebook official", "food", "hourglass zero", "level down", "level up", "log out", "meanpath", "money", "move", "pencil", "protect", "radio", "remove bookmark", "resize horizontal", "resize vertical", "sign in", "sign out", "spoon", "star half empty", "star half full", "ticket", "times rectangle", "write", "youtube play"], cP = Xf([].concat(sP, lP)), uP = [
  "left dropdown"
  // nested dropdown menu direction icon
], dP = Xf([].concat(cP, uP));
function fP(e, t) {
  return $f(e, t);
}
function jm(e) {
  return e !== null && typeof e == "object" && e.hasOwnProperty("current");
}
function hs(e) {
  var t = typeof e.defaultState > "u" ? e.initialState : e.defaultState, n = R.useState(t), r = n[0], i = n[1], a = typeof e.state > "u" ? r : e.state, o = R.useRef(a);
  R.useEffect(function() {
    o.current = a;
  }, [a]);
  var s = R.useCallback(function(l) {
    typeof l == "function" ? o.current = l(o.current) : o.current = l, i(o.current);
  }, []);
  return [a, s];
}
var xl = ss() && process.env.NODE_ENV !== "test" ? R.useLayoutEffect : R.useEffect, pP = /\s+/;
function hP(e) {
  var t = [];
  return e ? (e.forEach(function(n) {
    if (typeof n.current == "string") {
      var r = n.current.split(pP);
      r.forEach(function(i) {
        t.push(i);
      });
    }
  }), t.filter(function(n, r, i) {
    return n.length > 0 && i.indexOf(n) === r;
  })) : [];
}
function mP(e, t) {
  return [t.filter(function(n) {
    return e.indexOf(n) === -1;
  }), e.filter(function(n) {
    return t.indexOf(n) === -1;
  })];
}
var T5 = /* @__PURE__ */ new Map(), Ch = function(e, t) {
  var n = hP(t), r = mP(T5.get(e) || [], n), i = r[0], a = r[1];
  e && (i.forEach(function(o) {
    return e.classList.add(o);
  }), a.forEach(function(o) {
    return e.classList.remove(o);
  })), T5.set(e, n);
}, gP = function() {
  var e = this;
  this.add = function(t, n) {
    if (e.nodes.has(t)) {
      var r = e.nodes.get(t);
      r.add(n);
      return;
    }
    var i = /* @__PURE__ */ new Set();
    i.add(n), e.nodes.set(t, i);
  }, this.del = function(t, n) {
    if (e.nodes.has(t)) {
      var r = e.nodes.get(t);
      if (r.size === 1) {
        e.nodes.delete(t);
        return;
      }
      r.delete(n);
    }
  }, this.emit = function(t, n) {
    n(t, e.nodes.get(t));
  }, this.nodes = /* @__PURE__ */ new Map();
}, bc = new gP();
function yP(e, t) {
  var n = R.useRef(), r = R.useRef(!1);
  xl(function() {
    if (n.current = t, r.current) {
      var i = jm(e) ? e.current : e;
      bc.emit(i, Ch);
    }
    r.current = !0;
  }, [t]), xl(function() {
    var i = jm(e) ? e.current : e;
    return bc.add(i, n), bc.emit(i, Ch), function() {
      bc.del(i, n), bc.emit(i, Ch);
    };
  }, [e]);
}
function lo(e) {
  var t = R.useRef(function() {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering...");
  });
  return xl(function() {
    t.current = e;
  }, [e]), R.useCallback(function() {
    var n = t.current;
    return n.apply(void 0, arguments);
  }, [t]);
}
function Zc(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function qa(e, t) {
  var n = R.useCallback(function(r) {
    n.current = r, Zc(e, r), Zc(t, r);
  }, [e, t]);
  return n;
}
function vP(e) {
  var t = R.useRef();
  return R.useEffect(function() {
    t.current = e;
  }), t.current;
}
var Rr = Pl(function(e, t) {
  return Xc(e) ? Fb(e, t) : [];
}), cu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.size, o = rt(a, "icons", r), s = nt(cu, e), l = lt(e, {
    defaultAs: "i"
  });
  return /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), vt(n) ? i : n);
});
cu.handledProps = ["as", "children", "className", "content", "size"];
cu.displayName = "IconGroup";
cu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Size of the icon group. */
  size: g.oneOf(Rr(Or, "medium"))
} : {};
function bP(e) {
  var t = {}, n = e["aria-label"], r = e["aria-hidden"];
  return Tt(n) ? t["aria-hidden"] = "true" : t["aria-label"] = n, Tt(r) || (t["aria-hidden"] = r), t;
}
var uu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.bordered, r = e.circular, i = e.className, a = e.color, o = e.corner, s = e.disabled, l = e.fitted, c = e.flipped, d = e.inverted, p = e.link, y = e.loading, f = e.name, N = e.rotated, b = e.size, S = rt(a, f, b, ue(n, "bordered"), ue(r, "circular"), ue(s, "disabled"), ue(l, "fitted"), ue(d, "inverted"), ue(p, "link"), ue(y, "loading"), mn(o, "corner"), Dr(c, "flipped"), Dr(N, "rotated"), "icon", i), _ = nt(uu, e), E = lt(e, {
    defaultAs: "i"
  }), k = bP(e), M = lo(function(F) {
    if (s) {
      F.preventDefault();
      return;
    }
    Ze(e, "onClick", F, e);
  });
  return /* @__PURE__ */ R.createElement(E, Pe({}, _, k, {
    className: S,
    onClick: M,
    ref: t
  }));
});
uu.handledProps = ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"];
uu.displayName = "Icon";
uu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Formatted to appear bordered. */
  bordered: g.bool,
  /** Icon can formatted to appear circular. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** Color of the icon. */
  color: g.oneOf(Fi),
  /** Icons can display a smaller corner icon. */
  corner: g.oneOfType([g.bool, g.oneOf(["top left", "top right", "bottom left", "bottom right"])]),
  /** Show that the icon is inactive. */
  disabled: g.bool,
  /** Fitted, without space to left or right of Icon. */
  fitted: g.bool,
  /** Icon can be flipped. */
  flipped: g.oneOf(["horizontally", "vertically"]),
  /** Formatted to have its colors inverted for contrast. */
  inverted: g.bool,
  /** Icon can be formatted as a link. */
  link: g.bool,
  /** Icon can be used as a simple loader. */
  loading: g.bool,
  /** Name of the icon. */
  name: Vb(dP),
  /** Icon can rotated. */
  rotated: g.oneOf(["clockwise", "counterclockwise"]),
  /** Size of the icon. */
  size: g.oneOf(Rr(Or, "medium")),
  /** Icon can have an aria label. */
  "aria-hidden": g.string,
  /** Icon can have an aria label. */
  "aria-label": g.string
} : {};
var $t = /* @__PURE__ */ R.memo(uu);
$t.Group = cu;
$t.create = Vt($t, function(e) {
  return {
    name: e
  };
});
var F5 = function(e) {
  return e !== null && !Array.isArray(e) && typeof e == "object";
}, Sf = {
  // ----------------------------------------
  // By Code
  // ----------------------------------------
  3: "Cancel",
  6: "Help",
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  28: "Convert",
  29: "NonConvert",
  30: "Accept",
  31: "ModeChange",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  41: "Select",
  42: "Print",
  43: "Execute",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  48: ["0", ")"],
  49: ["1", "!"],
  50: ["2", "@"],
  51: ["3", "#"],
  52: ["4", "$"],
  53: ["5", "%"],
  54: ["6", "^"],
  55: ["7", "&"],
  56: ["8", "*"],
  57: ["9", "("],
  91: "OS",
  93: "ContextMenu",
  144: "NumLock",
  145: "ScrollLock",
  181: "VolumeMute",
  182: "VolumeDown",
  183: "VolumeUp",
  186: [";", ":"],
  187: ["=", "+"],
  188: [",", "<"],
  189: ["-", "_"],
  190: [".", ">"],
  191: ["/", "?"],
  192: ["`", "~"],
  219: ["[", "{"],
  220: ["\\", "|"],
  221: ["]", "}"],
  222: ["'", '"'],
  224: "Meta",
  225: "AltGraph",
  246: "Attn",
  247: "CrSel",
  248: "ExSel",
  249: "EraseEof",
  250: "Play",
  251: "ZoomOut"
};
for (var Ud = 0; Ud < 24; Ud += 1)
  Sf[112 + Ud] = "F" + (Ud + 1);
for (var Oh = 0; Oh < 26; Oh += 1) {
  var jh = Oh + 65;
  Sf[jh] = [String.fromCharCode(jh + 32), String.fromCharCode(jh)];
}
var Ke = {
  codes: Sf,
  /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */
  getCode: function(e) {
    return F5(e) ? e.keyCode || e.which || this[e.key] : this[e];
  },
  /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */
  getKey: function(e) {
    var t = F5(e);
    if (t && e.key)
      return e.key;
    var n = Sf[t ? e.keyCode || e.which : e];
    return Array.isArray(n) && (t ? n = n[e.shiftKey ? 1 : 0] : n = n[0]), n;
  },
  // ----------------------------------------
  // By Name
  // ----------------------------------------
  // declare these manually for static analysis
  Cancel: 3,
  Help: 6,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Enter: 13,
  Shift: 16,
  Control: 17,
  Alt: 18,
  Pause: 19,
  CapsLock: 20,
  Escape: 27,
  Convert: 28,
  NonConvert: 29,
  Accept: 30,
  ModeChange: 31,
  " ": 32,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Select: 41,
  Print: 42,
  Execute: 43,
  PrintScreen: 44,
  Insert: 45,
  Delete: 46,
  0: 48,
  ")": 48,
  1: 49,
  "!": 49,
  2: 50,
  "@": 50,
  3: 51,
  "#": 51,
  4: 52,
  $: 52,
  5: 53,
  "%": 53,
  6: 54,
  "^": 54,
  7: 55,
  "&": 55,
  8: 56,
  "*": 56,
  9: 57,
  "(": 57,
  a: 65,
  A: 65,
  b: 66,
  B: 66,
  c: 67,
  C: 67,
  d: 68,
  D: 68,
  e: 69,
  E: 69,
  f: 70,
  F: 70,
  g: 71,
  G: 71,
  h: 72,
  H: 72,
  i: 73,
  I: 73,
  j: 74,
  J: 74,
  k: 75,
  K: 75,
  l: 76,
  L: 76,
  m: 77,
  M: 77,
  n: 78,
  N: 78,
  o: 79,
  O: 79,
  p: 80,
  P: 80,
  q: 81,
  Q: 81,
  r: 82,
  R: 82,
  s: 83,
  S: 83,
  t: 84,
  T: 84,
  u: 85,
  U: 85,
  v: 86,
  V: 86,
  w: 87,
  W: 87,
  x: 88,
  X: 88,
  y: 89,
  Y: 89,
  z: 90,
  Z: 90,
  OS: 91,
  ContextMenu: 93,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NumLock: 144,
  ScrollLock: 145,
  VolumeMute: 181,
  VolumeDown: 182,
  VolumeUp: 183,
  ";": 186,
  ":": 186,
  "=": 187,
  "+": 187,
  ",": 188,
  "<": 188,
  "-": 189,
  _: 189,
  ".": 190,
  ">": 190,
  "/": 191,
  "?": 191,
  "`": 192,
  "~": 192,
  "[": 219,
  "{": 219,
  "\\": 220,
  "|": 220,
  "]": 221,
  "}": 221,
  "'": 222,
  '"': 222,
  Meta: 224,
  AltGraph: 225,
  Attn: 246,
  CrSel: 247,
  ExSel: 248,
  EraseEof: 249,
  Play: 250,
  ZoomOut: 251
};
Ke.Spacebar = Ke[" "];
Ke.Digit0 = Ke[0];
Ke.Digit1 = Ke[1];
Ke.Digit2 = Ke[2];
Ke.Digit3 = Ke[3];
Ke.Digit4 = Ke[4];
Ke.Digit5 = Ke[5];
Ke.Digit6 = Ke[6];
Ke.Digit7 = Ke[7];
Ke.Digit8 = Ke[8];
Ke.Digit9 = Ke[9];
Ke.Tilde = Ke["~"];
Ke.GraveAccent = Ke["`"];
Ke.ExclamationPoint = Ke["!"];
Ke.AtSign = Ke["@"];
Ke.PoundSign = Ke["#"];
Ke.PercentSign = Ke["%"];
Ke.Caret = Ke["^"];
Ke.Ampersand = Ke["&"];
Ke.PlusSign = Ke["+"];
Ke.MinusSign = Ke["-"];
Ke.EqualsSign = Ke["="];
Ke.DivisionSign = Ke["/"];
Ke.MultiplicationSign = Ke["*"];
Ke.Comma = Ke[","];
Ke.Decimal = Ke["."];
Ke.Colon = Ke[":"];
Ke.Semicolon = Ke[";"];
Ke.Pipe = Ke["|"];
Ke.BackSlash = Ke["\\"];
Ke.QuestionMark = Ke["?"];
Ke.SingleQuote = Ke["'"];
Ke.DoubleQuote = Ke['"'];
Ke.LeftCurlyBrace = Ke["{"];
Ke.RightCurlyBrace = Ke["}"];
Ke.LeftParenthesis = Ke["("];
Ke.RightParenthesis = Ke[")"];
Ke.LeftAngleBracket = Ke["<"];
Ke.RightAngleBracket = Ke[">"];
Ke.LeftSquareBracket = Ke["["];
Ke.RightSquareBracket = Ke["]"];
var wP = Ke;
const lr = /* @__PURE__ */ ha(wP);
function xP(e) {
  if (R.Children.only(e), Zf.isFragment(e))
    throw new Error('An "React.Fragment" cannot be used as a `trigger`.');
}
function _P(e, t) {
  var n = qa(e == null ? void 0 : e.ref, t);
  return e ? (process.env.NODE_ENV !== "production" && xP(e), [n, /* @__PURE__ */ R.cloneElement(e, {
    ref: n
  })]) : [n, null];
}
function Jb(e, t) {
  var n = qa(e.ref, t);
  if (/* @__PURE__ */ R.isValidElement(e)) {
    if (mj.isForwardRef(e))
      return /* @__PURE__ */ R.cloneElement(e, {
        ref: n
      });
    if (typeof e.type == "string")
      return /* @__PURE__ */ R.cloneElement(e, {
        ref: n
      });
  }
  return /* @__PURE__ */ R.createElement("div", {
    "data-suir-portal": "true",
    ref: n
  }, e);
}
Jb.handledProps = [];
var du = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = lo(function() {
    return Ze(e, "onMount", null, e);
  }), r = lo(function() {
    return Ze(e, "onUnmount", null, e);
  }), i = Jb(e.children, t);
  return R.useEffect(function() {
    return n(), function() {
      r();
    };
  }, []), ss() ? /* @__PURE__ */ b_(i, e.mountNode || document.body) : null;
});
du.handledProps = ["children", "mountNode", "onMount", "onUnmount"];
du.displayName = "PortalInner";
du.propTypes = {
  /** Primary content. */
  children: g.node.isRequired,
  /** The node where the portal should mount. */
  mountNode: g.any,
  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: g.func,
  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: g.func
};
function ca(e) {
  var t = e.children, n = e.closeOnDocumentClick, r = n === void 0 ? !0 : n, i = e.closeOnEscape, a = i === void 0 ? !0 : i, o = e.closeOnPortalMouseLeave, s = e.closeOnTriggerBlur, l = e.closeOnTriggerClick, c = e.closeOnTriggerMouseLeave, d = e.eventPool, p = d === void 0 ? "default" : d, y = e.mountNode, f = e.mouseEnterDelay, N = e.mouseLeaveDelay, b = e.openOnTriggerClick, S = b === void 0 ? !0 : b, _ = e.openOnTriggerFocus, E = e.openOnTriggerMouseEnter, k = hs({
    state: e.open,
    defaultState: e.defaultOpen,
    initialState: !1
  }), M = k[0], F = k[1], q = R.useRef(), j = _P(e.trigger, e.triggerRef), x = j[0], C = j[1], D = R.useRef(), P = R.useRef(), L = R.useRef(), H = function(ee) {
    F(!0), Ze(e, "onOpen", ee, Pe({}, e, {
      open: !0
    }));
  }, $ = function(ee, te) {
    var ne = Pe({}, ee);
    return setTimeout(function() {
      return H(ne);
    }, te || 0);
  }, ae = function(ee) {
    F(!1), Ze(e, "onClose", ee, Pe({}, e, {
      open: !1
    }));
  }, ce = function(ee, te) {
    var ne = Pe({}, ee);
    return setTimeout(function() {
      return ae(ne);
    }, te || 0);
  };
  R.useEffect(function() {
    clearTimeout(D.current), clearTimeout(P.current);
  }, []);
  var le = function(ee) {
    L.current = ee;
  }, oe = function(ee) {
    var te, ne = L.current;
    L.current = null;
    var ve = ls(x.current, ee), _e = ne && ls(q.current, ne), pe = ls(q.current, ee);
    !((te = q.current) != null && te.contains) || // no portal
    ve || _e || pe || r && ae(ee);
  }, se = function(ee) {
    a && lr.getCode(ee) === lr.Escape && ae(ee);
  }, J = function(ee) {
    o && ee.target === q.current && (P.current = ce(ee, N));
  }, re = function() {
    o && clearTimeout(P.current);
  }, I = function(ee) {
    for (var te = arguments.length, ne = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
      ne[ve - 1] = arguments[ve];
    Ze.apply(void 0, [C, "props.onBlur", ee].concat(ne));
    var _e = ee.relatedTarget || document.activeElement, pe = Ze(q.current, "contains", _e);
    !s || pe || ae(ee);
  }, U = function(ee) {
    for (var te = arguments.length, ne = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
      ne[ve - 1] = arguments[ve];
    Ze.apply(void 0, [C, "props.onClick", ee].concat(ne)), M && l ? ae(ee) : !M && S && H(ee);
  }, G = function(ee) {
    for (var te = arguments.length, ne = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
      ne[ve - 1] = arguments[ve];
    Ze.apply(void 0, [C, "props.onFocus", ee].concat(ne)), _ && H(ee);
  }, K = function(ee) {
    clearTimeout(D.current);
    for (var te = arguments.length, ne = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
      ne[ve - 1] = arguments[ve];
    Ze.apply(void 0, [C, "props.onMouseLeave", ee].concat(ne)), c && (P.current = ce(ee, N));
  }, A = function(ee) {
    clearTimeout(P.current);
    for (var te = arguments.length, ne = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
      ne[ve - 1] = arguments[ve];
    Ze.apply(void 0, [C, "props.onMouseEnter", ee].concat(ne)), E && (D.current = $(ee, f));
  };
  return /* @__PURE__ */ R.createElement(R.Fragment, null, M && /* @__PURE__ */ R.createElement(R.Fragment, null, /* @__PURE__ */ R.createElement(du, {
    mountNode: y,
    onMount: function() {
      return Ze(e, "onMount", null, e);
    },
    onUnmount: function() {
      return Ze(e, "onUnmount", null, e);
    },
    ref: q
  }, t), /* @__PURE__ */ R.createElement(ja, {
    name: "mouseleave",
    on: J,
    pool: p,
    target: q
  }), /* @__PURE__ */ R.createElement(ja, {
    name: "mouseenter",
    on: re,
    pool: p,
    target: q
  }), /* @__PURE__ */ R.createElement(ja, {
    name: "mousedown",
    on: le,
    pool: p
  }), /* @__PURE__ */ R.createElement(ja, {
    name: "click",
    on: oe,
    pool: p
  }), /* @__PURE__ */ R.createElement(ja, {
    name: "keydown",
    on: se,
    pool: p
  })), C && /* @__PURE__ */ R.cloneElement(C, {
    onBlur: I,
    onClick: U,
    onFocus: G,
    onMouseLeave: K,
    onMouseEnter: A,
    ref: x
  }));
}
ca.handledProps = ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"];
ca.displayName = "Portal";
ca.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Primary content. */
  children: g.node.isRequired,
  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: g.bool,
  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: g.bool,
  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: g.bool,
  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: g.bool,
  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: g.bool,
  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: g.bool,
  /** Initial value of open. */
  defaultOpen: g.bool,
  /** Event pool namespace that is used to handle component events */
  eventPool: g.string,
  /** The node where the portal should mount. */
  mountNode: g.any,
  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: g.number,
  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: g.number,
  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: g.func,
  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: g.func,
  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: g.func,
  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: g.func,
  /** Controls whether or not the portal is displayed. */
  open: g.bool,
  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: g.bool,
  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: g.bool,
  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: g.bool,
  /** Element to be rendered in-place where the portal is defined. */
  trigger: g.node,
  /** Called with a ref to the trigger node. */
  triggerRef: tj
} : {};
ca.Inner = du;
var fu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.blurring, r = e.className, i = e.children, a = e.content, o = e.dimmed, s = rt(ue(n, "blurring"), ue(o, "dimmed"), "dimmable", r), l = nt(fu, e), c = lt(e);
  return /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    className: s,
    ref: t
  }), vt(i) ? a : i);
});
fu.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"];
fu.displayName = "DimmerDimmable";
fu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A dimmable element can blur its contents. */
  blurring: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Controls whether or not the dim is displayed. */
  dimmed: g.bool
} : {};
var ms = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.content, o = e.disabled, s = e.inverted, l = e.page, c = e.simple, d = e.verticalAlign, p = qa(t, R.useRef()), y = R.useRef();
  xl(function() {
    var E;
    (E = p.current) != null && E.style && (n ? p.current.style.setProperty("display", "flex", "important") : p.current.style.removeProperty("display"));
  }, [n]);
  var f = function(E) {
    Ze(e, "onClick", E, e), !(y.current !== E.target && ls(y.current, E)) && Ze(e, "onClickOutside", E, e);
  }, N = rt("ui", ue(n, "active transition visible"), ue(o, "disabled"), ue(s, "inverted"), ue(l, "page"), ue(c, "simple"), Ro(d), "dimmer", i), b = nt(ms, e), S = lt(e), _ = vt(r) ? a : r;
  return /* @__PURE__ */ R.createElement(S, Pe({}, b, {
    className: N,
    onClick: f,
    ref: p
  }), _ && /* @__PURE__ */ R.createElement("div", {
    className: "content",
    ref: y
  }, _));
});
ms.handledProps = ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"];
ms.displayName = "DimmerInner";
ms.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** An active dimmer will dim its parent container. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A disabled dimmer cannot be activated */
  disabled: g.bool,
  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /**
   * Handles click outside Dimmer's content, but inside Dimmer area.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClickOutside: g.func,
  /** A dimmer can be formatted to have its colors inverted. */
  inverted: g.bool,
  /** A dimmer can be formatted to be fixed to the page. */
  page: g.bool,
  /** A dimmer can be controlled with simple prop. */
  simple: g.bool,
  /** A dimmer can have its content top or bottom aligned. */
  verticalAlign: g.oneOf(["bottom", "top"])
} : {};
var Fa = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.page, i = nt(Fa, e);
  if (r) {
    var a = function() {
      ss() && (document.body.classList.add("dimmed"), document.body.classList.add("dimmable"));
    }, o = function() {
      ss() && (document.body.classList.remove("dimmed"), document.body.classList.remove("dimmable"));
    };
    return /* @__PURE__ */ R.createElement(ca, {
      closeOnEscape: !1,
      closeOnDocumentClick: !1,
      onMount: a,
      onUnmount: o,
      open: n,
      openOnTriggerClick: !1
    }, /* @__PURE__ */ R.createElement(ms, Pe({}, i, {
      active: n,
      page: r,
      ref: t
    })));
  }
  return /* @__PURE__ */ R.createElement(ms, Pe({}, i, {
    active: n,
    page: r,
    ref: t
  }));
});
Fa.handledProps = ["active", "page"];
Fa.displayName = "Dimmer";
Fa.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An active dimmer will dim its parent container. */
  active: g.bool,
  /** A dimmer can be formatted to be fixed to the page. */
  page: g.bool
} : {};
Fa.Dimmable = fu;
Fa.Inner = ms;
Fa.create = Vt(Fa, function(e) {
  return {
    content: e
  };
});
var pu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.size, o = rt("ui", a, r, "images"), s = nt(pu, e), l = lt(e);
  return /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), vt(n) ? i : n);
});
pu.handledProps = ["as", "children", "className", "content", "size"];
pu.displayName = "ImageGroup";
pu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A group of images can be formatted to have the same size. */
  size: g.oneOf(Or)
} : {};
var ua = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.avatar, r = e.bordered, i = e.centered, a = e.children, o = e.circular, s = e.className, l = e.content, c = e.dimmer, d = e.disabled, p = e.floated, y = e.fluid, f = e.hidden, N = e.href, b = e.inline, S = e.label, _ = e.rounded, E = e.size, k = e.spaced, M = e.verticalAlign, F = e.wrapped, q = e.ui, j = q === void 0 ? !0 : q, x = rt(ue(j, "ui"), E, ue(n, "avatar"), ue(r, "bordered"), ue(o, "circular"), ue(i, "centered"), ue(d, "disabled"), ue(y, "fluid"), ue(f, "hidden"), ue(b, "inline"), ue(_, "rounded"), mn(k, "spaced"), Dr(p, "floated"), Ro(M), "image", s), C = nt(ua, e), D = Fg(C, {
    htmlProps: Nj
  }), P = D[0], L = D[1], H = lt(e, {
    defaultAs: "img",
    getDefault: function() {
      if (!Tt(c) || !Tt(S) || !Tt(F) || !vt(a))
        return "div";
    }
  });
  return vt(a) ? vt(l) ? H === "img" ? /* @__PURE__ */ R.createElement(H, Pe({}, L, P, {
    className: x,
    ref: t
  })) : /* @__PURE__ */ R.createElement(H, Pe({}, L, {
    className: x,
    href: N
  }), Fa.create(c, {
    autoGenerateKey: !1
  }), Mr.create(S, {
    autoGenerateKey: !1
  }), /* @__PURE__ */ R.createElement("img", Pe({}, P, {
    ref: t
  }))) : /* @__PURE__ */ R.createElement(H, Pe({}, C, {
    className: x,
    ref: t
  }), l) : /* @__PURE__ */ R.createElement(H, Pe({}, C, {
    className: x,
    ref: t
  }), a);
});
ua.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"];
ua.Group = pu;
ua.displayName = "Image";
ua.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** An image may be formatted to appear inline with text as an avatar. */
  avatar: g.bool,
  /** An image may include a border to emphasize the edges of white or transparent content. */
  bordered: g.bool,
  /** An image can appear centered in a content block. */
  centered: g.bool,
  /** Primary content. */
  children: g.node,
  /** An image may appear circular. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** An image can show that it is disabled and cannot be selected. */
  disabled: g.bool,
  /** Shorthand for Dimmer. */
  dimmer: kt,
  /** An image can sit to the left or right of other content. */
  floated: g.oneOf(lu),
  /** An image can take up the width of its container. */
  fluid: qt([g.bool, Jt(["size"])]),
  /** An image can be hidden. */
  hidden: g.bool,
  /** Renders the Image as an <a> tag with this href. */
  href: g.string,
  /** An image may appear inline. */
  inline: g.bool,
  /** Shorthand for Label. */
  label: kt,
  /** An image may appear rounded. */
  rounded: g.bool,
  /** An image may appear at different sizes. */
  size: g.oneOf(Or),
  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
  spaced: g.oneOfType([g.bool, g.oneOf(["left", "right"])]),
  /** Whether or not to add the ui className. */
  ui: g.bool,
  /** An image can specify its vertical alignment. */
  verticalAlign: g.oneOf(_s),
  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
  wrapped: g.bool
} : {};
ua.create = Vt(ua, function(e) {
  return {
    src: e
  };
});
var co = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("detail", r), o = nt(co, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
co.handledProps = ["as", "children", "className", "content"];
co.displayName = "LabelDetail";
co.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
co.create = Vt(co, function(e) {
  return {
    content: e
  };
});
var hu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.circular, i = e.className, a = e.color, o = e.content, s = e.size, l = e.tag, c = rt("ui", a, s, ue(r, "circular"), ue(l, "tag"), "labels", i), d = nt(hu, e), p = lt(e);
  return /* @__PURE__ */ R.createElement(p, Pe({}, d, {
    className: c,
    ref: t
  }), vt(n) ? o : n);
});
hu.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"];
hu.displayName = "LabelGroup";
hu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Labels can share shapes. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** Label group can share colors together. */
  color: g.oneOf(Fi),
  /** Shorthand for primary content. */
  content: Lt,
  /** Label group can share sizes together. */
  size: g.oneOf(Or),
  /** Label group can share tag formatting. */
  tag: g.bool
} : {};
var Mr = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.attached, i = e.basic, a = e.children, o = e.circular, s = e.className, l = e.color, c = e.content, d = e.corner, p = e.detail, y = e.empty, f = e.floating, N = e.horizontal, b = e.icon, S = e.image, _ = e.onRemove, E = e.pointing, k = e.prompt, M = e.removeIcon, F = e.ribbon, q = e.size, j = e.tag, x = E === !0 && "pointing" || (E === "left" || E === "right") && E + " pointing" || (E === "above" || E === "below") && "pointing " + E, C = rt("ui", l, x, q, ue(n, "active"), ue(i, "basic"), ue(o, "circular"), ue(y, "empty"), ue(f, "floating"), ue(N, "horizontal"), ue(S === !0, "image"), ue(k, "prompt"), ue(j, "tag"), mn(d, "corner"), mn(F, "ribbon"), Dr(r, "attached"), "label", s), D = nt(Mr, e), P = lt(e), L = lo(function($) {
    Ze(e, "onClick", $, e);
  });
  if (!vt(a))
    return /* @__PURE__ */ R.createElement(P, Pe({}, D, {
      className: C,
      onClick: L,
      ref: t
    }), a);
  var H = pl(M) ? "delete" : M;
  return /* @__PURE__ */ R.createElement(P, Pe({}, D, {
    className: C,
    onClick: L,
    ref: t
  }), $t.create(b, {
    autoGenerateKey: !1
  }), typeof S != "boolean" && ua.create(S, {
    autoGenerateKey: !1
  }), c, co.create(p, {
    autoGenerateKey: !1
  }), _ && $t.create(H, {
    autoGenerateKey: !1,
    overrideProps: function($) {
      return {
        onClick: function(ae) {
          Ze($, "onClick", ae), Ze(e, "onRemove", ae, e);
        }
      };
    }
  }));
});
Mr.handledProps = ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"];
Mr.displayName = "Label";
Mr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A label can be active. */
  active: g.bool,
  /** A label can attach to a content segment. */
  attached: g.oneOf(["top", "bottom", "top right", "top left", "bottom left", "bottom right"]),
  /** A label can reduce its complexity. */
  basic: g.bool,
  /** Primary content. */
  children: g.node,
  /** A label can be circular. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** Color of the label. */
  color: g.oneOf(Fi),
  /** Shorthand for primary content. */
  content: Lt,
  /** A label can position itself in the corner of an element. */
  corner: g.oneOfType([g.bool, g.oneOf(["left", "right"])]),
  /** Shorthand for LabelDetail. */
  detail: kt,
  /** Formats the label as a dot. */
  empty: qt([g.bool, oo(["circular"])]),
  /** Float above another element in the upper right corner. */
  floating: g.bool,
  /** A horizontal label is formatted to label content along-side it horizontally. */
  horizontal: g.bool,
  /** Shorthand for Icon. */
  icon: kt,
  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
  image: g.oneOfType([g.bool, kt]),
  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /**
   * Adds an "x" icon, called when "x" is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onRemove: g.func,
  /** A label can point to content next to it. */
  pointing: g.oneOfType([g.bool, g.oneOf(["above", "below", "left", "right"])]),
  /** A label can prompt for an error in your forms. */
  prompt: g.bool,
  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
  removeIcon: kt,
  /** A label can appear as a ribbon attaching itself to an element. */
  ribbon: g.oneOfType([g.bool, g.oneOf(["right"])]),
  /** A label can have different sizes. */
  size: g.oneOf(Or),
  /** A label can appear as a tag. */
  tag: g.bool
} : {};
Mr.Detail = co;
Mr.Group = hu;
Mr.create = Vt(Mr, function(e) {
  return {
    content: e
  };
});
var mu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.hidden, o = e.visible, s = rt(ue(o, "visible"), ue(a, "hidden"), "content", r), l = nt(mu, e), c = lt(e);
  return /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    className: s,
    ref: t
  }), vt(n) ? i : n);
});
mu.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
mu.displayName = "ButtonContent";
mu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Initially hidden, visible on hover. */
  hidden: g.bool,
  /** Initially visible, hidden on hover. */
  visible: g.bool
} : {};
var gu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.attached, r = e.basic, i = e.buttons, a = e.children, o = e.className, s = e.color, l = e.compact, c = e.content, d = e.floated, p = e.fluid, y = e.icon, f = e.inverted, N = e.labeled, b = e.negative, S = e.positive, _ = e.primary, E = e.secondary, k = e.size, M = e.toggle, F = e.vertical, q = e.widths, j = rt("ui", s, k, ue(r, "basic"), ue(l, "compact"), ue(p, "fluid"), ue(y, "icon"), ue(f, "inverted"), ue(N, "labeled"), ue(b, "negative"), ue(S, "positive"), ue(_, "primary"), ue(E, "secondary"), ue(M, "toggle"), ue(F, "vertical"), mn(n, "attached"), Dr(d, "floated"), kr(q), "buttons", o), x = nt(gu, e), C = lt(e);
  return Tt(i) ? /* @__PURE__ */ R.createElement(C, Pe({}, x, {
    className: j,
    ref: t
  }), vt(a) ? c : a) : /* @__PURE__ */ R.createElement(C, Pe({}, x, {
    className: j,
    ref: t
  }), Hn(i, function(D) {
    return Ft.create(D);
  }));
});
gu.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"];
gu.displayName = "ButtonGroup";
gu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Groups can be attached to other content. */
  attached: g.oneOfType([g.bool, g.oneOf(["left", "right", "top", "bottom"])]),
  /** Groups can be less pronounced. */
  basic: g.bool,
  /** Array of shorthand Button values. */
  buttons: xs,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Groups can have a shared color. */
  color: g.oneOf(Fi),
  /** Groups can reduce their padding to fit into tighter spaces. */
  compact: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** Groups can be aligned to the left or right of its container. */
  floated: g.oneOf(lu),
  /** Groups can take the width of their container. */
  fluid: g.bool,
  /** Groups can be formatted as icons. */
  icon: g.bool,
  /** Groups can be formatted to appear on dark backgrounds. */
  inverted: g.bool,
  /** Groups can be formatted as labeled icon buttons. */
  labeled: g.bool,
  /** Groups can hint towards a negative consequence. */
  negative: g.bool,
  /** Groups can hint towards a positive consequence. */
  positive: g.bool,
  /** Groups can be formatted to show different levels of emphasis. */
  primary: g.bool,
  /** Groups can be formatted to show different levels of emphasis. */
  secondary: g.bool,
  /** Groups can have different sizes. */
  size: g.oneOf(Or),
  /** Groups can be formatted to toggle on and off. */
  toggle: g.bool,
  /** Groups can be formatted to appear vertically. */
  vertical: g.bool,
  /** Groups can have their widths divided evenly. */
  widths: g.oneOf(Yr)
} : {};
var yu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.text, i = rt("or", n), a = nt(yu, e), o = lt(e);
  return /* @__PURE__ */ R.createElement(o, Pe({}, a, {
    className: i,
    "data-text": r,
    ref: t
  }));
});
yu.handledProps = ["as", "className", "text"];
yu.displayName = "ButtonOr";
yu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Additional classes. */
  className: g.string,
  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: g.oneOfType([g.number, g.string])
} : {};
function NP(e, t) {
  if (!Tt(t))
    return t;
  if (e !== "button")
    return "button";
}
function SP(e, t, n) {
  if (!Tt(n))
    return n;
  if (t)
    return -1;
  if (e === "div")
    return 0;
}
function EP(e) {
  var t = e.children, n = e.content, r = e.icon, i = e.labelPosition;
  if (r === !0)
    return !0;
  if (r)
    return i || vt(t) && Tt(n);
}
var Ft = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.animated, i = e.attached, a = e.basic, o = e.children, s = e.circular, l = e.className, c = e.color, d = e.compact, p = e.content, y = e.disabled, f = e.floated, N = e.fluid, b = e.icon, S = e.inverted, _ = e.label, E = e.labelPosition, k = e.loading, M = e.negative, F = e.positive, q = e.primary, j = e.secondary, x = e.size, C = e.toggle, D = e.type, P = qa(t, R.useRef()), L = rt(c, x, ue(n, "active"), ue(a, "basic"), ue(s, "circular"), ue(d, "compact"), ue(N, "fluid"), ue(EP(e), "icon"), ue(S, "inverted"), ue(k, "loading"), ue(M, "negative"), ue(F, "positive"), ue(q, "primary"), ue(j, "secondary"), ue(C, "toggle"), mn(r, "animated"), mn(i, "attached")), H = rt(mn(E || !!_, "labeled")), $ = rt(ue(y, "disabled"), Dr(f, "floated")), ae = nt(Ft, e), ce = lt(e, {
    defaultAs: "button",
    getDefault: function() {
      if (!Tt(i) || !Tt(_))
        return "div";
    }
  }), le = SP(ce, y, e.tabIndex), oe = function(K) {
    if (y) {
      K.preventDefault();
      return;
    }
    Ze(e, "onClick", K, e);
  };
  if (!Tt(_)) {
    var se = rt("ui", L, "button", l), J = rt("ui", H, "button", l, $), re = Mr.create(_, {
      defaultProps: {
        basic: !0,
        pointing: E === "left" ? "right" : "left"
      },
      autoGenerateKey: !1
    });
    return /* @__PURE__ */ R.createElement(ce, Pe({}, ae, {
      className: J,
      onClick: oe
    }), E === "left" && re, /* @__PURE__ */ R.createElement("button", {
      className: se,
      "aria-pressed": C ? !!n : void 0,
      disabled: y,
      tabIndex: le,
      type: D,
      ref: P
    }, $t.create(b, {
      autoGenerateKey: !1
    }), " ", p), (E === "right" || !E) && re);
  }
  var I = rt("ui", L, $, H, "button", l), U = !vt(o), G = NP(ce, e.role);
  return /* @__PURE__ */ R.createElement(ce, Pe({}, ae, {
    className: I,
    "aria-pressed": C ? !!n : void 0,
    disabled: y && ce === "button" || void 0,
    onClick: oe,
    role: G,
    tabIndex: le,
    type: D,
    ref: P
  }), U && o, !U && $t.create(b, {
    autoGenerateKey: !1
  }), !U && p);
});
Ft.handledProps = ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle", "type"];
Ft.displayName = "Button";
Ft.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A button can show it is currently the active user selection. */
  active: g.bool,
  /** A button can animate to show hidden content. */
  animated: g.oneOfType([g.bool, g.oneOf(["fade", "vertical"])]),
  /** A button can be attached to other content. */
  attached: g.oneOfType([g.bool, g.oneOf(["left", "right", "top", "bottom"])]),
  /** A basic button is less pronounced. */
  basic: g.bool,
  /** Primary content. */
  children: qt([g.node, Jt(["label"]), Wb({
    icon: g.oneOfType([g.string.isRequired, g.object.isRequired, g.element.isRequired])
  }, Jt(["icon"]))]),
  /** A button can be circular. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** A button can have different colors */
  color: g.oneOf([].concat(Fi, ["facebook", "google plus", "instagram", "linkedin", "twitter", "vk", "youtube"])),
  /** A button can reduce its padding to fit into tighter spaces. */
  compact: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** A button can show it is currently unable to be interacted with. */
  disabled: g.bool,
  /** A button can be aligned to the left or right of its container. */
  floated: g.oneOf(lu),
  /** A button can take the width of its container. */
  fluid: g.bool,
  /** Add an Icon by name, props object, or pass an <Icon />. */
  icon: g.oneOfType([g.bool, g.string, g.object, g.element]),
  /** A button can be formatted to appear on dark backgrounds. */
  inverted: g.bool,
  /** Add a Label by text, props object, or pass a <Label />. */
  label: g.oneOfType([g.string, g.object, g.element]),
  /** A labeled button can format a Label or Icon to appear on the left or right. */
  labelPosition: g.oneOf(["right", "left"]),
  /** A button can show a loading indicator. */
  loading: g.bool,
  /** A button can hint towards a negative consequence. */
  negative: g.bool,
  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /** A button can hint towards a positive consequence. */
  positive: g.bool,
  /** A button can be formatted to show different levels of emphasis. */
  primary: g.bool,
  /** The role of the HTML element. */
  role: g.string,
  /** A button can be formatted to show different levels of emphasis. */
  secondary: g.bool,
  /** A button can have different sizes. */
  size: g.oneOf(Or),
  /** A button can receive focus. */
  tabIndex: g.oneOfType([g.number, g.string]),
  /** A button can be formatted to toggle on and off. */
  toggle: g.bool,
  /** The type of the HTML element. */
  type: g.oneOf(["button", "submit", "reset"])
} : {};
Ft.Content = mu;
Ft.Group = gu;
Ft.Or = yu;
Ft.create = Vt(Ft, function(e) {
  return {
    content: e
  };
});
function Ab(e, t, n, r) {
  var i = -1, a = e == null ? 0 : e.length;
  for (r && a && (n = e[++i]); ++i < a; )
    n = t(n, e[i], i, e);
  return n;
}
function CP(e, t, n, r, i) {
  return i(e, function(a, o, s) {
    n = r ? (r = !1, a) : t(n, a, o, s);
  }), n;
}
function Ig(e, t, n) {
  var r = Rn(e) ? Ab : CP, i = arguments.length < 3;
  return r(e, ko(t), n, i, Ll);
}
var OP = function(e, t, n, r) {
  var i = n ? n.call(r, e, t) : void 0;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  var a = Object.keys(e), o = Object.keys(t);
  if (a.length !== o.length)
    return !1;
  for (var s = Object.prototype.hasOwnProperty.bind(t), l = 0; l < a.length; l++) {
    var c = a[l];
    if (!s(c))
      return !1;
    var d = e[c], p = t[c];
    if (i = n ? n.call(r, d, p, c) : void 0, i === !1 || i === void 0 && d !== p)
      return !1;
  }
  return !0;
};
const Uc = /* @__PURE__ */ ha(OP);
var uo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.actions, r = e.children, i = e.className, a = e.content, o = rt("actions", i), s = nt(uo, e), l = lt(e);
  return vt(r) ? vt(a) ? /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), Hn(n, function(c) {
    return Ft.create(c, {
      overrideProps: function(d) {
        return {
          onClick: function(p, y) {
            Ze(d, "onClick", p, y), Ze(e, "onActionClick", p, y);
          }
        };
      }
    });
  })) : /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o
  }), a) : /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), r);
});
uo.handledProps = ["actions", "as", "children", "className", "content", "onActionClick"];
uo.displayName = "ModalActions";
uo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Array of shorthand buttons. */
  actions: xs,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props from the clicked action.
   */
  onActionClick: qt([Jt(["children"]), g.func])
} : {};
uo.create = Vt(uo, function(e) {
  return {
    actions: e
  };
});
var fo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.image, o = e.scrolling, s = rt(r, ue(a, "image"), ue(o, "scrolling"), "content"), l = nt(fo, e), c = lt(e);
  return /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    className: s,
    ref: t
  }), vt(n) ? i : n);
});
fo.handledProps = ["as", "children", "className", "content", "image", "scrolling"];
fo.displayName = "ModalContent";
fo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A modal can contain image content. */
  image: g.bool,
  /** A modal can use the entire size of the screen. */
  scrolling: g.bool
} : {};
fo.create = Vt(fo, function(e) {
  return {
    content: e
  };
});
var vu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("description", r), o = nt(vu, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
vu.handledProps = ["as", "children", "className", "content"];
vu.displayName = "ModalDescription";
vu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
var po = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.blurring, r = e.children, i = e.className, a = e.centered, o = e.content, s = e.inverted, l = e.mountNode, c = e.scrolling, d = qa(t, R.useRef()), p = rt("ui", ue(s, "inverted"), ue(!a, "top aligned"), "page modals dimmer transition visible active", i), y = rt("dimmable dimmed", ue(n, "blurring"), ue(c, "scrolling")), f = nt(po, e), N = lt(e);
  return yP(l, y), R.useEffect(function() {
    var b;
    (b = d.current) == null || (b = b.style) == null || b.setProperty("display", "flex", "important");
  }, []), /* @__PURE__ */ R.createElement(N, Pe({}, f, {
    className: p,
    ref: d
  }), vt(r) ? o : r);
});
po.handledProps = ["as", "blurring", "centered", "children", "className", "content", "inverted", "mountNode", "scrolling"];
po.displayName = "ModalDimmer";
po.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A dimmer can be blurred. */
  blurring: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A dimmer can center its contents in the viewport. */
  centered: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** A dimmer can be inverted. */
  inverted: g.bool,
  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: g.any,
  /** A dimmer can make body scrollable. */
  scrolling: g.bool
} : {};
po.create = Vt(po, function(e) {
  return {
    content: e
  };
});
var ho = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("header", r), o = nt(ho, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
ho.handledProps = ["as", "children", "className", "content"];
ho.displayName = "ModalHeader";
ho.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
ho.create = Vt(ho, function(e) {
  return {
    content: e
  };
});
var I5 = 0, jP = 50, PP = function(e) {
  var t = e.height + I5, n = e.height + I5, r = window.innerHeight, i = r / 2, a = -(n / 2), o = jP, s = i + a;
  return s + t + o < r;
}, LP = function(e, t, n) {
  var r = t && e ? -(n.height / 2) : 0, i = -(n.width / 2);
  return {
    marginLeft: i,
    marginTop: r
  };
}, TP = function() {
  return !window.ActiveXObject && "ActiveXObject" in window;
}, Kr = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.actions, r = e.basic, i = e.centered, a = i === void 0 ? !0 : i, o = e.children, s = e.className, l = e.closeIcon, c = e.closeOnDimmerClick, d = c === void 0 ? !0 : c, p = e.closeOnDocumentClick, y = p === void 0 ? !1 : p, f = e.content, N = e.dimmer, b = N === void 0 ? !0 : N, S = e.eventPool, _ = S === void 0 ? "Modal" : S, E = e.header, k = e.size, M = e.style, F = e.trigger, q = ss() ? e.mountNode || document.body : null, j = hs({
    state: e.open,
    defaultState: e.defaultOpen,
    initialState: !1
  }), x = j[0], C = j[1], D = R.useState({}), P = D[0], L = D[1], H = R.useState(!1), $ = H[0], ae = H[1], ce = R.useState(function() {
    return ss() && TP();
  }), le = ce[0], oe = qa(t, R.useRef()), se = R.useRef(), J = R.useRef(), re = R.useRef();
  R.useEffect(function() {
    return function() {
      cancelAnimationFrame(J.current), re.current = null;
    };
  }, []);
  var I = function Se() {
    if (oe.current) {
      var be = oe.current.getBoundingClientRect(), X = PP(be);
      ae(!X);
      var Ye = le ? LP(X, a, be) : {};
      Uc(Ye, Ye) || L(Ye);
    }
    J.current = requestAnimationFrame(Se);
  }, U = function(Se) {
    C(!1), Ze(e, "onClose", Se, Pe({}, e, {
      open: !1
    }));
  }, G = function(Se) {
    re.current = Se;
  }, K = function(Se) {
    var be = re.current;
    re.current = null, !(!d || ls(oe.current, be) || ls(oe.current, Se)) && (C(!1), Ze(e, "onClose", Se, Pe({}, e, {
      open: !1
    })));
  }, A = function(Se) {
    C(!0), Ze(e, "onOpen", Se, Pe({}, e, {
      open: !0
    }));
  }, ee = function(Se) {
    ae(!1), I(), Md.sub("mousedown", G, {
      pool: _,
      target: se.current
    }), Md.sub("click", K, {
      pool: _,
      target: se.current
    }), Ze(e, "onMount", Se, e);
  }, te = function(Se) {
    cancelAnimationFrame(J.current), Md.unsub("mousedown", G, {
      pool: _,
      target: se.current
    }), Md.unsub("click", K, {
      pool: _,
      target: se.current
    }), Ze(e, "onUnmount", Se, e);
  }, ne = function(Se) {
    var be = rt("ui", k, ue(r, "basic"), ue(le, "legacy"), ue($, "scrolling"), "modal transition visible active", s), X = lt(e), Ye = l === !0 ? "close" : l, Re = $t.create(Ye, {
      overrideProps: function(Te) {
        return {
          onClick: function(Ue) {
            Ze(Te, "onClick", Ue), U(Ue);
          }
        };
      }
    });
    return /* @__PURE__ */ R.createElement(X, Pe({}, Se, {
      className: be,
      ref: oe,
      style: Pe({}, P, M)
    }), Re, vt(o) ? /* @__PURE__ */ R.createElement(R.Fragment, null, ho.create(E, {
      autoGenerateKey: !1
    }), fo.create(f, {
      autoGenerateKey: !1
    }), uo.create(n, {
      overrideProps: function(Te) {
        return {
          onActionClick: function(Ue, T) {
            Ze(Te, "onActionClick", Ue, T), Ze(e, "onActionClick", Ue, e), U(Ue);
          }
        };
      }
    })) : o);
  };
  if (ne.handledProps = [], !ss())
    return /* @__PURE__ */ R.isValidElement(F) ? F : null;
  var ve = nt(Kr, e), _e = ca.handledProps, pe = Ig(ve, function(Se, be, X) {
    return Ei(_e, X) || (Se[X] = be), Se;
  }, {}), je = Yf(ve, _e);
  return /* @__PURE__ */ R.createElement(ca, Pe({
    closeOnDocumentClick: y
  }, je, {
    trigger: F,
    eventPool: _,
    mountNode: q,
    open: x,
    onClose: U,
    onMount: ee,
    onOpen: A,
    onUnmount: te
  }), po.create(Kf(b) ? b : {}, {
    autoGenerateKey: !1,
    defaultProps: {
      blurring: b === "blurring",
      inverted: b === "inverted"
    },
    overrideProps: {
      children: ne(pe),
      centered: a,
      mountNode: q,
      scrolling: $,
      ref: se
    }
  }));
});
Kr.handledProps = ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"];
Kr.displayName = "Modal";
Kr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
  actions: kt,
  /** A modal can reduce its complexity */
  basic: g.bool,
  /** A modal can be vertically centered in the viewport */
  centered: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for the close icon. Closes the modal on click. */
  closeIcon: g.oneOfType([g.node, g.object, g.bool]),
  /** Whether or not the Modal should close when the dimmer is clicked. */
  closeOnDimmerClick: g.bool,
  /** Whether or not the Modal should close when the document is clicked. */
  closeOnDocumentClick: g.bool,
  /** Simple text content for the Modal. */
  content: kt,
  /** Initial value of open. */
  defaultOpen: g.bool,
  /** A Modal can appear in a dimmer. */
  dimmer: g.oneOfType([g.bool, g.func, g.object, g.oneOf(["inverted", "blurring"])]),
  /** Event pool namespace that is used to handle component events */
  eventPool: g.string,
  /** Modal displayed above the content in bold. */
  header: kt,
  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: g.any,
  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onActionClick: g.func,
  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: g.func,
  /**
   * Called when the modal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: g.func,
  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: g.func,
  /**
   * Called when the modal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: g.func,
  /** Controls whether or not the Modal is displayed. */
  open: g.bool,
  /** A modal can vary in size */
  size: g.oneOf(["mini", "tiny", "small", "large", "fullscreen"]),
  /** Custom styles. */
  style: g.object,
  /** Element to be rendered in-place where the modal is defined. */
  trigger: g.node
  /**
   * NOTE: Any unhandled props that are defined in Modal are passed-through
   * to the inner Portal.
   */
} : {};
Kr.Actions = uo;
Kr.Content = fo;
Kr.Description = vu;
Kr.Dimmer = po;
Kr.Header = ho;
var bu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("header", r), o = nt(bu, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
bu.handledProps = ["as", "children", "className", "content"];
bu.displayName = "MenuHeader";
bu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
function FP(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var IP = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, kP = FP(IP), DP = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, RP = "\\u0300-\\u036f", MP = "\\ufe20-\\ufe2f", UP = "\\u20d0-\\u20ff", BP = RP + MP + UP, zP = "[" + BP + "]", qP = RegExp(zP, "g");
function Pm(e) {
  return e = ws(e), e && e.replace(DP, kP).replace(qP, "");
}
var VP = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function WP(e) {
  return e.match(VP) || [];
}
var HP = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function $P(e) {
  return HP.test(e);
}
var e4 = "\\ud800-\\udfff", GP = "\\u0300-\\u036f", QP = "\\ufe20-\\ufe2f", YP = "\\u20d0-\\u20ff", KP = GP + QP + YP, t4 = "\\u2700-\\u27bf", n4 = "a-z\\xdf-\\xf6\\xf8-\\xff", XP = "\\xac\\xb1\\xd7\\xf7", ZP = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", JP = "\\u2000-\\u206f", AP = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", r4 = "A-Z\\xc0-\\xd6\\xd8-\\xde", eL = "\\ufe0e\\ufe0f", i4 = XP + ZP + JP + AP, a4 = "['’]", k5 = "[" + i4 + "]", tL = "[" + KP + "]", o4 = "\\d+", nL = "[" + t4 + "]", s4 = "[" + n4 + "]", l4 = "[^" + e4 + i4 + o4 + t4 + n4 + r4 + "]", rL = "\\ud83c[\\udffb-\\udfff]", iL = "(?:" + tL + "|" + rL + ")", aL = "[^" + e4 + "]", c4 = "(?:\\ud83c[\\udde6-\\uddff]){2}", u4 = "[\\ud800-\\udbff][\\udc00-\\udfff]", tl = "[" + r4 + "]", oL = "\\u200d", D5 = "(?:" + s4 + "|" + l4 + ")", sL = "(?:" + tl + "|" + l4 + ")", R5 = "(?:" + a4 + "(?:d|ll|m|re|s|t|ve))?", M5 = "(?:" + a4 + "(?:D|LL|M|RE|S|T|VE))?", d4 = iL + "?", f4 = "[" + eL + "]?", lL = "(?:" + oL + "(?:" + [aL, c4, u4].join("|") + ")" + f4 + d4 + ")*", cL = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", uL = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", dL = f4 + d4 + lL, fL = "(?:" + [nL, c4, u4].join("|") + ")" + dL, pL = RegExp([
  tl + "?" + s4 + "+" + R5 + "(?=" + [k5, tl, "$"].join("|") + ")",
  sL + "+" + M5 + "(?=" + [k5, tl + D5, "$"].join("|") + ")",
  tl + "?" + D5 + "+" + R5,
  tl + "+" + M5,
  uL,
  cL,
  o4,
  fL
].join("|"), "g");
function hL(e) {
  return e.match(pL) || [];
}
function mL(e, t, n) {
  return e = ws(e), t = t, t === void 0 ? $P(e) ? hL(e) : WP(e) : e.match(t) || [];
}
var gL = "['’]", yL = RegExp(gL, "g");
function vL(e) {
  return function(t) {
    return Ab(mL(Pm(t).replace(yL, "")), e, "");
  };
}
function bL(e) {
  return function(t) {
    t = ws(t);
    var n = Pg(t) ? Nm(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? Ib(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var wL = bL("toUpperCase"), xL = vL(function(e, t, n) {
  return e + (n ? " " : "") + wL(t);
}), mo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.color, o = e.content, s = e.disabled, l = e.fitted, c = e.header, d = e.icon, p = e.link, y = e.name, f = e.onClick, N = e.position, b = rt(a, N, ue(n, "active"), ue(s, "disabled"), ue(d === !0 || d && !(y || o), "icon"), ue(c, "header"), ue(p, "link"), mn(l, "fitted"), "item", i), S = lt(e, {
    getDefault: function() {
      if (f) return "a";
    }
  }), _ = nt(mo, e), E = lo(function(k) {
    s || Ze(e, "onClick", k, e);
  });
  return vt(r) ? /* @__PURE__ */ R.createElement(S, Pe({}, _, {
    className: b,
    onClick: E,
    ref: t
  }), $t.create(d, {
    autoGenerateKey: !1
  }), vt(o) ? xL(y) : o) : /* @__PURE__ */ R.createElement(S, Pe({}, _, {
    className: b,
    onClick: E,
    ref: t
  }), r);
});
mo.handledProps = ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"];
mo.displayName = "MenuItem";
mo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A menu item can be active. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Additional colors can be specified. */
  color: g.oneOf(Fi),
  /** Shorthand for primary content. */
  content: Lt,
  /** A menu item can be disabled. */
  disabled: g.bool,
  /** A menu item or menu can remove element padding, vertically or horizontally. */
  fitted: g.oneOfType([g.bool, g.oneOf(["horizontally", "vertically"])]),
  /** A menu item may include a header or may itself be a header. */
  header: g.bool,
  /** MenuItem can be only icon. */
  icon: g.oneOfType([g.bool, kt]),
  /** MenuItem index inside Menu. */
  index: g.number,
  /** A menu item can be link. */
  link: g.bool,
  /** Internal name of the MenuItem. */
  name: g.string,
  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /** A menu item can take left or right position. */
  position: g.oneOf(["left", "right"])
} : {};
mo.create = Vt(mo, function(e) {
  return {
    content: e,
    name: e
  };
});
var wu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.position, o = rt(a, "menu", r), s = nt(wu, e), l = lt(e);
  return /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), vt(n) ? i : n);
});
wu.handledProps = ["as", "children", "className", "content", "position"];
wu.displayName = "MenuMenu";
wu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A sub menu can take left or right position. */
  position: g.oneOf(["left", "right"])
} : {};
var da = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.attached, r = e.borderless, i = e.children, a = e.className, o = e.color, s = e.compact, l = e.fixed, c = e.floated, d = e.fluid, p = e.icon, y = e.inverted, f = e.items, N = e.pagination, b = e.pointing, S = e.secondary, _ = e.size, E = e.stackable, k = e.tabular, M = e.text, F = e.vertical, q = e.widths, j = hs({
    state: e.activeIndex,
    defaultState: e.defaultActiveIndex,
    initialState: -1
  }), x = j[0], C = j[1], D = rt("ui", o, _, ue(r, "borderless"), ue(s, "compact"), ue(d, "fluid"), ue(y, "inverted"), ue(N, "pagination"), ue(b, "pointing"), ue(S, "secondary"), ue(E, "stackable"), ue(M, "text"), ue(F, "vertical"), mn(n, "attached"), mn(c, "floated"), mn(p, "icon"), mn(k, "tabular"), Dr(l, "fixed"), kr(q, "item"), a, "menu"), P = nt(da, e), L = lt(e);
  return vt(i) ? /* @__PURE__ */ R.createElement(L, Pe({}, P, {
    className: D,
    ref: t
  }), Hn(f, function(H, $) {
    return mo.create(H, {
      defaultProps: {
        active: parseInt(x, 10) === $,
        index: $
      },
      overrideProps: function(ae) {
        return {
          onClick: function(ce, le) {
            var oe = le.index;
            C(oe), Ze(ae, "onClick", ce, le), Ze(e, "onItemClick", ce, le);
          }
        };
      }
    });
  })) : /* @__PURE__ */ R.createElement(L, Pe({}, P, {
    className: D,
    ref: t
  }), i);
});
da.handledProps = ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"];
da.displayName = "Menu";
da.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Index of the currently active item. */
  activeIndex: g.oneOfType([g.number, g.string]),
  /** A menu may be attached to other content segments. */
  attached: g.oneOfType([g.bool, g.oneOf(["top", "bottom"])]),
  /** A menu item or menu can have no borders. */
  borderless: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Additional colors can be specified. */
  color: g.oneOf(Fi),
  /** A menu can take up only the space necessary to fit its content. */
  compact: g.bool,
  /** Initial activeIndex value. */
  defaultActiveIndex: g.oneOfType([g.number, g.string]),
  /** A menu can be fixed to a side of its context. */
  fixed: g.oneOf(["left", "right", "bottom", "top"]),
  /** A menu can be floated. */
  floated: g.oneOfType([g.bool, g.oneOf(["right"])]),
  /** A vertical menu may take the size of its container. */
  fluid: g.bool,
  /** A menu may have just icons (bool) or labeled icons. */
  icon: g.oneOfType([g.bool, g.oneOf(["labeled"])]),
  /** A menu may have its colors inverted to show greater contrast. */
  inverted: g.bool,
  /** Shorthand array of props for Menu. */
  items: xs,
  /**
   * onClick handler for MenuItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: qt([Jt(["children"]), g.func]),
  /** A pagination menu is specially formatted to present links to pages of content. */
  pagination: g.bool,
  /** A menu can point to show its relationship to nearby content. */
  pointing: g.bool,
  /** A menu can adjust its appearance to de-emphasize its contents. */
  secondary: g.bool,
  /** A menu can vary in size. */
  size: g.oneOf(Rr(Or, "medium", "big")),
  /** A menu can stack at mobile resolutions. */
  stackable: g.bool,
  /** A menu can be formatted to show tabs of information. */
  tabular: g.oneOfType([g.bool, g.oneOf(["right"])]),
  /** A menu can be formatted for text content. */
  text: g.bool,
  /** A vertical menu displays elements vertically. */
  vertical: g.bool,
  /** A menu can have its items divided evenly. */
  widths: g.oneOf(Yr)
} : {};
da.Header = bu;
da.Item = mo;
da.Menu = wu;
da.create = Vt(da, function(e) {
  return {
    items: e
  };
});
var dr = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.disabled, i = e.label, a = e.id, o = e.name, s = e.radio, l = e.readOnly, c = e.slider, d = e.tabIndex, p = e.toggle, y = e.type, f = y === void 0 ? "checkbox" : y, N = e.value, b = hs({
    state: e.checked,
    defaultState: e.defaultChecked,
    initialState: !1
  }), S = b[0], _ = b[1], E = hs({
    state: e.indeterminate,
    defaultState: e.defaultIndeterminate,
    initialState: !1
  }), k = E[0], M = E[1], F = qa(R.useRef(), t), q = R.useRef(), j = R.useRef();
  xl(function() {
    F.current && (F.current.indeterminate = !!k);
  });
  var x = function() {
    return !r && !l && !(s && S);
  }, C = function() {
    return Tt(d) ? r ? -1 : 0 : d;
  }, D = function(re) {
    x() && (Ze(e, "onChange", re, Pe({}, e, {
      checked: !S,
      indeterminate: !1
    })), _(!S), M(!1));
  }, P = function(re) {
    var I = Ze(F.current, "contains", re.target), U = Ze(q.current, "contains", re.target), G = !U && !I, K = !Tt(a), A = U && K;
    A || Ze(e, "onClick", re, Pe({}, e, {
      checked: !S,
      indeterminate: !!k
    })), j.current && (j.current = !1, U && !K && D(re), G && D(re), U && K && re.stopPropagation());
  }, L = function(re) {
    Ze(e, "onMouseDown", re, Pe({}, e, {
      checked: !!S,
      indeterminate: !!k
    })), re.defaultPrevented || Ze(F.current, "focus"), re.preventDefault();
  }, H = function(re) {
    j.current = !0, Ze(e, "onMouseUp", re, Pe({}, e, {
      checked: !!S,
      indeterminate: !!k
    }));
  }, $ = rt(
    "ui",
    ue(S, "checked"),
    ue(r, "disabled"),
    ue(k, "indeterminate"),
    // auto apply fitted class to compact white space when there is no label
    // https://semantic-ui.com/modules/checkbox.html#fitted
    ue(Tt(i), "fitted"),
    ue(s, "radio"),
    ue(l, "read-only"),
    ue(c, "slider"),
    ue(p, "toggle"),
    "checkbox",
    n
  ), ae = nt(dr, e), ce = lt(e), le = Fg(ae, {
    htmlProps: Xb
  }), oe = le[0], se = le[1], J = Om(i, {
    defaultProps: {
      htmlFor: a
    },
    autoGenerateKey: !1
  }) || /* @__PURE__ */ R.createElement("label", {
    htmlFor: a
  });
  return /* @__PURE__ */ R.createElement(ce, Pe({}, se, {
    className: $,
    onClick: P,
    onChange: D,
    onMouseDown: L,
    onMouseUp: H
  }), /* @__PURE__ */ R.createElement("input", Pe({}, oe, {
    checked: S,
    className: "hidden",
    disabled: r,
    id: a,
    name: o,
    readOnly: !0,
    ref: F,
    tabIndex: C(),
    type: f,
    value: N
  })), /* @__PURE__ */ R.cloneElement(J, {
    ref: q
  }));
});
dr.handledProps = ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"];
dr.displayName = "Checkbox";
dr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Whether or not checkbox is checked. */
  checked: g.bool,
  /** Additional classes. */
  className: g.string,
  /** The initial value of checked. */
  defaultChecked: g.bool,
  /** Whether or not checkbox is indeterminate. */
  defaultIndeterminate: g.bool,
  /** A checkbox can appear disabled and be unable to change states */
  disabled: g.bool,
  /** Removes padding for a label. Auto applied when there is no label. */
  fitted: g.bool,
  /** A unique identifier. */
  id: g.oneOfType([g.number, g.string]),
  /** Whether or not checkbox is indeterminate. */
  indeterminate: g.bool,
  /** The text of the associated label element. */
  label: kt,
  /** The HTML input name. */
  name: g.string,
  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed checked/indeterminate state.
   */
  onChange: g.func,
  /**
   * Called when the checkbox or label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onClick: g.func,
  /**
   * Called when the user presses down on the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseDown: g.func,
  /**
   * Called when the user releases the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseUp: g.func,
  /** Format as a radio element. This means it is an exclusive option. */
  radio: qt([g.bool, Jt(["slider", "toggle"])]),
  /** A checkbox can be read-only and unable to change states. */
  readOnly: g.bool,
  /** Format to emphasize the current selection state. */
  slider: qt([g.bool, Jt(["radio", "toggle"])]),
  /** A checkbox can receive focus. */
  tabIndex: g.oneOfType([g.number, g.string]),
  /** Format to show an on or off choice. */
  toggle: qt([g.bool, Jt(["radio", "slider"])]),
  /** HTML input type, either checkbox or radio. */
  type: g.oneOf(["checkbox", "radio"]),
  /** The HTML input value. */
  value: g.oneOfType([g.string, g.number])
} : {};
var Tl = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.slider, r = e.toggle, i = e.type, a = i === void 0 ? "radio" : i, o = nt(Tl, e), s = !(n || r) || void 0;
  return /* @__PURE__ */ R.createElement(dr, Pe({}, o, {
    type: a,
    radio: s,
    slider: n,
    toggle: r,
    ref: t
  }));
});
Tl.handledProps = ["slider", "toggle", "type"];
Tl.displayName = "Radio";
Tl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Format to emphasize the current selection state. */
  slider: dr.propTypes.slider,
  /** Format to show an on or off choice. */
  toggle: dr.propTypes.toggle,
  /** HTML input type, either checkbox or radio. */
  type: dr.propTypes.type
} : {};
function p4(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function _L(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n; ) {
    var a = e[t];
    a && (i[r++] = a);
  }
  return i;
}
function NL(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (!t(e[n], n, e))
      return !1;
  return !0;
}
function SL(e, t) {
  var n = !0;
  return Ll(e, function(r, i, a) {
    return n = !!t(r, i, a), n;
  }), n;
}
function EL(e, t, n) {
  var r = Rn(e) ? NL : SL;
  return r(e, ko(t));
}
function CL(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? (t = t === void 0 ? 1 : su(t), t = r - t, Hf(e, 0, t < 0 ? 0 : t)) : [];
}
var OL = jb("length"), h4 = "\\ud800-\\udfff", jL = "\\u0300-\\u036f", PL = "\\ufe20-\\ufe2f", LL = "\\u20d0-\\u20ff", TL = jL + PL + LL, FL = "\\ufe0e\\ufe0f", IL = "[" + h4 + "]", Lm = "[" + TL + "]", Tm = "\\ud83c[\\udffb-\\udfff]", kL = "(?:" + Lm + "|" + Tm + ")", m4 = "[^" + h4 + "]", g4 = "(?:\\ud83c[\\udde6-\\uddff]){2}", y4 = "[\\ud800-\\udbff][\\udc00-\\udfff]", DL = "\\u200d", v4 = kL + "?", b4 = "[" + FL + "]?", RL = "(?:" + DL + "(?:" + [m4, g4, y4].join("|") + ")" + b4 + v4 + ")*", ML = b4 + v4 + RL, UL = "(?:" + [m4 + Lm + "?", Lm, g4, y4, IL].join("|") + ")", U5 = RegExp(Tm + "(?=" + Tm + ")|" + UL + ML, "g");
function BL(e) {
  for (var t = U5.lastIndex = 0; U5.test(e); )
    ++t;
  return t;
}
function zL(e) {
  return Pg(e) ? BL(e) : OL(e);
}
var qL = "[object Map]", VL = "[object Set]";
function WL(e) {
  if (e == null)
    return 0;
  if (za(e))
    return Tg(e) ? zL(e) : e.length;
  var t = na(e);
  return t == qL || t == VL ? e.size : Cg(e).length;
}
var B5 = Pl(function(e) {
  return Qb(Qf(e, 1, Xc, !0));
}), HL = ["ad", "andorra", "ae", "united arab emirates", "uae", "af", "afghanistan", "ag", "antigua", "ai", "anguilla", "al", "albania", "am", "armenia", "an", "netherlands antilles", "ao", "angola", "ar", "argentina", "as", "american samoa", "at", "austria", "au", "australia", "aw", "aruba", "ax", "aland islands", "az", "azerbaijan", "ba", "bosnia", "bb", "barbados", "bd", "bangladesh", "be", "belgium", "bf", "burkina faso", "bg", "bulgaria", "bh", "bahrain", "bi", "burundi", "bj", "benin", "bm", "bermuda", "bn", "brunei", "bo", "bolivia", "br", "brazil", "bs", "bahamas", "bt", "bhutan", "bv", "bouvet island", "bw", "botswana", "by", "belarus", "bz", "belize", "ca", "canada", "cc", "cocos islands", "cd", "congo", "cf", "central african republic", "cg", "congo brazzaville", "ch", "switzerland", "ci", "cote divoire", "ck", "cook islands", "cl", "chile", "cm", "cameroon", "cn", "china", "co", "colombia", "cr", "costa rica", "cs", "cu", "cuba", "cv", "cape verde", "cx", "christmas island", "cy", "cyprus", "cz", "czech republic", "de", "germany", "dj", "djibouti", "dk", "denmark", "dm", "dominica", "do", "dominican republic", "dz", "algeria", "ec", "ecuador", "england", "gb eng", "ee", "estonia", "eg", "egypt", "eh", "western sahara", "er", "eritrea", "es", "spain", "et", "ethiopia", "eu", "european union", "fi", "finland", "fj", "fiji", "fk", "falkland islands", "fm", "micronesia", "fo", "faroe islands", "fr", "france", "ga", "gabon", "gb", "uk", "united kingdom", "gd", "grenada", "ge", "georgia", "gf", "french guiana", "gh", "ghana", "gi", "gibraltar", "gl", "greenland", "gm", "gambia", "gn", "guinea", "gp", "guadeloupe", "gq", "equatorial guinea", "gr", "greece", "gs", "sandwich islands", "gt", "guatemala", "gu", "guam", "gw", "guinea-bissau", "gy", "guyana", "hk", "hong kong", "hm", "heard island", "hn", "honduras", "hr", "croatia", "ht", "haiti", "hu", "hungary", "id", "indonesia", "ie", "ireland", "il", "israel", "in", "india", "io", "indian ocean territory", "iq", "iraq", "ir", "iran", "is", "iceland", "it", "italy", "jm", "jamaica", "jo", "jordan", "jp", "japan", "ke", "kenya", "kg", "kyrgyzstan", "kh", "cambodia", "ki", "kiribati", "km", "comoros", "kn", "saint kitts and nevis", "kp", "north korea", "kr", "south korea", "kw", "kuwait", "ky", "cayman islands", "kz", "kazakhstan", "la", "laos", "lb", "lebanon", "lc", "saint lucia", "li", "liechtenstein", "lk", "sri lanka", "lr", "liberia", "ls", "lesotho", "lt", "lithuania", "lu", "luxembourg", "lv", "latvia", "ly", "libya", "ma", "morocco", "mc", "monaco", "md", "moldova", "me", "montenegro", "mg", "madagascar", "mh", "marshall islands", "mk", "macedonia", "ml", "mali", "mm", "myanmar", "burma", "mn", "mongolia", "mo", "macau", "mp", "northern mariana islands", "mq", "martinique", "mr", "mauritania", "ms", "montserrat", "mt", "malta", "mu", "mauritius", "mv", "maldives", "mw", "malawi", "mx", "mexico", "my", "malaysia", "mz", "mozambique", "na", "namibia", "nc", "new caledonia", "ne", "niger", "nf", "norfolk island", "ng", "nigeria", "ni", "nicaragua", "nl", "netherlands", "no", "norway", "np", "nepal", "nr", "nauru", "nu", "niue", "nz", "new zealand", "om", "oman", "pa", "panama", "pe", "peru", "pf", "french polynesia", "pg", "new guinea", "ph", "philippines", "pk", "pakistan", "pl", "poland", "pm", "saint pierre", "pn", "pitcairn islands", "pr", "puerto rico", "ps", "palestine", "pt", "portugal", "pw", "palau", "py", "paraguay", "qa", "qatar", "re", "reunion", "ro", "romania", "rs", "serbia", "ru", "russia", "rw", "rwanda", "sa", "saudi arabia", "sb", "solomon islands", "sc", "seychelles", "gb sct", "scotland", "sd", "sudan", "se", "sweden", "sg", "singapore", "sh", "saint helena", "si", "slovenia", "sj", "svalbard", "jan mayen", "sk", "slovakia", "sl", "sierra leone", "sm", "san marino", "sn", "senegal", "so", "somalia", "sr", "suriname", "st", "sao tome", "sv", "el salvador", "sy", "syria", "sz", "swaziland", "tc", "caicos islands", "td", "chad", "tf", "french territories", "tg", "togo", "th", "thailand", "tj", "tajikistan", "tk", "tokelau", "tl", "timorleste", "tm", "turkmenistan", "tn", "tunisia", "to", "tonga", "tr", "turkey", "tt", "trinidad", "tv", "tuvalu", "tw", "taiwan", "tz", "tanzania", "ua", "ukraine", "ug", "uganda", "um", "us minor islands", "us", "america", "united states", "uy", "uruguay", "uz", "uzbekistan", "va", "vatican city", "vc", "saint vincent", "ve", "venezuela", "vg", "british virgin islands", "vi", "us virgin islands", "vn", "vietnam", "vu", "vanuatu", "gb wls", "wales", "wf", "wallis and futuna", "ws", "samoa", "ye", "yemen", "yt", "mayotte", "za", "south africa", "zm", "zambia", "zw", "zimbabwe"], xu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.name, i = rt(r, "flag", n), a = nt(xu, e), o = lt(e, {
    defaultAs: "i"
  });
  return /* @__PURE__ */ R.createElement(o, Pe({}, a, {
    className: i,
    ref: t
  }));
});
xu.handledProps = ["as", "className", "name"];
xu.displayName = "Flag";
xu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Additional classes. */
  className: g.string,
  /** Flag name, can use the two digit country code, the full name, or a common alias. */
  name: Vb(HL)
} : {};
var Ef = /* @__PURE__ */ R.memo(xu);
Ef.create = Vt(Ef, function(e) {
  return {
    name: e
  };
});
var _u = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = rt("divider", n), i = nt(_u, e), a = lt(e);
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    className: r,
    ref: t
  }));
});
_u.handledProps = ["as", "className"];
_u.displayName = "DropdownDivider";
_u.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Additional classes. */
  className: g.string
} : {};
var Ia = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.content, o = e.disabled, s = e.description, l = e.flag, c = e.icon, d = e.image, p = e.label, y = e.selected, f = e.text, N = function(D) {
    Ze(e, "onClick", D, e);
  }, b = rt(ue(n, "active"), ue(o, "disabled"), ue(y, "selected"), "item", i), S = Tt(c) ? nO(r, "DropdownMenu") && "dropdown" : c, _ = nt(Ia, e), E = lt(e), k = {
    role: "option",
    "aria-disabled": o,
    "aria-checked": n,
    "aria-selected": y
  };
  if (!vt(r))
    return /* @__PURE__ */ R.createElement(E, Pe({}, _, k, {
      className: b,
      onClick: N,
      ref: t
    }), r);
  var M = Ef.create(l, {
    autoGenerateKey: !1
  }), F = $t.create(S, {
    autoGenerateKey: !1
  }), q = ua.create(d, {
    autoGenerateKey: !1
  }), j = Mr.create(p, {
    autoGenerateKey: !1
  }), x = Cm("span", function(D) {
    return {
      children: D
    };
  }, s, {
    defaultProps: {
      className: "description"
    },
    autoGenerateKey: !1
  }), C = Cm("span", function(D) {
    return {
      children: D
    };
  }, vt(a) ? f : a, {
    defaultProps: {
      className: "text"
    },
    autoGenerateKey: !1
  });
  return /* @__PURE__ */ R.createElement(E, Pe({}, _, k, {
    className: b,
    onClick: N,
    ref: t
  }), q, F, M, j, x, C);
});
Ia.handledProps = ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"];
Ia.displayName = "DropdownItem";
Ia.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Style as the currently chosen item. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Additional text with less emphasis. */
  description: kt,
  /** A dropdown item can be disabled. */
  disabled: g.bool,
  /** Shorthand for Flag. */
  flag: kt,
  /** Shorthand for Icon. */
  icon: kt,
  /** Shorthand for Image. */
  image: kt,
  /** Shorthand for Label. */
  label: kt,
  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /**
   * The item currently selected by keyboard shortcut.
   * This is not the active item.
   */
  selected: g.bool,
  /** Display text. */
  text: Lt,
  /** Stored value. */
  value: g.oneOfType([g.bool, g.number, g.string])
} : {};
Ia.create = Vt(Ia, function(e) {
  return e;
});
var go = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.icon, o = rt("header", r), s = nt(go, e), l = lt(e);
  return vt(n) ? /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), $t.create(a, {
    autoGenerateKey: !1
  }), i) : /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), n);
});
go.handledProps = ["as", "children", "className", "content", "icon"];
go.displayName = "DropdownHeader";
go.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function) */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Shorthand for Icon. */
  icon: kt
} : {};
go.create = Vt(go, function(e) {
  return {
    content: e
  };
});
var Fl = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.direction, o = e.open, s = e.scrolling, l = rt(a, ue(o, "visible"), ue(s, "scrolling"), "menu transition", r), c = nt(Fl, e), d = lt(e);
  return /* @__PURE__ */ R.createElement(d, Pe({}, c, {
    className: l,
    ref: t
  }), vt(n) ? i : n);
});
Fl.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"];
Fl.displayName = "DropdownMenu";
Fl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A dropdown menu can open to the left or to the right. */
  direction: g.oneOf(["left", "right"]),
  /** Whether or not the dropdown menu is displayed. */
  open: g.bool,
  /** A dropdown menu can scroll. */
  scrolling: g.bool
} : {};
var yo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.autoComplete, r = n === void 0 ? "off" : n, i = e.className, a = e.tabIndex, o = e.type, s = o === void 0 ? "text" : o, l = e.value, c = function(f) {
    var N = Hi(f, "target.value");
    Ze(e, "onChange", f, Pe({}, e, {
      value: N
    }));
  }, d = rt("search", i), p = lt(e, {
    defaultAs: "input"
  }), y = nt(yo, e);
  return /* @__PURE__ */ R.createElement(p, Pe({
    "aria-autocomplete": "list"
  }, y, {
    autoComplete: r,
    className: d,
    onChange: c,
    ref: t,
    tabIndex: a,
    type: s,
    value: l
  }));
});
yo.handledProps = ["as", "autoComplete", "className", "tabIndex", "type", "value"];
yo.displayName = "DropdownSearchInput";
yo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** An input can have the auto complete. */
  autoComplete: g.string,
  /** Additional classes. */
  className: g.string,
  /** An input can receive focus. */
  tabIndex: g.oneOfType([g.number, g.string]),
  /** The HTML input type. */
  type: g.string,
  /** Stored value. */
  value: g.oneOfType([g.number, g.string])
} : {};
yo.create = Vt(yo, function(e) {
  return {
    type: e
  };
});
var vo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("divider", r), o = nt(vo, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({
    "aria-atomic": !0,
    "aria-live": "polite",
    role: "alert"
  }, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
vo.handledProps = ["as", "children", "className", "content"];
vo.displayName = "DropdownText";
vo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
vo.create = Vt(vo, function(e) {
  return {
    content: e
  };
});
var w4 = /[\\^$.*+?()[\]{}|]/g, $L = RegExp(w4.source);
function GL(e) {
  return e = ws(e), e && $L.test(e) ? e.replace(w4, "\\$&") : e;
}
function ol(e) {
  var t = e.additionLabel, n = e.additionPosition, r = e.allowAdditions, i = e.deburr, a = e.multiple, o = e.options, s = e.search, l = e.searchQuery, c = e.value, d = o;
  if (a && (d = ym(d, function(b) {
    return !Ei(c, b.value);
  })), s && l)
    if (wl(s))
      d = s(d, l);
    else {
      var p = i ? Pm(l) : l, y = new RegExp(GL(p), "i");
      d = ym(d, function(b) {
        return y.test(i ? Pm(b.text) : b.text);
      });
    }
  if (r && s && l && !Mc(d, {
    text: l
  })) {
    var f = /* @__PURE__ */ R.isValidElement(t) ? /* @__PURE__ */ R.cloneElement(t, {
      key: "addition-label"
    }) : t || "", N = {
      key: "addition",
      // by using an array, we can pass multiple elements, but when doing so
      // we must specify a `key` for React to know which one is which
      text: [f, /* @__PURE__ */ R.createElement("b", {
        key: "addition-query"
      }, l)],
      value: l,
      className: "addition",
      "data-additional": !0
    };
    n === "top" ? d.unshift(N) : d.push(N);
  }
  return d;
}
ol.handledProps = [];
function z5(e) {
  var t = e.additionLabel, n = e.additionPosition, r = e.allowAdditions, i = e.deburr, a = e.multiple, o = e.options, s = e.search, l = e.searchQuery, c = e.selectedIndex, d = e.value, p = ol({
    value: d,
    options: o,
    searchQuery: l,
    additionLabel: t,
    additionPosition: n,
    allowAdditions: r,
    deburr: i,
    multiple: a,
    search: s
  }), y = Ig(p, function(S, _, E) {
    return _.disabled || S.push(E), S;
  }, []), f;
  if (!c || c < 0) {
    var N = y[0];
    f = a ? N : bm(p, ["value", d]) || y[0];
  } else if (a)
    f = Tb(y, function(S) {
      return S >= c;
    }), c >= p.length - 1 && (f = y[y.length - 1]);
  else {
    var b = bm(p, ["value", d]);
    f = Ei(y, b) ? b : void 0;
  }
  return (!f || f < 0) && (f = y[0]), f;
}
var QL = ["additionLabel", "additionPosition", "closeOnBlur", "closeOnEscape", "deburr", "icon", "minCharacters", "noResultsMessage", "openOnFocus", "renderLabel", "searchInput", "selectOnBlur", "selectOnNavigation", "wrapSelection"], q5 = function(e, t) {
  return Tt(e) ? t : e;
}, V5 = function(e) {
  return e && e.map(function(t) {
    return Yf(t, ["key", "value"]);
  });
};
function x4(e) {
  var t = e.flag, n = e.image, r = e.text;
  return wl(r) ? r : {
    content: /* @__PURE__ */ gt.createElement(gt.Fragment, null, Ef.create(t), ua.create(n), r)
  };
}
var An = /* @__PURE__ */ gt.forwardRef(function(e, t) {
  var n = e.additionLabel, r = n === void 0 ? "Add " : n, i = e.additionPosition, a = i === void 0 ? "top" : i, o = e.closeOnBlur, s = o === void 0 ? !0 : o, l = e.closeOnEscape, c = l === void 0 ? !0 : l, d = e.deburr, p = d === void 0 ? !1 : d, y = e.icon, f = y === void 0 ? "dropdown" : y, N = e.minCharacters, b = N === void 0 ? 1 : N, S = e.noResultsMessage, _ = S === void 0 ? "No results found." : S, E = e.openOnFocus, k = E === void 0 ? !0 : E, M = e.renderLabel, F = M === void 0 ? x4 : M, q = e.searchInput, j = q === void 0 ? "text" : q, x = e.selectOnBlur, C = x === void 0 ? !0 : x, D = e.selectOnNavigation, P = D === void 0 ? !0 : D, L = e.wrapSelection, H = L === void 0 ? !0 : L, $ = p4(e, QL);
  return /* @__PURE__ */ gt.createElement(Jf, Pe({
    additionLabel: r,
    additionPosition: a,
    closeOnBlur: s,
    closeOnEscape: c,
    deburr: p,
    icon: f,
    minCharacters: b,
    noResultsMessage: _,
    openOnFocus: k,
    renderLabel: F,
    searchInput: j,
    selectOnBlur: C,
    selectOnNavigation: P,
    wrapSelection: H
  }, $, {
    innerRef: t
  }));
});
An.handledProps = ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"];
var Jf = /* @__PURE__ */ function(e) {
  Sg(t, e);
  function t() {
    for (var r, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(a)) || this, r.searchRef = /* @__PURE__ */ rf(), r.sizerRef = /* @__PURE__ */ rf(), r.ref = /* @__PURE__ */ rf(), r.handleRef = function(s) {
      r.ref.current = s, Zc(r.props.innerRef, s);
    }, r.handleChange = function(s, l) {
      Ze(r.props, "onChange", s, Pe({}, r.props, {
        value: l
      }));
    }, r.closeOnChange = function(s) {
      var l = r.props, c = l.closeOnChange, d = l.multiple, p = pl(c) ? !d : c;
      p && r.close(s, Gb);
    }, r.closeOnEscape = function(s) {
      r.props.closeOnEscape && lr.getCode(s) === lr.Escape && (s.preventDefault(), r.close(s));
    }, r.moveSelectionOnKeyDown = function(s) {
      var l, c = r.props, d = c.multiple, p = c.selectOnNavigation, y = r.state.open;
      if (y) {
        var f = (l = {}, l[lr.ArrowDown] = 1, l[lr.ArrowUp] = -1, l), N = f[lr.getCode(s)];
        if (N !== void 0) {
          s.preventDefault();
          var b = r.getSelectedIndexAfterMove(N);
          !d && p && r.makeSelectedItemActive(s, b), r.setState({
            selectedIndex: b
          });
        }
      }
    }, r.openOnSpace = function(s) {
      var l, c, d, p = r.state.focus && !r.state.open && lr.getCode(s) === lr.Spacebar, y = ((l = s.target) == null ? void 0 : l.tagName) !== "INPUT" && ((c = s.target) == null ? void 0 : c.tagName) !== "TEXTAREA" && ((d = s.target) == null ? void 0 : d.isContentEditable) !== !0;
      p && (y && s.preventDefault(), r.open(s));
    }, r.openOnArrow = function(s) {
      var l = r.state, c = l.focus, d = l.open;
      if (c && !d) {
        var p = lr.getCode(s);
        (p === lr.ArrowDown || p === lr.ArrowUp) && (s.preventDefault(), r.open(s));
      }
    }, r.makeSelectedItemActive = function(s, l) {
      var c = r.state, d = c.open, p = c.value, y = r.props.multiple, f = r.getSelectedItem(l), N = Hi(f, "value"), b = Hi(f, "disabled");
      if (Tt(N) || !d || b)
        return p;
      var S = y ? B5(p, [N]) : N, _ = y ? !!wm(S, p).length : S !== p;
      return _ && (r.setState({
        value: S
      }), r.handleChange(s, S), f["data-additional"] && Ze(r.props, "onAddItem", s, Pe({}, r.props, {
        value: N
      }))), p;
    }, r.selectItemOnEnter = function(s) {
      var l = r.props.search, c = r.state, d = c.open, p = c.selectedIndex;
      if (d) {
        var y = lr.getCode(s) === lr.Enter || // https://github.com/Semantic-Org/Semantic-UI-React/pull/3766
        !l && lr.getCode(s) === lr.Spacebar;
        if (y) {
          s.preventDefault();
          var f = WL(ol({
            value: r.state.value,
            options: r.props.options,
            searchQuery: r.state.searchQuery,
            additionLabel: r.props.additionLabel,
            additionPosition: r.props.additionPosition,
            allowAdditions: r.props.allowAdditions,
            deburr: r.props.deburr,
            multiple: r.props.multiple,
            search: r.props.search
          }));
          if (!(l && f === 0)) {
            var N = r.makeSelectedItemActive(s, p);
            r.setState({
              selectedIndex: z5({
                additionLabel: r.props.additionLabel,
                additionPosition: r.props.additionPosition,
                allowAdditions: r.props.allowAdditions,
                deburr: r.props.deburr,
                multiple: r.props.multiple,
                search: r.props.search,
                selectedIndex: p,
                value: N,
                options: r.props.options,
                searchQuery: ""
              })
            }), r.closeOnChange(s), r.clearSearchQuery(), l && Ze(r.searchRef.current, "focus");
          }
        }
      }
    }, r.removeItemOnBackspace = function(s) {
      var l = r.props, c = l.multiple, d = l.search, p = r.state, y = p.searchQuery, f = p.value;
      if (lr.getCode(s) === lr.Backspace && !(y || !d || !c || al(f))) {
        s.preventDefault();
        var N = CL(f);
        r.setState({
          value: N
        }), r.handleChange(s, N);
      }
    }, r.closeOnDocumentClick = function(s) {
      r.props.closeOnBlur && (r.ref.current && ls(r.ref.current, s) || r.close());
    }, r.handleMouseDown = function(s) {
      r.isMouseDown = !0, Ze(r.props, "onMouseDown", s, r.props), document.addEventListener("mouseup", r.handleDocumentMouseUp);
    }, r.handleDocumentMouseUp = function() {
      r.isMouseDown = !1, document.removeEventListener("mouseup", r.handleDocumentMouseUp);
    }, r.handleClick = function(s) {
      var l = r.props, c = l.minCharacters, d = l.search, p = r.state, y = p.open, f = p.searchQuery;
      if (Ze(r.props, "onClick", s, r.props), s.stopPropagation(), !d) return r.toggle(s);
      if (y) {
        Ze(r.searchRef.current, "focus");
        return;
      }
      if (f.length >= c || c === 1) {
        r.open(s);
        return;
      }
      Ze(r.searchRef.current, "focus");
    }, r.handleIconClick = function(s) {
      var l = r.props.clearable, c = r.hasValue();
      Ze(r.props, "onClick", s, r.props), s.stopPropagation(), l && c ? r.clearValue(s) : r.toggle(s);
    }, r.handleItemClick = function(s, l) {
      var c = r.props, d = c.multiple, p = c.search, y = r.state.value, f = l.value;
      if (s.stopPropagation(), (d || l.disabled) && s.nativeEvent.stopImmediatePropagation(), !l.disabled) {
        var N = l["data-additional"], b = d ? B5(r.state.value, [f]) : f, S = d ? !!wm(b, y).length : b !== y;
        S && (r.setState({
          value: b
        }), r.handleChange(s, b)), r.clearSearchQuery(), Ze(p ? r.searchRef.current : r.ref.current, "focus"), r.closeOnChange(s), N && Ze(r.props, "onAddItem", s, Pe({}, r.props, {
          value: f
        }));
      }
    }, r.handleFocus = function(s) {
      var l = r.state.focus;
      l || (Ze(r.props, "onFocus", s, r.props), r.setState({
        focus: !0
      }));
    }, r.handleBlur = function(s) {
      var l = Hi(s, "currentTarget");
      if (!(l && l.contains(document.activeElement))) {
        var c = r.props, d = c.closeOnBlur, p = c.multiple, y = c.selectOnBlur;
        r.isMouseDown || (Ze(r.props, "onBlur", s, r.props), y && !p && (r.makeSelectedItemActive(s, r.state.selectedIndex), d && r.close()), r.setState({
          focus: !1
        }), r.clearSearchQuery());
      }
    }, r.handleSearchChange = function(s, l) {
      var c = l.value;
      s.stopPropagation();
      var d = r.props.minCharacters, p = r.state.open, y = c;
      if (Ze(r.props, "onSearchChange", s, Pe({}, r.props, {
        searchQuery: y
      })), r.setState({
        searchQuery: y,
        selectedIndex: 0
      }), !p && y.length >= d) {
        r.open();
        return;
      }
      p && d !== 1 && y.length < d && r.close();
    }, r.handleKeyDown = function(s) {
      r.moveSelectionOnKeyDown(s), r.openOnArrow(s), r.openOnSpace(s), r.selectItemOnEnter(s), Ze(r.props, "onKeyDown", s);
    }, r.getSelectedItem = function(s) {
      var l = ol({
        value: r.state.value,
        options: r.props.options,
        searchQuery: r.state.searchQuery,
        additionLabel: r.props.additionLabel,
        additionPosition: r.props.additionPosition,
        allowAdditions: r.props.allowAdditions,
        deburr: r.props.deburr,
        multiple: r.props.multiple,
        search: r.props.search
      });
      return Hi(l, "[" + s + "]");
    }, r.getItemByValue = function(s) {
      var l = r.props.options;
      return Tb(l, {
        value: s
      });
    }, r.getDropdownAriaOptions = function() {
      var s = r.props, l = s.loading, c = s.disabled, d = s.search, p = s.multiple, y = r.state.open, f = {
        role: d ? "combobox" : "listbox",
        "aria-busy": l,
        "aria-disabled": c,
        "aria-expanded": !!y
      };
      return f.role === "listbox" && (f["aria-multiselectable"] = p), f;
    }, r.clearSearchQuery = function() {
      var s = r.state.searchQuery;
      s === void 0 || s === "" || r.setState({
        searchQuery: ""
      });
    }, r.handleLabelClick = function(s, l) {
      s.stopPropagation(), r.setState({
        selectedLabel: l.value
      }), Ze(r.props, "onLabelClick", s, l);
    }, r.handleLabelRemove = function(s, l) {
      s.stopPropagation();
      var c = r.state.value, d = Rr(c, l.value);
      r.setState({
        value: d
      }), r.handleChange(s, d);
    }, r.getSelectedIndexAfterMove = function(s, l) {
      l === void 0 && (l = r.state.selectedIndex);
      var c = ol({
        value: r.state.value,
        options: r.props.options,
        searchQuery: r.state.searchQuery,
        additionLabel: r.props.additionLabel,
        additionPosition: r.props.additionPosition,
        allowAdditions: r.props.allowAdditions,
        deburr: r.props.deburr,
        multiple: r.props.multiple,
        search: r.props.search
      });
      if (!(c === void 0 || EL(c, "disabled"))) {
        var d = c.length - 1, p = r.props.wrapSelection, y = l + s;
        return !p && (y > d || y < 0) ? y = l : y > d ? y = 0 : y < 0 && (y = d), c[y].disabled ? r.getSelectedIndexAfterMove(s, y) : y;
      }
    }, r.handleIconOverrides = function(s) {
      var l = r.props.clearable, c = rt(l && r.hasValue() && "clear", s.className);
      return {
        className: c,
        onClick: function(d) {
          Ze(s, "onClick", d, s), r.handleIconClick(d);
        }
      };
    }, r.clearValue = function(s) {
      var l = r.props.multiple, c = l ? [] : "";
      r.setState({
        value: c
      }), r.handleChange(s, c);
    }, r.computeSearchInputTabIndex = function() {
      var s = r.props, l = s.disabled, c = s.tabIndex;
      return Tt(c) ? l ? -1 : 0 : c;
    }, r.computeSearchInputWidth = function() {
      var s = r.state.searchQuery;
      if (r.sizerRef.current && s) {
        r.sizerRef.current.style.display = "inline", r.sizerRef.current.textContent = s;
        var l = Math.ceil(r.sizerRef.current.getBoundingClientRect().width);
        return r.sizerRef.current.style.removeProperty("display"), l;
      }
    }, r.computeTabIndex = function() {
      var s = r.props, l = s.disabled, c = s.search, d = s.tabIndex;
      if (!c)
        return l ? -1 : Tt(d) ? 0 : d;
    }, r.handleSearchInputOverrides = function(s) {
      return {
        onChange: function(l, c) {
          Ze(s, "onChange", l, c), r.handleSearchChange(l, c);
        },
        ref: r.searchRef
      };
    }, r.hasValue = function() {
      var s = r.props.multiple, l = r.state.value;
      return s ? !al(l) : !Tt(l) && l !== "";
    }, r.scrollSelectedItemIntoView = function() {
      if (r.ref.current) {
        var s = r.ref.current.querySelector(".menu.visible");
        if (s) {
          var l = s.querySelector(".item.selected");
          if (l) {
            var c = l.offsetTop < s.scrollTop, d = l.offsetTop + l.clientHeight > s.scrollTop + s.clientHeight;
            c ? s.scrollTop = l.offsetTop : d && (s.scrollTop = l.offsetTop + l.clientHeight - s.clientHeight);
          }
        }
      }
    }, r.setOpenDirection = function() {
      if (r.ref.current) {
        var s = r.ref.current.querySelector(".menu.visible");
        if (s) {
          var l = r.ref.current.getBoundingClientRect(), c = s.clientHeight, d = document.documentElement.clientHeight - l.top - l.height - c, p = l.top - c, y = d < 0 && p > d;
          !y != !r.state.upward && r.setState({
            upward: y
          });
        }
      }
    }, r.open = function(s, l) {
      s === void 0 && (s = null), l === void 0 && (l = !0);
      var c = r.props, d = c.disabled, p = c.search;
      d || (p && Ze(r.searchRef.current, "focus"), Ze(r.props, "onOpen", s, r.props), l && r.setState({
        open: !0
      }), r.scrollSelectedItemIntoView());
    }, r.close = function(s, l) {
      l === void 0 && (l = r.handleClose), r.state.open && (Ze(r.props, "onClose", s, r.props), r.setState({
        open: !1
      }, l));
    }, r.handleClose = function() {
      var s = document.activeElement === r.searchRef.current;
      !s && r.ref.current && r.ref.current.blur();
      var l = document.activeElement === r.ref.current, c = s || l;
      r.setState({
        focus: c
      });
    }, r.toggle = function(s) {
      return r.state.open ? r.close(s) : r.open(s);
    }, r.renderText = function() {
      var s = r.props, l = s.multiple, c = s.placeholder, d = s.search, p = s.text, y = r.state, f = y.searchQuery, N = y.selectedIndex, b = y.value, S = y.open, _ = r.hasValue(), E = rt(c && !_ && "default", "text", d && f && "filtered"), k = c, M;
      return p ? k = p : S && !l ? M = r.getSelectedItem(N) : _ && (M = r.getItemByValue(b)), vo.create(M ? x4(M) : k, {
        defaultProps: {
          className: E
        }
      });
    }, r.renderSearchInput = function() {
      var s = r.props, l = s.search, c = s.searchInput, d = r.state.searchQuery;
      return l && yo.create(c, {
        defaultProps: {
          style: {
            width: r.computeSearchInputWidth()
          },
          tabIndex: r.computeSearchInputTabIndex(),
          value: d
        },
        overrideProps: r.handleSearchInputOverrides
      });
    }, r.renderSearchSizer = function() {
      var s = r.props, l = s.search, c = s.multiple;
      return l && c && /* @__PURE__ */ gt.createElement("span", {
        className: "sizer",
        ref: r.sizerRef
      });
    }, r.renderLabels = function() {
      var s = r.props, l = s.multiple, c = s.renderLabel, d = r.state, p = d.selectedLabel, y = d.value;
      if (!(!l || al(y))) {
        var f = Hn(y, r.getItemByValue);
        return Hn(_L(f), function(N, b) {
          var S = {
            active: N.value === p,
            as: "a",
            key: q5(N.key, N.value),
            onClick: r.handleLabelClick,
            onRemove: r.handleLabelRemove,
            value: N.value
          };
          return Mr.create(c(N, b, S), {
            defaultProps: S
          });
        });
      }
    }, r.renderOptions = function() {
      var s = r.props, l = s.lazyLoad, c = s.multiple, d = s.search, p = s.noResultsMessage, y = r.state, f = y.open, N = y.selectedIndex, b = y.value;
      if (l && !f) return null;
      var S = ol({
        value: r.state.value,
        options: r.props.options,
        searchQuery: r.state.searchQuery,
        additionLabel: r.props.additionLabel,
        additionPosition: r.props.additionPosition,
        allowAdditions: r.props.allowAdditions,
        deburr: r.props.deburr,
        multiple: r.props.multiple,
        search: r.props.search
      });
      if (p !== null && d && al(S))
        return /* @__PURE__ */ gt.createElement("div", {
          className: "message"
        }, p);
      var _ = c ? function(E) {
        return Ei(b, E);
      } : function(E) {
        return E === b;
      };
      return Hn(S, function(E, k) {
        return Ia.create(Pe({
          active: _(E.value),
          selected: N === k
        }, E, {
          key: q5(E.key, E.value),
          // Needed for handling click events on disabled items
          style: Pe({}, E.style, {
            pointerEvents: "all"
          })
        }), {
          generateKey: !1,
          overrideProps: function(M) {
            return {
              onClick: function(F, q) {
                M.onClick == null || M.onClick(F, q), r.handleItemClick(F, q);
              }
            };
          }
        });
      });
    }, r.renderMenu = function() {
      var s = r.props, l = s.children, c = s.direction, d = s.header, p = r.state.open, y = r.getDropdownMenuAriaOptions();
      if (!vt(l)) {
        var f = K0.only(l), N = rt(c, ue(p, "visible"), f.props.className);
        return /* @__PURE__ */ ag(f, Pe({
          className: N
        }, y));
      }
      return /* @__PURE__ */ gt.createElement(Fl, Pe({}, y, {
        direction: c,
        open: p
      }), go.create(d, {
        autoGenerateKey: !1
      }), r.renderOptions());
    }, r;
  }
  var n = t.prototype;
  return n.getInitialAutoControlledState = function() {
    return {
      focus: !1,
      searchQuery: ""
    };
  }, t.getAutoControlledStateFromProps = function(r, i, a) {
    var o = {
      __options: r.options,
      __value: i.value
    }, s = (
      // On value change
      !Uc(a.__value, i.value) || // On option keys/values, we only check those properties to avoid recursive performance impacts.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000
      !fP(V5(r.options), V5(a.__options))
    );
    return s && (o.selectedIndex = z5({
      additionLabel: r.additionLabel,
      additionPosition: r.additionPosition,
      allowAdditions: r.allowAdditions,
      deburr: r.deburr,
      multiple: r.multiple,
      search: r.search,
      selectedIndex: i.selectedIndex,
      value: i.value,
      options: r.options,
      searchQuery: i.searchQuery
    })), o;
  }, n.componentDidMount = function() {
    var r = this.state.open;
    r && this.open(null, !1);
  }, n.shouldComponentUpdate = function(r, i) {
    return !Uc(r, this.props) || !Uc(i, this.state);
  }, n.componentDidUpdate = function(r, i) {
    var a = this.props, o = a.closeOnBlur, s = a.minCharacters, l = a.openOnFocus, c = a.search;
    if (process.env.NODE_ENV !== "production") {
      var d = Array.isArray(this.props.value), p = dm(this.props, "value");
      p && this.props.multiple && !d ? console.error("Dropdown `value` must be an array when `multiple` is set." + (" Received type: `" + Object.prototype.toString.call(this.props.value) + "`.")) : p && !this.props.multiple && d && console.error("Dropdown `value` must not be an array when `multiple` is not set. Either set `multiple={true}` or use a string or number value.");
    }
    if (!i.focus && this.state.focus) {
      if (!this.isMouseDown) {
        var y = !c || c && s === 1 && !this.state.open;
        l && y && this.open();
      }
    } else i.focus && !this.state.focus && !this.isMouseDown && o && this.close();
    !i.open && this.state.open ? (this.setOpenDirection(), this.scrollSelectedItemIntoView()) : i.open && this.state.open, i.selectedIndex !== this.state.selectedIndex && this.scrollSelectedItemIntoView();
  }, n.getDropdownMenuAriaOptions = function() {
    var r = this.props, i = r.search, a = r.multiple, o = {};
    return i && (o["aria-multiselectable"] = a, o.role = "listbox"), o;
  }, n.render = function() {
    var r = this.props, i = r.basic, a = r.button, o = r.className, s = r.compact, l = r.disabled, c = r.error, d = r.fluid, p = r.floating, y = r.icon, f = r.inline, N = r.item, b = r.labeled, S = r.loading, _ = r.multiple, E = r.pointing, k = r.search, M = r.selection, F = r.scrolling, q = r.simple, j = r.trigger, x = this.state, C = x.focus, D = x.open, P = x.upward, L = rt(
      "ui",
      ue(D, "active visible"),
      ue(l, "disabled"),
      ue(c, "error"),
      ue(S, "loading"),
      ue(i, "basic"),
      ue(a, "button"),
      ue(s, "compact"),
      ue(d, "fluid"),
      ue(p, "floating"),
      ue(f, "inline"),
      // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
      // TODO: the icon class is only required when a dropdown is a button
      // useKeyOnly(icon, 'icon'),
      ue(b, "labeled"),
      ue(N, "item"),
      ue(_, "multiple"),
      ue(k, "search"),
      ue(M, "selection"),
      ue(q, "simple"),
      ue(F, "scrolling"),
      ue(P, "upward"),
      mn(E, "pointing"),
      "dropdown",
      o
    ), H = nt(An, this.props), $ = lt(this.props), ae = this.getDropdownAriaOptions($, this.props);
    return /* @__PURE__ */ gt.createElement($, Pe({}, H, ae, {
      className: L,
      onBlur: this.handleBlur,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleMouseDown,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      tabIndex: this.computeTabIndex(),
      ref: this.handleRef
    }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), j || this.renderText(), $t.create(y, {
      overrideProps: this.handleIconOverrides,
      autoGenerateKey: !1
    }), this.renderMenu(), D && /* @__PURE__ */ gt.createElement(ja, {
      name: "keydown",
      on: this.closeOnEscape
    }), D && /* @__PURE__ */ gt.createElement(ja, {
      name: "click",
      on: this.closeOnDocumentClick
    }), C && /* @__PURE__ */ gt.createElement(ja, {
      name: "keydown",
      on: this.removeItemOnBackspace
    }));
  }, t;
}(J7);
Jf.handledProps = [];
An.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Label prefixed to an option added by a user. */
  additionLabel: g.oneOfType([g.element, g.string]),
  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
  additionPosition: g.oneOf(["top", "bottom"]),
  /**
   * Allow user additions to the list of options (boolean).
   * Requires the use of `selection`, `options` and `search`.
   */
  allowAdditions: qt([oo(["options", "selection", "search"]), g.bool]),
  /** A Dropdown can reduce its complexity. */
  basic: g.bool,
  /** Format the Dropdown to appear as a button. */
  button: g.bool,
  /** Primary content. */
  children: qt([Jt(["options", "selection"]), Wb({
    children: g.any.isRequired
  }, g.element.isRequired)]),
  /** Additional classes. */
  className: g.string,
  /** Using the clearable setting will let users remove their selection from a dropdown. */
  clearable: g.bool,
  /** Whether or not the menu should close when the dropdown is blurred. */
  closeOnBlur: g.bool,
  /** Whether or not the dropdown should close when the escape key is pressed. */
  closeOnEscape: g.bool,
  /**
   * Whether or not the menu should close when a value is selected from the dropdown.
   * By default, multiple selection dropdowns will remain open on change, while single
   * selection dropdowns will close on change.
   */
  closeOnChange: g.bool,
  /** A compact dropdown has no minimum width. */
  compact: g.bool,
  /** Whether or not the dropdown should strip diacritics in options and input search */
  deburr: g.bool,
  /** Initial value of open. */
  defaultOpen: g.bool,
  /** Initial value of searchQuery. */
  defaultSearchQuery: g.string,
  /** Currently selected label in multi-select. */
  defaultSelectedLabel: qt([oo(["multiple"]), g.oneOfType([g.number, g.string])]),
  /** Initial value of upward. */
  defaultUpward: g.bool,
  /** Initial value or value array if multiple. */
  defaultValue: g.oneOfType([g.number, g.string, g.bool, g.arrayOf(g.oneOfType([g.string, g.number, g.bool]))]),
  /** A dropdown menu can open to the left or to the right. */
  direction: g.oneOf(["left", "right"]),
  /** A disabled dropdown menu or item does not allow user interaction. */
  disabled: g.bool,
  /** An errored dropdown can alert a user to a problem. */
  error: g.bool,
  /** A dropdown menu can contain floated content. */
  floating: g.bool,
  /** A dropdown can take the full width of its parent */
  fluid: g.bool,
  /** A dropdown menu can contain a header. */
  header: g.node,
  /** Shorthand for Icon. */
  icon: g.oneOfType([g.node, g.object]),
  /** A dropdown can be formatted to appear inline in other content. */
  inline: g.bool,
  /** A dropdown can be formatted as a Menu item. */
  item: g.bool,
  /** A dropdown can be labeled. */
  labeled: g.bool,
  /** A dropdown can defer rendering its options until it is open. */
  lazyLoad: g.bool,
  /** A dropdown can show that it is currently loading data. */
  loading: g.bool,
  /** The minimum characters for a search to begin showing results. */
  minCharacters: g.number,
  /** A selection dropdown can allow multiple selections. */
  multiple: g.bool,
  /** Message to display when there are no results. */
  noResultsMessage: g.node,
  /**
   * Called when a user adds a new item. Use this to update the options list.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and the new item's value.
   */
  onAddItem: g.func,
  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: g.func,
  /**
   * Called when the user attempts to change the value.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: g.func,
  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func,
  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: g.func,
  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: g.func,
  /**
   * Called when a multi-select label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All label props.
   */
  onLabelClick: g.func,
  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: g.func,
  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: g.func,
  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of searchQuery.
   */
  onSearchChange: g.func,
  /** Controls whether or not the dropdown menu is displayed. */
  open: g.bool,
  /** Whether or not the menu should open when the dropdown is focused. */
  openOnFocus: g.bool,
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: qt([Jt(["children"]), g.arrayOf(g.shape(Ia.propTypes))]),
  /** Placeholder text. */
  placeholder: g.string,
  /** A dropdown can be formatted so that its menu is pointing. */
  pointing: g.oneOfType([g.bool, g.oneOf(["left", "right", "top", "top left", "top right", "bottom", "bottom left", "bottom right"])]),
  /**
   * Mapped over the active items and returns shorthand for the active item Labels.
   * Only applies to `multiple` Dropdowns.
   *
   * @param {object} item - A currently active dropdown item.
   * @param {number} index - The current index.
   * @param {object} defaultLabelProps - The default props for an active item Label.
   * @returns {*} Shorthand for a Label.
   */
  renderLabel: g.func,
  /** A dropdown can have its menu scroll. */
  scrolling: g.bool,
  /**
   * A selection dropdown can allow a user to search through a large list of choices.
   * Pass a function here to replace the default search.
   */
  search: g.oneOfType([g.bool, g.func]),
  /** A shorthand for a search input. */
  searchInput: g.oneOfType([g.array, g.node, g.object]),
  /** Current value of searchQuery. Creates a controlled component. */
  searchQuery: g.string,
  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?
  /** Define whether the highlighted item should be selected on blur. */
  selectOnBlur: g.bool,
  /**
   * Whether or not to change the value when navigating the menu using arrow keys.
   * Setting to false will require enter or left click to confirm a choice.
   */
  selectOnNavigation: g.bool,
  /** Currently selected label in multi-select. */
  selectedLabel: qt([oo(["multiple"]), g.oneOfType([g.string, g.number])]),
  /** A dropdown can be used to select between choices in a form. */
  selection: qt([Jt(["children"]), oo(["options"]), g.bool]),
  /** A simple dropdown can open without Javascript. */
  simple: g.bool,
  /** A dropdown can receive focus. */
  tabIndex: g.oneOfType([g.number, g.string]),
  /** The text displayed in the dropdown, usually for the active item. */
  text: g.string,
  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
  trigger: qt([Jt(["selection", "text"]), g.node]),
  /** Current value or value array if multiple. Creates a controlled component. */
  value: g.oneOfType([g.bool, g.string, g.number, g.arrayOf(g.oneOfType([g.bool, g.string, g.number]))]),
  /** Controls whether the dropdown will open upward. */
  upward: g.bool,
  /**
   * A dropdown will go to the last element when ArrowUp is pressed on the first,
   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
   */
  wrapSelection: g.bool
} : {};
An.displayName = "Dropdown";
Jf.autoControlledProps = ["open", "searchQuery", "selectedLabel", "value", "upward"];
process.env.NODE_ENV !== "production" && (Jf.propTypes = process.env.NODE_ENV !== "production" ? An.propTypes : {});
An.Divider = _u;
An.Header = go;
An.Item = Ia;
An.Menu = Fl;
An.SearchInput = yo;
An.Text = vo;
var fa = /* @__PURE__ */ R.forwardRef(function(e, t) {
  return /* @__PURE__ */ R.createElement(An, Pe({}, e, {
    selection: !0,
    ref: t
  }));
});
fa.handledProps = ["options"];
fa.displayName = "Select";
fa.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: g.arrayOf(g.shape(An.Item.propTypes)).isRequired
} : {};
fa.Divider = An.Divider;
fa.Header = An.Header;
fa.Item = An.Item;
fa.Menu = An.Menu;
var Nu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.rows, r = n === void 0 ? 3 : n, i = e.value, a = qa(t, R.useRef()), o = function(d) {
    var p = Hi(d, "target.value");
    Ze(e, "onChange", d, Pe({}, e, {
      value: p
    }));
  }, s = function(d) {
    var p = Hi(d, "target.value");
    Ze(e, "onInput", d, Pe({}, e, {
      value: p
    }));
  }, l = nt(Nu, e), c = lt(e, {
    defaultAs: "textarea"
  });
  return /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    onChange: o,
    onInput: s,
    ref: a,
    rows: r,
    value: i
  }));
});
Nu.handledProps = ["as", "onChange", "onInput", "rows", "value"];
Nu.displayName = "TextArea";
Nu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /**
   * Called on change.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onChange: g.func,
  /**
   * Called on input.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onInput: g.func,
  /** Indicates row count for a TextArea. */
  rows: g.oneOfType([g.number, g.string]),
  /** The value of the textarea. */
  value: g.oneOfType([g.number, g.string])
} : {};
var nr = /* @__PURE__ */ gt.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.control, o = e.disabled, s = e.error, l = e.inline, c = e.label, d = e.required, p = e.type, y = e.width, f = e.id, N = rt(ue(o, "disabled"), ue(s, "error"), ue(l, "inline"), ue(d, "required"), kr(y, "wide"), "field", r), b = nt(nr, e), S = lt(e), _ = Hi(s, "pointing", "above"), E = Mr.create(s, {
    autoGenerateKey: !1,
    defaultProps: {
      prompt: !0,
      pointing: _,
      id: f ? f + "-error-message" : void 0,
      role: "alert",
      "aria-atomic": !0
    }
  }), k = (_ === "below" || _ === "right") && E, M = (_ === "above" || _ === "left") && E;
  if (Tt(a))
    return Tt(c) ? /* @__PURE__ */ gt.createElement(S, Pe({}, b, {
      className: N,
      id: f,
      ref: t
    }), vt(n) ? i : n) : /* @__PURE__ */ gt.createElement(S, Pe({}, b, {
      className: N,
      id: f,
      ref: t
    }), k, Om(c, {
      autoGenerateKey: !1
    }), M);
  var F = f && s ? f + "-error-message" : null, q = {
    "aria-describedby": F,
    "aria-invalid": s ? !0 : void 0
  }, j = Pe({}, b, {
    content: i,
    children: n,
    disabled: o,
    required: d,
    type: p,
    id: f,
    ref: t
  });
  return a === "input" && (p === "checkbox" || p === "radio") ? /* @__PURE__ */ gt.createElement(S, {
    className: N
  }, /* @__PURE__ */ gt.createElement("label", null, k, /* @__PURE__ */ rh(a, Pe({}, q, j)), " ", c, M)) : a === dr || a === Tl ? /* @__PURE__ */ gt.createElement(S, {
    className: N
  }, k, /* @__PURE__ */ rh(a, Pe({}, q, j, {
    label: c
  })), M) : /* @__PURE__ */ gt.createElement(S, {
    className: N
  }, Om(c, {
    defaultProps: {
      htmlFor: f
    },
    autoGenerateKey: !1
  }), k, /* @__PURE__ */ rh(a, Pe({}, q, j)), M);
});
nr.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "id", "inline", "label", "required", "type", "width"];
nr.displayName = "FormField";
nr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /**
   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
   * Extra FormField props are passed to the control component.
   * Mutually exclusive with children.
   */
  control: g.oneOfType([g.elementType, g.oneOf(["button", "input", "select", "textarea"])]),
  /** Individual fields may be disabled. */
  disabled: g.bool,
  /** Individual fields may display an error state along with a message. */
  error: g.oneOfType([g.bool, kt]),
  /** The id of the control */
  id: g.string,
  /** A field can have its label next to instead of above it. */
  inline: g.bool,
  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`
  /** Mutually exclusive with children. */
  label: g.oneOfType([g.node, g.object]),
  /** A field can show that input is mandatory. */
  required: g.bool,
  /** Passed to the control component (i.e. <input type='password' />) */
  type: qt([
    oo(["control"])
    // don't strictly validate HTML types
    // a control might be passed that uses a `type` prop with unknown values
    // let the control validate if for us
  ]),
  /** A field can specify its width in grid columns */
  width: g.oneOf(Yr)
} : {};
var Su = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? Ft : n, i = nt(Su, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
Su.handledProps = ["as", "control"];
Su.displayName = "FormButton";
Su.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Eu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? dr : n, i = nt(Eu, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
Eu.handledProps = ["as", "control"];
Eu.displayName = "FormCheckbox";
Eu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Cu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? An : n, i = nt(Cu, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
Cu.handledProps = ["as", "control"];
Cu.displayName = "FormDropdown";
Cu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Ou = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.disabled, a = e.error, o = e.grouped, s = e.inline, l = e.unstackable, c = e.widths, d = rt(ue(a, "error"), ue(i, "disabled"), ue(o, "grouped"), ue(s, "inline"), ue(l, "unstackable"), kr(c, null, !0), "fields", r), p = nt(Ou, e), y = lt(e);
  return /* @__PURE__ */ R.createElement(y, Pe({}, p, {
    className: d,
    ref: t
  }), n);
});
Ou.handledProps = ["as", "children", "className", "disabled", "error", "grouped", "inline", "unstackable", "widths"];
Ou.displayName = "FormGroup";
Ou.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A Form Group can be disabled. */
  disabled: g.bool,
  /** A Form Group can have error. */
  error: g.bool,
  /** Fields can show related choices. */
  grouped: qt([Jt(["inline"]), g.bool]),
  /** Multiple fields may be inline in a row. */
  inline: qt([Jt(["grouped"]), g.bool]),
  /** A form group can prevent itself from stacking on mobile. */
  unstackable: g.bool,
  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
  widths: g.oneOf([].concat(Yr, ["equal"]))
} : {};
var bo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.action, r = e.actionPosition, i = e.children, a = e.className, o = e.disabled, s = e.error, l = e.fluid, c = e.focus, d = e.icon, p = e.iconPosition, y = e.input, f = e.inverted, N = e.label, b = e.labelPosition, S = e.loading, _ = e.size, E = e.tabIndex, k = e.transparent, M = e.type, F = M === void 0 ? "text" : M, q = function() {
    if (!Tt(d))
      return d;
    if (S)
      return "spinner";
  }, j = function() {
    if (!Tt(E))
      return E;
    if (o)
      return -1;
  }, x = function(oe) {
    var se = Hi(oe, "target.value");
    Ze(e, "onChange", oe, Pe({}, e, {
      value: se
    }));
  }, C = function() {
    var oe = nt(bo, e), se = Fg(oe), J = se[0], re = se[1];
    return [Pe({}, J, {
      disabled: o,
      type: F,
      tabIndex: j(),
      onChange: x,
      ref: t
    }), re];
  }, D = rt("ui", _, ue(o, "disabled"), ue(s, "error"), ue(l, "fluid"), ue(c, "focus"), ue(f, "inverted"), ue(S, "loading"), ue(k, "transparent"), Dr(r, "action") || ue(n, "action"), Dr(p, "icon") || ue(d || S, "icon"), Dr(b, "labeled") || ue(N, "labeled"), "input", a), P = lt(e), L = C(), H = L[0], $ = L[1];
  if (!vt(i)) {
    var ae = Hn(R.Children.toArray(i), function(oe) {
      return oe.type === "input" ? /* @__PURE__ */ R.cloneElement(oe, Pe({}, H, oe.props, {
        ref: function(se) {
          Zc(oe.ref, se), Zc(t, se);
        }
      })) : oe;
    });
    return /* @__PURE__ */ R.createElement(P, Pe({}, $, {
      className: D
    }), ae);
  }
  var ce = Ft.create(n, {
    autoGenerateKey: !1
  }), le = Mr.create(N, {
    defaultProps: {
      className: rt(
        "label",
        // add 'left|right corner'
        Ei(b, "corner") && b
      )
    },
    autoGenerateKey: !1
  });
  return /* @__PURE__ */ R.createElement(P, Pe({}, $, {
    className: D
  }), r === "left" && ce, b !== "right" && le, yj(y || F, {
    defaultProps: H,
    autoGenerateKey: !1
  }), $t.create(q(), {
    autoGenerateKey: !1
  }), r !== "left" && ce, b === "right" && le);
});
bo.handledProps = ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"];
bo.displayName = "Input";
bo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** An Input can be formatted to alert the user to an action they may perform. */
  action: g.oneOfType([g.bool, kt]),
  /** An action can appear along side an Input on the left or right. */
  actionPosition: g.oneOf(["left"]),
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** An Input field can show that it is disabled. */
  disabled: g.bool,
  /** An Input field can show the data contains errors. */
  error: g.bool,
  /** Take on the size of its container. */
  fluid: g.bool,
  /** An Input field can show a user is currently interacting with it. */
  focus: g.bool,
  /** Optional Icon to display inside the Input. */
  icon: g.oneOfType([g.bool, kt]),
  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: g.oneOf(["left"]),
  /** Shorthand for creating the HTML Input. */
  input: kt,
  /** Format to appear on dark backgrounds. */
  inverted: g.bool,
  /** Optional Label to display along side the Input. */
  label: kt,
  /** A Label can appear outside an Input on the left or right. */
  labelPosition: g.oneOf(["left", "right", "left corner", "right corner"]),
  /** An Icon Input field can show that it is currently loading data. */
  loading: g.bool,
  /**
   * Called on change.
   *
   * @param {ChangeEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and a proposed value.
   */
  onChange: g.func,
  /** An Input can vary in size. */
  size: g.oneOf(["mini", "small", "large", "big", "huge", "massive"]),
  /** An Input can receive focus. */
  tabIndex: g.oneOfType([g.number, g.string]),
  /** Transparent Input has no background. */
  transparent: g.bool,
  /** The HTML input type. */
  type: g.string
} : {};
bo.create = Vt(bo, function(e) {
  return {
    type: e
  };
});
var ju = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? bo : n, i = nt(ju, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
ju.handledProps = ["as", "control"];
ju.displayName = "FormInput";
ju.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Pu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? Tl : n, i = nt(Pu, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
Pu.handledProps = ["as", "control"];
Pu.displayName = "FormRadio";
Pu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Lu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? fa : n, i = e.options, a = nt(Lu, e), o = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(o, Pe({}, a, {
    control: r,
    options: i,
    ref: t
  }));
});
Lu.handledProps = ["as", "control", "options"];
Lu.displayName = "FormSelect";
Lu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control,
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: g.arrayOf(g.shape(An.Item.propTypes)).isRequired
} : {};
var Tu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.control, r = n === void 0 ? Nu : n, i = nt(Tu, e), a = lt(e, {
    defaultAs: nr
  });
  return /* @__PURE__ */ R.createElement(a, Pe({}, i, {
    control: r,
    ref: t
  }));
});
Tu.handledProps = ["as", "control"];
Tu.displayName = "FormTextArea";
Tu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A FormField control prop. */
  control: nr.propTypes.control
} : {};
var Ct = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.action, r = e.children, i = e.className, a = e.error, o = e.inverted, s = e.loading, l = e.reply, c = e.size, d = e.success, p = e.unstackable, y = e.warning, f = e.widths, N = function(E) {
    typeof n != "string" && Ze(E, "preventDefault");
    for (var k = arguments.length, M = new Array(k > 1 ? k - 1 : 0), F = 1; F < k; F++)
      M[F - 1] = arguments[F];
    Ze.apply(void 0, [e, "onSubmit", E, e].concat(M));
  }, b = rt("ui", c, ue(a, "error"), ue(o, "inverted"), ue(s, "loading"), ue(l, "reply"), ue(d, "success"), ue(p, "unstackable"), ue(y, "warning"), kr(f, null, !0), "form", i), S = nt(Ct, e), _ = lt(e, {
    defaultAs: "form"
  });
  return /* @__PURE__ */ R.createElement(_, Pe({}, S, {
    action: n,
    className: b,
    onSubmit: N,
    ref: t
  }), r);
});
Ct.handledProps = ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"];
Ct.displayName = "Form";
Ct.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** The HTML form action */
  action: g.string,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Automatically show any error Message children. */
  error: g.bool,
  /** A form can have its color inverted for contrast. */
  inverted: g.bool,
  /** Automatically show a loading indicator. */
  loading: g.bool,
  /** The HTML form submit handler. */
  onSubmit: g.func,
  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: g.bool,
  /** A form can vary in size. */
  size: g.oneOf(Rr(Or, "medium")),
  /** Automatically show any success Message children. */
  success: g.bool,
  /** A form can prevent itself from stacking on mobile. */
  unstackable: g.bool,
  /** Automatically show any warning Message children. */
  warning: g.bool,
  /** Forms can automatically divide fields to be equal width. */
  widths: g.oneOf(["equal"])
} : {};
Ct.Field = nr;
Ct.Button = Su;
Ct.Checkbox = Eu;
Ct.Dropdown = Cu;
Ct.Group = Ou;
Ct.Input = ju;
Ct.Radio = Pu;
Ct.Select = Lu;
Ct.TextArea = Tu;
var ia = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.computer, a = e.color, o = e.floated, s = e.largeScreen, l = e.mobile, c = e.only, d = e.stretched, p = e.tablet, y = e.textAlign, f = e.verticalAlign, N = e.widescreen, b = e.width, S = rt(a, ue(d, "stretched"), xf(c, "only"), Do(y), Dr(o, "floated"), Ro(f), kr(i, "wide computer"), kr(s, "wide large screen"), kr(l, "wide mobile"), kr(p, "wide tablet"), kr(N, "wide widescreen"), kr(b, "wide"), "column", r), _ = nt(ia, e), E = lt(e);
  return /* @__PURE__ */ R.createElement(E, Pe({}, _, {
    className: S,
    ref: t
  }), n);
});
ia.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"];
ia.displayName = "GridColumn";
ia.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A grid column can be colored. */
  color: g.oneOf(Fi),
  /** A column can specify a width for a computer. */
  computer: qt([Jt(["width"]), g.oneOf(Yr)]),
  /** A column can sit flush against the left or right edge of a row. */
  floated: g.oneOf(lu),
  /** A column can specify a width for a large screen device. */
  largeScreen: qt([Jt(["width"]), g.oneOf(Yr)]),
  /** A column can specify a width for a mobile device. */
  mobile: qt([Jt(["width"]), g.oneOf(Yr)]),
  /** A column can appear only for a specific device, or screen sizes. */
  only: _f(Zb),
  /** A column can stretch its contents to take up the entire grid or row height. */
  stretched: g.bool,
  /** A column can specify a width for a tablet device. */
  tablet: qt([Jt(["width"]), g.oneOf(Yr)]),
  /** A column can specify its text alignment. */
  textAlign: g.oneOf(Mo),
  /** A column can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: g.oneOf(_s),
  /** A column can specify a width for a wide screen device. */
  widescreen: qt([Jt(["width"]), g.oneOf(Yr)]),
  /** Represents width of column. */
  width: qt([Jt(["computer", "largeScreen", "mobile", "tablet", "widescreen"]), g.oneOf(Yr)])
} : {};
ia.create = Vt(ia, function(e) {
  return {
    children: e
  };
});
var Fu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.centered, r = e.children, i = e.className, a = e.color, o = e.columns, s = e.divided, l = e.only, c = e.reversed, d = e.stretched, p = e.textAlign, y = e.verticalAlign, f = rt(a, ue(n, "centered"), ue(s, "divided"), ue(d, "stretched"), xf(l, "only"), xf(c, "reversed"), Do(p), Ro(y), kr(o, "column", !0), "row", i), N = nt(Fu, e), b = lt(e);
  return /* @__PURE__ */ R.createElement(b, Pe({}, N, {
    className: f,
    ref: t
  }), r);
});
Fu.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"];
Fu.displayName = "GridRow";
Fu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A row can have its columns centered. */
  centered: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A grid row can be colored. */
  color: g.oneOf(Fi),
  /** Represents column count per line in Row. */
  columns: g.oneOf([].concat(Yr, ["equal"])),
  /** A row can have dividers between its columns. */
  divided: g.bool,
  /** A row can appear only for a specific device, or screen sizes. */
  only: _f(Zb),
  /** A row can specify that its columns should reverse order at different device sizes. */
  reversed: _f(["computer", "computer vertically", "mobile", "mobile vertically", "tablet", "tablet vertically"]),
  /** A row can stretch its contents to take up the entire column height. */
  stretched: g.bool,
  /** A row can specify its text alignment. */
  textAlign: g.oneOf(Mo),
  /** A row can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: g.oneOf(_s)
} : {};
var We = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.celled, r = e.centered, i = e.children, a = e.className, o = e.columns, s = e.container, l = e.divided, c = e.doubling, d = e.inverted, p = e.padded, y = e.relaxed, f = e.reversed, N = e.stackable, b = e.stretched, S = e.textAlign, _ = e.verticalAlign, E = rt("ui", ue(r, "centered"), ue(s, "container"), ue(c, "doubling"), ue(d, "inverted"), ue(N, "stackable"), ue(b, "stretched"), mn(n, "celled"), mn(l, "divided"), mn(p, "padded"), mn(y, "relaxed"), xf(f, "reversed"), Do(S), Ro(_), kr(o, "column", !0), "grid", a), k = nt(We, e), M = lt(e);
  return /* @__PURE__ */ R.createElement(M, Pe({}, k, {
    className: E,
    ref: t
  }), i);
});
We.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"];
We.Column = ia;
We.Row = Fu;
We.displayName = "Grid";
We.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A grid can have rows divided into cells. */
  celled: g.oneOfType([g.bool, g.oneOf(["internally"])]),
  /** A grid can have its columns centered. */
  centered: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Represents column count per row in Grid. */
  columns: g.oneOf([].concat(Yr, ["equal"])),
  /** A grid can be combined with a container to use the available layout and alignment. */
  container: g.bool,
  /** A grid can have dividers between its columns. */
  divided: g.oneOfType([g.bool, g.oneOf(["vertically"])]),
  /** A grid can double its column width on tablet and mobile sizes. */
  doubling: g.bool,
  /** A grid's colors can be inverted. */
  inverted: g.bool,
  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
  padded: g.oneOfType([g.bool, g.oneOf(["horizontally", "vertically"])]),
  /** A grid can increase its gutters to allow for more negative space. */
  relaxed: g.oneOfType([g.bool, g.oneOf(["very"])]),
  /** A grid can specify that its columns should reverse order at different device sizes. */
  reversed: _f(["computer", "computer vertically", "mobile", "mobile vertically", "tablet", "tablet vertically"]),
  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
  stackable: g.bool,
  /** A grid can stretch its contents to take up the entire grid height. */
  stretched: g.bool,
  /** A grid can specify its text alignment. */
  textAlign: g.oneOf(Mo),
  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: g.oneOf(_s)
} : {};
var Il = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("content", r), o = nt(Il, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
Il.handledProps = ["as", "children", "className", "content"];
Il.displayName = "MessageContent";
Il.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
var wo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("header", r), o = nt(wo, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
wo.handledProps = ["as", "children", "className", "content"];
wo.displayName = "MessageHeader";
wo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
wo.create = Vt(wo, function(e) {
  return {
    content: e
  };
});
var xo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("content", r), o = nt(xo, e), s = lt(e, {
    defaultAs: "li"
  });
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
xo.handledProps = ["as", "children", "className", "content"];
xo.displayName = "MessageItem";
xo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
xo.create = Vt(xo, function(e) {
  return {
    content: e
  };
});
var _o = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.items, a = rt("list", r), o = nt(_o, e), s = lt(e, {
    defaultAs: "ul"
  });
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? Hn(i, xo.create) : n);
});
_o.handledProps = ["as", "children", "className", "items"];
_o.displayName = "MessageList";
_o.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand Message.Items. */
  items: xs
} : {};
_o.create = Vt(_o, function(e) {
  return {
    items: e
  };
});
var Ii = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.attached, r = e.children, i = e.className, a = e.color, o = e.compact, s = e.content, l = e.error, c = e.floating, d = e.header, p = e.hidden, y = e.icon, f = e.info, N = e.list, b = e.negative, S = e.onDismiss, _ = e.positive, E = e.size, k = e.success, M = e.visible, F = e.warning, q = rt("ui", a, E, ue(o, "compact"), ue(l, "error"), ue(c, "floating"), ue(p, "hidden"), ue(y, "icon"), ue(f, "info"), ue(b, "negative"), ue(_, "positive"), ue(k, "success"), ue(M, "visible"), ue(F, "warning"), mn(n, "attached"), "message", i), j = nt(Ii, e), x = lt(e), C = lo(function(P) {
    Ze(e, "onDismiss", P, e);
  }), D = S && /* @__PURE__ */ R.createElement($t, {
    name: "close",
    onClick: C
  });
  return vt(r) ? /* @__PURE__ */ R.createElement(x, Pe({}, j, {
    className: q,
    ref: t
  }), D, $t.create(y, {
    autoGenerateKey: !1
  }), (!Tt(d) || !Tt(s) || !Tt(N)) && /* @__PURE__ */ R.createElement(Il, null, wo.create(d, {
    autoGenerateKey: !1
  }), _o.create(N, {
    autoGenerateKey: !1
  }), vj(s, {
    autoGenerateKey: !1
  }))) : /* @__PURE__ */ R.createElement(x, Pe({}, j, {
    className: q,
    ref: t
  }), D, r);
});
Ii.handledProps = ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"];
Ii.displayName = "Message";
Ii.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A message can be formatted to attach itself to other content. */
  attached: g.oneOfType([g.bool, g.oneOf(["bottom", "top"])]),
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A message can be formatted to be different colors. */
  color: g.oneOf(Fi),
  /** A message can only take up the width of its content. */
  compact: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** A message may be formatted to display a negative message. Same as `negative`. */
  error: g.bool,
  /** A message can float above content that it is related to. */
  floating: g.bool,
  /** Shorthand for MessageHeader. */
  header: kt,
  /** A message can be hidden. */
  hidden: g.bool,
  /** A message can contain an icon. */
  icon: g.oneOfType([kt, g.bool]),
  /** A message may be formatted to display information. */
  info: g.bool,
  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
  list: xs,
  /** A message may be formatted to display a negative message. Same as `error`. */
  negative: g.bool,
  /**
   * A message that the user can choose to hide.
   * Called when the user clicks the "x" icon. This also adds the "x" icon.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onDismiss: g.func,
  /** A message may be formatted to display a positive message.  Same as `success`. */
  positive: g.bool,
  /** A message can have different sizes. */
  size: g.oneOf(Rr(Or, "medium")),
  /** A message may be formatted to display a positive message.  Same as `positive`. */
  success: g.bool,
  /** A message can be set to visible to force itself to be shown. */
  visible: g.bool,
  /** A message may be formatted to display warning messages. */
  warning: g.bool
} : {};
Ii.Content = Il;
Ii.Header = wo;
Ii.List = _o;
Ii.Item = xo;
var kl = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = rt(r), a = nt(kl, e), o = lt(e, {
    defaultAs: "tbody"
  });
  return /* @__PURE__ */ R.createElement(o, Pe({}, a, {
    className: i,
    ref: t
  }), n);
});
kl.handledProps = ["as", "children", "className"];
kl.displayName = "TableBody";
kl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string
} : {};
var ka = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.collapsing, o = e.content, s = e.disabled, l = e.error, c = e.icon, d = e.negative, p = e.positive, y = e.selectable, f = e.singleLine, N = e.textAlign, b = e.verticalAlign, S = e.warning, _ = e.width, E = rt(ue(n, "active"), ue(a, "collapsing"), ue(s, "disabled"), ue(l, "error"), ue(d, "negative"), ue(p, "positive"), ue(y, "selectable"), ue(f, "single line"), ue(S, "warning"), Do(N), Ro(b), kr(_, "wide"), i), k = nt(ka, e), M = lt(e, {
    defaultAs: "td"
  });
  return vt(r) ? /* @__PURE__ */ R.createElement(M, Pe({}, k, {
    className: E,
    ref: t
  }), $t.create(c), o) : /* @__PURE__ */ R.createElement(M, Pe({}, k, {
    className: E,
    ref: t
  }), r);
});
ka.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"];
ka.displayName = "TableCell";
ka.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A cell can be active or selected by a user. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A cell can be collapsing so that it only uses as much space as required. */
  collapsing: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** A cell can be disabled. */
  disabled: g.bool,
  /** A cell may call attention to an error or a negative value. */
  error: g.bool,
  /** Add an Icon by name, props object, or pass an <Icon /> */
  icon: kt,
  /** A cell may let a user know whether a value is bad. */
  negative: g.bool,
  /** A cell may let a user know whether a value is good. */
  positive: g.bool,
  /** A cell can be selectable. */
  selectable: g.bool,
  /** A cell can specify that its contents should remain on a single line and not wrap. */
  singleLine: g.bool,
  /** A table cell can adjust its text alignment. */
  textAlign: g.oneOf(Rr(Mo, "justified")),
  /** A table cell can adjust its text alignment. */
  verticalAlign: g.oneOf(_s),
  /** A cell may warn a user. */
  warning: g.bool,
  /** A table can specify the width of individual columns independently. */
  width: g.oneOf(Yr)
} : {};
ka.create = Vt(ka, function(e) {
  return {
    content: e
  };
});
var Ns = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.fullWidth, o = rt(ue(a, "full-width"), r), s = nt(Ns, e), l = lt(e, {
    defaultAs: "thead"
  });
  return /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), vt(n) ? i : n);
});
Ns.handledProps = ["as", "children", "className", "content", "fullWidth"];
Ns.displayName = "TableHeader";
Ns.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
  fullWidth: g.bool
} : {};
var Dl = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.as, r = n === void 0 ? "tfoot" : n, i = nt(Dl, e);
  return /* @__PURE__ */ R.createElement(Ns, Pe({}, i, {
    as: r,
    ref: t
  }));
});
Dl.handledProps = ["as"];
Dl.displayName = "TableFooter";
Dl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType
} : {};
var Iu = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.as, r = n === void 0 ? "th" : n, i = e.className, a = e.sorted, o = rt(Dr(a, "sorted"), i), s = nt(Iu, e);
  return /* @__PURE__ */ R.createElement(ka, Pe({}, s, {
    as: r,
    className: o,
    ref: t
  }));
});
Iu.handledProps = ["as", "className", "sorted"];
Iu.displayName = "TableHeaderCell";
Iu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Additional classes. */
  className: g.string,
  /** A header cell can be sorted in ascending or descending order. */
  sorted: g.oneOf(["ascending", "descending"])
} : {};
var $i = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.cellAs, i = r === void 0 ? "td" : r, a = e.cells, o = e.children, s = e.className, l = e.disabled, c = e.error, d = e.negative, p = e.positive, y = e.textAlign, f = e.verticalAlign, N = e.warning, b = rt(ue(n, "active"), ue(l, "disabled"), ue(c, "error"), ue(d, "negative"), ue(p, "positive"), ue(N, "warning"), Do(y), Ro(f), s), S = nt($i, e), _ = lt(e, {
    defaultAs: "tr"
  });
  return vt(o) ? /* @__PURE__ */ R.createElement(_, Pe({}, S, {
    className: b,
    ref: t
  }), Hn(a, function(E) {
    return ka.create(E, {
      defaultProps: {
        as: i
      }
    });
  })) : /* @__PURE__ */ R.createElement(_, Pe({}, S, {
    className: b,
    ref: t
  }), o);
});
$i.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"];
$i.displayName = "TableRow";
$i.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A row can be active or selected by a user. */
  active: g.bool,
  /** An element type to render as (string or function). */
  cellAs: g.elementType,
  /** Shorthand array of props for TableCell. */
  cells: xs,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A row can be disabled. */
  disabled: g.bool,
  /** A row may call attention to an error or a negative value. */
  error: g.bool,
  /** A row may let a user know whether a value is bad. */
  negative: g.bool,
  /** A row may let a user know whether a value is good. */
  positive: g.bool,
  /** A table row can adjust its text alignment. */
  textAlign: g.oneOf(Rr(Mo, "justified")),
  /** A table row can adjust its vertical alignment. */
  verticalAlign: g.oneOf(_s),
  /** A row may warn a user. */
  warning: g.bool
} : {};
$i.create = Vt($i, function(e) {
  return {
    cells: e
  };
});
var Qe = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.attached, r = e.basic, i = e.celled, a = e.children, o = e.className, s = e.collapsing, l = e.color, c = e.columns, d = e.compact, p = e.definition, y = e.fixed, f = e.footerRow, N = e.headerRow, b = e.headerRows, S = e.inverted, _ = e.padded, E = e.renderBodyRow, k = e.selectable, M = e.singleLine, F = e.size, q = e.sortable, j = e.stackable, x = e.striped, C = e.structured, D = e.tableData, P = e.textAlign, L = e.unstackable, H = e.verticalAlign, $ = rt("ui", l, F, ue(i, "celled"), ue(s, "collapsing"), ue(p, "definition"), ue(y, "fixed"), ue(S, "inverted"), ue(k, "selectable"), ue(M, "single line"), ue(q, "sortable"), ue(j, "stackable"), ue(x, "striped"), ue(C, "structured"), ue(L, "unstackable"), mn(n, "attached"), mn(r, "basic"), mn(d, "compact"), mn(_, "padded"), Do(P), Ro(H), kr(c, "column"), "table", o), ae = nt(Qe, e), ce = lt(e, {
    defaultAs: "table"
  });
  if (!vt(a))
    return /* @__PURE__ */ R.createElement(ce, Pe({}, ae, {
      className: $,
      ref: t
    }), a);
  var le = N || b, oe = {
    defaultProps: {
      cellAs: "th"
    }
  }, se = le && /* @__PURE__ */ R.createElement(Ns, null, $i.create(N, oe), Hn(b, function(J) {
    return $i.create(J, oe);
  }));
  return /* @__PURE__ */ R.createElement(ce, Pe({}, ae, {
    className: $,
    ref: t
  }), se, /* @__PURE__ */ R.createElement(kl, null, E && Hn(D, function(J, re) {
    return $i.create(E(J, re));
  })), f && /* @__PURE__ */ R.createElement(Dl, null, $i.create(f)));
});
Qe.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"];
Qe.displayName = "Table";
Qe.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Attach table to other content */
  attached: g.oneOfType([g.bool, g.oneOf(["top", "bottom"])]),
  /** A table can reduce its complexity to increase readability. */
  basic: g.oneOfType([g.oneOf(["very"]), g.bool]),
  /** A table may be divided into individual cells. */
  celled: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A table can be collapsing, taking up only as much space as its rows. */
  collapsing: g.bool,
  /** A table can be given a color to distinguish it from other tables. */
  color: g.oneOf(Fi),
  /** A table can specify its column count to divide its content evenly. */
  columns: g.oneOf(Yr),
  /** A table may sometimes need to be more compact to make more rows visible at a time. */
  compact: g.oneOfType([g.bool, g.oneOf(["very"])]),
  /** A table may be formatted to emphasize a first column that defines a rows content. */
  definition: g.bool,
  /**
   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
   */
  fixed: g.bool,
  /** Shorthand for a TableRow to be placed within Table.Footer. */
  footerRow: kt,
  /** Shorthand for a TableRow to be placed within Table.Header. */
  headerRow: qt([Jt(["headerRows"]), kt]),
  /** Shorthand for multiple TableRows to be placed within Table.Header. */
  headerRows: qt([Jt(["headerRow"]), xs]),
  /** A table's colors can be inverted. */
  inverted: g.bool,
  /** A table may sometimes need to be more padded for legibility. */
  padded: g.oneOfType([g.bool, g.oneOf(["very"])]),
  /**
   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
   *
   * @param {*} data - An element in the `tableData` array.
   * @param {number} index - The index of the current element in `tableData`.
   * @returns {*} Shorthand for a Table.Row.
   */
  renderBodyRow: qt([Jt(["children"]), oo(["tableData"]), g.func]),
  /** A table can have its rows appear selectable. */
  selectable: g.bool,
  /** A table can specify that its cell contents should remain on a single line and not wrap. */
  singleLine: g.bool,
  /** A table can also be small or large. */
  size: g.oneOf(Rr(Or, "mini", "tiny", "medium", "big", "huge", "massive")),
  /** A table may allow a user to sort contents by clicking on a table header. */
  sortable: g.bool,
  /** A table can specify how it stacks table content responsively. */
  stackable: g.bool,
  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
  striped: g.bool,
  /** A table can be formatted to display complex structured data. */
  structured: g.bool,
  /** Data to be passed to the renderBodyRow function. */
  tableData: qt([Jt(["children"]), oo(["renderBodyRow"]), g.array]),
  /** A table can adjust its text alignment. */
  textAlign: g.oneOf(Rr(Mo, "justified")),
  /** A table can specify how it stacks table content responsively. */
  unstackable: g.bool,
  /** A table can adjust its text alignment. */
  verticalAlign: g.oneOf(_s)
} : {};
Qe.Body = kl;
Qe.Cell = ka;
Qe.Footer = Dl;
Qe.Header = Ns;
Qe.HeaderCell = Iu;
Qe.Row = $i;
var fr = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = e.fluid, o = e.text, s = e.textAlign, l = rt("ui", ue(o, "text"), ue(a, "fluid"), Do(s), "container", r), c = nt(fr, e), d = lt(e);
  return /* @__PURE__ */ R.createElement(d, Pe({}, c, {
    className: l,
    ref: t
  }), vt(n) ? i : n);
});
fr.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"];
fr.displayName = "Container";
fr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Container has no maximum width. */
  fluid: g.bool,
  /** Reduce maximum width to more naturally accommodate text. */
  text: g.bool,
  /** Align container text. */
  textAlign: g.oneOf(Mo)
} : {};
var ku = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.content, o = e.disabled, s = e.indeterminate, l = e.inline, c = e.inverted, d = e.size, p = rt("ui", d, ue(n, "active"), ue(o, "disabled"), ue(s, "indeterminate"), ue(c, "inverted"), ue(r || a, "text"), mn(l, "inline"), "loader", i), y = nt(ku, e), f = lt(e);
  return /* @__PURE__ */ R.createElement(f, Pe({}, y, {
    className: p,
    ref: t
  }), vt(r) ? a : r);
});
ku.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"];
ku.displayName = "Loader";
ku.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A loader can be active or visible. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A loader can be disabled or hidden. */
  disabled: g.bool,
  /** A loader can show it's unsure of how long a task will take. */
  indeterminate: g.bool,
  /** Loaders can appear inline with content. */
  inline: g.oneOfType([g.bool, g.oneOf(["centered"])]),
  /** Loaders can have their colors inverted. */
  inverted: g.bool,
  /** Loaders can have different sizes. */
  size: g.oneOf(Or)
} : {};
var Du = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.compact, a = e.content, o = e.horizontal, s = e.piled, l = e.raised, c = e.size, d = e.stacked, p = rt("ui", c, ue(i, "compact"), ue(o, "horizontal"), ue(s, "piled"), ue(l, "raised"), ue(d, "stacked"), "segments", r), y = nt(Du, e), f = lt(e);
  return /* @__PURE__ */ R.createElement(f, Pe({}, y, {
    className: p,
    ref: t
  }), vt(n) ? a : n);
});
Du.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"];
Du.displayName = "SegmentGroup";
Du.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** A segment may take up only as much space as is necessary. */
  compact: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** Formats content to be aligned horizontally. */
  horizontal: g.bool,
  /** Formatted to look like a pile of pages. */
  piled: g.bool,
  /** A segment group may be formatted to raise above the page. */
  raised: g.bool,
  /** A segment group can have different sizes. */
  size: g.oneOf(Rr(Or, "medium")),
  /** Formatted to show it contains multiple pages. */
  stacked: g.bool
} : {};
var Ru = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("inline", r), o = nt(Ru, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
Ru.handledProps = ["as", "children", "className", "content"];
Ru.displayName = "SegmentInline";
Ru.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
var No = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.attached, r = e.basic, i = e.children, a = e.circular, o = e.className, s = e.clearing, l = e.color, c = e.compact, d = e.content, p = e.disabled, y = e.floated, f = e.inverted, N = e.loading, b = e.placeholder, S = e.padded, _ = e.piled, E = e.raised, k = e.secondary, M = e.size, F = e.stacked, q = e.tertiary, j = e.textAlign, x = e.vertical, C = rt("ui", l, M, ue(r, "basic"), ue(a, "circular"), ue(s, "clearing"), ue(c, "compact"), ue(p, "disabled"), ue(f, "inverted"), ue(N, "loading"), ue(b, "placeholder"), ue(_, "piled"), ue(E, "raised"), ue(k, "secondary"), ue(F, "stacked"), ue(q, "tertiary"), ue(x, "vertical"), mn(n, "attached"), mn(S, "padded"), Do(j), Dr(y, "floated"), "segment", o), D = nt(No, e), P = lt(e);
  return /* @__PURE__ */ R.createElement(P, Pe({}, D, {
    className: C,
    ref: t
  }), vt(i) ? d : i);
});
No.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"];
No.Group = Du;
No.Inline = Ru;
No.displayName = "Segment";
No.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Attach segment to other content, like a header. */
  attached: g.oneOfType([g.bool, g.oneOf(["top", "bottom"])]),
  /** A basic segment has no special formatting. */
  basic: g.bool,
  /** Primary content. */
  children: g.node,
  /** A segment can be circular. */
  circular: g.bool,
  /** Additional classes. */
  className: g.string,
  /** A segment can clear floated content. */
  clearing: g.bool,
  /** Segment can be colored. */
  color: g.oneOf(Fi),
  /** A segment may take up only as much space as is necessary. */
  compact: g.bool,
  /** Shorthand for primary content. */
  content: Lt,
  /** A segment may show its content is disabled. */
  disabled: g.bool,
  /** Segment content can be floated to the left or right. */
  floated: g.oneOf(lu),
  /** A segment can have its colors inverted for contrast. */
  inverted: g.bool,
  /** A segment may show its content is being loaded. */
  loading: g.bool,
  /** A segment can increase its padding. */
  padded: g.oneOfType([g.bool, g.oneOf(["very"])]),
  /** A segment can be used to reserve space for conditionally displayed content. */
  placeholder: g.bool,
  /** Formatted to look like a pile of pages. */
  piled: g.bool,
  /** A segment may be formatted to raise above the page. */
  raised: g.bool,
  /** A segment can be formatted to appear less noticeable. */
  secondary: g.bool,
  /** A segment can have different sizes. */
  size: g.oneOf(Rr(Or, "medium")),
  /** Formatted to show it contains multiple pages. */
  stacked: g.bool,
  /** A segment can be formatted to appear even less noticeable. */
  tertiary: g.bool,
  /** Formats content to be aligned as part of a vertical group. */
  textAlign: g.oneOf(Rr(Mo, "justified")),
  /** Formats content to be aligned vertically. */
  vertical: g.bool
} : {};
var So = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.content, o = e.icon, s = rt(ue(n, "active"), "title", i), l = nt(So, e), c = lt(e), d = Tt(o) ? "dropdown" : o, p = lo(function(y) {
    Ze(e, "onClick", y, e);
  });
  return vt(r) ? /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    className: s,
    onClick: p,
    ref: t
  }), $t.create(d, {
    autoGenerateKey: !1
  }), a) : /* @__PURE__ */ R.createElement(c, Pe({}, l, {
    className: s,
    onClick: p,
    ref: t
  }), r);
});
So.handledProps = ["active", "as", "children", "className", "content", "icon", "index", "onClick"];
So.displayName = "AccordionTitle";
So.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Whether or not the title is in the open state. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** Shorthand for Icon. */
  icon: kt,
  /** AccordionTitle index inside Accordion. */
  index: g.oneOfType([g.string, g.number]),
  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: g.func
} : {};
So.create = Vt(So, function(e) {
  return {
    content: e
  };
});
var Eo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = e.children, i = e.className, a = e.content, o = rt("content", ue(n, "active"), i), s = nt(Eo, e), l = lt(e);
  return /* @__PURE__ */ R.createElement(l, Pe({}, s, {
    className: o,
    ref: t
  }), vt(r) ? a : r);
});
Eo.handledProps = ["active", "as", "children", "className", "content"];
Eo.displayName = "AccordionContent";
Eo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Whether or not the content is visible. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
Eo.create = Vt(Eo, function(e) {
  return {
    content: e
  };
});
var _l = /* @__PURE__ */ function(e) {
  Sg(t, e);
  function t() {
    for (var r, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(a)) || this, r.handleTitleOverrides = function(s) {
      return {
        onClick: function(l, c) {
          Ze(s, "onClick", l, c), Ze(r.props, "onTitleClick", l, c);
        }
      };
    }, r;
  }
  var n = t.prototype;
  return n.render = function() {
    var r = this.props, i = r.active, a = r.content, o = r.index, s = r.title;
    return /* @__PURE__ */ gt.createElement(gt.Fragment, null, So.create(s, {
      autoGenerateKey: !1,
      defaultProps: {
        active: i,
        index: o
      },
      overrideProps: this.handleTitleOverrides
    }), Eo.create(a, {
      autoGenerateKey: !1,
      defaultProps: {
        active: i
      }
    }));
  }, t;
}(h_);
_l.handledProps = ["active", "content", "index", "onTitleClick", "title"];
_l.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Whether or not the title is in the open state. */
  active: g.bool,
  /** A shorthand for Accordion.Content. */
  content: kt,
  /** A panel index. */
  index: g.oneOfType([g.number, g.string]),
  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: g.func,
  /** A shorthand for Accordion.Title. */
  title: kt
} : {};
_l.create = Vt(_l, null);
function YL(e, t, n) {
  return e ? t === n : Ei(t, n);
}
function KL(e, t, n) {
  return e ? n === t ? -1 : n : Ei(t, n) ? Rr(t, n) : [].concat(t, [n]);
}
var Co = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.children, i = e.exclusive, a = i === void 0 ? !0 : i, o = e.panels, s = hs({
    state: e.activeIndex,
    defaultState: e.defaultActiveIndex,
    initialState: function() {
      return a ? -1 : [];
    }
  }), l = s[0], c = s[1], d = rt("accordion", n), p = nt(Co, e), y = lt(e), f = lo(function(N, b) {
    var S = b.index;
    c(KL(a, l, S)), Ze(e, "onTitleClick", N, b);
  });
  return process.env.NODE_ENV !== "production" && R.useEffect(function() {
    a && typeof l != "number" ? console.error("`activeIndex` must be a number if `exclusive` is true") : !a && !Rn(l) && console.error("`activeIndex` must be an array if `exclusive` is false");
  }, [a, l]), /* @__PURE__ */ R.createElement(y, Pe({}, p, {
    className: d,
    ref: t
  }), vt(r) ? Hn(o, function(N, b) {
    return _l.create(N, {
      defaultProps: {
        active: YL(a, l, b),
        index: b,
        onTitleClick: f
      }
    });
  }) : r);
});
Co.handledProps = ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"];
Co.displayName = "AccordionAccordion";
Co.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Index of the currently active panel. */
  activeIndex: qt([Jt(["children"]), g.oneOfType([g.arrayOf(g.number), g.number])]),
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Initial activeIndex value. */
  defaultActiveIndex: qt([Jt(["children"]), g.oneOfType([g.arrayOf(g.number), g.number])]),
  /** Only allow one panel open at a time. */
  exclusive: g.bool,
  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: qt([Jt(["children"]), g.func]),
  /** Shorthand array of props for Accordion. */
  panels: qt([Jt(["children"]), g.arrayOf(g.shape({
    content: kt,
    title: kt
  }))])
} : {};
Co.create = Vt(Co, function(e) {
  return {
    content: e
  };
});
var yr = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.fluid, i = e.inverted, a = e.styled, o = rt("ui", ue(r, "fluid"), ue(i, "inverted"), ue(a, "styled"), n), s = nt(yr, e);
  return /* @__PURE__ */ R.createElement(Co, Pe({}, s, {
    className: o,
    ref: t
  }));
});
yr.handledProps = ["className", "fluid", "inverted", "styled"];
yr.displayName = "Accordion";
yr.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional classes. */
  className: g.string,
  /** Format to take up the width of its container. */
  fluid: g.bool,
  /** Format for dark backgrounds. */
  inverted: g.bool,
  /** Adds some basic styling to accordion panels. */
  styled: g.bool
} : {};
yr.Accordion = Co;
yr.Content = Eo;
yr.Panel = _l;
yr.Title = So;
function XL(e) {
  return ji(e) && e.nodeType === 1 && !Kf(e);
}
var ZL = R.createContext();
R.createContext();
var JL = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, AL = function(e) {
  if (typeof e == "function") {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return e.apply(void 0, n);
  }
}, eT = function(e, t) {
  if (typeof e == "function")
    return AL(e, t);
  e != null && (e.current = t);
}, W5 = function(e) {
  return e.reduce(function(t, n) {
    var r = n[0], i = n[1];
    return t[r] = i, t;
  }, {});
}, H5 = typeof window < "u" && window.document && window.document.createElement ? R.useLayoutEffect : R.useEffect, Xr = "top", Pi = "bottom", Li = "right", Zr = "left", kg = "auto", Mu = [Xr, Pi, Li, Zr], Nl = "start", Jc = "end", tT = "clippingParents", _4 = "viewport", wc = "popper", nT = "reference", $5 = /* @__PURE__ */ Mu.reduce(function(e, t) {
  return e.concat([t + "-" + Nl, t + "-" + Jc]);
}, []), N4 = /* @__PURE__ */ [].concat(Mu, [kg]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Nl, t + "-" + Jc]);
}, []), rT = "beforeRead", iT = "read", aT = "afterRead", oT = "beforeMain", sT = "main", lT = "afterMain", cT = "beforeWrite", uT = "write", dT = "afterWrite", fT = [rT, iT, aT, oT, sT, lT, cT, uT, dT];
function pa(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function si(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function gs(e) {
  var t = si(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ci(e) {
  var t = si(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Dg(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = si(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function pT(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !Ci(a) || !pa(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(o) {
      var s = i[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function hT(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], a = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Ci(i) || !pa(i) || (Object.assign(i.style, s), Object.keys(a).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const mT = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: pT,
  effect: hT,
  requires: ["computeStyles"]
};
function aa(e) {
  return e.split("-")[0];
}
var cs = Math.max, Cf = Math.min, Sl = Math.round;
function Fm() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function S4() {
  return !/^((?!chrome|android).)*safari/i.test(Fm());
}
function El(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, a = 1;
  t && Ci(e) && (i = e.offsetWidth > 0 && Sl(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && Sl(r.height) / e.offsetHeight || 1);
  var o = gs(e) ? si(e) : window, s = o.visualViewport, l = !S4() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / i, d = (r.top + (l && s ? s.offsetTop : 0)) / a, p = r.width / i, y = r.height / a;
  return {
    width: p,
    height: y,
    top: d,
    right: c + p,
    bottom: d + y,
    left: c,
    x: c,
    y: d
  };
}
function Rg(e) {
  var t = El(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function E4(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Dg(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Da(e) {
  return si(e).getComputedStyle(e);
}
function gT(e) {
  return ["table", "td", "th"].indexOf(pa(e)) >= 0;
}
function Uo(e) {
  return ((gs(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Af(e) {
  return pa(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Dg(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Uo(e)
  );
}
function G5(e) {
  return !Ci(e) || // https://github.com/popperjs/popper-core/issues/837
  Da(e).position === "fixed" ? null : e.offsetParent;
}
function yT(e) {
  var t = /firefox/i.test(Fm()), n = /Trident/i.test(Fm());
  if (n && Ci(e)) {
    var r = Da(e);
    if (r.position === "fixed")
      return null;
  }
  var i = Af(e);
  for (Dg(i) && (i = i.host); Ci(i) && ["html", "body"].indexOf(pa(i)) < 0; ) {
    var a = Da(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Uu(e) {
  for (var t = si(e), n = G5(e); n && gT(n) && Da(n).position === "static"; )
    n = G5(n);
  return n && (pa(n) === "html" || pa(n) === "body" && Da(n).position === "static") ? t : n || yT(e) || t;
}
function Mg(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Bc(e, t, n) {
  return cs(e, Cf(t, n));
}
function vT(e, t, n) {
  var r = Bc(e, t, n);
  return r > n ? n : r;
}
function C4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function O4(e) {
  return Object.assign({}, C4(), e);
}
function j4(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var bT = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, O4(typeof e != "number" ? e : j4(e, Mu));
};
function wT(e) {
  var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = aa(n.placement), l = Mg(s), c = [Zr, Li].indexOf(s) >= 0, d = c ? "height" : "width";
  if (!(!a || !o)) {
    var p = bT(i.padding, n), y = Rg(a), f = l === "y" ? Xr : Zr, N = l === "y" ? Pi : Li, b = n.rects.reference[d] + n.rects.reference[l] - o[l] - n.rects.popper[d], S = o[l] - n.rects.reference[l], _ = Uu(a), E = _ ? l === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, k = b / 2 - S / 2, M = p[f], F = E - y[d] - p[N], q = E / 2 - y[d] / 2 + k, j = Bc(M, q, F), x = l;
    n.modifiersData[r] = (t = {}, t[x] = j, t.centerOffset = j - q, t);
  }
}
function xT(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || E4(t.elements.popper, i) && (t.elements.arrow = i));
}
const _T = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wT,
  effect: xT,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Cl(e) {
  return e.split("-")[1];
}
var NT = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ST(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: Sl(n * i) / i || 0,
    y: Sl(r * i) / i || 0
  };
}
function Q5(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, p = e.isFixed, y = o.x, f = y === void 0 ? 0 : y, N = o.y, b = N === void 0 ? 0 : N, S = typeof d == "function" ? d({
    x: f,
    y: b
  }) : {
    x: f,
    y: b
  };
  f = S.x, b = S.y;
  var _ = o.hasOwnProperty("x"), E = o.hasOwnProperty("y"), k = Zr, M = Xr, F = window;
  if (c) {
    var q = Uu(n), j = "clientHeight", x = "clientWidth";
    if (q === si(n) && (q = Uo(n), Da(q).position !== "static" && s === "absolute" && (j = "scrollHeight", x = "scrollWidth")), q = q, i === Xr || (i === Zr || i === Li) && a === Jc) {
      M = Pi;
      var C = p && q === F && F.visualViewport ? F.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        q[j]
      );
      b -= C - r.height, b *= l ? 1 : -1;
    }
    if (i === Zr || (i === Xr || i === Pi) && a === Jc) {
      k = Li;
      var D = p && q === F && F.visualViewport ? F.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        q[x]
      );
      f -= D - r.width, f *= l ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: s
  }, c && NT), L = d === !0 ? ST({
    x: f,
    y: b
  }, si(n)) : {
    x: f,
    y: b
  };
  if (f = L.x, b = L.y, l) {
    var H;
    return Object.assign({}, P, (H = {}, H[M] = E ? "0" : "", H[k] = _ ? "0" : "", H.transform = (F.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + b + "px)" : "translate3d(" + f + "px, " + b + "px, 0)", H));
  }
  return Object.assign({}, P, (t = {}, t[M] = E ? b + "px" : "", t[k] = _ ? f + "px" : "", t.transform = "", t));
}
function ET(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: aa(t.placement),
    variation: Cl(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Q5(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Q5(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const CT = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ET,
  data: {}
};
var Bd = {
  passive: !0
};
function OT(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, o = r.resize, s = o === void 0 ? !0 : o, l = si(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, Bd);
  }), s && l.addEventListener("resize", n.update, Bd), function() {
    a && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Bd);
    }), s && l.removeEventListener("resize", n.update, Bd);
  };
}
const jT = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: OT,
  data: {}
};
var PT = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function sf(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return PT[t];
  });
}
var LT = {
  start: "end",
  end: "start"
};
function Y5(e) {
  return e.replace(/start|end/g, function(t) {
    return LT[t];
  });
}
function Ug(e) {
  var t = si(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Bg(e) {
  return El(Uo(e)).left + Ug(e).scrollLeft;
}
function TT(e, t) {
  var n = si(e), r = Uo(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    var c = S4();
    (c || !c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + Bg(e),
    y: l
  };
}
function FT(e) {
  var t, n = Uo(e), r = Ug(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = cs(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = cs(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + Bg(e), l = -r.scrollTop;
  return Da(i || n).direction === "rtl" && (s += cs(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function zg(e) {
  var t = Da(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function P4(e) {
  return ["html", "body", "#document"].indexOf(pa(e)) >= 0 ? e.ownerDocument.body : Ci(e) && zg(e) ? e : P4(Af(e));
}
function zc(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = P4(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = si(r), o = i ? [a].concat(a.visualViewport || [], zg(r) ? r : []) : r, s = t.concat(o);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(zc(Af(o)))
  );
}
function Im(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function IT(e, t) {
  var n = El(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function K5(e, t, n) {
  return t === _4 ? Im(TT(e, n)) : gs(t) ? IT(t, n) : Im(FT(Uo(e)));
}
function kT(e) {
  var t = zc(Af(e)), n = ["absolute", "fixed"].indexOf(Da(e).position) >= 0, r = n && Ci(e) ? Uu(e) : e;
  return gs(r) ? t.filter(function(i) {
    return gs(i) && E4(i, r) && pa(i) !== "body";
  }) : [];
}
function DT(e, t, n, r) {
  var i = t === "clippingParents" ? kT(e) : [].concat(t), a = [].concat(i, [n]), o = a[0], s = a.reduce(function(l, c) {
    var d = K5(e, c, r);
    return l.top = cs(d.top, l.top), l.right = Cf(d.right, l.right), l.bottom = Cf(d.bottom, l.bottom), l.left = cs(d.left, l.left), l;
  }, K5(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function L4(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? aa(r) : null, a = r ? Cl(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (i) {
    case Xr:
      l = {
        x: o,
        y: t.y - n.height
      };
      break;
    case Pi:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Li:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Zr:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = i ? Mg(i) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (a) {
      case Nl:
        l[c] = l[c] - (t[d] / 2 - n[d] / 2);
        break;
      case Jc:
        l[c] = l[c] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function Ac(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, o = a === void 0 ? e.strategy : a, s = n.boundary, l = s === void 0 ? tT : s, c = n.rootBoundary, d = c === void 0 ? _4 : c, p = n.elementContext, y = p === void 0 ? wc : p, f = n.altBoundary, N = f === void 0 ? !1 : f, b = n.padding, S = b === void 0 ? 0 : b, _ = O4(typeof S != "number" ? S : j4(S, Mu)), E = y === wc ? nT : wc, k = e.rects.popper, M = e.elements[N ? E : y], F = DT(gs(M) ? M : M.contextElement || Uo(e.elements.popper), l, d, o), q = El(e.elements.reference), j = L4({
    reference: q,
    element: k,
    placement: i
  }), x = Im(Object.assign({}, k, j)), C = y === wc ? x : q, D = {
    top: F.top - C.top + _.top,
    bottom: C.bottom - F.bottom + _.bottom,
    left: F.left - C.left + _.left,
    right: C.right - F.right + _.right
  }, P = e.modifiersData.offset;
  if (y === wc && P) {
    var L = P[i];
    Object.keys(D).forEach(function(H) {
      var $ = [Li, Pi].indexOf(H) >= 0 ? 1 : -1, ae = [Xr, Pi].indexOf(H) >= 0 ? "y" : "x";
      D[H] += L[ae] * $;
    });
  }
  return D;
}
function RT(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? N4 : l, d = Cl(r), p = d ? s ? $5 : $5.filter(function(N) {
    return Cl(N) === d;
  }) : Mu, y = p.filter(function(N) {
    return c.indexOf(N) >= 0;
  });
  y.length === 0 && (y = p);
  var f = y.reduce(function(N, b) {
    return N[b] = Ac(e, {
      placement: b,
      boundary: i,
      rootBoundary: a,
      padding: o
    })[aa(b)], N;
  }, {});
  return Object.keys(f).sort(function(N, b) {
    return f[N] - f[b];
  });
}
function MT(e) {
  if (aa(e) === kg)
    return [];
  var t = sf(e);
  return [Y5(e), t, Y5(t)];
}
function UT(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, d = n.boundary, p = n.rootBoundary, y = n.altBoundary, f = n.flipVariations, N = f === void 0 ? !0 : f, b = n.allowedAutoPlacements, S = t.options.placement, _ = aa(S), E = _ === S, k = l || (E || !N ? [sf(S)] : MT(S)), M = [S].concat(k).reduce(function(G, K) {
      return G.concat(aa(K) === kg ? RT(t, {
        placement: K,
        boundary: d,
        rootBoundary: p,
        padding: c,
        flipVariations: N,
        allowedAutoPlacements: b
      }) : K);
    }, []), F = t.rects.reference, q = t.rects.popper, j = /* @__PURE__ */ new Map(), x = !0, C = M[0], D = 0; D < M.length; D++) {
      var P = M[D], L = aa(P), H = Cl(P) === Nl, $ = [Xr, Pi].indexOf(L) >= 0, ae = $ ? "width" : "height", ce = Ac(t, {
        placement: P,
        boundary: d,
        rootBoundary: p,
        altBoundary: y,
        padding: c
      }), le = $ ? H ? Li : Zr : H ? Pi : Xr;
      F[ae] > q[ae] && (le = sf(le));
      var oe = sf(le), se = [];
      if (a && se.push(ce[L] <= 0), s && se.push(ce[le] <= 0, ce[oe] <= 0), se.every(function(G) {
        return G;
      })) {
        C = P, x = !1;
        break;
      }
      j.set(P, se);
    }
    if (x)
      for (var J = N ? 3 : 1, re = function(G) {
        var K = M.find(function(A) {
          var ee = j.get(A);
          if (ee)
            return ee.slice(0, G).every(function(te) {
              return te;
            });
        });
        if (K)
          return C = K, "break";
      }, I = J; I > 0; I--) {
        var U = re(I);
        if (U === "break") break;
      }
    t.placement !== C && (t.modifiersData[r]._skip = !0, t.placement = C, t.reset = !0);
  }
}
const BT = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: UT,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function X5(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Z5(e) {
  return [Xr, Li, Pi, Zr].some(function(t) {
    return e[t] >= 0;
  });
}
function zT(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, o = Ac(t, {
    elementContext: "reference"
  }), s = Ac(t, {
    altBoundary: !0
  }), l = X5(o, r), c = X5(s, i, a), d = Z5(l), p = Z5(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const qT = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: zT
};
function VT(e, t, n) {
  var r = aa(e), i = [Zr, Xr].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * i, [Zr, Li].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function WT(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = N4.reduce(function(d, p) {
    return d[p] = VT(p, t.rects, a), d;
  }, {}), s = o[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = o;
}
const HT = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: WT
};
function $T(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = L4({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const GT = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: $T,
  data: {}
};
function QT(e) {
  return e === "x" ? "y" : "x";
}
function YT(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, d = n.altBoundary, p = n.padding, y = n.tether, f = y === void 0 ? !0 : y, N = n.tetherOffset, b = N === void 0 ? 0 : N, S = Ac(t, {
    boundary: l,
    rootBoundary: c,
    padding: p,
    altBoundary: d
  }), _ = aa(t.placement), E = Cl(t.placement), k = !E, M = Mg(_), F = QT(M), q = t.modifiersData.popperOffsets, j = t.rects.reference, x = t.rects.popper, C = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, D = typeof C == "number" ? {
    mainAxis: C,
    altAxis: C
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, C), P = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (q) {
    if (a) {
      var H, $ = M === "y" ? Xr : Zr, ae = M === "y" ? Pi : Li, ce = M === "y" ? "height" : "width", le = q[M], oe = le + S[$], se = le - S[ae], J = f ? -x[ce] / 2 : 0, re = E === Nl ? j[ce] : x[ce], I = E === Nl ? -x[ce] : -j[ce], U = t.elements.arrow, G = f && U ? Rg(U) : {
        width: 0,
        height: 0
      }, K = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : C4(), A = K[$], ee = K[ae], te = Bc(0, j[ce], G[ce]), ne = k ? j[ce] / 2 - J - te - A - D.mainAxis : re - te - A - D.mainAxis, ve = k ? -j[ce] / 2 + J + te + ee + D.mainAxis : I + te + ee + D.mainAxis, _e = t.elements.arrow && Uu(t.elements.arrow), pe = _e ? M === "y" ? _e.clientTop || 0 : _e.clientLeft || 0 : 0, je = (H = P == null ? void 0 : P[M]) != null ? H : 0, Se = le + ne - je - pe, be = le + ve - je, X = Bc(f ? Cf(oe, Se) : oe, le, f ? cs(se, be) : se);
      q[M] = X, L[M] = X - le;
    }
    if (s) {
      var Ye, Re = M === "x" ? Xr : Zr, Te = M === "x" ? Pi : Li, Ue = q[F], T = F === "y" ? "height" : "width", fe = Ue + S[Re], xe = Ue - S[Te], Fe = [Xr, Zr].indexOf(_) !== -1, Ge = (Ye = P == null ? void 0 : P[F]) != null ? Ye : 0, Me = Fe ? fe : Ue - j[T] - x[T] - Ge + D.altAxis, Ie = Fe ? Ue + j[T] + x[T] - Ge - D.altAxis : xe, ct = f && Fe ? vT(Me, Ue, Ie) : Bc(f ? Me : fe, Ue, f ? Ie : xe);
      q[F] = ct, L[F] = ct - Ue;
    }
    t.modifiersData[r] = L;
  }
}
const KT = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: YT,
  requiresIfExists: ["offset"]
};
function XT(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ZT(e) {
  return e === si(e) || !Ci(e) ? Ug(e) : XT(e);
}
function JT(e) {
  var t = e.getBoundingClientRect(), n = Sl(t.width) / e.offsetWidth || 1, r = Sl(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function AT(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ci(t), i = Ci(t) && JT(t), a = Uo(t), o = El(e, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((pa(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  zg(a)) && (s = ZT(t)), Ci(t) ? (l = El(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = Bg(a))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function eF(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && i(l);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function tF(e) {
  var t = eF(e);
  return fT.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function nF(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function rF(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var J5 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function A5() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function iF(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? J5 : i;
  return function(o, s, l) {
    l === void 0 && (l = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, J5, a),
      modifiersData: {},
      elements: {
        reference: o,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, y = {
      state: c,
      setOptions: function(b) {
        var S = typeof b == "function" ? b(c.options) : b;
        N(), c.options = Object.assign({}, a, c.options, S), c.scrollParents = {
          reference: gs(o) ? zc(o) : o.contextElement ? zc(o.contextElement) : [],
          popper: zc(s)
        };
        var _ = tF(rF([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = _.filter(function(E) {
          return E.enabled;
        }), f(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var b = c.elements, S = b.reference, _ = b.popper;
          if (A5(S, _)) {
            c.rects = {
              reference: AT(S, Uu(_), c.options.strategy === "fixed"),
              popper: Rg(_)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(x) {
              return c.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var E = 0; E < c.orderedModifiers.length; E++) {
              if (c.reset === !0) {
                c.reset = !1, E = -1;
                continue;
              }
              var k = c.orderedModifiers[E], M = k.fn, F = k.options, q = F === void 0 ? {} : F, j = k.name;
              typeof M == "function" && (c = M({
                state: c,
                options: q,
                name: j,
                instance: y
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: nF(function() {
        return new Promise(function(b) {
          y.forceUpdate(), b(c);
        });
      }),
      destroy: function() {
        N(), p = !0;
      }
    };
    if (!A5(o, s))
      return y;
    y.setOptions(l).then(function(b) {
      !p && l.onFirstUpdate && l.onFirstUpdate(b);
    });
    function f() {
      c.orderedModifiers.forEach(function(b) {
        var S = b.name, _ = b.options, E = _ === void 0 ? {} : _, k = b.effect;
        if (typeof k == "function") {
          var M = k({
            state: c,
            name: S,
            instance: y,
            options: E
          }), F = function() {
          };
          d.push(M || F);
        }
      });
    }
    function N() {
      d.forEach(function(b) {
        return b();
      }), d = [];
    }
    return y;
  };
}
var aF = [jT, GT, CT, mT, HT, BT, KT, _T, qT], oF = /* @__PURE__ */ iF({
  defaultModifiers: aF
}), sF = typeof Element < "u", lF = typeof Map == "function", cF = typeof Set == "function", uF = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function lf(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!lf(e[r], t[r])) return !1;
      return !0;
    }
    var a;
    if (lF && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0])) return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!lf(r.value[1], t.get(r.value[0]))) return !1;
      return !0;
    }
    if (cF && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0])) return !1;
      return !0;
    }
    if (uF && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r])) return !1;
    if (sF && e instanceof Element) return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && e.$$typeof) && !lf(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var dF = function(e, t) {
  try {
    return lf(e, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const fF = /* @__PURE__ */ ha(dF);
var pF = [], hF = function(e, t, n) {
  n === void 0 && (n = {});
  var r = R.useRef(null), i = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || pF
  }, a = R.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), o = a[0], s = a[1], l = R.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(p) {
        var y = p.state, f = Object.keys(y.elements);
        v_.flushSync(function() {
          s({
            styles: W5(f.map(function(N) {
              return [N, y.styles[N] || {}];
            })),
            attributes: W5(f.map(function(N) {
              return [N, y.attributes[N]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = R.useMemo(function() {
    var p = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [l, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return fF(r.current, p) ? r.current || p : (r.current = p, p);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, l]), d = R.useRef();
  return H5(function() {
    d.current && d.current.setOptions(c);
  }, [c]), H5(function() {
    if (!(e == null || t == null)) {
      var p = n.createPopper || oF, y = p(e, t, c);
      return d.current = y, function() {
        y.destroy(), d.current = null;
      };
    }
  }, [e, t, n.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: o.styles,
    attributes: o.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
}, mF = function() {
}, gF = function() {
  return Promise.resolve(null);
}, yF = [];
function vF(e) {
  var t = e.placement, n = t === void 0 ? "bottom" : t, r = e.strategy, i = r === void 0 ? "absolute" : r, a = e.modifiers, o = a === void 0 ? yF : a, s = e.referenceElement, l = e.onFirstUpdate, c = e.innerRef, d = e.children, p = R.useContext(ZL), y = R.useState(null), f = y[0], N = y[1], b = R.useState(null), S = b[0], _ = b[1];
  R.useEffect(function() {
    eT(c, f);
  }, [c, f]);
  var E = R.useMemo(function() {
    return {
      placement: n,
      strategy: i,
      onFirstUpdate: l,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: S != null,
        options: {
          element: S
        }
      }])
    };
  }, [n, i, l, o, S]), k = hF(s || p, f, E), M = k.state, F = k.styles, q = k.forceUpdate, j = k.update, x = R.useMemo(function() {
    return {
      ref: N,
      style: F.popper,
      placement: M ? M.placement : n,
      hasPopperEscaped: M && M.modifiersData.hide ? M.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: M && M.modifiersData.hide ? M.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: F.arrow,
        ref: _
      },
      forceUpdate: q || mF,
      update: j || gF
    };
  }, [N, _, n, M, F, j, q]);
  return JL(d)(x);
}
function bF(e, t, n, r) {
  return xb(e, function(i, a, o) {
    t(r, n(i), a, o);
  }), r;
}
function wF(e, t) {
  return function(n, r) {
    return bF(n, e, t(r), {});
  };
}
var xF = Object.prototype, _F = xF.toString, NF = wF(function(e, t, n) {
  t != null && typeof t.toString != "function" && (t = _F.call(t)), e[t] = n;
}, db(Io)), qg = {
  "top center": "top",
  "top left": "top-start",
  "top right": "top-end",
  "bottom center": "bottom",
  "bottom left": "bottom-start",
  "bottom right": "bottom-end",
  "right center": "right",
  "left center": "left"
}, SF = Si(qg), EF = NF(qg);
function Yt(e) {
  "@babel/helpers - typeof";
  return Yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yt(e);
}
function CF(e, t) {
  if (Yt(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Yt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function OF(e) {
  var t = CF(e, "string");
  return Yt(t) == "symbol" ? t : t + "";
}
function jF(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OF(r.key), r);
  }
}
function PF(e, t, n) {
  return jF(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var LF = /* @__PURE__ */ function() {
  function e(n) {
    this.ref = n;
  }
  var t = e.prototype;
  return t.getBoundingClientRect = function() {
    return Ze(this.ref.current, "getBoundingClientRect") || {};
  }, PF(e, [{
    key: "clientWidth",
    get: function() {
      return this.getBoundingClientRect().width;
    }
  }, {
    key: "clientHeight",
    get: function() {
      return this.getBoundingClientRect().height;
    }
  }, {
    key: "parentNode",
    get: function() {
      return this.ref.current ? this.ref.current.parentNode : void 0;
    }
  }, {
    key: "contextElement",
    get: function() {
      return this.ref.current;
    }
  }]), e;
}(), TF = iu(function(e) {
  return new LF(jm(e) ? e : {
    current: e
  });
}), Oo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("content", r), o = nt(Oo, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
Oo.handledProps = ["as", "children", "className", "content"];
Oo.displayName = "PopupContent";
Oo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** The content of the Popup */
  children: g.node,
  /** Classes to add to the Popup content className. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
Oo.create = Vt(Oo, function(e) {
  return {
    children: e
  };
});
var jo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = e.content, a = rt("header", r), o = nt(jo, e), s = lt(e);
  return /* @__PURE__ */ R.createElement(s, Pe({}, o, {
    className: a,
    ref: t
  }), vt(n) ? i : n);
});
jo.handledProps = ["as", "children", "className", "content"];
jo.displayName = "PopupHeader";
jo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt
} : {};
jo.create = Vt(jo, function(e) {
  return {
    children: e
  };
});
function FF(e) {
  var t, n = {}, r = (t = e.on) != null ? t : ["click", "hover"], i = Rn(r) ? r : [r];
  return e.hoverable && (n.closeOnPortalMouseLeave = !0, n.mouseLeaveDelay = 300), Ei(i, "hover") && (n.openOnTriggerClick = !1, n.closeOnTriggerClick = !1, n.openOnTriggerMouseEnter = !0, n.closeOnTriggerMouseLeave = !0, n.mouseLeaveDelay = 70, n.mouseEnterDelay = 50), Ei(i, "click") && (n.openOnTriggerClick = !0, n.closeOnTriggerClick = !0, n.closeOnDocumentClick = !0), Ei(i, "focus") && (n.openOnTriggerFocus = !0, n.closeOnTriggerBlur = !0), n;
}
function IF(e, t, n) {
  if (t || n)
    return {};
  var r = Ig(e, function(a, o, s) {
    return Ei(ca.handledProps, s) || (a[s] = o), a;
  }, {}), i = Yf(e, ca.handledProps);
  return {
    contentRestProps: r,
    portalRestProps: i
  };
}
function kF(e, t) {
  var n = vP(e);
  xl(function() {
    t.current && t.current();
  }, [Uc(n, e)]);
}
var Gi = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.basic, r = e.className, i = e.content, a = e.context, o = e.children, s = e.disabled, l = s === void 0 ? !1 : s, c = e.eventsEnabled, d = c === void 0 ? !0 : c, p = e.flowing, y = e.header, f = e.inverted, N = e.offset, b = e.pinned, S = b === void 0 ? !1 : b, _ = e.popper, E = e.popperDependencies, k = e.popperModifiers, M = k === void 0 ? [] : k, F = e.position, q = F === void 0 ? "top left" : F, j = e.positionFixed, x = e.size, C = e.style, D = e.trigger, P = e.wide, L = R.useState(!1), H = L[0], $ = L[1], ae = nt(Gi, e), ce = IF(ae, H, l), le = ce.contentRestProps, oe = ce.portalRestProps, se = qa(t), J = R.useRef(), re = R.useRef(), I = R.useRef(), U = R.useRef(!1);
  kF(E, J), R.useEffect(function() {
    return function() {
      clearTimeout(re.current);
    };
  }, []);
  var G = function(je) {
    Ze(e, "onClose", je, Pe({}, e, {
      open: !1
    }));
  }, K = function(je) {
    Ze(e, "onOpen", je, Pe({}, e, {
      open: !0
    }));
  }, A = function(je) {
    XL(je.target) && se.current.contains(je.target) || ($(!0), re.current = setTimeout(function() {
      $(!1);
    }, 50), G(je));
  }, ee = function(je) {
    Ze(e, "onMount", je, e);
  }, te = function(je) {
    J.current = null, Ze(e, "onUnmount", je, e);
  }, ne = function(je) {
    var Se = je.placement, be = je.ref, X = je.update, Ye = je.style;
    J.current = X;
    var Re = rt("ui", EF[Se], x, mn(P, "wide"), ue(n, "basic"), ue(p, "flowing"), ue(f, "inverted"), "popup transition visible", r), Te = lt(e), Ue = Pe({
      // Heads up! We need default styles to get working correctly `flowing`
      left: "auto",
      right: "auto",
      // This is required to be properly positioned inside wrapping `div`
      position: "initial"
    }, C), T = /* @__PURE__ */ R.createElement(Te, Pe({}, le, {
      className: Re,
      style: Ue,
      ref: se
    }), vt(o) ? /* @__PURE__ */ R.createElement(R.Fragment, null, jo.create(y, {
      autoGenerateKey: !1
    }), Oo.create(i, {
      autoGenerateKey: !1
    })) : o, /* @__PURE__ */ R.createElement(ja, {
      on: A,
      name: "scroll",
      target: "window"
    }));
    return gj(_ || {}, {
      overrideProps: {
        children: T,
        ref: be,
        style: Pe({
          // Fixes layout for floated elements
          // https://github.com/Semantic-Org/Semantic-UI-React/issues/4092
          display: "flex"
        }, Ye)
      }
    });
  };
  if (ne.handledProps = [], H || l)
    return D;
  var ve = [{
    name: "arrow",
    enabled: !1
  }, {
    name: "eventListeners",
    options: {
      scroll: !!d,
      resize: !!d
    }
  }, {
    name: "flip",
    enabled: !S
  }, {
    name: "preventOverflow",
    enabled: !!N
  }, {
    name: "offset",
    enabled: !!N,
    options: {
      offset: N
    }
  }].concat(M, [
    // We are syncing zIndex from `.ui.popup.content` to avoid layering issues as in SUIR we are using an additional
    // `div` for Popper.js
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/4083
    {
      name: "syncZIndex",
      enabled: !0,
      phase: "beforeRead",
      fn: function(je) {
        var Se, be = je.state;
        if (!U.current) {
          var X = _ == null || (Se = _.style) == null ? void 0 : Se.zIndex;
          pl(X) && (be.elements.popper.style.zIndex = window.getComputedStyle(be.elements.popper.firstChild).zIndex), U.current = !0;
        }
      },
      effect: function() {
        return function() {
          U.current = !1;
        };
      }
    }
  ]), _e = TF(Tt(a) ? I : a), pe = Pe({}, FF(e), oe);
  return /* @__PURE__ */ R.createElement(ca, Pe({}, pe, {
    onClose: G,
    onMount: ee,
    onOpen: K,
    onUnmount: te,
    trigger: D,
    triggerRef: I
  }), /* @__PURE__ */ R.createElement(vF, {
    modifiers: ve,
    placement: qg[q],
    strategy: j ? "fixed" : null,
    referenceElement: _e
  }, ne));
});
Gi.handledProps = ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popper", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"];
Gi.displayName = "Popup";
Gi.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** Display the popup without the pointing arrow. */
  basic: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Simple text content for the popover. */
  content: kt,
  /** Existing element the pop-up should be bound to. */
  context: g.oneOfType([g.object, Hb]),
  /** A disabled popup only renders its trigger. */
  disabled: g.bool,
  /** Enables the Popper.js event listeners. */
  eventsEnabled: g.bool,
  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
  flowing: g.bool,
  /** Takes up the entire width of its offset container. */
  // TODO: implement the Popup fluid layout
  // fluid: PropTypes.bool,
  /** Header displayed above the content in bold. */
  header: kt,
  /** Hide the Popup when scrolling the window. */
  hideOnScroll: g.bool,
  /** Whether the popup should not close on hover. */
  hoverable: g.bool,
  /** Invert the colors of the Popup. */
  inverted: g.bool,
  /**
   * Offset values in px unit to apply to rendered popup. The basic offset accepts an
   * array with two numbers in the form [skidding, distance]:
   * - `skidding` displaces the Popup along the reference element
   * - `distance` displaces the Popup away from, or toward, the reference element in the direction of its placement. A positive number displaces it further away, while a negative number lets it overlap the reference.
   *
   * @see https://popper.js.org/docs/v2/modifiers/offset/
   */
  offset: g.oneOfType([g.func, g.arrayOf(g.number)]),
  /** Events triggering the popup. */
  on: g.oneOfType([g.oneOf(["hover", "click", "focus"]), g.arrayOf(g.oneOf(["hover", "click", "focus"]))]),
  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: g.func,
  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: g.func,
  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: g.func,
  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: g.func,
  /** Disables automatic repositioning of the component, it will always be placed according to the position value. */
  pinned: g.bool,
  /** Position for the popover. */
  position: g.oneOf(SF),
  /** Tells `Popper.js` to use the `position: fixed` strategy to position the popover. */
  positionFixed: g.bool,
  /** A wrapping element for an actual content that will be used for positioning. */
  popper: kt,
  /** An array containing custom settings for the Popper.js modifiers. */
  popperModifiers: g.array,
  /** A popup can have dependencies which update will schedule a position update. */
  popperDependencies: g.array,
  /** Popup size. */
  size: g.oneOf(Rr(Or, "medium", "big", "massive")),
  /** Custom Popup style. */
  style: g.object,
  /** Element to be rendered in-place where the popup is defined. */
  trigger: g.node,
  /** Popup width. */
  wide: g.oneOfType([g.bool, g.oneOf(["very"])])
} : {};
Gi.Content = Oo;
Gi.Header = jo;
var Po = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.active, r = n === void 0 ? !0 : n, i = e.children, a = e.className, o = e.content, s = e.loading, l = rt(ue(r, "active"), ue(s, "loading"), "tab", a), c = nt(Po, e), d = lt(e, {
    defaultAs: No
  }), p = {};
  return d === No && (p.attached = "bottom"), /* @__PURE__ */ R.createElement(d, Pe({}, p, c, {
    className: l,
    ref: t
  }), vt(i) ? o : i);
});
Po.handledProps = ["active", "as", "children", "className", "content", "loading"];
Po.displayName = "TabPane";
Po.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** A tab pane can be active. */
  active: g.bool,
  /** Primary content. */
  children: g.node,
  /** Additional classes. */
  className: g.string,
  /** Shorthand for primary content. */
  content: Lt,
  /** A Tab.Pane can display a loading indicator. */
  loading: g.bool
} : {};
Po.create = Vt(Po, function(e) {
  return {
    content: e
  };
});
var DF = ["paneWidth", "tabWidth"], Bo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.grid, r = n === void 0 ? {
    paneWidth: 12,
    tabWidth: 4
  } : n, i = e.menu, a = i === void 0 ? {
    attached: !0,
    tabular: !0
  } : i, o = e.menuPosition, s = e.panes, l = e.renderActiveOnly, c = l === void 0 ? !0 : l, d = hs({
    state: e.activeIndex,
    defaultState: e.defaultActiveIndex,
    initialState: 0
  }), p = d[0], y = d[1], f = function(M, F) {
    var q = F.index;
    Ze(e, "onTabChange", M, Pe({}, e, {
      activeIndex: q
    })), y(q);
  }, N = function() {
    return c ? Ze(Hi(s, "[" + p + "]"), "render", e) : Hn(s, function(M, F) {
      var q = M.pane;
      return Po.create(q, {
        overrideProps: {
          active: F === p
        }
      });
    });
  }, b = function() {
    return a.tabular === !0 && o === "right" && (a.tabular = "right"), da.create(a, {
      autoGenerateKey: !1,
      overrideProps: {
        items: Hn(s, "menuItem"),
        onItemClick: f,
        activeIndex: p
      }
    });
  }, S = function(M) {
    var F = r.paneWidth, q = r.tabWidth, j = p4(r, DF), x = o || M.props.tabular === "right" && "right" || "left";
    return /* @__PURE__ */ R.createElement(We, j, x === "left" && ia.create({
      width: q,
      children: M
    }, {
      autoGenerateKey: !1
    }), ia.create({
      width: F,
      children: N(),
      stretched: !0
    }, {
      autoGenerateKey: !1
    }), x === "right" && ia.create({
      width: q,
      children: M
    }, {
      autoGenerateKey: !1
    }));
  };
  S.handledProps = [];
  var _ = b(), E = nt(Bo, e), k = lt(e);
  return _.props.vertical ? /* @__PURE__ */ R.createElement(k, Pe({}, E, {
    ref: t
  }), S(_)) : /* @__PURE__ */ R.createElement(k, Pe({}, E, {
    ref: t
  }), _.props.attached !== "bottom" && _, N(), _.props.attached === "bottom" && _);
});
Bo.handledProps = ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"];
Bo.displayName = "Tab";
Bo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An element type to render as (string or function). */
  as: g.elementType,
  /** The initial activeIndex. */
  defaultActiveIndex: g.oneOfType([g.number, g.string]),
  /** Index of the currently active tab. */
  activeIndex: g.oneOfType([g.number, g.string]),
  /**
   * Shorthand props for the Menu.
   * tabular, if true, will derive final value from `menuPosition`, otherwise set 'left' or 'right' explicitly.
   */
  menu: g.object,
  /** Align vertical menu */
  menuPosition: g.oneOf(["left", "right"]),
  /** Shorthand props for the Grid. Only applicable to vertical menus. */
  grid: g.object,
  /**
   * Called on tab change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed new activeIndex.
   * @param {object} data.activeIndex - The new proposed activeIndex.
   */
  onTabChange: g.func,
  /**
   * Array of objects describing each Menu.Item and Tab.Pane:
   * { menuItem: 'Home', render: () => <Tab.Pane /> }
   * or
   * { menuItem: 'Home', pane: 'Welcome' }
   */
  panes: g.arrayOf(g.shape({
    menuItem: kt,
    pane: kt,
    render: g.func
  })),
  /** A Tab can render only active pane. */
  renderActiveOnly: g.bool
} : {};
Bo.Pane = Po;
const ga = () => /* @__PURE__ */ m.jsx("div", { className: "loading-indicator", children: /* @__PURE__ */ m.jsx(ku, { active: !0, inline: "centered" }) });
var km = { exports: {} }, Ph = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ey;
function RF() {
  if (ey) return Ph;
  ey = 1;
  var e = gt;
  function t(l, c) {
    return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, o = e.useMemo, s = e.useDebugValue;
  return Ph.useSyncExternalStoreWithSelector = function(l, c, d, p, y) {
    var f = i(null);
    if (f.current === null) {
      var N = { hasValue: !1, value: null };
      f.current = N;
    } else N = f.current;
    f = o(
      function() {
        function S(F) {
          if (!_) {
            if (_ = !0, E = F, F = p(F), y !== void 0 && N.hasValue) {
              var q = N.value;
              if (y(q, F))
                return k = q;
            }
            return k = F;
          }
          if (q = k, n(E, F)) return q;
          var j = p(F);
          return y !== void 0 && y(q, j) ? (E = F, q) : (E = F, k = j);
        }
        var _ = !1, E, k, M = d === void 0 ? null : d;
        return [
          function() {
            return S(c());
          },
          M === null ? void 0 : function() {
            return S(M());
          }
        ];
      },
      [c, d, p, y]
    );
    var b = r(l, f[0], f[1]);
    return a(
      function() {
        N.hasValue = !0, N.value = b;
      },
      [b]
    ), s(b), b;
  }, Ph;
}
var ty = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ny;
function MF() {
  return ny || (ny = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, c) {
      return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = gt, n = typeof Object.is == "function" ? Object.is : e, r = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, o = t.useMemo, s = t.useDebugValue;
    ty.useSyncExternalStoreWithSelector = function(l, c, d, p, y) {
      var f = i(null);
      if (f.current === null) {
        var N = { hasValue: !1, value: null };
        f.current = N;
      } else N = f.current;
      f = o(
        function() {
          function S(F) {
            if (!_) {
              if (_ = !0, E = F, F = p(F), y !== void 0 && N.hasValue) {
                var q = N.value;
                if (y(q, F))
                  return k = q;
              }
              return k = F;
            }
            if (q = k, n(E, F))
              return q;
            var j = p(F);
            return y !== void 0 && y(q, j) ? (E = F, q) : (E = F, k = j);
          }
          var _ = !1, E, k, M = d === void 0 ? null : d;
          return [
            function() {
              return S(c());
            },
            M === null ? void 0 : function() {
              return S(M());
            }
          ];
        },
        [c, d, p, y]
      );
      var b = r(l, f[0], f[1]);
      return a(
        function() {
          N.hasValue = !0, N.value = b;
        },
        [b]
      ), s(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ty;
}
process.env.NODE_ENV === "production" ? km.exports = RF() : km.exports = MF();
var UF = km.exports, T4 = /* @__PURE__ */ R.version.startsWith("19"), BF = /* @__PURE__ */ Symbol.for(
  T4 ? "react.transitional.element" : "react.element"
), zF = /* @__PURE__ */ Symbol.for("react.portal"), F4 = /* @__PURE__ */ Symbol.for("react.fragment"), I4 = /* @__PURE__ */ Symbol.for("react.strict_mode"), k4 = /* @__PURE__ */ Symbol.for("react.profiler"), Vg = /* @__PURE__ */ Symbol.for("react.consumer"), Wg = /* @__PURE__ */ Symbol.for("react.context"), Hg = /* @__PURE__ */ Symbol.for("react.forward_ref"), D4 = /* @__PURE__ */ Symbol.for("react.suspense"), R4 = /* @__PURE__ */ Symbol.for(
  "react.suspense_list"
), ep = /* @__PURE__ */ Symbol.for("react.memo"), M4 = /* @__PURE__ */ Symbol.for("react.lazy"), qF = /* @__PURE__ */ Symbol.for("react.offscreen"), VF = /* @__PURE__ */ Symbol.for(
  "react.client.reference"
), WF = Hg, HF = ep;
function $F(e) {
  return typeof e == "string" || typeof e == "function" || e === F4 || e === k4 || e === I4 || e === D4 || e === R4 || e === qF || typeof e == "object" && e !== null && (e.$$typeof === M4 || e.$$typeof === ep || e.$$typeof === Wg || e.$$typeof === Vg || e.$$typeof === Hg || e.$$typeof === VF || e.getModuleId !== void 0);
}
function Dm(e) {
  if (typeof e == "object" && e !== null) {
    const { $$typeof: t } = e;
    switch (t) {
      case BF:
        switch (e = e.type, e) {
          case F4:
          case k4:
          case I4:
          case D4:
          case R4:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Wg:
              case Hg:
              case M4:
              case ep:
                return e;
              case Vg:
                return e;
              default:
                return t;
            }
        }
      case zF:
        return t;
    }
  }
}
function GF(e) {
  return T4 ? Dm(e) === Vg : Dm(e) === Wg;
}
function QF(e) {
  return Dm(e) === ep;
}
function $g(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Lh(e, t) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || $g(
      `The selector for ${t} of connect did not specify a value for dependsOnOwnProps.`
    ));
  else throw new Error(`Unexpected value for ${t} in connect.`);
}
function YF(e, t, n) {
  Lh(e, "mapStateToProps"), Lh(t, "mapDispatchToProps"), Lh(n, "mergeProps");
}
function KF(e, t, n, r, {
  areStatesEqual: i,
  areOwnPropsEqual: a,
  areStatePropsEqual: o
}) {
  let s = !1, l, c, d, p, y;
  function f(E, k) {
    return l = E, c = k, d = e(l, c), p = t(r, c), y = n(d, p, c), s = !0, y;
  }
  function N() {
    return d = e(l, c), t.dependsOnOwnProps && (p = t(r, c)), y = n(d, p, c), y;
  }
  function b() {
    return e.dependsOnOwnProps && (d = e(l, c)), t.dependsOnOwnProps && (p = t(r, c)), y = n(d, p, c), y;
  }
  function S() {
    const E = e(l, c), k = !o(E, d);
    return d = E, k && (y = n(d, p, c)), y;
  }
  function _(E, k) {
    const M = !a(k, c), F = !i(
      E,
      l,
      k,
      c
    );
    return l = E, c = k, M && F ? N() : M ? b() : F ? S() : y;
  }
  return function(E, k) {
    return s ? _(E, k) : f(E, k);
  };
}
function XF(e, {
  initMapStateToProps: t,
  initMapDispatchToProps: n,
  initMergeProps: r,
  ...i
}) {
  const a = t(e, i), o = n(e, i), s = r(e, i);
  return process.env.NODE_ENV !== "production" && YF(a, o, s), KF(a, o, s, e, i);
}
function ZF(e, t) {
  const n = {};
  for (const r in e) {
    const i = e[r];
    typeof i == "function" && (n[r] = (...a) => t(i(...a)));
  }
  return n;
}
function JF(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null) return !0;
  let n = t;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function U4(e, t, n) {
  JF(e) || $g(
    `${n}() in ${t} must return a plain object. Instead received ${e}.`
  );
}
function Rm(e) {
  return function(t) {
    const n = e(t);
    function r() {
      return n;
    }
    return r.dependsOnOwnProps = !1, r;
  };
}
function ry(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function B4(e, t) {
  return function(n, { displayName: r }) {
    const i = function(a, o) {
      return i.dependsOnOwnProps ? i.mapToProps(a, o) : i.mapToProps(a, void 0);
    };
    return i.dependsOnOwnProps = !0, i.mapToProps = function(a, o) {
      i.mapToProps = e, i.dependsOnOwnProps = ry(e);
      let s = i(a, o);
      return typeof s == "function" && (i.mapToProps = s, i.dependsOnOwnProps = ry(s), s = i(a, o)), process.env.NODE_ENV !== "production" && U4(s, r, t), s;
    }, i;
  };
}
function Gg(e, t) {
  return (n, r) => {
    throw new Error(
      `Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`
    );
  };
}
function AF(e) {
  return e && typeof e == "object" ? Rm(
    (t) => (
      // @ts-ignore
      ZF(e, t)
    )
  ) : e ? typeof e == "function" ? (
    // @ts-ignore
    B4(e, "mapDispatchToProps")
  ) : Gg(e, "mapDispatchToProps") : Rm((t) => ({
    dispatch: t
  }));
}
function eI(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    B4(e, "mapStateToProps")
  ) : Gg(e, "mapStateToProps") : Rm(() => ({}));
}
function tI(e, t, n) {
  return { ...n, ...e, ...t };
}
function nI(e) {
  return function(t, { displayName: n, areMergedPropsEqual: r }) {
    let i = !1, a;
    return function(o, s, l) {
      const c = e(o, s, l);
      return i ? r(c, a) || (a = c) : (i = !0, a = c, process.env.NODE_ENV !== "production" && U4(a, n, "mergeProps")), a;
    };
  };
}
function rI(e) {
  return e ? typeof e == "function" ? nI(e) : Gg(e, "mergeProps") : () => tI;
}
function iI(e) {
  e();
}
function aI() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      iI(() => {
        let n = e;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      const n = [];
      let r = e;
      for (; r; )
        n.push(r), r = r.next;
      return n;
    },
    subscribe(n) {
      let r = !0;
      const i = t = {
        callback: n,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !r || e === null || (r = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var iy = {
  notify() {
  },
  get: () => []
};
function oI(e, t) {
  let n, r = iy, i = 0, a = !1;
  function o(b) {
    d();
    const S = r.subscribe(b);
    let _ = !1;
    return () => {
      _ || (_ = !0, S(), p());
    };
  }
  function s() {
    r.notify();
  }
  function l() {
    N.onStateChange && N.onStateChange();
  }
  function c() {
    return a;
  }
  function d() {
    i++, n || (n = t ? t.addNestedSub(l) : e.subscribe(l), r = aI());
  }
  function p() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = iy);
  }
  function y() {
    a || (a = !0, d());
  }
  function f() {
    a && (a = !1, p());
  }
  const N = {
    addNestedSub: o,
    notifyNestedSubs: s,
    handleChangeWrapper: l,
    isSubscribed: c,
    trySubscribe: y,
    tryUnsubscribe: f,
    getListeners: () => r
  };
  return N;
}
var sI = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", lI = /* @__PURE__ */ sI(), cI = () => typeof navigator < "u" && navigator.product === "ReactNative", uI = /* @__PURE__ */ cI(), dI = () => lI || uI ? R.useLayoutEffect : R.useEffect, Mm = /* @__PURE__ */ dI();
function ay(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Th(e, t) {
  if (ay(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let i = 0; i < n.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, n[i]) || !ay(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
var fI = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, pI = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, hI = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, z4 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, mI = {
  [WF]: hI,
  [HF]: z4
};
function oy(e) {
  return QF(e) ? z4 : mI[e.$$typeof] || fI;
}
var gI = Object.defineProperty, yI = Object.getOwnPropertyNames, sy = Object.getOwnPropertySymbols, vI = Object.getOwnPropertyDescriptor, bI = Object.getPrototypeOf, ly = Object.prototype;
function Um(e, t) {
  if (typeof t != "string") {
    if (ly) {
      const a = bI(t);
      a && a !== ly && Um(e, a);
    }
    let n = yI(t);
    sy && (n = n.concat(sy(t)));
    const r = oy(e), i = oy(t);
    for (let a = 0; a < n.length; ++a) {
      const o = n[a];
      if (!pI[o] && !(i && i[o]) && !(r && r[o])) {
        const s = vI(t, o);
        try {
          gI(e, o, s);
        } catch {
        }
      }
    }
  }
  return e;
}
var cy = /* @__PURE__ */ Symbol.for("react-redux-context"), uy = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function wI() {
  if (!R.createContext) return {};
  const e = uy[cy] ?? (uy[cy] = /* @__PURE__ */ new Map());
  let t = e.get(R.createContext);
  return t || (t = R.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(R.createContext, t)), t;
}
var Lo = /* @__PURE__ */ wI(), xI = [null, null], _I = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
};
function NI(e, t, n) {
  Mm(() => e(...t), n);
}
function SI(e, t, n, r, i, a) {
  e.current = r, n.current = !1, i.current && (i.current = null, a());
}
function EI(e, t, n, r, i, a, o, s, l, c, d) {
  if (!e) return () => {
  };
  let p = !1, y = null;
  const f = () => {
    if (p || !s.current)
      return;
    const N = t.getState();
    let b, S;
    try {
      b = r(
        N,
        i.current
      );
    } catch (_) {
      S = _, y = _;
    }
    S || (y = null), b === a.current ? o.current || c() : (a.current = b, l.current = b, o.current = !0, d());
  };
  return n.onStateChange = f, n.trySubscribe(), f(), () => {
    if (p = !0, n.tryUnsubscribe(), n.onStateChange = null, y)
      throw y;
  };
}
function CI(e, t) {
  return e === t;
}
var dy = !1;
function OI(e, t, n, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: i = CI,
  areOwnPropsEqual: a = Th,
  areStatePropsEqual: o = Th,
  areMergedPropsEqual: s = Th,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: l = !1,
  // the context consumer to use
  context: c = Lo
} = {}) {
  process.env.NODE_ENV !== "production" && r !== void 0 && !dy && (dy = !0, $g(
    'The `pure` option has been removed. `connect` is now always a "pure/memoized" component'
  ));
  const d = c, p = eI(e), y = AF(t), f = rI(n), N = !!e;
  return (b) => {
    if (process.env.NODE_ENV !== "production" && !/* @__PURE__ */ $F(b))
      throw new Error(
        `You must pass a component to the function returned by connect. Instead received ${_I(
          b
        )}`
      );
    const S = b.displayName || b.name || "Component", _ = `Connect(${S})`, E = {
      shouldHandleStateChanges: N,
      displayName: _,
      wrappedComponentName: S,
      WrappedComponent: b,
      // @ts-ignore
      initMapStateToProps: p,
      initMapDispatchToProps: y,
      initMergeProps: f,
      areStatesEqual: i,
      areStatePropsEqual: o,
      areOwnPropsEqual: a,
      areMergedPropsEqual: s
    };
    function k(F) {
      const [q, j, x] = R.useMemo(() => {
        const { reactReduxForwardedRef: ne, ...ve } = F;
        return [F.context, ne, ve];
      }, [F]), C = R.useMemo(() => {
        let ne = d;
        if (q != null && q.Consumer && process.env.NODE_ENV !== "production") {
          if (!/* @__PURE__ */ GF(
            // @ts-ignore
            /* @__PURE__ */ R.createElement(q.Consumer, null)
          ))
            throw new Error(
              "You must pass a valid React context consumer as `props.context`"
            );
          ne = q;
        }
        return ne;
      }, [q, d]), D = R.useContext(C), P = !!F.store && !!F.store.getState && !!F.store.dispatch, L = !!D && !!D.store;
      if (process.env.NODE_ENV !== "production" && !P && !L)
        throw new Error(
          `Could not find "store" in the context of "${_}". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ${_} in connect options.`
        );
      const H = P ? F.store : D.store, $ = L ? D.getServerState : H.getState, ae = R.useMemo(() => XF(H.dispatch, E), [H]), [ce, le] = R.useMemo(() => {
        if (!N) return xI;
        const ne = oI(
          H,
          P ? void 0 : D.subscription
        ), ve = ne.notifyNestedSubs.bind(ne);
        return [ne, ve];
      }, [H, P, D]), oe = R.useMemo(() => P ? D : {
        ...D,
        subscription: ce
      }, [P, D, ce]), se = R.useRef(void 0), J = R.useRef(x), re = R.useRef(void 0), I = R.useRef(!1), U = R.useRef(!1), G = R.useRef(
        void 0
      );
      Mm(() => (U.current = !0, () => {
        U.current = !1;
      }), []);
      const K = R.useMemo(() => () => re.current && x === J.current ? re.current : ae(H.getState(), x), [H, x]), A = R.useMemo(() => (ne) => ce ? EI(
        N,
        H,
        ce,
        // @ts-ignore
        ae,
        J,
        se,
        I,
        U,
        re,
        le,
        ne
      ) : () => {
      }, [ce]);
      NI(SI, [
        J,
        se,
        I,
        x,
        re,
        le
      ]);
      let ee;
      try {
        ee = R.useSyncExternalStore(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          A,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          K,
          $ ? () => ae($(), x) : K
        );
      } catch (ne) {
        throw G.current && (ne.message += `
The error may be correlated with this previous error:
${G.current.stack}

`), ne;
      }
      Mm(() => {
        G.current = void 0, re.current = void 0, se.current = ee;
      });
      const te = R.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ R.createElement(
          b,
          {
            ...ee,
            ref: j
          }
        )
      ), [j, b, ee]);
      return R.useMemo(() => N ? /* @__PURE__ */ R.createElement(C.Provider, { value: oe }, te) : te, [C, te, oe]);
    }
    const M = R.memo(k);
    if (M.WrappedComponent = b, M.displayName = k.displayName = _, l) {
      const F = R.forwardRef(
        function(q, j) {
          return /* @__PURE__ */ R.createElement(M, { ...q, reactReduxForwardedRef: j });
        }
      );
      return F.displayName = _, F.WrappedComponent = b, /* @__PURE__ */ Um(F, b);
    }
    return /* @__PURE__ */ Um(M, b);
  };
}
var Mt = OI;
function Qg(e = Lo) {
  return function() {
    const t = R.useContext(e);
    if (process.env.NODE_ENV !== "production" && !t)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return t;
  };
}
var q4 = /* @__PURE__ */ Qg();
function V4(e = Lo) {
  const t = e === Lo ? q4 : (
    // @ts-ignore
    Qg(e)
  ), n = () => {
    const { store: r } = t();
    return r;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var jI = /* @__PURE__ */ V4();
function PI(e = Lo) {
  const t = e === Lo ? jI : V4(e), n = () => t().dispatch;
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var tp = /* @__PURE__ */ PI(), LI = (e, t) => e === t;
function TI(e = Lo) {
  const t = e === Lo ? q4 : Qg(e), n = (r, i = {}) => {
    const { equalityFn: a = LI } = typeof i == "function" ? { equalityFn: i } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const o = t(), { store: s, subscription: l, getServerState: c } = o, d = R.useRef(!0), p = R.useCallback(
      {
        [r.name](f) {
          const N = r(f);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: b = {} } = typeof i == "function" ? {} : i, { identityFunctionCheck: S, stabilityCheck: _ } = o, {
              identityFunctionCheck: E,
              stabilityCheck: k
            } = {
              stabilityCheck: _,
              identityFunctionCheck: S,
              ...b
            };
            if (k === "always" || k === "once" && d.current) {
              const M = r(f);
              if (!a(N, M)) {
                let F;
                try {
                  throw new Error();
                } catch (q) {
                  ({ stack: F } = q);
                }
                console.warn(
                  "Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: f,
                    selected: N,
                    selected2: M,
                    stack: F
                  }
                );
              }
            }
            if ((E === "always" || E === "once" && d.current) && N === f) {
              let M;
              try {
                throw new Error();
              } catch (F) {
                ({ stack: M } = F);
              }
              console.warn(
                "Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: M }
              );
            }
            d.current && (d.current = !1);
          }
          return N;
        }
      }[r.name],
      [r]
    ), y = UF.useSyncExternalStoreWithSelector(
      l.addNestedSub,
      s.getState,
      c || s.getState,
      p,
      a
    );
    return R.useDebugValue(y), y;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var oa = /* @__PURE__ */ TI();
const FI = ({
  children: e,
  logOut: t
}) => {
  const n = sg(), r = Yn();
  return !r || r === "0" ? (t(), /* @__PURE__ */ m.jsx(y_, { to: "/login", state: {
    from: n
  }, replace: !0 })) : e;
}, II = (e) => Kt({
  logOut: ib
}, e);
Mt(null, II)(FI);
class kI extends R.Component {
  constructor(t) {
    super(t), et(this, "handleInputChange", (n) => {
      this.setState({
        email: n.target.value
      });
    }), this.state = {
      email: ""
    };
  }
  /* TODO: Error handling, once the API has been implemented */
  render() {
    const {
      handleSubmit: t,
      isFetching: n
    } = this.props, {
      email: r
    } = this.state;
    return /* @__PURE__ */ m.jsxs(Ct, { onSubmit: () => t(r), className: "login-form__form", children: [
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Email", name: "email", type: "text", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsxs("div", { className: "login-form__buttons", children: [
        /* @__PURE__ */ m.jsx(Ft, { type: "submit", loading: n, children: "Reset Password" }),
        /* @__PURE__ */ m.jsx($c, { to: "/login", className: "login-form__forgot-button", children: "Log In" })
      ] })
    ] });
  }
}
class DI extends R.Component {
  constructor(t) {
    super(t), et(this, "handleInputChange", (n) => {
      let r = Object.assign({}, this.state.formData);
      r[n.target.name] = n.target.value, this.setState({
        formData: r
      });
    }), this.state = {
      formData: {
        email: "",
        password: ""
      }
    };
  }
  render() {
    const {
      handleSubmit: t,
      isFetching: n,
      showRegisterLink: r
    } = this.props, {
      formData: i
    } = this.state;
    return /* @__PURE__ */ m.jsxs(Ct, { onSubmit: () => {
      t(i);
    }, className: "login-form__form", children: [
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Email", name: "email", type: "text", autoComplete: "email", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Password", name: "password", type: "password", autoComplete: "password", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsxs("div", { className: "login-form__buttons", children: [
        /* @__PURE__ */ m.jsx(Ft, { type: "submit", loading: n, children: "Log In" }),
        r && /* @__PURE__ */ m.jsx($c, { to: "/register", className: "login-form__forgot-button", children: "Register" }),
        /* @__PURE__ */ m.jsx($c, { to: "/forgot-password", className: "login-form__forgot-button", children: "Forgot Password" })
      ] })
    ] });
  }
}
class RI extends R.Component {
  constructor(t) {
    super(t), et(this, "handleSubmit", (n) => {
      const {
        forgotPassword: r,
        productId: i
      } = this.props;
      r(n, i).then((a) => a === !0 ? this.setState({
        resetPasswordRequested: !0
      }) : !1);
    }), this.state = {
      resetPasswordRequested: !1
      // authToken: getAuthToken()
    };
  }
  render() {
    const {
      isFetching: t,
      error: n
    } = this.props, {
      resetPasswordRequested: r
    } = this.state;
    return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "login-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs("div", { className: "callout", children: [
      /* @__PURE__ */ m.jsx("h2", { children: "Forgot Password" }),
      /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsxs(We.Column, { width: 10, children: [
        n && /* @__PURE__ */ m.jsx(Ii, { warning: !0, icon: "warning", content: n }),
        r ? /* @__PURE__ */ m.jsxs("div", { children: [
          /* @__PURE__ */ m.jsx("p", { children: "If that account exists and you haven't reached your forgotten password limit, we have sent you an email with instructions on how to reset your password. Please check your email inbox." }),
          /* @__PURE__ */ m.jsx("p", { children: /* @__PURE__ */ m.jsx($c, { to: "/login", children: "Back to Login" }) })
        ] }) : (
          /* $FlowFixMe */
          /* @__PURE__ */ m.jsx(kI, { handleSubmit: this.handleSubmit, isFetching: t, error: n })
        )
      ] }) })
    ] }) }) }) }) }) });
  }
}
const MI = (e) => ({
  isFetching: e.auth.user.isFetching,
  error: e.auth.error
}), UI = (e) => Kt({
  forgotPassword: cS
}, e);
Mt(MI, UI)(RI);
const BI = ({
  isFetching: e,
  loginStatus: t,
  error: n,
  redirectTo: r = "/",
  product: i,
  loginUserandGetData: a,
  clearLoginForm: o,
  showRegisterLink: s
}) => {
  const l = Ol();
  R.useState(Yn()), R.useEffect(() => {
    o();
  }, [o]);
  const c = async (d) => {
    await a(d.email, d.password, i) === !0 && l(r);
  };
  return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "login-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs("div", { className: "callout", children: [
    /* @__PURE__ */ m.jsx("h2", { children: "Log In" }),
    /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsxs(We.Column, { width: 10, children: [
      /* @__PURE__ */ m.jsx("p", { className: "login-comment", children: "Your roymorgan.com credentials are the same for all products." }),
      n && /* @__PURE__ */ m.jsx(Ii, { warning: !0, icon: !1, content: n }),
      /* @__PURE__ */ m.jsx(DI, { handleSubmit: c, isFetching: e || t, error: n, showRegisterLink: s })
    ] }) })
  ] }) }) }) }) }) });
}, zI = (e) => ({
  isFetching: e.auth.user.isFetching,
  loginStatus: e.auth.loginStatus.isFetching,
  error: e.auth.user.error
}), qI = (e) => Kt({
  loginUserandGetData: FS,
  clearLoginForm: B6
}, e);
Mt(zI, qI)(BI);
const VI = ({
  logOut: e,
  logoutCallback: t
}) => {
  const n = Ol();
  return gn(() => {
    e(t).then((r) => n("/"));
  }, [e, n, t]), /* @__PURE__ */ m.jsx("div", { children: "Logging Out... " });
}, WI = (e) => ({}), HI = (e) => Kt({
  logOut: ib
}, e);
Mt(WI, HI)(VI);
class $I extends R.Component {
  constructor(t) {
    super(t), et(this, "handleInputChange", (n) => {
      let r = Object.assign({}, this.state.formData);
      r[n.target.name] = n.target.value, this.setState({
        formData: r
      });
    }), this.state = {
      formData: {
        newPassword: "",
        newPasswordConfirmation: ""
      }
    };
  }
  render() {
    const {
      handleSubmit: t,
      isFetching: n
    } = this.props, {
      newPassword: r,
      newPasswordConfirmation: i
    } = this.state.formData, a = {
      fontSize: "11px"
    };
    return /* @__PURE__ */ m.jsxs(Ct, { onSubmit: () => {
      t(r);
    }, className: "login-form__form", children: [
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "New Password", name: "newPassword", type: "password", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx("p", { style: a, children: "Passwords must be at least eight characters in length, and must include one uppercase letter, one lowercase letter, and one numeric character" }),
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Confirm New Password", name: "newPasswordConfirmation", type: "password", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsx(Ft, { disabled: r !== i || r === "", type: "submit", loading: n, children: "Update Password" }) })
    ] });
  }
}
const GI = ({
  resetPassword: e,
  isFetching: t,
  error: n
}) => {
  const r = Ol(), [i] = Z0(), a = async (o) => {
    const s = i.get("token") || "", l = i.get("productId") || "", c = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV, d = Jv(l, c);
    await e(o, s) === !0 && r(d);
  };
  return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "login-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs("div", { className: "callout", children: [
    /* @__PURE__ */ m.jsx("h2", { children: "Reset Password" }),
    /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsxs(We.Column, { width: 10, children: [
      n && /* @__PURE__ */ m.jsx(Ii, { warning: !0, icon: !1, content: n }),
      /* @__PURE__ */ m.jsx($I, { handleSubmit: a })
    ] }) })
  ] }) }) }) }) }) });
}, QI = (e) => ({
  isFetching: e.auth.user.isFetching,
  error: e.auth.user.error
}), YI = (e) => Kt({
  resetPassword: NS
}, e);
Mt(QI, YI)(GI);
class KI extends R.Component {
  constructor(t) {
    super(t), et(this, "handleInputChange", (n) => {
      let r = Object.assign({}, this.state.formData);
      r[n.target.name] = n.target.value, this.setState({
        formData: r
      });
    }), this.state = {
      formData: {
        name: "",
        phoneNumber: "",
        password: "",
        passwordConfirmation: ""
      }
    };
  }
  render() {
    const {
      handleSubmit: t,
      isFetching: n
    } = this.props, {
      name: r,
      phoneNumber: i,
      password: a,
      passwordConfirmation: o
    } = this.state.formData, s = {
      fontSize: "11px"
    };
    return /* @__PURE__ */ m.jsxs(Ct, { onSubmit: () => {
      t(r, i, a);
    }, className: "register-form__form", children: [
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Name", name: "name", type: "text", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Phone Number", name: "phoneNumber", type: "text", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Password", name: "password", type: "password", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx("p", { style: s, children: "Passwords must be at least eight characters in length, and must include one uppercase letter, one lowercase letter, and one numeric character" }),
      /* @__PURE__ */ m.jsx(Ct.Input, { label: "Confirm Password", name: "passwordConfirmation", type: "password", onChange: this.handleInputChange, disabled: n }),
      /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsx(Ft, { disabled: a !== o || a === "", type: "submit", loading: n, children: "Register" }) })
    ] });
  }
}
const XI = ({
  registerUser: e,
  isFetching: t,
  error: n
}) => {
  const r = Ol(), [i] = Z0(), a = async (o, s, l) => {
    const c = i.get("token") || "", d = i.get("productId") || "", p = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV, y = Jv(d, p);
    try {
      await e(o, s, l, c) === !0 && r(y === "/" ? "/verification" : y);
    } catch {
    }
  };
  return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "register-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs("div", { className: "callout", children: [
    /* @__PURE__ */ m.jsx("h2", { children: "Register" }),
    /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsxs(We.Column, { width: 10, children: [
      n && /* @__PURE__ */ m.jsx(Ii, { warning: !0, icon: !1, content: n }),
      /* @__PURE__ */ m.jsx(KI, { handleSubmit: a })
    ] }) })
  ] }) }) }) }) }) });
}, ZI = (e) => ({
  isFetching: e.auth.user.isFetching,
  error: e.auth.user.error
}), JI = (e) => Kt({
  registerUser: OS
}, e);
Mt(ZI, JI)(XI);
const fy = {
  maxWidth: "300px",
  margin: "0 auto",
  marginBottom: "20px",
  lineHeight: "12px"
}, py = {
  fontFamily: "'Proxima Nova',sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  textAlign: "center"
}, hy = {
  fontWeight: "600",
  justifyContent: "center",
  color: "#0f849e",
  fontSize: "18px",
  textAlign: "center"
}, AI = {
  fontSize: "12px"
}, e9 = {
  width: "50px",
  height: "50px"
}, t9 = {
  width: "29px",
  height: "29px"
}, n9 = {
  margin: "0 auto",
  display: "block"
}, r9 = ({
  products: e = [],
  noAccessTeams: t,
  loadNoAccessTeams: n,
  loadNoAccessUserOrganisations: r,
  switchOrganisationAndTeam: i,
  productId: a,
  noAccessOrganisations: o,
  productName: s
}) => {
  sg();
  const [l, c] = R.useState(null), [d, p] = R.useState(null), [y, f] = R.useState(!1);
  R.useEffect(() => {
    r(a);
  }, [r, a]);
  const N = R.useCallback((M, {
    value: F
  }) => {
    c(F), p(null), f(!0), n(a, F);
  }, [n, a]), b = R.useCallback((M, {
    value: F
  }) => {
    p(F);
  }, []), S = R.useCallback(async (M, F) => {
    await i(M, F), window.location.href = "/";
  }, [i]), _ = R.useMemo(() => {
    const M = [];
    return o != null && o.byId && Object.values(o.byId).forEach((F) => {
      M.push({
        value: F.id.toString(),
        key: F.id.toString(),
        text: F.name
      });
    }), M;
  }, [o]), E = R.useMemo(() => {
    const M = [];
    return y && t != null && t.byId && Object.values(t.byId).forEach((F) => {
      M.push({
        value: F.id.toString(),
        key: F.id.toString(),
        text: F.name,
        name: F.name
      });
    }), M;
  }, [y, t]), k = R.useMemo(() => E.length && l && d ? !1 : !(E.length === 0 && l), [E.length, l, d]);
  return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "register-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 10, children: /* @__PURE__ */ m.jsxs("div", { className: "callout", children: [
    o && _.length > 0 ? /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsxs("h3", { style: py, children: [
        "Select an Organisation and/or Team with Access to",
        " ",
        s
      ] }),
      /* @__PURE__ */ m.jsxs(We, { stackable: !0, centered: !0, children: [
        /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs(We.Row, { children: [
          /* @__PURE__ */ m.jsx("h4", { style: hy, children: "Organisations" }),
          /* @__PURE__ */ m.jsx(fa, { style: fy, onChange: N, placeholder: "Select Organisation", fluid: !0, search: !0, selection: !0, options: _ })
        ] }) }),
        E.length > 0 && /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs(We.Row, { children: [
          /* @__PURE__ */ m.jsx("h4", { style: hy, children: "Teams" }),
          /* @__PURE__ */ m.jsx(fa, { style: fy, onChange: b, placeholder: "Select Team", fluid: !0, search: !0, selection: !0, options: E })
        ] }) })
      ] }),
      /* @__PURE__ */ m.jsx(Ft, { style: n9, onClick: () => S(l, d), disabled: k, children: "Apply" })
    ] }) : null,
    /* @__PURE__ */ m.jsx("h3", { style: py, children: o && _.length > 0 ? "Alternatively you can select an available product below:" : "Please select an available product below:" }),
    /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Row, { children: e.map((M) => M.hasAccess ? /* @__PURE__ */ m.jsx(We.Column, { mobile: 6, tablet: 3, computer: 1, children: /* @__PURE__ */ m.jsxs("a", { className: "nine-dot__item", href: M.url, target: "_blank", rel: "noopener noreferrer", children: [
      /* @__PURE__ */ m.jsx("div", { className: "nine-dot-menu__icon", style: e9, children: /* @__PURE__ */ m.jsx("img", { src: M.iconLogoLocation, alt: M.name, style: t9 }) }),
      /* @__PURE__ */ m.jsx("span", { style: AI, children: M.name })
    ] }) }, M.id) : null) }) })
  ] }) }) }) }) }) });
}, i9 = (e, t) => ({
  products: e.auth.products,
  noAccessOrganisations: e.auth.noAccessUserOrganisations,
  noAccessTeams: e.auth.noAccessUserTeams && e.auth.noAccessUserTeams.order.length > 0 && e.auth.noAccessUserTeams,
  currentOrganisation: e.auth.organisations.byId[e.auth.organisations.currentOrganisation],
  currentTeam: e.auth.teams.currentTeam ? e.auth.teams.byId[e.auth.teams.currentTeam] : null
}), a9 = (e) => Kt({
  loadNoAccessTeams: lE,
  switchOrganisationAndTeam: jS,
  loadNoAccessUserOrganisations: qS
}, e);
Mt(i9, a9)(r9);
const o9 = ({
  isFetching: e,
  error: t,
  products: n = []
}) => {
  Ol();
  const r = {
    fontSize: "12px"
  }, i = {
    width: "50px",
    height: "50px"
  }, a = {
    width: "29px",
    height: "29px"
  };
  return /* @__PURE__ */ m.jsx("div", { className: "page--multifaceted-bg-grey", children: /* @__PURE__ */ m.jsx(fr, { className: "page-container", children: /* @__PURE__ */ m.jsx("div", { className: "register-form", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Column, { width: 10, children: /* @__PURE__ */ m.jsx("div", { className: "callout", children: /* @__PURE__ */ m.jsx(We, { stackable: !0, centered: !0, children: /* @__PURE__ */ m.jsx(We.Row, { children: n.map((o) => o.hasAccess ? /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsxs("a", { className: "nine-dot__item", href: o.url, target: "_blank", rel: "noopener noreferrer", children: [
    /* @__PURE__ */ m.jsx("div", { className: "nine-dot-menu__icon", style: i, children: /* @__PURE__ */ m.jsx("img", { src: o.iconLogoLocation, alt: o.name, style: a }) }),
    /* @__PURE__ */ m.jsx("span", { style: r, children: o.name })
  ] }) }, o.id) : /* @__PURE__ */ m.jsx("span", {})) }) }) }) }) }) }) }) });
}, s9 = (e) => ({
  isFetching: e.auth.user.isFetching,
  error: e.auth.user.error,
  products: e.auth.products
}), l9 = (e) => Kt({}, e);
Mt(s9, l9)(o9);
var W4 = { exports: {} };
(function(e) {
  (function(t) {
    var n = function(_, E, k) {
      if (!c(E) || p(E) || y(E) || f(E) || l(E))
        return E;
      var M, F = 0, q = 0;
      if (d(E))
        for (M = [], q = E.length; F < q; F++)
          M.push(n(_, E[F], k));
      else {
        M = {};
        for (var j in E)
          Object.prototype.hasOwnProperty.call(E, j) && (M[_(j, k)] = n(_, E[j], k));
      }
      return M;
    }, r = function(_, E) {
      E = E || {};
      var k = E.separator || "_", M = E.split || /(?=[A-Z])/;
      return _.split(M).join(k);
    }, i = function(_) {
      return N(_) ? _ : (_ = _.replace(/[\-_\s]+(.)?/g, function(E, k) {
        return k ? k.toUpperCase() : "";
      }), _.substr(0, 1).toLowerCase() + _.substr(1));
    }, a = function(_) {
      var E = i(_);
      return E.substr(0, 1).toUpperCase() + E.substr(1);
    }, o = function(_, E) {
      return r(_, E).toLowerCase();
    }, s = Object.prototype.toString, l = function(_) {
      return typeof _ == "function";
    }, c = function(_) {
      return _ === Object(_);
    }, d = function(_) {
      return s.call(_) == "[object Array]";
    }, p = function(_) {
      return s.call(_) == "[object Date]";
    }, y = function(_) {
      return s.call(_) == "[object RegExp]";
    }, f = function(_) {
      return s.call(_) == "[object Boolean]";
    }, N = function(_) {
      return _ = _ - 0, _ === _;
    }, b = function(_, E) {
      var k = E && "process" in E ? E.process : E;
      return typeof k != "function" ? _ : function(M, F) {
        return k(M, _, F);
      };
    }, S = {
      camelize: i,
      decamelize: o,
      pascalize: a,
      depascalize: o,
      camelizeKeys: function(_, E) {
        return n(b(i, E), _);
      },
      decamelizeKeys: function(_, E) {
        return n(b(o, E), _, E);
      },
      pascalizeKeys: function(_, E) {
        return n(b(a, E), _);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = S : t.humps = S;
  })(xn);
})(W4);
var Yg = W4.exports;
const c9 = (e, t = "id") => e.reduce((n, r) => (n[r[t]] = r, n), {}), u9 = (e, t = "id") => ({
  bySlug: c9(e, t),
  order: vg(e, t)
}), d9 = (e) => (Object.values(e.bySlug).forEach((t) => {
  t.segments = t.segments.sort((n, r) => n.id - r.id);
}), e), Kg = (e, t, n) => {
  const {
    sortColumn: r,
    sortDirection: i
  } = n.state, a = i === "ascending" ? 1 : -1;
  return r ? e.belowSample ? 1 : t.belowSample ? -1 : e && e[r] && isNaN(e[r]) && t && t[r] && isNaN(t[r]) ? e[r].toLowerCase() < t[r].toLowerCase() ? -1 * a : e[r].toLowerCase() > t[r].toLowerCase() ? a : 0 : a * (e[r] - t[r]) : 0;
}, f9 = (e, t, n, r) => {
  const {
    sortColumn: i,
    sortDirection: a
  } = r.state, o = a === "ascending" ? 1 : -1;
  return i ? e.answers[i].belowSample ? 1 : t.answers[i].belowSample ? -1 : e.answers[i][n] < t.answers[i][n] ? -1 * o : e.answers[i][n] > t.answers[i][n] ? o : 0 : 0;
}, Xg = (e, t) => {
  const {
    sortColumn: n,
    sortDirection: r
  } = t.state;
  if (n !== e) {
    t.setState({
      sortColumn: e,
      sortDirection: "descending"
    });
    return;
  }
  t.setState({
    sortDirection: r === "ascending" ? "descending" : "ascending"
  });
}, Bm = (e) => {
  let t = 0;
  if (e !== null)
    switch (typeof e) {
      case "string":
        e.length > 0 && (isNaN(e) || (t = parseFloat(e)));
        break;
      case "number":
        t = e;
        break;
    }
  return t;
}, Qr = (e, t) => Object.values(e).reduce((n, r) => Math.max(n, Bm(r[t])), Bm(e[0][t])), zd = (e, t) => e.reduce((n, r) => Math.max(n, Bm(r[t])), e[0][t]), zm = (e) => e && e.toFixed(1) + "%", np = (e) => Math.round(e / 1e3).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "k", p9 = (e) => {
  let t = {};
  return e.bySlug && Object.values(e.bySlug).map((n) => t[n.id] = n.color), t;
}, h9 = (e, t = "id") => ({
  bySlug: yg(e, t),
  order: vg(e, t)
});
function m9(e, t) {
  if (!t)
    return "";
  const n = Object.values(t).find(
    // $FlowFixMe
    (r) => parseInt(r.id) === e
  );
  return n ? n.label : "";
}
const g9 = () => process.env.REACT_APP_DATA_ENDPOINT === "nz-helix" || window.location.host.includes("nz") ? "nz-helix/v1" : "helix/v1", Rl = () => {
  const {
    REACT_APP_DATA_ENDPOINT: e
  } = process.env;
  return e === "nz-helix" || window.location.host.includes("nz") ? ur("v2", "nz-helix") : e === "helix" ? ur("v2", "helix") : e === "premium" ? ur("v2", "premium") : "undefined";
}, Zg = (e, t) => e.toLowerCase() === "id" ? "id" : /(^[A-Z0-9_]+$|^id+$)/.test(e) ? e : t(e);
function y9() {
  switch (process.env.REACT_APP_RM_ENV) {
    case "prod":
      return "https://livecms.roymorgan.com";
    case "uat":
      return "https://livecms.roymorganuat.com";
    default:
      return "https://livecms.roymorgandev.com";
  }
}
const Jg = y9(), v9 = () => {
  let e = g9();
  return `${Jg}/wp-json/${e}`;
};
Xv(process.env.REACT_APP_RM_ENV);
const Va = async ({
  method: e,
  targetUrl: t,
  token: n,
  headers: r,
  body: i
}) => {
  const a = n ? new Headers({
    "Content-Type": "application/json",
    ...r,
    token: n
  }) : new Headers({
    "Content-Type": "application/json",
    ...r
  }), o = await fetch(t, {
    method: e,
    headers: a,
    body: JSON.stringify(i)
  });
  if (!o.ok) {
    const s = await o.json(), l = Error("Invalid API Response");
    throw l.msg = s.errors ? s.errors[0].message : s.statusMessage ? s.statusMessage : "API Error", l;
  }
  return await o.json();
}, b9 = async ({
  method: e,
  endpoint: t,
  body: n,
  isLiveAPICall: r,
  useToken: i,
  selfRegisteredToken: a,
  customHeaders: o
}) => {
  try {
    const s = r ? `${t}` : `${Jg}${t}`;
    let l;
    r === !0 && i === !0 && (l = Yn());
    let c = a || l, d = !(typeof c > "u") && c && r === !0 ? new Headers({
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      token: c
    }) : null;
    if (d = typeof c > "u" && r === !0 ? new Headers({
      "Content-Type": "application/json"
    }) : d, o && d)
      for (const [N, b] of Object.entries(o))
        d.append(N, b);
    const p = d, y = p === null ? await fetch(s, {
      method: e,
      body: JSON.stringify(n)
    }) : await fetch(s, {
      method: e,
      headers: p,
      body: JSON.stringify(n)
    });
    if (!y.ok) {
      const N = await y.json();
      let b = Error("API Error");
      throw N.errors ? b.message = N.errors[0].message : N.message && (b.message = N.message), b.code = "API", b;
    }
    const f = await y.json();
    return Yg.camelizeKeys(f, Zg);
  } catch (s) {
    throw console.error(s), s.code === "API" ? s : new Error("API Error");
  }
}, w9 = "LOAD_CATEGORIES_REQUEST", H4 = "LOAD_CATEGORIES_SUCCESS", x9 = "LOAD_CATEGORIES_FAILURE", $4 = "LOAD_CHARACTERISTICS_REQUEST", G4 = "LOAD_CHARACTERISTICS_SUCCESS", Q4 = "LOAD_CHARACTERISTICS_FAILURE", _9 = () => ({
  type: $4
}), N9 = (e) => ({
  type: G4,
  payload: e
}), S9 = (e) => ({
  type: Q4,
  error: e
}), E9 = () => async (e, t) => {
  try {
    Ra(e), e(_9());
    const n = t(), r = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    }, i = n.options.tagIds.findPersonasCharacteristics, a = Yn(), o = Rl(), s = await Va({
      method: "GET",
      targetUrl: `${o}/campaign-creator/available-attributes?tagId=${i}`,
      token: a,
      headers: r
    });
    if (s instanceof Error)
      return s;
    e(N9(s));
  } catch (n) {
    return e(S9(n.message)), process.env.NODE_ENV !== "test" && (Tn(n), console.error(n)), n;
  }
}, Y4 = "CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST", K4 = "CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS", C9 = "CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE";
function O9() {
  return {
    type: Y4
  };
}
function j9(e) {
  return {
    type: K4,
    payload: e
  };
}
function P9(e) {
  return {
    type: C9,
    error: e
  };
}
const Ag = () => async (e, t) => {
  try {
    e(O9());
    const n = await b9({
      method: "GET",
      endpoint: "/wp-json/acf/v3/options/helix_campaign_creator"
    });
    e(j9(n));
  } catch (n) {
    e(P9(n.message)), process.env.NODE_ENV !== "test" && (Tn(n), console.error(n));
  }
}, X4 = "ADD_SELECTED_CHARACTERISTIC", L9 = (e) => ({
  type: X4,
  payload: e
}), T9 = (e) => async (t) => {
  t(L9(e));
}, Z4 = "REMOVE_SELECTED_CHARACTERISTIC", F9 = (e) => ({
  type: Z4,
  payload: e
}), e1 = (e) => async (t) => {
  t(F9(e));
}, J4 = "UPDATE_SELECTED_MEASURE", I9 = (e) => ({
  type: J4,
  payload: e
}), k9 = (e) => async (t) => {
  t(I9(e));
}, D9 = "LOAD_DIGITAL_AUDIENCES_VENDORS_REQUEST", R9 = "LOAD_DIGITAL_AUDIENCES_VENDORS_SUCCESS", M9 = "LOAD_DIGITAL_AUDIENCES_VENDORS_FAILURE", t1 = "LOAD_PROFILE_CATEGORIES_REQUEST", n1 = "LOAD_PROFILE_CATEGORIES_SUCCESS", r1 = "LOAD_PROFILE_CATEGORIES_FAILURE", U9 = () => ({
  type: t1
}), B9 = (e) => ({
  type: H4,
  payload: e
}), z9 = (e) => ({
  type: n1,
  payload: e
}), q9 = (e) => ({
  type: r1,
  error: e
}), V9 = () => async (e, t) => {
  try {
    Ra(e), e(U9());
    const n = t(), r = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    }, i = Yn(), a = Rl(), o = n.themeFilter.isModified, s = await Va({
      method: "GET",
      targetUrl: `${a}/campaign-creator/profile-categories`,
      token: i,
      headers: r
    });
    return s instanceof Error || (e(B9(s)), o || e(z9(s))), s;
  } catch (n) {
    return e(q9(n.message)), process.env.NODE_ENV !== "test" && (Tn(n), console.error(n)), n;
  }
}, W9 = () => async (e, t) => {
  try {
    Ra(e);
    const n = t(), r = n.universes.currentUniverse, i = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    }, a = Yn(), o = Rl(), s = await Va({
      method: "GET",
      targetUrl: `${o}/campaign-creator/downloads?universeId=${r}`,
      token: a,
      headers: i
    });
    return s instanceof Error ? s : s.url;
  } catch (n) {
    return process.env.NODE_ENV !== "test" && (Tn(n), console.error(n)), n;
  }
}, A4 = "LOAD_GROUPED_REQUEST", ew = "LOAD_GROUPED_SUCCESS", tw = "LOAD_GROUPED_FAILURE", nw = "LOAD_GROUPED_EMPTY", H9 = () => ({
  type: A4
}), $9 = (e) => ({
  type: ew,
  payload: e
}), G9 = (e) => ({
  type: tw,
  error: e
}), Q9 = () => ({
  type: nw
}), Y9 = () => async (e, t) => {
  try {
    const n = t(), r = n.selectedCharacteristics.characteristics.map((f) => f.answerId).join(","), i = n.audienceView.view.segmentType, a = n.options.tagIds.findPersonasGrouped, o = n.options.isDataPage.value;
    if (r.length <= 0)
      return e(Q9()), {};
    Ra(e), e(H9());
    const {
      currentUniverse: s
    } = n.universes, l = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    };
    let c;
    o ? c = i : c = "segments";
    const d = Yn(), p = Rl(), y = await Va({
      method: "GET",
      targetUrl: `${p}/campaign-creator/grouped/${c}?answerIds=${r}&universeId=${s}&tagId=${a}`,
      token: d,
      headers: l
    });
    if (y instanceof Error)
      return y;
    e($9(y));
  } catch (n) {
    return e(G9(n.message)), process.env.NODE_ENV !== "test" && (Tn(n), console.error(n)), n;
  }
}, rw = "LOAD_INDIVIDUAL_REQUEST", iw = "LOAD_INDIVIDUAL_SUCCESS", aw = "LOAD_INDIVIDUAL_FAILURE", ow = "LOAD_INDIVIDUAL_EMPTY", K9 = () => ({
  type: rw
}), X9 = (e) => ({
  type: iw,
  payload: e
}), Z9 = (e) => ({
  type: aw,
  error: e
}), J9 = () => ({
  type: ow
}), A9 = () => async (e, t) => {
  try {
    const n = t(), r = n.selectedCharacteristics.characteristics.map((y) => y.answerId).join(","), i = n.audienceView.view.segmentType, a = n.options.tagIds.findPersonasIndividual;
    if (r.length <= 0)
      return e(J9()), [];
    Ra(e), e(K9());
    const {
      currentUniverse: o
    } = n.universes, s = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    }, l = i, c = Yn(), d = Rl(), p = await Va({
      method: "GET",
      targetUrl: `${d}/campaign-creator/individual/${l}?answerIds=${r}&universeId=${o}&tagId=${a}`,
      token: c,
      headers: s
    });
    if (p instanceof Error)
      return p;
    e(X9(p));
  } catch (n) {
    return e(Z9(n.message)), process.env.NODE_ENV !== "test" && (Tn(n), console.error(n)), n;
  }
}, sw = "RESET_INDEX", lw = "RESET_SHARE_OF_ATTRIBUTE", cw = "RESET_SHARE_OF_AUDIENCE", uw = "RESET_THEME", dw = "SET_INDEX", fw = "SET_SHARE_OF_ATTRIBUTE", pw = "SET_SHARE_OF_AUDIENCE", hw = "SET_THEME", mw = "SET_POPULATION", gw = "RESET_POPULATION", ek = () => ({
  type: sw
}), tk = () => ({
  type: lw
}), nk = () => ({
  type: cw
}), rk = (e) => ({
  type: uw,
  payload: e
}), ik = (e) => ({
  type: dw,
  payload: e
}), ak = (e) => ({
  type: fw,
  payload: e
}), yw = (e) => ({
  type: pw,
  payload: e
}), ok = (e) => ({
  type: hw,
  payload: e
}), sk = (e) => ({
  type: mw,
  payload: e
}), lk = () => ({
  type: gw
}), vw = "SET_MEDIA_SHARE_OF_ATTRIBUTE", bw = "SET_MEDIA_SHARE_OF_AUDIENCE", ww = "RESET_MEDIA_INDEX", xw = "RESET_MEDIA_POPULATION", _w = "RESET_MEDIA_SHARE_OF_ATTRIBUTE", Nw = "RESET_MEDIA_SHARE_OF_AUDIENCE", Sw = "RESET_MEDIA_THEME", Ew = "SET_MEDIA_INDEX", Cw = "SET_MEDIA_POPULATION", Ow = "SET_MEDIA_THEME", ck = () => ({
  type: ww
}), uk = () => ({
  type: xw
}), dk = () => ({
  type: _w
}), fk = () => ({
  type: Nw
}), pk = (e) => ({
  type: Sw,
  payload: e
}), hk = (e) => ({
  type: Ew,
  payload: e
}), mk = (e) => ({
  type: Cw,
  payload: e
}), gk = (e) => ({
  type: vw,
  payload: e
}), jw = (e) => ({
  type: bw,
  payload: e
}), yk = (e) => ({
  type: Ow,
  payload: e
}), vk = "LOAD_UNIVERSE_REQUEST", bk = "LOAD_UNIVERSE_SUCCESS", wk = "LOAD_UNIVERSE_FAILURE", Pw = "READ_GROUPED_PERSONA_REQUEST", Lw = "READ_GROUPED_PERSONA_SUCCESS", Tw = "READ_GROUPED_PERSONA_FAILURE", Fw = "READ_GROUPED_PERSONA_EMPTY", xk = () => ({
  type: Pw
}), _k = (e) => ({
  type: Lw,
  payload: e
}), Nk = (e) => ({
  type: Tw,
  accessInfo: e
}), Sk = () => ({
  type: Fw
}), Ss = () => async (e, t) => {
  try {
    const n = t(), r = n.selectedPersonas.personas.map((N) => N.id).join(","), {
      universes: i,
      audienceView: a
    } = n, o = i.currentUniverse, s = n.options.tagIds.audienceProfiling, l = n.options.isDataPage.value;
    let c;
    if (a.view.segmentType === "supersegments" && l ? c = {
      endpointType: "supersegment",
      queryStringType: "supersegmentIds"
    } : c = {
      endpointType: "segment",
      queryStringType: "segmentIds"
    }, r.length <= 0) {
      e(Sk());
      return;
    }
    Ra(e), e(xk());
    const d = `/grouped-${c.endpointType}-data?${c.queryStringType}=${r}&universeId=${o}&tagId=${s}`, p = Yn(), y = {
      "context-organisation": n.auth.organisations.currentOrganisation,
      "context-team": n.auth.teams.currentTeam
    }, f = await Va({
      method: "GET",
      targetUrl: `${Rl()}${d}`,
      token: p,
      headers: y
    });
    if (f instanceof Error)
      throw f;
    return e(_k(f)), f;
  } catch (n) {
    return Tn(n), e(Nk(n)), n;
  }
}, Ek = "LOAD_POPULATIONS_REQUEST", Ck = "LOAD_POPULATIONS_SUCCESS", Ok = "LOAD_POPULATIONS_FAILURE", jk = "SET_CURRENT_UNIVERSE", Pk = "SET_UNIVERSE_FAILURE", Iw = "LOAD_COMMUNITIES_AND_PERSONAS_REQUEST", kw = "LOAD_COMMUNITIES_AND_PERSONAS_SUCCESS", Dw = "LOAD_COMMUNITIES_AND_PERSONAS_FAILURE", Lk = () => ({
  type: Iw
}), Tk = (e, t) => ({
  type: kw,
  payload: e,
  accessInfo: t
}), Fk = (e) => ({
  type: Dw,
  accessInfo: e
}), i1 = () => async (e, t) => {
  try {
    Ra(e), e(Lk());
    const n = Yn(), r = t().auth.organisations.currentOrganisation, i = t().auth.teams.currentTeam;
    let a = {
      "context-organisation": r,
      "context-team": null,
      token: n
    };
    i && (a["context-team"] = i);
    const o = v9(), s = await Va({
      method: "GET",
      targetUrl: `${o}/persona-excerpts`,
      headers: a
    });
    if (s instanceof Error)
      throw s;
    const l = Yg.camelizeKeys(s, Zg), c = h9(l.personas, "postName");
    return e(Tk(c, s.accessInfo)), s;
  } catch (n) {
    return Tn(n), e(Fk(n)), n;
  }
}, Ik = "SET_CURRENT_MESSAGE_STREAM", kk = "SET_INDEX_THRESHOLD", Dk = "GET_QUADRANTS_REQUEST", Rk = "GET_QUADRANTS_SUCCESS", Mk = "GET_QUADRANTS_FAILURE", Uk = "GET_QUADRANT_MESSAGES_REQUEST", Bk = "GET_QUADRANT_MESSAGES_SUCCESS", zk = "GET_QUADRANT_MESSAGES_FAILURE", qk = "GET_PERSONA_INSIGHTS_REQUEST", Vk = "GET_PERSONA_INSIGHTS_SUCCESS", Wk = "GET_PERSONA_INSIGHTS_FAILURE", Hk = "GET_COMMUNITY_INSIGHTS_REQUEST", $k = "GET_COMMUNITY_INSIGHTS_SUCCESS", Gk = "GET_COMMUNITY_INSIGHTS_FAILURE", Rw = "SET_HELPER_MESSAGE_VISIBILITY", a1 = (e, t) => ({
  type: Rw,
  id: e,
  payload: t
}), Mw = "SET_FILE_UPLOAD_META", Qk = (e) => ({
  type: Mw,
  payload: e
}), Uw = "LOAD_SUPER_SEGMENTS_REQUEST", Bw = "LOAD_SUPER_SEGMENTS_SUCCESS", zw = "LOAD_SUPER_SEGMENTS_FAILURE", Yk = () => ({
  type: Uw
}), Kk = (e, t) => ({
  type: Bw,
  payload: e,
  accessInfo: t
}), Xk = (e) => ({
  type: zw,
  accessInfo: e
}), zo = () => async (e, t) => {
  try {
    Ra(e), e(Yk());
    const n = window.location.host.includes("nz") ? "nz-helix" : process.env.REACT_APP_DATA_ENDPOINT ? process.env.REACT_APP_DATA_ENDPOINT : "undefined", r = await Va({
      method: "GET",
      headers: {},
      targetUrl: `${Jg}/wp-json/data-workflow/v1/segments?type=${n}`
    });
    if (r instanceof Error)
      throw r;
    const i = u9(r.body, "ID"), a = Yg.camelizeKeys(i, Zg), o = d9(a);
    return e(Kk(o, r.accessInfo)), a;
  } catch (n) {
    return Tn(n), e(Xk(n)), n;
  }
}, qw = "READ_INDUSTRY_DATA_REQUEST", Vw = "READ_INDUSTRY_DATA_SUCCESS", Ww = "READ_INDUSTRY_DATA_FAILURE", Zk = () => ({
  type: qw
}), Jk = (e) => ({
  type: Vw,
  payload: e
}), Ak = (e) => ({
  type: Ww,
  accessInfo: e
}), eD = () => async (e, t) => {
  try {
    Ra(e), e(Zk());
    const n = await fetch("/industry-data.json");
    if (n instanceof Error)
      throw n;
    const r = await n.json();
    return e(Jk(r)), n;
  } catch (n) {
    return Tn(n), e(Ak(n)), n;
  }
}, tD = "RESET_STATE_DATA", di = "RESET_PAGE_DATA", Hw = () => async (e, t) => {
  const n = t().categories.categories.filter((r) => r.isDefault);
  e({
    type: di,
    payload: n
  });
}, $w = "DONT_COLLAPSE_CHECKBOXES", nD = () => async (e) => {
  e({
    type: $w
  });
}, Bu = "SET_AUDIENCE_VIEW", o1 = "ADD_SELECTED_PERSONA", zu = (e) => ({
  type: o1,
  payload: e
}), s1 = "REMOVE_SELECTED_PERSONA", Es = (e) => ({
  type: s1,
  payload: e
}), l1 = "UPDATE_SELECTED_PERSONA", c1 = "SET_SELECTED_PERSONAS", rp = "RESET_SELECTED_PERSONAS", ip = "SET_BRIEFS_FLOW", rD = (e, t) => ({
  type: l1,
  payload: e,
  index: t
}), u1 = (e) => ({
  type: c1,
  payload: e
}), ap = () => ({
  type: rp
}), d1 = (e) => ({
  type: ip,
  payload: e
}), Gw = "SET_PREVIEW_SELECTED_PERSONAS", Qw = (e) => ({
  type: Gw,
  payload: e
}), Yw = "TOGGLE_SEGMENT_SELECTION_VISIBILITY", iD = (e) => ({
  type: Yw,
  payload: e
}), aD = "READ_DIGITAL_AUDIENCES_REQUEST", oD = "READ_DIGITAL_AUDIENCES_SUCCESS", sD = "READ_DIGITAL_AUDIENCES_FAILURE", Kw = "PREMIUM_DATA_ENQUIRY_RESET", Xw = "PREMIUM_DATA_ENQUIRY_REQUEST", Zw = "PREMIUM_DATA_ENQUIRY_SUCCESS", Jw = "PREMIUM_DATA_ENQUIRY_FAILURE";
function lD() {
  return {
    type: Kw
  };
}
function cD() {
  return {
    type: Xw
  };
}
function uD(e) {
  return {
    type: Zw,
    payload: e
  };
}
function dD(e) {
  return {
    type: Jw,
    error: e
  };
}
const Aw = (e) => async (t, n) => {
  try {
    t(as(cD()));
    const r = Yn(), i = n();
    let a = `${ur("v2", "premium")}/contact?requestType=industryDataPack`;
    e.firstName && (a = `${a}&firstName=${encodeURIComponent(e.firstName)}`), e.lastName && (a = `${a}&lastName=${encodeURIComponent(e.lastName)}`), e.email && (a = `${a}&email=${encodeURIComponent(e.email)}`), e.phone && (a = `${a}&phone=${encodeURIComponent(e.phone)}`), e.comment && (a = `${a}&comment=${encodeURIComponent(e.comment)}`), e.organisation && (a = `${a}&organisation=${encodeURIComponent(e.organisation)}`), e.industryOfInterest && (a = `${a}&industryOfInterest=${encodeURIComponent(e.industryOfInterest)}`);
    const o = {
      "context-organisation": i.auth.organisations.currentOrganisation,
      "context-team": i.auth.teams.currentTeam
    }, s = await Va({
      method: "POST",
      targetUrl: a,
      token: r,
      headers: o
    });
    t(as(uD(s)));
  } catch (r) {
    Tn(r), t(as(dD(r.message))), process.env.NODE_ENV !== "test" && console.error(r);
  }
};
function e3() {
  return async (e, t) => {
    try {
      e(as(lD()));
    } catch (n) {
      Tn(n);
    }
  };
}
const fD = "SET_IS_DATA_PAGE", pD = "SET_TAG_IDS", hD = "SET_PERMISSIONS", mD = "SET_DEFAULT_AUDIENCE_VIEWS", gD = "SET_DISPLAY_SEGMENT_IDS", yD = "SET_DATA_MESSAGE";
class vD extends R.Component {
  constructor() {
    super(...arguments), et(this, "state", {
      active: !1,
      isOpen: !1
    }), et(this, "toggleActive", (t) => {
      this.setState({
        ...this.state,
        active: !this.state.active
      });
    }), et(this, "handleAnswerClick", (t) => {
      const {
        value: n
      } = this.props, r = this.props.selectedCharacteristics.characteristics.find((a) => a.answerId === t.answerId), i = {
        answerId: t.answerId,
        questionId: n.questionId,
        answerLabel: t.answerLabel,
        questionLabel: n.questionLabel
      };
      r ? this.props.removeSelectedCharacteristic(i) : this.props.addSelectedCharacteristic(i);
    }), et(this, "handleQuestionClick", (t) => {
      const {
        value: n,
        addSelectedCharacteristic: r,
        removeSelectedCharacteristic: i
      } = this.props;
      t ? n.answers.map((a) => i(a)) : n.answers.filter((a) => !this.props.selectedCharacteristics.characteristics.find((o) => o.answerId === a.answerId)).map((a) => {
        let o = {
          answerId: a.answerId,
          questionId: n.questionId,
          answerLabel: a.answerLabel,
          questionLabel: n.questionLabel
        };
        return r(o);
      });
    }), et(this, "isGroupChecked", (t) => this.props.selectedCharacteristics.characteristics.filter((n) => n.questionId === t.questionId).length === t.answers.length), et(this, "isPartiallySelected", (t) => {
      const n = this.props.selectedCharacteristics.characteristics.filter((r) => r.questionId === t.questionId);
      return n.length > 0 && n.length < t.answers.length;
    }), et(this, "handleShowHide", () => {
      this.setState({
        isOpen: !this.state.isOpen
      });
    });
  }
  //to allow collapse the questions if clear btn clicked
  componentDidUpdate() {
    this.props.shouldReset && this.state.active === !0 && this.setState({
      ...this.state,
      active: !1
    });
  }
  render() {
    const {
      value: t,
      selectedCharacteristics: n,
      hasAccess: r = !0,
      noAccessAction: i,
      categoryLabel: a
    } = this.props, {
      active: o,
      isOpen: s
    } = this.state, l = this.isGroupChecked(t), c = this.isPartiallySelected(t), d = 10, p = s ? void 0 : d, y = t.answers.length;
    return /* @__PURE__ */ m.jsx("li", { className: "characteristics-filter-question", children: /* @__PURE__ */ m.jsxs(yr, { active: o ? "true" : "false", className: "characteristics-filter__accordion", children: [
      /* @__PURE__ */ m.jsxs(yr.Title, { className: "characteristics-filter-question__title", children: [
        /* @__PURE__ */ m.jsx(dr, { className: "characteristics-filter-question__checkbox", value: t.questionId, onClick: () => r ? this.handleQuestionClick(l) : i(a), checked: l, indeterminate: c }),
        /* @__PURE__ */ m.jsxs("button", { onClick: this.toggleActive, className: "characteristics-filter__button", children: [
          /* @__PURE__ */ m.jsx("span", { className: "characteristics-filter__question-label", children: t.questionLabel }),
          /* @__PURE__ */ m.jsx($t, { className: "characteristics-filter__button-icon", name: `${o ? "minus square outline" : "plus square outline"}` })
        ] })
      ] }),
      /* @__PURE__ */ m.jsx(yr.Content, { active: o, children: /* @__PURE__ */ m.jsxs("ul", { className: "characteristics-filter__answer-list", children: [
        t && t.answers && t.answers.slice(0, p).map((f, N) => /* @__PURE__ */ m.jsx("li", { className: "characteristics-filter-answer", children: /* @__PURE__ */ m.jsx(dr, { onClick: () => r ? this.handleAnswerClick(f) : i(a), checked: !!n.characteristics.find((b) => b.answerId === f.answerId), className: "characteristics-filter-answer__checkbox", "data-canonical-name": f.answerLabel, value: f.answerId, label: f.answerLabel }) }, N)),
        y > d && /* @__PURE__ */ m.jsx("li", { className: "characteristics-filter-answer", children: /* @__PURE__ */ m.jsx("button", { className: "characteristics-filter-answer__show-more", onClick: this.handleShowHide, children: s ? /* @__PURE__ */ m.jsx(R.Fragment, { children: "Show less…" }) : /* @__PURE__ */ m.jsx(R.Fragment, { children: "Show more…" }) }) })
      ] }) })
    ] }) });
  }
}
const bD = (e, t) => ({
  selectedCharacteristics: e.selectedCharacteristics
}), wD = (e) => Kt({
  addSelectedCharacteristic: T9,
  removeSelectedCharacteristic: e1
}, e), xD = Mt(bD, wD)(vD);
class _D extends R.Component {
  constructor() {
    super(...arguments), et(this, "state", {
      active: !1
    }), et(this, "toggleActive", (t) => {
      this.setState({
        ...this.state,
        active: !this.state.active
      });
    });
  }
  componentDidUpdate(t, n) {
    this.props.shouldReset && !t.shouldReset && this.setState({
      ...this.state,
      active: !1
    });
  }
  render() {
    const {
      value: t,
      hasAccess: n,
      noAccessAction: r
    } = this.props, {
      active: i
    } = this.state;
    return /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsx("li", { className: "characteristics-filter-category", children: /* @__PURE__ */ m.jsxs(yr, { active: i ? "true" : "false", className: "characteristics-filter__accordion", children: [
        /* @__PURE__ */ m.jsx(yr.Title, { className: "characteristics-filter-category__title", children: /* @__PURE__ */ m.jsxs("button", { onClick: this.toggleActive, className: "characteristics-filter__button", children: [
          /* @__PURE__ */ m.jsx("h3", { children: t.categoryLabel }),
          /* @__PURE__ */ m.jsx($t, { className: "characteristics-filter__button-icon", name: `${i ? "minus square" : "plus square"}` })
        ] }) }),
        /* @__PURE__ */ m.jsx(yr.Content, { active: i, children: /* @__PURE__ */ m.jsx("ul", { className: "characteristics-filter-category__list", children: t && t.questions && t.questions.map((a, o) => /* @__PURE__ */ m.jsx(xD, { value: a, shouldReset: this.props.shouldReset, hasAccess: n, noAccessAction: r, categoryLabel: t.categoryLabel }, o)) }) })
      ] }) }),
      /* @__PURE__ */ m.jsx("hr", { className: "characteristics-filter-category__divider" })
    ] });
  }
}
class ND extends R.Component {
  componentDidUpdate() {
    this.props.collapseCheckboxes && this.props.dontCollapseCheckboxes();
  }
  render() {
    const {
      categories: t
    } = this.props.characteristics, {
      hasAccess: n,
      noAccessAction: r
    } = this.props;
    return /* @__PURE__ */ m.jsx("ul", { className: "characteristics-filter", children: t.map((i, a) => /* @__PURE__ */ m.jsx(_D, { value: i, shouldReset: this.props.collapseCheckboxes, hasAccess: n, noAccessAction: r }, a)) });
  }
}
const SD = (e, t) => ({
  collapseCheckboxes: e.dataPages.collapseCheckboxes
}), ED = (e) => Kt({
  dontCollapseCheckboxes: nD
}, e), t3 = Mt(SD, ED)(ND);
class CD extends R.Component {
  constructor(t) {
    super(t), et(this, "enquireAndShowThankyou", () => {
      const {
        formData: n
      } = this.state;
      n.industryOfInterest = this.props.industryOfInterest, this.props.premiumDataEnquiry(n);
    }), et(this, "handleInputChange", (n) => {
      let r = Object.assign({}, this.state.formData);
      r[n.target.name] = n.target.value, this.setState({
        formData: r
      });
    }), this.state = {
      open: !1,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        organisation: "",
        industryOfInterest: "",
        comment: ""
      }
    };
  }
  render() {
    const {
      enquiryError: t,
      enquirySent: n,
      isFetching: r,
      open: i,
      closeModal: a
    } = this.props;
    return /* @__PURE__ */ m.jsxs(Kr, { open: i, onClose: a, closeOnEscape: !0, closeOnDimmerClick: !0, centered: !1, id: "industry-data-modal", closeIcon: /* @__PURE__ */ m.jsx("button", { className: "modal__close", children: "Close" }), children: [
      /* @__PURE__ */ m.jsx(Kr.Header, { className: "industry-data-modal--header", children: "Industry Data Packs Enquiry" }),
      !n && /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsxs(Kr.Content, { className: "industry-data-modal--content", children: [
        /* @__PURE__ */ m.jsx("p", { children: "Your current subscription doesn’t include access to this data." }),
        /* @__PURE__ */ m.jsx("p", { children: "Just complete the contact form below and someone will come straight back to you with our pricing." }),
        /* @__PURE__ */ m.jsx("p", { children: " You’ll be pleasantly surprised." }),
        /* @__PURE__ */ m.jsx(Ct, { onSubmit: this.enquireAndShowThankyou.bind(this), className: "login-form__form", children: /* @__PURE__ */ m.jsxs(We, { children: [
          /* @__PURE__ */ m.jsxs(We.Row, { className: "industry-data-modal--row", children: [
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { required: !0, label: "First Name", name: "firstName", type: "text", onChange: this.handleInputChange, disabled: r }) }),
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { required: !0, label: "Last Name", name: "lastName", type: "text", onChange: this.handleInputChange, disabled: r }) })
          ] }),
          /* @__PURE__ */ m.jsxs(We.Row, { className: "industry-data-modal--row", children: [
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { required: !0, label: "Email", name: "email", type: "email", onChange: this.handleInputChange, disabled: r }) }),
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { required: !0, label: "Phone", name: "phone", type: "tel", onChange: this.handleInputChange, disabled: r }) })
          ] }),
          /* @__PURE__ */ m.jsxs(We.Row, { className: "industry-data-modal--row", children: [
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { label: "Organisation", name: "organisation", type: "text", onChange: this.handleInputChange, disabled: r }) }),
            /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx(Ct.Input, { name: "industryOfInterest", type: "hidden", onChange: this.handleInputChange, disabled: r, value: this.props.industryOfInterest }) })
          ] }),
          /* @__PURE__ */ m.jsx(We.Row, { className: "industry-data-modal--row", children: /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsx(Ct.TextArea, { className: "industry-data-modal--comment", label: "Comment", name: "comment", type: "textarea", onChange: this.handleInputChange, disabled: r, rows: 3 }) }) }),
          /* @__PURE__ */ m.jsx(We.Row, { children: /* @__PURE__ */ m.jsxs(We.Column, { width: 12, style: {
            textAlign: "right"
          }, children: [
            /* @__PURE__ */ m.jsx(Ft, { onClick: a, negative: !0, children: "No Thanks" }),
            " ",
            /* @__PURE__ */ m.jsx(Ct.Button, { as: Ft, type: "submit", children: "Enquire now" })
          ] }) })
        ] }) })
      ] }) }),
      n && /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
        !t && /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsx(Kr.Content, { children: "Thank you for contacting us, we'll be in touch shortly." }) }),
        t && /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsxs(Kr.Content, { children: [
          "Unfortunately there has been an error. Please email us directly at",
          " ",
          /* @__PURE__ */ m.jsx("a", { href: "mailto:live@roymorgan.com", children: "live@roymorgan.com" }),
          "."
        ] }) })
      ] })
    ] });
  }
}
const OD = (e, t) => ({
  enquiryError: e.contact.error,
  enquirySent: e.contact.fetched,
  isFetching: e.contact.isFetching
}), jD = (e) => Kt({
  premiumDataEnquiry: Aw,
  premiumDataEnquiryReset: e3
}, e), PD = Mt(OD, jD)(CD);
class LD extends R.Component {
  constructor(t) {
    super(t), et(this, "openModal", (n) => {
      this.setState({
        open: !0,
        industryOfInterest: n
      });
    }), et(this, "closeModal", () => {
      this.setState({
        open: !1
      }), this.props.premiumDataEnquiryReset();
    }), this.props.loadIndustryData(), this.state = {
      open: !1,
      closeOnEscape: !1,
      closeOnDimmerClick: !1,
      industryOfInterest: ""
    };
  }
  render() {
    const {
      open: t,
      closeOnEscape: n,
      closeOnDimmerClick: r
    } = this.state, {
      industryData: i
    } = this.props;
    return /* @__PURE__ */ m.jsxs("div", { className: "grouped-personas__industry-data-wrapper", children: [
      /* @__PURE__ */ m.jsx("h2", { className: "grouped-personas__sub-title", children: "Industry Data" }),
      i && i.categories && /* @__PURE__ */ m.jsx(t3, { className: "scroll-box", characteristics: i, hasAccess: !1, noAccessAction: this.openModal }),
      /* @__PURE__ */ m.jsx(PD, { closeOnEscape: n, closeOnDimmerClick: r, open: t, closeModal: this.closeModal, industryOfInterest: this.state.industryOfInterest })
    ] });
  }
}
const TD = (e, t) => ({
  enquiryError: e.contact.error,
  enquirySent: e.contact.fetched,
  isFetching: e.contact.isFetching,
  industryData: e.dataPages.industryData
}), FD = (e) => Kt({
  premiumDataEnquiry: Aw,
  premiumDataEnquiryReset: e3,
  loadIndustryData: eD
}, e), ID = Mt(TD, FD)(LD);
function sl({
  children: e
}) {
  return /* @__PURE__ */ m.jsx(Gi, { trigger: /* @__PURE__ */ m.jsx(Ft, { className: "table-header-icon__button", children: /* @__PURE__ */ m.jsx($t, { className: "table-header-icon__icon", name: "info circle" }) }), position: "top center", content: e });
}
class kD extends R.Component {
  constructor() {
    super(...arguments), et(this, "handleMeasureChange", (t, n) => {
      this.props.updateSelectedMeasure(n.value);
    });
  }
  render() {
    const {
      showMeasure: t,
      selectedMeasure: n,
      singleView: r
    } = this.props, i = [{
      key: "index",
      value: "index",
      text: "Index"
    }, {
      key: "population",
      value: "population",
      text: "Population"
    }, {
      key: "shareOfSegment",
      value: "shareOfSegment",
      text: `Share Of ${r}`
    }, {
      key: "shareOfProperty",
      value: "shareOfProperty",
      text: "Share Of Attribute"
    }];
    return /* @__PURE__ */ m.jsx("div", { children: t ? /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsxs("div", { className: "metrics-filter", children: [
        /* @__PURE__ */ m.jsxs("h3", { className: "metrics-filter__title", children: [
          "Measure",
          /* @__PURE__ */ m.jsxs(sl, { children: [
            /* @__PURE__ */ m.jsx("p", { children: "Four measures are available." }),
            /* @__PURE__ */ m.jsxs("p", { children: [
              "Index is the propensity to possess an attribute, in comparison to the complete data set, and is expressed as a value based to 100. A value of 200, therefore, would indicate a ",
              r,
              " is twice as likely as the general population to possess the attribute."
            ] }),
            /* @__PURE__ */ m.jsxs("p", { children: [
              "Share of ",
              r,
              " is the the percentage of the",
              " ",
              r,
              " that possess the attribute."
            ] }),
            /* @__PURE__ */ m.jsxs("p", { children: [
              "Share of Attribute is the percentage who belong to the",
              r,
              ", among all who possess that attribute."
            ] }),
            /* @__PURE__ */ m.jsx("p", { children: "Population is self-explanatory, although the universe may vary as appropriate for the attribute (for instance, voting or drinking would be in terms of those aged over 18)." })
          ] })
        ] }),
        /* @__PURE__ */ m.jsx(An, { name: "measureFilter", className: "metrics-filter__dropdown", value: n || "index", selection: !0, options: i, onChange: this.handleMeasureChange })
      ] }),
      /* @__PURE__ */ m.jsx("hr", { className: "metrics-filter__divider" })
    ] }) : "" });
  }
}
const DD = (e, t) => ({
  pluralView: e.audienceView.view.textPlural,
  singleView: e.audienceView.view.textSingular
}), RD = Mt(DD, void 0)(kD);
class f1 extends R.Component {
  // establish type of sidebar reference
  constructor(t) {
    super(t), et(this, "handleScroll", (n) => {
      const r = this.sidebarRef.current.offsetTop;
      this.sidebarRef.current.setAttribute("data-debug-current-offset", r), r > 78 ? this.sidebarRef.current.setAttribute("style", "max-height:calc(100vh - 75px);") : this.sidebarRef.current.setAttribute("style", "max-height:calc(100vh - 155px);");
    }), this.sidebarRef = R.createRef(), this.state = {
      sidebarHeight: ""
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  render() {
    const {
      open: t,
      title: n,
      body: r
    } = this.props;
    return /* @__PURE__ */ m.jsx("div", { className: `grouped-personas__sidebar ${t ? "grouped-personas__sidebar--active" : ""}`, children: /* @__PURE__ */ m.jsxs(
      "div",
      {
        ref: this.sidebarRef,
        style: {
          maxHeight: this.state.sidebarHeight
        },
        className: `grouped-personas__sidebar-inner ${t ? "grouped-personas__sidebar-inner--active" : ""}`,
        children: [
          /* @__PURE__ */ m.jsx("div", { className: "grouped-personas__icon-container", children: n }),
          /* @__PURE__ */ m.jsx("div", { className: `grouped-personas__sidebar-content ${t ? "grouped-personas__sidebar-content--active" : ""} `, children: r })
        ]
      }
    ) });
  }
}
function MD() {
  const e = tp(), t = async () => {
    const n = await e(W9());
    if (n instanceof Error)
      return;
    let r = document.createElement("a");
    r.href = n, r.click();
  };
  return /* @__PURE__ */ m.jsxs("p", { children: [
    "If you wish to analyse this data further, you can",
    " ",
    /* @__PURE__ */ m.jsx("button", { className: "button--data-download", onClick: t, children: "download the complete set of metrics" }),
    " ",
    "available to this report, for the selected data set."
  ] });
}
const UD = (e) => oa((t) => t.featureAccess.byId && t.featureAccess.byId[e] && t.featureAccess.byId[e].hasAccess);
function n3({
  showDownload: e
}) {
  const t = oa((o) => o.options.isDataPage.value), n = oa((o) => o.options.dataMessage.value), r = oa((o) => o.options.permissions.dataDownload), i = UD(r), a = {
    __html: n
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "fine-print", children: [
    /* @__PURE__ */ m.jsx("div", { dangerouslySetInnerHTML: a }),
    t && i && e && /* @__PURE__ */ m.jsx(MD, {})
  ] });
}
function r3({
  resetMethod: e
}) {
  return /* @__PURE__ */ m.jsx(Ft, { className: "grouped-personas__sub-clearbtn", onClick: e, children: "Reset" });
}
let BD = class extends R.Component {
  constructor() {
    super(...arguments), et(this, "state", {
      communityColours: {},
      showSidebar: !1,
      showMeasure: !0
    }), et(this, "handleHideUnselectedPersonas", () => {
      this.props.toggleSegmentSelectionVisibility(!this.props.hideUnselectedPersonas);
    }), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "clearForm", () => {
      this.props.resetDataPage(), this.props.toggleSegmentSelectionVisibility(!1);
    }), et(this, "handleMeasureSideBarTabChange", (e, t) => {
      this.setState({
        ...this.state,
        showMeasure: t.activeIndex === 0
        // individual persona tab is on index 1
      });
    }), et(this, "handleSelectPersona", (e, t) => {
      const n = {
        id: parseInt(e),
        name: t
      };
      this.props.findPersonasSelected.length ? this.props.findPersonasSelected.filter((r) => r.id === e).length ? this.props.removeSelectedPersona(n) : this.props.addSelectedPersona(n) : this.props.addSelectedPersona(n);
    });
  }
  async componentDidMount() {
    const {
      isDataPage: e,
      loadSuperSegments: t,
      loadCharacteristics: n,
      featureAccess: r,
      resetDataPage: i
    } = this.props;
    e && i();
    const a = await t();
    this.setState({
      communityColours: p9(a)
    }), n(), r();
  }
  render() {
    const {
      characteristics: e,
      isDataPage: t,
      hasAccess: n,
      selectedMeasure: r,
      updateSelectedMeasure: i,
      hideUnselectedPersonas: a
    } = this.props, {
      showSidebar: o,
      communityColours: s
    } = this.state, l = {
      hideUnselectedPersonas: a,
      handleHideUnselectedPersonas: this.handleHideUnselectedPersonas,
      communityColours: s,
      handleSelectPersona: this.handleSelectPersona,
      isDataPage: t
    }, c = [{
      menuItem: "Individual Attributes",
      render: () => /* @__PURE__ */ m.jsx(j0, { ...l })
    }, {
      menuItem: "Combined Attributes",
      render: () => /* @__PURE__ */ m.jsx(SV, { ...l })
    }], d = () => /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsx($t, { className: "grouped-personas__icon", name: "bars", size: "large", onClick: this.toggleSidebar }),
      /* @__PURE__ */ m.jsx("h2", { className: "grouped-personas__sub-title", children: "Selection" }),
      t && /* @__PURE__ */ m.jsx(r3, { resetMethod: this.clearForm })
    ] });
    return /* @__PURE__ */ m.jsx("div", { children: n ? /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsxs("div", { className: "campaign-creator-page", children: [
      /* @__PURE__ */ m.jsxs("div", { className: "grouped-personas__row", children: [
        /* @__PURE__ */ m.jsx(f1, { open: o, title: /* @__PURE__ */ m.jsx(d, {}), body: /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
          /* @__PURE__ */ m.jsx(RD, { showMeasure: this.state.showMeasure, selectedMeasure: r, updateSelectedMeasure: i }),
          /* @__PURE__ */ m.jsxs("div", { className: "characteristics-filter--wrapper", children: [
            /* @__PURE__ */ m.jsx(t3, { className: "scroll-box", characteristics: e }),
            process.env.REACT_APP_DATA_ENDPOINT === "premium" && /* @__PURE__ */ m.jsx(ID, {})
          ] })
        ] }) }),
        /* @__PURE__ */ m.jsx("div", { className: "grouped-personas__table", children: t ? /* @__PURE__ */ m.jsx(j0, { ...l }) : /* @__PURE__ */ m.jsx(Bo, { className: "tabs tabs--short", onTabChange: this.handleMeasureSideBarTabChange, panes: c }) })
      ] }),
      /* @__PURE__ */ m.jsx("div", { className: "grouped-personas__row", children: /* @__PURE__ */ m.jsx(n3, { showDownload: !0 }) })
    ] }) }) : "" });
  }
};
var zD = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const i = {};
      e(i) === i && (r = !0);
    } catch {
    }
    if (r) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, qD = (e, t, n) => {
  const { memoize: r, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: o } = e, s = r(() => ({}), ...i);
  if (s.apply(null, a) !== s.apply(null, o)) {
    let l;
    try {
      throw new Error();
    } catch (c) {
      ({ stack: l } = c);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: a,
        secondInputs: o,
        stack: l
      }
    );
  }
}, VD = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function WD(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function HD(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function $D(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var my = (e) => Array.isArray(e) ? e : [e];
function GD(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return $D(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function gy(e, t) {
  const n = [], { length: r } = e;
  for (let i = 0; i < r; i++)
    n.push(e[i].apply(null, t));
  return n;
}
var QD = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...VD,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: zD
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: qD
    }
  };
}, YD = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, KD = typeof WeakRef < "u" ? WeakRef : YD, XD = 0, yy = 1;
function qd() {
  return {
    s: XD,
    v: void 0,
    o: null,
    p: null
  };
}
function i3(e, t = {}) {
  let n = qd();
  const { resultEqualityCheck: r } = t;
  let i, a = 0;
  function o() {
    var s;
    let l = n;
    const { length: c } = arguments;
    for (let y = 0, f = c; y < f; y++) {
      const N = arguments[y];
      if (typeof N == "function" || typeof N == "object" && N !== null) {
        let b = l.o;
        b === null && (l.o = b = /* @__PURE__ */ new WeakMap());
        const S = b.get(N);
        S === void 0 ? (l = qd(), b.set(N, l)) : l = S;
      } else {
        let b = l.p;
        b === null && (l.p = b = /* @__PURE__ */ new Map());
        const S = b.get(N);
        S === void 0 ? (l = qd(), b.set(N, l)) : l = S;
      }
    }
    const d = l;
    let p;
    if (l.s === yy)
      p = l.v;
    else if (p = e.apply(null, arguments), a++, r) {
      const y = ((s = i == null ? void 0 : i.deref) == null ? void 0 : s.call(i)) ?? i;
      y != null && r(y, p) && (p = y, a !== 0 && a--), i = typeof p == "object" && p !== null || typeof p == "function" ? new KD(p) : p;
    }
    return d.s = yy, d.v = p, p;
  }
  return o.clearCache = () => {
    n = qd(), o.resetResultsCount();
  }, o.resultsCount = () => a, o.resetResultsCount = () => {
    a = 0;
  }, o;
}
function ZD(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...i) => {
    let a = 0, o = 0, s, l = {}, c = i.pop();
    typeof c == "object" && (l = c, c = i.pop()), WD(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const d = {
      ...n,
      ...l
    }, {
      memoize: p,
      memoizeOptions: y = [],
      argsMemoize: f = i3,
      argsMemoizeOptions: N = [],
      devModeChecks: b = {}
    } = d, S = my(y), _ = my(N), E = GD(i), k = p(function() {
      return a++, c.apply(
        null,
        arguments
      );
    }, ...S);
    let M = !0;
    const F = f(function() {
      o++;
      const q = gy(
        E,
        arguments
      );
      if (s = k.apply(null, q), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: j, inputStabilityCheck: x } = QD(M, b);
        if (j.shouldRun && j.run(
          c,
          q,
          s
        ), x.shouldRun) {
          const C = gy(
            E,
            arguments
          );
          x.run(
            { inputSelectorResults: q, inputSelectorResultsCopy: C },
            { memoize: p, memoizeOptions: S },
            arguments
          );
        }
        M && (M = !1);
      }
      return s;
    }, ..._);
    return Object.assign(F, {
      resultFunc: c,
      memoizedResultFunc: k,
      dependencies: E,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => s,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: p,
      argsMemoize: f
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var fi = /* @__PURE__ */ ZD(i3), JD = Object.assign(
  (e, t = fi) => {
    HD(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((a, o, s) => (a[n[s]] = o, a), {})
    );
  },
  { withTypes: () => JD }
);
const AD = {
  isFetching: !1,
  categories: []
}, eR = (e = AD, t) => {
  switch (t.type) {
    case $4:
      return {
        ...e,
        isFetching: !0
      };
    case Q4:
      return {
        ...e,
        isFetching: !1
      };
    case G4:
      return {
        ...e,
        isFetching: !1,
        categories: t.payload
      };
    default:
      return e;
  }
}, tR = fi((e) => e.characteristics, (e) => {
  let t = e;
  return t.categories.forEach((n, r) => {
    let i = [];
    n.questions.forEach((a, o) => {
      if (typeof i[a.questionLabel] > "u") {
        let s = {
          questionId: a.questionId,
          questionLabel: a.questionLabel,
          answers: []
        };
        i[a.questionLabel] = s, i[a.questionLabel].answers.push(...a.answers);
      } else
        i[a.questionLabel].answers.push(...a.answers);
    }), n.questions = Object.values(i);
  }), t;
}), nR = (e, t) => {
  let {
    workflowPermission: n
  } = e.options.permissions;
  return {
    characteristics: tR(e),
    selectedCharacteristics: e.selectedCharacteristics,
    findPersonasSelected: e.findPersonasSelected.records,
    selectedMeasure: e.selectedMeasure.measure,
    hideUnselectedPersonas: e.selectedPersonas.isHidden,
    hasAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess,
    isDataPage: e.options.isDataPage.value
  };
}, rR = (e) => Kt({
  loadCharacteristics: E9,
  loadSuperSegments: zo,
  addSelectedPersona: zu,
  removeSelectedPersona: Es,
  toggleSegmentSelectionVisibility: iD,
  featureAccess: ui,
  updateSelectedMeasure: k9,
  resetDataPage: Hw
}, e);
Mt(nR, rR)(BD);
let iR = class extends R.PureComponent {
  constructor() {
    super(...arguments), et(this, "handlePersonaClick", async (e) => {
      this.props.selectedPersonas.find((t) => t.id === e.id) ? await this.props.removeSelectedPersona(e) : await this.props.addSelectedPersona(e), this.props.handleCheckBoxAction();
    });
  }
  render() {
    const {
      superSegment: e,
      key: t,
      selectedPersonas: n,
      displaySegmentIds: r
    } = this.props;
    return /* @__PURE__ */ m.jsx("li", { style: {
      backgroundColor: e.color
    }, className: "persona-list-community__title-checkbox", children: /* @__PURE__ */ m.jsx(dr, { onClick: () => this.handlePersonaClick({
      id: parseInt(e.id),
      name: e.label
    }), checked: !!n.find((i) => parseInt(i.id) === parseInt(e.id)), className: "persona-list-community__persona-checkbox", "data-canonical-name": `${e.id} ${e.label}`, label: `${r ? e.id : ""} ${e.label}` }) }, t);
  }
};
const aR = (e, t) => ({
  selectedPersonas: e.selectedPersonas.personas,
  displaySegmentIds: e.options.displaySegmentIds.value
}), oR = (e) => Kt({
  addSelectedPersona: zu,
  removeSelectedPersona: Es
}, e), sR = Mt(aR, oR)(iR);
let lR = class extends R.PureComponent {
  constructor() {
    super(...arguments), et(this, "state", {
      active: !1
    }), et(this, "handleClick", (e) => {
      this.setState({
        ...this.state,
        active: !this.state.active
      });
    }), et(this, "handlePersonaClick", async (e) => {
      this.props.selectedPersonas.find((t) => t.id === e.id) ? await this.props.removeSelectedPersona(e) : await this.props.addSelectedPersona(e), this.props.handleCheckBoxAction();
    });
  }
  render() {
    const {
      superSegment: e,
      expanded: t,
      selectedPersonas: n
    } = this.props, {
      active: r
    } = this.state;
    return /* @__PURE__ */ m.jsx("li", { className: "persona-list-community", children: /* @__PURE__ */ m.jsxs(yr, { active: r ? "true" : "false", className: "persona-list-community__accordion", children: [
      /* @__PURE__ */ m.jsx(yr.Title, { style: {
        backgroundColor: e.color
      }, className: "persona-list-community__title", children: /* @__PURE__ */ m.jsxs("button", { onClick: this.handleClick, className: "persona-list-community__button", children: [
        /* @__PURE__ */ m.jsxs("span", { children: [
          e.id,
          " ",
          t ? e.label : ""
        ] }),
        /* @__PURE__ */ m.jsx($t, { name: "dropdown", className: `persona-list-community__icon ${r ? "persona-list-community__icon--rotated" : ""}` })
      ] }) }),
      /* @__PURE__ */ m.jsx(yr.Content, { active: r, children: /* @__PURE__ */ m.jsx("ul", { children: e && e.segments && e.segments.map((i, a) => /* @__PURE__ */ m.jsx("li", { style: {
        backgroundColor: i.color
      }, className: "persona-list-community__persona", children: /* @__PURE__ */ m.jsx(dr, { onClick: () => {
        this.handlePersonaClick({
          id: parseInt(i.id),
          name: i.label
        });
      }, checked: n.find((o) => parseInt(o.id) === parseInt(i.id)), className: "persona-list-community__persona-checkbox", "data-canonical-name": i.id + " " + i.label, label: {
        children: `${i.id} ${t ? i.label : ""}`
      } }) }, a)) }) })
    ] }) });
  }
};
const cR = (e, t) => ({
  selectedPersonas: e.selectedPersonas.personas
}), uR = (e) => Kt({
  addSelectedPersona: zu,
  removeSelectedPersona: Es,
  loadGroupedPersona: Ss
}, e), dR = Mt(cR, uR)(lR);
class fR extends R.Component {
  constructor() {
    super(...arguments), et(this, "renderPersonaList", (t, n) => {
      const {
        handleCheckBoxAction: r,
        expanded: i,
        isDataPage: a,
        audienceView: o,
        fixedAudienceView: s
      } = this.props;
      let l;
      return s === "communities" ? l = !0 : s === "personas" ? l = !1 : a && o === "communities" ? l = !0 : l = !1, l ? /* @__PURE__ */ m.jsx(sR, { superSegment: t, handleCheckBoxAction: r }, n) : /* @__PURE__ */ m.jsx(dR, { expanded: i, superSegment: t, handleCheckBoxAction: r }, n);
    });
  }
  render() {
    const {
      superSegments: t
    } = this.props;
    return /* @__PURE__ */ m.jsx("ul", { className: "persona-list", children: t && Object.values(t).map(this.renderPersonaList) });
  }
}
const pR = (e, t) => ({
  superSegments: e.superSegments.bySlug,
  // TODO: Finish off changing to superSegments
  audienceView: e.audienceView.view.value,
  isDataPage: e.options.isDataPage.value
}), a3 = Mt(pR, void 0)(fR);
function hR(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var o3 = hR, mR = typeof xn == "object" && xn && xn.Object === Object && xn, gR = mR, yR = gR, vR = typeof self == "object" && self && self.Object === Object && self, bR = yR || vR || Function("return this")(), s3 = bR, wR = s3, xR = function() {
  return wR.Date.now();
}, _R = xR, NR = /\s/;
function SR(e) {
  for (var t = e.length; t-- && NR.test(e.charAt(t)); )
    ;
  return t;
}
var ER = SR, CR = ER, OR = /^\s+/;
function jR(e) {
  return e && e.slice(0, CR(e) + 1).replace(OR, "");
}
var PR = jR, LR = s3, TR = LR.Symbol, l3 = TR, vy = l3, c3 = Object.prototype, FR = c3.hasOwnProperty, IR = c3.toString, xc = vy ? vy.toStringTag : void 0;
function kR(e) {
  var t = FR.call(e, xc), n = e[xc];
  try {
    e[xc] = void 0;
    var r = !0;
  } catch {
  }
  var i = IR.call(e);
  return r && (t ? e[xc] = n : delete e[xc]), i;
}
var DR = kR, RR = Object.prototype, MR = RR.toString;
function UR(e) {
  return MR.call(e);
}
var BR = UR, by = l3, zR = DR, qR = BR, VR = "[object Null]", WR = "[object Undefined]", wy = by ? by.toStringTag : void 0;
function HR(e) {
  return e == null ? e === void 0 ? WR : VR : wy && wy in Object(e) ? zR(e) : qR(e);
}
var $R = HR;
function GR(e) {
  return e != null && typeof e == "object";
}
var QR = GR, YR = $R, KR = QR, XR = "[object Symbol]";
function ZR(e) {
  return typeof e == "symbol" || KR(e) && YR(e) == XR;
}
var JR = ZR, AR = PR, xy = o3, eM = JR, _y = NaN, tM = /^[-+]0x[0-9a-f]+$/i, nM = /^0b[01]+$/i, rM = /^0o[0-7]+$/i, iM = parseInt;
function aM(e) {
  if (typeof e == "number")
    return e;
  if (eM(e))
    return _y;
  if (xy(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = xy(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = AR(e);
  var n = nM.test(e);
  return n || rM.test(e) ? iM(e.slice(2), n ? 2 : 8) : tM.test(e) ? _y : +e;
}
var oM = aM, sM = o3, Fh = _R, Ny = oM, lM = "Expected a function", cM = Math.max, uM = Math.min;
function dM(e, t, n) {
  var r, i, a, o, s, l, c = 0, d = !1, p = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(lM);
  t = Ny(t) || 0, sM(n) && (d = !!n.leading, p = "maxWait" in n, a = p ? cM(Ny(n.maxWait) || 0, t) : a, y = "trailing" in n ? !!n.trailing : y);
  function f(q) {
    var j = r, x = i;
    return r = i = void 0, c = q, o = e.apply(x, j), o;
  }
  function N(q) {
    return c = q, s = setTimeout(_, t), d ? f(q) : o;
  }
  function b(q) {
    var j = q - l, x = q - c, C = t - j;
    return p ? uM(C, a - x) : C;
  }
  function S(q) {
    var j = q - l, x = q - c;
    return l === void 0 || j >= t || j < 0 || p && x >= a;
  }
  function _() {
    var q = Fh();
    if (S(q))
      return E(q);
    s = setTimeout(_, b(q));
  }
  function E(q) {
    return s = void 0, y && r ? f(q) : (r = i = void 0, o);
  }
  function k() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = i = s = void 0;
  }
  function M() {
    return s === void 0 ? o : E(Fh());
  }
  function F() {
    var q = Fh(), j = S(q);
    if (r = arguments, i = this, l = q, j) {
      if (s === void 0)
        return N(l);
      if (p)
        return clearTimeout(s), s = setTimeout(_, t), f(l);
    }
    return s === void 0 && (s = setTimeout(_, t)), o;
  }
  return F.cancel = k, F.flush = M, F;
}
var fM = dM;
const pM = /* @__PURE__ */ ha(fM);
class Vd extends R.Component {
  constructor(t) {
    super(t), et(this, "handleChange", (n) => {
      const r = parseInt(n.target.value);
      this.setState({
        value: r
      }, () => {
        this.changed(r);
      });
    }), this.state = {
      value: 0
    }, this.changed = pM(this.props.onUpdate, 250);
  }
  componentDidMount() {
    this.setState({
      value: this.props.defaultValue
    });
  }
  componentDidUpdate(t, n) {
    this.props.defaultValue !== t.defaultValue && this.setState({
      value: this.props.defaultValue
    });
  }
  render() {
    const {
      min: t,
      max: n,
      unit: r,
      title: i,
      valueFormatter: a
    } = this.props, o = Math.ceil(n), {
      value: s
    } = this.state, l = {
      width: s / o * 100 + "%"
    };
    return /* @__PURE__ */ m.jsxs("div", { className: "slider", children: [
      i,
      /* @__PURE__ */ m.jsxs("div", { className: "slider__wrapper", children: [
        /* @__PURE__ */ m.jsx("div", { className: "slider__bar" }),
        /* @__PURE__ */ m.jsx("div", { className: "slider__progress-bar", style: l }),
        /* @__PURE__ */ m.jsx("input", { className: "slider__input", type: "range", onChange: this.handleChange, min: t, max: o, step: 1, value: s })
      ] }),
      /* @__PURE__ */ m.jsxs("label", { className: "slider__label", children: [
        a ? a(s) : s,
        r
      ] })
    ] });
  }
}
const hM = (e) => {
  const {
    loading: t,
    values: n,
    onUpdate: r,
    defaultThemes: i
  } = e, [a, o] = oi(!1), [s, l] = oi([]), c = gr(null);
  gn(() => {
    l(i);
  }, [i]), gn(() => {
    r(s);
  }, [s, r]), gn(() => {
    const f = (N) => {
      c.current && !c.current.contains(N.target) && o(!1);
    };
    return document.addEventListener("mousedown", f), () => {
      document.removeEventListener("mousedown", f);
    };
  }, []);
  const d = (f) => {
    Object.entries(s).filter((N, b) => N[1].categoryId === f.categoryId).length > 0 ? l(s.filter((N) => N.categoryId !== f.categoryId)) : l([...s, f]);
  }, p = () => {
    o(!a);
  };
  let y = "";
  return s.length === 1 ? y = `Showing ${s[0].categoryLabel}` : n.length === s.length || s.length === 0 ? y = "Showing all themes" : y = `Showing ${s.length} themes`, t && !n ? /* @__PURE__ */ m.jsx(ga, {}) : /* @__PURE__ */ m.jsxs("div", { className: "select", ref: c, children: [
    /* @__PURE__ */ m.jsxs("button", { className: `select__header ${a ? "open" : ""}`, onClick: p, "data-testid": "select-header", children: [
      y,
      /* @__PURE__ */ m.jsx($t, { name: "dropdown" })
    ] }),
    /* @__PURE__ */ m.jsx("ul", { className: `select__list ${a ? "open" : ""}`, children: n && n.map((f, N) => {
      const b = s.filter((S) => S.categoryId === f.categoryId).length > 0;
      return /* @__PURE__ */ m.jsx("li", { className: "select__list-item", children: /* @__PURE__ */ m.jsx(dr, { className: `select__button ${b ? "selected" : ""}`, checked: b, onClick: () => d(f), label: f.categoryLabel }) }, N);
    }) })
  ] });
};
class mM extends R.Component {
  componentDidMount() {
    if (this.props.groupedPersonaRecords && Object.keys(this.props.groupedPersonaRecords).length) {
      const {
        groupedPersonaRecords: t,
        filters: n
      } = this.props;
      let r = Qr(t, "population");
      n.population > r && this.props.setPopulation(r);
      let i = Qr(t, "index");
      n.index > i && this.props.setIndex(Math.floor(i));
      let a = Qr(t, "shareOfAudience");
      n.shareOfAudience > a && this.props.setShareOfAudience(Math.floor(a));
      let o = Qr(t, "shareOfProperty");
      n.shareOfAttribute > o && this.props.setShareOfAttribute(Math.floor(o));
    }
  }
  componentDidUpdate(t) {
    if (this.props.groupedPersonaRecords && Object.keys(this.props.groupedPersonaRecords).length) {
      const {
        groupedPersonaRecords: n,
        filters: r
      } = this.props;
      let i = Qr(n, "population");
      r.population > i && this.props.setPopulation(i);
      let a = Qr(n, "index");
      r.index > a && this.props.setIndex(Math.floor(a));
      let o = Qr(n, "shareOfAudience");
      r.shareOfAudience > o && this.props.setShareOfAudience(Math.floor(o));
      let s = Qr(n, "shareOfProperty");
      r.shareOfAttribute > s && this.props.setShareOfAttribute(Math.floor(s));
    }
  }
  render() {
    const {
      groupedPersonaRecords: t,
      themeReset: n,
      isFetchingCategories: r,
      theme: i,
      filters: a,
      categories: o,
      setTheme: s,
      setShareOfAudience: l,
      setShareOfAttribute: c,
      setIndex: d,
      setPopulation: p
    } = this.props, {
      shareOfAudience: y,
      shareOfAttribute: f,
      index: N,
      population: b,
      resetShareOfAudience: S,
      resetShareOfAttribute: _,
      resetIndex: E,
      resetPopulation: k
    } = a;
    let M = 100, F = 100, q = 100, j = 100;
    return t && t[0] && (M = Qr(t, "shareOfProperty"), F = Qr(t, "shareOfAudience"), q = Qr(t, "index"), j = Qr(t, "population")), /* @__PURE__ */ m.jsxs("div", { className: "persona-filters", children: [
      /* @__PURE__ */ m.jsx(hM, { reset: n, selectMessage: "Select Theme", loading: r, values: o, onUpdate: s, defaultThemes: i }),
      /* @__PURE__ */ m.jsx(Vd, { title: "Population (greater than)", min: 0, max: j, reset: k, valueFormatter: np, onUpdate: p, defaultValue: b }),
      /* @__PURE__ */ m.jsx(Vd, { title: "Share of Audience (greater than)", min: 0, max: F, unit: "%", reset: S, onUpdate: l, defaultValue: y }),
      /* @__PURE__ */ m.jsx(Vd, { title: "Share of Attribute (greater than)", min: 0, max: M, unit: "%", reset: _, onUpdate: c, defaultValue: f }),
      /* @__PURE__ */ m.jsx(Vd, { title: "Index (greater than)", min: 0, max: q, reset: E, onUpdate: d, defaultValue: N })
    ] });
  }
}
class gM extends gt.Component {
  render() {
    const {
      themesFor: t
    } = this.props;
    let n, r, i, a, o, s;
    return t === "media" ? (n = this.props.mediaCategories, r = this.props.setMediaTheme, i = this.props.setMediaShareOfAudience, a = this.props.setMediaShareOfAttribute, o = this.props.setMediaIndex, s = this.props.setMediaPopulation) : (n = this.props.categories, r = this.props.setTheme, i = this.props.setShareOfAudience, a = this.props.setShareOfAttribute, o = this.props.setIndex, s = this.props.setPopulation), /* @__PURE__ */ m.jsx(mM, { ...this.props, categories: n, setTheme: r, setShareOfAudience: i, setShareOfAttribute: a, setIndex: o, setPopulation: s });
  }
}
const yM = (e, t) => ({
  themeReset: e.themeFilter.reset,
  isFetchingCategories: e.categories.isFetching,
  categories: e.categories.categories,
  mediaCategories: e.categories.mediaCategories
}), vM = (e) => Kt({
  setShareOfAttribute: ak,
  setMediaShareOfAttribute: gk,
  setShareOfAudience: yw,
  setMediaShareOfAudience: jw,
  setIndex: ik,
  setMediaIndex: hk,
  setPopulation: sk,
  setMediaPopulation: mk,
  setTheme: ok,
  setMediaTheme: yk
}, e), bM = Mt(yM, vM)(gM), es = (e) => /* @__PURE__ */ m.jsxs(Mr, { children: [
  e.title,
  /* @__PURE__ */ m.jsx($t, { name: "delete", onClick: e.handleClick })
] });
function u3({
  children: e
}) {
  const [t, n] = oi(!1), [r, i] = oi(!1), a = rf();
  gn(
    () => {
      a.current.clientHeight > 29 ? i(!0) : (i(!1), n(!1));
    },
    [a]
    // Only listen to changes to tagListInnerRef
  );
  const o = t === !0 ? "up" : "down";
  return /* @__PURE__ */ m.jsxs("div", { className: "tag-list", children: [
    /* @__PURE__ */ m.jsx("div", { className: `tag-list__overflow ${t ? "open" : ""}`, children: /* @__PURE__ */ m.jsx("div", { className: "tag-list__inner", ref: a, children: e }) }),
    r && /* @__PURE__ */ m.jsx("div", { className: "tag-list__button-container", children: /* @__PURE__ */ m.jsxs("button", { className: "tag-list__button", onClick: () => n(!t), children: [
      /* @__PURE__ */ m.jsx($t, { link: !0, name: `caret ${o}`, size: "large" }),
      t ? "Show Less" : "Show More"
    ] }) })
  ] });
}
class wM extends R.Component {
  constructor() {
    super(...arguments), et(this, "handlePersonaClick", async (t) => {
      await this.props.removeSelectedPersona(t), await this.props.loadGroupedPersona();
    });
  }
  render() {
    const {
      selectedPersonas: t,
      theme: n,
      filters: r,
      isDataPage: i = !1,
      resetTheme: a,
      resetShareOfAttribute: o,
      resetShareOfAudience: s,
      resetIndex: l,
      resetPopulation: c,
      displaySegmentIds: d
    } = this.props, {
      shareOfAttribute: p,
      shareOfAudience: y,
      index: f,
      population: N
    } = r;
    return /* @__PURE__ */ m.jsxs(u3, { children: [
      t && t.map((b, S) => /* @__PURE__ */ m.jsx(es, { handleClick: () => this.handlePersonaClick(b), title: `${b.name} ${d ? b.id : ""}` }, S)),
      !i && p > 0 && /* @__PURE__ */ m.jsx(es, { handleClick: () => o(), title: `Share of Attribute: ${p}%` }),
      !i && y > 0 && /* @__PURE__ */ m.jsx(es, { handleClick: () => s(), title: `Share of Audience: ${y}%` }),
      !i && f > 0 && /* @__PURE__ */ m.jsx(es, { handleClick: () => l(), title: `Index: ${f}` }),
      !i && N > 0 && /* @__PURE__ */ m.jsx(es, { handleClick: () => c(), title: `Population: ${np(N)}` }),
      !i && n.length > 0 && n.map((b) => /* @__PURE__ */ m.jsx(es, { handleClick: () => a(b.categoryId), title: `Theme: ${b.categoryLabel}` }, b.categoryId))
    ] });
  }
}
const xM = (e, t) => ({
  displaySegmentIds: e.options.displaySegmentIds.value
}), _M = Mt(xM, null)(wM);
class NM extends R.Component {
  render() {
    const {
      themesFor: t = "profiling"
    } = this.props;
    let n, r, i, a, o;
    return t === "media" ? (n = this.props.resetMediaTheme, r = this.props.resetMediaShareOfAttribute, i = this.props.resetMediaShareOfAudience, a = this.props.resetMediaIndex, o = this.props.resetMediaPopulation) : (n = this.props.resetTheme, r = this.props.resetShareOfAttribute, i = this.props.resetShareOfAudience, a = this.props.resetIndex, o = this.props.resetPopulation), /* @__PURE__ */ m.jsx(_M, { ...this.props, resetTheme: n, resetShareOfAttribute: r, resetShareOfAudience: i, resetIndex: a, resetPopulation: o });
  }
}
const SM = (e, t) => ({
  selectedPersonas: e.selectedPersonas.personas,
  findPersonasSelected: e.findPersonasSelected.selectedPersonas,
  isDataPage: e.options.isDataPage.value
}), EM = (e) => Kt({
  removeSelectedPersona: Es,
  loadGroupedPersona: Ss,
  resetShareOfAttribute: tk,
  resetMediaShareOfAttribute: dk,
  resetShareOfAudience: nk,
  resetMediaShareOfAudience: fk,
  resetIndex: ek,
  resetMediaIndex: ck,
  resetPopulation: lk,
  resetMediaPopulation: uk,
  resetTheme: rk,
  resetMediaTheme: pk
}, e), p1 = Mt(SM, EM)(NM), CM = {
  isFetching: !1,
  bySlug: {},
  order: []
}, OM = (e = CM, t) => {
  switch (t.type) {
    case Uw:
      return {
        ...e,
        isFetching: !0,
        accessInfo: {}
      };
    case zw:
      return {
        ...e,
        isFetching: !1,
        accessInfo: t.accessInfo && t.accessInfo.content
      };
    case Bw:
      return {
        ...e,
        ...t.payload,
        isFetching: !1,
        accessInfo: t.accessInfo && t.accessInfo.content
      };
    default:
      return e;
  }
}, jM = fi((e) => e.superSegments.bySlug, (e) => e && Object.keys(e).sort(function(t, n) {
  return e[t].label === void 0 || e[n].label === void 0 ? 0 : e[t].label.toLowerCase() < e[n].label.toLowerCase() ? -1 : e[t].label.toLowerCase() > e[n].label.toLowerCase() ? 1 : 0;
}).map(function(t) {
  return e[t];
})), Ml = fi((e) => jM(e), (e) => e.map((t) => t.featuredImage.sizes.medium));
var PM = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [r, i] = n.split(/ ?: ?/).map((a, o) => o === 0 ? a.replace(/\s+/g, "") : a.trim());
  if (r && i) {
    const a = r.replace(/(\w)-(\w)/g, (s, l, c) => `${l}${c.toUpperCase()}`);
    let o = i.trim();
    Number.isNaN(Number(i)) || (o = Number(i)), t[r.startsWith("-") ? r : a] = o;
  }
  return t;
}, {});
function LM(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var TM = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], Sy = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function FM(e, t) {
  var n;
  const { key: r, level: i, ...a } = t;
  switch (e.nodeType) {
    case 1:
      return R.createElement(
        kM(e.nodeName),
        IM(e, r),
        Ey(e.childNodes, i, a)
      );
    case 3: {
      const o = ((n = e.nodeValue) == null ? void 0 : n.toString()) ?? "";
      if (!a.allowWhiteSpaces && /^\s+$/.test(o) && !/[\u00A0\u202F]/.test(o))
        return null;
      if (!e.parentNode)
        return o;
      const s = e.parentNode.nodeName.toLowerCase();
      return TM.includes(s) ? (/\S/.test(o) && console.warn(
        `A textNode is not allowed inside '${s}'. Your text "${o}" will be ignored`
      ), null) : o;
    }
    case 8:
      return null;
    case 11:
      return Ey(e.childNodes, i, t);
    default:
      return null;
  }
}
function IM(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const r = e.getAttribute("class");
    r && (n.className = r), [...e.attributes].forEach((i) => {
      switch (i.name) {
        case "class":
          break;
        case "style":
          n[i.name] = PM(i.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[Sy[i.name] || i.name] = !0;
          break;
        default:
          n[Sy[i.name] || i.name] = i.value;
      }
    });
  }
  return n;
}
function Ey(e, t, n) {
  const r = [...e].map(
    (i, a) => Of(i, {
      ...n,
      index: a,
      level: t + 1
    })
  ).filter(Boolean);
  return r.length ? r : null;
}
function kM(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function d3(e, t = {}) {
  return typeof e == "string" ? DM(e, t) : e instanceof Node ? Of(e, t) : null;
}
function Of(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: r = 0, level: i = 0, randomKey: a } = t;
  let o = e, s = `${i}-${r}`;
  const l = [];
  return a && i === 0 && (s = `${LM()}-${s}`), Array.isArray(n) && n.forEach((c) => {
    c.condition(o, s, i) && (typeof c.pre == "function" && (o = c.pre(o, s, i), o instanceof Node || (o = e, process.env.NODE_ENV !== "production" && console.warn(
      "The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)"
    ))), typeof c.post == "function" && l.push(c.post(o, s, i)));
  }), l.length ? l : FM(o, { key: s, level: i, ...t });
}
function DM(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: r = !1,
    selector: i = "body > *",
    type: a = "text/html"
  } = t;
  try {
    const o = new DOMParser().parseFromString(e, a);
    if (n) {
      const { childNodes: l } = o.body;
      return r ? l : [...l].map((c) => Of(c, t));
    }
    const s = o.querySelector(i) || o.body.childNodes[0];
    if (!(s instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? s : Of(s, t);
  } catch (o) {
    process.env.NODE_ENV !== "production" && console.error(o);
  }
  return null;
}
var RM = Object.defineProperty, MM = (e, t, n) => t in e ? RM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Wd = (e, t, n) => MM(e, typeof t != "symbol" ? t + "" : t, n), Cy = "react-inlinesvg", Oy = 10, cn = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function UM(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function cf() {
  var e;
  return !!(typeof window < "u" && (e = window.document) != null && e.createElement);
}
function BM() {
  return WM() && typeof window < "u" && window !== null;
}
function zM(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
function qM(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = `${t}${t.toUpperCase()}1234567890`;
  let r = "";
  for (let i = 0; i < e; i++)
    r += UM(n);
  return r;
}
async function f3(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [i] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((a) => i.includes(a)))
    throw new Error(`Content type isn't valid: ${i}`);
  return n.text();
}
function VM(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function WM() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
var HM = class {
  constructor() {
    Wd(this, "cacheApi"), Wd(this, "cacheStore"), Wd(this, "subscribers", []), Wd(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = Cy, t = !1;
    cf() && (e = window.REACT_INLINESVG_CACHE_NAME ?? Cy, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n;
    }).catch((n) => {
      console.error(`Failed to open cache: ${n.message}`);
    }).finally(() => {
      this.isReady = !0, this.subscribers.forEach((n) => n());
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === cn.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === cn.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: cn.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: cn.LOADING });
      try {
        const r = await f3(e, t);
        this.cacheStore.set(e, { content: r, status: cn.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: cn.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var n, r, i;
    const a = this.cacheStore.get(e);
    if ((a == null ? void 0 : a.status) === cn.LOADED)
      return;
    if ((a == null ? void 0 : a.status) === cn.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: cn.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: cn.LOADING });
    const o = await ((n = this.cacheApi) == null ? void 0 : n.match(e));
    if (o) {
      const s = await o.text();
      this.cacheStore.set(e, { content: s, status: cn.LOADED });
      return;
    }
    try {
      await ((r = this.cacheApi) == null ? void 0 : r.add(new Request(e, t)));
      const s = await ((i = this.cacheApi) == null ? void 0 : i.match(e)), l = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: l, status: cn.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: cn.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var n;
    let r = 0;
    for (; ((n = this.cacheStore.get(e)) == null ? void 0 : n.status) === cn.LOADING && r < Oy; )
      await VM(0.1), r += 1;
    r >= Oy && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function jy(e) {
  const t = gr(void 0);
  return gn(() => {
    t.current = e;
  }), t.current;
}
function $M(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: i,
    hash: a,
    preProcessor: o,
    title: s,
    uniquifyIDs: l = !1
  } = e;
  try {
    const c = GM(n, o), d = d3(c, { nodeOnly: !0 });
    if (!d || !(d instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const p = p3(d, { baseURL: t, hash: a, uniquifyIDs: l });
    if (r) {
      const y = p.querySelector("desc");
      y != null && y.parentNode && y.parentNode.removeChild(y);
      const f = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      f.innerHTML = r, p.prepend(f);
    }
    if (typeof s < "u") {
      const y = p.querySelector("title");
      if (y != null && y.parentNode && y.parentNode.removeChild(y), s) {
        const f = document.createElementNS("http://www.w3.org/2000/svg", "title");
        f.innerHTML = s, p.prepend(f);
      }
    }
    return p;
  } catch (c) {
    return i(c);
  }
}
function GM(e, t) {
  return t ? t(e) : e;
}
function p3(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: i } = t, a = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], o = ["href", "xlink:href"], s = (l, c) => o.includes(l) && (c ? !c.includes("#") : !1);
  return i && [...e.children].forEach((l) => {
    var c;
    if ((c = l.attributes) != null && c.length) {
      const d = Object.values(l.attributes).map((p) => {
        const y = p, f = /url\((.*?)\)/.exec(p.value);
        return f != null && f[1] && (y.value = p.value.replace(f[0], `url(${n}${f[1]}__${r})`)), y;
      });
      a.forEach((p) => {
        const y = d.find((f) => f.name === p);
        y && !s(p, y.value) && (y.value = `${y.value}__${r}`);
      });
    }
    return l.children.length ? p3(l, t) : l;
  }), e;
}
var ll;
function QM(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: i,
    innerRef: a,
    loader: o = null,
    onError: s,
    onLoad: l,
    src: c,
    title: d,
    uniqueHash: p
  } = e, [y, f] = og(
    ($, ae) => ({
      ...$,
      ...ae
    }),
    {
      content: "",
      element: null,
      isCached: t && ll.isCached(e.src),
      status: cn.IDLE
    }
  ), { content: N, element: b, isCached: S, status: _ } = y, E = jy(e), k = jy(y), M = gr(p ?? qM(8)), F = gr(!1), q = gr(!1), j = Ln(
    ($) => {
      F.current && (f({
        status: $.message === "Browser does not support SVG" ? cn.UNSUPPORTED : cn.FAILED
      }), s == null || s($));
    },
    [s]
  ), x = Ln(($, ae = !1) => {
    F.current && f({
      content: $,
      isCached: ae,
      status: cn.LOADED
    });
  }, []), C = Ln(async () => {
    const $ = await f3(c, i);
    x($);
  }, [i, x, c]), D = Ln(() => {
    try {
      const $ = $M({ ...e, handleError: j, hash: M.current, content: N }), ae = d3($);
      if (!ae || !X0(ae))
        throw new Error("Could not convert the src to a React element");
      f({
        element: ae,
        status: cn.READY
      });
    } catch ($) {
      j(new Error($.message));
    }
  }, [N, j, e]), P = Ln(async () => {
    const $ = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let ae;
    if ($ ? ae = $[1] ? window.atob($[2]) : decodeURIComponent($[2]) : c.includes("<svg") && (ae = c), ae) {
      x(ae);
      return;
    }
    try {
      if (t) {
        const ce = await ll.get(c, i);
        x(ce, !0);
      } else
        await C();
    } catch (ce) {
      j(ce);
    }
  }, [t, C, i, j, x, c]), L = Ln(async () => {
    F.current && f({
      content: "",
      element: null,
      isCached: !1,
      status: cn.LOADING
    });
  }, []);
  gn(
    () => {
      if (F.current = !0, !cf() || q.current)
        return () => {
        };
      try {
        if (_ === cn.IDLE) {
          if (!BM())
            throw new Error("Browser does not support SVG");
          if (!c)
            throw new Error("Missing src");
          L();
        }
      } catch ($) {
        j($);
      }
      return q.current = !0, () => {
        F.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), gn(() => {
    if (cf() && E)
      if (E.src !== c) {
        if (!c) {
          j(new Error("Missing src"));
          return;
        }
        L();
      } else (E.title !== d || E.description !== r) && D();
  }, [r, D, j, L, E, c, d]), gn(() => {
    k && (k.status !== cn.LOADING && _ === cn.LOADING && P(), k.status !== cn.LOADED && _ === cn.LOADED && D(), k.status !== cn.READY && _ === cn.READY && (l == null || l(c, S)));
  }, [P, D, S, l, k, c, _]);
  const H = zM(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return cf() ? b ? ag(b, {
    ref: a,
    ...H
  }) : [cn.UNSUPPORTED, cn.FAILED].includes(_) ? n : o : o;
}
function YM(e) {
  ll || (ll = new HM());
  const { loader: t } = e, n = gr(!1), [r, i] = oi(ll.isReady);
  return gn(() => {
    n.current || (ll.onReady(() => {
      i(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ gt.createElement(QM, { ...e }) : t;
}
class qc extends R.Component {
  render() {
    const {
      src: t,
      colour: n,
      alt: r,
      title: i
    } = this.props;
    if (!t)
      return null;
    switch (t.split(".").pop()) {
      case "svg":
        return /* @__PURE__ */ m.jsx("span", { className: "landing-page--svg-wrapper", style: {
          fill: n,
          stroke: n
        }, children: /* @__PURE__ */ m.jsx(YM, { src: t, "aria-label": r }) });
      case "png":
      case "jpg":
      case "jpeg":
        return /* @__PURE__ */ m.jsx("img", { src: t, alt: r, title: i });
      default:
        return null;
    }
  }
}
class h1 extends R.Component {
  render() {
    const {
      name: t,
      colour: n = "cyan"
    } = this.props;
    let r;
    switch (n) {
      case "cyan":
        r = "#00aec7";
        break;
      case "deepCyan":
        r = "#0f849e";
        break;
      case "teal":
        r = "#00b398";
        break;
      case "blue":
        r = "#004b87";
        break;
      case "white":
        r = "#ffffff";
        break;
      case "lightCyan":
        r = "#7FD1E3";
        break;
      case "grey":
        r = "#646F80";
        break;
      case "paleSky":
        r = "#646F80";
        break;
      default:
        r = "#00aec7";
    }
    switch (t) {
      case "gear":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ m.jsx("path", { d: "M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z", fill: r }) });
      case "logout":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ m.jsx("path", { d: "M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z", fill: r }) });
      case "nineDot":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "38", height: "38", viewBox: "0 0 38 38", children: /* @__PURE__ */ m.jsxs("g", { fill: "none", fillRule: "evenodd", children: [
          /* @__PURE__ */ m.jsx("rect", { width: "38", height: "38", fill: "#646F80", rx: "2" }),
          /* @__PURE__ */ m.jsx("path", { stroke: "#FFF", strokeLinecap: "square", strokeWidth: "3", d: "M12 1.49642875L12 36.5M26 .496621776L26 37.5M36.5033332 26L.496528267 26M36.5034717 13L.496666815 13", fill: r })
        ] }) });
      case "userIcon":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ m.jsx("path", { d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z", fill: r }) });
      case "dropDownArrow":
        return /* @__PURE__ */ m.jsx("svg", { className: this.props.className, xmlns: "http://www.w4.org/2000/svg", width: "16", height: "8", viewBox: "0 0 16 8", children: /* @__PURE__ */ m.jsx("polygon", { fill: "#D0D5DC", fillRule: "evenodd", points: "1565 59 1573 67 1557 67", transform: "matrix(-1 0 0 1 1573 -59)" }) });
      case "question":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: this.props.className, children: /* @__PURE__ */ m.jsx("path", { fill: r, d: "M14.601 21.5c0 1.38-1.116 2.5-2.499 2.5-1.378 0-2.499-1.12-2.499-2.5s1.121-2.5 2.499-2.5c1.383 0 2.499 1.119 2.499 2.5zm-2.42-21.5c-4.029 0-7.06 2.693-7.06 8h3.955c0-2.304.906-4.189 3.024-4.189 1.247 0 2.57.828 2.684 2.411.123 1.666-.767 2.511-1.892 3.582-2.924 2.78-2.816 4.049-2.816 7.196h3.943c0-1.452-.157-2.508 1.838-4.659 1.331-1.436 2.986-3.222 3.021-5.943.047-3.963-2.751-6.398-6.697-6.398z" }) });
      case "close":
        return /* @__PURE__ */ m.jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", className: this.props.className, children: /* @__PURE__ */ m.jsx("path", { fill: r, d: "M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" }) });
      case "bag":
        return /* @__PURE__ */ m.jsx("svg", { width: "20", height: "23", viewBox: "0 0 20 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M15.23 6.8763L15.2301 5.5013C15.2304 2.46856 12.7953 0.00110716 9.802 0.000871138C6.80865 0.000635115 4.37324 2.46771 4.373 5.50044L4.37289 6.87544L0.30146 6.87512L0.300538 18.5626C0.300389 20.4611 1.81929 22.0002 3.69312 22.0004L15.9074 22.0014C17.7812 22.0015 19.3004 20.4626 19.3005 18.5641L19.3015 6.87662L15.23 6.8763ZM7.08728 5.50066C7.0874 3.98429 8.30511 2.75075 9.80179 2.75087C11.2985 2.75099 12.516 3.98472 12.5159 5.50109L12.5157 6.87609L7.08717 6.87566L7.08728 5.50066ZM13.8726 10.6574C13.3104 10.6574 12.8548 10.1957 12.8548 9.62611C12.8549 9.05656 13.3106 8.5949 13.8728 8.59494C14.4349 8.59499 14.8906 9.05672 14.8905 9.62627C14.8905 10.1958 14.4347 10.6575 13.8726 10.6574ZM5.72973 10.6568C5.16758 10.6568 4.71191 10.195 4.71196 9.62547C4.712 9.05592 5.16774 8.59426 5.7299 8.5943C6.29205 8.59434 6.74772 9.05608 6.74767 9.62563C6.74763 10.1952 6.29189 10.6568 5.72973 10.6568Z", fill: r }) });
      case "brush":
        return /* @__PURE__ */ m.jsx("svg", { width: "23", height: "23", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M19.8511 0.00156509C20.4247 0.00161032 20.9265 0.191941 21.3567 0.572556C21.7868 0.95317 22.0018 1.42993 22.0018 2.00285C22.0018 2.51848 21.8173 3.13639 21.4486 3.8566C18.7279 9.00445 16.8226 12.0817 15.7328 13.0883C14.9379 13.833 14.0448 14.2053 13.0533 14.2053C12.0209 14.2052 11.134 13.8266 10.3925 13.0695C9.65108 12.3123 9.28038 11.4141 9.28046 10.3746C9.28055 9.327 9.65752 8.45947 10.4114 7.77203L18.2533 0.664386C18.7368 0.22246 19.2694 0.00151922 19.8511 0.00156509ZM8.67805 12.6949C8.99755 13.3169 9.43382 13.849 9.98686 14.291C10.5399 14.733 11.1564 15.044 11.8365 15.2241L11.8487 16.0958C11.8814 17.8391 11.3507 19.2591 10.2568 20.3557C9.16283 21.4524 7.73504 22.0006 5.9734 22.0005C4.96558 22.0004 4.07249 21.81 3.29412 21.4294C2.51575 21.0487 1.89102 20.5269 1.41994 19.864C0.948857 19.201 0.594539 18.4521 0.356989 17.6172C0.119438 16.7824 0.000700836 15.8821 0.000776986 14.9163C0.0581294 14.9572 0.22609 15.08 0.504659 15.2846C0.783227 15.4893 1.03722 15.6714 1.26663 15.831C1.49604 15.9906 1.73774 16.14 1.99173 16.2792C2.24572 16.4183 2.43417 16.4879 2.55708 16.4879C2.89302 16.488 3.11836 16.3366 3.23309 16.0337C3.43798 15.4936 3.67358 15.0332 3.9399 14.6527C4.20623 14.2721 4.49098 13.9611 4.79417 13.7197C5.09735 13.4783 5.45789 13.2839 5.87578 13.1366C6.29367 12.9893 6.71565 12.885 7.14172 12.8237C7.5678 12.7623 8.07991 12.7194 8.67805 12.6949Z", fill: r }) });
      case "car":
        return /* @__PURE__ */ m.jsx("svg", { width: "22", height: "16", viewBox: "0 0 22 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M18.6678 5.56695L18.1178 5.56691L14.3789 0.836653C14.1727 0.575959 13.9113 0.365502 13.6139 0.220854C13.3166 0.076206 12.9908 0.00106856 12.6609 0.0010008L5.30773 0.000421013C4.40814 0.000350081 3.59925 0.554399 3.26506 1.39963L1.61782 5.64422C0.670422 5.8925 -0.0322709 6.75545 -0.0323526 7.79167L-0.0326598 11.6875C-0.0326841 11.995 0.213421 12.2441 0.517296 12.2441L2.1673 12.2442C2.16715 14.0885 3.64447 15.5836 5.46703 15.5838C7.2896 15.5839 8.76715 14.089 8.7673 12.2447L13.1673 12.2451C13.1672 14.0894 14.6445 15.5845 16.467 15.5846C18.2896 15.5848 19.7672 14.0899 19.7673 12.2456L21.4173 12.2457C21.7212 12.2458 21.9673 11.9967 21.9673 11.6892L21.9676 8.9065C21.9677 7.06224 20.4904 5.5671 18.6678 5.56695ZM5.46716 13.9141C4.55726 13.9141 3.81722 13.1651 3.8173 12.2444C3.81737 11.3236 4.55752 10.5748 5.46743 10.5748C6.37733 10.5749 7.11737 11.3239 7.1173 12.2446C7.11722 13.1654 6.37707 13.9142 5.46716 13.9141ZM7.94282 5.56611L3.98729 5.56579L5.30756 2.22661L7.94309 2.22682L7.94282 5.56611ZM9.59282 5.56624L9.59309 2.22695L12.6607 2.22719L15.3004 5.56669L9.59282 5.56624ZM16.4672 13.915C15.5573 13.9149 14.8172 13.166 14.8173 12.2452C14.8174 11.3245 15.5575 10.5756 16.4674 10.5757C17.3773 10.5758 18.1174 11.3247 18.1173 12.2455C18.1172 13.1662 17.3771 13.9151 16.4672 13.915Z", fill: r }) });
      case "people":
        return /* @__PURE__ */ m.jsx("svg", { width: "23", height: "23", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M17.5882 21.0433C17.5884 18.5727 15.1828 17.3152 12.8399 16.3052C10.5047 15.2996 9.75892 14.4526 9.75907 12.6376C9.75915 11.5497 10.4719 11.9039 10.7845 9.90856C10.9165 9.08137 11.5457 9.89542 11.6668 8.00673C11.6669 7.25432 11.3226 7.0673 11.3226 7.0673C11.3226 7.0673 11.4976 5.95301 11.5659 5.09502C11.6363 4.19632 11.1283 2.27898 9.03503 1.69032C8.66986 1.31519 8.42241 0.720069 9.54885 0.123958C7.08486 0.00936323 6.51166 1.29852 5.19929 2.24661C4.08272 3.07813 3.78122 4.3948 3.83506 5.09551C3.90649 5.95351 4.08021 7.06783 4.08021 7.06783C4.08021 7.06783 3.73479 7.2548 3.73473 8.0072C3.85558 9.89701 4.48705 9.08196 4.61788 9.90917C4.93012 11.9046 5.64405 11.5505 5.64397 12.6384C5.64382 14.4534 5.41057 15.0693 3.07409 16.0745C0.729915 17.0831 0.000487797 18.7 0.0124031 21.0419C0.0156479 21.7426 0.000227594 22 0.000227594 22L17.6002 22.0014C17.6002 22.0014 17.5881 21.744 17.5882 21.0433ZM20.3816 14.7031C19.1331 14.2003 18.6162 13.6008 18.6163 12.4304C18.6163 11.7253 19.0761 11.9552 19.2786 10.6671C19.3634 10.1347 19.7703 10.6584 19.8485 9.44067C19.8486 8.95557 19.6264 8.83455 19.6264 8.83455C19.6264 8.83455 19.7397 8.11296 19.7838 7.55967C19.8388 6.86997 19.3836 5.08793 17.2892 5.08777C15.1959 5.0876 14.7392 6.86957 14.7931 7.55927C14.8392 8.11148 14.9514 8.83418 14.9514 8.83418C14.9514 8.83418 14.7292 8.95407 14.7291 9.44027C14.8071 10.658 15.2142 10.1344 15.2988 10.6668C15.5011 11.956 15.9609 11.7262 15.9609 12.4302C15.9608 13.6006 15.4789 14.1483 13.9708 14.7972C13.8949 14.8291 13.8388 14.872 13.7695 14.9094C15.5734 15.6927 18.4179 17.0449 19.0909 19.8015L22.0004 19.8017C22.0004 19.8017 22.0006 17.7051 22.0006 17.2519C22.0007 16.1519 21.7005 15.2345 20.3816 14.7031Z", fill: r }) });
      case "pram":
        return /* @__PURE__ */ m.jsx("svg", { width: "21", height: "23", viewBox: "0 0 21 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M12.1354 0.000954076L12.1347 8.80095L20.9347 8.80165C20.9351 3.93965 16.9974 0.00133744 12.1354 0.000954076ZM19.0862 15.2805C20.2413 13.7956 20.9345 11.9256 20.9346 9.90165L4.91862 9.90039L3.87379 7.7003L0.0347933 7.7L0.0346198 9.9L2.47662 9.90019C2.47662 9.90019 4.55527 14.3774 4.80824 14.7624C3.59819 15.4113 2.78408 16.6872 2.78397 18.1502C2.7838 20.2732 4.51067 22.0004 6.63367 22.0005C8.56967 22.0007 10.1758 20.5708 10.4399 18.7008L12.7279 18.701C12.9918 20.571 14.5977 22.0011 16.5337 22.0013C18.6567 22.0015 20.3838 20.2746 20.384 18.1516C20.3841 17.0076 19.8781 15.9846 19.0862 15.2805ZM6.63384 19.8005C5.72084 19.8004 4.9839 19.0634 4.98397 18.1504C4.98404 17.2374 5.7211 16.5004 6.6341 16.5005C7.5471 16.5006 8.28404 17.2377 8.28397 18.1507C8.2839 19.0637 7.54684 19.8006 6.63384 19.8005ZM16.5338 19.8013C15.6208 19.8012 14.8839 19.0642 14.884 18.1512C14.884 17.2382 15.6211 16.5012 16.5341 16.5013C17.4471 16.5014 18.184 17.2384 18.184 18.1514C18.1839 19.0644 17.4468 19.8014 16.5338 19.8013Z", fill: r }) });
      case "star":
        return /* @__PURE__ */ m.jsx("svg", { width: "23", height: "22", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ m.jsx("path", { d: "M17.1129 20.9959C16.9366 20.9966 16.7627 20.9549 16.6058 20.8744L10.984 17.9243L5.36176 20.8735C5.17919 20.9697 4.97336 21.0126 4.76766 20.9974C4.56196 20.9822 4.36465 20.9094 4.19815 20.7874C4.03165 20.6654 3.90264 20.4991 3.8258 20.3072C3.74895 20.1154 3.72734 19.9058 3.76343 19.7023L4.86628 13.4827L0.324923 9.06342C0.183235 8.9217 0.0827293 8.74399 0.0341926 8.54936C-0.014344 8.35473 -0.00907951 8.15052 0.0494211 7.95866C0.113329 7.76233 0.230872 7.58788 0.388711 7.4551C0.54655 7.32233 0.738365 7.23656 0.942389 7.20751L7.22589 6.29107L9.99325 0.623982C10.0835 0.43721 10.2245 0.2797 10.4 0.169496C10.5754 0.0592912 10.7783 0.000849709 10.9854 0.000866038C11.1925 0.000882366 11.3954 0.0593558 11.5709 0.169588C11.7463 0.27982 11.8872 0.437352 11.9775 0.624138L14.777 6.28062L21.0604 7.19805C21.2644 7.22713 21.4562 7.31293 21.614 7.44573C21.7718 7.57853 21.8894 7.753 21.9532 7.94934C22.0117 8.14121 22.0169 8.34542 21.9684 8.54004C21.9198 8.73466 21.8193 8.91236 21.6776 9.05406L17.1355 13.4727L18.2374 19.6924C18.2767 19.8995 18.2561 20.1136 18.1779 20.3094C18.0998 20.5051 17.9674 20.6744 17.7963 20.7971C17.5967 20.9373 17.3564 21.0072 17.1129 20.9959Z", fill: r }) });
      case "file":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "61", viewBox: "0 0 50 61", fill: "none", children: /* @__PURE__ */ m.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 61H22.5C33 61 50 44.5 50 35.7374V0H0V61ZM30.5 47.5V41H31H38C40.3333 40.8333 45 39.2 45 34V5H5V54.5H23.5C28.7 54.5 30.3333 49.8333 30.5 47.5ZM38 15H13V18H38V15ZM13 22H38V25H13V22ZM38 30H13V33H38V30Z", fill: r }) });
      case "target":
        return /* @__PURE__ */ m.jsxs("svg", { width: "23", height: "23", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ m.jsxs("g", { clipPath: "url(#clip0)", children: [
            /* @__PURE__ */ m.jsx("path", { d: "M11.0004 20.1676C16.063 20.168 20.1674 16.0642 20.1678 11.0016C20.1682 5.939 16.0645 1.83462 11.0019 1.83422C5.93926 1.83382 1.83488 5.93755 1.83448 11.0002C1.83408 16.0628 5.93782 20.1672 11.0004 20.1676Z", stroke: r, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            /* @__PURE__ */ m.jsx("path", { d: "M11.0006 16.5009C14.0382 16.5012 16.5008 14.0389 16.501 11.0014C16.5013 7.96379 14.039 5.50116 11.0015 5.50092C7.9639 5.50068 5.50127 7.96292 5.50103 11.0005C5.50079 14.0381 7.96303 16.5007 11.0006 16.5009Z", stroke: r, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            /* @__PURE__ */ m.jsx("path", { d: "M11.001 12.8342C12.0135 12.8342 12.8344 12.0135 12.8345 11.001C12.8346 9.98846 12.0138 9.16758 11.0013 9.1675C9.98878 9.16742 9.1679 9.98817 9.16782 11.0007C9.16774 12.0132 9.98849 12.8341 11.001 12.8342Z", stroke: r, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
          ] }),
          /* @__PURE__ */ m.jsx("defs", { children: /* @__PURE__ */ m.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ m.jsx("rect", { width: "22", height: "22", fill: "white", transform: "translate(0.00195312)" }) }) })
        ] });
      case "creative":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M4 21.832c4.587.38 2.944-4.493 7.188-4.538l1.838 1.534c.458 5.538-6.315 6.773-9.026 3.004zm14.065-7.115c1.427-2.239 5.847-9.749 5.847-9.749.352-.623-.43-1.273-.976-.813 0 0-6.572 5.714-8.511 7.525-1.532 1.432-1.539 2.086-2.035 4.447l1.68 1.4c2.227-.915 2.868-1.039 3.995-2.81zm-11.999 3.876c.666-1.134 1.748-2.977 4.447-3.262.434-2.087.607-3.3 2.547-5.112 1.373-1.282 4.938-4.409 7.021-6.229-1-2.208-4.141-4.023-8.178-3.99-6.624.055-11.956 5.465-11.903 12.092.023 2.911 1.081 5.571 2.82 7.635 1.618.429 2.376.348 3.246-1.134zm6.952-15.835c1.102-.006 2.005.881 2.016 1.983.004 1.103-.882 2.009-1.986 2.016-1.105.009-2.008-.88-2.014-1.984-.013-1.106.876-2.006 1.984-2.015zm-5.997 2.001c1.102-.01 2.008.877 2.012 1.983.012 1.106-.88 2.005-1.98 2.016-1.106.007-2.009-.881-2.016-1.988-.009-1.103.877-2.004 1.984-2.011zm-2.003 5.998c1.106-.007 2.01.882 2.016 1.985.01 1.104-.88 2.008-1.986 2.015-1.105.008-2.005-.88-2.011-1.985-.011-1.105.879-2.004 1.981-2.015zm10.031 8.532c.021 2.239-.882 3.718-1.682 4.587l-.046.044c5.255-.591 9.062-4.304 6.266-7.889-1.373 2.047-2.534 2.442-4.538 3.258z" }) });
      case "megaphone":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z" }) });
      case "document":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm4.256 11h-12v-1h12v1zm0-3h-12v-1h12v1zm0-3h-12v-1h12v1zm-3.432-12.925c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z" }) });
      case "paperplane":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z" }) });
      case "fire":
        return /* @__PURE__ */ m.jsx("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M8.625 0c.61 7.189-5.625 9.664-5.625 15.996 0 4.301 3.069 7.972 9 8.004 5.931.032 9-4.414 9-8.956 0-4.141-2.062-8.046-5.952-10.474.924 2.607-.306 4.988-1.501 5.808.07-3.337-1.125-8.289-4.922-10.378zm4.711 13c3.755 3.989 1.449 9-1.567 9-1.835 0-2.779-1.265-2.769-2.577.019-2.433 2.737-2.435 4.336-6.423z" }) });
      case "key":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M12.451 17.337l-2.451 2.663h-2v2h-2v2h-6v-5l6.865-6.949c1.08 2.424 3.095 4.336 5.586 5.286zm11.549-9.337c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-3-3c0-1.104-.896-2-2-2s-2 .896-2 2 .896 2 2 2 2-.896 2-2z" }) });
      case "envelope":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z" }) });
      case "stats":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M7 24h-6v-6h6v6zm8-9h-6v9h6v-9zm8-4h-6v13h6v-13zm0-11l-6 1.221 1.716 1.708-6.85 6.733-3.001-3.002-7.841 7.797 1.41 1.418 6.427-6.39 2.991 2.993 8.28-8.137 1.667 1.66 1.201-6.001z" }) });
      case "nogo":
        return /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: r, children: /* @__PURE__ */ m.jsx("path", { d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z" }) });
      default:
        return /* @__PURE__ */ m.jsxs("strong", { children: [
          "Error: no case in InlineSVG for ",
          t
        ] });
    }
  }
}
var op = {};
Object.defineProperty(op, "__esModule", { value: !0 });
op.isUrlExternal = void 0;
const KM = (e) => new URL(e).hostname.replace("www.", ""), XM = (e) => {
  const t = e.toLowerCase();
  return t.startsWith("http") || t.startsWith("https");
}, ZM = (e, t) => XM(e) ? KM(e) !== t : !1;
op.isUrlExternal = ZM;
const JM = ({
  disabled: e,
  className: t,
  children: n,
  to: r,
  openInTab: i,
  onClickHandler: a
}) => {
  const o = i ? "_blank" : "_self", s = (l) => {
    a && typeof a == "function" && a();
  };
  return /* @__PURE__ */ m.jsx(R.Fragment, { children: e ? /* @__PURE__ */ m.jsx("div", { className: t, children: n }) : /* @__PURE__ */ m.jsx(R.Fragment, { children: op(r) ? /* @__PURE__ */ m.jsx("a", { className: t, onClick: s, href: r, target: o, children: n }) : /* @__PURE__ */ m.jsx(wn, { className: t, onClick: s, to: r, target: o, children: n }) }) });
};
function cl(e) {
  const {
    communityImages: t,
    to: n,
    blurred: r,
    image: i,
    introText: a,
    title: o,
    disabled: s,
    openInTab: l = !1,
    onClickHandler: c
  } = e;
  return /* @__PURE__ */ m.jsxs(JM, { className: `landing-page-card ${s ? "disabled" : ""}`, disabled: s, to: n, openInTab: l, onClickHandler: c, children: [
    t && /* @__PURE__ */ m.jsxs("div", { className: `landing-page-card__images ${r ? "blurred" : ""}`, children: [
      t.map((d, p) => /* @__PURE__ */ m.jsx(qc, { src: d }, p)),
      r && /* @__PURE__ */ m.jsx(h1, { name: "question", colour: "deepCyan", className: "landing-page-card__question" })
    ] }),
    i && /* @__PURE__ */ m.jsx(qc, { src: i }),
    a && /* @__PURE__ */ m.jsx("p", { className: "landing-page-card--intro-text", children: a }),
    /* @__PURE__ */ m.jsx("h4", { className: `landing-page-card__title ${s ? "disabled" : ""}`, children: o })
  ] });
}
let AM = class extends R.Component {
  componentDidMount() {
    this.props.loadSuperSegments(), this.props.featureAccess();
  }
  render() {
    const {
      communityImages: e,
      isFetching: t,
      firstLandingPage: n,
      campaignCreatorAccess: r
    } = this.props;
    return t && !e ? /* @__PURE__ */ m.jsx(ga, {}) : /* @__PURE__ */ m.jsx(R.Fragment, { children: r ? /* @__PURE__ */ m.jsx(fr, { children: /* @__PURE__ */ m.jsx(We, { children: /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsxs("div", { className: "landing-page", children: [
      /* @__PURE__ */ m.jsx("h1", { className: "landing-page__title", children: n ? n.pageTitle : null }),
      /* @__PURE__ */ m.jsx("h3", { className: "landing-page__sub-title", children: n ? n.subtitle : null }),
      /* @__PURE__ */ m.jsx(We, { stackable: !0, className: "landing-page__inner-grid", children: /* @__PURE__ */ m.jsxs(We.Row, { columns: 4, children: [
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(cl, { to: "/campaign-creator/select-personas-new", communityImages: e, blurred: !1, title: "I'll select from the list" }) }),
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(cl, { to: "/campaign-creator/select-personas", communityImages: e, blurred: !1, title: n ? n.firstImageText : "" }) }),
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(cl, { to: "/campaign-creator/find-personas", communityImages: e, blurred: !0, title: n ? n.secondImageText : "" }) }),
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(cl, { to: "/campaign-creator/find-personas-new", communityImages: e, blurred: !0, title: "I'll let the system select" }) })
      ] }) })
    ] }) }) }) }) : "" });
  }
};
const eU = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    isFetching: e.superSegments.isFetching,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage
  };
}, tU = (e) => Kt({
  loadSuperSegments: zo,
  featureAccess: ui
}, e);
Mt(eU, tU)(AM);
var h3 = {}, m1 = {}, g1 = {}, Cs = {}, y1 = {}, v1 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function n(r) {
    return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
  }
  e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(v1);
var Rt = {}, qo = xn && xn.__extends || /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vc = xn && xn.__assign || function() {
  return Vc = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Vc.apply(this, arguments);
};
Object.defineProperty(Rt, "__esModule", { value: !0 });
Rt.cloneNode = Rt.hasChildren = Rt.isDocument = Rt.isDirective = Rt.isComment = Rt.isText = Rt.isCDATA = Rt.isTag = Rt.Element = Rt.Document = Rt.CDATA = Rt.NodeWithChildren = Rt.ProcessingInstruction = Rt.Comment = Rt.Text = Rt.DataNode = Rt.Node = void 0;
var Jr = v1, b1 = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), w1(this, t);
    }, e;
  }()
);
Rt.Node = b1;
var sp = (
  /** @class */
  function(e) {
    qo(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b1)
);
Rt.DataNode = sp;
var m3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jr.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(sp)
);
Rt.Text = m3;
var g3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jr.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(sp)
);
Rt.Comment = g3;
var y3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t(n, r) {
      var i = e.call(this, r) || this;
      return i.name = n, i.type = Jr.ElementType.Directive, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(sp)
);
Rt.ProcessingInstruction = y3;
var lp = (
  /** @class */
  function(e) {
    qo(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b1)
);
Rt.NodeWithChildren = lp;
var v3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jr.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(lp)
);
Rt.CDATA = v3;
var b3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Jr.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(lp)
);
Rt.Document = b3;
var w3 = (
  /** @class */
  function(e) {
    qo(t, e);
    function t(n, r, i, a) {
      i === void 0 && (i = []), a === void 0 && (a = n === "script" ? Jr.ElementType.Script : n === "style" ? Jr.ElementType.Style : Jr.ElementType.Tag);
      var o = e.call(this, i) || this;
      return o.name = n, o.attribs = r, o.type = a, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var i, a;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (i = n["x-attribsNamespace"]) === null || i === void 0 ? void 0 : i[r],
            prefix: (a = n["x-attribsPrefix"]) === null || a === void 0 ? void 0 : a[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(lp)
);
Rt.Element = w3;
function x3(e) {
  return (0, Jr.isTag)(e);
}
Rt.isTag = x3;
function _3(e) {
  return e.type === Jr.ElementType.CDATA;
}
Rt.isCDATA = _3;
function N3(e) {
  return e.type === Jr.ElementType.Text;
}
Rt.isText = N3;
function S3(e) {
  return e.type === Jr.ElementType.Comment;
}
Rt.isComment = S3;
function E3(e) {
  return e.type === Jr.ElementType.Directive;
}
Rt.isDirective = E3;
function C3(e) {
  return e.type === Jr.ElementType.Root;
}
Rt.isDocument = C3;
function nU(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
Rt.hasChildren = nU;
function w1(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (N3(e))
    n = new m3(e.data);
  else if (S3(e))
    n = new g3(e.data);
  else if (x3(e)) {
    var r = t ? Ih(e.children) : [], i = new w3(e.name, Vc({}, e.attribs), r);
    r.forEach(function(l) {
      return l.parent = i;
    }), e.namespace != null && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = Vc({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = Vc({}, e["x-attribsPrefix"])), n = i;
  } else if (_3(e)) {
    var r = t ? Ih(e.children) : [], a = new v3(r);
    r.forEach(function(c) {
      return c.parent = a;
    }), n = a;
  } else if (C3(e)) {
    var r = t ? Ih(e.children) : [], o = new b3(r);
    r.forEach(function(c) {
      return c.parent = o;
    }), e["x-mode"] && (o["x-mode"] = e["x-mode"]), n = o;
  } else if (E3(e)) {
    var s = new y3(e.name, e.data);
    e["x-name"] != null && (s["x-name"] = e["x-name"], s["x-publicId"] = e["x-publicId"], s["x-systemId"] = e["x-systemId"]), n = s;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
Rt.cloneNode = w1;
function Ih(e) {
  for (var t = e.map(function(r) {
    return w1(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = xn && xn.__createBinding || (Object.create ? function(s, l, c, d) {
    d === void 0 && (d = c);
    var p = Object.getOwnPropertyDescriptor(l, c);
    (!p || ("get" in p ? !l.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return l[c];
    } }), Object.defineProperty(s, d, p);
  } : function(s, l, c, d) {
    d === void 0 && (d = c), s[d] = l[c];
  }), n = xn && xn.__exportStar || function(s, l) {
    for (var c in s) c !== "default" && !Object.prototype.hasOwnProperty.call(l, c) && t(l, s, c);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = v1, i = Rt;
  n(Rt, e);
  var a = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function s(l, c, d) {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (d = c, c = a), typeof l == "object" && (c = l, l = void 0), this.callback = l ?? null, this.options = c ?? a, this.elementCB = d ?? null;
      }
      return s.prototype.onparserinit = function(l) {
        this.parser = l;
      }, s.prototype.onreset = function() {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, s.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, s.prototype.onerror = function(l) {
        this.handleCallback(l);
      }, s.prototype.onclosetag = function() {
        this.lastNode = null;
        var l = this.tagStack.pop();
        this.options.withEndIndices && (l.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(l);
      }, s.prototype.onopentag = function(l, c) {
        var d = this.options.xmlMode ? r.ElementType.Tag : void 0, p = new i.Element(l, c, void 0, d);
        this.addNode(p), this.tagStack.push(p);
      }, s.prototype.ontext = function(l) {
        var c = this.lastNode;
        if (c && c.type === r.ElementType.Text)
          c.data += l, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var d = new i.Text(l);
          this.addNode(d), this.lastNode = d;
        }
      }, s.prototype.oncomment = function(l) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += l;
          return;
        }
        var c = new i.Comment(l);
        this.addNode(c), this.lastNode = c;
      }, s.prototype.oncommentend = function() {
        this.lastNode = null;
      }, s.prototype.oncdatastart = function() {
        var l = new i.Text(""), c = new i.CDATA([l]);
        this.addNode(c), l.parent = c, this.lastNode = l;
      }, s.prototype.oncdataend = function() {
        this.lastNode = null;
      }, s.prototype.onprocessinginstruction = function(l, c) {
        var d = new i.ProcessingInstruction(l, c);
        this.addNode(d);
      }, s.prototype.handleCallback = function(l) {
        if (typeof this.callback == "function")
          this.callback(l, this.dom);
        else if (l)
          throw l;
      }, s.prototype.addNode = function(l) {
        var c = this.tagStack[this.tagStack.length - 1], d = c.children[c.children.length - 1];
        this.options.withStartIndices && (l.startIndex = this.parser.startIndex), this.options.withEndIndices && (l.endIndex = this.parser.endIndex), c.children.push(l), d && (l.prev = d, d.next = l), l.parent = c, this.lastNode = null;
      }, s;
    }()
  );
  e.DomHandler = o, e.default = o;
})(y1);
var O3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = e.CARRIAGE_RETURN_PLACEHOLDER = e.CARRIAGE_RETURN_REGEX = e.CARRIAGE_RETURN = e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES = void 0, e.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
  ], e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES.reduce(function(t, n) {
    return t[n.toLowerCase()] = n, t;
  }, {}), e.CARRIAGE_RETURN = "\r", e.CARRIAGE_RETURN_REGEX = new RegExp(e.CARRIAGE_RETURN, "g"), e.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__"), e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(e.CARRIAGE_RETURN_PLACEHOLDER, "g");
})(O3);
Object.defineProperty(Cs, "__esModule", { value: !0 });
Cs.formatAttributes = j3;
Cs.escapeSpecialCharacters = aU;
Cs.revertEscapedCharacters = P3;
Cs.formatDOM = L3;
var Hd = y1, eu = O3;
function rU(e) {
  return eu.CASE_SENSITIVE_TAG_NAMES_MAP[e];
}
function j3(e) {
  for (var t = {}, n = 0, r = e.length; n < r; n++) {
    var i = e[n];
    t[i.name] = i.value;
  }
  return t;
}
function iU(e) {
  e = e.toLowerCase();
  var t = rU(e);
  return t || e;
}
function aU(e) {
  return e.replace(eu.CARRIAGE_RETURN_REGEX, eu.CARRIAGE_RETURN_PLACEHOLDER);
}
function P3(e) {
  return e.replace(eu.CARRIAGE_RETURN_PLACEHOLDER_REGEX, eu.CARRIAGE_RETURN);
}
function L3(e, t, n) {
  t === void 0 && (t = null);
  for (var r = [], i, a = 0, o = e.length; a < o; a++) {
    var s = e[a];
    switch (s.nodeType) {
      case 1: {
        var l = iU(s.nodeName);
        i = new Hd.Element(l, j3(s.attributes)), i.children = L3(
          // template children are on content
          l === "template" ? s.content.childNodes : s.childNodes,
          i
        );
        break;
      }
      case 3:
        i = new Hd.Text(P3(s.nodeValue));
        break;
      case 8:
        i = new Hd.Comment(s.nodeValue);
        break;
      default:
        continue;
    }
    var c = r[a - 1] || null;
    c && (c.next = i), i.parent = t, i.prev = c, i.next = null, r.push(i);
  }
  return n && (i = new Hd.ProcessingInstruction(n.substring(0, n.indexOf(" ")).toLowerCase(), n), i.next = r[0] || null, i.parent = t, r.unshift(i), r[1] && (r[1].prev = r[0])), r;
}
Object.defineProperty(g1, "__esModule", { value: !0 });
g1.default = uU;
var oU = Cs, Py = "html", Ly = "head", $d = "body", sU = /<([a-zA-Z]+[0-9]?)/, Ty = /<head[^]*>/i, Fy = /<body[^]*>/i, jf = function(e, t) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
}, qm = function(e, t) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
}, Iy = typeof window == "object" && window.DOMParser;
if (typeof Iy == "function") {
  var lU = new Iy(), cU = "text/html";
  qm = function(e, t) {
    return t && (e = "<".concat(t, ">").concat(e, "</").concat(t, ">")), lU.parseFromString(e, cU);
  }, jf = qm;
}
if (typeof document == "object" && document.implementation) {
  var Gd = document.implementation.createHTMLDocument();
  jf = function(e, t) {
    if (t) {
      var n = Gd.documentElement.querySelector(t);
      return n && (n.innerHTML = e), Gd;
    }
    return Gd.documentElement.innerHTML = e, Gd;
  };
}
var Qd = typeof document == "object" && document.createElement("template"), Vm;
Qd && Qd.content && (Vm = function(e) {
  return Qd.innerHTML = e, Qd.content.childNodes;
});
function uU(e) {
  var t, n;
  e = (0, oU.escapeSpecialCharacters)(e);
  var r = e.match(sU), i = r && r[1] ? r[1].toLowerCase() : "";
  switch (i) {
    case Py: {
      var a = qm(e);
      if (!Ty.test(e)) {
        var o = a.querySelector(Ly);
        (t = o == null ? void 0 : o.parentNode) === null || t === void 0 || t.removeChild(o);
      }
      if (!Fy.test(e)) {
        var o = a.querySelector($d);
        (n = o == null ? void 0 : o.parentNode) === null || n === void 0 || n.removeChild(o);
      }
      return a.querySelectorAll(Py);
    }
    case Ly:
    case $d: {
      var s = jf(e).querySelectorAll(i);
      return Fy.test(e) && Ty.test(e) ? s[0].parentNode.childNodes : s;
    }
    default: {
      if (Vm)
        return Vm(e);
      var o = jf(e, $d).querySelector($d);
      return o.childNodes;
    }
  }
}
var dU = xn && xn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(m1, "__esModule", { value: !0 });
m1.default = mU;
var fU = dU(g1), pU = Cs, hU = /<(![a-zA-Z\s]+)>/;
function mU(e) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  var t = e.match(hU), n = t ? t[1] : void 0;
  return (0, pU.formatDOM)((0, fU.default)(e), null, n);
}
var cp = {}, Qi = {}, up = {}, gU = 0;
up.SAME = gU;
var yU = 1;
up.CAMELCASE = yU;
up.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
const T3 = 0, Vo = 1, dp = 2, fp = 3, x1 = 4, F3 = 5, I3 = 6;
function vU(e) {
  return vr.hasOwnProperty(e) ? vr[e] : null;
}
function Br(e, t, n, r, i, a, o) {
  this.acceptsBooleans = t === dp || t === fp || t === x1, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = a, this.removeEmptyString = o;
}
const vr = {}, bU = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
bU.forEach((e) => {
  vr[e] = new Br(
    e,
    T3,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"]
].forEach(([e, t]) => {
  vr[e] = new Br(
    e,
    Vo,
    !1,
    // mustUseProperty
    t,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach((e) => {
  vr[e] = new Br(
    e,
    dp,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha"
].forEach((e) => {
  vr[e] = new Br(
    e,
    dp,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach((e) => {
  vr[e] = new Br(
    e,
    fp,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  vr[e] = new Br(
    e,
    fp,
    !0,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  vr[e] = new Br(
    e,
    x1,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  vr[e] = new Br(
    e,
    I3,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["rowSpan", "start"].forEach((e) => {
  vr[e] = new Br(
    e,
    F3,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const _1 = /[\-\:]([a-z])/g, N1 = (e) => e[1].toUpperCase();
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(_1, N1);
  vr[t] = new Br(
    t,
    Vo,
    !1,
    // mustUseProperty
    e,
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(_1, N1);
  vr[t] = new Br(
    t,
    Vo,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/1999/xlink",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(_1, N1);
  vr[t] = new Br(
    t,
    Vo,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/XML/1998/namespace",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["tabIndex", "crossOrigin"].forEach((e) => {
  vr[e] = new Br(
    e,
    Vo,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const wU = "xlinkHref";
vr[wU] = new Br(
  "xlinkHref",
  Vo,
  !1,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  // sanitizeURL
  !1
  // removeEmptyString
);
["src", "href", "action", "formAction"].forEach((e) => {
  vr[e] = new Br(
    e,
    Vo,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !0,
    // sanitizeURL
    !0
    // removeEmptyString
  );
});
const {
  CAMELCASE: xU,
  SAME: _U,
  possibleStandardNames: ky
} = up, NU = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", SU = NU + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", EU = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + SU + "]*$")
), CU = Object.keys(
  ky
).reduce((e, t) => {
  const n = ky[t];
  return n === _U ? e[t] = t : n === xU ? e[t.toLowerCase()] = t : e[t] = n, e;
}, {});
Qi.BOOLEAN = fp;
Qi.BOOLEANISH_STRING = dp;
Qi.NUMERIC = F3;
Qi.OVERLOADED_BOOLEAN = x1;
Qi.POSITIVE_NUMERIC = I3;
Qi.RESERVED = T3;
Qi.STRING = Vo;
Qi.getPropertyInfo = vU;
Qi.isCustomAttribute = EU;
Qi.possibleStandardNames = CU;
var S1 = {}, E1 = {}, Dy = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, OU = /\n/g, jU = /^\s*/, PU = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, LU = /^:\s*/, TU = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, FU = /^[;\s]*/, IU = /^\s+|\s+$/g, kU = `
`, Ry = "/", My = "*", rs = "", DU = "comment", RU = "declaration", MU = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(N) {
    var b = N.match(OU);
    b && (n += b.length);
    var S = N.lastIndexOf(kU);
    r = ~S ? N.length - S : r + N.length;
  }
  function a() {
    var N = { line: n, column: r };
    return function(b) {
      return b.position = new o(N), c(), b;
    };
  }
  function o(N) {
    this.start = N, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(N) {
    var b = new Error(
      t.source + ":" + n + ":" + r + ": " + N
    );
    if (b.reason = N, b.filename = t.source, b.line = n, b.column = r, b.source = e, !t.silent) throw b;
  }
  function l(N) {
    var b = N.exec(e);
    if (b) {
      var S = b[0];
      return i(S), e = e.slice(S.length), b;
    }
  }
  function c() {
    l(jU);
  }
  function d(N) {
    var b;
    for (N = N || []; b = p(); )
      b !== !1 && N.push(b);
    return N;
  }
  function p() {
    var N = a();
    if (!(Ry != e.charAt(0) || My != e.charAt(1))) {
      for (var b = 2; rs != e.charAt(b) && (My != e.charAt(b) || Ry != e.charAt(b + 1)); )
        ++b;
      if (b += 2, rs === e.charAt(b - 1))
        return s("End of comment missing");
      var S = e.slice(2, b - 2);
      return r += 2, i(S), e = e.slice(b), r += 2, N({
        type: DU,
        comment: S
      });
    }
  }
  function y() {
    var N = a(), b = l(PU);
    if (b) {
      if (p(), !l(LU)) return s("property missing ':'");
      var S = l(TU), _ = N({
        type: RU,
        property: Uy(b[0].replace(Dy, rs)),
        value: S ? Uy(S[0].replace(Dy, rs)) : rs
      });
      return l(FU), _;
    }
  }
  function f() {
    var N = [];
    d(N);
    for (var b; b = y(); )
      b !== !1 && (N.push(b), d(N));
    return N;
  }
  return c(), f();
};
function Uy(e) {
  return e ? e.replace(IU, rs) : rs;
}
var UU = xn && xn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(E1, "__esModule", { value: !0 });
E1.default = zU;
var BU = UU(MU);
function zU(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, BU.default)(e), i = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, s = a.value;
      i ? t(o, s, a) : s && (n = n || {}, n[o] = s);
    }
  }), n;
}
var pp = {};
Object.defineProperty(pp, "__esModule", { value: !0 });
pp.camelCase = void 0;
var qU = /^--[a-zA-Z0-9_-]+$/, VU = /-([a-z])/g, WU = /^[^-]+$/, HU = /^-(webkit|moz|ms|o|khtml)-/, $U = /^-(ms)-/, GU = function(e) {
  return !e || WU.test(e) || qU.test(e);
}, QU = function(e, t) {
  return t.toUpperCase();
}, By = function(e, t) {
  return "".concat(t, "-");
}, YU = function(e, t) {
  return t === void 0 && (t = {}), GU(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace($U, By) : e = e.replace(HU, By), e.replace(VU, QU));
};
pp.camelCase = YU;
var KU = xn && xn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, XU = KU(E1), ZU = pp;
function Wm(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, XU.default)(e, function(r, i) {
    r && i && (n[(0, ZU.camelCase)(r, t)] = i);
  }), n;
}
Wm.default = Wm;
var JU = Wm;
(function(e) {
  var t = xn && xn.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = a, e.setStyleProp = s;
  var n = gt, r = t(JU), i = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function a(d, p) {
    return d.includes("-") ? !i.has(d) : !!(p && typeof p.is == "string");
  }
  var o = {
    reactCompat: !0
  };
  function s(d, p) {
    if (typeof d == "string") {
      if (!d.trim()) {
        p.style = {};
        return;
      }
      try {
        p.style = (0, r.default)(d, o);
      } catch {
        p.style = {};
      }
    }
  }
  e.PRESERVE_CUSTOM_ATTRIBUTES = Number(n.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var l = function(d) {
    return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(d.name);
  };
  e.canTextBeChildOfNode = l;
  var c = function(d) {
    return d;
  };
  e.returnFirstArg = c;
})(S1);
Object.defineProperty(cp, "__esModule", { value: !0 });
cp.default = nB;
var Tc = Qi, zy = S1, AU = ["checked", "value"], eB = ["input", "select", "textarea"], tB = {
  reset: !0,
  submit: !0
};
function nB(e, t) {
  e === void 0 && (e = {});
  var n = {}, r = !!(e.type && tB[e.type]);
  for (var i in e) {
    var a = e[i];
    if ((0, Tc.isCustomAttribute)(i)) {
      n[i] = a;
      continue;
    }
    var o = i.toLowerCase(), s = qy(o);
    if (s) {
      var l = (0, Tc.getPropertyInfo)(s);
      switch (AU.includes(s) && eB.includes(t) && !r && (s = qy("default" + o)), n[s] = a, l && l.type) {
        case Tc.BOOLEAN:
          n[s] = !0;
          break;
        case Tc.OVERLOADED_BOOLEAN:
          a === "" && (n[s] = !0);
          break;
      }
      continue;
    }
    zy.PRESERVE_CUSTOM_ATTRIBUTES && (n[i] = a);
  }
  return (0, zy.setStyleProp)(e.style, n), n;
}
function qy(e) {
  return Tc.possibleStandardNames[e];
}
var C1 = {}, rB = xn && xn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(C1, "__esModule", { value: !0 });
C1.default = k3;
var kh = gt, iB = rB(cp), Wc = S1, aB = {
  cloneElement: kh.cloneElement,
  createElement: kh.createElement,
  isValidElement: kh.isValidElement
};
function k3(e, t) {
  t === void 0 && (t = {});
  for (var n = [], r = typeof t.replace == "function", i = t.transform || Wc.returnFirstArg, a = t.library || aB, o = a.cloneElement, s = a.createElement, l = a.isValidElement, c = e.length, d = 0; d < c; d++) {
    var p = e[d];
    if (r) {
      var y = t.replace(p, d);
      if (l(y)) {
        c > 1 && (y = o(y, {
          key: y.key || d
        })), n.push(i(y, p, d));
        continue;
      }
    }
    if (p.type === "text") {
      var f = !p.data.trim().length;
      if (f && p.parent && !(0, Wc.canTextBeChildOfNode)(p.parent) || t.trim && f)
        continue;
      n.push(i(p.data, p, d));
      continue;
    }
    var N = p, b = {};
    oB(N) ? ((0, Wc.setStyleProp)(N.attribs.style, N.attribs), b = N.attribs) : N.attribs && (b = (0, iB.default)(N.attribs, N.name));
    var S = void 0;
    switch (p.type) {
      case "script":
      case "style":
        p.children[0] && (b.dangerouslySetInnerHTML = {
          __html: p.children[0].data
        });
        break;
      case "tag":
        p.name === "textarea" && p.children[0] ? b.defaultValue = p.children[0].data : p.children && p.children.length && (S = k3(p.children, t));
        break;
      default:
        continue;
    }
    c > 1 && (b.key = d), n.push(i(s(p.name, b, S), p, d));
  }
  return n.length === 1 ? n[0] : n;
}
function oB(e) {
  return Wc.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && (0, Wc.isCustomComponent)(e.name, e.attribs);
}
(function(e) {
  var t = xn && xn.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = s;
  var n = t(m1);
  e.htmlToDOM = n.default;
  var r = t(cp);
  e.attributesToProps = r.default;
  var i = t(C1);
  e.domToReact = i.default;
  var a = y1;
  Object.defineProperty(e, "Comment", { enumerable: !0, get: function() {
    return a.Comment;
  } }), Object.defineProperty(e, "Element", { enumerable: !0, get: function() {
    return a.Element;
  } }), Object.defineProperty(e, "ProcessingInstruction", { enumerable: !0, get: function() {
    return a.ProcessingInstruction;
  } }), Object.defineProperty(e, "Text", { enumerable: !0, get: function() {
    return a.Text;
  } });
  var o = { lowerCaseAttributeNames: !1 };
  function s(l, c) {
    if (typeof l != "string")
      throw new TypeError("First argument must be a string");
    return l ? (0, i.default)((0, n.default)(l, (c == null ? void 0 : c.htmlparser2) || o), c) : [];
  }
})(h3);
const Vy = /* @__PURE__ */ ha(h3), uf = Vy.default || Vy;
class sB extends R.Component {
  render() {
    const {
      superSegment: t,
      persona: n
    } = this.props;
    let r;
    return t && n && (r = t.segments.find((i) => parseInt(i.id) === parseInt(n))), /* @__PURE__ */ m.jsxs("div", { className: "active-persona-panel", children: [
      /* @__PURE__ */ m.jsxs("div", { className: "active-persona-panel__content", children: [
        /* @__PURE__ */ m.jsxs("div", { className: "active-persona-panel__title", children: [
          /* @__PURE__ */ m.jsx("span", { children: r && r.id }),
          /* @__PURE__ */ m.jsxs("span", { className: "active-persona-panel__community-title", children: [
            t.id,
            " ",
            t.label
          ] })
        ] }),
        /* @__PURE__ */ m.jsx("div", { className: "active-persona-tile__name", children: r && r.label }),
        /* @__PURE__ */ m.jsxs("div", { className: "active-persona-tile__stats-container", children: [
          /* @__PURE__ */ m.jsxs("span", { className: "active-persona-tile-stat", children: [
            /* @__PURE__ */ m.jsx("span", { className: "active-persona-tile-stat__icon", children: r && r.acf.excerptIcon1 && /* @__PURE__ */ m.jsx(qc, { src: r.acf.excerptIcon1.image.url, colour: r.color }) }),
            r && r.acf.excerptNumberOnLeft1 && /* @__PURE__ */ m.jsxs("span", { className: "active-persona-panel__figure", children: [
              r && r.acf.excerptValue1,
              " ",
              r && r.acf.excerptLabel1
            ] }),
            r && !r.acf.excerptNumberOnLeft1 && /* @__PURE__ */ m.jsxs("span", { className: "active-persona-panel__figure", children: [
              r && r.acf.excerptLabel1,
              " ",
              r && r.acf.excerptValue1
            ] })
          ] }),
          /* @__PURE__ */ m.jsxs("span", { className: "active-persona-tile-stat", children: [
            /* @__PURE__ */ m.jsx("span", { className: "active-persona-tile-stat__icon", children: r && r.acf.excerptIcon2 && /* @__PURE__ */ m.jsx(qc, { src: r && r.acf.excerptIcon2.image.url, colour: r && r.color }) }),
            r && r.acf.excerptNumberOnLeft2 && /* @__PURE__ */ m.jsxs("span", { className: "active-persona-panel__figure", children: [
              r && r.acf.excerptValue2,
              " ",
              r && r.acf.excerptLabel2
            ] }),
            r && !r.acf.excerptNumberOnLeft2 && /* @__PURE__ */ m.jsxs("span", { className: "active-persona-panel__figure", children: [
              r && r.acf.excerptLabel2,
              " ",
              r && r.acf.excerptValue2
            ] })
          ] })
        ] }),
        uf(r && r.acf.summaryExcerpt)
      ] }),
      /* @__PURE__ */ m.jsx("div", { className: "active-persona-panel__images", children: r && r.knowMeGallery && r.knowMeGallery.map((i, a) => /* @__PURE__ */ m.jsx("div", { className: "active-persona-panel__image", children: /* @__PURE__ */ m.jsx(qc, { src: i.sizes.medium }) }, a)) })
    ] });
  }
}
class lB extends R.Component {
  constructor(t) {
    super(t), et(this, "setActivePersona", (n) => {
      this.setState({
        ...this.state,
        activePersona: n
      });
    }), et(this, "removeClick", (n) => {
      this.props.removePersona(n);
      const r = this.props.personas.filter((i) => i.id !== n.id);
      this.state.activePersona === n.id && (r.length ? this.setState({
        activePersona: r[0].id
      }) : this.setState({
        activePersona: void 0
      }));
    }), this.state = {
      activePersona: this.props.personas.length > 0 && this.props.personas[0].id ? this.props.personas[0].id : void 0
    };
  }
  componentDidUpdate(t, n) {
    t.personas.length === 0 && this.props.personas.length > 0 && this.setState({
      ...this.state,
      activePersona: this.props.personas[0].id
    }), !(this.state.activePersona && this.props.personas.filter((r) => r.id === this.state.activePersona).length) && this.state.activePersona && this.props.personas.length && this.setState({
      ...this.state,
      activePersona: this.props.personas[0].id
    });
  }
  render() {
    const {
      personas: t,
      superSegments: n
    } = this.props, {
      activePersona: r
    } = this.state;
    return /* @__PURE__ */ m.jsxs("div", { className: "active-persona-list", children: [
      /* @__PURE__ */ m.jsx("h2", { className: "active-persona-list__title", children: "Personas" }),
      /* @__PURE__ */ m.jsxs("div", { className: "active-persona-list__items", children: [
        /* @__PURE__ */ m.jsxs("div", { className: "active-persona-list__personas", children: [
          /* @__PURE__ */ m.jsx("hr", { className: "active-persona-list__ruler" }),
          /* @__PURE__ */ m.jsx("ul", { className: "active-persona-list__personas-list", children: t && t.length ? t.map((i, a) => /* @__PURE__ */ m.jsxs("li", { className: `active-persona-list__persona ${r === i.id ? "active" : ""}`, children: [
            /* @__PURE__ */ m.jsx("button", { className: "active-persona-list__close-button", onClick: () => this.removeClick(i), children: /* @__PURE__ */ m.jsx(h1, { className: "active-persona-list__close-icon", colour: "paleSky", name: "close" }) }),
            /* @__PURE__ */ m.jsxs("button", { className: "active-persona-list__active-button", onClick: () => this.setActivePersona(i.id), children: [
              i.id,
              " ",
              i.name
            ] })
          ] }, a)) : "Select some personas to get started." })
        ] }),
        /* @__PURE__ */ m.jsx("div", { className: "active-persona-list__info-wrapper", children: n && r && t && t.length > 0 && /* @__PURE__ */ m.jsx("div", { className: "active-persona-list__info-panel", children: r && n[parseInt(Math.floor(parseInt(r) / 100) * 100)] ? /* @__PURE__ */ m.jsx(sB, { superSegment: n[parseInt(Math.floor(parseInt(r) / 100) * 100)], persona: r }) : "No active persona" }) })
      ] })
    ] });
  }
}
class cB extends R.Component {
  constructor(t) {
    super(t), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "handleCheckBoxAction", () => {
      this.props.loadGroupedPersona();
    }), this.state = {
      showSidebar: !1
    };
  }
  componentDidMount() {
    this.props.loadSuperSegments(), this.props.featureAccess();
  }
  render() {
    const {
      selectedPersonas: t,
      removeSelectedPersona: n,
      superSegments: r,
      campaignCreatorAccess: i
    } = this.props, {
      showSidebar: a
    } = this.state, o = () => /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsx($t, { className: "grouped-personas__icon", name: "bars", size: "large", onClick: this.toggleSidebar }),
      /* @__PURE__ */ m.jsx("h2", { className: "grouped-personas__sub-title", children: "Select Personas" })
    ] });
    return /* @__PURE__ */ m.jsx("div", { children: i ? /* @__PURE__ */ m.jsx("div", { className: "campaign-creator-page", children: /* @__PURE__ */ m.jsxs("div", { className: "grouped-personas__row", children: [
      /* @__PURE__ */ m.jsx(f1, { open: a, title: /* @__PURE__ */ m.jsx(o, {}), body: /* @__PURE__ */ m.jsx("div", { className: "scroll-box", children: /* @__PURE__ */ m.jsx(a3, { expanded: !0, handleCheckBoxAction: this.handleCheckBoxAction }) }) }),
      /* @__PURE__ */ m.jsx("div", { className: "select-personas__body", children: /* @__PURE__ */ m.jsx(lB, { removePersona: n, personas: t, superSegments: r }) })
    ] }) }) : "" });
  }
}
const uB = (e, t) => {
  const n = e.options.permissions && e.options.permissions.workflowPermission;
  return {
    selectedPersonas: e.selectedPersonas.personas,
    superSegments: e.superSegments.bySlug,
    // Finish off changing to super segments
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess
  };
}, dB = (e) => Kt({
  removeSelectedPersona: Es,
  loadSuperSegments: zo,
  featureAccess: ui,
  loadGroupedPersona: Ss
}, e);
Mt(uB, dB)(cB);
function fB({
  page: e,
  message: t
}) {
  const n = tp(), r = oa((a) => a.campaignCreator.helperMessage[e]);
  function i() {
    n(a1(e, !1));
  }
  return /* @__PURE__ */ m.jsx(We, { className: `briefs-helper--wrapper__${e}`, style: {
    display: r ? "flex" : "none"
  }, children: /* @__PURE__ */ m.jsxs(We.Row, { style: {
    backgroundColor: "#647080",
    color: "white",
    paddingLeft: "12px",
    paddingRight: "12px"
  }, children: [
    /* @__PURE__ */ m.jsx(We.Column, { computer: 10, children: t }),
    /* @__PURE__ */ m.jsx(We.Column, { computer: 2, style: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end"
    }, children: /* @__PURE__ */ m.jsx(Ft, { className: "briefs-helper--button", onClick: i, children: "Ok, got it" }) })
  ] }) });
}
function pB({
  page: e
}) {
  const t = tp(), n = oa((i) => i.campaignCreator.helperMessage[e]), r = () => {
    t(a1(e, !0));
  };
  return n ? null : /* @__PURE__ */ m.jsx(Ft, { className: "creative-briefs__helper-message-button", onClick: r, children: /* @__PURE__ */ m.jsx($t, { name: "info circle big", className: "creative-briefs__helper-message-icon" }) });
}
var Cr = Uint8Array, ai = Uint16Array, O1 = Int32Array, hp = new Cr([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), mp = new Cr([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), Hm = new Cr([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), D3 = function(e, t) {
  for (var n = new ai(31), r = 0; r < 31; ++r)
    n[r] = t += 1 << e[r - 1];
  for (var i = new O1(n[30]), r = 1; r < 30; ++r)
    for (var a = n[r]; a < n[r + 1]; ++a)
      i[a] = a - n[r] << 5 | r;
  return { b: n, r: i };
}, R3 = D3(hp, 2), M3 = R3.b, $m = R3.r;
M3[28] = 258, $m[258] = 28;
var U3 = D3(mp, 0), hB = U3.b, Wy = U3.r, Gm = new ai(32768);
for (var En = 0; En < 32768; ++En) {
  var io = (En & 43690) >> 1 | (En & 21845) << 1;
  io = (io & 52428) >> 2 | (io & 13107) << 2, io = (io & 61680) >> 4 | (io & 3855) << 4, Gm[En] = ((io & 65280) >> 8 | (io & 255) << 8) >> 1;
}
var sa = function(e, t, n) {
  for (var r = e.length, i = 0, a = new ai(t); i < r; ++i)
    e[i] && ++a[e[i] - 1];
  var o = new ai(t);
  for (i = 1; i < t; ++i)
    o[i] = o[i - 1] + a[i - 1] << 1;
  var s;
  if (n) {
    s = new ai(1 << t);
    var l = 15 - t;
    for (i = 0; i < r; ++i)
      if (e[i])
        for (var c = i << 4 | e[i], d = t - e[i], p = o[e[i] - 1]++ << d, y = p | (1 << d) - 1; p <= y; ++p)
          s[Gm[p] >> l] = c;
  } else
    for (s = new ai(r), i = 0; i < r; ++i)
      e[i] && (s[i] = Gm[o[e[i] - 1]++] >> 15 - e[i]);
  return s;
}, To = new Cr(288);
for (var En = 0; En < 144; ++En)
  To[En] = 8;
for (var En = 144; En < 256; ++En)
  To[En] = 9;
for (var En = 256; En < 280; ++En)
  To[En] = 7;
for (var En = 280; En < 288; ++En)
  To[En] = 8;
var tu = new Cr(32);
for (var En = 0; En < 32; ++En)
  tu[En] = 5;
var mB = /* @__PURE__ */ sa(To, 9, 0), gB = /* @__PURE__ */ sa(To, 9, 1), yB = /* @__PURE__ */ sa(tu, 5, 0), vB = /* @__PURE__ */ sa(tu, 5, 1), Dh = function(e) {
  for (var t = e[0], n = 1; n < e.length; ++n)
    e[n] > t && (t = e[n]);
  return t;
}, Bi = function(e, t, n) {
  var r = t / 8 | 0;
  return (e[r] | e[r + 1] << 8) >> (t & 7) & n;
}, Rh = function(e, t) {
  var n = t / 8 | 0;
  return (e[n] | e[n + 1] << 8 | e[n + 2] << 16) >> (t & 7);
}, j1 = function(e) {
  return (e + 7) / 8 | 0;
}, B3 = function(e, t, n) {
  return (n == null || n > e.length) && (n = e.length), new Cr(e.subarray(t, n));
}, bB = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
  // determined by unknown compression method
], Wi = function(e, t, n) {
  var r = new Error(t || bB[e]);
  if (r.code = e, Error.captureStackTrace && Error.captureStackTrace(r, Wi), !n)
    throw r;
  return r;
}, wB = function(e, t, n, r) {
  var i = e.length, a = 0;
  if (!i || t.f && !t.l)
    return n || new Cr(0);
  var o = !n, s = o || t.i != 2, l = t.i;
  o && (n = new Cr(i * 3));
  var c = function(_e) {
    var pe = n.length;
    if (_e > pe) {
      var je = new Cr(Math.max(pe * 2, _e));
      je.set(n), n = je;
    }
  }, d = t.f || 0, p = t.p || 0, y = t.b || 0, f = t.l, N = t.d, b = t.m, S = t.n, _ = i * 8;
  do {
    if (!f) {
      d = Bi(e, p, 1);
      var E = Bi(e, p + 1, 3);
      if (p += 3, E)
        if (E == 1)
          f = gB, N = vB, b = 9, S = 5;
        else if (E == 2) {
          var k = Bi(e, p, 31) + 257, M = Bi(e, p + 10, 15) + 4, F = k + Bi(e, p + 5, 31) + 1;
          p += 14;
          for (var q = new Cr(F), j = new Cr(19), x = 0; x < M; ++x)
            j[Hm[x]] = Bi(e, p + x * 3, 7);
          p += M * 3;
          for (var C = Dh(j), D = (1 << C) - 1, P = sa(j, C, 1), x = 0; x < F; ) {
            var L = P[Bi(e, p, D)];
            p += L & 15;
            var H = L >> 4;
            if (H < 16)
              q[x++] = H;
            else {
              var $ = 0, ae = 0;
              for (H == 16 ? (ae = 3 + Bi(e, p, 3), p += 2, $ = q[x - 1]) : H == 17 ? (ae = 3 + Bi(e, p, 7), p += 3) : H == 18 && (ae = 11 + Bi(e, p, 127), p += 7); ae--; )
                q[x++] = $;
            }
          }
          var ce = q.subarray(0, k), le = q.subarray(k);
          b = Dh(ce), S = Dh(le), f = sa(ce, b, 1), N = sa(le, S, 1);
        } else
          Wi(1);
      else {
        var H = j1(p) + 4, oe = e[H - 4] | e[H - 3] << 8, se = H + oe;
        if (se > i) {
          l && Wi(0);
          break;
        }
        s && c(y + oe), n.set(e.subarray(H, se), y), t.b = y += oe, t.p = p = se * 8, t.f = d;
        continue;
      }
      if (p > _) {
        l && Wi(0);
        break;
      }
    }
    s && c(y + 131072);
    for (var J = (1 << b) - 1, re = (1 << S) - 1, I = p; ; I = p) {
      var $ = f[Rh(e, p) & J], U = $ >> 4;
      if (p += $ & 15, p > _) {
        l && Wi(0);
        break;
      }
      if ($ || Wi(2), U < 256)
        n[y++] = U;
      else if (U == 256) {
        I = p, f = null;
        break;
      } else {
        var G = U - 254;
        if (U > 264) {
          var x = U - 257, K = hp[x];
          G = Bi(e, p, (1 << K) - 1) + M3[x], p += K;
        }
        var A = N[Rh(e, p) & re], ee = A >> 4;
        A || Wi(3), p += A & 15;
        var le = hB[ee];
        if (ee > 3) {
          var K = mp[ee];
          le += Rh(e, p) & (1 << K) - 1, p += K;
        }
        if (p > _) {
          l && Wi(0);
          break;
        }
        s && c(y + 131072);
        var te = y + G;
        if (y < le) {
          var ne = a - le, ve = Math.min(le, te);
          for (ne + y < 0 && Wi(3); y < ve; ++y)
            n[y] = r[ne + y];
        }
        for (; y < te; ++y)
          n[y] = n[y - le];
      }
    }
    t.l = f, t.p = I, t.b = y, t.f = d, f && (d = 1, t.m = b, t.d = N, t.n = S);
  } while (!d);
  return y != n.length && o ? B3(n, 0, y) : n.subarray(0, y);
}, Oa = function(e, t, n) {
  n <<= t & 7;
  var r = t / 8 | 0;
  e[r] |= n, e[r + 1] |= n >> 8;
}, _c = function(e, t, n) {
  n <<= t & 7;
  var r = t / 8 | 0;
  e[r] |= n, e[r + 1] |= n >> 8, e[r + 2] |= n >> 16;
}, Mh = function(e, t) {
  for (var n = [], r = 0; r < e.length; ++r)
    e[r] && n.push({ s: r, f: e[r] });
  var i = n.length, a = n.slice();
  if (!i)
    return { t: q3, l: 0 };
  if (i == 1) {
    var o = new Cr(n[0].s + 1);
    return o[n[0].s] = 1, { t: o, l: 1 };
  }
  n.sort(function(F, q) {
    return F.f - q.f;
  }), n.push({ s: -1, f: 25001 });
  var s = n[0], l = n[1], c = 0, d = 1, p = 2;
  for (n[0] = { s: -1, f: s.f + l.f, l: s, r: l }; d != i - 1; )
    s = n[n[c].f < n[p].f ? c++ : p++], l = n[c != d && n[c].f < n[p].f ? c++ : p++], n[d++] = { s: -1, f: s.f + l.f, l: s, r: l };
  for (var y = a[0].s, r = 1; r < i; ++r)
    a[r].s > y && (y = a[r].s);
  var f = new ai(y + 1), N = Qm(n[d - 1], f, 0);
  if (N > t) {
    var r = 0, b = 0, S = N - t, _ = 1 << S;
    for (a.sort(function(q, j) {
      return f[j.s] - f[q.s] || q.f - j.f;
    }); r < i; ++r) {
      var E = a[r].s;
      if (f[E] > t)
        b += _ - (1 << N - f[E]), f[E] = t;
      else
        break;
    }
    for (b >>= S; b > 0; ) {
      var k = a[r].s;
      f[k] < t ? b -= 1 << t - f[k]++ - 1 : ++r;
    }
    for (; r >= 0 && b; --r) {
      var M = a[r].s;
      f[M] == t && (--f[M], ++b);
    }
    N = t;
  }
  return { t: new Cr(f), l: N };
}, Qm = function(e, t, n) {
  return e.s == -1 ? Math.max(Qm(e.l, t, n + 1), Qm(e.r, t, n + 1)) : t[e.s] = n;
}, Hy = function(e) {
  for (var t = e.length; t && !e[--t]; )
    ;
  for (var n = new ai(++t), r = 0, i = e[0], a = 1, o = function(l) {
    n[r++] = l;
  }, s = 1; s <= t; ++s)
    if (e[s] == i && s != t)
      ++a;
    else {
      if (!i && a > 2) {
        for (; a > 138; a -= 138)
          o(32754);
        a > 2 && (o(a > 10 ? a - 11 << 5 | 28690 : a - 3 << 5 | 12305), a = 0);
      } else if (a > 3) {
        for (o(i), --a; a > 6; a -= 6)
          o(8304);
        a > 2 && (o(a - 3 << 5 | 8208), a = 0);
      }
      for (; a--; )
        o(i);
      a = 1, i = e[s];
    }
  return { c: n.subarray(0, r), n: t };
}, Nc = function(e, t) {
  for (var n = 0, r = 0; r < t.length; ++r)
    n += e[r] * t[r];
  return n;
}, z3 = function(e, t, n) {
  var r = n.length, i = j1(t + 2);
  e[i] = r & 255, e[i + 1] = r >> 8, e[i + 2] = e[i] ^ 255, e[i + 3] = e[i + 1] ^ 255;
  for (var a = 0; a < r; ++a)
    e[i + a + 4] = n[a];
  return (i + 4 + r) * 8;
}, $y = function(e, t, n, r, i, a, o, s, l, c, d) {
  Oa(t, d++, n), ++i[256];
  for (var p = Mh(i, 15), y = p.t, f = p.l, N = Mh(a, 15), b = N.t, S = N.l, _ = Hy(y), E = _.c, k = _.n, M = Hy(b), F = M.c, q = M.n, j = new ai(19), x = 0; x < E.length; ++x)
    ++j[E[x] & 31];
  for (var x = 0; x < F.length; ++x)
    ++j[F[x] & 31];
  for (var C = Mh(j, 7), D = C.t, P = C.l, L = 19; L > 4 && !D[Hm[L - 1]]; --L)
    ;
  var H = c + 5 << 3, $ = Nc(i, To) + Nc(a, tu) + o, ae = Nc(i, y) + Nc(a, b) + o + 14 + 3 * L + Nc(j, D) + 2 * j[16] + 3 * j[17] + 7 * j[18];
  if (l >= 0 && H <= $ && H <= ae)
    return z3(t, d, e.subarray(l, l + c));
  var ce, le, oe, se;
  if (Oa(t, d, 1 + (ae < $)), d += 2, ae < $) {
    ce = sa(y, f, 0), le = y, oe = sa(b, S, 0), se = b;
    var J = sa(D, P, 0);
    Oa(t, d, k - 257), Oa(t, d + 5, q - 1), Oa(t, d + 10, L - 4), d += 14;
    for (var x = 0; x < L; ++x)
      Oa(t, d + 3 * x, D[Hm[x]]);
    d += 3 * L;
    for (var re = [E, F], I = 0; I < 2; ++I)
      for (var U = re[I], x = 0; x < U.length; ++x) {
        var G = U[x] & 31;
        Oa(t, d, J[G]), d += D[G], G > 15 && (Oa(t, d, U[x] >> 5 & 127), d += U[x] >> 12);
      }
  } else
    ce = mB, le = To, oe = yB, se = tu;
  for (var x = 0; x < s; ++x) {
    var K = r[x];
    if (K > 255) {
      var G = K >> 18 & 31;
      _c(t, d, ce[G + 257]), d += le[G + 257], G > 7 && (Oa(t, d, K >> 23 & 31), d += hp[G]);
      var A = K & 31;
      _c(t, d, oe[A]), d += se[A], A > 3 && (_c(t, d, K >> 5 & 8191), d += mp[A]);
    } else
      _c(t, d, ce[K]), d += le[K];
  }
  return _c(t, d, ce[256]), d + le[256];
}, xB = /* @__PURE__ */ new O1([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), q3 = /* @__PURE__ */ new Cr(0), _B = function(e, t, n, r, i, a) {
  var o = a.z || e.length, s = new Cr(r + o + 5 * (1 + Math.ceil(o / 7e3)) + i), l = s.subarray(r, s.length - i), c = a.l, d = (a.r || 0) & 7;
  if (t) {
    d && (l[0] = a.r >> 3);
    for (var p = xB[t - 1], y = p >> 13, f = p & 8191, N = (1 << n) - 1, b = a.p || new ai(32768), S = a.h || new ai(N + 1), _ = Math.ceil(n / 3), E = 2 * _, k = function(Se) {
      return (e[Se] ^ e[Se + 1] << _ ^ e[Se + 2] << E) & N;
    }, M = new O1(25e3), F = new ai(288), q = new ai(32), j = 0, x = 0, C = a.i || 0, D = 0, P = a.w || 0, L = 0; C + 2 < o; ++C) {
      var H = k(C), $ = C & 32767, ae = S[H];
      if (b[$] = ae, S[H] = $, P <= C) {
        var ce = o - C;
        if ((j > 7e3 || D > 24576) && (ce > 423 || !c)) {
          d = $y(e, l, 0, M, F, q, x, D, L, C - L, d), D = j = x = 0, L = C;
          for (var le = 0; le < 286; ++le)
            F[le] = 0;
          for (var le = 0; le < 30; ++le)
            q[le] = 0;
        }
        var oe = 2, se = 0, J = f, re = $ - ae & 32767;
        if (ce > 2 && H == k(C - re))
          for (var I = Math.min(y, ce) - 1, U = Math.min(32767, C), G = Math.min(258, ce); re <= U && --J && $ != ae; ) {
            if (e[C + oe] == e[C + oe - re]) {
              for (var K = 0; K < G && e[C + K] == e[C + K - re]; ++K)
                ;
              if (K > oe) {
                if (oe = K, se = re, K > I)
                  break;
                for (var A = Math.min(re, K - 2), ee = 0, le = 0; le < A; ++le) {
                  var te = C - re + le & 32767, ne = b[te], ve = te - ne & 32767;
                  ve > ee && (ee = ve, ae = te);
                }
              }
            }
            $ = ae, ae = b[$], re += $ - ae & 32767;
          }
        if (se) {
          M[D++] = 268435456 | $m[oe] << 18 | Wy[se];
          var _e = $m[oe] & 31, pe = Wy[se] & 31;
          x += hp[_e] + mp[pe], ++F[257 + _e], ++q[pe], P = C + oe, ++j;
        } else
          M[D++] = e[C], ++F[e[C]];
      }
    }
    for (C = Math.max(C, P); C < o; ++C)
      M[D++] = e[C], ++F[e[C]];
    d = $y(e, l, c, M, F, q, x, D, L, C - L, d), c || (a.r = d & 7 | l[d / 8 | 0] << 3, d -= 7, a.h = S, a.p = b, a.i = C, a.w = P);
  } else {
    for (var C = a.w || 0; C < o + c; C += 65535) {
      var je = C + 65535;
      je >= o && (l[d / 8 | 0] = c, je = o), d = z3(l, d + 1, e.subarray(C, je));
    }
    a.i = o;
  }
  return B3(s, 0, r + j1(d) + i);
}, V3 = function() {
  var e = 1, t = 0;
  return {
    p: function(n) {
      for (var r = e, i = t, a = n.length | 0, o = 0; o != a; ) {
        for (var s = Math.min(o + 2655, a); o < s; ++o)
          i += r += n[o];
        r = (r & 65535) + 15 * (r >> 16), i = (i & 65535) + 15 * (i >> 16);
      }
      e = r, t = i;
    },
    d: function() {
      return e %= 65521, t %= 65521, (e & 255) << 24 | (e & 65280) << 8 | (t & 255) << 8 | t >> 8;
    }
  };
}, NB = function(e, t, n, r, i) {
  if (!i && (i = { l: 1 }, t.dictionary)) {
    var a = t.dictionary.subarray(-32768), o = new Cr(a.length + e.length);
    o.set(a), o.set(e, a.length), e = o, i.w = a.length;
  }
  return _B(e, t.level == null ? 6 : t.level, t.mem == null ? i.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 20 : 12 + t.mem, n, r, i);
}, W3 = function(e, t, n) {
  for (; n; ++t)
    e[t] = n, n >>>= 8;
}, SB = function(e, t) {
  var n = t.level, r = n == 0 ? 0 : n < 6 ? 1 : n == 9 ? 3 : 2;
  if (e[0] = 120, e[1] = r << 6 | (t.dictionary && 32), e[1] |= 31 - (e[0] << 8 | e[1]) % 31, t.dictionary) {
    var i = V3();
    i.p(t.dictionary), W3(e, 2, i.d());
  }
}, EB = function(e, t) {
  return ((e[0] & 15) != 8 || e[0] >> 4 > 7 || (e[0] << 8 | e[1]) % 31) && Wi(6, "invalid zlib data"), (e[1] >> 5 & 1) == 1 && Wi(6, "invalid zlib data: " + (e[1] & 32 ? "need" : "unexpected") + " dictionary"), (e[1] >> 3 & 4) + 2;
};
function Ym(e, t) {
  t || (t = {});
  var n = V3();
  n.p(e);
  var r = NB(e, t, t.dictionary ? 6 : 2, 4);
  return SB(r, t), W3(r, r.length - 4, n.d()), r;
}
function CB(e, t) {
  return wB(e.subarray(EB(e), -4), { i: 2 }, t, t);
}
var OB = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), jB = 0;
try {
  OB.decode(q3, { stream: !0 }), jB = 1;
} catch {
}
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.2 Built on 2024-09-17T13:29:57.859Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var wt = /* @__PURE__ */ function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
}();
function Uh() {
  wt.console && typeof wt.console.log == "function" && wt.console.log.apply(wt.console, arguments);
}
var hn = { log: Uh, warn: function(e) {
  wt.console && (typeof wt.console.warn == "function" ? wt.console.warn.apply(wt.console, arguments) : Uh.call(null, arguments));
}, error: function(e) {
  wt.console && (typeof wt.console.error == "function" ? wt.console.error.apply(wt.console, arguments) : Uh(e));
} };
function Bh(e, t, n) {
  var r = new XMLHttpRequest();
  r.open("GET", e), r.responseType = "blob", r.onload = function() {
    ts(r.response, t, n);
  }, r.onerror = function() {
    hn.error("could not download file");
  }, r.send();
}
function Gy(e) {
  var t = new XMLHttpRequest();
  t.open("HEAD", e, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function Yd(e) {
  try {
    e.dispatchEvent(new MouseEvent("click"));
  } catch {
    var t = document.createEvent("MouseEvents");
    t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
  }
}
var Hc, Km, ts = wt.saveAs || ((typeof window > "u" ? "undefined" : Yt(window)) !== "object" || window !== wt ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(e, t, n) {
  var r = wt.URL || wt.webkitURL, i = document.createElement("a");
  t = t || e.name || "download", i.download = t, i.rel = "noopener", typeof e == "string" ? (i.href = e, i.origin !== location.origin ? Gy(i.href) ? Bh(e, t, n) : Yd(i, i.target = "_blank") : Yd(i)) : (i.href = r.createObjectURL(e), setTimeout(function() {
    r.revokeObjectURL(i.href);
  }, 4e4), setTimeout(function() {
    Yd(i);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, t, n) {
  if (t = t || e.name || "download", typeof e == "string") if (Gy(e)) Bh(e, t, n);
  else {
    var r = document.createElement("a");
    r.href = e, r.target = "_blank", setTimeout(function() {
      Yd(r);
    });
  }
  else navigator.msSaveOrOpenBlob(function(i, a) {
    return a === void 0 ? a = { autoBom: !1 } : Yt(a) !== "object" && (hn.warn("Deprecated: Expected third argument to be a object"), a = { autoBom: !a }), a.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(i.type) ? new Blob(["\uFEFF", i], { type: i.type }) : i;
  }(e, n), t);
} : function(e, t, n, r) {
  if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), typeof e == "string") return Bh(e, t, n);
  var i = e.type === "application/octet-stream", a = /constructor/i.test(wt.HTMLElement) || wt.safari, o = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((o || i && a) && (typeof FileReader > "u" ? "undefined" : Yt(FileReader)) === "object") {
    var s = new FileReader();
    s.onloadend = function() {
      var d = s.result;
      d = o ? d : d.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = d : location = d, r = null;
    }, s.readAsDataURL(e);
  } else {
    var l = wt.URL || wt.webkitURL, c = l.createObjectURL(e);
    r ? r.location = c : location.href = c, r = null, setTimeout(function() {
      l.revokeObjectURL(c);
    }, 4e4);
  }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function H3(e) {
  var t;
  e = e || "", this.ok = !1, e.charAt(0) == "#" && (e = e.substr(1, 6)), e = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[e = (e = e.replace(/ /g, "")).toLowerCase()] || e;
  for (var n = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(s) {
    return [parseInt(s[1]), parseInt(s[2]), parseInt(s[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(s) {
    return [parseInt(s[1], 16), parseInt(s[2], 16), parseInt(s[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(s) {
    return [parseInt(s[1] + s[1], 16), parseInt(s[2] + s[2], 16), parseInt(s[3] + s[3], 16)];
  } }], r = 0; r < n.length; r++) {
    var i = n[r].re, a = n[r].process, o = i.exec(e);
    o && (t = a(o), this.r = t[0], this.g = t[1], this.b = t[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var s = this.r.toString(16), l = this.g.toString(16), c = this.b.toString(16);
    return s.length == 1 && (s = "0" + s), l.length == 1 && (l = "0" + l), c.length == 1 && (c = "0" + c), "#" + s + l + c;
  };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function zh(e, t) {
  var n = e[0], r = e[1], i = e[2], a = e[3];
  n = _r(n, r, i, a, t[0], 7, -680876936), a = _r(a, n, r, i, t[1], 12, -389564586), i = _r(i, a, n, r, t[2], 17, 606105819), r = _r(r, i, a, n, t[3], 22, -1044525330), n = _r(n, r, i, a, t[4], 7, -176418897), a = _r(a, n, r, i, t[5], 12, 1200080426), i = _r(i, a, n, r, t[6], 17, -1473231341), r = _r(r, i, a, n, t[7], 22, -45705983), n = _r(n, r, i, a, t[8], 7, 1770035416), a = _r(a, n, r, i, t[9], 12, -1958414417), i = _r(i, a, n, r, t[10], 17, -42063), r = _r(r, i, a, n, t[11], 22, -1990404162), n = _r(n, r, i, a, t[12], 7, 1804603682), a = _r(a, n, r, i, t[13], 12, -40341101), i = _r(i, a, n, r, t[14], 17, -1502002290), n = Nr(n, r = _r(r, i, a, n, t[15], 22, 1236535329), i, a, t[1], 5, -165796510), a = Nr(a, n, r, i, t[6], 9, -1069501632), i = Nr(i, a, n, r, t[11], 14, 643717713), r = Nr(r, i, a, n, t[0], 20, -373897302), n = Nr(n, r, i, a, t[5], 5, -701558691), a = Nr(a, n, r, i, t[10], 9, 38016083), i = Nr(i, a, n, r, t[15], 14, -660478335), r = Nr(r, i, a, n, t[4], 20, -405537848), n = Nr(n, r, i, a, t[9], 5, 568446438), a = Nr(a, n, r, i, t[14], 9, -1019803690), i = Nr(i, a, n, r, t[3], 14, -187363961), r = Nr(r, i, a, n, t[8], 20, 1163531501), n = Nr(n, r, i, a, t[13], 5, -1444681467), a = Nr(a, n, r, i, t[2], 9, -51403784), i = Nr(i, a, n, r, t[7], 14, 1735328473), n = Sr(n, r = Nr(r, i, a, n, t[12], 20, -1926607734), i, a, t[5], 4, -378558), a = Sr(a, n, r, i, t[8], 11, -2022574463), i = Sr(i, a, n, r, t[11], 16, 1839030562), r = Sr(r, i, a, n, t[14], 23, -35309556), n = Sr(n, r, i, a, t[1], 4, -1530992060), a = Sr(a, n, r, i, t[4], 11, 1272893353), i = Sr(i, a, n, r, t[7], 16, -155497632), r = Sr(r, i, a, n, t[10], 23, -1094730640), n = Sr(n, r, i, a, t[13], 4, 681279174), a = Sr(a, n, r, i, t[0], 11, -358537222), i = Sr(i, a, n, r, t[3], 16, -722521979), r = Sr(r, i, a, n, t[6], 23, 76029189), n = Sr(n, r, i, a, t[9], 4, -640364487), a = Sr(a, n, r, i, t[12], 11, -421815835), i = Sr(i, a, n, r, t[15], 16, 530742520), n = Er(n, r = Sr(r, i, a, n, t[2], 23, -995338651), i, a, t[0], 6, -198630844), a = Er(a, n, r, i, t[7], 10, 1126891415), i = Er(i, a, n, r, t[14], 15, -1416354905), r = Er(r, i, a, n, t[5], 21, -57434055), n = Er(n, r, i, a, t[12], 6, 1700485571), a = Er(a, n, r, i, t[3], 10, -1894986606), i = Er(i, a, n, r, t[10], 15, -1051523), r = Er(r, i, a, n, t[1], 21, -2054922799), n = Er(n, r, i, a, t[8], 6, 1873313359), a = Er(a, n, r, i, t[15], 10, -30611744), i = Er(i, a, n, r, t[6], 15, -1560198380), r = Er(r, i, a, n, t[13], 21, 1309151649), n = Er(n, r, i, a, t[4], 6, -145523070), a = Er(a, n, r, i, t[11], 10, -1120210379), i = Er(i, a, n, r, t[2], 15, 718787259), r = Er(r, i, a, n, t[9], 21, -343485551), e[0] = so(n, e[0]), e[1] = so(r, e[1]), e[2] = so(i, e[2]), e[3] = so(a, e[3]);
}
function gp(e, t, n, r, i, a) {
  return t = so(so(t, e), so(r, a)), so(t << i | t >>> 32 - i, n);
}
function _r(e, t, n, r, i, a, o) {
  return gp(t & n | ~t & r, e, t, i, a, o);
}
function Nr(e, t, n, r, i, a, o) {
  return gp(t & r | n & ~r, e, t, i, a, o);
}
function Sr(e, t, n, r, i, a, o) {
  return gp(t ^ n ^ r, e, t, i, a, o);
}
function Er(e, t, n, r, i, a, o) {
  return gp(n ^ (t | ~r), e, t, i, a, o);
}
function $3(e) {
  var t, n = e.length, r = [1732584193, -271733879, -1732584194, 271733878];
  for (t = 64; t <= e.length; t += 64) zh(r, PB(e.substring(t - 64, t)));
  e = e.substring(t - 64);
  var i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (t = 0; t < e.length; t++) i[t >> 2] |= e.charCodeAt(t) << (t % 4 << 3);
  if (i[t >> 2] |= 128 << (t % 4 << 3), t > 55) for (zh(r, i), t = 0; t < 16; t++) i[t] = 0;
  return i[14] = 8 * n, zh(r, i), r;
}
function PB(e) {
  var t, n = [];
  for (t = 0; t < 64; t += 4) n[t >> 2] = e.charCodeAt(t) + (e.charCodeAt(t + 1) << 8) + (e.charCodeAt(t + 2) << 16) + (e.charCodeAt(t + 3) << 24);
  return n;
}
Hc = wt.atob.bind(wt), Km = wt.btoa.bind(wt);
var Qy = "0123456789abcdef".split("");
function LB(e) {
  for (var t = "", n = 0; n < 4; n++) t += Qy[e >> 8 * n + 4 & 15] + Qy[e >> 8 * n & 15];
  return t;
}
function TB(e) {
  return String.fromCharCode((255 & e) >> 0, (65280 & e) >> 8, (16711680 & e) >> 16, (4278190080 & e) >> 24);
}
function Xm(e) {
  return $3(e).map(TB).join("");
}
var FB = function(e) {
  for (var t = 0; t < e.length; t++) e[t] = LB(e[t]);
  return e.join("");
}($3("hello")) != "5d41402abc4b2a76b9719d911017c592";
function so(e, t) {
  if (FB) {
    var n = (65535 & e) + (65535 & t);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
  }
  return e + t & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function Zm(e, t) {
  var n, r, i, a;
  if (e !== n) {
    for (var o = (i = e, a = 1 + (256 / e.length >> 0), new Array(a + 1).join(i)), s = [], l = 0; l < 256; l++) s[l] = l;
    var c = 0;
    for (l = 0; l < 256; l++) {
      var d = s[l];
      c = (c + d + o.charCodeAt(l)) % 256, s[l] = s[c], s[c] = d;
    }
    n = e, r = s;
  } else s = r;
  var p = t.length, y = 0, f = 0, N = "";
  for (l = 0; l < p; l++) f = (f + (d = s[y = (y + 1) % 256])) % 256, s[y] = s[f], s[f] = d, o = s[(s[y] + s[f]) % 256], N += String.fromCharCode(t.charCodeAt(l) ^ o);
  return N;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var Yy = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function nl(e, t, n, r) {
  this.v = 1, this.r = 2;
  var i = 192;
  e.forEach(function(s) {
    if (Yy.perm !== void 0) throw new Error("Invalid permission: " + s);
    i += Yy[s];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var a = (t + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = Xm(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = Zm(this.encryptionKey, this.padding);
}
function rl(e) {
  if (/[^\u0000-\u00ff]/.test(e)) throw new Error("Invalid PDF Name Object: " + e + ", Only accept ASCII characters.");
  for (var t = "", n = e.length, r = 0; r < n; r++) {
    var i = e.charCodeAt(r);
    i < 33 || i === 35 || i === 37 || i === 40 || i === 41 || i === 47 || i === 60 || i === 62 || i === 91 || i === 93 || i === 123 || i === 125 || i > 126 ? t += "#" + ("0" + i.toString(16)).slice(-2) : t += e[r];
  }
  return t;
}
function Ky(e) {
  if (Yt(e) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var t = {};
  this.subscribe = function(n, r, i) {
    if (i = i || !1, typeof n != "string" || typeof r != "function" || typeof i != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    t.hasOwnProperty(n) || (t[n] = {});
    var a = Math.random().toString(35);
    return t[n][a] = [r, !!i], a;
  }, this.unsubscribe = function(n) {
    for (var r in t) if (t[r][n]) return delete t[r][n], Object.keys(t[r]).length === 0 && delete t[r], !0;
    return !1;
  }, this.publish = function(n) {
    if (t.hasOwnProperty(n)) {
      var r = Array.prototype.slice.call(arguments, 1), i = [];
      for (var a in t[n]) {
        var o = t[n][a];
        try {
          o[0].apply(e, r);
        } catch (s) {
          wt.console && hn.error("jsPDF PubSub Error", s.message, s);
        }
        o[1] && i.push(a);
      }
      i.length && i.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return t;
  };
}
function Pf(e) {
  if (!(this instanceof Pf)) return new Pf(e);
  var t = "opacity,stroke-opacity".split(",");
  for (var n in e) e.hasOwnProperty(n) && t.indexOf(n) >= 0 && (this[n] = e[n]);
  this.id = "", this.objectNumber = -1;
}
function G3(e, t) {
  this.gState = e, this.matrix = t, this.id = "", this.objectNumber = -1;
}
function is(e, t, n, r, i) {
  if (!(this instanceof is)) return new is(e, t, n, r, i);
  this.type = e === "axial" ? 2 : 3, this.coords = t, this.colors = n, G3.call(this, r, i);
}
function ul(e, t, n, r, i) {
  if (!(this instanceof ul)) return new ul(e, t, n, r, i);
  this.boundingBox = e, this.xStep = t, this.yStep = n, this.stream = "", this.cloneIndex = 0, G3.call(this, r, i);
}
function xt(e) {
  var t, n = typeof arguments[0] == "string" ? arguments[0] : "p", r = arguments[1], i = arguments[2], a = arguments[3], o = [], s = 1, l = 16, c = "S", d = null;
  Yt(e = e || {}) === "object" && (n = e.orientation, r = e.unit || r, i = e.format || i, a = e.compress || e.compressPdf || a, (d = e.encryption || null) !== null && (d.userPassword = d.userPassword || "", d.ownerPassword = d.ownerPassword || "", d.userPermissions = d.userPermissions || []), s = typeof e.userUnit == "number" ? Math.abs(e.userUnit) : 1, e.precision !== void 0 && (t = e.precision), e.floatPrecision !== void 0 && (l = e.floatPrecision), c = e.defaultPathOperation || "S"), o = e.filters || (a === !0 ? ["FlateEncode"] : o), r = r || "mm", n = ("" + (n || "P")).toLowerCase();
  var p = e.putOnlyUsedFonts || !1, y = {}, f = { internal: {}, __private__: {} };
  f.__private__.PubSub = Ky;
  var N = "1.3", b = f.__private__.getPdfVersion = function() {
    return N;
  };
  f.__private__.setPdfVersion = function(v) {
    N = v;
  };
  var S = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  f.__private__.getPageFormats = function() {
    return S;
  };
  var _ = f.__private__.getPageFormat = function(v) {
    return S[v];
  };
  i = i || "a4";
  var E = { COMPAT: "compat", ADVANCED: "advanced" }, k = E.COMPAT;
  function M() {
    this.saveGraphicsState(), X(new ht($e, 0, 0, -$e, 0, $a() * $e).toString() + " cm"), this.setFontSize(this.getFontSize() / $e), c = "n", k = E.ADVANCED;
  }
  function F() {
    this.restoreGraphicsState(), c = "S", k = E.COMPAT;
  }
  var q = f.__private__.combineFontStyleAndFontWeight = function(v, z) {
    if (v == "bold" && z == "normal" || v == "bold" && z == 400 || v == "normal" && z == "italic" || v == "bold" && z == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return z && (v = z == 400 || z === "normal" ? v === "italic" ? "italic" : "normal" : z != 700 && z !== "bold" || v !== "normal" ? (z == 700 ? "bold" : z) + "" + v : "bold"), v;
  };
  f.advancedAPI = function(v) {
    var z = k === E.COMPAT;
    return z && M.call(this), typeof v != "function" || (v(this), z && F.call(this)), this;
  }, f.compatAPI = function(v) {
    var z = k === E.ADVANCED;
    return z && F.call(this), typeof v != "function" || (v(this), z && M.call(this)), this;
  }, f.isAdvancedAPI = function() {
    return k === E.ADVANCED;
  };
  var j, x = function(v) {
    if (k !== E.ADVANCED) throw new Error(v + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, C = f.roundToPrecision = f.__private__.roundToPrecision = function(v, z) {
    var ie = t || z;
    if (isNaN(v) || isNaN(ie)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return v.toFixed(ie).replace(/0+$/, "");
  };
  j = f.hpf = f.__private__.hpf = typeof l == "number" ? function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return C(v, l);
  } : l === "smart" ? function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return C(v, v > -1 && v < 1 ? 16 : 5);
  } : function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return C(v, 16);
  };
  var D = f.f2 = f.__private__.f2 = function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.f2");
    return C(v, 2);
  }, P = f.__private__.f3 = function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.f3");
    return C(v, 3);
  }, L = f.scale = f.__private__.scale = function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.scale");
    return k === E.COMPAT ? v * $e : k === E.ADVANCED ? v : void 0;
  }, H = function(v) {
    return k === E.COMPAT ? $a() - v : k === E.ADVANCED ? v : void 0;
  }, $ = function(v) {
    return L(H(v));
  };
  f.__private__.setPrecision = f.setPrecision = function(v) {
    typeof parseInt(v, 10) == "number" && (t = parseInt(v, 10));
  };
  var ae, ce = "00000000000000000000000000000000", le = f.__private__.getFileId = function() {
    return ce;
  }, oe = f.__private__.setFileId = function(v) {
    return ce = v !== void 0 && /^[a-fA-F0-9]{32}$/.test(v) ? v.toUpperCase() : ce.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), d !== null && (wr = new nl(d.userPermissions, d.userPassword, d.ownerPassword, ce)), ce;
  };
  f.setFileId = function(v) {
    return oe(v), this;
  }, f.getFileId = function() {
    return le();
  };
  var se = f.__private__.convertDateToPDFDate = function(v) {
    var z = v.getTimezoneOffset(), ie = z < 0 ? "+" : "-", he = Math.floor(Math.abs(z / 60)), Ee = Math.abs(z % 60), De = [ie, G(he), "'", G(Ee), "'"].join("");
    return ["D:", v.getFullYear(), G(v.getMonth() + 1), G(v.getDate()), G(v.getHours()), G(v.getMinutes()), G(v.getSeconds()), De].join("");
  }, J = f.__private__.convertPDFDateToDate = function(v) {
    var z = parseInt(v.substr(2, 4), 10), ie = parseInt(v.substr(6, 2), 10) - 1, he = parseInt(v.substr(8, 2), 10), Ee = parseInt(v.substr(10, 2), 10), De = parseInt(v.substr(12, 2), 10), He = parseInt(v.substr(14, 2), 10);
    return new Date(z, ie, he, Ee, De, He, 0);
  }, re = f.__private__.setCreationDate = function(v) {
    var z;
    if (v === void 0 && (v = /* @__PURE__ */ new Date()), v instanceof Date) z = se(v);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(v)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      z = v;
    }
    return ae = z;
  }, I = f.__private__.getCreationDate = function(v) {
    var z = ae;
    return v === "jsDate" && (z = J(ae)), z;
  };
  f.setCreationDate = function(v) {
    return re(v), this;
  }, f.getCreationDate = function(v) {
    return I(v);
  };
  var U, G = f.__private__.padd2 = function(v) {
    return ("0" + parseInt(v)).slice(-2);
  }, K = f.__private__.padd2Hex = function(v) {
    return ("00" + (v = v.toString())).substr(v.length);
  }, A = 0, ee = [], te = [], ne = 0, ve = [], _e = [], pe = !1, je = te, Se = function() {
    A = 0, ne = 0, te = [], ee = [], ve = [], pi = en(), Un = en();
  };
  f.__private__.setCustomOutputDestination = function(v) {
    pe = !0, je = v;
  };
  var be = function(v) {
    pe || (je = v);
  };
  f.__private__.resetCustomOutputDestination = function() {
    pe = !1, je = te;
  };
  var X = f.__private__.out = function(v) {
    return v = v.toString(), ne += v.length + 1, je.push(v), je;
  }, Ye = f.__private__.write = function(v) {
    return X(arguments.length === 1 ? v.toString() : Array.prototype.join.call(arguments, " "));
  }, Re = f.__private__.getArrayBuffer = function(v) {
    for (var z = v.length, ie = new ArrayBuffer(z), he = new Uint8Array(ie); z--; ) he[z] = v.charCodeAt(z);
    return ie;
  }, Te = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  f.__private__.getStandardFonts = function() {
    return Te;
  };
  var Ue = e.fontSize || 16;
  f.__private__.setFontSize = f.setFontSize = function(v) {
    return Ue = k === E.ADVANCED ? v / $e : v, this;
  };
  var T, fe = f.__private__.getFontSize = f.getFontSize = function() {
    return k === E.COMPAT ? Ue : Ue * $e;
  }, xe = e.R2L || !1;
  f.__private__.setR2L = f.setR2L = function(v) {
    return xe = v, this;
  }, f.__private__.getR2L = f.getR2L = function() {
    return xe;
  };
  var Fe, Ge = f.__private__.setZoomMode = function(v) {
    var z = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(v)) T = v;
    else if (isNaN(v)) {
      if (z.indexOf(v) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + v + '" is not recognized.');
      T = v;
    } else T = parseInt(v, 10);
  };
  f.__private__.getZoomMode = function() {
    return T;
  };
  var Me, Ie = f.__private__.setPageMode = function(v) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(v) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + v + '" is not recognized.');
    Fe = v;
  };
  f.__private__.getPageMode = function() {
    return Fe;
  };
  var ct = f.__private__.setLayoutMode = function(v) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(v) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + v + '" is not recognized.');
    Me = v;
  };
  f.__private__.getLayoutMode = function() {
    return Me;
  }, f.__private__.setDisplayMode = f.setDisplayMode = function(v, z, ie) {
    return Ge(v), ct(z), Ie(ie), this;
  };
  var at = { title: "", subject: "", author: "", keywords: "", creator: "" };
  f.__private__.getDocumentProperty = function(v) {
    if (Object.keys(at).indexOf(v) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return at[v];
  }, f.__private__.getDocumentProperties = function() {
    return at;
  }, f.__private__.setDocumentProperties = f.setProperties = f.setDocumentProperties = function(v) {
    for (var z in at) at.hasOwnProperty(z) && v[z] && (at[z] = v[z]);
    return this;
  }, f.__private__.setDocumentProperty = function(v, z) {
    if (Object.keys(at).indexOf(v) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return at[v] = z;
  };
  var Je, $e, _t, dt, Ut, Le = {}, pt = {}, At = [], Ot = {}, Fn = {}, It = {}, In = {}, Cn = null, Gt = 0, mt = [], ut = new Ky(f), rn = e.hotfixes || [], _n = {}, Mn = {}, er = [], ht = function v(z, ie, he, Ee, De, He) {
    if (!(this instanceof v)) return new v(z, ie, he, Ee, De, He);
    isNaN(z) && (z = 1), isNaN(ie) && (ie = 0), isNaN(he) && (he = 0), isNaN(Ee) && (Ee = 1), isNaN(De) && (De = 0), isNaN(He) && (He = 0), this._matrix = [z, ie, he, Ee, De, He];
  };
  Object.defineProperty(ht.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(v) {
    this._matrix[0] = v;
  } }), Object.defineProperty(ht.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(v) {
    this._matrix[1] = v;
  } }), Object.defineProperty(ht.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(v) {
    this._matrix[2] = v;
  } }), Object.defineProperty(ht.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(v) {
    this._matrix[3] = v;
  } }), Object.defineProperty(ht.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(v) {
    this._matrix[4] = v;
  } }), Object.defineProperty(ht.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(v) {
    this._matrix[5] = v;
  } }), Object.defineProperty(ht.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(v) {
    this._matrix[0] = v;
  } }), Object.defineProperty(ht.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(v) {
    this._matrix[1] = v;
  } }), Object.defineProperty(ht.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(v) {
    this._matrix[2] = v;
  } }), Object.defineProperty(ht.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(v) {
    this._matrix[3] = v;
  } }), Object.defineProperty(ht.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(v) {
    this._matrix[4] = v;
  } }), Object.defineProperty(ht.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(v) {
    this._matrix[5] = v;
  } }), Object.defineProperty(ht.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(ht.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(ht.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(ht.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), ht.prototype.join = function(v) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(j).join(v);
  }, ht.prototype.multiply = function(v) {
    var z = v.sx * this.sx + v.shy * this.shx, ie = v.sx * this.shy + v.shy * this.sy, he = v.shx * this.sx + v.sy * this.shx, Ee = v.shx * this.shy + v.sy * this.sy, De = v.tx * this.sx + v.ty * this.shx + this.tx, He = v.tx * this.shy + v.ty * this.sy + this.ty;
    return new ht(z, ie, he, Ee, De, He);
  }, ht.prototype.decompose = function() {
    var v = this.sx, z = this.shy, ie = this.shx, he = this.sy, Ee = this.tx, De = this.ty, He = Math.sqrt(v * v + z * z), ot = (v /= He) * ie + (z /= He) * he;
    ie -= v * ot, he -= z * ot;
    var yt = Math.sqrt(ie * ie + he * he);
    return ot /= yt, v * (he /= yt) < z * (ie /= yt) && (v = -v, z = -z, ot = -ot, He = -He), { scale: new ht(He, 0, 0, yt, 0, 0), translate: new ht(1, 0, 0, 1, Ee, De), rotate: new ht(v, z, -z, v, 0, 0), skew: new ht(1, 0, ot, 1, 0, 0) };
  }, ht.prototype.toString = function(v) {
    return this.join(" ");
  }, ht.prototype.inversed = function() {
    var v = this.sx, z = this.shy, ie = this.shx, he = this.sy, Ee = this.tx, De = this.ty, He = 1 / (v * he - z * ie), ot = he * He, yt = -z * He, jt = -ie * He, St = v * He;
    return new ht(ot, yt, jt, St, -ot * Ee - jt * De, -yt * Ee - St * De);
  }, ht.prototype.applyToPoint = function(v) {
    var z = v.x * this.sx + v.y * this.shx + this.tx, ie = v.x * this.shy + v.y * this.sy + this.ty;
    return new Ms(z, ie);
  }, ht.prototype.applyToRectangle = function(v) {
    var z = this.applyToPoint(v), ie = this.applyToPoint(new Ms(v.x + v.w, v.y + v.h));
    return new Ql(z.x, z.y, ie.x - z.x, ie.y - z.y);
  }, ht.prototype.clone = function() {
    var v = this.sx, z = this.shy, ie = this.shx, he = this.sy, Ee = this.tx, De = this.ty;
    return new ht(v, z, ie, he, Ee, De);
  }, f.Matrix = ht;
  var rr = f.matrixMult = function(v, z) {
    return z.multiply(v);
  }, ir = new ht(1, 0, 0, 1, 0, 0);
  f.unitMatrix = f.identityMatrix = ir;
  var yn = function(v, z) {
    if (!Fn[v]) {
      var ie = (z instanceof is ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
      z.id = ie, Fn[v] = ie, Ot[ie] = z, ut.publish("addPattern", z);
    }
  };
  f.ShadingPattern = is, f.TilingPattern = ul, f.addShadingPattern = function(v, z) {
    return x("addShadingPattern()"), yn(v, z), this;
  }, f.beginTilingPattern = function(v) {
    x("beginTilingPattern()"), id(v.boundingBox[0], v.boundingBox[1], v.boundingBox[2] - v.boundingBox[0], v.boundingBox[3] - v.boundingBox[1], v.matrix);
  }, f.endTilingPattern = function(v, z) {
    x("endTilingPattern()"), z.stream = _e[U].join(`
`), yn(v, z), ut.publish("endTilingPattern", z), er.pop().restore();
  };
  var Qt = f.__private__.newObject = function() {
    var v = en();
    return jn(v, !0), v;
  }, en = f.__private__.newObjectDeferred = function() {
    return A++, ee[A] = function() {
      return ne;
    }, A;
  }, jn = function(v, z) {
    return z = typeof z == "boolean" && z, ee[v] = ne, z && X(v + " 0 obj"), v;
  }, Xi = f.__private__.newAdditionalObject = function() {
    var v = { objId: en(), content: "" };
    return ve.push(v), v;
  }, pi = en(), Un = en(), zr = f.__private__.decodeColorString = function(v) {
    var z = v.split(" ");
    if (z.length !== 2 || z[1] !== "g" && z[1] !== "G")
      z.length === 5 && (z[4] === "k" || z[4] === "K") && (z = [(1 - z[0]) * (1 - z[3]), (1 - z[1]) * (1 - z[3]), (1 - z[2]) * (1 - z[3]), "r"]);
    else {
      var ie = parseFloat(z[0]);
      z = [ie, ie, ie, "r"];
    }
    for (var he = "#", Ee = 0; Ee < 3; Ee++) he += ("0" + Math.floor(255 * parseFloat(z[Ee])).toString(16)).slice(-2);
    return he;
  }, qr = f.__private__.encodeColorString = function(v) {
    var z;
    typeof v == "string" && (v = { ch1: v });
    var ie = v.ch1, he = v.ch2, Ee = v.ch3, De = v.ch4, He = v.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof ie == "string" && ie.charAt(0) !== "#") {
      var ot = new H3(ie);
      if (ot.ok) ie = ot.toHex();
      else if (!/^\d*\.?\d*$/.test(ie)) throw new Error('Invalid color "' + ie + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof ie == "string" && /^#[0-9A-Fa-f]{3}$/.test(ie) && (ie = "#" + ie[1] + ie[1] + ie[2] + ie[2] + ie[3] + ie[3]), typeof ie == "string" && /^#[0-9A-Fa-f]{6}$/.test(ie)) {
      var yt = parseInt(ie.substr(1), 16);
      ie = yt >> 16 & 255, he = yt >> 8 & 255, Ee = 255 & yt;
    }
    if (he === void 0 || De === void 0 && ie === he && he === Ee) if (typeof ie == "string") z = ie + " " + He[0];
    else switch (v.precision) {
      case 2:
        z = D(ie / 255) + " " + He[0];
        break;
      case 3:
      default:
        z = P(ie / 255) + " " + He[0];
    }
    else if (De === void 0 || Yt(De) === "object") {
      if (De && !isNaN(De.a) && De.a === 0) return z = ["1.", "1.", "1.", He[1]].join(" ");
      if (typeof ie == "string") z = [ie, he, Ee, He[1]].join(" ");
      else switch (v.precision) {
        case 2:
          z = [D(ie / 255), D(he / 255), D(Ee / 255), He[1]].join(" ");
          break;
        default:
        case 3:
          z = [P(ie / 255), P(he / 255), P(Ee / 255), He[1]].join(" ");
      }
    } else if (typeof ie == "string") z = [ie, he, Ee, De, He[2]].join(" ");
    else switch (v.precision) {
      case 2:
        z = [D(ie), D(he), D(Ee), D(De), He[2]].join(" ");
        break;
      case 3:
      default:
        z = [P(ie), P(he), P(Ee), P(De), He[2]].join(" ");
    }
    return z;
  }, ei = f.__private__.getFilters = function() {
    return o;
  }, jr = f.__private__.putStream = function(v) {
    var z = (v = v || {}).data || "", ie = v.filters || ei(), he = v.alreadyAppliedFilters || [], Ee = v.addLength1 || !1, De = z.length, He = v.objectId, ot = function(xr) {
      return xr;
    };
    if (d !== null && He === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    d !== null && (ot = wr.encryptor(He, 0));
    var yt = {};
    ie === !0 && (ie = ["FlateEncode"]);
    var jt = v.additionalKeyValues || [], St = (yt = xt.API.processDataByFilters !== void 0 ? xt.API.processDataByFilters(z, ie) : { data: z, reverseChain: [] }).reverseChain + (Array.isArray(he) ? he.join(" ") : he.toString());
    if (yt.data.length !== 0 && (jt.push({ key: "Length", value: yt.data.length }), Ee === !0 && jt.push({ key: "Length1", value: De })), St.length != 0) if (St.split("/").length - 1 == 1) jt.push({ key: "Filter", value: St });
    else {
      jt.push({ key: "Filter", value: "[" + St + "]" });
      for (var Wt = 0; Wt < jt.length; Wt += 1) if (jt[Wt].key === "DecodeParms") {
        for (var Pn = [], zn = 0; zn < yt.reverseChain.split("/").length - 1; zn += 1) Pn.push("null");
        Pn.push(jt[Wt].value), jt[Wt].value = "[" + Pn.join(" ") + "]";
      }
    }
    X("<<");
    for (var Xn = 0; Xn < jt.length; Xn++) X("/" + jt[Xn].key + " " + jt[Xn].value);
    X(">>"), yt.data.length !== 0 && (X("stream"), X(ot(yt.data)), X("endstream"));
  }, hi = f.__private__.putPage = function(v) {
    var z = v.number, ie = v.data, he = v.objId, Ee = v.contentsObjId;
    jn(he, !0), X("<</Type /Page"), X("/Parent " + v.rootDictionaryObjId + " 0 R"), X("/Resources " + v.resourceDictionaryObjId + " 0 R"), X("/MediaBox [" + parseFloat(j(v.mediaBox.bottomLeftX)) + " " + parseFloat(j(v.mediaBox.bottomLeftY)) + " " + j(v.mediaBox.topRightX) + " " + j(v.mediaBox.topRightY) + "]"), v.cropBox !== null && X("/CropBox [" + j(v.cropBox.bottomLeftX) + " " + j(v.cropBox.bottomLeftY) + " " + j(v.cropBox.topRightX) + " " + j(v.cropBox.topRightY) + "]"), v.bleedBox !== null && X("/BleedBox [" + j(v.bleedBox.bottomLeftX) + " " + j(v.bleedBox.bottomLeftY) + " " + j(v.bleedBox.topRightX) + " " + j(v.bleedBox.topRightY) + "]"), v.trimBox !== null && X("/TrimBox [" + j(v.trimBox.bottomLeftX) + " " + j(v.trimBox.bottomLeftY) + " " + j(v.trimBox.topRightX) + " " + j(v.trimBox.topRightY) + "]"), v.artBox !== null && X("/ArtBox [" + j(v.artBox.bottomLeftX) + " " + j(v.artBox.bottomLeftY) + " " + j(v.artBox.topRightX) + " " + j(v.artBox.topRightY) + "]"), typeof v.userUnit == "number" && v.userUnit !== 1 && X("/UserUnit " + v.userUnit), ut.publish("putPage", { objId: he, pageContext: mt[z], pageNumber: z, page: ie }), X("/Contents " + Ee + " 0 R"), X(">>"), X("endobj");
    var De = ie.join(`
`);
    return k === E.ADVANCED && (De += `
Q`), jn(Ee, !0), jr({ data: De, filters: ei(), objectId: Ee }), X("endobj"), he;
  }, de = f.__private__.putPages = function() {
    var v, z, ie = [];
    for (v = 1; v <= Gt; v++) mt[v].objId = en(), mt[v].contentsObjId = en();
    for (v = 1; v <= Gt; v++) ie.push(hi({ number: v, data: _e[v], objId: mt[v].objId, contentsObjId: mt[v].contentsObjId, mediaBox: mt[v].mediaBox, cropBox: mt[v].cropBox, bleedBox: mt[v].bleedBox, trimBox: mt[v].trimBox, artBox: mt[v].artBox, userUnit: mt[v].userUnit, rootDictionaryObjId: pi, resourceDictionaryObjId: Un }));
    jn(pi, !0), X("<</Type /Pages");
    var he = "/Kids [";
    for (z = 0; z < Gt; z++) he += ie[z] + " 0 R ";
    X(he + "]"), X("/Count " + Gt), X(">>"), X("endobj"), ut.publish("postPutPages");
  }, it = function(v) {
    ut.publish("putFont", { font: v, out: X, newObject: Qt, putStream: jr }), v.isAlreadyPutted !== !0 && (v.objectNumber = Qt(), X("<<"), X("/Type /Font"), X("/BaseFont /" + rl(v.postScriptName)), X("/Subtype /Type1"), typeof v.encoding == "string" && X("/Encoding /" + v.encoding), X("/FirstChar 32"), X("/LastChar 255"), X(">>"), X("endobj"));
  }, Xe = function() {
    for (var v in Le) Le.hasOwnProperty(v) && (p === !1 || p === !0 && y.hasOwnProperty(v)) && it(Le[v]);
  }, Bt = function(v) {
    v.objectNumber = Qt();
    var z = [];
    z.push({ key: "Type", value: "/XObject" }), z.push({ key: "Subtype", value: "/Form" }), z.push({ key: "BBox", value: "[" + [j(v.x), j(v.y), j(v.x + v.width), j(v.y + v.height)].join(" ") + "]" }), z.push({ key: "Matrix", value: "[" + v.matrix.toString() + "]" });
    var ie = v.pages[1].join(`
`);
    jr({ data: ie, additionalKeyValues: z, objectId: v.objectNumber }), X("endobj");
  }, On = function() {
    for (var v in _n) _n.hasOwnProperty(v) && Bt(_n[v]);
  }, Nn = function(v, z) {
    var ie, he = [], Ee = 1 / (z - 1);
    for (ie = 0; ie < 1; ie += Ee) he.push(ie);
    if (he.push(1), v[0].offset != 0) {
      var De = { offset: 0, color: v[0].color };
      v.unshift(De);
    }
    if (v[v.length - 1].offset != 1) {
      var He = { offset: 1, color: v[v.length - 1].color };
      v.push(He);
    }
    for (var ot = "", yt = 0, jt = 0; jt < he.length; jt++) {
      for (ie = he[jt]; ie > v[yt + 1].offset; ) yt++;
      var St = v[yt].offset, Wt = (ie - St) / (v[yt + 1].offset - St), Pn = v[yt].color, zn = v[yt + 1].color;
      ot += K(Math.round((1 - Wt) * Pn[0] + Wt * zn[0]).toString(16)) + K(Math.round((1 - Wt) * Pn[1] + Wt * zn[1]).toString(16)) + K(Math.round((1 - Wt) * Pn[2] + Wt * zn[2]).toString(16));
    }
    return ot.trim();
  }, ti = function(v, z) {
    z || (z = 21);
    var ie = Qt(), he = Nn(v.colors, z), Ee = [];
    Ee.push({ key: "FunctionType", value: "0" }), Ee.push({ key: "Domain", value: "[0.0 1.0]" }), Ee.push({ key: "Size", value: "[" + z + "]" }), Ee.push({ key: "BitsPerSample", value: "8" }), Ee.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), Ee.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), jr({ data: he, additionalKeyValues: Ee, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: ie }), X("endobj"), v.objectNumber = Qt(), X("<< /ShadingType " + v.type), X("/ColorSpace /DeviceRGB");
    var De = "/Coords [" + j(parseFloat(v.coords[0])) + " " + j(parseFloat(v.coords[1])) + " ";
    v.type === 2 ? De += j(parseFloat(v.coords[2])) + " " + j(parseFloat(v.coords[3])) : De += j(parseFloat(v.coords[2])) + " " + j(parseFloat(v.coords[3])) + " " + j(parseFloat(v.coords[4])) + " " + j(parseFloat(v.coords[5])), X(De += "]"), v.matrix && X("/Matrix [" + v.matrix.toString() + "]"), X("/Function " + ie + " 0 R"), X("/Extend [true true]"), X(">>"), X("endobj");
  }, br = function(v, z) {
    var ie = en(), he = Qt();
    z.push({ resourcesOid: ie, objectOid: he }), v.objectNumber = he;
    var Ee = [];
    Ee.push({ key: "Type", value: "/Pattern" }), Ee.push({ key: "PatternType", value: "1" }), Ee.push({ key: "PaintType", value: "1" }), Ee.push({ key: "TilingType", value: "1" }), Ee.push({ key: "BBox", value: "[" + v.boundingBox.map(j).join(" ") + "]" }), Ee.push({ key: "XStep", value: j(v.xStep) }), Ee.push({ key: "YStep", value: j(v.yStep) }), Ee.push({ key: "Resources", value: ie + " 0 R" }), v.matrix && Ee.push({ key: "Matrix", value: "[" + v.matrix.toString() + "]" }), jr({ data: v.stream, additionalKeyValues: Ee, objectId: v.objectNumber }), X("endobj");
  }, pr = function(v) {
    var z;
    for (z in Ot) Ot.hasOwnProperty(z) && (Ot[z] instanceof is ? ti(Ot[z]) : Ot[z] instanceof ul && br(Ot[z], v));
  }, Kn = function(v) {
    for (var z in v.objectNumber = Qt(), X("<<"), v) switch (z) {
      case "opacity":
        X("/ca " + D(v[z]));
        break;
      case "stroke-opacity":
        X("/CA " + D(v[z]));
    }
    X(">>"), X("endobj");
  }, Ps = function() {
    var v;
    for (v in It) It.hasOwnProperty(v) && Kn(It[v]);
  }, Wo = function() {
    for (var v in X("/XObject <<"), _n) _n.hasOwnProperty(v) && _n[v].objectNumber >= 0 && X("/" + v + " " + _n[v].objectNumber + " 0 R");
    ut.publish("putXobjectDict"), X(">>");
  }, vp = function() {
    wr.oid = Qt(), X("<<"), X("/Filter /Standard"), X("/V " + wr.v), X("/R " + wr.r), X("/U <" + wr.toHexString(wr.U) + ">"), X("/O <" + wr.toHexString(wr.O) + ">"), X("/P " + wr.P), X(">>"), X("endobj");
  }, Vu = function() {
    for (var v in X("/Font <<"), Le) Le.hasOwnProperty(v) && (p === !1 || p === !0 && y.hasOwnProperty(v)) && X("/" + v + " " + Le[v].objectNumber + " 0 R");
    X(">>");
  }, bp = function() {
    if (Object.keys(Ot).length > 0) {
      for (var v in X("/Shading <<"), Ot) Ot.hasOwnProperty(v) && Ot[v] instanceof is && Ot[v].objectNumber >= 0 && X("/" + v + " " + Ot[v].objectNumber + " 0 R");
      ut.publish("putShadingPatternDict"), X(">>");
    }
  }, Ls = function(v) {
    if (Object.keys(Ot).length > 0) {
      for (var z in X("/Pattern <<"), Ot) Ot.hasOwnProperty(z) && Ot[z] instanceof f.TilingPattern && Ot[z].objectNumber >= 0 && Ot[z].objectNumber < v && X("/" + z + " " + Ot[z].objectNumber + " 0 R");
      ut.publish("putTilingPatternDict"), X(">>");
    }
  }, wp = function() {
    if (Object.keys(It).length > 0) {
      var v;
      for (v in X("/ExtGState <<"), It) It.hasOwnProperty(v) && It[v].objectNumber >= 0 && X("/" + v + " " + It[v].objectNumber + " 0 R");
      ut.publish("putGStateDict"), X(">>");
    }
  }, Bn = function(v) {
    jn(v.resourcesOid, !0), X("<<"), X("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), Vu(), bp(), Ls(v.objectOid), wp(), Wo(), X(">>"), X("endobj");
  }, Wu = function() {
    var v = [];
    Xe(), Ps(), On(), pr(v), ut.publish("putResources"), v.forEach(Bn), Bn({ resourcesOid: Un, objectOid: Number.MAX_SAFE_INTEGER }), ut.publish("postPutResources");
  }, Hu = function() {
    ut.publish("putAdditionalObjects");
    for (var v = 0; v < ve.length; v++) {
      var z = ve[v];
      jn(z.objId, !0), X(z.content), X("endobj");
    }
    ut.publish("postPutAdditionalObjects");
  }, $u = function(v) {
    pt[v.fontName] = pt[v.fontName] || {}, pt[v.fontName][v.fontStyle] = v.id;
  }, Ul = function(v, z, ie, he, Ee) {
    var De = { id: "F" + (Object.keys(Le).length + 1).toString(10), postScriptName: v, fontName: z, fontStyle: ie, encoding: he, isStandardFont: Ee || !1, metadata: {} };
    return ut.publish("addFont", { font: De, instance: this }), Le[De.id] = De, $u(De), De.id;
  }, xp = function(v) {
    for (var z = 0, ie = Te.length; z < ie; z++) {
      var he = Ul.call(this, v[z][0], v[z][1], v[z][2], Te[z][3], !0);
      p === !1 && (y[he] = !0);
      var Ee = v[z][0].split("-");
      $u({ id: he, fontName: Ee[0], fontStyle: Ee[1] || "" });
    }
    ut.publish("addFonts", { fonts: Le, dictionary: pt });
  }, ki = function(v) {
    return v.foo = function() {
      try {
        return v.apply(this, arguments);
      } catch (he) {
        var z = he.stack || "";
        ~z.indexOf(" at ") && (z = z.split(" at ")[1]);
        var ie = "Error in function " + z.split(`
`)[0].split("<")[0] + ": " + he.message;
        if (!wt.console) throw new Error(ie);
        wt.console.error(ie, he), wt.alert && alert(ie);
      }
    }, v.foo.bar = v, v.foo;
  }, Ts = function(v, z) {
    var ie, he, Ee, De, He, ot, yt, jt, St;
    if (Ee = (z = z || {}).sourceEncoding || "Unicode", He = z.outputEncoding, (z.autoencode || He) && Le[Je].metadata && Le[Je].metadata[Ee] && Le[Je].metadata[Ee].encoding && (De = Le[Je].metadata[Ee].encoding, !He && Le[Je].encoding && (He = Le[Je].encoding), !He && De.codePages && (He = De.codePages[0]), typeof He == "string" && (He = De[He]), He)) {
      for (yt = !1, ot = [], ie = 0, he = v.length; ie < he; ie++) (jt = He[v.charCodeAt(ie)]) ? ot.push(String.fromCharCode(jt)) : ot.push(v[ie]), ot[ie].charCodeAt(0) >> 8 && (yt = !0);
      v = ot.join("");
    }
    for (ie = v.length; yt === void 0 && ie !== 0; ) v.charCodeAt(ie - 1) >> 8 && (yt = !0), ie--;
    if (!yt) return v;
    for (ot = z.noBOM ? [] : [254, 255], ie = 0, he = v.length; ie < he; ie++) {
      if ((St = (jt = v.charCodeAt(ie)) >> 8) >> 8) throw new Error("Character at position " + ie + " of string '" + v + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
      ot.push(St), ot.push(jt - (St << 8));
    }
    return String.fromCharCode.apply(void 0, ot);
  }, Vr = f.__private__.pdfEscape = f.pdfEscape = function(v, z) {
    return Ts(v, z).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, Bl = f.__private__.beginPage = function(v) {
    _e[++Gt] = [], mt[Gt] = { objId: 0, contentsObjId: 0, userUnit: Number(s), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(v[0]), topRightY: Number(v[1]) } }, Qu(Gt), be(_e[U]);
  }, Gu = function(v, z) {
    var ie, he, Ee;
    switch (n = z || n, typeof v == "string" && (ie = _(v.toLowerCase()), Array.isArray(ie) && (he = ie[0], Ee = ie[1])), Array.isArray(v) && (he = v[0] * $e, Ee = v[1] * $e), isNaN(he) && (he = i[0], Ee = i[1]), (he > 14400 || Ee > 14400) && (hn.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), he = Math.min(14400, he), Ee = Math.min(14400, Ee)), i = [he, Ee], n.substr(0, 1)) {
      case "l":
        Ee > he && (i = [Ee, he]);
        break;
      case "p":
        he > Ee && (i = [Ee, he]);
    }
    Bl(i), Au(Wl), X(Di), $l !== 0 && X($l + " J"), Gl !== 0 && X(Gl + " j"), ut.publish("addPage", { pageNumber: Gt });
  }, _p = function(v) {
    v > 0 && v <= Gt && (_e.splice(v, 1), mt.splice(v, 1), Gt--, U > Gt && (U = Gt), this.setPage(U));
  }, Qu = function(v) {
    v > 0 && v <= Gt && (U = v);
  }, Np = f.__private__.getNumberOfPages = f.getNumberOfPages = function() {
    return _e.length - 1;
  }, Yu = function(v, z, ie) {
    var he, Ee = void 0;
    return ie = ie || {}, v = v !== void 0 ? v : Le[Je].fontName, z = z !== void 0 ? z : Le[Je].fontStyle, he = v.toLowerCase(), pt[he] !== void 0 && pt[he][z] !== void 0 ? Ee = pt[he][z] : pt[v] !== void 0 && pt[v][z] !== void 0 ? Ee = pt[v][z] : ie.disableWarning === !1 && hn.warn("Unable to look up font label for font '" + v + "', '" + z + "'. Refer to getFontList() for available fonts."), Ee || ie.noFallback || (Ee = pt.times[z]) == null && (Ee = pt.times.normal), Ee;
  }, Sp = f.__private__.putInfo = function() {
    var v = Qt(), z = function(he) {
      return he;
    };
    for (var ie in d !== null && (z = wr.encryptor(v, 0)), X("<<"), X("/Producer (" + Vr(z("jsPDF " + xt.version)) + ")"), at) at.hasOwnProperty(ie) && at[ie] && X("/" + ie.substr(0, 1).toUpperCase() + ie.substr(1) + " (" + Vr(z(at[ie])) + ")");
    X("/CreationDate (" + Vr(z(ae)) + ")"), X(">>"), X("endobj");
  }, zl = f.__private__.putCatalog = function(v) {
    var z = (v = v || {}).rootDictionaryObjId || pi;
    switch (Qt(), X("<<"), X("/Type /Catalog"), X("/Pages " + z + " 0 R"), T || (T = "fullwidth"), T) {
      case "fullwidth":
        X("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        X("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        X("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        X("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var ie = "" + T;
        ie.substr(ie.length - 1) === "%" && (T = parseInt(T) / 100), typeof T == "number" && X("/OpenAction [3 0 R /XYZ null null " + D(T) + "]");
    }
    switch (Me || (Me = "continuous"), Me) {
      case "continuous":
        X("/PageLayout /OneColumn");
        break;
      case "single":
        X("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        X("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        X("/PageLayout /TwoColumnRight");
    }
    Fe && X("/PageMode /" + Fe), ut.publish("putCatalog"), X(">>"), X("endobj");
  }, Ep = f.__private__.putTrailer = function() {
    X("trailer"), X("<<"), X("/Size " + (A + 1)), X("/Root " + A + " 0 R"), X("/Info " + (A - 1) + " 0 R"), d !== null && X("/Encrypt " + wr.oid + " 0 R"), X("/ID [ <" + ce + "> <" + ce + "> ]"), X(">>");
  }, Cp = f.__private__.putHeader = function() {
    X("%PDF-" + N), X("%ºß¬à");
  }, Op = f.__private__.putXRef = function() {
    var v = "0000000000";
    X("xref"), X("0 " + (A + 1)), X("0000000000 65535 f ");
    for (var z = 1; z <= A; z++)
      typeof ee[z] == "function" ? X((v + ee[z]()).slice(-10) + " 00000 n ") : ee[z] !== void 0 ? X((v + ee[z]).slice(-10) + " 00000 n ") : X("0000000000 00000 n ");
  }, va = f.__private__.buildDocument = function() {
    Se(), be(te), ut.publish("buildDocument"), Cp(), de(), Hu(), Wu(), d !== null && vp(), Sp(), zl();
    var v = ne;
    return Op(), Ep(), X("startxref"), X("" + v), X("%%EOF"), be(_e[U]), te.join(`
`);
  }, Fs = f.__private__.getBlob = function(v) {
    return new Blob([Re(v)], { type: "application/pdf" });
  }, Is = f.output = f.__private__.output = ki(function(v, z) {
    switch (typeof (z = z || {}) == "string" ? z = { filename: z } : z.filename = z.filename || "generated.pdf", v) {
      case void 0:
        return va();
      case "save":
        f.save(z.filename);
        break;
      case "arraybuffer":
        return Re(va());
      case "blob":
        return Fs(va());
      case "bloburi":
      case "bloburl":
        if (wt.URL !== void 0 && typeof wt.URL.createObjectURL == "function") return wt.URL && wt.URL.createObjectURL(Fs(va())) || void 0;
        hn.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var ie = "", he = va();
        try {
          ie = Km(he);
        } catch {
          ie = Km(unescape(encodeURIComponent(he)));
        }
        return "data:application/pdf;filename=" + z.filename + ";base64," + ie;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(wt) === "[object Window]") {
          var Ee = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", De = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          z.pdfObjectUrl && (Ee = z.pdfObjectUrl, De = "");
          var He = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + Ee + '"' + De + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(z) + ");<\/script></body></html>", ot = wt.open();
          return ot !== null && ot.document.write(He), ot;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(wt) === "[object Window]") {
          var yt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (z.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + z.filename + '" width="500px" height="400px" /></body></html>', jt = wt.open();
          if (jt !== null) {
            jt.document.write(yt);
            var St = this;
            jt.document.documentElement.querySelector("#pdfViewer").onload = function() {
              jt.document.title = z.filename, jt.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(St.output("bloburl"));
            };
          }
          return jt;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(wt) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var Wt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", z) + '"></iframe></body></html>', Pn = wt.open();
        if (Pn !== null && (Pn.document.write(Wt), Pn.document.title = z.filename), Pn || typeof safari > "u") return Pn;
        break;
      case "datauri":
      case "dataurl":
        return wt.document.location.href = this.output("datauristring", z);
      default:
        return null;
    }
  }), Ku = function(v) {
    return Array.isArray(rn) === !0 && rn.indexOf(v) > -1;
  };
  switch (r) {
    case "pt":
      $e = 1;
      break;
    case "mm":
      $e = 72 / 25.4;
      break;
    case "cm":
      $e = 72 / 2.54;
      break;
    case "in":
      $e = 72;
      break;
    case "px":
      $e = Ku("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      $e = 12;
      break;
    case "ex":
      $e = 6;
      break;
    default:
      if (typeof r != "number") throw new Error("Invalid unit: " + r);
      $e = r;
  }
  var wr = null;
  re(), oe();
  var jp = function(v) {
    return d !== null ? wr.encryptor(v, 0) : function(z) {
      return z;
    };
  }, Xu = f.__private__.getPageInfo = f.getPageInfo = function(v) {
    if (isNaN(v) || v % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: mt[v].objId, pageNumber: v, pageContext: mt[v] };
  }, Nt = f.__private__.getPageInfoByObjId = function(v) {
    if (isNaN(v) || v % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var z in mt) if (mt[z].objId === v) break;
    return Xu(z);
  }, Pp = f.__private__.getCurrentPageInfo = f.getCurrentPageInfo = function() {
    return { objId: mt[U].objId, pageNumber: U, pageContext: mt[U] };
  };
  f.addPage = function() {
    return Gu.apply(this, arguments), this;
  }, f.setPage = function() {
    return Qu.apply(this, arguments), be.call(this, _e[U]), this;
  }, f.insertPage = function(v) {
    return this.addPage(), this.movePage(U, v), this;
  }, f.movePage = function(v, z) {
    var ie, he;
    if (v > z) {
      ie = _e[v], he = mt[v];
      for (var Ee = v; Ee > z; Ee--) _e[Ee] = _e[Ee - 1], mt[Ee] = mt[Ee - 1];
      _e[z] = ie, mt[z] = he, this.setPage(z);
    } else if (v < z) {
      ie = _e[v], he = mt[v];
      for (var De = v; De < z; De++) _e[De] = _e[De + 1], mt[De] = mt[De + 1];
      _e[z] = ie, mt[z] = he, this.setPage(z);
    }
    return this;
  }, f.deletePage = function() {
    return _p.apply(this, arguments), this;
  }, f.__private__.text = f.text = function(v, z, ie, he, Ee) {
    var De, He, ot, yt, jt, St, Wt, Pn, zn, Xn = (he = he || {}).scope || this;
    if (typeof v == "number" && typeof z == "number" && (typeof ie == "string" || Array.isArray(ie))) {
      var xr = ie;
      ie = z, z = v, v = xr;
    }
    if (arguments[3] instanceof ht ? (x("The transform parameter of text() with a Matrix value"), zn = Ee) : (ot = arguments[4], yt = arguments[5], Yt(Wt = arguments[3]) === "object" && Wt !== null || (typeof ot == "string" && (yt = ot, ot = null), typeof Wt == "string" && (yt = Wt, Wt = null), typeof Wt == "number" && (ot = Wt, Wt = null), he = { flags: Wt, angle: ot, align: yt })), isNaN(z) || isNaN(ie) || v == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (v.length === 0) return Xn;
    var ar = "", Ri = !1, mi = typeof he.lineHeightFactor == "number" ? he.lineHeightFactor : $o, Ai = Xn.internal.scaleFactor;
    function ad(vn) {
      return vn = vn.split("	").join(Array(he.TabLen || 9).join(" ")), Vr(vn, Wt);
    }
    function Zl(vn) {
      for (var bn, Vn = vn.concat(), tr = [], Na = Vn.length; Na--; ) typeof (bn = Vn.shift()) == "string" ? tr.push(bn) : Array.isArray(vn) && (bn.length === 1 || bn[1] === void 0 && bn[2] === void 0) ? tr.push(bn[0]) : tr.push([bn[0], bn[1], bn[2]]);
      return tr;
    }
    function Jl(vn, bn) {
      var Vn;
      if (typeof vn == "string") Vn = bn(vn)[0];
      else if (Array.isArray(vn)) {
        for (var tr, Na, oc = vn.concat(), Ys = [], ud = oc.length; ud--; ) typeof (tr = oc.shift()) == "string" ? Ys.push(bn(tr)[0]) : Array.isArray(tr) && typeof tr[0] == "string" && (Na = bn(tr[0], tr[1], tr[2]), Ys.push([Na[0], Na[1], Na[2]]));
        Vn = Ys;
      }
      return Vn;
    }
    var Bs = !1, Al = !0;
    if (typeof v == "string") Bs = !0;
    else if (Array.isArray(v)) {
      var ec = v.concat();
      He = [];
      for (var zs, hr = ec.length; hr--; ) (typeof (zs = ec.shift()) != "string" || Array.isArray(zs) && typeof zs[0] != "string") && (Al = !1);
      Bs = Al;
    }
    if (Bs === !1) throw new Error('Type of text must be string or Array. "' + v + '" is not recognized.');
    typeof v == "string" && (v = v.match(/[\r?\n]/) ? v.split(/\r\n|\r|\n/g) : [v]);
    var qs = Ue / Xn.internal.scaleFactor, Vs = qs * (mi - 1);
    switch (he.baseline) {
      case "bottom":
        ie -= Vs;
        break;
      case "top":
        ie += qs - Vs;
        break;
      case "hanging":
        ie += qs - 2 * Vs;
        break;
      case "middle":
        ie += qs / 2 - Vs;
    }
    if ((St = he.maxWidth || 0) > 0 && (typeof v == "string" ? v = Xn.splitTextToSize(v, St) : Object.prototype.toString.call(v) === "[object Array]" && (v = v.reduce(function(vn, bn) {
      return vn.concat(Xn.splitTextToSize(bn, St));
    }, []))), De = { text: v, x: z, y: ie, options: he, mutex: { pdfEscape: Vr, activeFontKey: Je, fonts: Le, activeFontSize: Ue } }, ut.publish("preProcessText", De), v = De.text, ot = (he = De.options).angle, !(zn instanceof ht) && ot && typeof ot == "number") {
      ot *= Math.PI / 180, he.rotationDirection === 0 && (ot = -ot), k === E.ADVANCED && (ot = -ot);
      var Ws = Math.cos(ot), tc = Math.sin(ot);
      zn = new ht(Ws, tc, -tc, Ws, 0, 0);
    } else ot && ot instanceof ht && (zn = ot);
    k !== E.ADVANCED || zn || (zn = ir), (jt = he.charSpace || Rs) !== void 0 && (ar += j(L(jt)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Pn = he.horizontalScale) !== void 0 && (ar += j(100 * Pn) + ` Tz
`), he.lang;
    var Wr = -1, Bp = he.renderingMode !== void 0 ? he.renderingMode : he.stroke, nc = Xn.internal.getCurrentPageInfo().pageContext;
    switch (Bp) {
      case 0:
      case !1:
      case "fill":
        Wr = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        Wr = 1;
        break;
      case 2:
      case "fillThenStroke":
        Wr = 2;
        break;
      case 3:
      case "invisible":
        Wr = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        Wr = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        Wr = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        Wr = 6;
        break;
      case 7:
      case "addToPathForClipping":
        Wr = 7;
    }
    var od = nc.usedRenderingMode !== void 0 ? nc.usedRenderingMode : -1;
    Wr !== -1 ? ar += Wr + ` Tr
` : od !== -1 && (ar += `0 Tr
`), Wr !== -1 && (nc.usedRenderingMode = Wr), yt = he.align || "left";
    var gi, Hs = Ue * mi, sd = Xn.internal.pageSize.getWidth(), ld = Le[Je];
    jt = he.charSpace || Rs, St = he.maxWidth || 0, Wt = Object.assign({ autoencode: !0, noBOM: !0 }, he.flags);
    var Ga = [], Yo = function(vn) {
      return Xn.getStringUnitWidth(vn, { font: ld, charSpace: jt, fontSize: Ue, doKerning: !1 }) * Ue / Ai;
    };
    if (Object.prototype.toString.call(v) === "[object Array]") {
      var Hr;
      He = Zl(v), yt !== "left" && (gi = He.map(Yo));
      var Pr, Qa = 0;
      if (yt === "right") {
        z -= gi[0], v = [], hr = He.length;
        for (var wa = 0; wa < hr; wa++) wa === 0 ? (Pr = Ji(z), Hr = ba(ie)) : (Pr = L(Qa - gi[wa]), Hr = -Hs), v.push([He[wa], Pr, Hr]), Qa = gi[wa];
      } else if (yt === "center") {
        z -= gi[0] / 2, v = [], hr = He.length;
        for (var xa = 0; xa < hr; xa++) xa === 0 ? (Pr = Ji(z), Hr = ba(ie)) : (Pr = L((Qa - gi[xa]) / 2), Hr = -Hs), v.push([He[xa], Pr, Hr]), Qa = gi[xa];
      } else if (yt === "left") {
        v = [], hr = He.length;
        for (var $s = 0; $s < hr; $s++) v.push(He[$s]);
      } else if (yt === "justify" && ld.encoding === "Identity-H") {
        v = [], hr = He.length, St = St !== 0 ? St : sd;
        for (var _a = 0, qn = 0; qn < hr; qn++) if (Hr = qn === 0 ? ba(ie) : -Hs, Pr = qn === 0 ? Ji(z) : _a, qn < hr - 1) {
          var rc = L((St - gi[qn]) / (He[qn].split(" ").length - 1)), Lr = He[qn].split(" ");
          v.push([Lr[0] + " ", Pr, Hr]), _a = 0;
          for (var yi = 1; yi < Lr.length; yi++) {
            var Gs = (Yo(Lr[yi - 1] + " " + Lr[yi]) - Yo(Lr[yi])) * Ai + rc;
            yi == Lr.length - 1 ? v.push([Lr[yi], Gs, 0]) : v.push([Lr[yi] + " ", Gs, 0]), _a -= Gs;
          }
        } else v.push([He[qn], Pr, Hr]);
        v.push(["", _a, 0]);
      } else {
        if (yt !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (v = [], hr = He.length, St = St !== 0 ? St : sd, qn = 0; qn < hr; qn++) Hr = qn === 0 ? ba(ie) : -Hs, Pr = qn === 0 ? Ji(z) : 0, qn < hr - 1 ? Ga.push(j(L((St - gi[qn]) / (He[qn].split(" ").length - 1)))) : Ga.push(0), v.push([He[qn], Pr, Hr]);
      }
    }
    var cd = typeof he.R2L == "boolean" ? he.R2L : xe;
    cd === !0 && (v = Jl(v, function(vn, bn, Vn) {
      return [vn.split("").reverse().join(""), bn, Vn];
    })), De = { text: v, x: z, y: ie, options: he, mutex: { pdfEscape: Vr, activeFontKey: Je, fonts: Le, activeFontSize: Ue } }, ut.publish("postProcessText", De), v = De.text, Ri = De.mutex.isHex || !1;
    var ic = Le[Je].encoding;
    ic !== "WinAnsiEncoding" && ic !== "StandardEncoding" || (v = Jl(v, function(vn, bn, Vn) {
      return [ad(vn), bn, Vn];
    })), He = Zl(v), v = [];
    for (var Ko, Xo, Ya, Zo = 0, Qs = 1, Jo = Array.isArray(He[0]) ? Qs : Zo, Ka = "", ac = function(vn, bn, Vn) {
      var tr = "";
      return Vn instanceof ht ? (Vn = typeof he.angle == "number" ? rr(Vn, new ht(1, 0, 0, 1, vn, bn)) : rr(new ht(1, 0, 0, 1, vn, bn), Vn), k === E.ADVANCED && (Vn = rr(new ht(1, 0, 0, -1, 0, 0), Vn)), tr = Vn.join(" ") + ` Tm
`) : tr = j(vn) + " " + j(bn) + ` Td
`, tr;
    }, vi = 0; vi < He.length; vi++) {
      switch (Ka = "", Jo) {
        case Qs:
          Ya = (Ri ? "<" : "(") + He[vi][0] + (Ri ? ">" : ")"), Ko = parseFloat(He[vi][1]), Xo = parseFloat(He[vi][2]);
          break;
        case Zo:
          Ya = (Ri ? "<" : "(") + He[vi] + (Ri ? ">" : ")"), Ko = Ji(z), Xo = ba(ie);
      }
      Ga !== void 0 && Ga[vi] !== void 0 && (Ka = Ga[vi] + ` Tw
`), vi === 0 ? v.push(Ka + ac(Ko, Xo, zn) + Ya) : Jo === Zo ? v.push(Ka + Ya) : Jo === Qs && v.push(Ka + ac(Ko, Xo, zn) + Ya);
    }
    v = Jo === Zo ? v.join(` Tj
T* `) : v.join(` Tj
`), v += ` Tj
`;
    var bi = `BT
/`;
    return bi += Je + " " + Ue + ` Tf
`, bi += j(Ue * mi) + ` TL
`, bi += Go + `
`, bi += ar, bi += v, X(bi += "ET"), y[Je] = !0, Xn;
  };
  var Lp = f.__private__.clip = f.clip = function(v) {
    return X(v === "evenodd" ? "W*" : "W"), this;
  };
  f.clipEvenOdd = function() {
    return Lp("evenodd");
  }, f.__private__.discardPath = f.discardPath = function() {
    return X("n"), this;
  };
  var Zi = f.__private__.isValidStyle = function(v) {
    var z = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(v) !== -1 && (z = !0), z;
  };
  f.__private__.setDefaultPathOperation = f.setDefaultPathOperation = function(v) {
    return Zi(v) && (c = v), this;
  };
  var Zu = f.__private__.getStyle = f.getStyle = function(v) {
    var z = c;
    switch (v) {
      case "D":
      case "S":
        z = "S";
        break;
      case "F":
        z = "f";
        break;
      case "FD":
      case "DF":
        z = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        z = v;
    }
    return z;
  }, Ju = f.close = function() {
    return X("h"), this;
  };
  f.stroke = function() {
    return X("S"), this;
  }, f.fill = function(v) {
    return ks("f", v), this;
  }, f.fillEvenOdd = function(v) {
    return ks("f*", v), this;
  }, f.fillStroke = function(v) {
    return ks("B", v), this;
  }, f.fillStrokeEvenOdd = function(v) {
    return ks("B*", v), this;
  };
  var ks = function(v, z) {
    Yt(z) === "object" ? Fp(z, v) : X(v);
  }, ql = function(v) {
    v === null || k === E.ADVANCED && v === void 0 || (v = Zu(v), X(v));
  };
  function Tp(v, z, ie, he, Ee) {
    var De = new ul(z || this.boundingBox, ie || this.xStep, he || this.yStep, this.gState, Ee || this.matrix);
    De.stream = this.stream;
    var He = v + "$$" + this.cloneIndex++ + "$$";
    return yn(He, De), De;
  }
  var Fp = function(v, z) {
    var ie = Fn[v.key], he = Ot[ie];
    if (he instanceof is) X("q"), X(Ip(z)), he.gState && f.setGState(he.gState), X(v.matrix.toString() + " cm"), X("/" + ie + " sh"), X("Q");
    else if (he instanceof ul) {
      var Ee = new ht(1, 0, 0, -1, 0, $a());
      v.matrix && (Ee = Ee.multiply(v.matrix || ir), ie = Tp.call(he, v.key, v.boundingBox, v.xStep, v.yStep, Ee).id), X("q"), X("/Pattern cs"), X("/" + ie + " scn"), he.gState && f.setGState(he.gState), X(z), X("Q");
    }
  }, Ip = function(v) {
    switch (v) {
      case "f":
      case "F":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
        return "W S";
      case "B*":
        return "W* S";
      case "S":
        return "W S";
      case "n":
        return "W n";
    }
  }, Vl = f.moveTo = function(v, z) {
    return X(j(L(v)) + " " + j($(z)) + " m"), this;
  }, Ho = f.lineTo = function(v, z) {
    return X(j(L(v)) + " " + j($(z)) + " l"), this;
  }, Wa = f.curveTo = function(v, z, ie, he, Ee, De) {
    return X([j(L(v)), j($(z)), j(L(ie)), j($(he)), j(L(Ee)), j($(De)), "c"].join(" ")), this;
  };
  f.__private__.line = f.line = function(v, z, ie, he, Ee) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || isNaN(he) || !Zi(Ee)) throw new Error("Invalid arguments passed to jsPDF.line");
    return k === E.COMPAT ? this.lines([[ie - v, he - z]], v, z, [1, 1], Ee || "S") : this.lines([[ie - v, he - z]], v, z, [1, 1]).stroke();
  }, f.__private__.lines = f.lines = function(v, z, ie, he, Ee, De) {
    var He, ot, yt, jt, St, Wt, Pn, zn, Xn, xr, ar, Ri;
    if (typeof v == "number" && (Ri = ie, ie = z, z = v, v = Ri), he = he || [1, 1], De = De || !1, isNaN(z) || isNaN(ie) || !Array.isArray(v) || !Array.isArray(he) || !Zi(Ee) || typeof De != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (Vl(z, ie), He = he[0], ot = he[1], jt = v.length, xr = z, ar = ie, yt = 0; yt < jt; yt++) (St = v[yt]).length === 2 ? (xr = St[0] * He + xr, ar = St[1] * ot + ar, Ho(xr, ar)) : (Wt = St[0] * He + xr, Pn = St[1] * ot + ar, zn = St[2] * He + xr, Xn = St[3] * ot + ar, xr = St[4] * He + xr, ar = St[5] * ot + ar, Wa(Wt, Pn, zn, Xn, xr, ar));
    return De && Ju(), ql(Ee), this;
  }, f.path = function(v) {
    for (var z = 0; z < v.length; z++) {
      var ie = v[z], he = ie.c;
      switch (ie.op) {
        case "m":
          Vl(he[0], he[1]);
          break;
        case "l":
          Ho(he[0], he[1]);
          break;
        case "c":
          Wa.apply(this, he);
          break;
        case "h":
          Ju();
      }
    }
    return this;
  }, f.__private__.rect = f.rect = function(v, z, ie, he, Ee) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || isNaN(he) || !Zi(Ee)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return k === E.COMPAT && (he = -he), X([j(L(v)), j($(z)), j(L(ie)), j(L(he)), "re"].join(" ")), ql(Ee), this;
  }, f.__private__.triangle = f.triangle = function(v, z, ie, he, Ee, De, He) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || isNaN(he) || isNaN(Ee) || isNaN(De) || !Zi(He)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[ie - v, he - z], [Ee - ie, De - he], [v - Ee, z - De]], v, z, [1, 1], He, !0), this;
  }, f.__private__.roundedRect = f.roundedRect = function(v, z, ie, he, Ee, De, He) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || isNaN(he) || isNaN(Ee) || isNaN(De) || !Zi(He)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var ot = 4 / 3 * (Math.SQRT2 - 1);
    return Ee = Math.min(Ee, 0.5 * ie), De = Math.min(De, 0.5 * he), this.lines([[ie - 2 * Ee, 0], [Ee * ot, 0, Ee, De - De * ot, Ee, De], [0, he - 2 * De], [0, De * ot, -Ee * ot, De, -Ee, De], [2 * Ee - ie, 0], [-Ee * ot, 0, -Ee, -De * ot, -Ee, -De], [0, 2 * De - he], [0, -De * ot, Ee * ot, -De, Ee, -De]], v + Ee, z, [1, 1], He, !0), this;
  }, f.__private__.ellipse = f.ellipse = function(v, z, ie, he, Ee) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || isNaN(he) || !Zi(Ee)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var De = 4 / 3 * (Math.SQRT2 - 1) * ie, He = 4 / 3 * (Math.SQRT2 - 1) * he;
    return Vl(v + ie, z), Wa(v + ie, z - He, v + De, z - he, v, z - he), Wa(v - De, z - he, v - ie, z - He, v - ie, z), Wa(v - ie, z + He, v - De, z + he, v, z + he), Wa(v + De, z + he, v + ie, z + He, v + ie, z), ql(Ee), this;
  }, f.__private__.circle = f.circle = function(v, z, ie, he) {
    if (isNaN(v) || isNaN(z) || isNaN(ie) || !Zi(he)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(v, z, ie, ie, he);
  }, f.setFont = function(v, z, ie) {
    return ie && (z = q(z, ie)), Je = Yu(v, z, { disableWarning: !1 }), this;
  };
  var kp = f.__private__.getFont = f.getFont = function() {
    return Le[Yu.apply(f, arguments)];
  };
  f.__private__.getFontList = f.getFontList = function() {
    var v, z, ie = {};
    for (v in pt) if (pt.hasOwnProperty(v)) for (z in ie[v] = [], pt[v]) pt[v].hasOwnProperty(z) && ie[v].push(z);
    return ie;
  }, f.addFont = function(v, z, ie, he, Ee) {
    var De = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && De.indexOf(arguments[3]) !== -1 ? Ee = arguments[3] : arguments[3] && De.indexOf(arguments[3]) == -1 && (ie = q(ie, he)), Ee = Ee || "Identity-H", Ul.call(this, v, z, ie, Ee);
  };
  var $o, Wl = e.lineWidth || 0.200025, Ds = f.__private__.getLineWidth = f.getLineWidth = function() {
    return Wl;
  }, Au = f.__private__.setLineWidth = f.setLineWidth = function(v) {
    return Wl = v, X(j(L(v)) + " w"), this;
  };
  f.__private__.setLineDash = xt.API.setLineDash = xt.API.setLineDashPattern = function(v, z) {
    if (v = v || [], z = z || 0, isNaN(z) || !Array.isArray(v)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return v = v.map(function(ie) {
      return j(L(ie));
    }).join(" "), z = j(L(z)), X("[" + v + "] " + z + " d"), this;
  };
  var ed = f.__private__.getLineHeight = f.getLineHeight = function() {
    return Ue * $o;
  };
  f.__private__.getLineHeight = f.getLineHeight = function() {
    return Ue * $o;
  };
  var td = f.__private__.setLineHeightFactor = f.setLineHeightFactor = function(v) {
    return typeof (v = v || 1.15) == "number" && ($o = v), this;
  }, nd = f.__private__.getLineHeightFactor = f.getLineHeightFactor = function() {
    return $o;
  };
  td(e.lineHeight);
  var Ji = f.__private__.getHorizontalCoordinate = function(v) {
    return L(v);
  }, ba = f.__private__.getVerticalCoordinate = function(v) {
    return k === E.ADVANCED ? v : mt[U].mediaBox.topRightY - mt[U].mediaBox.bottomLeftY - L(v);
  }, Dp = f.__private__.getHorizontalCoordinateString = f.getHorizontalCoordinateString = function(v) {
    return j(Ji(v));
  }, Ha = f.__private__.getVerticalCoordinateString = f.getVerticalCoordinateString = function(v) {
    return j(ba(v));
  }, Di = e.strokeColor || "0 G";
  f.__private__.getStrokeColor = f.getDrawColor = function() {
    return zr(Di);
  }, f.__private__.setStrokeColor = f.setDrawColor = function(v, z, ie, he) {
    return Di = qr({ ch1: v, ch2: z, ch3: ie, ch4: he, pdfColorType: "draw", precision: 2 }), X(Di), this;
  };
  var Hl = e.fillColor || "0 g";
  f.__private__.getFillColor = f.getFillColor = function() {
    return zr(Hl);
  }, f.__private__.setFillColor = f.setFillColor = function(v, z, ie, he) {
    return Hl = qr({ ch1: v, ch2: z, ch3: ie, ch4: he, pdfColorType: "fill", precision: 2 }), X(Hl), this;
  };
  var Go = e.textColor || "0 g", Rp = f.__private__.getTextColor = f.getTextColor = function() {
    return zr(Go);
  };
  f.__private__.setTextColor = f.setTextColor = function(v, z, ie, he) {
    return Go = qr({ ch1: v, ch2: z, ch3: ie, ch4: he, pdfColorType: "text", precision: 3 }), this;
  };
  var Rs = e.charSpace, Mp = f.__private__.getCharSpace = f.getCharSpace = function() {
    return parseFloat(Rs || 0);
  };
  f.__private__.setCharSpace = f.setCharSpace = function(v) {
    if (isNaN(v)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Rs = v, this;
  };
  var $l = 0;
  f.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, f.__private__.setLineCap = f.setLineCap = function(v) {
    var z = f.CapJoinStyles[v];
    if (z === void 0) throw new Error("Line cap style of '" + v + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return $l = z, X(z + " J"), this;
  };
  var Gl = 0;
  f.__private__.setLineJoin = f.setLineJoin = function(v) {
    var z = f.CapJoinStyles[v];
    if (z === void 0) throw new Error("Line join style of '" + v + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Gl = z, X(z + " j"), this;
  }, f.__private__.setLineMiterLimit = f.__private__.setMiterLimit = f.setLineMiterLimit = f.setMiterLimit = function(v) {
    if (v = v || 0, isNaN(v)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return X(j(L(v)) + " M"), this;
  }, f.GState = Pf, f.setGState = function(v) {
    (v = typeof v == "string" ? It[In[v]] : rd(null, v)).equals(Cn) || (X("/" + v.id + " gs"), Cn = v);
  };
  var rd = function(v, z) {
    if (!v || !In[v]) {
      var ie = !1;
      for (var he in It) if (It.hasOwnProperty(he) && It[he].equals(z)) {
        ie = !0;
        break;
      }
      if (ie) z = It[he];
      else {
        var Ee = "GS" + (Object.keys(It).length + 1).toString(10);
        It[Ee] = z, z.id = Ee;
      }
      return v && (In[v] = z.id), ut.publish("addGState", z), z;
    }
  };
  f.addGState = function(v, z) {
    return rd(v, z), this;
  }, f.saveGraphicsState = function() {
    return X("q"), At.push({ key: Je, size: Ue, color: Go }), this;
  }, f.restoreGraphicsState = function() {
    X("Q");
    var v = At.pop();
    return Je = v.key, Ue = v.size, Go = v.color, Cn = null, this;
  }, f.setCurrentTransformationMatrix = function(v) {
    return X(v.toString() + " cm"), this;
  }, f.comment = function(v) {
    return X("#" + v), this;
  };
  var Ms = function(v, z) {
    var ie = v || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return ie;
    }, set: function(De) {
      isNaN(De) || (ie = parseFloat(De));
    } });
    var he = z || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return he;
    }, set: function(De) {
      isNaN(De) || (he = parseFloat(De));
    } });
    var Ee = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return Ee;
    }, set: function(De) {
      Ee = De.toString();
    } }), this;
  }, Ql = function(v, z, ie, he) {
    Ms.call(this, v, z), this.type = "rect";
    var Ee = ie || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return Ee;
    }, set: function(He) {
      isNaN(He) || (Ee = parseFloat(He));
    } });
    var De = he || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return De;
    }, set: function(He) {
      isNaN(He) || (De = parseFloat(He));
    } }), this;
  }, Yl = function() {
    this.page = Gt, this.currentPage = U, this.pages = _e.slice(0), this.pagesContext = mt.slice(0), this.x = _t, this.y = dt, this.matrix = Ut, this.width = Qo(U), this.height = $a(U), this.outputDestination = je, this.id = "", this.objectNumber = -1;
  };
  Yl.prototype.restore = function() {
    Gt = this.page, U = this.currentPage, mt = this.pagesContext, _e = this.pages, _t = this.x, dt = this.y, Ut = this.matrix, Kl(U, this.width), Xl(U, this.height), je = this.outputDestination;
  };
  var id = function(v, z, ie, he, Ee) {
    er.push(new Yl()), Gt = U = 0, _e = [], _t = v, dt = z, Ut = Ee, Bl([ie, he]);
  }, Up = function(v) {
    if (Mn[v]) er.pop().restore();
    else {
      var z = new Yl(), ie = "Xo" + (Object.keys(_n).length + 1).toString(10);
      z.id = ie, Mn[v] = ie, _n[ie] = z, ut.publish("addFormObject", z), er.pop().restore();
    }
  };
  for (var Us in f.beginFormObject = function(v, z, ie, he, Ee) {
    return id(v, z, ie, he, Ee), this;
  }, f.endFormObject = function(v) {
    return Up(v), this;
  }, f.doFormObject = function(v, z) {
    var ie = _n[Mn[v]];
    return X("q"), X(z.toString() + " cm"), X("/" + ie.id + " Do"), X("Q"), this;
  }, f.getFormObject = function(v) {
    var z = _n[Mn[v]];
    return { x: z.x, y: z.y, width: z.width, height: z.height, matrix: z.matrix };
  }, f.save = function(v, z) {
    return v = v || "generated.pdf", (z = z || {}).returnPromise = z.returnPromise || !1, z.returnPromise === !1 ? (ts(Fs(va()), v), typeof ts.unload == "function" && wt.setTimeout && setTimeout(ts.unload, 911), this) : new Promise(function(ie, he) {
      try {
        var Ee = ts(Fs(va()), v);
        typeof ts.unload == "function" && wt.setTimeout && setTimeout(ts.unload, 911), ie(Ee);
      } catch (De) {
        he(De.message);
      }
    });
  }, xt.API) xt.API.hasOwnProperty(Us) && (Us === "events" && xt.API.events.length ? function(v, z) {
    var ie, he, Ee;
    for (Ee = z.length - 1; Ee !== -1; Ee--) ie = z[Ee][0], he = z[Ee][1], v.subscribe.apply(v, [ie].concat(typeof he == "function" ? [he] : he));
  }(ut, xt.API.events) : f[Us] = xt.API[Us]);
  var Qo = f.getPageWidth = function(v) {
    return (mt[v = v || U].mediaBox.topRightX - mt[v].mediaBox.bottomLeftX) / $e;
  }, Kl = f.setPageWidth = function(v, z) {
    mt[v].mediaBox.topRightX = z * $e + mt[v].mediaBox.bottomLeftX;
  }, $a = f.getPageHeight = function(v) {
    return (mt[v = v || U].mediaBox.topRightY - mt[v].mediaBox.bottomLeftY) / $e;
  }, Xl = f.setPageHeight = function(v, z) {
    mt[v].mediaBox.topRightY = z * $e + mt[v].mediaBox.bottomLeftY;
  };
  return f.internal = { pdfEscape: Vr, getStyle: Zu, getFont: kp, getFontSize: fe, getCharSpace: Mp, getTextColor: Rp, getLineHeight: ed, getLineHeightFactor: nd, getLineWidth: Ds, write: Ye, getHorizontalCoordinate: Ji, getVerticalCoordinate: ba, getCoordinateString: Dp, getVerticalCoordinateString: Ha, collections: {}, newObject: Qt, newAdditionalObject: Xi, newObjectDeferred: en, newObjectDeferredBegin: jn, getFilters: ei, putStream: jr, events: ut, scaleFactor: $e, pageSize: { getWidth: function() {
    return Qo(U);
  }, setWidth: function(v) {
    Kl(U, v);
  }, getHeight: function() {
    return $a(U);
  }, setHeight: function(v) {
    Xl(U, v);
  } }, encryptionOptions: d, encryption: wr, getEncryptor: jp, output: Is, getNumberOfPages: Np, pages: _e, out: X, f2: D, f3: P, getPageInfo: Xu, getPageInfoByObjId: Nt, getCurrentPageInfo: Pp, getPDFVersion: b, Point: Ms, Rectangle: Ql, Matrix: ht, hasHotfix: Ku }, Object.defineProperty(f.internal.pageSize, "width", { get: function() {
    return Qo(U);
  }, set: function(v) {
    Kl(U, v);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(f.internal.pageSize, "height", { get: function() {
    return $a(U);
  }, set: function(v) {
    Xl(U, v);
  }, enumerable: !0, configurable: !0 }), xp.call(f, Te), Je = "F1", Gu(i, n), ut.publish("initialized"), f;
}
nl.prototype.lsbFirstWord = function(e) {
  return String.fromCharCode(e >> 0 & 255, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255);
}, nl.prototype.toHexString = function(e) {
  return e.split("").map(function(t) {
    return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, nl.prototype.hexToBytes = function(e) {
  for (var t = [], n = 0; n < e.length; n += 2) t.push(String.fromCharCode(parseInt(e.substr(n, 2), 16)));
  return t.join("");
}, nl.prototype.processOwnerPassword = function(e, t) {
  return Zm(Xm(t).substr(0, 5), e);
}, nl.prototype.encryptor = function(e, t) {
  var n = Xm(this.encryptionKey + String.fromCharCode(255 & e, e >> 8 & 255, e >> 16 & 255, 255 & t, t >> 8 & 255)).substr(0, 10);
  return function(r) {
    return Zm(n, r);
  };
}, Pf.prototype.equals = function(e) {
  var t, n = "id,objectNumber,equals";
  if (!e || Yt(e) !== Yt(this)) return !1;
  var r = 0;
  for (t in this) if (!(n.indexOf(t) >= 0)) {
    if (this.hasOwnProperty(t) && !e.hasOwnProperty(t) || this[t] !== e[t]) return !1;
    r++;
  }
  for (t in e) e.hasOwnProperty(t) && n.indexOf(t) < 0 && r--;
  return r === 0;
}, xt.API = { events: [] }, xt.version = "2.5.2";
var Dn = xt.API, P1 = 1, Os = function(e) {
  return e.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, As = function(e) {
  return e.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Et = function(e) {
  return e.toFixed(2);
}, ao = function(e) {
  return e.toFixed(5);
};
Dn.__acroform__ = {};
var Ar = function(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e;
}, Xy = function(e) {
  return e * P1;
}, ta = function(e) {
  var t = new Y3(), n = ft.internal.getHeight(e) || 0, r = ft.internal.getWidth(e) || 0;
  return t.BBox = [0, 0, Number(Et(r)), Number(Et(n))], t;
}, IB = Dn.__acroform__.setBit = function(e, t) {
  if (e = e || 0, t = t || 0, isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return e |= 1 << t;
}, kB = Dn.__acroform__.clearBit = function(e, t) {
  if (e = e || 0, t = t || 0, isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return e &= ~(1 << t);
}, DB = Dn.__acroform__.getBit = function(e, t) {
  if (isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return e & 1 << t ? 1 : 0;
}, $n = Dn.__acroform__.getBitForPdf = function(e, t) {
  if (isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return DB(e, t - 1);
}, Gn = Dn.__acroform__.setBitForPdf = function(e, t) {
  if (isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return IB(e, t - 1);
}, Qn = Dn.__acroform__.clearBitForPdf = function(e, t) {
  if (isNaN(e) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return kB(e, t - 1);
}, RB = Dn.__acroform__.calculateCoordinates = function(e, t) {
  var n = t.internal.getHorizontalCoordinate, r = t.internal.getVerticalCoordinate, i = e[0], a = e[1], o = e[2], s = e[3], l = {};
  return l.lowerLeft_X = n(i) || 0, l.lowerLeft_Y = r(a + s) || 0, l.upperRight_X = n(i + o) || 0, l.upperRight_Y = r(a) || 0, [Number(Et(l.lowerLeft_X)), Number(Et(l.lowerLeft_Y)), Number(Et(l.upperRight_X)), Number(Et(l.upperRight_Y))];
}, MB = function(e) {
  if (e.appearanceStreamContent) return e.appearanceStreamContent;
  if (e.V || e.DV) {
    var t = [], n = e._V || e.DV, r = Jm(e, n), i = e.scope.internal.getFont(e.fontName, e.fontStyle).id;
    t.push("/Tx BMC"), t.push("q"), t.push("BT"), t.push(e.scope.__private__.encodeColorString(e.color)), t.push("/" + i + " " + Et(r.fontSize) + " Tf"), t.push("1 0 0 1 0 0 Tm"), t.push(r.text), t.push("ET"), t.push("Q"), t.push("EMC");
    var a = ta(e);
    return a.scope = e.scope, a.stream = t.join(`
`), a;
  }
}, Jm = function(e, t) {
  var n = e.fontSize === 0 ? e.maxFontSize : e.fontSize, r = { text: "", fontSize: "" }, i = (t = (t = t.substr(0, 1) == "(" ? t.substr(1) : t).substr(t.length - 1) == ")" ? t.substr(0, t.length - 1) : t).split(" ");
  i = e.multiline ? i.map(function(P) {
    return P.split(`
`);
  }) : i.map(function(P) {
    return [P];
  });
  var a = n, o = ft.internal.getHeight(e) || 0;
  o = o < 0 ? -o : o;
  var s = ft.internal.getWidth(e) || 0;
  s = s < 0 ? -s : s;
  var l = function(P, L, H) {
    if (P + 1 < i.length) {
      var $ = L + " " + i[P + 1][0];
      return Kd($, e, H).width <= s - 4;
    }
    return !1;
  };
  a++;
  e: for (; a > 0; ) {
    t = "", a--;
    var c, d, p = Kd("3", e, a).height, y = e.multiline ? o - a : (o - p) / 2, f = y += 2, N = 0, b = 0, S = 0;
    if (a <= 0) {
      t = `(...) Tj
`, t += "% Width of Text: " + Kd(t, e, a = 12).width + ", FieldWidth:" + s + `
`;
      break;
    }
    for (var _ = "", E = 0, k = 0; k < i.length; k++) if (i.hasOwnProperty(k)) {
      var M = !1;
      if (i[k].length !== 1 && S !== i[k].length - 1) {
        if ((p + 2) * (E + 2) + 2 > o) continue e;
        _ += i[k][S], M = !0, b = k, k--;
      } else {
        _ = (_ += i[k][S] + " ").substr(_.length - 1) == " " ? _.substr(0, _.length - 1) : _;
        var F = parseInt(k), q = l(F, _, a), j = k >= i.length - 1;
        if (q && !j) {
          _ += " ", S = 0;
          continue;
        }
        if (q || j) {
          if (j) b = F;
          else if (e.multiline && (p + 2) * (E + 2) + 2 > o) continue e;
        } else {
          if (!e.multiline || (p + 2) * (E + 2) + 2 > o) continue e;
          b = F;
        }
      }
      for (var x = "", C = N; C <= b; C++) {
        var D = i[C];
        if (e.multiline) {
          if (C === b) {
            x += D[S] + " ", S = (S + 1) % D.length;
            continue;
          }
          if (C === N) {
            x += D[D.length - 1] + " ";
            continue;
          }
        }
        x += D[0] + " ";
      }
      switch (x = x.substr(x.length - 1) == " " ? x.substr(0, x.length - 1) : x, d = Kd(x, e, a).width, e.textAlign) {
        case "right":
          c = s - d - 2;
          break;
        case "center":
          c = (s - d) / 2;
          break;
        case "left":
        default:
          c = 2;
      }
      t += Et(c) + " " + Et(f) + ` Td
`, t += "(" + Os(x) + `) Tj
`, t += -Et(c) + ` 0 Td
`, f = -(a + 2), d = 0, N = M ? b : b + 1, E++, _ = "";
    }
    break;
  }
  return r.text = t, r.fontSize = a, r;
}, Kd = function(e, t, n) {
  var r = t.scope.internal.getFont(t.fontName, t.fontStyle), i = t.scope.getStringUnitWidth(e, { font: r, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n);
  return { height: t.scope.getStringUnitWidth("3", { font: r, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n) * 1.5, width: i };
}, UB = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, BB = function(e, t) {
  var n = { type: "reference", object: e };
  t.internal.getPageInfo(e.page).pageContext.annotations.find(function(r) {
    return r.type === n.type && r.object === n.object;
  }) === void 0 && t.internal.getPageInfo(e.page).pageContext.annotations.push(n);
}, zB = function(e, t) {
  for (var n in e) if (e.hasOwnProperty(n)) {
    var r = n, i = e[n];
    t.internal.newObjectDeferredBegin(i.objId, !0), Yt(i) === "object" && typeof i.putStream == "function" && i.putStream(), delete e[r];
  }
}, qB = function(e, t) {
  if (t.scope = e, e.internal !== void 0 && (e.internal.acroformPlugin === void 0 || e.internal.acroformPlugin.isInitialized === !1)) {
    if (Yi.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(UB)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    P1 = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new K3(), e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
      (function(n) {
        n.internal.events.unsubscribe(n.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete n.internal.acroformPlugin.acroFormDictionaryRoot._eventID, n.internal.acroformPlugin.printedOut = !0;
      })(e);
    }), e.internal.events.subscribe("buildDocument", function() {
      (function(n) {
        n.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var r = n.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var i in r) if (r.hasOwnProperty(i)) {
          var a = r[i];
          a.objId = void 0, a.hasAnnotation && BB(a, n);
        }
      })(e);
    }), e.internal.events.subscribe("putCatalog", function() {
      (function(n) {
        if (n.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        n.internal.write("/AcroForm " + n.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(e);
    }), e.internal.events.subscribe("postPutPages", function(n) {
      (function(r, i) {
        var a = !r;
        for (var o in r || (i.internal.newObjectDeferredBegin(i.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), i.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), r = r || i.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (r.hasOwnProperty(o)) {
          var s = r[o], l = [], c = s.Rect;
          if (s.Rect && (s.Rect = RB(s.Rect, i)), i.internal.newObjectDeferredBegin(s.objId, !0), s.DA = ft.createDefaultAppearanceStream(s), Yt(s) === "object" && typeof s.getKeyValueListForStream == "function" && (l = s.getKeyValueListForStream()), s.Rect = c, s.hasAppearanceStream && !s.appearanceStreamContent) {
            var d = MB(s);
            l.push({ key: "AP", value: "<</N " + d + ">>" }), i.internal.acroformPlugin.xForms.push(d);
          }
          if (s.appearanceStreamContent) {
            var p = "";
            for (var y in s.appearanceStreamContent) if (s.appearanceStreamContent.hasOwnProperty(y)) {
              var f = s.appearanceStreamContent[y];
              if (p += "/" + y + " ", p += "<<", Object.keys(f).length >= 1 || Array.isArray(f)) {
                for (var o in f) if (f.hasOwnProperty(o)) {
                  var N = f[o];
                  typeof N == "function" && (N = N.call(i, s)), p += "/" + o + " " + N + " ", i.internal.acroformPlugin.xForms.indexOf(N) >= 0 || i.internal.acroformPlugin.xForms.push(N);
                }
              } else typeof (N = f) == "function" && (N = N.call(i, s)), p += "/" + o + " " + N, i.internal.acroformPlugin.xForms.indexOf(N) >= 0 || i.internal.acroformPlugin.xForms.push(N);
              p += ">>";
            }
            l.push({ key: "AP", value: `<<
` + p + ">>" });
          }
          i.internal.putStream({ additionalKeyValues: l, objectId: s.objId }), i.internal.out("endobj");
        }
        a && zB(i.internal.acroformPlugin.xForms, i);
      })(n, e);
    }), e.internal.acroformPlugin.isInitialized = !0;
  }
}, Q3 = Dn.__acroform__.arrayToPdfArray = function(e, t, n) {
  var r = function(o) {
    return o;
  };
  if (Array.isArray(e)) {
    for (var i = "[", a = 0; a < e.length; a++) switch (a !== 0 && (i += " "), Yt(e[a])) {
      case "boolean":
      case "number":
      case "object":
        i += e[a].toString();
        break;
      case "string":
        e[a].substr(0, 1) !== "/" ? (t !== void 0 && n && (r = n.internal.getEncryptor(t)), i += "(" + Os(r(e[a].toString())) + ")") : i += e[a].toString();
    }
    return i += "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, qh = function(e, t, n) {
  var r = function(i) {
    return i;
  };
  return t !== void 0 && n && (r = n.internal.getEncryptor(t)), (e = e || "").toString(), e = "(" + Os(r(e)) + ")";
}, ra = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(e) {
    this._objId = e;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
ra.prototype.toString = function() {
  return this.objId + " 0 R";
}, ra.prototype.putStream = function() {
  var e = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: e, objectId: this.objId }), this.scope.internal.out("endobj");
}, ra.prototype.getKeyValueListForStream = function() {
  var e = [], t = Object.getOwnPropertyNames(this).filter(function(a) {
    return a != "content" && a != "appearanceStreamContent" && a != "scope" && a != "objId" && a.substring(0, 1) != "_";
  });
  for (var n in t) if (Object.getOwnPropertyDescriptor(this, t[n]).configurable === !1) {
    var r = t[n], i = this[r];
    i && (Array.isArray(i) ? e.push({ key: r, value: Q3(i, this.objId, this.scope) }) : i instanceof ra ? (i.scope = this.scope, e.push({ key: r, value: i.objId + " 0 R" })) : typeof i != "function" && e.push({ key: r, value: i }));
  }
  return e;
};
var Y3 = function() {
  ra.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var e, t = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(n) {
    e = n.trim();
  }, get: function() {
    return e || null;
  } });
};
Ar(Y3, ra);
var K3 = function() {
  ra.call(this);
  var e, t = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return t.length > 0 ? t : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return t;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (e) {
      var n = function(r) {
        return r;
      };
      return this.scope && (n = this.scope.internal.getEncryptor(this.objId)), "(" + Os(n(e)) + ")";
    }
  }, set: function(n) {
    e = n;
  } });
};
Ar(K3, ra);
var Yi = function e() {
  ra.call(this);
  var t = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(_) {
    if (isNaN(_)) throw new Error('Invalid value "' + _ + '" for attribute F supplied.');
    t = _;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(t, 3);
  }, set: function(_) {
    _ ? this.F = Gn(t, 3) : this.F = Qn(t, 3);
  } });
  var n = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(_) {
    if (isNaN(_)) throw new Error('Invalid value "' + _ + '" for attribute Ff supplied.');
    n = _;
  } });
  var r = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (r.length !== 0) return r;
  }, set: function(_) {
    r = _ !== void 0 ? _ : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[0]) ? 0 : r[0];
  }, set: function(_) {
    r[0] = _;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[1]) ? 0 : r[1];
  }, set: function(_) {
    r[1] = _;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[2]) ? 0 : r[2];
  }, set: function(_) {
    r[2] = _;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[3]) ? 0 : r[3];
  }, set: function(_) {
    r[3] = _;
  } });
  var i = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return i;
  }, set: function(_) {
    switch (_) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        i = _;
        break;
      default:
        throw new Error('Invalid value "' + _ + '" for attribute FT supplied.');
    }
  } });
  var a = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!a || a.length < 1) {
      if (this instanceof Lf) return;
      a = "FieldObject" + e.FieldNum++;
    }
    var _ = function(E) {
      return E;
    };
    return this.scope && (_ = this.scope.internal.getEncryptor(this.objId)), "(" + Os(_(a)) + ")";
  }, set: function(_) {
    a = _.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return a;
  }, set: function(_) {
    a = _;
  } });
  var o = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(_) {
    o = _;
  } });
  var s = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(_) {
    s = _;
  } });
  var l = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return l;
  }, set: function(_) {
    l = _;
  } });
  var c = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return c === void 0 ? 50 / P1 : c;
  }, set: function(_) {
    c = _;
  } });
  var d = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return d;
  }, set: function(_) {
    d = _;
  } });
  var p = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!p || this instanceof Lf || this instanceof us)) return qh(p, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), p = _;
  } });
  var y = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (y) return this instanceof cr ? y : qh(y, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), y = this instanceof cr ? _ : _.substr(0, 1) === "(" ? As(_.substr(1, _.length - 2)) : As(_);
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof cr ? As(y.substr(1, y.length - 1)) : y;
  }, set: function(_) {
    _ = _.toString(), y = this instanceof cr ? "/" + _ : _;
  } });
  var f = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (f) return f;
  }, set: function(_) {
    this.V = _;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (f) return this instanceof cr ? f : qh(f, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), f = this instanceof cr ? _ : _.substr(0, 1) === "(" ? As(_.substr(1, _.length - 2)) : As(_);
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof cr ? As(f.substr(1, f.length - 1)) : f;
  }, set: function(_) {
    _ = _.toString(), f = this instanceof cr ? "/" + _ : _;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var N, b = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return b;
  }, set: function(_) {
    _ = !!_, b = _;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (N) return N;
  }, set: function(_) {
    N = _;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 1);
  }, set: function(_) {
    _ ? this.Ff = Gn(this.Ff, 1) : this.Ff = Qn(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 2);
  }, set: function(_) {
    _ ? this.Ff = Gn(this.Ff, 2) : this.Ff = Qn(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 3);
  }, set: function(_) {
    _ ? this.Ff = Gn(this.Ff, 3) : this.Ff = Qn(this.Ff, 3);
  } });
  var S = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (S !== null) return S;
  }, set: function(_) {
    if ([0, 1, 2].indexOf(_) === -1) throw new Error('Invalid value "' + _ + '" for attribute Q supplied.');
    S = _;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var _;
    switch (S) {
      case 0:
      default:
        _ = "left";
        break;
      case 1:
        _ = "center";
        break;
      case 2:
        _ = "right";
    }
    return _;
  }, configurable: !0, enumerable: !0, set: function(_) {
    switch (_) {
      case "right":
      case 2:
        S = 2;
        break;
      case "center":
      case 1:
        S = 1;
        break;
      case "left":
      case 0:
      default:
        S = 0;
    }
  } });
};
Ar(Yi, ra);
var ml = function() {
  Yi.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var e = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } });
  var t = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return Q3(t, this.objId, this.scope);
  }, set: function(n) {
    var r, i;
    i = [], typeof (r = n) == "string" && (i = function(a, o, s) {
      s || (s = 1);
      for (var l, c = []; l = o.exec(a); ) c.push(l[s]);
      return c;
    }(r, /\((.*?)\)/g)), t = i;
  } }), this.getOptions = function() {
    return t;
  }, this.setOptions = function(n) {
    t = n, this.sort && t.sort();
  }, this.addOption = function(n) {
    n = (n = n || "").toString(), t.push(n), this.sort && t.sort();
  }, this.removeOption = function(n, r) {
    for (r = r || !1, n = (n = n || "").toString(); t.indexOf(n) !== -1 && (t.splice(t.indexOf(n), 1), r !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 18);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 18) : this.Ff = Qn(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 19);
  }, set: function(n) {
    this.combo === !0 && (n ? this.Ff = Gn(this.Ff, 19) : this.Ff = Qn(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 20);
  }, set: function(n) {
    n ? (this.Ff = Gn(this.Ff, 20), t.sort()) : this.Ff = Qn(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 22);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 22) : this.Ff = Qn(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 23);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 23) : this.Ff = Qn(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 27);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 27) : this.Ff = Qn(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
Ar(ml, Yi);
var gl = function() {
  ml.call(this), this.fontName = "helvetica", this.combo = !1;
};
Ar(gl, ml);
var yl = function() {
  gl.call(this), this.combo = !0;
};
Ar(yl, gl);
var df = function() {
  yl.call(this), this.edit = !0;
};
Ar(df, yl);
var cr = function() {
  Yi.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 15);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 15) : this.Ff = Qn(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 16);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 16) : this.Ff = Qn(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 17);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 17) : this.Ff = Qn(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 26);
  }, set: function(n) {
    n ? this.Ff = Gn(this.Ff, 26) : this.Ff = Qn(this.Ff, 26);
  } });
  var e, t = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(a) {
      return a;
    };
    if (this.scope && (n = this.scope.internal.getEncryptor(this.objId)), Object.keys(t).length !== 0) {
      var r, i = [];
      for (r in i.push("<<"), t) i.push("/" + r + " (" + Os(n(t[r])) + ")");
      return i.push(">>"), i.join(`
`);
    }
  }, set: function(n) {
    Yt(n) === "object" && (t = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return t.CA || "";
  }, set: function(n) {
    typeof n == "string" && (t.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return e.substr(1, e.length - 1);
  }, set: function(n) {
    e = "/" + n;
  } });
};
Ar(cr, Yi);
var ff = function() {
  cr.call(this), this.pushButton = !0;
};
Ar(ff, cr);
var vl = function() {
  cr.call(this), this.radio = !0, this.pushButton = !1;
  var e = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    e = t !== void 0 ? t : [];
  } });
};
Ar(vl, cr);
var Lf = function() {
  var e, t;
  Yi.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(i) {
    e = i;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return t;
  }, set: function(i) {
    t = i;
  } });
  var n, r = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var i = function(s) {
      return s;
    };
    this.scope && (i = this.scope.internal.getEncryptor(this.objId));
    var a, o = [];
    for (a in o.push("<<"), r) o.push("/" + a + " (" + Os(i(r[a])) + ")");
    return o.push(">>"), o.join(`
`);
  }, set: function(i) {
    Yt(i) === "object" && (r = i);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return r.CA || "";
  }, set: function(i) {
    typeof i == "string" && (r.CA = i);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(i) {
    n = i;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return n.substr(1, n.length - 1);
  }, set: function(i) {
    n = "/" + i;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = ft.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
Ar(Lf, Yi), vl.prototype.setAppearance = function(e) {
  if (!("createAppearanceStream" in e) || !("getCA" in e)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var t in this.Kids) if (this.Kids.hasOwnProperty(t)) {
    var n = this.Kids[t];
    n.appearanceStreamContent = e.createAppearanceStream(n.optionName), n.caption = e.getCA();
  }
}, vl.prototype.createOption = function(e) {
  var t = new Lf();
  return t.Parent = this, t.optionName = e, this.Kids.push(t), VB.call(this.scope, t), t;
};
var pf = function() {
  cr.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = ft.CheckBox.createAppearanceStream();
};
Ar(pf, cr);
var us = function() {
  Yi.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 13);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 13) : this.Ff = Qn(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 21);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 21) : this.Ff = Qn(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 23);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 23) : this.Ff = Qn(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 24);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 24) : this.Ff = Qn(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 25);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 25) : this.Ff = Qn(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 26);
  }, set: function(t) {
    t ? this.Ff = Gn(this.Ff, 26) : this.Ff = Qn(this.Ff, 26);
  } });
  var e = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return e;
  }, set: function(t) {
    e = t;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return e;
  }, set: function(t) {
    Number.isInteger(t) && (e = t);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
Ar(us, Yi);
var hf = function() {
  us.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!$n(this.Ff, 14);
  }, set: function(e) {
    e ? this.Ff = Gn(this.Ff, 14) : this.Ff = Qn(this.Ff, 14);
  } }), this.password = !0;
};
Ar(hf, us);
var ft = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: ft.CheckBox.YesNormal }, D: { On: ft.CheckBox.YesPushDown, Off: ft.CheckBox.OffPushDown } };
}, YesPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [], r = e.scope.internal.getFont(e.fontName, e.fontStyle).id, i = e.scope.__private__.encodeColorString(e.color), a = Jm(e, e.caption);
  return n.push("0.749023 g"), n.push("0 0 " + Et(ft.internal.getWidth(e)) + " " + Et(ft.internal.getHeight(e)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + Et(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), t.stream = n.join(`
`), t;
}, YesNormal: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = e.scope.internal.getFont(e.fontName, e.fontStyle).id, r = e.scope.__private__.encodeColorString(e.color), i = [], a = ft.internal.getHeight(e), o = ft.internal.getWidth(e), s = Jm(e, e.caption);
  return i.push("1 g"), i.push("0 0 " + Et(o) + " " + Et(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + Et(o - 1) + " " + Et(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + Et(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), t.stream = i.join(`
`), t;
}, OffPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + Et(ft.internal.getWidth(e)) + " " + Et(ft.internal.getHeight(e)) + " re"), n.push("f"), t.stream = n.join(`
`), t;
} }, RadioButton: { Circle: { createAppearanceStream: function(e) {
  var t = { D: { Off: ft.RadioButton.Circle.OffPushDown }, N: {} };
  return t.N[e] = ft.RadioButton.Circle.YesNormal, t.D[e] = ft.RadioButton.Circle.YesPushDown, t;
}, getCA: function() {
  return "l";
}, YesNormal: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [], r = ft.internal.getWidth(e) <= ft.internal.getHeight(e) ? ft.internal.getWidth(e) / 4 : ft.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var i = ft.internal.Bezier_C, a = Number((r * i).toFixed(5));
  return n.push("q"), n.push("1 0 0 1 " + ao(ft.internal.getWidth(e) / 2) + " " + ao(ft.internal.getHeight(e) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join(`
`), t;
}, YesPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [], r = ft.internal.getWidth(e) <= ft.internal.getHeight(e) ? ft.internal.getWidth(e) / 4 : ft.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var i = Number((2 * r).toFixed(5)), a = Number((i * ft.internal.Bezier_C).toFixed(5)), o = Number((r * ft.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + ao(ft.internal.getWidth(e) / 2) + " " + ao(ft.internal.getHeight(e) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + ao(ft.internal.getWidth(e) / 2) + " " + ao(ft.internal.getHeight(e) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join(`
`), t;
}, OffPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [], r = ft.internal.getWidth(e) <= ft.internal.getHeight(e) ? ft.internal.getWidth(e) / 4 : ft.internal.getHeight(e) / 4;
  r = Number((0.9 * r).toFixed(5));
  var i = Number((2 * r).toFixed(5)), a = Number((i * ft.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + ao(ft.internal.getWidth(e) / 2) + " " + ao(ft.internal.getHeight(e) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join(`
`), t;
} }, Cross: { createAppearanceStream: function(e) {
  var t = { D: { Off: ft.RadioButton.Cross.OffPushDown }, N: {} };
  return t.N[e] = ft.RadioButton.Cross.YesNormal, t.D[e] = ft.RadioButton.Cross.YesPushDown, t;
}, getCA: function() {
  return "8";
}, YesNormal: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [], r = ft.internal.calculateCross(e);
  return n.push("q"), n.push("1 1 " + Et(ft.internal.getWidth(e) - 2) + " " + Et(ft.internal.getHeight(e) - 2) + " re"), n.push("W"), n.push("n"), n.push(Et(r.x1.x) + " " + Et(r.x1.y) + " m"), n.push(Et(r.x2.x) + " " + Et(r.x2.y) + " l"), n.push(Et(r.x4.x) + " " + Et(r.x4.y) + " m"), n.push(Et(r.x3.x) + " " + Et(r.x3.y) + " l"), n.push("s"), n.push("Q"), t.stream = n.join(`
`), t;
}, YesPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = ft.internal.calculateCross(e), r = [];
  return r.push("0.749023 g"), r.push("0 0 " + Et(ft.internal.getWidth(e)) + " " + Et(ft.internal.getHeight(e)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + Et(ft.internal.getWidth(e) - 2) + " " + Et(ft.internal.getHeight(e) - 2) + " re"), r.push("W"), r.push("n"), r.push(Et(n.x1.x) + " " + Et(n.x1.y) + " m"), r.push(Et(n.x2.x) + " " + Et(n.x2.y) + " l"), r.push(Et(n.x4.x) + " " + Et(n.x4.y) + " m"), r.push(Et(n.x3.x) + " " + Et(n.x3.y) + " l"), r.push("s"), r.push("Q"), t.stream = r.join(`
`), t;
}, OffPushDown: function(e) {
  var t = ta(e);
  t.scope = e.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + Et(ft.internal.getWidth(e)) + " " + Et(ft.internal.getHeight(e)) + " re"), n.push("f"), t.stream = n.join(`
`), t;
} } }, createDefaultAppearanceStream: function(e) {
  var t = e.scope.internal.getFont(e.fontName, e.fontStyle).id, n = e.scope.__private__.encodeColorString(e.color);
  return "/" + t + " " + e.fontSize + " Tf " + n;
} };
ft.internal = { Bezier_C: 0.551915024494, calculateCross: function(e) {
  var t = ft.internal.getWidth(e), n = ft.internal.getHeight(e), r = Math.min(t, n);
  return { x1: { x: (t - r) / 2, y: (n - r) / 2 + r }, x2: { x: (t - r) / 2 + r, y: (n - r) / 2 }, x3: { x: (t - r) / 2, y: (n - r) / 2 }, x4: { x: (t - r) / 2 + r, y: (n - r) / 2 + r } };
} }, ft.internal.getWidth = function(e) {
  var t = 0;
  return Yt(e) === "object" && (t = Xy(e.Rect[2])), t;
}, ft.internal.getHeight = function(e) {
  var t = 0;
  return Yt(e) === "object" && (t = Xy(e.Rect[3])), t;
};
var VB = Dn.addField = function(e) {
  if (qB(this, e), !(e instanceof Yi)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var t;
  return (t = e).scope.internal.acroformPlugin.printedOut && (t.scope.internal.acroformPlugin.printedOut = !1, t.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), t.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t), e.page = e.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Dn.AcroFormChoiceField = ml, Dn.AcroFormListBox = gl, Dn.AcroFormComboBox = yl, Dn.AcroFormEditBox = df, Dn.AcroFormButton = cr, Dn.AcroFormPushButton = ff, Dn.AcroFormRadioButton = vl, Dn.AcroFormCheckBox = pf, Dn.AcroFormTextField = us, Dn.AcroFormPasswordField = hf, Dn.AcroFormAppearance = ft, Dn.AcroForm = { ChoiceField: ml, ListBox: gl, ComboBox: yl, EditBox: df, Button: cr, PushButton: ff, RadioButton: vl, CheckBox: pf, TextField: us, PasswordField: hf, Appearance: ft }, xt.AcroForm = { ChoiceField: ml, ListBox: gl, ComboBox: yl, EditBox: df, Button: cr, PushButton: ff, RadioButton: vl, CheckBox: pf, TextField: us, PasswordField: hf, Appearance: ft };
function X3(e) {
  return e.reduce(function(t, n, r) {
    return t[n] = r, t;
  }, {});
}
(function(e) {
  e.__addimage__ = {};
  var t = "UNKNOWN", n = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, r = e.__addimage__.getImageFileTypeByImageData = function(P, L) {
    var H, $, ae, ce, le, oe = t;
    if ((L = L || t) === "RGBA" || P.data !== void 0 && P.data instanceof Uint8ClampedArray && "height" in P && "width" in P) return "RGBA";
    if (q(P)) for (le in n) for (ae = n[le], H = 0; H < ae.length; H += 1) {
      for (ce = !0, $ = 0; $ < ae[H].length; $ += 1) if (ae[H][$] !== void 0 && ae[H][$] !== P[$]) {
        ce = !1;
        break;
      }
      if (ce === !0) {
        oe = le;
        break;
      }
    }
    else for (le in n) for (ae = n[le], H = 0; H < ae.length; H += 1) {
      for (ce = !0, $ = 0; $ < ae[H].length; $ += 1) if (ae[H][$] !== void 0 && ae[H][$] !== P.charCodeAt($)) {
        ce = !1;
        break;
      }
      if (ce === !0) {
        oe = le;
        break;
      }
    }
    return oe === t && L !== t && (oe = L), oe;
  }, i = function P(L) {
    for (var H = this.internal.write, $ = this.internal.putStream, ae = (0, this.internal.getFilters)(); ae.indexOf("FlateEncode") !== -1; ) ae.splice(ae.indexOf("FlateEncode"), 1);
    L.objectId = this.internal.newObject();
    var ce = [];
    if (ce.push({ key: "Type", value: "/XObject" }), ce.push({ key: "Subtype", value: "/Image" }), ce.push({ key: "Width", value: L.width }), ce.push({ key: "Height", value: L.height }), L.colorSpace === S.INDEXED ? ce.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (L.palette.length / 3 - 1) + " " + ("sMask" in L && L.sMask !== void 0 ? L.objectId + 2 : L.objectId + 1) + " 0 R]" }) : (ce.push({ key: "ColorSpace", value: "/" + L.colorSpace }), L.colorSpace === S.DEVICE_CMYK && ce.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), ce.push({ key: "BitsPerComponent", value: L.bitsPerComponent }), "decodeParameters" in L && L.decodeParameters !== void 0 && ce.push({ key: "DecodeParms", value: "<<" + L.decodeParameters + ">>" }), "transparency" in L && Array.isArray(L.transparency)) {
      for (var le = "", oe = 0, se = L.transparency.length; oe < se; oe++) le += L.transparency[oe] + " " + L.transparency[oe] + " ";
      ce.push({ key: "Mask", value: "[" + le + "]" });
    }
    L.sMask !== void 0 && ce.push({ key: "SMask", value: L.objectId + 1 + " 0 R" });
    var J = L.filter !== void 0 ? ["/" + L.filter] : void 0;
    if ($({ data: L.data, additionalKeyValues: ce, alreadyAppliedFilters: J, objectId: L.objectId }), H("endobj"), "sMask" in L && L.sMask !== void 0) {
      var re = "/Predictor " + L.predictor + " /Colors 1 /BitsPerComponent " + L.bitsPerComponent + " /Columns " + L.width, I = { width: L.width, height: L.height, colorSpace: "DeviceGray", bitsPerComponent: L.bitsPerComponent, decodeParameters: re, data: L.sMask };
      "filter" in L && (I.filter = L.filter), P.call(this, I);
    }
    if (L.colorSpace === S.INDEXED) {
      var U = this.internal.newObject();
      $({ data: x(new Uint8Array(L.palette)), objectId: U }), H("endobj");
    }
  }, a = function() {
    var P = this.internal.collections.addImage_images;
    for (var L in P) i.call(this, P[L]);
  }, o = function() {
    var P, L = this.internal.collections.addImage_images, H = this.internal.write;
    for (var $ in L) H("/I" + (P = L[$]).index, P.objectId, "0", "R");
  }, s = function() {
    this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", a), this.internal.events.subscribe("putXobjectDict", o));
  }, l = function() {
    var P = this.internal.collections.addImage_images;
    return s.call(this), P;
  }, c = function() {
    return Object.keys(this.internal.collections.addImage_images).length;
  }, d = function(P) {
    return typeof e["process" + P.toUpperCase()] == "function";
  }, p = function(P) {
    return Yt(P) === "object" && P.nodeType === 1;
  }, y = function(P, L) {
    if (P.nodeName === "IMG" && P.hasAttribute("src")) {
      var H = "" + P.getAttribute("src");
      if (H.indexOf("data:image/") === 0) return Hc(unescape(H).split("base64,").pop());
      var $ = e.loadFile(H, !0);
      if ($ !== void 0) return $;
    }
    if (P.nodeName === "CANVAS") {
      if (P.width === 0 || P.height === 0) throw new Error("Given canvas must have data. Canvas width: " + P.width + ", height: " + P.height);
      var ae;
      switch (L) {
        case "PNG":
          ae = "image/png";
          break;
        case "WEBP":
          ae = "image/webp";
          break;
        case "JPEG":
        case "JPG":
        default:
          ae = "image/jpeg";
      }
      return Hc(P.toDataURL(ae, 1).split("base64,").pop());
    }
  }, f = function(P) {
    var L = this.internal.collections.addImage_images;
    if (L) {
      for (var H in L) if (P === L[H].alias) return L[H];
    }
  }, N = function(P, L, H) {
    return P || L || (P = -96, L = -96), P < 0 && (P = -1 * H.width * 72 / P / this.internal.scaleFactor), L < 0 && (L = -1 * H.height * 72 / L / this.internal.scaleFactor), P === 0 && (P = L * H.width / H.height), L === 0 && (L = P * H.height / H.width), [P, L];
  }, b = function(P, L, H, $, ae, ce) {
    var le = N.call(this, H, $, ae), oe = this.internal.getCoordinateString, se = this.internal.getVerticalCoordinateString, J = l.call(this);
    if (H = le[0], $ = le[1], J[ae.index] = ae, ce) {
      ce *= Math.PI / 180;
      var re = Math.cos(ce), I = Math.sin(ce), U = function(K) {
        return K.toFixed(4);
      }, G = [U(re), U(I), U(-1 * I), U(re), 0, 0, "cm"];
    }
    this.internal.write("q"), ce ? (this.internal.write([1, "0", "0", 1, oe(P), se(L + $), "cm"].join(" ")), this.internal.write(G.join(" ")), this.internal.write([oe(H), "0", "0", oe($), "0", "0", "cm"].join(" "))) : this.internal.write([oe(H), "0", "0", oe($), oe(P), se(L + $), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + ae.index + " Do"), this.internal.write("Q");
  }, S = e.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  e.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var _ = e.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, E = e.__addimage__.sHashCode = function(P) {
    var L, H, $ = 0;
    if (typeof P == "string") for (H = P.length, L = 0; L < H; L++) $ = ($ << 5) - $ + P.charCodeAt(L), $ |= 0;
    else if (q(P)) for (H = P.byteLength / 2, L = 0; L < H; L++) $ = ($ << 5) - $ + P[L], $ |= 0;
    return $;
  }, k = e.__addimage__.validateStringAsBase64 = function(P) {
    (P = P || "").toString().trim();
    var L = !0;
    return P.length === 0 && (L = !1), P.length % 4 != 0 && (L = !1), /^[A-Za-z0-9+/]+$/.test(P.substr(0, P.length - 2)) === !1 && (L = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(P.substr(-2)) === !1 && (L = !1), L;
  }, M = e.__addimage__.extractImageFromDataUrl = function(P) {
    var L = (P = P || "").split("base64,"), H = null;
    if (L.length === 2) {
      var $ = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(L[0]);
      Array.isArray($) && (H = { mimeType: $[1], charset: $[2], data: L[1] });
    }
    return H;
  }, F = e.__addimage__.supportsArrayBuffer = function() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  };
  e.__addimage__.isArrayBuffer = function(P) {
    return F() && P instanceof ArrayBuffer;
  };
  var q = e.__addimage__.isArrayBufferView = function(P) {
    return F() && typeof Uint32Array < "u" && (P instanceof Int8Array || P instanceof Uint8Array || typeof Uint8ClampedArray < "u" && P instanceof Uint8ClampedArray || P instanceof Int16Array || P instanceof Uint16Array || P instanceof Int32Array || P instanceof Uint32Array || P instanceof Float32Array || P instanceof Float64Array);
  }, j = e.__addimage__.binaryStringToUint8Array = function(P) {
    for (var L = P.length, H = new Uint8Array(L), $ = 0; $ < L; $++) H[$] = P.charCodeAt($);
    return H;
  }, x = e.__addimage__.arrayBufferToBinaryString = function(P) {
    for (var L = "", H = q(P) ? P : new Uint8Array(P), $ = 0; $ < H.length; $ += 8192) L += String.fromCharCode.apply(null, H.subarray($, $ + 8192));
    return L;
  };
  e.addImage = function() {
    var P, L, H, $, ae, ce, le, oe, se;
    if (typeof arguments[1] == "number" ? (L = t, H = arguments[1], $ = arguments[2], ae = arguments[3], ce = arguments[4], le = arguments[5], oe = arguments[6], se = arguments[7]) : (L = arguments[1], H = arguments[2], $ = arguments[3], ae = arguments[4], ce = arguments[5], le = arguments[6], oe = arguments[7], se = arguments[8]), Yt(P = arguments[0]) === "object" && !p(P) && "imageData" in P) {
      var J = P;
      P = J.imageData, L = J.format || L || t, H = J.x || H || 0, $ = J.y || $ || 0, ae = J.w || J.width || ae, ce = J.h || J.height || ce, le = J.alias || le, oe = J.compression || oe, se = J.rotation || J.angle || se;
    }
    var re = this.internal.getFilters();
    if (oe === void 0 && re.indexOf("FlateEncode") !== -1 && (oe = "SLOW"), isNaN(H) || isNaN($)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    s.call(this);
    var I = C.call(this, P, L, le, oe);
    return b.call(this, H, $, ae, ce, I, se), this;
  };
  var C = function(P, L, H, $) {
    var ae, ce, le;
    if (typeof P == "string" && r(P) === t) {
      P = unescape(P);
      var oe = D(P, !1);
      (oe !== "" || (oe = e.loadFile(P, !0)) !== void 0) && (P = oe);
    }
    if (p(P) && (P = y(P, L)), L = r(P, L), !d(L)) throw new Error("addImage does not support files of type '" + L + "', please ensure that a plugin for '" + L + "' support is added.");
    if (((le = H) == null || le.length === 0) && (H = function(se) {
      return typeof se == "string" || q(se) ? E(se) : q(se.data) ? E(se.data) : null;
    }(P)), (ae = f.call(this, H)) || (F() && (P instanceof Uint8Array || L === "RGBA" || (ce = P, P = j(P))), ae = this["process" + L.toUpperCase()](P, c.call(this), H, function(se) {
      return se && typeof se == "string" && (se = se.toUpperCase()), se in e.image_compression ? se : _.NONE;
    }($), ce)), !ae) throw new Error("An unknown error occurred whilst processing the image.");
    return ae;
  }, D = e.__addimage__.convertBase64ToBinaryString = function(P, L) {
    var H;
    L = typeof L != "boolean" || L;
    var $, ae = "";
    if (typeof P == "string") {
      $ = (H = M(P)) !== null ? H.data : P;
      try {
        ae = Hc($);
      } catch (ce) {
        if (L) throw k($) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + ce.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return ae;
  };
  e.getImageProperties = function(P) {
    var L, H, $ = "";
    if (p(P) && (P = y(P)), typeof P == "string" && r(P) === t && (($ = D(P, !1)) === "" && ($ = e.loadFile(P) || ""), P = $), H = r(P), !d(H)) throw new Error("addImage does not support files of type '" + H + "', please ensure that a plugin for '" + H + "' support is added.");
    if (!F() || P instanceof Uint8Array || (P = j(P)), !(L = this["process" + H.toUpperCase()](P))) throw new Error("An unknown error occurred whilst processing the image");
    return L.fileType = H, L;
  };
})(xt.API), /**
* @license
* Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = function(n) {
    if (n !== void 0 && n != "") return !0;
  };
  xt.API.events.push(["addPage", function(n) {
    this.internal.getPageInfo(n.pageNumber).pageContext.annotations = [];
  }]), e.events.push(["putPage", function(n) {
    for (var r, i, a, o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString, l = this.internal.getPageInfoByObjId(n.objId), c = n.pageContext.annotations, d = !1, p = 0; p < c.length && !d; p++) switch ((r = c[p]).type) {
      case "link":
        (t(r.options.url) || t(r.options.pageNumber)) && (d = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        d = !0;
    }
    if (d != 0) {
      this.internal.write("/Annots [");
      for (var y = 0; y < c.length; y++) {
        r = c[y];
        var f = this.internal.pdfEscape, N = this.internal.getEncryptor(n.objId);
        switch (r.type) {
          case "reference":
            this.internal.write(" " + r.object.objId + " 0 R ");
            break;
          case "text":
            var b = this.internal.newAdditionalObject(), S = this.internal.newAdditionalObject(), _ = this.internal.getEncryptor(b.objId), E = r.title || "Note";
            a = "<</Type /Annot /Subtype /Text " + (i = "/Rect [" + o(r.bounds.x) + " " + s(r.bounds.y + r.bounds.h) + " " + o(r.bounds.x + r.bounds.w) + " " + s(r.bounds.y) + "] ") + "/Contents (" + f(_(r.contents)) + ")", a += " /Popup " + S.objId + " 0 R", a += " /P " + l.objId + " 0 R", a += " /T (" + f(_(E)) + ") >>", b.content = a;
            var k = b.objId + " 0 R";
            a = "<</Type /Annot /Subtype /Popup " + (i = "/Rect [" + o(r.bounds.x + 30) + " " + s(r.bounds.y + r.bounds.h) + " " + o(r.bounds.x + r.bounds.w + 30) + " " + s(r.bounds.y) + "] ") + " /Parent " + k, r.open && (a += " /Open true"), a += " >>", S.content = a, this.internal.write(b.objId, "0 R", S.objId, "0 R");
            break;
          case "freetext":
            i = "/Rect [" + o(r.bounds.x) + " " + s(r.bounds.y) + " " + o(r.bounds.x + r.bounds.w) + " " + s(r.bounds.y + r.bounds.h) + "] ";
            var M = r.color || "#000000";
            a = "<</Type /Annot /Subtype /FreeText " + i + "/Contents (" + f(N(r.contents)) + ")", a += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + M + ")", a += " /Border [0 0 0]", a += " >>", this.internal.write(a);
            break;
          case "link":
            if (r.options.name) {
              var F = this.annotations._nameMap[r.options.name];
              r.options.pageNumber = F.page, r.options.top = F.y;
            } else r.options.top || (r.options.top = 0);
            if (i = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", a = "", r.options.url) a = "<</Type /Annot /Subtype /Link " + i + "/Border [0 0 0] /A <</S /URI /URI (" + f(N(r.options.url)) + ") >>";
            else if (r.options.pageNumber)
              switch (a = "<</Type /Annot /Subtype /Link " + i + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor) {
                case "Fit":
                  a += " /Fit]";
                  break;
                case "FitH":
                  a += " /FitH " + r.options.top + "]";
                  break;
                case "FitV":
                  r.options.left = r.options.left || 0, a += " /FitV " + r.options.left + "]";
                  break;
                case "XYZ":
                default:
                  var q = s(r.options.top);
                  r.options.left = r.options.left || 0, r.options.zoom === void 0 && (r.options.zoom = 0), a += " /XYZ " + r.options.left + " " + q + " " + r.options.zoom + "]";
              }
            a != "" && (a += " >>", this.internal.write(a));
        }
      }
      this.internal.write("]");
    }
  }]), e.createAnnotation = function(n) {
    var r = this.internal.getCurrentPageInfo();
    switch (n.type) {
      case "link":
        this.link(n.bounds.x, n.bounds.y, n.bounds.w, n.bounds.h, n);
        break;
      case "text":
      case "freetext":
        r.pageContext.annotations.push(n);
    }
  }, e.link = function(n, r, i, a, o) {
    var s = this.internal.getCurrentPageInfo(), l = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString;
    s.pageContext.annotations.push({ finalBounds: { x: l(n), y: c(r), w: l(n + i), h: c(r + a) }, options: o, type: "link" });
  }, e.textWithLink = function(n, r, i, a) {
    var o, s, l = this.getTextWidth(n), c = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (a.maxWidth !== void 0) {
      s = a.maxWidth;
      var d = this.splitTextToSize(n, s).length;
      o = Math.ceil(c * d);
    } else s = l, o = c;
    return this.text(n, r, i, a), i += 0.2 * c, a.align === "center" && (r -= l / 2), a.align === "right" && (r -= l), this.link(r, i - c, s, o, a), l;
  }, e.getTextWidth = function(n) {
    var r = this.internal.getFontSize();
    return this.getStringUnitWidth(n) * r / this.internal.scaleFactor;
  };
}(xt.API), /**
* @license
* Copyright (c) 2017 Aras Abbasi
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, n = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, r = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, i = [1570, 1571, 1573, 1575];
  e.__arabicParser__ = {};
  var a = e.__arabicParser__.isInArabicSubstitutionA = function(b) {
    return t[b.charCodeAt(0)] !== void 0;
  }, o = e.__arabicParser__.isArabicLetter = function(b) {
    return typeof b == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(b);
  }, s = e.__arabicParser__.isArabicEndLetter = function(b) {
    return o(b) && a(b) && t[b.charCodeAt(0)].length <= 2;
  }, l = e.__arabicParser__.isArabicAlfLetter = function(b) {
    return o(b) && i.indexOf(b.charCodeAt(0)) >= 0;
  };
  e.__arabicParser__.arabicLetterHasIsolatedForm = function(b) {
    return o(b) && a(b) && t[b.charCodeAt(0)].length >= 1;
  };
  var c = e.__arabicParser__.arabicLetterHasFinalForm = function(b) {
    return o(b) && a(b) && t[b.charCodeAt(0)].length >= 2;
  };
  e.__arabicParser__.arabicLetterHasInitialForm = function(b) {
    return o(b) && a(b) && t[b.charCodeAt(0)].length >= 3;
  };
  var d = e.__arabicParser__.arabicLetterHasMedialForm = function(b) {
    return o(b) && a(b) && t[b.charCodeAt(0)].length == 4;
  }, p = e.__arabicParser__.resolveLigatures = function(b) {
    var S = 0, _ = n, E = "", k = 0;
    for (S = 0; S < b.length; S += 1) _[b.charCodeAt(S)] !== void 0 ? (k++, typeof (_ = _[b.charCodeAt(S)]) == "number" && (E += String.fromCharCode(_), _ = n, k = 0), S === b.length - 1 && (_ = n, E += b.charAt(S - (k - 1)), S -= k - 1, k = 0)) : (_ = n, E += b.charAt(S - k), S -= k, k = 0);
    return E;
  };
  e.__arabicParser__.isArabicDiacritic = function(b) {
    return b !== void 0 && r[b.charCodeAt(0)] !== void 0;
  };
  var y = e.__arabicParser__.getCorrectForm = function(b, S, _) {
    return o(b) ? a(b) === !1 ? -1 : !c(b) || !o(S) && !o(_) || !o(_) && s(S) || s(b) && !o(S) || s(b) && l(S) || s(b) && s(S) ? 0 : d(b) && o(S) && !s(S) && o(_) && c(_) ? 3 : s(b) || !o(_) ? 1 : 2 : -1;
  }, f = function(b) {
    var S = 0, _ = 0, E = 0, k = "", M = "", F = "", q = (b = b || "").split("\\s+"), j = [];
    for (S = 0; S < q.length; S += 1) {
      for (j.push(""), _ = 0; _ < q[S].length; _ += 1) k = q[S][_], M = q[S][_ - 1], F = q[S][_ + 1], o(k) ? (E = y(k, M, F), j[S] += E !== -1 ? String.fromCharCode(t[k.charCodeAt(0)][E]) : k) : j[S] += k;
      j[S] = p(j[S]);
    }
    return j.join(" ");
  }, N = e.__arabicParser__.processArabic = e.processArabic = function() {
    var b, S = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, _ = [];
    if (Array.isArray(S)) {
      var E = 0;
      for (_ = [], E = 0; E < S.length; E += 1) Array.isArray(S[E]) ? _.push([f(S[E][0]), S[E][1], S[E][2]]) : _.push([f(S[E])]);
      b = _;
    } else b = f(S);
    return typeof arguments[0] == "string" ? b : (arguments[0].text = b, arguments[0]);
  };
  e.events.push(["preProcessText", N]);
}(xt.API), xt.API.autoPrint = function(e) {
  var t;
  switch ((e = e || {}).variant = e.variant || "non-conform", e.variant) {
    case "javascript":
      this.addJS("print({});");
      break;
    case "non-conform":
    default:
      this.internal.events.subscribe("postPutResources", function() {
        t = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
      }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + t + " 0 R");
      });
  }
  return this;
}, /**
* @license
* Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = function() {
    var n = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return n;
    }, set: function(s) {
      n = s;
    } });
    var r = 150;
    Object.defineProperty(this, "width", { get: function() {
      return r;
    }, set: function(s) {
      r = isNaN(s) || Number.isInteger(s) === !1 || s < 0 ? 150 : s, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = r + 1);
    } });
    var i = 300;
    Object.defineProperty(this, "height", { get: function() {
      return i;
    }, set: function(s) {
      i = isNaN(s) || Number.isInteger(s) === !1 || s < 0 ? 300 : s, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = i + 1);
    } });
    var a = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return a;
    }, set: function(s) {
      a = s;
    } });
    var o = {};
    Object.defineProperty(this, "style", { get: function() {
      return o;
    }, set: function(s) {
      o = s;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  t.prototype.getContext = function(n, r) {
    var i;
    if ((n = n || "2d") !== "2d") return null;
    for (i in r) this.pdf.context2d.hasOwnProperty(i) && (this.pdf.context2d[i] = r[i]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, t.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, e.events.push(["initialized", function() {
    this.canvas = new t(), this.canvas.pdf = this;
  }]);
}(xt.API), function(e) {
  var t = { left: 0, top: 0, bottom: 0, right: 0 }, n = !1, r = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, t), this.internal.__cell__.margins.width = this.getPageWidth(), i.call(this));
  }, i = function() {
    this.internal.__cell__.lastCell = new a(), this.internal.__cell__.pages = 1;
  }, a = function() {
    var l = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return l;
    }, set: function(b) {
      l = b;
    } });
    var c = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return c;
    }, set: function(b) {
      c = b;
    } });
    var d = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return d;
    }, set: function(b) {
      d = b;
    } });
    var p = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return p;
    }, set: function(b) {
      p = b;
    } });
    var y = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return y;
    }, set: function(b) {
      y = b;
    } });
    var f = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return f;
    }, set: function(b) {
      f = b;
    } });
    var N = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return N;
    }, set: function(b) {
      N = b;
    } }), this;
  };
  a.prototype.clone = function() {
    return new a(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, a.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, e.setHeaderFunction = function(l) {
    return r.call(this), this.internal.__cell__.headerFunction = typeof l == "function" ? l : void 0, this;
  }, e.getTextDimensions = function(l, c) {
    r.call(this);
    var d = (c = c || {}).fontSize || this.getFontSize(), p = c.font || this.getFont(), y = c.scaleFactor || this.internal.scaleFactor, f = 0, N = 0, b = 0, S = this;
    if (!Array.isArray(l) && typeof l != "string") {
      if (typeof l != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      l = String(l);
    }
    var _ = c.maxWidth;
    _ > 0 ? typeof l == "string" ? l = this.splitTextToSize(l, _) : Object.prototype.toString.call(l) === "[object Array]" && (l = l.reduce(function(k, M) {
      return k.concat(S.splitTextToSize(M, _));
    }, [])) : l = Array.isArray(l) ? l : [l];
    for (var E = 0; E < l.length; E++) f < (b = this.getStringUnitWidth(l[E], { font: p }) * d) && (f = b);
    return f !== 0 && (N = l.length), { w: f /= y, h: Math.max((N * d * this.getLineHeightFactor() - d * (this.getLineHeightFactor() - 1)) / y, 0) };
  }, e.cellAddPage = function() {
    r.call(this), this.addPage();
    var l = this.internal.__cell__.margins || t;
    return this.internal.__cell__.lastCell = new a(l.left, l.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var o = e.cell = function() {
    var l;
    l = arguments[0] instanceof a ? arguments[0] : new a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), r.call(this);
    var c = this.internal.__cell__.lastCell, d = this.internal.__cell__.padding, p = this.internal.__cell__.margins || t, y = this.internal.__cell__.tableHeaderRow, f = this.internal.__cell__.printHeaders;
    return c.lineNumber !== void 0 && (c.lineNumber === l.lineNumber ? (l.x = (c.x || 0) + (c.width || 0), l.y = c.y || 0) : c.y + c.height + l.height + p.bottom > this.getPageHeight() ? (this.cellAddPage(), l.y = p.top, f && y && (this.printHeaderRow(l.lineNumber, !0), l.y += y[0].height)) : l.y = c.y + c.height || l.y), l.text[0] !== void 0 && (this.rect(l.x, l.y, l.width, l.height, n === !0 ? "FD" : void 0), l.align === "right" ? this.text(l.text, l.x + l.width - d, l.y + d, { align: "right", baseline: "top" }) : l.align === "center" ? this.text(l.text, l.x + l.width / 2, l.y + d, { align: "center", baseline: "top", maxWidth: l.width - d - d }) : this.text(l.text, l.x + d, l.y + d, { align: "left", baseline: "top", maxWidth: l.width - d - d })), this.internal.__cell__.lastCell = l, this;
  };
  e.table = function(l, c, d, p, y) {
    if (r.call(this), !d) throw new Error("No data for PDF table.");
    var f, N, b, S, _ = [], E = [], k = [], M = {}, F = {}, q = [], j = [], x = (y = y || {}).autoSize || !1, C = y.printHeaders !== !1, D = y.css && y.css["font-size"] !== void 0 ? 16 * y.css["font-size"] : y.fontSize || 12, P = y.margins || Object.assign({ width: this.getPageWidth() }, t), L = typeof y.padding == "number" ? y.padding : 3, H = y.headerBackgroundColor || "#c8c8c8", $ = y.headerTextColor || "#000";
    if (i.call(this), this.internal.__cell__.printHeaders = C, this.internal.__cell__.margins = P, this.internal.__cell__.table_font_size = D, this.internal.__cell__.padding = L, this.internal.__cell__.headerBackgroundColor = H, this.internal.__cell__.headerTextColor = $, this.setFontSize(D), p == null) E = _ = Object.keys(d[0]), k = _.map(function() {
      return "left";
    });
    else if (Array.isArray(p) && Yt(p[0]) === "object") for (_ = p.map(function(J) {
      return J.name;
    }), E = p.map(function(J) {
      return J.prompt || J.name || "";
    }), k = p.map(function(J) {
      return J.align || "left";
    }), f = 0; f < p.length; f += 1) F[p[f].name] = p[f].width * (19.049976 / 25.4);
    else Array.isArray(p) && typeof p[0] == "string" && (E = _ = p, k = _.map(function() {
      return "left";
    }));
    if (x || Array.isArray(p) && typeof p[0] == "string") for (f = 0; f < _.length; f += 1) {
      for (M[S = _[f]] = d.map(function(J) {
        return J[S];
      }), this.setFont(void 0, "bold"), q.push(this.getTextDimensions(E[f], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), N = M[S], this.setFont(void 0, "normal"), b = 0; b < N.length; b += 1) q.push(this.getTextDimensions(N[b], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      F[S] = Math.max.apply(null, q) + L + L, q = [];
    }
    if (C) {
      var ae = {};
      for (f = 0; f < _.length; f += 1) ae[_[f]] = {}, ae[_[f]].text = E[f], ae[_[f]].align = k[f];
      var ce = s.call(this, ae, F);
      j = _.map(function(J) {
        return new a(l, c, F[J], ce, ae[J].text, void 0, ae[J].align);
      }), this.setTableHeaderRow(j), this.printHeaderRow(1, !1);
    }
    var le = p.reduce(function(J, re) {
      return J[re.name] = re.align, J;
    }, {});
    for (f = 0; f < d.length; f += 1) {
      "rowStart" in y && y.rowStart instanceof Function && y.rowStart({ row: f, data: d[f] }, this);
      var oe = s.call(this, d[f], F);
      for (b = 0; b < _.length; b += 1) {
        var se = d[f][_[b]];
        "cellStart" in y && y.cellStart instanceof Function && y.cellStart({ row: f, col: b, data: se }, this), o.call(this, new a(l, c, F[_[b]], oe, se, f + 2, le[_[b]]));
      }
    }
    return this.internal.__cell__.table_x = l, this.internal.__cell__.table_y = c, this;
  };
  var s = function(l, c) {
    var d = this.internal.__cell__.padding, p = this.internal.__cell__.table_font_size, y = this.internal.scaleFactor;
    return Object.keys(l).map(function(f) {
      var N = l[f];
      return this.splitTextToSize(N.hasOwnProperty("text") ? N.text : N, c[f] - d - d);
    }, this).map(function(f) {
      return this.getLineHeightFactor() * f.length * p / y + d + d;
    }, this).reduce(function(f, N) {
      return Math.max(f, N);
    }, 0);
  };
  e.setTableHeaderRow = function(l) {
    r.call(this), this.internal.__cell__.tableHeaderRow = l;
  }, e.printHeaderRow = function(l, c) {
    if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var d;
    if (n = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var p = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new a(p[0], p[1], p[2], p[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var y = [], f = 0; f < this.internal.__cell__.tableHeaderRow.length; f += 1) {
      d = this.internal.__cell__.tableHeaderRow[f].clone(), c && (d.y = this.internal.__cell__.margins.top || 0, y.push(d)), d.lineNumber = l;
      var N = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), o.call(this, d), this.setTextColor(N);
    }
    y.length > 0 && this.setTableHeaderRow(y), this.setFont(void 0, "normal"), n = !1;
  };
}(xt.API);
var Z3 = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, J3 = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], Am = X3(J3), A3 = [100, 200, 300, 400, 500, 600, 700, 800, 900], WB = X3(A3);
function eg(e) {
  var t = e.family.replace(/"|'/g, "").toLowerCase(), n = function(a) {
    return Z3[a = a || "normal"] ? a : "normal";
  }(e.style), r = function(a) {
    if (!a) return 400;
    if (typeof a == "number") return a >= 100 && a <= 900 && a % 100 == 0 ? a : 400;
    if (/^\d00$/.test(a)) return parseInt(a);
    switch (a) {
      case "bold":
        return 700;
      case "normal":
      default:
        return 400;
    }
  }(e.weight), i = function(a) {
    return typeof Am[a = a || "normal"] == "number" ? a : "normal";
  }(e.stretch);
  return { family: t, style: n, weight: r, stretch: i, src: e.src || [], ref: e.ref || { name: t, style: [i, n, r].join(" ") } };
}
function Zy(e, t, n, r) {
  var i;
  for (i = n; i >= 0 && i < t.length; i += r) if (e[t[i]]) return e[t[i]];
  for (i = n; i >= 0 && i < t.length; i -= r) if (e[t[i]]) return e[t[i]];
}
var HB = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, Jy = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function Ay(e) {
  return [e.stretch, e.style, e.weight, e.family].join(" ");
}
function $B(e, t, n) {
  for (var r = (n = n || {}).defaultFontFamily || "times", i = Object.assign({}, HB, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < t.length; ++s) if (i[(a = eg(t[s])).family] && (a.family = i[a.family]), e.hasOwnProperty(a.family)) {
    o = e[a.family];
    break;
  }
  if (!(o = o || e[r])) throw new Error("Could not find a font-family for the rule '" + Ay(a) + "' and default family '" + r + "'.");
  if (o = function(l, c) {
    if (c[l]) return c[l];
    var d = Am[l], p = d <= Am.normal ? -1 : 1, y = Zy(c, J3, d, p);
    if (!y) throw new Error("Could not find a matching font-stretch value for " + l);
    return y;
  }(a.stretch, o), o = function(l, c) {
    if (c[l]) return c[l];
    for (var d = Z3[l], p = 0; p < d.length; ++p) if (c[d[p]]) return c[d[p]];
    throw new Error("Could not find a matching font-style for " + l);
  }(a.style, o), !(o = function(l, c) {
    if (c[l]) return c[l];
    if (l === 400 && c[500]) return c[500];
    if (l === 500 && c[400]) return c[400];
    var d = WB[l], p = Zy(c, A3, d, l < 400 ? -1 : 1);
    if (!p) throw new Error("Could not find a matching font-weight for value " + l);
    return p;
  }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + Ay(a) + "'.");
  return o;
}
function e0(e) {
  return e.trimLeft();
}
function GB(e, t) {
  for (var n = 0; n < e.length; ) {
    if (e.charAt(n) === t) return [e.substring(0, n), e.substring(n + 1)];
    n += 1;
  }
  return null;
}
function QB(e) {
  var t = e.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return t === null ? null : [t[0], e.substring(t[0].length)];
}
var Xd, t0, n0, r0 = ["times"];
(function(e) {
  var t, n, r, i, a, o, s, l, c, d = function(I) {
    return I = I || {}, this.isStrokeTransparent = I.isStrokeTransparent || !1, this.strokeOpacity = I.strokeOpacity || 1, this.strokeStyle = I.strokeStyle || "#000000", this.fillStyle = I.fillStyle || "#000000", this.isFillTransparent = I.isFillTransparent || !1, this.fillOpacity = I.fillOpacity || 1, this.font = I.font || "10px sans-serif", this.textBaseline = I.textBaseline || "alphabetic", this.textAlign = I.textAlign || "left", this.lineWidth = I.lineWidth || 1, this.lineJoin = I.lineJoin || "miter", this.lineCap = I.lineCap || "butt", this.path = I.path || [], this.transform = I.transform !== void 0 ? I.transform.clone() : new l(), this.globalCompositeOperation = I.globalCompositeOperation || "normal", this.globalAlpha = I.globalAlpha || 1, this.clip_path = I.clip_path || [], this.currentPoint = I.currentPoint || new o(), this.miterLimit = I.miterLimit || 10, this.lastPoint = I.lastPoint || new o(), this.lineDashOffset = I.lineDashOffset || 0, this.lineDash = I.lineDash || [], this.margin = I.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = I.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof I.ignoreClearRect != "boolean" || I.ignoreClearRect, this;
  };
  e.events.push(["initialized", function() {
    this.context2d = new p(this), t = this.internal.f2, n = this.internal.getCoordinateString, r = this.internal.getVerticalCoordinateString, i = this.internal.getHorizontalCoordinate, a = this.internal.getVerticalCoordinate, o = this.internal.Point, s = this.internal.Rectangle, l = this.internal.Matrix, c = new d();
  }]);
  var p = function(I) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var U = I;
    Object.defineProperty(this, "pdf", { get: function() {
      return U;
    } });
    var G = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return G;
    }, set: function(be) {
      G = !!be;
    } });
    var K = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return K;
    }, set: function(be) {
      K = !!be;
    } });
    var A = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return A;
    }, set: function(be) {
      isNaN(be) || (A = be);
    } });
    var ee = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return ee;
    }, set: function(be) {
      isNaN(be) || (ee = be);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return c.margin;
    }, set: function(be) {
      var X;
      typeof be == "number" ? X = [be, be, be, be] : ((X = new Array(4))[0] = be[0], X[1] = be.length >= 2 ? be[1] : X[0], X[2] = be.length >= 3 ? be[2] : X[0], X[3] = be.length >= 4 ? be[3] : X[1]), c.margin = X;
    } });
    var te = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return te;
    }, set: function(be) {
      te = be;
    } });
    var ne = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return ne;
    }, set: function(be) {
      ne = be;
    } });
    var ve = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return ve;
    }, set: function(be) {
      ve = be;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return c;
    }, set: function(be) {
      be instanceof d && (c = be);
    } }), Object.defineProperty(this, "path", { get: function() {
      return c.path;
    }, set: function(be) {
      c.path = be;
    } });
    var _e = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return _e;
    }, set: function(be) {
      _e = be;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(be) {
      var X;
      X = y(be), this.ctx.fillStyle = X.style, this.ctx.isFillTransparent = X.a === 0, this.ctx.fillOpacity = X.a, this.pdf.setFillColor(X.r, X.g, X.b, { a: X.a }), this.pdf.setTextColor(X.r, X.g, X.b, { a: X.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(be) {
      var X = y(be);
      this.ctx.strokeStyle = X.style, this.ctx.isStrokeTransparent = X.a === 0, this.ctx.strokeOpacity = X.a, X.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (X.a, this.pdf.setDrawColor(X.r, X.g, X.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(be) {
      ["butt", "round", "square"].indexOf(be) !== -1 && (this.ctx.lineCap = be, this.pdf.setLineCap(be));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(be) {
      isNaN(be) || (this.ctx.lineWidth = be, this.pdf.setLineWidth(be));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(be) {
      ["bevel", "round", "miter"].indexOf(be) !== -1 && (this.ctx.lineJoin = be, this.pdf.setLineJoin(be));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(be) {
      isNaN(be) || (this.ctx.miterLimit = be, this.pdf.setMiterLimit(be));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(be) {
      this.ctx.textBaseline = be;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(be) {
      ["right", "end", "center", "left", "start"].indexOf(be) !== -1 && (this.ctx.textAlign = be);
    } });
    var pe = null;
    function je(be, X) {
      if (pe === null) {
        var Ye = function(Re) {
          var Te = [];
          return Object.keys(Re).forEach(function(Ue) {
            Re[Ue].forEach(function(T) {
              var fe = null;
              switch (T) {
                case "bold":
                  fe = { family: Ue, weight: "bold" };
                  break;
                case "italic":
                  fe = { family: Ue, style: "italic" };
                  break;
                case "bolditalic":
                  fe = { family: Ue, weight: "bold", style: "italic" };
                  break;
                case "":
                case "normal":
                  fe = { family: Ue };
              }
              fe !== null && (fe.ref = { name: Ue, style: T }, Te.push(fe));
            });
          }), Te;
        }(be.getFontList());
        pe = function(Re) {
          for (var Te = {}, Ue = 0; Ue < Re.length; ++Ue) {
            var T = eg(Re[Ue]), fe = T.family, xe = T.stretch, Fe = T.style, Ge = T.weight;
            Te[fe] = Te[fe] || {}, Te[fe][xe] = Te[fe][xe] || {}, Te[fe][xe][Fe] = Te[fe][xe][Fe] || {}, Te[fe][xe][Fe][Ge] = T;
          }
          return Te;
        }(Ye.concat(X));
      }
      return pe;
    }
    var Se = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return Se;
    }, set: function(be) {
      pe = null, Se = be;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(be) {
      var X;
      if (this.ctx.font = be, (X = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(be)) !== null) {
        var Ye = X[1], Re = (X[2], X[3]), Te = X[4], Ue = (X[5], X[6]), T = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(Te)[2];
        Te = Math.floor(T === "px" ? parseFloat(Te) * this.pdf.internal.scaleFactor : T === "em" ? parseFloat(Te) * this.pdf.getFontSize() : parseFloat(Te) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(Te);
        var fe = function(at) {
          var Je, $e, _t = [], dt = at.trim();
          if (dt === "") return r0;
          if (dt in Jy) return [Jy[dt]];
          for (; dt !== ""; ) {
            switch ($e = null, Je = (dt = e0(dt)).charAt(0)) {
              case '"':
              case "'":
                $e = GB(dt.substring(1), Je);
                break;
              default:
                $e = QB(dt);
            }
            if ($e === null || (_t.push($e[0]), (dt = e0($e[1])) !== "" && dt.charAt(0) !== ",")) return r0;
            dt = dt.replace(/^,/, "");
          }
          return _t;
        }(Ue);
        if (this.fontFaces) {
          var xe = $B(je(this.pdf, this.fontFaces), fe.map(function(at) {
            return { family: at, stretch: "normal", weight: Re, style: Ye };
          }));
          this.pdf.setFont(xe.ref.name, xe.ref.style);
        } else {
          var Fe = "";
          (Re === "bold" || parseInt(Re, 10) >= 700 || Ye === "bold") && (Fe = "bold"), Ye === "italic" && (Fe += "italic"), Fe.length === 0 && (Fe = "normal");
          for (var Ge = "", Me = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, Ie = 0; Ie < fe.length; Ie++) {
            if (this.pdf.internal.getFont(fe[Ie], Fe, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ge = fe[Ie];
              break;
            }
            if (Fe === "bolditalic" && this.pdf.internal.getFont(fe[Ie], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) Ge = fe[Ie], Fe = "bold";
            else if (this.pdf.internal.getFont(fe[Ie], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              Ge = fe[Ie], Fe = "normal";
              break;
            }
          }
          if (Ge === "") {
            for (var ct = 0; ct < fe.length; ct++) if (Me[fe[ct]]) {
              Ge = Me[fe[ct]];
              break;
            }
          }
          Ge = Ge === "" ? "Times" : Ge, this.pdf.setFont(Ge, Fe);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(be) {
      this.ctx.globalCompositeOperation = be;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(be) {
      this.ctx.globalAlpha = be;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(be) {
      this.ctx.lineDashOffset = be, re.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(be) {
      this.ctx.lineDash = be, re.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(be) {
      this.ctx.ignoreClearRect = !!be;
    } });
  };
  p.prototype.setLineDash = function(I) {
    this.lineDash = I;
  }, p.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, p.prototype.fill = function() {
    M.call(this, "fill", !1);
  }, p.prototype.stroke = function() {
    M.call(this, "stroke", !1);
  }, p.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, p.prototype.moveTo = function(I, U) {
    if (isNaN(I) || isNaN(U)) throw hn.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var G = this.ctx.transform.applyToPoint(new o(I, U));
    this.path.push({ type: "mt", x: G.x, y: G.y }), this.ctx.lastPoint = new o(I, U);
  }, p.prototype.closePath = function() {
    var I = new o(0, 0), U = 0;
    for (U = this.path.length - 1; U !== -1; U--) if (this.path[U].type === "begin" && Yt(this.path[U + 1]) === "object" && typeof this.path[U + 1].x == "number") {
      I = new o(this.path[U + 1].x, this.path[U + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new o(I.x, I.y);
  }, p.prototype.lineTo = function(I, U) {
    if (isNaN(I) || isNaN(U)) throw hn.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var G = this.ctx.transform.applyToPoint(new o(I, U));
    this.path.push({ type: "lt", x: G.x, y: G.y }), this.ctx.lastPoint = new o(G.x, G.y);
  }, p.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), M.call(this, null, !0);
  }, p.prototype.quadraticCurveTo = function(I, U, G, K) {
    if (isNaN(G) || isNaN(K) || isNaN(I) || isNaN(U)) throw hn.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var A = this.ctx.transform.applyToPoint(new o(G, K)), ee = this.ctx.transform.applyToPoint(new o(I, U));
    this.path.push({ type: "qct", x1: ee.x, y1: ee.y, x: A.x, y: A.y }), this.ctx.lastPoint = new o(A.x, A.y);
  }, p.prototype.bezierCurveTo = function(I, U, G, K, A, ee) {
    if (isNaN(A) || isNaN(ee) || isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K)) throw hn.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var te = this.ctx.transform.applyToPoint(new o(A, ee)), ne = this.ctx.transform.applyToPoint(new o(I, U)), ve = this.ctx.transform.applyToPoint(new o(G, K));
    this.path.push({ type: "bct", x1: ne.x, y1: ne.y, x2: ve.x, y2: ve.y, x: te.x, y: te.y }), this.ctx.lastPoint = new o(te.x, te.y);
  }, p.prototype.arc = function(I, U, G, K, A, ee) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K) || isNaN(A)) throw hn.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (ee = !!ee, !this.ctx.transform.isIdentity) {
      var te = this.ctx.transform.applyToPoint(new o(I, U));
      I = te.x, U = te.y;
      var ne = this.ctx.transform.applyToPoint(new o(0, G)), ve = this.ctx.transform.applyToPoint(new o(0, 0));
      G = Math.sqrt(Math.pow(ne.x - ve.x, 2) + Math.pow(ne.y - ve.y, 2));
    }
    Math.abs(A - K) >= 2 * Math.PI && (K = 0, A = 2 * Math.PI), this.path.push({ type: "arc", x: I, y: U, radius: G, startAngle: K, endAngle: A, counterclockwise: ee });
  }, p.prototype.arcTo = function(I, U, G, K, A) {
    throw new Error("arcTo not implemented.");
  }, p.prototype.rect = function(I, U, G, K) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K)) throw hn.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(I, U), this.lineTo(I + G, U), this.lineTo(I + G, U + K), this.lineTo(I, U + K), this.lineTo(I, U), this.lineTo(I + G, U), this.lineTo(I, U);
  }, p.prototype.fillRect = function(I, U, G, K) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K)) throw hn.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!f.call(this)) {
      var A = {};
      this.lineCap !== "butt" && (A.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (A.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(I, U, G, K), this.fill(), A.hasOwnProperty("lineCap") && (this.lineCap = A.lineCap), A.hasOwnProperty("lineJoin") && (this.lineJoin = A.lineJoin);
    }
  }, p.prototype.strokeRect = function(I, U, G, K) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K)) throw hn.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    N.call(this) || (this.beginPath(), this.rect(I, U, G, K), this.stroke());
  }, p.prototype.clearRect = function(I, U, G, K) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K)) throw hn.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(I, U, G, K));
  }, p.prototype.save = function(I) {
    I = typeof I != "boolean" || I;
    for (var U = this.pdf.internal.getCurrentPageInfo().pageNumber, G = 0; G < this.pdf.internal.getNumberOfPages(); G++) this.pdf.setPage(G + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(U), I) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var K = new d(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = K;
    }
  }, p.prototype.restore = function(I) {
    I = typeof I != "boolean" || I;
    for (var U = this.pdf.internal.getCurrentPageInfo().pageNumber, G = 0; G < this.pdf.internal.getNumberOfPages(); G++) this.pdf.setPage(G + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(U), I && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, p.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var y = function(I) {
    var U, G, K, A;
    if (I.isCanvasGradient === !0 && (I = I.getColor()), !I) return { r: 0, g: 0, b: 0, a: 0, style: I };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(I)) U = 0, G = 0, K = 0, A = 0;
    else {
      var ee = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(I);
      if (ee !== null) U = parseInt(ee[1]), G = parseInt(ee[2]), K = parseInt(ee[3]), A = 1;
      else if ((ee = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(I)) !== null) U = parseInt(ee[1]), G = parseInt(ee[2]), K = parseInt(ee[3]), A = parseFloat(ee[4]);
      else {
        if (A = 1, typeof I == "string" && I.charAt(0) !== "#") {
          var te = new H3(I);
          I = te.ok ? te.toHex() : "#000000";
        }
        I.length === 4 ? (U = I.substring(1, 2), U += U, G = I.substring(2, 3), G += G, K = I.substring(3, 4), K += K) : (U = I.substring(1, 3), G = I.substring(3, 5), K = I.substring(5, 7)), U = parseInt(U, 16), G = parseInt(G, 16), K = parseInt(K, 16);
      }
    }
    return { r: U, g: G, b: K, a: A, style: I };
  }, f = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, N = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  p.prototype.fillText = function(I, U, G, K) {
    if (isNaN(U) || isNaN(G) || typeof I != "string") throw hn.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (K = isNaN(K) ? void 0 : K, !f.call(this)) {
      var A = oe(this.ctx.transform.rotation), ee = this.ctx.transform.scaleX;
      L.call(this, { text: I, x: U, y: G, scale: ee, angle: A, align: this.textAlign, maxWidth: K });
    }
  }, p.prototype.strokeText = function(I, U, G, K) {
    if (isNaN(U) || isNaN(G) || typeof I != "string") throw hn.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!N.call(this)) {
      K = isNaN(K) ? void 0 : K;
      var A = oe(this.ctx.transform.rotation), ee = this.ctx.transform.scaleX;
      L.call(this, { text: I, x: U, y: G, scale: ee, renderingMode: "stroke", angle: A, align: this.textAlign, maxWidth: K });
    }
  }, p.prototype.measureText = function(I) {
    if (typeof I != "string") throw hn.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var U = this.pdf, G = this.pdf.internal.scaleFactor, K = U.internal.getFontSize(), A = U.getStringUnitWidth(I) * K / U.internal.scaleFactor, ee = function(te) {
      var ne = (te = te || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return ne;
      } }), this;
    };
    return new ee({ width: A *= Math.round(96 * G / 72 * 1e4) / 1e4 });
  }, p.prototype.scale = function(I, U) {
    if (isNaN(I) || isNaN(U)) throw hn.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var G = new l(I, 0, 0, U, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(G);
  }, p.prototype.rotate = function(I) {
    if (isNaN(I)) throw hn.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var U = new l(Math.cos(I), Math.sin(I), -Math.sin(I), Math.cos(I), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(U);
  }, p.prototype.translate = function(I, U) {
    if (isNaN(I) || isNaN(U)) throw hn.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var G = new l(1, 0, 0, 1, I, U);
    this.ctx.transform = this.ctx.transform.multiply(G);
  }, p.prototype.transform = function(I, U, G, K, A, ee) {
    if (isNaN(I) || isNaN(U) || isNaN(G) || isNaN(K) || isNaN(A) || isNaN(ee)) throw hn.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var te = new l(I, U, G, K, A, ee);
    this.ctx.transform = this.ctx.transform.multiply(te);
  }, p.prototype.setTransform = function(I, U, G, K, A, ee) {
    I = isNaN(I) ? 1 : I, U = isNaN(U) ? 0 : U, G = isNaN(G) ? 0 : G, K = isNaN(K) ? 1 : K, A = isNaN(A) ? 0 : A, ee = isNaN(ee) ? 0 : ee, this.ctx.transform = new l(I, U, G, K, A, ee);
  };
  var b = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  p.prototype.drawImage = function(I, U, G, K, A, ee, te, ne, ve) {
    var _e = this.pdf.getImageProperties(I), pe = 1, je = 1, Se = 1, be = 1;
    K !== void 0 && ne !== void 0 && (Se = ne / K, be = ve / A, pe = _e.width / K * ne / K, je = _e.height / A * ve / A), ee === void 0 && (ee = U, te = G, U = 0, G = 0), K !== void 0 && ne === void 0 && (ne = K, ve = A), K === void 0 && ne === void 0 && (ne = _e.width, ve = _e.height);
    for (var X, Ye = this.ctx.transform.decompose(), Re = oe(Ye.rotate.shx), Te = new l(), Ue = (Te = (Te = (Te = Te.multiply(Ye.translate)).multiply(Ye.skew)).multiply(Ye.scale)).applyToRectangle(new s(ee - U * Se, te - G * be, K * pe, A * je)), T = S.call(this, Ue), fe = [], xe = 0; xe < T.length; xe += 1) fe.indexOf(T[xe]) === -1 && fe.push(T[xe]);
    if (k(fe), this.autoPaging) for (var Fe = fe[0], Ge = fe[fe.length - 1], Me = Fe; Me < Ge + 1; Me++) {
      this.pdf.setPage(Me);
      var Ie = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], ct = Me === 1 ? this.posY + this.margin[0] : this.margin[0], at = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Je = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], $e = Me === 1 ? 0 : at + (Me - 2) * Je;
      if (this.ctx.clip_path.length !== 0) {
        var _t = this.path;
        X = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = E(X, this.posX + this.margin[3], -$e + ct + this.ctx.prevPageLastElemOffset), F.call(this, "fill", !0), this.path = _t;
      }
      var dt = JSON.parse(JSON.stringify(Ue));
      dt = E([dt], this.posX + this.margin[3], -$e + ct + this.ctx.prevPageLastElemOffset)[0];
      var Ut = (Me > Fe || Me < Ge) && b.call(this);
      Ut && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Ie, Je, null).clip().discardPath()), this.pdf.addImage(I, "JPEG", dt.x, dt.y, dt.w, dt.h, null, null, Re), Ut && this.pdf.restoreGraphicsState();
    }
    else this.pdf.addImage(I, "JPEG", Ue.x, Ue.y, Ue.w, Ue.h, null, null, Re);
  };
  var S = function(I, U, G) {
    var K = [];
    U = U || this.pdf.internal.pageSize.width, G = G || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var A = this.posY + this.ctx.prevPageLastElemOffset;
    switch (I.type) {
      default:
      case "mt":
      case "lt":
        K.push(Math.floor((I.y + A) / G) + 1);
        break;
      case "arc":
        K.push(Math.floor((I.y + A - I.radius) / G) + 1), K.push(Math.floor((I.y + A + I.radius) / G) + 1);
        break;
      case "qct":
        var ee = se(this.ctx.lastPoint.x, this.ctx.lastPoint.y, I.x1, I.y1, I.x, I.y);
        K.push(Math.floor((ee.y + A) / G) + 1), K.push(Math.floor((ee.y + ee.h + A) / G) + 1);
        break;
      case "bct":
        var te = J(this.ctx.lastPoint.x, this.ctx.lastPoint.y, I.x1, I.y1, I.x2, I.y2, I.x, I.y);
        K.push(Math.floor((te.y + A) / G) + 1), K.push(Math.floor((te.y + te.h + A) / G) + 1);
        break;
      case "rect":
        K.push(Math.floor((I.y + A) / G) + 1), K.push(Math.floor((I.y + I.h + A) / G) + 1);
    }
    for (var ne = 0; ne < K.length; ne += 1) for (; this.pdf.internal.getNumberOfPages() < K[ne]; ) _.call(this);
    return K;
  }, _ = function() {
    var I = this.fillStyle, U = this.strokeStyle, G = this.font, K = this.lineCap, A = this.lineWidth, ee = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = I, this.strokeStyle = U, this.font = G, this.lineCap = K, this.lineWidth = A, this.lineJoin = ee;
  }, E = function(I, U, G) {
    for (var K = 0; K < I.length; K++) switch (I[K].type) {
      case "bct":
        I[K].x2 += U, I[K].y2 += G;
      case "qct":
        I[K].x1 += U, I[K].y1 += G;
      case "mt":
      case "lt":
      case "arc":
      default:
        I[K].x += U, I[K].y += G;
    }
    return I;
  }, k = function(I) {
    return I.sort(function(U, G) {
      return U - G;
    });
  }, M = function(I, U) {
    for (var G, K, A = this.fillStyle, ee = this.strokeStyle, te = this.lineCap, ne = this.lineWidth, ve = Math.abs(ne * this.ctx.transform.scaleX), _e = this.lineJoin, pe = JSON.parse(JSON.stringify(this.path)), je = JSON.parse(JSON.stringify(this.path)), Se = [], be = 0; be < je.length; be++) if (je[be].x !== void 0) for (var X = S.call(this, je[be]), Ye = 0; Ye < X.length; Ye += 1) Se.indexOf(X[Ye]) === -1 && Se.push(X[Ye]);
    for (var Re = 0; Re < Se.length; Re++) for (; this.pdf.internal.getNumberOfPages() < Se[Re]; ) _.call(this);
    if (k(Se), this.autoPaging) for (var Te = Se[0], Ue = Se[Se.length - 1], T = Te; T < Ue + 1; T++) {
      this.pdf.setPage(T), this.fillStyle = A, this.strokeStyle = ee, this.lineCap = te, this.lineWidth = ve, this.lineJoin = _e;
      var fe = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], xe = T === 1 ? this.posY + this.margin[0] : this.margin[0], Fe = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Ge = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], Me = T === 1 ? 0 : Fe + (T - 2) * Ge;
      if (this.ctx.clip_path.length !== 0) {
        var Ie = this.path;
        G = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = E(G, this.posX + this.margin[3], -Me + xe + this.ctx.prevPageLastElemOffset), F.call(this, I, !0), this.path = Ie;
      }
      if (K = JSON.parse(JSON.stringify(pe)), this.path = E(K, this.posX + this.margin[3], -Me + xe + this.ctx.prevPageLastElemOffset), U === !1 || T === 0) {
        var ct = (T > Te || T < Ue) && b.call(this);
        ct && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], fe, Ge, null).clip().discardPath()), F.call(this, I, U), ct && this.pdf.restoreGraphicsState();
      }
      this.lineWidth = ne;
    }
    else this.lineWidth = ve, F.call(this, I, U), this.lineWidth = ne;
    this.path = pe;
  }, F = function(I, U) {
    if ((I !== "stroke" || U || !N.call(this)) && (I === "stroke" || U || !f.call(this))) {
      for (var G, K, A = [], ee = this.path, te = 0; te < ee.length; te++) {
        var ne = ee[te];
        switch (ne.type) {
          case "begin":
            A.push({ begin: !0 });
            break;
          case "close":
            A.push({ close: !0 });
            break;
          case "mt":
            A.push({ start: ne, deltas: [], abs: [] });
            break;
          case "lt":
            var ve = A.length;
            if (ee[te - 1] && !isNaN(ee[te - 1].x) && (G = [ne.x - ee[te - 1].x, ne.y - ee[te - 1].y], ve > 0)) {
              for (; ve >= 0; ve--) if (A[ve - 1].close !== !0 && A[ve - 1].begin !== !0) {
                A[ve - 1].deltas.push(G), A[ve - 1].abs.push(ne);
                break;
              }
            }
            break;
          case "bct":
            G = [ne.x1 - ee[te - 1].x, ne.y1 - ee[te - 1].y, ne.x2 - ee[te - 1].x, ne.y2 - ee[te - 1].y, ne.x - ee[te - 1].x, ne.y - ee[te - 1].y], A[A.length - 1].deltas.push(G);
            break;
          case "qct":
            var _e = ee[te - 1].x + 2 / 3 * (ne.x1 - ee[te - 1].x), pe = ee[te - 1].y + 2 / 3 * (ne.y1 - ee[te - 1].y), je = ne.x + 2 / 3 * (ne.x1 - ne.x), Se = ne.y + 2 / 3 * (ne.y1 - ne.y), be = ne.x, X = ne.y;
            G = [_e - ee[te - 1].x, pe - ee[te - 1].y, je - ee[te - 1].x, Se - ee[te - 1].y, be - ee[te - 1].x, X - ee[te - 1].y], A[A.length - 1].deltas.push(G);
            break;
          case "arc":
            A.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(A[A.length - 1].abs) && A[A.length - 1].abs.push(ne);
        }
      }
      K = U ? null : I === "stroke" ? "stroke" : "fill";
      for (var Ye = !1, Re = 0; Re < A.length; Re++) if (A[Re].arc) for (var Te = A[Re].abs, Ue = 0; Ue < Te.length; Ue++) {
        var T = Te[Ue];
        T.type === "arc" ? x.call(this, T.x, T.y, T.radius, T.startAngle, T.endAngle, T.counterclockwise, void 0, U, !Ye) : H.call(this, T.x, T.y), Ye = !0;
      }
      else if (A[Re].close === !0) this.pdf.internal.out("h"), Ye = !1;
      else if (A[Re].begin !== !0) {
        var fe = A[Re].start.x, xe = A[Re].start.y;
        $.call(this, A[Re].deltas, fe, xe), Ye = !0;
      }
      K && C.call(this, K), U && D.call(this);
    }
  }, q = function(I) {
    var U = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, G = U * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return I - G;
      case "top":
        return I + U - G;
      case "hanging":
        return I + U - 2 * G;
      case "middle":
        return I + U / 2 - G;
      case "ideographic":
        return I;
      case "alphabetic":
      default:
        return I;
    }
  }, j = function(I) {
    return I + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  p.prototype.createLinearGradient = function() {
    var I = function() {
    };
    return I.colorStops = [], I.addColorStop = function(U, G) {
      this.colorStops.push([U, G]);
    }, I.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, I.isCanvasGradient = !0, I;
  }, p.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, p.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var x = function(I, U, G, K, A, ee, te, ne, ve) {
    for (var _e = ce.call(this, G, K, A, ee), pe = 0; pe < _e.length; pe++) {
      var je = _e[pe];
      pe === 0 && (ve ? P.call(this, je.x1 + I, je.y1 + U) : H.call(this, je.x1 + I, je.y1 + U)), ae.call(this, I, U, je.x2, je.y2, je.x3, je.y3, je.x4, je.y4);
    }
    ne ? D.call(this) : C.call(this, te);
  }, C = function(I) {
    switch (I) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, D = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, P = function(I, U) {
    this.pdf.internal.out(n(I) + " " + r(U) + " m");
  }, L = function(I) {
    var U;
    switch (I.align) {
      case "right":
      case "end":
        U = "right";
        break;
      case "center":
        U = "center";
        break;
      case "left":
      case "start":
      default:
        U = "left";
    }
    var G = this.pdf.getTextDimensions(I.text), K = q.call(this, I.y), A = j.call(this, K) - G.h, ee = this.ctx.transform.applyToPoint(new o(I.x, K)), te = this.ctx.transform.decompose(), ne = new l();
    ne = (ne = (ne = ne.multiply(te.translate)).multiply(te.skew)).multiply(te.scale);
    for (var ve, _e, pe, je = this.ctx.transform.applyToRectangle(new s(I.x, K, G.w, G.h)), Se = ne.applyToRectangle(new s(I.x, A, G.w, G.h)), be = S.call(this, Se), X = [], Ye = 0; Ye < be.length; Ye += 1) X.indexOf(be[Ye]) === -1 && X.push(be[Ye]);
    if (k(X), this.autoPaging) for (var Re = X[0], Te = X[X.length - 1], Ue = Re; Ue < Te + 1; Ue++) {
      this.pdf.setPage(Ue);
      var T = Ue === 1 ? this.posY + this.margin[0] : this.margin[0], fe = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], xe = this.pdf.internal.pageSize.height - this.margin[2], Fe = xe - this.margin[0], Ge = this.pdf.internal.pageSize.width - this.margin[1], Me = Ge - this.margin[3], Ie = Ue === 1 ? 0 : fe + (Ue - 2) * Fe;
      if (this.ctx.clip_path.length !== 0) {
        var ct = this.path;
        ve = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = E(ve, this.posX + this.margin[3], -1 * Ie + T), F.call(this, "fill", !0), this.path = ct;
      }
      var at = E([JSON.parse(JSON.stringify(Se))], this.posX + this.margin[3], -Ie + T + this.ctx.prevPageLastElemOffset)[0];
      I.scale >= 0.01 && (_e = this.pdf.internal.getFontSize(), this.pdf.setFontSize(_e * I.scale), pe = this.lineWidth, this.lineWidth = pe * I.scale);
      var Je = this.autoPaging !== "text";
      if (Je || at.y + at.h <= xe) {
        if (Je || at.y >= T && at.x <= Ge) {
          var $e = Je ? I.text : this.pdf.splitTextToSize(I.text, I.maxWidth || Ge - at.x)[0], _t = E([JSON.parse(JSON.stringify(je))], this.posX + this.margin[3], -Ie + T + this.ctx.prevPageLastElemOffset)[0], dt = Je && (Ue > Re || Ue < Te) && b.call(this);
          dt && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Me, Fe, null).clip().discardPath()), this.pdf.text($e, _t.x, _t.y, { angle: I.angle, align: U, renderingMode: I.renderingMode }), dt && this.pdf.restoreGraphicsState();
        }
      } else at.y < xe && (this.ctx.prevPageLastElemOffset += xe - at.y);
      I.scale >= 0.01 && (this.pdf.setFontSize(_e), this.lineWidth = pe);
    }
    else I.scale >= 0.01 && (_e = this.pdf.internal.getFontSize(), this.pdf.setFontSize(_e * I.scale), pe = this.lineWidth, this.lineWidth = pe * I.scale), this.pdf.text(I.text, ee.x + this.posX, ee.y + this.posY, { angle: I.angle, align: U, renderingMode: I.renderingMode, maxWidth: I.maxWidth }), I.scale >= 0.01 && (this.pdf.setFontSize(_e), this.lineWidth = pe);
  }, H = function(I, U, G, K) {
    G = G || 0, K = K || 0, this.pdf.internal.out(n(I + G) + " " + r(U + K) + " l");
  }, $ = function(I, U, G) {
    return this.pdf.lines(I, U, G, null, null);
  }, ae = function(I, U, G, K, A, ee, te, ne) {
    this.pdf.internal.out([t(i(G + I)), t(a(K + U)), t(i(A + I)), t(a(ee + U)), t(i(te + I)), t(a(ne + U)), "c"].join(" "));
  }, ce = function(I, U, G, K) {
    for (var A = 2 * Math.PI, ee = Math.PI / 2; U > G; ) U -= A;
    var te = Math.abs(G - U);
    te < A && K && (te = A - te);
    for (var ne = [], ve = K ? -1 : 1, _e = U; te > 1e-5; ) {
      var pe = _e + ve * Math.min(te, ee);
      ne.push(le.call(this, I, _e, pe)), te -= Math.abs(pe - _e), _e = pe;
    }
    return ne;
  }, le = function(I, U, G) {
    var K = (G - U) / 2, A = I * Math.cos(K), ee = I * Math.sin(K), te = A, ne = -ee, ve = te * te + ne * ne, _e = ve + te * A + ne * ee, pe = 4 / 3 * (Math.sqrt(2 * ve * _e) - _e) / (te * ee - ne * A), je = te - pe * ne, Se = ne + pe * te, be = je, X = -Se, Ye = K + U, Re = Math.cos(Ye), Te = Math.sin(Ye);
    return { x1: I * Math.cos(U), y1: I * Math.sin(U), x2: je * Re - Se * Te, y2: je * Te + Se * Re, x3: be * Re - X * Te, y3: be * Te + X * Re, x4: I * Math.cos(G), y4: I * Math.sin(G) };
  }, oe = function(I) {
    return 180 * I / Math.PI;
  }, se = function(I, U, G, K, A, ee) {
    var te = I + 0.5 * (G - I), ne = U + 0.5 * (K - U), ve = A + 0.5 * (G - A), _e = ee + 0.5 * (K - ee), pe = Math.min(I, A, te, ve), je = Math.max(I, A, te, ve), Se = Math.min(U, ee, ne, _e), be = Math.max(U, ee, ne, _e);
    return new s(pe, Se, je - pe, be - Se);
  }, J = function(I, U, G, K, A, ee, te, ne) {
    var ve, _e, pe, je, Se, be, X, Ye, Re, Te, Ue, T, fe, xe, Fe = G - I, Ge = K - U, Me = A - G, Ie = ee - K, ct = te - A, at = ne - ee;
    for (_e = 0; _e < 41; _e++) Re = (X = (pe = I + (ve = _e / 40) * Fe) + ve * ((Se = G + ve * Me) - pe)) + ve * (Se + ve * (A + ve * ct - Se) - X), Te = (Ye = (je = U + ve * Ge) + ve * ((be = K + ve * Ie) - je)) + ve * (be + ve * (ee + ve * at - be) - Ye), _e == 0 ? (Ue = Re, T = Te, fe = Re, xe = Te) : (Ue = Math.min(Ue, Re), T = Math.min(T, Te), fe = Math.max(fe, Re), xe = Math.max(xe, Te));
    return new s(Math.round(Ue), Math.round(T), Math.round(fe - Ue), Math.round(xe - T));
  }, re = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var I, U, G = (I = this.ctx.lineDash, U = this.ctx.lineDashOffset, JSON.stringify({ lineDash: I, lineDashOffset: U }));
      this.prevLineDash !== G && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = G);
    }
  };
})(xt.API), /**
* @license
* jsPDF filters PlugIn
* Copyright (c) 2014 Aras Abbasi
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = function(a) {
    var o, s, l, c, d, p, y, f, N, b;
    for (s = [], l = 0, c = (a += o = "\0\0\0\0".slice(a.length % 4 || 4)).length; c > l; l += 4) (d = (a.charCodeAt(l) << 24) + (a.charCodeAt(l + 1) << 16) + (a.charCodeAt(l + 2) << 8) + a.charCodeAt(l + 3)) !== 0 ? (p = (d = ((d = ((d = ((d = (d - (b = d % 85)) / 85) - (N = d % 85)) / 85) - (f = d % 85)) / 85) - (y = d % 85)) / 85) % 85, s.push(p + 33, y + 33, f + 33, N + 33, b + 33)) : s.push(122);
    return function(S, _) {
      for (var E = _; E > 0; E--) S.pop();
    }(s, o.length), String.fromCharCode.apply(String, s) + "~>";
  }, n = function(a) {
    var o, s, l, c, d, p = String, y = "length", f = 255, N = "charCodeAt", b = "slice", S = "replace";
    for (a[b](-2), a = a[b](0, -2)[S](/\s/g, "")[S]("z", "!!!!!"), l = [], c = 0, d = (a += o = "uuuuu"[b](a[y] % 5 || 5))[y]; d > c; c += 5) s = 52200625 * (a[N](c) - 33) + 614125 * (a[N](c + 1) - 33) + 7225 * (a[N](c + 2) - 33) + 85 * (a[N](c + 3) - 33) + (a[N](c + 4) - 33), l.push(f & s >> 24, f & s >> 16, f & s >> 8, f & s);
    return function(_, E) {
      for (var k = E; k > 0; k--) _.pop();
    }(l, o[y]), p.fromCharCode.apply(p, l);
  }, r = function(a) {
    var o = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((a = a.replace(/\s/g, "")).indexOf(">") !== -1 && (a = a.substr(0, a.indexOf(">"))), a.length % 2 && (a += "0"), o.test(a) === !1) return "";
    for (var s = "", l = 0; l < a.length; l += 2) s += String.fromCharCode("0x" + (a[l] + a[l + 1]));
    return s;
  }, i = function(a) {
    for (var o = new Uint8Array(a.length), s = a.length; s--; ) o[s] = a.charCodeAt(s);
    return a = (o = Ym(o)).reduce(function(l, c) {
      return l + String.fromCharCode(c);
    }, "");
  };
  e.processDataByFilters = function(a, o) {
    var s = 0, l = a || "", c = [];
    for (typeof (o = o || []) == "string" && (o = [o]), s = 0; s < o.length; s += 1) switch (o[s]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        l = n(l), c.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        l = t(l), c.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        l = r(l), c.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        l = l.split("").map(function(d) {
          return ("0" + d.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">", c.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        l = i(l), c.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + o[s] + '" is not implemented');
    }
    return { data: l, reverseChain: c.reverse().join(" ") };
  };
}(xt.API), /**
* @license
* jsPDF fileloading PlugIn
* Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  e.loadFile = function(t, n, r) {
    return function(i, a, o) {
      a = a !== !1, o = typeof o == "function" ? o : function() {
      };
      var s = void 0;
      try {
        s = function(l, c, d) {
          var p = new XMLHttpRequest(), y = 0, f = function(N) {
            var b = N.length, S = [], _ = String.fromCharCode;
            for (y = 0; y < b; y += 1) S.push(_(255 & N.charCodeAt(y)));
            return S.join("");
          };
          if (p.open("GET", l, !c), p.overrideMimeType("text/plain; charset=x-user-defined"), c === !1 && (p.onload = function() {
            p.status === 200 ? d(f(this.responseText)) : d(void 0);
          }), p.send(null), c && p.status === 200) return f(p.responseText);
        }(i, a, o);
      } catch {
      }
      return s;
    }(t, n, r);
  }, e.loadImageFile = e.loadFile;
}(xt.API), function(e) {
  function t() {
    return (wt.html2canvas ? Promise.resolve(wt.html2canvas) : import("./html2canvas.esm-KipKlkGD-BeAzOrRM.js")).catch(function(o) {
      return Promise.reject(new Error("Could not load html2canvas: " + o));
    }).then(function(o) {
      return o.default ? o.default : o;
    });
  }
  function n() {
    return (wt.DOMPurify ? Promise.resolve(wt.DOMPurify) : import("./purify.es-CKk_t3XZ-DiwTzLZw.js")).catch(function(o) {
      return Promise.reject(new Error("Could not load dompurify: " + o));
    }).then(function(o) {
      return o.default ? o.default : o;
    });
  }
  var r = function(o) {
    var s = Yt(o);
    return s === "undefined" ? "undefined" : s === "string" || o instanceof String ? "string" : s === "number" || o instanceof Number ? "number" : s === "function" || o instanceof Function ? "function" : o && o.constructor === Array ? "array" : o && o.nodeType === 1 ? "element" : s === "object" ? "object" : "unknown";
  }, i = function(o, s) {
    var l = document.createElement(o);
    for (var c in s.className && (l.className = s.className), s.innerHTML && s.dompurify && (l.innerHTML = s.dompurify.sanitize(s.innerHTML)), s.style) l.style[c] = s.style[c];
    return l;
  }, a = function o(s) {
    var l = Object.assign(o.convert(Promise.resolve()), JSON.parse(JSON.stringify(o.template))), c = o.convert(Promise.resolve(), l);
    return c = (c = c.setProgress(1, o, 1, [o])).set(s);
  };
  (a.prototype = Object.create(Promise.prototype)).constructor = a, a.convert = function(o, s) {
    return o.__proto__ = s || a.prototype, o;
  }, a.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, a.prototype.from = function(o, s) {
    return this.then(function() {
      switch (s = s || function(l) {
        switch (r(l)) {
          case "string":
            return "string";
          case "element":
            return l.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      }(o)) {
        case "string":
          return this.then(n).then(function(l) {
            return this.set({ src: i("div", { innerHTML: o, dompurify: l }) });
          });
        case "element":
          return this.set({ src: o });
        case "canvas":
          return this.set({ canvas: o });
        case "img":
          return this.set({ img: o });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, a.prototype.to = function(o) {
    switch (o) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, a.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var o = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, s = function l(c, d) {
        for (var p = c.nodeType === 3 ? document.createTextNode(c.nodeValue) : c.cloneNode(!1), y = c.firstChild; y; y = y.nextSibling) d !== !0 && y.nodeType === 1 && y.nodeName === "SCRIPT" || p.appendChild(l(y, d));
        return c.nodeType === 1 && (c.nodeName === "CANVAS" ? (p.width = c.width, p.height = c.height, p.getContext("2d").drawImage(c, 0, 0)) : c.nodeName !== "TEXTAREA" && c.nodeName !== "SELECT" || (p.value = c.value), p.addEventListener("load", function() {
          p.scrollTop = c.scrollTop, p.scrollLeft = c.scrollLeft;
        }, !0)), p;
      }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      s.tagName === "BODY" && (o.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = i("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = i("div", { className: "html2pdf__container", style: o }), this.prop.container.appendChild(s), this.prop.container.firstChild.appendChild(i("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, a.prototype.toCanvas = function() {
    var o = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(o).then(t).then(function(s) {
      var l = Object.assign({}, this.opt.html2canvas);
      return delete l.onrendered, s(this.prop.container, l);
    }).then(function(s) {
      (this.opt.html2canvas.onrendered || function() {
      })(s), this.prop.canvas = s, document.body.removeChild(this.prop.overlay);
    });
  }, a.prototype.toContext2d = function() {
    var o = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(o).then(t).then(function(s) {
      var l = this.opt.jsPDF, c = this.opt.fontFaces, d = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, p = Object.assign({ async: !0, allowTaint: !0, scale: d, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete p.onrendered, l.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, l.context2d.posX = this.opt.x, l.context2d.posY = this.opt.y, l.context2d.margin = this.opt.margin, l.context2d.fontFaces = c, c) for (var y = 0; y < c.length; ++y) {
        var f = c[y], N = f.src.find(function(b) {
          return b.format === "truetype";
        });
        N && l.addFont(N.url, f.ref.name, f.ref.style);
      }
      return p.windowHeight = p.windowHeight || 0, p.windowHeight = p.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : p.windowHeight, l.context2d.save(!0), s(this.prop.container, p);
    }).then(function(s) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(s), this.prop.canvas = s, document.body.removeChild(this.prop.overlay);
    });
  }, a.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var o = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = o;
    });
  }, a.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, a.prototype.output = function(o, s, l) {
    return (l = l || "pdf").toLowerCase() === "img" || l.toLowerCase() === "image" ? this.outputImg(o, s) : this.outputPdf(o, s);
  }, a.prototype.outputPdf = function(o, s) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(o, s);
    });
  }, a.prototype.outputImg = function(o) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (o) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + o + '" is not supported.';
      }
    });
  }, a.prototype.save = function(o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(o ? { filename: o } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, a.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, a.prototype.set = function(o) {
    if (r(o) !== "object") return this;
    var s = Object.keys(o || {}).map(function(l) {
      if (l in a.template.prop) return function() {
        this.prop[l] = o[l];
      };
      switch (l) {
        case "margin":
          return this.setMargin.bind(this, o.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = o.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, o.pageSize);
        default:
          return function() {
            this.opt[l] = o[l];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(s);
    });
  }, a.prototype.get = function(o, s) {
    return this.then(function() {
      var l = o in a.template.prop ? this.prop[o] : this.opt[o];
      return s ? s(l) : l;
    });
  }, a.prototype.setMargin = function(o) {
    return this.then(function() {
      switch (r(o)) {
        case "number":
          o = [o, o, o, o];
        case "array":
          if (o.length === 2 && (o = [o[0], o[1], o[0], o[1]]), o.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = o;
    }).then(this.setPageSize);
  }, a.prototype.setPageSize = function(o) {
    function s(l, c) {
      return Math.floor(l * c / 72 * 96);
    }
    return this.then(function() {
      (o = o || xt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (o.inner = { width: o.width - this.opt.margin[1] - this.opt.margin[3], height: o.height - this.opt.margin[0] - this.opt.margin[2] }, o.inner.px = { width: s(o.inner.width, o.k), height: s(o.inner.height, o.k) }, o.inner.ratio = o.inner.height / o.inner.width), this.prop.pageSize = o;
    });
  }, a.prototype.setProgress = function(o, s, l, c) {
    return o != null && (this.progress.val = o), s != null && (this.progress.state = s), l != null && (this.progress.n = l), c != null && (this.progress.stack = c), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, a.prototype.updateProgress = function(o, s, l, c) {
    return this.setProgress(o ? this.progress.val + o : null, s || null, l ? this.progress.n + l : null, c ? this.progress.stack.concat(c) : null);
  }, a.prototype.then = function(o, s) {
    var l = this;
    return this.thenCore(o, s, function(c, d) {
      return l.updateProgress(null, null, 1, [c]), Promise.prototype.then.call(this, function(p) {
        return l.updateProgress(null, c), p;
      }).then(c, d).then(function(p) {
        return l.updateProgress(1), p;
      });
    });
  }, a.prototype.thenCore = function(o, s, l) {
    l = l || Promise.prototype.then, o && (o = o.bind(this)), s && (s = s.bind(this));
    var c = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? this : a.convert(Object.assign({}, this), Promise.prototype), d = l.call(c, o, s);
    return a.convert(d, this.__proto__);
  }, a.prototype.thenExternal = function(o, s) {
    return Promise.prototype.then.call(this, o, s);
  }, a.prototype.thenList = function(o) {
    var s = this;
    return o.forEach(function(l) {
      s = s.thenCore(l);
    }), s;
  }, a.prototype.catch = function(o) {
    o && (o = o.bind(this));
    var s = Promise.prototype.catch.call(this, o);
    return a.convert(s, this);
  }, a.prototype.catchExternal = function(o) {
    return Promise.prototype.catch.call(this, o);
  }, a.prototype.error = function(o) {
    return this.then(function() {
      throw new Error(o);
    });
  }, a.prototype.using = a.prototype.set, a.prototype.saveAs = a.prototype.save, a.prototype.export = a.prototype.output, a.prototype.run = a.prototype.then, xt.getPageSize = function(o, s, l) {
    if (Yt(o) === "object") {
      var c = o;
      o = c.orientation, s = c.unit || s, l = c.format || l;
    }
    s = s || "mm", l = l || "a4", o = ("" + (o || "P")).toLowerCase();
    var d, p = ("" + l).toLowerCase(), y = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (s) {
      case "pt":
        d = 1;
        break;
      case "mm":
        d = 72 / 25.4;
        break;
      case "cm":
        d = 72 / 2.54;
        break;
      case "in":
        d = 72;
        break;
      case "px":
        d = 0.75;
        break;
      case "pc":
      case "em":
        d = 12;
        break;
      case "ex":
        d = 6;
        break;
      default:
        throw "Invalid unit: " + s;
    }
    var f, N = 0, b = 0;
    if (y.hasOwnProperty(p)) N = y[p][1] / d, b = y[p][0] / d;
    else try {
      N = l[1], b = l[0];
    } catch {
      throw new Error("Invalid format: " + l);
    }
    if (o === "p" || o === "portrait") o = "p", b > N && (f = b, b = N, N = f);
    else {
      if (o !== "l" && o !== "landscape") throw "Invalid orientation: " + o;
      o = "l", N > b && (f = b, b = N, N = f);
    }
    return { width: b, height: N, unit: s, k: d, orientation: o };
  }, e.html = function(o, s) {
    (s = s || {}).callback = s.callback || function() {
    }, s.html2canvas = s.html2canvas || {}, s.html2canvas.canvas = s.html2canvas.canvas || this.canvas, s.jsPDF = s.jsPDF || this, s.fontFaces = s.fontFaces ? s.fontFaces.map(eg) : null;
    var l = new a(s);
    return s.worker ? l : l.from(o).doCallback();
  };
}(xt.API), xt.API.addJS = function(e) {
  return n0 = e, this.internal.events.subscribe("postPutResources", function() {
    Xd = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Xd + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), t0 = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + n0 + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    Xd !== void 0 && t0 !== void 0 && this.internal.out("/Names <</JavaScript " + Xd + " 0 R>>");
  }), this;
}, /**
* @license
* Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t;
  e.events.push(["postPutResources", function() {
    var n = this, r = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var i = n.outline.render().split(/\r\n/), a = 0; a < i.length; a++) {
      var o = i[a], s = r.exec(o);
      if (s != null) {
        var l = s[1];
        n.internal.newObjectDeferredBegin(l, !1);
      }
      n.internal.write(o);
    }
    if (this.outline.createNamedDestinations) {
      var c = this.internal.pages.length, d = [];
      for (a = 0; a < c; a++) {
        var p = n.internal.newObject();
        d.push(p);
        var y = n.internal.getPageInfo(a + 1);
        n.internal.write("<< /D[" + y.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var f = n.internal.newObject();
      for (n.internal.write("<< /Names [ "), a = 0; a < d.length; a++) n.internal.write("(page_" + (a + 1) + ")" + d[a] + " 0 R");
      n.internal.write(" ] >>", "endobj"), t = n.internal.newObject(), n.internal.write("<< /Dests " + f + " 0 R"), n.internal.write(">>", "endobj");
    }
  }]), e.events.push(["putCatalog", function() {
    this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + t + " 0 R"));
  }]), e.events.push(["initialized", function() {
    var n = this;
    n.outline = { createNamedDestinations: !1, root: { children: [] } }, n.outline.add = function(r, i, a) {
      var o = { title: i, options: a, children: [] };
      return r == null && (r = this.root), r.children.push(o), o;
    }, n.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = n, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, n.outline.genIds_r = function(r) {
      r.id = n.internal.newObjectDeferred();
      for (var i = 0; i < r.children.length; i++) this.genIds_r(r.children[i]);
    }, n.outline.renderRoot = function(r) {
      this.objStart(r), this.line("/Type /Outlines"), r.children.length > 0 && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, r)), this.objEnd();
    }, n.outline.renderItems = function(r) {
      for (var i = this.ctx.pdf.internal.getVerticalCoordinateString, a = 0; a < r.children.length; a++) {
        var o = r.children[a];
        this.objStart(o), this.line("/Title " + this.makeString(o.title)), this.line("/Parent " + this.makeRef(r)), a > 0 && this.line("/Prev " + this.makeRef(r.children[a - 1])), a < r.children.length - 1 && this.line("/Next " + this.makeRef(r.children[a + 1])), o.children.length > 0 && (this.line("/First " + this.makeRef(o.children[0])), this.line("/Last " + this.makeRef(o.children[o.children.length - 1])));
        var s = this.count = this.count_r({ count: 0 }, o);
        if (s > 0 && this.line("/Count " + s), o.options && o.options.pageNumber) {
          var l = n.internal.getPageInfo(o.options.pageNumber);
          this.line("/Dest [" + l.objId + " 0 R /XYZ 0 " + i(0) + " 0]");
        }
        this.objEnd();
      }
      for (var c = 0; c < r.children.length; c++) this.renderItems(r.children[c]);
    }, n.outline.line = function(r) {
      this.ctx.val += r + `\r
`;
    }, n.outline.makeRef = function(r) {
      return r.id + " 0 R";
    }, n.outline.makeString = function(r) {
      return "(" + n.internal.pdfEscape(r) + ")";
    }, n.outline.objStart = function(r) {
      this.ctx.val += `\r
` + r.id + ` 0 obj\r
<<\r
`;
    }, n.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, n.outline.count_r = function(r, i) {
      for (var a = 0; a < i.children.length; a++) r.count++, this.count_r(r, i.children[a]);
      return r.count;
    };
  }]);
}(xt.API), /**
* @license
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = [192, 193, 194, 195, 196, 197, 198, 199];
  e.processJPEG = function(n, r, i, a, o, s) {
    var l, c = this.decode.DCT_DECODE, d = null;
    if (typeof n == "string" || this.__addimage__.isArrayBuffer(n) || this.__addimage__.isArrayBufferView(n)) {
      switch (n = o || n, n = this.__addimage__.isArrayBuffer(n) ? new Uint8Array(n) : n, (l = function(p) {
        for (var y, f = 256 * p.charCodeAt(4) + p.charCodeAt(5), N = p.length, b = { width: 0, height: 0, numcomponents: 1 }, S = 4; S < N; S += 2) {
          if (S += f, t.indexOf(p.charCodeAt(S + 1)) !== -1) {
            y = 256 * p.charCodeAt(S + 5) + p.charCodeAt(S + 6), b = { width: 256 * p.charCodeAt(S + 7) + p.charCodeAt(S + 8), height: y, numcomponents: p.charCodeAt(S + 9) };
            break;
          }
          f = 256 * p.charCodeAt(S + 2) + p.charCodeAt(S + 3);
        }
        return b;
      }(n = this.__addimage__.isArrayBufferView(n) ? this.__addimage__.arrayBufferToBinaryString(n) : n)).numcomponents) {
        case 1:
          s = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          s = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          s = this.color_spaces.DEVICE_RGB;
      }
      d = { data: n, width: l.width, height: l.height, colorSpace: s, bitsPerComponent: 8, filter: c, index: r, alias: i };
    }
    return d;
  };
}(xt.API);
var el, Zd, i0, a0, o0, YB = function() {
  var e, t, n;
  function r(a) {
    var o, s, l, c, d, p, y, f, N, b, S, _, E, k;
    for (this.data = a, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, p = null; ; ) {
      switch (o = this.readUInt32(), N = (function() {
        var M, F;
        for (F = [], M = 0; M < 4; ++M) F.push(String.fromCharCode(this.data[this.pos++]));
        return F;
      }).call(this).join("")) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "acTL":
          this.animation = { numFrames: this.readUInt32(), numPlays: this.readUInt32() || 1 / 0, frames: [] };
          break;
        case "PLTE":
          this.palette = this.read(o);
          break;
        case "fcTL":
          p && this.animation.frames.push(p), this.pos += 4, p = { width: this.readUInt32(), height: this.readUInt32(), xOffset: this.readUInt32(), yOffset: this.readUInt32() }, d = this.readUInt16(), c = this.readUInt16() || 100, p.delay = 1e3 * d / c, p.disposeOp = this.data[this.pos++], p.blendOp = this.data[this.pos++], p.data = [];
          break;
        case "IDAT":
        case "fdAT":
          for (N === "fdAT" && (this.pos += 4, o -= 4), a = (p != null ? p.data : void 0) || this.imgData, _ = 0; 0 <= o ? _ < o : _ > o; 0 <= o ? ++_ : --_) a.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              if (l = this.palette.length / 3, this.transparency.indexed = this.read(o), this.transparency.indexed.length > l) throw new Error("More transparent colors than palette size");
              if ((b = l - this.transparency.indexed.length) > 0) for (E = 0; 0 <= b ? E < b : E > b; 0 <= b ? ++E : --E) this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(o)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(o);
          }
          break;
        case "tEXt":
          y = (S = this.read(o)).indexOf(0), f = String.fromCharCode.apply(String, S.slice(0, y)), this.text[f] = String.fromCharCode.apply(String, S.slice(y + 1));
          break;
        case "IEND":
          return p && this.animation.frames.push(p), this.colors = (function() {
            switch (this.colorType) {
              case 0:
              case 3:
              case 4:
                return 1;
              case 2:
              case 6:
                return 3;
            }
          }).call(this), this.hasAlphaChannel = (k = this.colorType) === 4 || k === 6, s = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * s, this.colorSpace = (function() {
            switch (this.colors) {
              case 1:
                return "DeviceGray";
              case 3:
                return "DeviceRGB";
            }
          }).call(this), void (this.imgData = new Uint8Array(this.imgData));
        default:
          this.pos += o;
      }
      if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
    }
  }
  r.prototype.read = function(a) {
    var o, s;
    for (s = [], o = 0; 0 <= a ? o < a : o > a; 0 <= a ? ++o : --o) s.push(this.data[this.pos++]);
    return s;
  }, r.prototype.readUInt32 = function() {
    return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
  }, r.prototype.readUInt16 = function() {
    return this.data[this.pos++] << 8 | this.data[this.pos++];
  }, r.prototype.decodePixels = function(a) {
    var o = this.pixelBitlength / 8, s = new Uint8Array(this.width * this.height * o), l = 0, c = this;
    if (a == null && (a = this.imgData), a.length === 0) return new Uint8Array(0);
    function d(p, y, f, N) {
      var b, S, _, E, k, M, F, q, j, x, C, D, P, L, H, $, ae, ce, le, oe, se, J = Math.ceil((c.width - p) / f), re = Math.ceil((c.height - y) / N), I = c.width == J && c.height == re;
      for (L = o * J, D = I ? s : new Uint8Array(L * re), M = a.length, P = 0, S = 0; P < re && l < M; ) {
        switch (a[l++]) {
          case 0:
            for (E = ae = 0; ae < L; E = ae += 1) D[S++] = a[l++];
            break;
          case 1:
            for (E = ce = 0; ce < L; E = ce += 1) b = a[l++], k = E < o ? 0 : D[S - o], D[S++] = (b + k) % 256;
            break;
          case 2:
            for (E = le = 0; le < L; E = le += 1) b = a[l++], _ = (E - E % o) / o, H = P && D[(P - 1) * L + _ * o + E % o], D[S++] = (H + b) % 256;
            break;
          case 3:
            for (E = oe = 0; oe < L; E = oe += 1) b = a[l++], _ = (E - E % o) / o, k = E < o ? 0 : D[S - o], H = P && D[(P - 1) * L + _ * o + E % o], D[S++] = (b + Math.floor((k + H) / 2)) % 256;
            break;
          case 4:
            for (E = se = 0; se < L; E = se += 1) b = a[l++], _ = (E - E % o) / o, k = E < o ? 0 : D[S - o], P === 0 ? H = $ = 0 : (H = D[(P - 1) * L + _ * o + E % o], $ = _ && D[(P - 1) * L + (_ - 1) * o + E % o]), F = k + H - $, q = Math.abs(F - k), x = Math.abs(F - H), C = Math.abs(F - $), j = q <= x && q <= C ? k : x <= C ? H : $, D[S++] = (b + j) % 256;
            break;
          default:
            throw new Error("Invalid filter algorithm: " + a[l - 1]);
        }
        if (!I) {
          var U = ((y + P * N) * c.width + p) * o, G = P * L;
          for (E = 0; E < J; E += 1) {
            for (var K = 0; K < o; K += 1) s[U++] = D[G++];
            U += (f - 1) * o;
          }
        }
        P++;
      }
    }
    return a = CB(a), c.interlaceMethod == 1 ? (d(0, 0, 8, 8), d(4, 0, 8, 8), d(0, 4, 4, 8), d(2, 0, 4, 4), d(0, 2, 2, 4), d(1, 0, 2, 2), d(0, 1, 1, 2)) : d(0, 0, 1, 1), s;
  }, r.prototype.decodePalette = function() {
    var a, o, s, l, c, d, p, y, f;
    for (s = this.palette, d = this.transparency.indexed || [], c = new Uint8Array((d.length || 0) + s.length), l = 0, a = 0, o = p = 0, y = s.length; p < y; o = p += 3) c[l++] = s[o], c[l++] = s[o + 1], c[l++] = s[o + 2], c[l++] = (f = d[a++]) != null ? f : 255;
    return c;
  }, r.prototype.copyToImageData = function(a, o) {
    var s, l, c, d, p, y, f, N, b, S, _;
    if (l = this.colors, b = null, s = this.hasAlphaChannel, this.palette.length && (b = (_ = this._decodedPalette) != null ? _ : this._decodedPalette = this.decodePalette(), l = 4, s = !0), N = (c = a.data || a).length, p = b || o, d = y = 0, l === 1) for (; d < N; ) f = b ? 4 * o[d / 4] : y, S = p[f++], c[d++] = S, c[d++] = S, c[d++] = S, c[d++] = s ? p[f++] : 255, y = f;
    else for (; d < N; ) f = b ? 4 * o[d / 4] : y, c[d++] = p[f++], c[d++] = p[f++], c[d++] = p[f++], c[d++] = s ? p[f++] : 255, y = f;
  }, r.prototype.decode = function() {
    var a;
    return a = new Uint8Array(this.width * this.height * 4), this.copyToImageData(a, this.decodePixels()), a;
  };
  var i = function() {
    if (Object.prototype.toString.call(wt) === "[object Window]") {
      try {
        t = wt.document.createElement("canvas"), n = t.getContext("2d");
      } catch {
        return !1;
      }
      return !0;
    }
    return !1;
  };
  return i(), e = function(a) {
    var o;
    if (i() === !0) return n.width = a.width, n.height = a.height, n.clearRect(0, 0, a.width, a.height), n.putImageData(a, 0, 0), (o = new Image()).src = t.toDataURL(), o;
    throw new Error("This method requires a Browser with Canvas-capability.");
  }, r.prototype.decodeFrames = function(a) {
    var o, s, l, c, d, p, y, f;
    if (this.animation) {
      for (f = [], s = d = 0, p = (y = this.animation.frames).length; d < p; s = ++d) o = y[s], l = a.createImageData(o.width, o.height), c = this.decodePixels(new Uint8Array(o.data)), this.copyToImageData(l, c), o.imageData = l, f.push(o.image = e(l));
      return f;
    }
  }, r.prototype.renderFrame = function(a, o) {
    var s, l, c;
    return s = (l = this.animation.frames)[o], c = l[o - 1], o === 0 && a.clearRect(0, 0, this.width, this.height), (c != null ? c.disposeOp : void 0) === 1 ? a.clearRect(c.xOffset, c.yOffset, c.width, c.height) : (c != null ? c.disposeOp : void 0) === 2 && a.putImageData(c.imageData, c.xOffset, c.yOffset), s.blendOp === 0 && a.clearRect(s.xOffset, s.yOffset, s.width, s.height), a.drawImage(s.image, s.xOffset, s.yOffset);
  }, r.prototype.animate = function(a) {
    var o, s, l, c, d, p, y = this;
    return s = 0, p = this.animation, c = p.numFrames, l = p.frames, d = p.numPlays, (o = function() {
      var f, N;
      if (f = s++ % c, N = l[f], y.renderFrame(a, f), c > 1 && s / c < d) return y.animation._timeout = setTimeout(o, N.delay);
    })();
  }, r.prototype.stopAnimation = function() {
    var a;
    return clearTimeout((a = this.animation) != null ? a._timeout : void 0);
  }, r.prototype.render = function(a) {
    var o, s;
    return a._png && a._png.stopAnimation(), a._png = this, a.width = this.width, a.height = this.height, o = a.getContext("2d"), this.animation ? (this.decodeFrames(o), this.animate(o)) : (s = o.createImageData(this.width, this.height), this.copyToImageData(s, this.decodePixels()), o.putImageData(s, 0, 0));
  }, r;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function KB(e) {
  var t = 0;
  if (e[t++] !== 71 || e[t++] !== 73 || e[t++] !== 70 || e[t++] !== 56 || (e[t++] + 1 & 253) != 56 || e[t++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var n = e[t++] | e[t++] << 8, r = e[t++] | e[t++] << 8, i = e[t++], a = i >> 7, o = 1 << (7 & i) + 1;
  e[t++], e[t++];
  var s = null, l = null;
  a && (s = t, l = o, t += 3 * o);
  var c = !0, d = [], p = 0, y = null, f = 0, N = null;
  for (this.width = n, this.height = r; c && t < e.length; ) switch (e[t++]) {
    case 33:
      switch (e[t++]) {
        case 255:
          if (e[t] !== 11 || e[t + 1] == 78 && e[t + 2] == 69 && e[t + 3] == 84 && e[t + 4] == 83 && e[t + 5] == 67 && e[t + 6] == 65 && e[t + 7] == 80 && e[t + 8] == 69 && e[t + 9] == 50 && e[t + 10] == 46 && e[t + 11] == 48 && e[t + 12] == 3 && e[t + 13] == 1 && e[t + 16] == 0) t += 14, N = e[t++] | e[t++] << 8, t++;
          else for (t += 12; ; ) {
            if (!((P = e[t++]) >= 0)) throw Error("Invalid block size");
            if (P === 0) break;
            t += P;
          }
          break;
        case 249:
          if (e[t++] !== 4 || e[t + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var b = e[t++];
          p = e[t++] | e[t++] << 8, y = e[t++], !(1 & b) && (y = null), f = b >> 2 & 7, t++;
          break;
        case 254:
          for (; ; ) {
            if (!((P = e[t++]) >= 0)) throw Error("Invalid block size");
            if (P === 0) break;
            t += P;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + e[t - 1].toString(16));
      }
      break;
    case 44:
      var S = e[t++] | e[t++] << 8, _ = e[t++] | e[t++] << 8, E = e[t++] | e[t++] << 8, k = e[t++] | e[t++] << 8, M = e[t++], F = M >> 6 & 1, q = 1 << (7 & M) + 1, j = s, x = l, C = !1;
      M >> 7 && (C = !0, j = t, x = q, t += 3 * q);
      var D = t;
      for (t++; ; ) {
        var P;
        if (!((P = e[t++]) >= 0)) throw Error("Invalid block size");
        if (P === 0) break;
        t += P;
      }
      d.push({ x: S, y: _, width: E, height: k, has_local_palette: C, palette_offset: j, palette_size: x, data_offset: D, data_length: t - D, transparent_index: y, interlaced: !!F, delay: p, disposal: f });
      break;
    case 59:
      c = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + e[t - 1].toString(16));
  }
  this.numFrames = function() {
    return d.length;
  }, this.loopCount = function() {
    return N;
  }, this.frameInfo = function(L) {
    if (L < 0 || L >= d.length) throw new Error("Frame index out of range.");
    return d[L];
  }, this.decodeAndBlitFrameBGRA = function(L, H) {
    var $ = this.frameInfo(L), ae = $.width * $.height, ce = new Uint8Array(ae);
    s0(e, $.data_offset, ce, ae);
    var le = $.palette_offset, oe = $.transparent_index;
    oe === null && (oe = 256);
    var se = $.width, J = n - se, re = se, I = 4 * ($.y * n + $.x), U = 4 * (($.y + $.height) * n + $.x), G = I, K = 4 * J;
    $.interlaced === !0 && (K += 4 * n * 7);
    for (var A = 8, ee = 0, te = ce.length; ee < te; ++ee) {
      var ne = ce[ee];
      if (re === 0 && (re = se, (G += K) >= U && (K = 4 * J + 4 * n * (A - 1), G = I + (se + J) * (A << 1), A >>= 1)), ne === oe) G += 4;
      else {
        var ve = e[le + 3 * ne], _e = e[le + 3 * ne + 1], pe = e[le + 3 * ne + 2];
        H[G++] = pe, H[G++] = _e, H[G++] = ve, H[G++] = 255;
      }
      --re;
    }
  }, this.decodeAndBlitFrameRGBA = function(L, H) {
    var $ = this.frameInfo(L), ae = $.width * $.height, ce = new Uint8Array(ae);
    s0(e, $.data_offset, ce, ae);
    var le = $.palette_offset, oe = $.transparent_index;
    oe === null && (oe = 256);
    var se = $.width, J = n - se, re = se, I = 4 * ($.y * n + $.x), U = 4 * (($.y + $.height) * n + $.x), G = I, K = 4 * J;
    $.interlaced === !0 && (K += 4 * n * 7);
    for (var A = 8, ee = 0, te = ce.length; ee < te; ++ee) {
      var ne = ce[ee];
      if (re === 0 && (re = se, (G += K) >= U && (K = 4 * J + 4 * n * (A - 1), G = I + (se + J) * (A << 1), A >>= 1)), ne === oe) G += 4;
      else {
        var ve = e[le + 3 * ne], _e = e[le + 3 * ne + 1], pe = e[le + 3 * ne + 2];
        H[G++] = ve, H[G++] = _e, H[G++] = pe, H[G++] = 255;
      }
      --re;
    }
  };
}
function s0(e, t, n, r) {
  for (var i = e[t++], a = 1 << i, o = a + 1, s = o + 1, l = i + 1, c = (1 << l) - 1, d = 0, p = 0, y = 0, f = e[t++], N = new Int32Array(4096), b = null; ; ) {
    for (; d < 16 && f !== 0; ) p |= e[t++] << d, d += 8, f === 1 ? f = e[t++] : --f;
    if (d < l) break;
    var S = p & c;
    if (p >>= l, d -= l, S !== a) {
      if (S === o) break;
      for (var _ = S < s ? S : b, E = 0, k = _; k > a; ) k = N[k] >> 8, ++E;
      var M = k;
      if (y + E + (_ !== S ? 1 : 0) > r) return void hn.log("Warning, gif stream longer than expected.");
      n[y++] = M;
      var F = y += E;
      for (_ !== S && (n[y++] = M), k = _; E--; ) k = N[k], n[--F] = 255 & k, k >>= 8;
      b !== null && s < 4096 && (N[s++] = b << 8 | M, s >= c + 1 && l < 12 && (++l, c = c << 1 | 1)), b = S;
    } else s = o + 1, c = (1 << (l = i + 1)) - 1, b = null;
  }
  return y !== r && hn.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function Vh(e) {
  var t, n, r, i, a, o = Math.floor, s = new Array(64), l = new Array(64), c = new Array(64), d = new Array(64), p = new Array(65535), y = new Array(65535), f = new Array(64), N = new Array(64), b = [], S = 0, _ = 7, E = new Array(64), k = new Array(64), M = new Array(64), F = new Array(256), q = new Array(2048), j = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], x = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], C = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], D = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], P = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], L = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], H = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], $ = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], ae = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function ce(I, U) {
    for (var G = 0, K = 0, A = new Array(), ee = 1; ee <= 16; ee++) {
      for (var te = 1; te <= I[ee]; te++) A[U[K]] = [], A[U[K]][0] = G, A[U[K]][1] = ee, K++, G++;
      G *= 2;
    }
    return A;
  }
  function le(I) {
    for (var U = I[0], G = I[1] - 1; G >= 0; ) U & 1 << G && (S |= 1 << _), G--, --_ < 0 && (S == 255 ? (oe(255), oe(0)) : oe(S), _ = 7, S = 0);
  }
  function oe(I) {
    b.push(I);
  }
  function se(I) {
    oe(I >> 8 & 255), oe(255 & I);
  }
  function J(I, U, G, K, A) {
    for (var ee, te = A[0], ne = A[240], ve = function(Te, Ue) {
      var T, fe, xe, Fe, Ge, Me, Ie, ct, at, Je, $e = 0;
      for (at = 0; at < 8; ++at) {
        T = Te[$e], fe = Te[$e + 1], xe = Te[$e + 2], Fe = Te[$e + 3], Ge = Te[$e + 4], Me = Te[$e + 5], Ie = Te[$e + 6];
        var _t = T + (ct = Te[$e + 7]), dt = T - ct, Ut = fe + Ie, Le = fe - Ie, pt = xe + Me, At = xe - Me, Ot = Fe + Ge, Fn = Fe - Ge, It = _t + Ot, In = _t - Ot, Cn = Ut + pt, Gt = Ut - pt;
        Te[$e] = It + Cn, Te[$e + 4] = It - Cn;
        var mt = 0.707106781 * (Gt + In);
        Te[$e + 2] = In + mt, Te[$e + 6] = In - mt;
        var ut = 0.382683433 * ((It = Fn + At) - (Gt = Le + dt)), rn = 0.5411961 * It + ut, _n = 1.306562965 * Gt + ut, Mn = 0.707106781 * (Cn = At + Le), er = dt + Mn, ht = dt - Mn;
        Te[$e + 5] = ht + rn, Te[$e + 3] = ht - rn, Te[$e + 1] = er + _n, Te[$e + 7] = er - _n, $e += 8;
      }
      for ($e = 0, at = 0; at < 8; ++at) {
        T = Te[$e], fe = Te[$e + 8], xe = Te[$e + 16], Fe = Te[$e + 24], Ge = Te[$e + 32], Me = Te[$e + 40], Ie = Te[$e + 48];
        var rr = T + (ct = Te[$e + 56]), ir = T - ct, yn = fe + Ie, Qt = fe - Ie, en = xe + Me, jn = xe - Me, Xi = Fe + Ge, pi = Fe - Ge, Un = rr + Xi, zr = rr - Xi, qr = yn + en, ei = yn - en;
        Te[$e] = Un + qr, Te[$e + 32] = Un - qr;
        var jr = 0.707106781 * (ei + zr);
        Te[$e + 16] = zr + jr, Te[$e + 48] = zr - jr;
        var hi = 0.382683433 * ((Un = pi + jn) - (ei = Qt + ir)), de = 0.5411961 * Un + hi, it = 1.306562965 * ei + hi, Xe = 0.707106781 * (qr = jn + Qt), Bt = ir + Xe, On = ir - Xe;
        Te[$e + 40] = On + de, Te[$e + 24] = On - de, Te[$e + 8] = Bt + it, Te[$e + 56] = Bt - it, $e++;
      }
      for (at = 0; at < 64; ++at) Je = Te[at] * Ue[at], f[at] = Je > 0 ? Je + 0.5 | 0 : Je - 0.5 | 0;
      return f;
    }(I, U), _e = 0; _e < 64; ++_e) N[j[_e]] = ve[_e];
    var pe = N[0] - G;
    G = N[0], pe == 0 ? le(K[0]) : (le(K[y[ee = 32767 + pe]]), le(p[ee]));
    for (var je = 63; je > 0 && N[je] == 0; ) je--;
    if (je == 0) return le(te), G;
    for (var Se, be = 1; be <= je; ) {
      for (var X = be; N[be] == 0 && be <= je; ) ++be;
      var Ye = be - X;
      if (Ye >= 16) {
        Se = Ye >> 4;
        for (var Re = 1; Re <= Se; ++Re) le(ne);
        Ye &= 15;
      }
      ee = 32767 + N[be], le(A[(Ye << 4) + y[ee]]), le(p[ee]), be++;
    }
    return je != 63 && le(te), G;
  }
  function re(I) {
    I = Math.min(Math.max(I, 1), 100), a != I && (function(U) {
      for (var G = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], K = 0; K < 64; K++) {
        var A = o((G[K] * U + 50) / 100);
        A = Math.min(Math.max(A, 1), 255), s[j[K]] = A;
      }
      for (var ee = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], te = 0; te < 64; te++) {
        var ne = o((ee[te] * U + 50) / 100);
        ne = Math.min(Math.max(ne, 1), 255), l[j[te]] = ne;
      }
      for (var ve = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], _e = 0, pe = 0; pe < 8; pe++) for (var je = 0; je < 8; je++) c[_e] = 1 / (s[j[_e]] * ve[pe] * ve[je] * 8), d[_e] = 1 / (l[j[_e]] * ve[pe] * ve[je] * 8), _e++;
    }(I < 50 ? Math.floor(5e3 / I) : Math.floor(200 - 2 * I)), a = I);
  }
  this.encode = function(I, U) {
    U && re(U), b = new Array(), S = 0, _ = 7, se(65496), se(65504), se(16), oe(74), oe(70), oe(73), oe(70), oe(0), oe(1), oe(1), oe(0), se(1), se(1), oe(0), oe(0), function() {
      se(65499), se(132), oe(0);
      for (var fe = 0; fe < 64; fe++) oe(s[fe]);
      oe(1);
      for (var xe = 0; xe < 64; xe++) oe(l[xe]);
    }(), function(fe, xe) {
      se(65472), se(17), oe(8), se(xe), se(fe), oe(3), oe(1), oe(17), oe(0), oe(2), oe(17), oe(1), oe(3), oe(17), oe(1);
    }(I.width, I.height), function() {
      se(65476), se(418), oe(0);
      for (var fe = 0; fe < 16; fe++) oe(x[fe + 1]);
      for (var xe = 0; xe <= 11; xe++) oe(C[xe]);
      oe(16);
      for (var Fe = 0; Fe < 16; Fe++) oe(D[Fe + 1]);
      for (var Ge = 0; Ge <= 161; Ge++) oe(P[Ge]);
      oe(1);
      for (var Me = 0; Me < 16; Me++) oe(L[Me + 1]);
      for (var Ie = 0; Ie <= 11; Ie++) oe(H[Ie]);
      oe(17);
      for (var ct = 0; ct < 16; ct++) oe($[ct + 1]);
      for (var at = 0; at <= 161; at++) oe(ae[at]);
    }(), se(65498), se(12), oe(3), oe(1), oe(0), oe(2), oe(17), oe(3), oe(17), oe(0), oe(63), oe(0);
    var G = 0, K = 0, A = 0;
    S = 0, _ = 7, this.encode.displayName = "_encode_";
    for (var ee, te, ne, ve, _e, pe, je, Se, be, X = I.data, Ye = I.width, Re = I.height, Te = 4 * Ye, Ue = 0; Ue < Re; ) {
      for (ee = 0; ee < Te; ) {
        for (_e = Te * Ue + ee, je = -1, Se = 0, be = 0; be < 64; be++) pe = _e + (Se = be >> 3) * Te + (je = 4 * (7 & be)), Ue + Se >= Re && (pe -= Te * (Ue + 1 + Se - Re)), ee + je >= Te && (pe -= ee + je - Te + 4), te = X[pe++], ne = X[pe++], ve = X[pe++], E[be] = (q[te] + q[ne + 256 >> 0] + q[ve + 512 >> 0] >> 16) - 128, k[be] = (q[te + 768 >> 0] + q[ne + 1024 >> 0] + q[ve + 1280 >> 0] >> 16) - 128, M[be] = (q[te + 1280 >> 0] + q[ne + 1536 >> 0] + q[ve + 1792 >> 0] >> 16) - 128;
        G = J(E, c, G, t, r), K = J(k, d, K, n, i), A = J(M, d, A, n, i), ee += 32;
      }
      Ue += 8;
    }
    if (_ >= 0) {
      var T = [];
      T[1] = _ + 1, T[0] = (1 << _ + 1) - 1, le(T);
    }
    return se(65497), new Uint8Array(b);
  }, e = e || 50, function() {
    for (var I = String.fromCharCode, U = 0; U < 256; U++) F[U] = I(U);
  }(), t = ce(x, C), n = ce(L, H), r = ce(D, P), i = ce($, ae), function() {
    for (var I = 1, U = 2, G = 1; G <= 15; G++) {
      for (var K = I; K < U; K++) y[32767 + K] = G, p[32767 + K] = [], p[32767 + K][1] = G, p[32767 + K][0] = K;
      for (var A = -(U - 1); A <= -I; A++) y[32767 + A] = G, p[32767 + A] = [], p[32767 + A][1] = G, p[32767 + A][0] = U - 1 + A;
      I <<= 1, U <<= 1;
    }
  }(), function() {
    for (var I = 0; I < 256; I++) q[I] = 19595 * I, q[I + 256 >> 0] = 38470 * I, q[I + 512 >> 0] = 7471 * I + 32768, q[I + 768 >> 0] = -11059 * I, q[I + 1024 >> 0] = -21709 * I, q[I + 1280 >> 0] = 32768 * I + 8421375, q[I + 1536 >> 0] = -27439 * I, q[I + 1792 >> 0] = -5329 * I;
  }(), re(e);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function zi(e, t) {
  if (this.pos = 0, this.buffer = e, this.datav = new DataView(e.buffer), this.is_with_alpha = !!t, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function l0(e) {
  function t(x) {
    if (!x) throw Error("assert :P");
  }
  function n(x, C, D) {
    for (var P = 0; 4 > P; P++) if (x[C + P] != D.charCodeAt(P)) return !0;
    return !1;
  }
  function r(x, C, D, P, L) {
    for (var H = 0; H < L; H++) x[C + H] = D[P + H];
  }
  function i(x, C, D, P) {
    for (var L = 0; L < P; L++) x[C + L] = D;
  }
  function a(x) {
    return new Int32Array(x);
  }
  function o(x, C) {
    for (var D = [], P = 0; P < x; P++) D.push(new C());
    return D;
  }
  function s(x, C) {
    var D = [];
    return function P(L, H, $) {
      for (var ae = $[H], ce = 0; ce < ae && (L.push($.length > H + 1 ? [] : new C()), !($.length < H + 1)); ce++) P(L[ce], H + 1, $);
    }(D, 0, x), D;
  }
  var l = function() {
    var x = this;
    function C(u, h) {
      for (var w = 1 << h - 1 >>> 0; u & w; ) w >>>= 1;
      return w ? (u & w - 1) + w : u;
    }
    function D(u, h, w, O, B) {
      t(!(O % w));
      do
        u[h + (O -= w)] = B;
      while (0 < O);
    }
    function P(u, h, w, O, B) {
      if (t(2328 >= B), 512 >= B) var V = a(512);
      else if ((V = a(B)) == null) return 0;
      return function(W, Q, Y, Z, ge, Ce) {
        var Oe, Ne, qe = Q, ke = 1 << Y, ye = a(16), we = a(16);
        for (t(ge != 0), t(Z != null), t(W != null), t(0 < Y), Ne = 0; Ne < ge; ++Ne) {
          if (15 < Z[Ne]) return 0;
          ++ye[Z[Ne]];
        }
        if (ye[0] == ge) return 0;
        for (we[1] = 0, Oe = 1; 15 > Oe; ++Oe) {
          if (ye[Oe] > 1 << Oe) return 0;
          we[Oe + 1] = we[Oe] + ye[Oe];
        }
        for (Ne = 0; Ne < ge; ++Ne) Oe = Z[Ne], 0 < Z[Ne] && (Ce[we[Oe]++] = Ne);
        if (we[15] == 1) return (Z = new L()).g = 0, Z.value = Ce[0], D(W, qe, 1, ke, Z), ke;
        var Be, Ve = -1, ze = ke - 1, st = 0, Ae = 1, bt = 1, tt = 1 << Y;
        for (Ne = 0, Oe = 1, ge = 2; Oe <= Y; ++Oe, ge <<= 1) {
          if (Ae += bt <<= 1, 0 > (bt -= ye[Oe])) return 0;
          for (; 0 < ye[Oe]; --ye[Oe]) (Z = new L()).g = Oe, Z.value = Ce[Ne++], D(W, qe + st, ge, tt, Z), st = C(st, Oe);
        }
        for (Oe = Y + 1, ge = 2; 15 >= Oe; ++Oe, ge <<= 1) {
          if (Ae += bt <<= 1, 0 > (bt -= ye[Oe])) return 0;
          for (; 0 < ye[Oe]; --ye[Oe]) {
            if (Z = new L(), (st & ze) != Ve) {
              for (qe += tt, Be = 1 << (Ve = Oe) - Y; 15 > Ve && !(0 >= (Be -= ye[Ve])); ) ++Ve, Be <<= 1;
              ke += tt = 1 << (Be = Ve - Y), W[Q + (Ve = st & ze)].g = Be + Y, W[Q + Ve].value = qe - Q - Ve;
            }
            Z.g = Oe - Y, Z.value = Ce[Ne++], D(W, qe + (st >> Y), ge, tt, Z), st = C(st, Oe);
          }
        }
        return Ae != 2 * we[15] - 1 ? 0 : ke;
      }(u, h, w, O, B, V);
    }
    function L() {
      this.value = this.g = 0;
    }
    function H() {
      this.value = this.g = 0;
    }
    function $() {
      this.G = o(5, L), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(hr, H);
    }
    function ae(u, h, w, O) {
      t(u != null), t(h != null), t(2147483648 > O), u.Ca = 254, u.I = 0, u.b = -8, u.Ka = 0, u.oa = h, u.pa = w, u.Jd = h, u.Yc = w + O, u.Zc = 4 <= O ? w + O - 4 + 1 : w, ee(u);
    }
    function ce(u, h) {
      for (var w = 0; 0 < h--; ) w |= ne(u, 128) << h;
      return w;
    }
    function le(u, h) {
      var w = ce(u, h);
      return te(u) ? -w : w;
    }
    function oe(u, h, w, O) {
      var B, V = 0;
      for (t(u != null), t(h != null), t(4294967288 > O), u.Sb = O, u.Ra = 0, u.u = 0, u.h = 0, 4 < O && (O = 4), B = 0; B < O; ++B) V += h[w + B] << 8 * B;
      u.Ra = V, u.bb = O, u.oa = h, u.pa = w;
    }
    function se(u) {
      for (; 8 <= u.u && u.bb < u.Sb; ) u.Ra >>>= 8, u.Ra += u.oa[u.pa + u.bb] << Ws - 8 >>> 0, ++u.bb, u.u -= 8;
      G(u) && (u.h = 1, u.u = 0);
    }
    function J(u, h) {
      if (t(0 <= h), !u.h && h <= Vs) {
        var w = U(u) & qs[h];
        return u.u += h, se(u), w;
      }
      return u.h = 1, u.u = 0;
    }
    function re() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function I() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function U(u) {
      return u.Ra >>> (u.u & Ws - 1) >>> 0;
    }
    function G(u) {
      return t(u.bb <= u.Sb), u.h || u.bb == u.Sb && u.u > Ws;
    }
    function K(u, h) {
      u.u = h, u.h = G(u);
    }
    function A(u) {
      u.u >= tc && (t(u.u >= tc), se(u));
    }
    function ee(u) {
      t(u != null && u.oa != null), u.pa < u.Zc ? (u.I = (u.oa[u.pa++] | u.I << 8) >>> 0, u.b += 8) : (t(u != null && u.oa != null), u.pa < u.Yc ? (u.b += 8, u.I = u.oa[u.pa++] | u.I << 8) : u.Ka ? u.b = 0 : (u.I <<= 8, u.b += 8, u.Ka = 1));
    }
    function te(u) {
      return ce(u, 1);
    }
    function ne(u, h) {
      var w = u.Ca;
      0 > u.b && ee(u);
      var O = u.b, B = w * h >>> 8, V = (u.I >>> O > B) + 0;
      for (V ? (w -= B, u.I -= B + 1 << O >>> 0) : w = B + 1, O = w, B = 0; 256 <= O; ) B += 8, O >>= 8;
      return O = 7 ^ B + Wr[O], u.b -= O, u.Ca = (w << O) - 1, V;
    }
    function ve(u, h, w) {
      u[h + 0] = w >> 24 & 255, u[h + 1] = w >> 16 & 255, u[h + 2] = w >> 8 & 255, u[h + 3] = w >> 0 & 255;
    }
    function _e(u, h) {
      return u[h + 0] << 0 | u[h + 1] << 8;
    }
    function pe(u, h) {
      return _e(u, h) | u[h + 2] << 16;
    }
    function je(u, h) {
      return _e(u, h) | _e(u, h + 2) << 16;
    }
    function Se(u, h) {
      var w = 1 << h;
      return t(u != null), t(0 < h), u.X = a(w), u.X == null ? 0 : (u.Mb = 32 - h, u.Xa = h, 1);
    }
    function be(u, h) {
      t(u != null), t(h != null), t(u.Xa == h.Xa), r(h.X, 0, u.X, 0, 1 << h.Xa);
    }
    function X() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function Ye(u, h, w, O) {
      t(w != null), t(O != null);
      var B = w[0], V = O[0];
      return B == 0 && (B = (u * V + h / 2) / h), V == 0 && (V = (h * B + u / 2) / u), 0 >= B || 0 >= V ? 0 : (w[0] = B, O[0] = V, 1);
    }
    function Re(u, h) {
      return u + (1 << h) - 1 >>> h;
    }
    function Te(u, h) {
      return ((4278255360 & u) + (4278255360 & h) >>> 0 & 4278255360) + ((16711935 & u) + (16711935 & h) >>> 0 & 16711935) >>> 0;
    }
    function Ue(u, h) {
      x[h] = function(w, O, B, V, W, Q, Y) {
        var Z;
        for (Z = 0; Z < W; ++Z) {
          var ge = x[u](Q[Y + Z - 1], B, V + Z);
          Q[Y + Z] = Te(w[O + Z], ge);
        }
      };
    }
    function T() {
      this.ud = this.hd = this.jd = 0;
    }
    function fe(u, h) {
      return ((4278124286 & (u ^ h)) >>> 1) + (u & h) >>> 0;
    }
    function xe(u) {
      return 0 <= u && 256 > u ? u : 0 > u ? 0 : 255 < u ? 255 : void 0;
    }
    function Fe(u, h) {
      return xe(u + (u - h + 0.5 >> 1));
    }
    function Ge(u, h, w) {
      return Math.abs(h - w) - Math.abs(u - w);
    }
    function Me(u, h, w, O, B, V, W) {
      for (O = V[W - 1], w = 0; w < B; ++w) V[W + w] = O = Te(u[h + w], O);
    }
    function Ie(u, h, w, O, B) {
      var V;
      for (V = 0; V < w; ++V) {
        var W = u[h + V], Q = W >> 8 & 255, Y = 16711935 & (Y = (Y = 16711935 & W) + ((Q << 16) + Q));
        O[B + V] = (4278255360 & W) + Y >>> 0;
      }
    }
    function ct(u, h) {
      h.jd = u >> 0 & 255, h.hd = u >> 8 & 255, h.ud = u >> 16 & 255;
    }
    function at(u, h, w, O, B, V) {
      var W;
      for (W = 0; W < O; ++W) {
        var Q = h[w + W], Y = Q >>> 8, Z = Q, ge = 255 & (ge = (ge = Q >>> 16) + ((u.jd << 24 >> 24) * (Y << 24 >> 24) >>> 5));
        Z = 255 & (Z = (Z = Z + ((u.hd << 24 >> 24) * (Y << 24 >> 24) >>> 5)) + ((u.ud << 24 >> 24) * (ge << 24 >> 24) >>> 5)), B[V + W] = (4278255360 & Q) + (ge << 16) + Z;
      }
    }
    function Je(u, h, w, O, B) {
      x[h] = function(V, W, Q, Y, Z, ge, Ce, Oe, Ne) {
        for (Y = Ce; Y < Oe; ++Y) for (Ce = 0; Ce < Ne; ++Ce) Z[ge++] = B(Q[O(V[W++])]);
      }, x[u] = function(V, W, Q, Y, Z, ge, Ce) {
        var Oe = 8 >> V.b, Ne = V.Ea, qe = V.K[0], ke = V.w;
        if (8 > Oe) for (V = (1 << V.b) - 1, ke = (1 << Oe) - 1; W < Q; ++W) {
          var ye, we = 0;
          for (ye = 0; ye < Ne; ++ye) ye & V || (we = O(Y[Z++])), ge[Ce++] = B(qe[we & ke]), we >>= Oe;
        }
        else x["VP8LMapColor" + w](Y, Z, qe, ke, ge, Ce, W, Q, Ne);
      };
    }
    function $e(u, h, w, O, B) {
      for (w = h + w; h < w; ) {
        var V = u[h++];
        O[B++] = V >> 16 & 255, O[B++] = V >> 8 & 255, O[B++] = V >> 0 & 255;
      }
    }
    function _t(u, h, w, O, B) {
      for (w = h + w; h < w; ) {
        var V = u[h++];
        O[B++] = V >> 16 & 255, O[B++] = V >> 8 & 255, O[B++] = V >> 0 & 255, O[B++] = V >> 24 & 255;
      }
    }
    function dt(u, h, w, O, B) {
      for (w = h + w; h < w; ) {
        var V = (W = u[h++]) >> 16 & 240 | W >> 12 & 15, W = W >> 0 & 240 | W >> 28 & 15;
        O[B++] = V, O[B++] = W;
      }
    }
    function Ut(u, h, w, O, B) {
      for (w = h + w; h < w; ) {
        var V = (W = u[h++]) >> 16 & 248 | W >> 13 & 7, W = W >> 5 & 224 | W >> 3 & 31;
        O[B++] = V, O[B++] = W;
      }
    }
    function Le(u, h, w, O, B) {
      for (w = h + w; h < w; ) {
        var V = u[h++];
        O[B++] = V >> 0 & 255, O[B++] = V >> 8 & 255, O[B++] = V >> 16 & 255;
      }
    }
    function pt(u, h, w, O, B, V) {
      if (V == 0) for (w = h + w; h < w; ) ve(O, ((V = u[h++])[0] >> 24 | V[1] >> 8 & 65280 | V[2] << 8 & 16711680 | V[3] << 24) >>> 0), B += 32;
      else r(O, B, u, h, w);
    }
    function At(u, h) {
      x[h][0] = x[u + "0"], x[h][1] = x[u + "1"], x[h][2] = x[u + "2"], x[h][3] = x[u + "3"], x[h][4] = x[u + "4"], x[h][5] = x[u + "5"], x[h][6] = x[u + "6"], x[h][7] = x[u + "7"], x[h][8] = x[u + "8"], x[h][9] = x[u + "9"], x[h][10] = x[u + "10"], x[h][11] = x[u + "11"], x[h][12] = x[u + "12"], x[h][13] = x[u + "13"], x[h][14] = x[u + "0"], x[h][15] = x[u + "0"];
    }
    function Ot(u) {
      return u == Vp || u == Wp || u == gd || u == Hp;
    }
    function Fn() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function It() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function In() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new Fn(), this.f.kb = new It(), this.sd = null;
    }
    function Cn() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function Gt() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function mt(u) {
      return alert("todo:WebPSamplerProcessPlane"), u.T;
    }
    function ut(u, h) {
      var w = u.T, O = h.ba.f.RGBA, B = O.eb, V = O.fb + u.ka * O.A, W = xi[h.ba.S], Q = u.y, Y = u.O, Z = u.f, ge = u.N, Ce = u.ea, Oe = u.W, Ne = h.cc, qe = h.dc, ke = h.Mc, ye = h.Nc, we = u.ka, Be = u.ka + u.T, Ve = u.U, ze = Ve + 1 >> 1;
      for (we == 0 ? W(Q, Y, null, null, Z, ge, Ce, Oe, Z, ge, Ce, Oe, B, V, null, null, Ve) : (W(h.ec, h.fc, Q, Y, Ne, qe, ke, ye, Z, ge, Ce, Oe, B, V - O.A, B, V, Ve), ++w); we + 2 < Be; we += 2) Ne = Z, qe = ge, ke = Ce, ye = Oe, ge += u.Rc, Oe += u.Rc, V += 2 * O.A, W(Q, (Y += 2 * u.fa) - u.fa, Q, Y, Ne, qe, ke, ye, Z, ge, Ce, Oe, B, V - O.A, B, V, Ve);
      return Y += u.fa, u.j + Be < u.o ? (r(h.ec, h.fc, Q, Y, Ve), r(h.cc, h.dc, Z, ge, ze), r(h.Mc, h.Nc, Ce, Oe, ze), w--) : 1 & Be || W(Q, Y, null, null, Z, ge, Ce, Oe, Z, ge, Ce, Oe, B, V + O.A, null, null, Ve), w;
    }
    function rn(u, h, w) {
      var O = u.F, B = [u.J];
      if (O != null) {
        var V = u.U, W = h.ba.S, Q = W == md || W == gd;
        h = h.ba.f.RGBA;
        var Y = [0], Z = u.ka;
        Y[0] = u.T, u.Kb && (Z == 0 ? --Y[0] : (--Z, B[0] -= u.width), u.j + u.ka + u.T == u.o && (Y[0] = u.o - u.j - Z));
        var ge = h.eb;
        Z = h.fb + Z * h.A, u = bn(O, B[0], u.width, V, Y, ge, Z + (Q ? 0 : 3), h.A), t(w == Y), u && Ot(W) && bi(ge, Z, Q, V, Y, h.A);
      }
      return 0;
    }
    function _n(u) {
      var h = u.ma, w = h.ba.S, O = 11 > w, B = w == pd || w == hd || w == md || w == qp || w == 12 || Ot(w);
      if (h.memory = null, h.Ib = null, h.Jb = null, h.Nd = null, !Al(h.Oa, u, B ? 11 : 12)) return 0;
      if (B && Ot(w) && He(), u.da) alert("todo:use_scaling");
      else {
        if (O) {
          if (h.Ib = mt, u.Kb) {
            if (w = u.U + 1 >> 1, h.memory = a(u.U + 2 * w), h.memory == null) return 0;
            h.ec = h.memory, h.fc = 0, h.cc = h.ec, h.dc = h.fc + u.U, h.Mc = h.cc, h.Nc = h.dc + w, h.Ib = ut, He();
          }
        } else alert("todo:EmitYUV");
        B && (h.Jb = rn, O && Ee());
      }
      if (O && !q1) {
        for (u = 0; 256 > u; ++u) Qx[u] = 89858 * (u - 128) + vd >> yd, Xx[u] = -22014 * (u - 128) + vd, Kx[u] = -45773 * (u - 128), Yx[u] = 113618 * (u - 128) + vd >> yd;
        for (u = lc; u < Qp; ++u) h = 76283 * (u - 16) + vd >> yd, Zx[u - lc] = mi(h, 255), Jx[u - lc] = mi(h + 8 >> 4, 15);
        q1 = 1;
      }
      return 1;
    }
    function Mn(u) {
      var h = u.ma, w = u.U, O = u.T;
      return t(!(1 & u.ka)), 0 >= w || 0 >= O ? 0 : (w = h.Ib(u, h), h.Jb != null && h.Jb(u, h, w), h.Dc += w, 1);
    }
    function er(u) {
      u.ma.memory = null;
    }
    function ht(u, h, w, O) {
      return J(u, 8) != 47 ? 0 : (h[0] = J(u, 14) + 1, w[0] = J(u, 14) + 1, O[0] = J(u, 1), J(u, 3) != 0 ? 0 : !u.h);
    }
    function rr(u, h) {
      if (4 > u) return u + 1;
      var w = u - 2 >> 1;
      return (2 + (1 & u) << w) + J(h, w) + 1;
    }
    function ir(u, h) {
      return 120 < h ? h - 120 : 1 <= (w = ((w = Ix[h - 1]) >> 4) * u + (8 - (15 & w))) ? w : 1;
      var w;
    }
    function yn(u, h, w) {
      var O = U(w), B = u[h += 255 & O].g - 8;
      return 0 < B && (K(w, w.u + 8), O = U(w), h += u[h].value, h += O & (1 << B) - 1), K(w, w.u + u[h].g), u[h].value;
    }
    function Qt(u, h, w) {
      return w.g += u.g, w.value += u.value << h >>> 0, t(8 >= w.g), u.g;
    }
    function en(u, h, w) {
      var O = u.xc;
      return t((h = O == 0 ? 0 : u.vc[u.md * (w >> O) + (h >> O)]) < u.Wb), u.Ya[h];
    }
    function jn(u, h, w, O) {
      var B = u.ab, V = u.c * h, W = u.C;
      h = W + h;
      var Q = w, Y = O;
      for (O = u.Ta, w = u.Ua; 0 < B--; ) {
        var Z = u.gc[B], ge = W, Ce = h, Oe = Q, Ne = Y, qe = (Y = O, Q = w, Z.Ea);
        switch (t(ge < Ce), t(Ce <= Z.nc), Z.hc) {
          case 2:
            od(Oe, Ne, (Ce - ge) * qe, Y, Q);
            break;
          case 0:
            var ke = ge, ye = Ce, we = Y, Be = Q, Ve = (tt = Z).Ea;
            ke == 0 && (Bp(Oe, Ne, null, null, 1, we, Be), Me(Oe, Ne + 1, 0, 0, Ve - 1, we, Be + 1), Ne += Ve, Be += Ve, ++ke);
            for (var ze = 1 << tt.b, st = ze - 1, Ae = Re(Ve, tt.b), bt = tt.K, tt = tt.w + (ke >> tt.b) * Ae; ke < ye; ) {
              var Xt = bt, an = tt, Ht = 1;
              for (nc(Oe, Ne, we, Be - Ve, 1, we, Be); Ht < Ve; ) {
                var zt = (Ht & ~st) + ze;
                zt > Ve && (zt = Ve), (0, Ga[Xt[an++] >> 8 & 15])(Oe, Ne + +Ht, we, Be + Ht - Ve, zt - Ht, we, Be + Ht), Ht = zt;
              }
              Ne += Ve, Be += Ve, ++ke & st || (tt += Ae);
            }
            Ce != Z.nc && r(Y, Q - qe, Y, Q + (Ce - ge - 1) * qe, qe);
            break;
          case 1:
            for (qe = Oe, ye = Ne, Ve = (Oe = Z.Ea) - (Be = Oe & ~(we = (Ne = 1 << Z.b) - 1)), ke = Re(Oe, Z.b), ze = Z.K, Z = Z.w + (ge >> Z.b) * ke; ge < Ce; ) {
              for (st = ze, Ae = Z, bt = new T(), tt = ye + Be, Xt = ye + Oe; ye < tt; ) ct(st[Ae++], bt), Yo(bt, qe, ye, Ne, Y, Q), ye += Ne, Q += Ne;
              ye < Xt && (ct(st[Ae++], bt), Yo(bt, qe, ye, Ve, Y, Q), ye += Ve, Q += Ve), ++ge & we || (Z += ke);
            }
            break;
          case 3:
            if (Oe == Y && Ne == Q && 0 < Z.b) {
              for (ye = Y, Oe = qe = Q + (Ce - ge) * qe - (Be = (Ce - ge) * Re(Z.Ea, Z.b)), Ne = Y, we = Q, ke = [], Be = (Ve = Be) - 1; 0 <= Be; --Be) ke[Be] = Ne[we + Be];
              for (Be = Ve - 1; 0 <= Be; --Be) ye[Oe + Be] = ke[Be];
              gi(Z, ge, Ce, Y, qe, Y, Q);
            } else gi(Z, ge, Ce, Oe, Ne, Y, Q);
        }
        Q = O, Y = w;
      }
      Y != w && r(O, w, Q, Y, V);
    }
    function Xi(u, h) {
      var w = u.V, O = u.Ba + u.c * u.C, B = h - u.C;
      if (t(h <= u.l.o), t(16 >= B), 0 < B) {
        var V = u.l, W = u.Ta, Q = u.Ua, Y = V.width;
        if (jn(u, B, w, O), B = Q = [Q], t((w = u.C) < (O = h)), t(V.v < V.va), O > V.o && (O = V.o), w < V.j) {
          var Z = V.j - w;
          w = V.j, B[0] += Z * Y;
        }
        if (w >= O ? w = 0 : (B[0] += 4 * V.v, V.ka = w - V.j, V.U = V.va - V.v, V.T = O - w, w = 1), w) {
          if (Q = Q[0], 11 > (w = u.ca).S) {
            var ge = w.f.RGBA, Ce = (O = w.S, B = V.U, V = V.T, Z = ge.eb, ge.A), Oe = V;
            for (ge = ge.fb + u.Ma * ge.A; 0 < Oe--; ) {
              var Ne = W, qe = Q, ke = B, ye = Z, we = ge;
              switch (O) {
                case fd:
                  Hr(Ne, qe, ke, ye, we);
                  break;
                case pd:
                  Pr(Ne, qe, ke, ye, we);
                  break;
                case Vp:
                  Pr(Ne, qe, ke, ye, we), bi(ye, we, 0, ke, 1, 0);
                  break;
                case F1:
                  xa(Ne, qe, ke, ye, we);
                  break;
                case hd:
                  pt(Ne, qe, ke, ye, we, 1);
                  break;
                case Wp:
                  pt(Ne, qe, ke, ye, we, 1), bi(ye, we, 0, ke, 1, 0);
                  break;
                case md:
                  pt(Ne, qe, ke, ye, we, 0);
                  break;
                case gd:
                  pt(Ne, qe, ke, ye, we, 0), bi(ye, we, 1, ke, 1, 0);
                  break;
                case qp:
                  Qa(Ne, qe, ke, ye, we);
                  break;
                case Hp:
                  Qa(Ne, qe, ke, ye, we), vn(ye, we, ke, 1, 0);
                  break;
                case I1:
                  wa(Ne, qe, ke, ye, we);
                  break;
                default:
                  t(0);
              }
              Q += Y, ge += Ce;
            }
            u.Ma += V;
          } else alert("todo:EmitRescaledRowsYUVA");
          t(u.Ma <= w.height);
        }
      }
      u.C = h, t(u.C <= u.i);
    }
    function pi(u) {
      var h;
      if (0 < u.ua) return 0;
      for (h = 0; h < u.Wb; ++h) {
        var w = u.Ya[h].G, O = u.Ya[h].H;
        if (0 < w[1][O[1] + 0].g || 0 < w[2][O[2] + 0].g || 0 < w[3][O[3] + 0].g) return 0;
      }
      return 1;
    }
    function Un(u, h, w, O, B, V) {
      if (u.Z != 0) {
        var W = u.qd, Q = u.rd;
        for (t(Za[u.Z] != null); h < w; ++h) Za[u.Z](W, Q, O, B, O, B, V), W = O, Q = B, B += V;
        u.qd = W, u.rd = Q;
      }
    }
    function zr(u, h) {
      var w = u.l.ma, O = w.Z == 0 || w.Z == 1 ? u.l.j : u.C;
      if (O = u.C < O ? O : u.C, t(h <= u.l.o), h > O) {
        var B = u.l.width, V = w.ca, W = w.tb + B * O, Q = u.V, Y = u.Ba + u.c * O, Z = u.gc;
        t(u.ab == 1), t(Z[0].hc == 3), sd(Z[0], O, h, Q, Y, V, W), Un(w, O, h, V, W, B);
      }
      u.C = u.Ma = h;
    }
    function qr(u, h, w, O, B, V, W) {
      var Q = u.$ / O, Y = u.$ % O, Z = u.m, ge = u.s, Ce = w + u.$, Oe = Ce;
      B = w + O * B;
      var Ne = w + O * V, qe = 280 + ge.ua, ke = u.Pb ? Q : 16777216, ye = 0 < ge.ua ? ge.Wa : null, we = ge.wc, Be = Ce < Ne ? en(ge, Y, Q) : null;
      t(u.C < V), t(Ne <= B);
      var Ve = !1;
      e: for (; ; ) {
        for (; Ve || Ce < Ne; ) {
          var ze = 0;
          if (Q >= ke) {
            var st = Ce - w;
            t((ke = u).Pb), ke.wd = ke.m, ke.xd = st, 0 < ke.s.ua && be(ke.s.Wa, ke.s.vb), ke = Q + Dx;
          }
          if (Y & we || (Be = en(ge, Y, Q)), t(Be != null), Be.Qb && (h[Ce] = Be.qb, Ve = !0), !Ve) if (A(Z), Be.jc) {
            ze = Z, st = h;
            var Ae = Ce, bt = Be.pd[U(ze) & hr - 1];
            t(Be.jc), 256 > bt.g ? (K(ze, ze.u + bt.g), st[Ae] = bt.value, ze = 0) : (K(ze, ze.u + bt.g - 256), t(256 <= bt.value), ze = bt.value), ze == 0 && (Ve = !0);
          } else ze = yn(Be.G[0], Be.H[0], Z);
          if (Z.h) break;
          if (Ve || 256 > ze) {
            if (!Ve) if (Be.nd) h[Ce] = (Be.qb | ze << 8) >>> 0;
            else {
              if (A(Z), Ve = yn(Be.G[1], Be.H[1], Z), A(Z), st = yn(Be.G[2], Be.H[2], Z), Ae = yn(Be.G[3], Be.H[3], Z), Z.h) break;
              h[Ce] = (Ae << 24 | Ve << 16 | ze << 8 | st) >>> 0;
            }
            if (Ve = !1, ++Ce, ++Y >= O && (Y = 0, ++Q, W != null && Q <= V && !(Q % 16) && W(u, Q), ye != null)) for (; Oe < Ce; ) ze = h[Oe++], ye.X[(506832829 * ze & 4294967295) >>> ye.Mb] = ze;
          } else if (280 > ze) {
            if (ze = rr(ze - 256, Z), st = yn(Be.G[4], Be.H[4], Z), A(Z), st = ir(O, st = rr(st, Z)), Z.h) break;
            if (Ce - w < st || B - Ce < ze) break e;
            for (Ae = 0; Ae < ze; ++Ae) h[Ce + Ae] = h[Ce + Ae - st];
            for (Ce += ze, Y += ze; Y >= O; ) Y -= O, ++Q, W != null && Q <= V && !(Q % 16) && W(u, Q);
            if (t(Ce <= B), Y & we && (Be = en(ge, Y, Q)), ye != null) for (; Oe < Ce; ) ze = h[Oe++], ye.X[(506832829 * ze & 4294967295) >>> ye.Mb] = ze;
          } else {
            if (!(ze < qe)) break e;
            for (Ve = ze - 280, t(ye != null); Oe < Ce; ) ze = h[Oe++], ye.X[(506832829 * ze & 4294967295) >>> ye.Mb] = ze;
            ze = Ce, t(!(Ve >>> (st = ye).Xa)), h[ze] = st.X[Ve], Ve = !0;
          }
          Ve || t(Z.h == G(Z));
        }
        if (u.Pb && Z.h && Ce < B) t(u.m.h), u.a = 5, u.m = u.wd, u.$ = u.xd, 0 < u.s.ua && be(u.s.vb, u.s.Wa);
        else {
          if (Z.h) break e;
          W != null && W(u, Q > V ? V : Q), u.a = 0, u.$ = Ce - w;
        }
        return 1;
      }
      return u.a = 3, 0;
    }
    function ei(u) {
      t(u != null), u.vc = null, u.yc = null, u.Ya = null;
      var h = u.Wa;
      h != null && (h.X = null), u.vb = null, t(u != null);
    }
    function jr() {
      var u = new Up();
      return u == null ? null : (u.a = 0, u.xb = R1, At("Predictor", "VP8LPredictors"), At("Predictor", "VP8LPredictors_C"), At("PredictorAdd", "VP8LPredictorsAdd"), At("PredictorAdd", "VP8LPredictorsAdd_C"), od = Ie, Yo = at, Hr = $e, Pr = _t, Qa = dt, wa = Ut, xa = Le, x.VP8LMapColor32b = Hs, x.VP8LMapColor8b = ld, u);
    }
    function hi(u, h, w, O, B) {
      var V = 1, W = [u], Q = [h], Y = O.m, Z = O.s, ge = null, Ce = 0;
      e: for (; ; ) {
        if (w) for (; V && J(Y, 1); ) {
          var Oe = W, Ne = Q, qe = O, ke = 1, ye = qe.m, we = qe.gc[qe.ab], Be = J(ye, 2);
          if (qe.Oc & 1 << Be) V = 0;
          else {
            switch (qe.Oc |= 1 << Be, we.hc = Be, we.Ea = Oe[0], we.nc = Ne[0], we.K = [null], ++qe.ab, t(4 >= qe.ab), Be) {
              case 0:
              case 1:
                we.b = J(ye, 3) + 2, ke = hi(Re(we.Ea, we.b), Re(we.nc, we.b), 0, qe, we.K), we.K = we.K[0];
                break;
              case 3:
                var Ve, ze = J(ye, 8) + 1, st = 16 < ze ? 0 : 4 < ze ? 1 : 2 < ze ? 2 : 3;
                if (Oe[0] = Re(we.Ea, st), we.b = st, Ve = ke = hi(ze, 1, 0, qe, we.K)) {
                  var Ae, bt = ze, tt = we, Xt = 1 << (8 >> tt.b), an = a(Xt);
                  if (an == null) Ve = 0;
                  else {
                    var Ht = tt.K[0], zt = tt.w;
                    for (an[0] = tt.K[0][0], Ae = 1; Ae < 1 * bt; ++Ae) an[Ae] = Te(Ht[zt + Ae], an[Ae - 1]);
                    for (; Ae < 4 * Xt; ++Ae) an[Ae] = 0;
                    tt.K[0] = null, tt.K[0] = an, Ve = 1;
                  }
                }
                ke = Ve;
                break;
              case 2:
                break;
              default:
                t(0);
            }
            V = ke;
          }
        }
        if (W = W[0], Q = Q[0], V && J(Y, 1) && !(V = 1 <= (Ce = J(Y, 4)) && 11 >= Ce)) {
          O.a = 3;
          break e;
        }
        var pn;
        if (pn = V) t: {
          var dn, Pt, Zn, $r = O, Jn = W, Gr = Q, on = Ce, ri = w, ii = $r.m, or = $r.s, mr = [null], Tr = 1, _i = 0, ea = kx[on];
          n: for (; ; ) {
            if (ri && J(ii, 1)) {
              var sr = J(ii, 3) + 2, Ea = Re(Jn, sr), Ao = Re(Gr, sr), Ks = Ea * Ao;
              if (!hi(Ea, Ao, 0, $r, mr)) break n;
              for (mr = mr[0], or.xc = sr, dn = 0; dn < Ks; ++dn) {
                var Ja = mr[dn] >> 8 & 65535;
                mr[dn] = Ja, Ja >= Tr && (Tr = Ja + 1);
              }
            }
            if (ii.h) break n;
            for (Pt = 0; 5 > Pt; ++Pt) {
              var kn = k1[Pt];
              !Pt && 0 < on && (kn += 1 << on), _i < kn && (_i = kn);
            }
            var Yp = o(Tr * ea, L), H1 = Tr, $1 = o(H1, $);
            if ($1 == null) var wd = null;
            else t(65536 >= H1), wd = $1;
            var cc = a(_i);
            if (wd == null || cc == null || Yp == null) {
              $r.a = 1;
              break n;
            }
            var xd = Yp;
            for (dn = Zn = 0; dn < Tr; ++dn) {
              var Ui = wd[dn], Xs = Ui.G, Zs = Ui.H, G1 = 0, _d = 1, Q1 = 0;
              for (Pt = 0; 5 > Pt; ++Pt) {
                kn = k1[Pt], Xs[Pt] = xd, Zs[Pt] = Zn, !Pt && 0 < on && (kn += 1 << on);
                i: {
                  var Nd, Kp = kn, Sd = $r, uc = cc, t_ = xd, n_ = Zn, Xp = 0, Aa = Sd.m, r_ = J(Aa, 1);
                  if (i(uc, 0, 0, Kp), r_) {
                    var i_ = J(Aa, 1) + 1, a_ = J(Aa, 1), Y1 = J(Aa, a_ == 0 ? 1 : 8);
                    uc[Y1] = 1, i_ == 2 && (uc[Y1 = J(Aa, 8)] = 1);
                    var Ed = 1;
                  } else {
                    var K1 = a(19), X1 = J(Aa, 4) + 4;
                    if (19 < X1) {
                      Sd.a = 3;
                      var Cd = 0;
                      break i;
                    }
                    for (Nd = 0; Nd < X1; ++Nd) K1[Fx[Nd]] = J(Aa, 3);
                    var Zp = void 0, dc = void 0, Z1 = Sd, o_ = K1, Od = Kp, J1 = uc, Jp = 0, eo = Z1.m, A1 = 8, e2 = o(128, L);
                    r: for (; P(e2, 0, 7, o_, 19); ) {
                      if (J(eo, 1)) {
                        var s_ = 2 + 2 * J(eo, 3);
                        if ((Zp = 2 + J(eo, s_)) > Od) break r;
                      } else Zp = Od;
                      for (dc = 0; dc < Od && Zp--; ) {
                        A(eo);
                        var t2 = e2[0 + (127 & U(eo))];
                        K(eo, eo.u + t2.g);
                        var Js = t2.value;
                        if (16 > Js) J1[dc++] = Js, Js != 0 && (A1 = Js);
                        else {
                          var l_ = Js == 16, n2 = Js - 16, c_ = Lx[n2], r2 = J(eo, Px[n2]) + c_;
                          if (dc + r2 > Od) break r;
                          for (var u_ = l_ ? A1 : 0; 0 < r2--; ) J1[dc++] = u_;
                        }
                      }
                      Jp = 1;
                      break r;
                    }
                    Jp || (Z1.a = 3), Ed = Jp;
                  }
                  (Ed = Ed && !Aa.h) && (Xp = P(t_, n_, 8, uc, Kp)), Ed && Xp != 0 ? Cd = Xp : (Sd.a = 3, Cd = 0);
                }
                if (Cd == 0) break n;
                if (_d && Tx[Pt] == 1 && (_d = xd[Zn].g == 0), G1 += xd[Zn].g, Zn += Cd, 3 >= Pt) {
                  var fc, Ap = cc[0];
                  for (fc = 1; fc < kn; ++fc) cc[fc] > Ap && (Ap = cc[fc]);
                  Q1 += Ap;
                }
              }
              if (Ui.nd = _d, Ui.Qb = 0, _d && (Ui.qb = (Xs[3][Zs[3] + 0].value << 24 | Xs[1][Zs[1] + 0].value << 16 | Xs[2][Zs[2] + 0].value) >>> 0, G1 == 0 && 256 > Xs[0][Zs[0] + 0].value && (Ui.Qb = 1, Ui.qb += Xs[0][Zs[0] + 0].value << 8)), Ui.jc = !Ui.Qb && 6 > Q1, Ui.jc) {
                var jd, Ca = Ui;
                for (jd = 0; jd < hr; ++jd) {
                  var to = jd, no = Ca.pd[to], Pd = Ca.G[0][Ca.H[0] + to];
                  256 <= Pd.value ? (no.g = Pd.g + 256, no.value = Pd.value) : (no.g = 0, no.value = 0, to >>= Qt(Pd, 8, no), to >>= Qt(Ca.G[1][Ca.H[1] + to], 16, no), to >>= Qt(Ca.G[2][Ca.H[2] + to], 0, no), Qt(Ca.G[3][Ca.H[3] + to], 24, no));
                }
              }
            }
            or.vc = mr, or.Wb = Tr, or.Ya = wd, or.yc = Yp, pn = 1;
            break t;
          }
          pn = 0;
        }
        if (!(V = pn)) {
          O.a = 3;
          break e;
        }
        if (0 < Ce) {
          if (Z.ua = 1 << Ce, !Se(Z.Wa, Ce)) {
            O.a = 1, V = 0;
            break e;
          }
        } else Z.ua = 0;
        var eh = O, i2 = W, d_ = Q, th = eh.s, nh = th.xc;
        if (eh.c = i2, eh.i = d_, th.md = Re(i2, nh), th.wc = nh == 0 ? -1 : (1 << nh) - 1, w) {
          O.xb = Vx;
          break e;
        }
        if ((ge = a(W * Q)) == null) {
          O.a = 1, V = 0;
          break e;
        }
        V = (V = qr(O, ge, 0, W, Q, Q, null)) && !Y.h;
        break e;
      }
      return V ? (B != null ? B[0] = ge : (t(ge == null), t(w)), O.$ = 0, w || ei(Z)) : ei(Z), V;
    }
    function de(u, h) {
      var w = u.c * u.i, O = w + h + 16 * h;
      return t(u.c <= h), u.V = a(O), u.V == null ? (u.Ta = null, u.Ua = 0, u.a = 1, 0) : (u.Ta = u.V, u.Ua = u.Ba + w + h, 1);
    }
    function it(u, h) {
      var w = u.C, O = h - w, B = u.V, V = u.Ba + u.c * w;
      for (t(h <= u.l.o); 0 < O; ) {
        var W = 16 < O ? 16 : O, Q = u.l.ma, Y = u.l.width, Z = Y * W, ge = Q.ca, Ce = Q.tb + Y * w, Oe = u.Ta, Ne = u.Ua;
        jn(u, W, B, V), Vn(Oe, Ne, ge, Ce, Z), Un(Q, w, w + W, ge, Ce, Y), O -= W, B += W * u.c, w += W;
      }
      t(w == h), u.C = u.Ma = h;
    }
    function Xe() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Bt() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function On() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
    }
    function Nn() {
      this.Yb = function() {
        var u = [];
        return function h(w, O, B) {
          for (var V = B[O], W = 0; W < V && (w.push(B.length > O + 1 ? [] : 0), !(B.length < O + 1)); W++) h(w[W], O + 1, B);
        }(u, 0, [3, 11]), u;
      }();
    }
    function ti() {
      this.jb = a(3), this.Wc = s([4, 8], Nn), this.Xc = s([4, 17], Nn);
    }
    function br() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
    }
    function pr() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function Kn() {
      this.Na = this.la = 0;
    }
    function Ps() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function Wo() {
      this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function vp() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new pr()), this.Y = 0, this.ya = Array(new Wo()), this.aa = 0, this.l = new Ls();
    }
    function Vu() {
      this.y = a(16), this.f = a(8), this.ea = a(8);
    }
    function bp() {
      this.cb = this.a = 0, this.sc = "", this.m = new re(), this.Od = new Xe(), this.Kc = new Bt(), this.ed = new br(), this.Qa = new On(), this.Ic = this.$c = this.Aa = 0, this.D = new vp(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, re), this.ia = 0, this.pb = o(4, Ps), this.Pa = new ti(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Vu()), this.Hd = 0, this.rb = Array(new Kn()), this.sb = 0, this.wa = Array(new pr()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Wo()), this.L = this.aa = 0, this.gd = s([4, 2], pr), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function Ls() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function wp() {
      var u = new bp();
      return u != null && (u.a = 0, u.sc = "OK", u.cb = 0, u.Xb = 0, sc || (sc = $u)), u;
    }
    function Bn(u, h, w) {
      return u.a == 0 && (u.a = h, u.sc = w, u.cb = 0), 0;
    }
    function Wu(u, h, w) {
      return 3 <= w && u[h + 0] == 157 && u[h + 1] == 1 && u[h + 2] == 42;
    }
    function Hu(u, h) {
      if (u == null) return 0;
      if (u.a = 0, u.sc = "OK", h == null) return Bn(u, 2, "null VP8Io passed to VP8GetHeaders()");
      var w = h.data, O = h.w, B = h.ha;
      if (4 > B) return Bn(u, 7, "Truncated header.");
      var V = w[O + 0] | w[O + 1] << 8 | w[O + 2] << 16, W = u.Od;
      if (W.Rb = !(1 & V), W.td = V >> 1 & 7, W.yd = V >> 4 & 1, W.ub = V >> 5, 3 < W.td) return Bn(u, 3, "Incorrect keyframe parameters.");
      if (!W.yd) return Bn(u, 4, "Frame not displayable.");
      O += 3, B -= 3;
      var Q = u.Kc;
      if (W.Rb) {
        if (7 > B) return Bn(u, 7, "cannot parse picture header");
        if (!Wu(w, O, B)) return Bn(u, 3, "Bad code word");
        Q.c = 16383 & (w[O + 4] << 8 | w[O + 3]), Q.Td = w[O + 4] >> 6, Q.i = 16383 & (w[O + 6] << 8 | w[O + 5]), Q.Ud = w[O + 6] >> 6, O += 7, B -= 7, u.za = Q.c + 15 >> 4, u.Ub = Q.i + 15 >> 4, h.width = Q.c, h.height = Q.i, h.Da = 0, h.j = 0, h.v = 0, h.va = h.width, h.o = h.height, h.da = 0, h.ib = h.width, h.hb = h.height, h.U = h.width, h.T = h.height, i((V = u.Pa).jb, 0, 255, V.jb.length), t((V = u.Qa) != null), V.Cb = 0, V.Bb = 0, V.Fb = 1, i(V.Zb, 0, 0, V.Zb.length), i(V.Lb, 0, 0, V.Lb);
      }
      if (W.ub > B) return Bn(u, 7, "bad partition length");
      ae(V = u.m, w, O, W.ub), O += W.ub, B -= W.ub, W.Rb && (Q.Ld = te(V), Q.Kd = te(V)), Q = u.Qa;
      var Y, Z = u.Pa;
      if (t(V != null), t(Q != null), Q.Cb = te(V), Q.Cb) {
        if (Q.Bb = te(V), te(V)) {
          for (Q.Fb = te(V), Y = 0; 4 > Y; ++Y) Q.Zb[Y] = te(V) ? le(V, 7) : 0;
          for (Y = 0; 4 > Y; ++Y) Q.Lb[Y] = te(V) ? le(V, 6) : 0;
        }
        if (Q.Bb) for (Y = 0; 3 > Y; ++Y) Z.jb[Y] = te(V) ? ce(V, 8) : 255;
      } else Q.Bb = 0;
      if (V.Ka) return Bn(u, 3, "cannot parse segment header");
      if ((Q = u.ed).zd = te(V), Q.Tb = ce(V, 6), Q.wb = ce(V, 3), Q.Pc = te(V), Q.Pc && te(V)) {
        for (Z = 0; 4 > Z; ++Z) te(V) && (Q.vd[Z] = le(V, 6));
        for (Z = 0; 4 > Z; ++Z) te(V) && (Q.od[Z] = le(V, 6));
      }
      if (u.L = Q.Tb == 0 ? 0 : Q.zd ? 1 : 2, V.Ka) return Bn(u, 3, "cannot parse filter header");
      var ge = B;
      if (B = Y = O, O = Y + ge, Q = ge, u.Xb = (1 << ce(u.m, 2)) - 1, ge < 3 * (Z = u.Xb)) w = 7;
      else {
        for (Y += 3 * Z, Q -= 3 * Z, ge = 0; ge < Z; ++ge) {
          var Ce = w[B + 0] | w[B + 1] << 8 | w[B + 2] << 16;
          Ce > Q && (Ce = Q), ae(u.Jc[+ge], w, Y, Ce), Y += Ce, Q -= Ce, B += 3;
        }
        ae(u.Jc[+Z], w, Y, Q), w = Y < O ? 0 : 5;
      }
      if (w != 0) return Bn(u, w, "cannot parse partitions");
      for (w = ce(Y = u.m, 7), B = te(Y) ? le(Y, 4) : 0, O = te(Y) ? le(Y, 4) : 0, Q = te(Y) ? le(Y, 4) : 0, Z = te(Y) ? le(Y, 4) : 0, Y = te(Y) ? le(Y, 4) : 0, ge = u.Qa, Ce = 0; 4 > Ce; ++Ce) {
        if (ge.Cb) {
          var Oe = ge.Zb[Ce];
          ge.Fb || (Oe += w);
        } else {
          if (0 < Ce) {
            u.pb[Ce] = u.pb[0];
            continue;
          }
          Oe = w;
        }
        var Ne = u.pb[Ce];
        Ne.Sc[0] = $p[mi(Oe + B, 127)], Ne.Sc[1] = Gp[mi(Oe + 0, 127)], Ne.Eb[0] = 2 * $p[mi(Oe + O, 127)], Ne.Eb[1] = 101581 * Gp[mi(Oe + Q, 127)] >> 16, 8 > Ne.Eb[1] && (Ne.Eb[1] = 8), Ne.Qc[0] = $p[mi(Oe + Z, 117)], Ne.Qc[1] = Gp[mi(Oe + Y, 127)], Ne.lc = Oe + Y;
      }
      if (!W.Rb) return Bn(u, 4, "Not a key frame.");
      for (te(V), W = u.Pa, w = 0; 4 > w; ++w) {
        for (B = 0; 8 > B; ++B) for (O = 0; 3 > O; ++O) for (Q = 0; 11 > Q; ++Q) Z = ne(V, zx[w][B][O][Q]) ? ce(V, 8) : Ux[w][B][O][Q], W.Wc[w][B].Yb[O][Q] = Z;
        for (B = 0; 17 > B; ++B) W.Xc[w][B] = W.Wc[w][qx[B]];
      }
      return u.kc = te(V), u.kc && (u.Bd = ce(V, 8)), u.cb = 1;
    }
    function $u(u, h, w, O, B, V, W) {
      var Q = h[B].Yb[w];
      for (w = 0; 16 > B; ++B) {
        if (!ne(u, Q[w + 0])) return B;
        for (; !ne(u, Q[w + 1]); ) if (Q = h[++B].Yb[0], w = 0, B == 16) return 16;
        var Y = h[B + 1].Yb;
        if (ne(u, Q[w + 2])) {
          var Z = u, ge = 0;
          if (ne(Z, (Oe = Q)[(Ce = w) + 3])) if (ne(Z, Oe[Ce + 6])) {
            for (Q = 0, Ce = 2 * (ge = ne(Z, Oe[Ce + 8])) + (Oe = ne(Z, Oe[Ce + 9 + ge])), ge = 0, Oe = Rx[Ce]; Oe[Q]; ++Q) ge += ge + ne(Z, Oe[Q]);
            ge += 3 + (8 << Ce);
          } else ne(Z, Oe[Ce + 7]) ? (ge = 7 + 2 * ne(Z, 165), ge += ne(Z, 145)) : ge = 5 + ne(Z, 159);
          else ge = ne(Z, Oe[Ce + 4]) ? 3 + ne(Z, Oe[Ce + 5]) : 2;
          Q = Y[2];
        } else ge = 1, Q = Y[1];
        Y = W + Mx[B], 0 > (Z = u).b && ee(Z);
        var Ce, Oe = Z.b, Ne = (Ce = Z.Ca >> 1) - (Z.I >> Oe) >> 31;
        --Z.b, Z.Ca += Ne, Z.Ca |= 1, Z.I -= (Ce + 1 & Ne) << Oe, V[Y] = ((ge ^ Ne) - Ne) * O[(0 < B) + 0];
      }
      return 16;
    }
    function Ul(u) {
      var h = u.rb[u.sb - 1];
      h.la = 0, h.Na = 0, i(u.zc, 0, 0, u.zc.length), u.ja = 0;
    }
    function xp(u, h) {
      if (u == null) return 0;
      if (h == null) return Bn(u, 2, "NULL VP8Io parameter in VP8Decode().");
      if (!u.cb && !Hu(u, h)) return 0;
      if (t(u.cb), h.ac == null || h.ac(h)) {
        h.ob && (u.L = 0);
        var w = bd[u.L];
        if (u.L == 2 ? (u.yb = 0, u.zb = 0) : (u.yb = h.v - w >> 4, u.zb = h.j - w >> 4, 0 > u.yb && (u.yb = 0), 0 > u.zb && (u.zb = 0)), u.Va = h.o + 15 + w >> 4, u.Hb = h.va + 15 + w >> 4, u.Hb > u.za && (u.Hb = u.za), u.Va > u.Ub && (u.Va = u.Ub), 0 < u.L) {
          var O = u.ed;
          for (w = 0; 4 > w; ++w) {
            var B;
            if (u.Qa.Cb) {
              var V = u.Qa.Lb[w];
              u.Qa.Fb || (V += O.Tb);
            } else V = O.Tb;
            for (B = 0; 1 >= B; ++B) {
              var W = u.gd[w][B], Q = V;
              if (O.Pc && (Q += O.vd[0], B && (Q += O.od[0])), 0 < (Q = 0 > Q ? 0 : 63 < Q ? 63 : Q)) {
                var Y = Q;
                0 < O.wb && (Y = 4 < O.wb ? Y >> 2 : Y >> 1) > 9 - O.wb && (Y = 9 - O.wb), 1 > Y && (Y = 1), W.dd = Y, W.tc = 2 * Q + Y, W.ld = 40 <= Q ? 2 : 15 <= Q ? 1 : 0;
              } else W.tc = 0;
              W.La = B;
            }
          }
        }
        w = 0;
      } else Bn(u, 6, "Frame setup failed"), w = u.a;
      if (w = w == 0) {
        if (w) {
          u.$c = 0, 0 < u.Aa || (u.Ic = e_);
          e: {
            w = u.Ic, O = 4 * (Y = u.za);
            var Z = 32 * Y, ge = Y + 1, Ce = 0 < u.L ? Y * (0 < u.Aa ? 2 : 1) : 0, Oe = (u.Aa == 2 ? 2 : 1) * Y;
            if ((W = O + 832 + (B = 3 * (16 * w + bd[u.L]) / 2 * Z) + (V = u.Fa != null && 0 < u.Fa.length ? u.Kc.c * u.Kc.i : 0)) != W) w = 0;
            else {
              if (W > u.Vb) {
                if (u.Vb = 0, u.Ec = a(W), u.Fc = 0, u.Ec == null) {
                  w = Bn(u, 1, "no memory during frame initialization.");
                  break e;
                }
                u.Vb = W;
              }
              W = u.Ec, Q = u.Fc, u.Ac = W, u.Bc = Q, Q += O, u.Gd = o(Z, Vu), u.Hd = 0, u.rb = o(ge + 1, Kn), u.sb = 1, u.wa = Ce ? o(Ce, pr) : null, u.Y = 0, u.D.Nb = 0, u.D.wa = u.wa, u.D.Y = u.Y, 0 < u.Aa && (u.D.Y += Y), t(!0), u.oc = W, u.pc = Q, Q += 832, u.ya = o(Oe, Wo), u.aa = 0, u.D.ya = u.ya, u.D.aa = u.aa, u.Aa == 2 && (u.D.aa += Y), u.R = 16 * Y, u.B = 8 * Y, Y = (Z = bd[u.L]) * u.R, Z = Z / 2 * u.B, u.sa = W, u.ta = Q + Y, u.qa = u.sa, u.ra = u.ta + 16 * w * u.R + Z, u.Ha = u.qa, u.Ia = u.ra + 8 * w * u.B + Z, u.$c = 0, Q += B, u.mb = V ? W : null, u.nb = V ? Q : null, t(Q + V <= u.Fc + u.Vb), Ul(u), i(u.Ac, u.Bc, 0, O), w = 1;
            }
          }
          if (w) {
            if (h.ka = 0, h.y = u.sa, h.O = u.ta, h.f = u.qa, h.N = u.ra, h.ea = u.Ha, h.Vd = u.Ia, h.fa = u.R, h.Rc = u.B, h.F = null, h.J = 0, !ud) {
              for (w = -255; 255 >= w; ++w) tr[255 + w] = 0 > w ? -w : w;
              for (w = -1020; 1020 >= w; ++w) Na[1020 + w] = -128 > w ? -128 : 127 < w ? 127 : w;
              for (w = -112; 112 >= w; ++w) oc[112 + w] = -16 > w ? -16 : 15 < w ? 15 : w;
              for (w = -255; 510 >= w; ++w) Ys[255 + w] = 0 > w ? 0 : 255 < w ? 255 : w;
              ud = 1;
            }
            $s = Sp, _a = _p, rc = Qu, Lr = Np, yi = Yu, qn = Gu, Gs = Hl, cd = Go, ic = Mp, Ko = $l, Xo = Rp, Ya = Rs, Zo = Gl, Qs = rd, Jo = nd, Ka = Ji, ac = ba, vi = Dp, Mi[0] = Zi, Mi[1] = Ep, Mi[2] = Pp, Mi[3] = Lp, Mi[4] = Zu, Mi[5] = ks, Mi[6] = Ju, Mi[7] = ql, Mi[8] = Fp, Mi[9] = Tp, Xa[0] = Ku, Xa[1] = Op, Xa[2] = va, Xa[3] = Fs, Xa[4] = wr, Xa[5] = jp, Xa[6] = Xu, Sa[0] = Wa, Sa[1] = Cp, Sa[2] = Ip, Sa[3] = Vl, Sa[4] = $o, Sa[5] = kp, Sa[6] = Wl, w = 1;
          } else w = 0;
        }
        w && (w = function(Ne, qe) {
          for (Ne.M = 0; Ne.M < Ne.Va; ++Ne.M) {
            var ke, ye = Ne.Jc[Ne.M & Ne.Xb], we = Ne.m, Be = Ne;
            for (ke = 0; ke < Be.za; ++ke) {
              var Ve = we, ze = Be, st = ze.Ac, Ae = ze.Bc + 4 * ke, bt = ze.zc, tt = ze.ya[ze.aa + ke];
              if (ze.Qa.Bb ? tt.$b = ne(Ve, ze.Pa.jb[0]) ? 2 + ne(Ve, ze.Pa.jb[2]) : ne(Ve, ze.Pa.jb[1]) : tt.$b = 0, ze.kc && (tt.Ad = ne(Ve, ze.Bd)), tt.Za = !ne(Ve, 145) + 0, tt.Za) {
                var Xt = tt.Ob, an = 0;
                for (ze = 0; 4 > ze; ++ze) {
                  var Ht, zt = bt[0 + ze];
                  for (Ht = 0; 4 > Ht; ++Ht) {
                    zt = Bx[st[Ae + Ht]][zt];
                    for (var pn = D1[ne(Ve, zt[0])]; 0 < pn; ) pn = D1[2 * pn + ne(Ve, zt[pn])];
                    zt = -pn, st[Ae + Ht] = zt;
                  }
                  r(Xt, an, st, Ae, 4), an += 4, bt[0 + ze] = zt;
                }
              } else zt = ne(Ve, 156) ? ne(Ve, 128) ? 1 : 3 : ne(Ve, 163) ? 2 : 0, tt.Ob[0] = zt, i(st, Ae, zt, 4), i(bt, 0, zt, 4);
              tt.Dd = ne(Ve, 142) ? ne(Ve, 114) ? ne(Ve, 183) ? 1 : 3 : 2 : 0;
            }
            if (Be.m.Ka) return Bn(Ne, 7, "Premature end-of-partition0 encountered.");
            for (; Ne.ja < Ne.za; ++Ne.ja) {
              if (Be = ye, Ve = (we = Ne).rb[we.sb - 1], st = we.rb[we.sb + we.ja], ke = we.ya[we.aa + we.ja], Ae = we.kc ? ke.Ad : 0) Ve.la = st.la = 0, ke.Za || (Ve.Na = st.Na = 0), ke.Hc = 0, ke.Gc = 0, ke.ia = 0;
              else {
                var dn, Pt;
                if (Ve = st, st = Be, Ae = we.Pa.Xc, bt = we.ya[we.aa + we.ja], tt = we.pb[bt.$b], ze = bt.ad, Xt = 0, an = we.rb[we.sb - 1], zt = Ht = 0, i(ze, Xt, 0, 384), bt.Za) var Zn = 0, $r = Ae[3];
                else {
                  pn = a(16);
                  var Jn = Ve.Na + an.Na;
                  if (Jn = sc(st, Ae[1], Jn, tt.Eb, 0, pn, 0), Ve.Na = an.Na = (0 < Jn) + 0, 1 < Jn) $s(pn, 0, ze, Xt);
                  else {
                    var Gr = pn[0] + 3 >> 3;
                    for (pn = 0; 256 > pn; pn += 16) ze[Xt + pn] = Gr;
                  }
                  Zn = 1, $r = Ae[0];
                }
                var on = 15 & Ve.la, ri = 15 & an.la;
                for (pn = 0; 4 > pn; ++pn) {
                  var ii = 1 & ri;
                  for (Gr = Pt = 0; 4 > Gr; ++Gr) on = on >> 1 | (ii = (Jn = sc(st, $r, Jn = ii + (1 & on), tt.Sc, Zn, ze, Xt)) > Zn) << 7, Pt = Pt << 2 | (3 < Jn ? 3 : 1 < Jn ? 2 : ze[Xt + 0] != 0), Xt += 16;
                  on >>= 4, ri = ri >> 1 | ii << 7, Ht = (Ht << 8 | Pt) >>> 0;
                }
                for ($r = on, Zn = ri >> 4, dn = 0; 4 > dn; dn += 2) {
                  for (Pt = 0, on = Ve.la >> 4 + dn, ri = an.la >> 4 + dn, pn = 0; 2 > pn; ++pn) {
                    for (ii = 1 & ri, Gr = 0; 2 > Gr; ++Gr) Jn = ii + (1 & on), on = on >> 1 | (ii = 0 < (Jn = sc(st, Ae[2], Jn, tt.Qc, 0, ze, Xt))) << 3, Pt = Pt << 2 | (3 < Jn ? 3 : 1 < Jn ? 2 : ze[Xt + 0] != 0), Xt += 16;
                    on >>= 2, ri = ri >> 1 | ii << 5;
                  }
                  zt |= Pt << 4 * dn, $r |= on << 4 << dn, Zn |= (240 & ri) << dn;
                }
                Ve.la = $r, an.la = Zn, bt.Hc = Ht, bt.Gc = zt, bt.ia = 43690 & zt ? 0 : tt.ia, Ae = !(Ht | zt);
              }
              if (0 < we.L && (we.wa[we.Y + we.ja] = we.gd[ke.$b][ke.Za], we.wa[we.Y + we.ja].La |= !Ae), Be.Ka) return Bn(Ne, 7, "Premature end-of-file encountered.");
            }
            if (Ul(Ne), we = qe, Be = 1, ke = (ye = Ne).D, Ve = 0 < ye.L && ye.M >= ye.zb && ye.M <= ye.Va, ye.Aa == 0) e: {
              if (ke.M = ye.M, ke.uc = Ve, Jl(ye, ke), Be = 1, ke = (Pt = ye.D).Nb, Ve = (zt = bd[ye.L]) * ye.R, st = zt / 2 * ye.B, pn = 16 * ke * ye.R, Gr = 8 * ke * ye.B, Ae = ye.sa, bt = ye.ta - Ve + pn, tt = ye.qa, ze = ye.ra - st + Gr, Xt = ye.Ha, an = ye.Ia - st + Gr, ri = (on = Pt.M) == 0, Ht = on >= ye.Va - 1, ye.Aa == 2 && Jl(ye, Pt), Pt.uc) for (ii = (Jn = ye).D.M, t(Jn.D.uc), Pt = Jn.yb; Pt < Jn.Hb; ++Pt) {
                Zn = Pt, $r = ii;
                var or = (mr = (kn = Jn).D).Nb;
                dn = kn.R;
                var mr = mr.wa[mr.Y + Zn], Tr = kn.sa, _i = kn.ta + 16 * or * dn + 16 * Zn, ea = mr.dd, sr = mr.tc;
                if (sr != 0) if (t(3 <= sr), kn.L == 1) 0 < Zn && Ka(Tr, _i, dn, sr + 4), mr.La && vi(Tr, _i, dn, sr), 0 < $r && Jo(Tr, _i, dn, sr + 4), mr.La && ac(Tr, _i, dn, sr);
                else {
                  var Ea = kn.B, Ao = kn.qa, Ks = kn.ra + 8 * or * Ea + 8 * Zn, Ja = kn.Ha, kn = kn.Ia + 8 * or * Ea + 8 * Zn;
                  or = mr.ld, 0 < Zn && (cd(Tr, _i, dn, sr + 4, ea, or), Ko(Ao, Ks, Ja, kn, Ea, sr + 4, ea, or)), mr.La && (Ya(Tr, _i, dn, sr, ea, or), Qs(Ao, Ks, Ja, kn, Ea, sr, ea, or)), 0 < $r && (Gs(Tr, _i, dn, sr + 4, ea, or), ic(Ao, Ks, Ja, kn, Ea, sr + 4, ea, or)), mr.La && (Xo(Tr, _i, dn, sr, ea, or), Zo(Ao, Ks, Ja, kn, Ea, sr, ea, or));
                }
              }
              if (ye.ia && alert("todo:DitherRow"), we.put != null) {
                if (Pt = 16 * on, on = 16 * (on + 1), ri ? (we.y = ye.sa, we.O = ye.ta + pn, we.f = ye.qa, we.N = ye.ra + Gr, we.ea = ye.Ha, we.W = ye.Ia + Gr) : (Pt -= zt, we.y = Ae, we.O = bt, we.f = tt, we.N = ze, we.ea = Xt, we.W = an), Ht || (on -= zt), on > we.o && (on = we.o), we.F = null, we.J = null, ye.Fa != null && 0 < ye.Fa.length && Pt < on && (we.J = Xl(ye, we, Pt, on - Pt), we.F = ye.mb, we.F == null && we.F.length == 0)) {
                  Be = Bn(ye, 3, "Could not decode alpha data.");
                  break e;
                }
                Pt < we.j && (zt = we.j - Pt, Pt = we.j, t(!(1 & zt)), we.O += ye.R * zt, we.N += ye.B * (zt >> 1), we.W += ye.B * (zt >> 1), we.F != null && (we.J += we.width * zt)), Pt < on && (we.O += we.v, we.N += we.v >> 1, we.W += we.v >> 1, we.F != null && (we.J += we.v), we.ka = Pt - we.j, we.U = we.va - we.v, we.T = on - Pt, Be = we.put(we));
              }
              ke + 1 != ye.Ic || Ht || (r(ye.sa, ye.ta - Ve, Ae, bt + 16 * ye.R, Ve), r(ye.qa, ye.ra - st, tt, ze + 8 * ye.B, st), r(ye.Ha, ye.Ia - st, Xt, an + 8 * ye.B, st));
            }
            if (!Be) return Bn(Ne, 6, "Output aborted.");
          }
          return 1;
        }(u, h)), h.bc != null && h.bc(h), w &= 1;
      }
      return w ? (u.cb = 0, w) : 0;
    }
    function ki(u, h, w, O, B) {
      B = u[h + w + 32 * O] + (B >> 3), u[h + w + 32 * O] = -256 & B ? 0 > B ? 0 : 255 : B;
    }
    function Ts(u, h, w, O, B, V) {
      ki(u, h, 0, w, O + B), ki(u, h, 1, w, O + V), ki(u, h, 2, w, O - V), ki(u, h, 3, w, O - B);
    }
    function Vr(u) {
      return (20091 * u >> 16) + u;
    }
    function Bl(u, h, w, O) {
      var B, V = 0, W = a(16);
      for (B = 0; 4 > B; ++B) {
        var Q = u[h + 0] + u[h + 8], Y = u[h + 0] - u[h + 8], Z = (35468 * u[h + 4] >> 16) - Vr(u[h + 12]), ge = Vr(u[h + 4]) + (35468 * u[h + 12] >> 16);
        W[V + 0] = Q + ge, W[V + 1] = Y + Z, W[V + 2] = Y - Z, W[V + 3] = Q - ge, V += 4, h++;
      }
      for (B = V = 0; 4 > B; ++B) Q = (u = W[V + 0] + 4) + W[V + 8], Y = u - W[V + 8], Z = (35468 * W[V + 4] >> 16) - Vr(W[V + 12]), ki(w, O, 0, 0, Q + (ge = Vr(W[V + 4]) + (35468 * W[V + 12] >> 16))), ki(w, O, 1, 0, Y + Z), ki(w, O, 2, 0, Y - Z), ki(w, O, 3, 0, Q - ge), V++, O += 32;
    }
    function Gu(u, h, w, O) {
      var B = u[h + 0] + 4, V = 35468 * u[h + 4] >> 16, W = Vr(u[h + 4]), Q = 35468 * u[h + 1] >> 16;
      Ts(w, O, 0, B + W, u = Vr(u[h + 1]), Q), Ts(w, O, 1, B + V, u, Q), Ts(w, O, 2, B - V, u, Q), Ts(w, O, 3, B - W, u, Q);
    }
    function _p(u, h, w, O, B) {
      Bl(u, h, w, O), B && Bl(u, h + 16, w, O + 4);
    }
    function Qu(u, h, w, O) {
      _a(u, h + 0, w, O, 1), _a(u, h + 32, w, O + 128, 1);
    }
    function Np(u, h, w, O) {
      var B;
      for (u = u[h + 0] + 4, B = 0; 4 > B; ++B) for (h = 0; 4 > h; ++h) ki(w, O, h, B, u);
    }
    function Yu(u, h, w, O) {
      u[h + 0] && Lr(u, h + 0, w, O), u[h + 16] && Lr(u, h + 16, w, O + 4), u[h + 32] && Lr(u, h + 32, w, O + 128), u[h + 48] && Lr(u, h + 48, w, O + 128 + 4);
    }
    function Sp(u, h, w, O) {
      var B, V = a(16);
      for (B = 0; 4 > B; ++B) {
        var W = u[h + 0 + B] + u[h + 12 + B], Q = u[h + 4 + B] + u[h + 8 + B], Y = u[h + 4 + B] - u[h + 8 + B], Z = u[h + 0 + B] - u[h + 12 + B];
        V[0 + B] = W + Q, V[8 + B] = W - Q, V[4 + B] = Z + Y, V[12 + B] = Z - Y;
      }
      for (B = 0; 4 > B; ++B) W = (u = V[0 + 4 * B] + 3) + V[3 + 4 * B], Q = V[1 + 4 * B] + V[2 + 4 * B], Y = V[1 + 4 * B] - V[2 + 4 * B], Z = u - V[3 + 4 * B], w[O + 0] = W + Q >> 3, w[O + 16] = Z + Y >> 3, w[O + 32] = W - Q >> 3, w[O + 48] = Z - Y >> 3, O += 64;
    }
    function zl(u, h, w) {
      var O, B = h - 32, V = ni, W = 255 - u[B - 1];
      for (O = 0; O < w; ++O) {
        var Q, Y = V, Z = W + u[h - 1];
        for (Q = 0; Q < w; ++Q) u[h + Q] = Y[Z + u[B + Q]];
        h += 32;
      }
    }
    function Ep(u, h) {
      zl(u, h, 4);
    }
    function Cp(u, h) {
      zl(u, h, 8);
    }
    function Op(u, h) {
      zl(u, h, 16);
    }
    function va(u, h) {
      var w;
      for (w = 0; 16 > w; ++w) r(u, h + 32 * w, u, h - 32, 16);
    }
    function Fs(u, h) {
      var w;
      for (w = 16; 0 < w; --w) i(u, h, u[h - 1], 16), h += 32;
    }
    function Is(u, h, w) {
      var O;
      for (O = 0; 16 > O; ++O) i(h, w + 32 * O, u, 16);
    }
    function Ku(u, h) {
      var w, O = 16;
      for (w = 0; 16 > w; ++w) O += u[h - 1 + 32 * w] + u[h + w - 32];
      Is(O >> 5, u, h);
    }
    function wr(u, h) {
      var w, O = 8;
      for (w = 0; 16 > w; ++w) O += u[h - 1 + 32 * w];
      Is(O >> 4, u, h);
    }
    function jp(u, h) {
      var w, O = 8;
      for (w = 0; 16 > w; ++w) O += u[h + w - 32];
      Is(O >> 4, u, h);
    }
    function Xu(u, h) {
      Is(128, u, h);
    }
    function Nt(u, h, w) {
      return u + 2 * h + w + 2 >> 2;
    }
    function Pp(u, h) {
      var w, O = h - 32;
      for (O = new Uint8Array([Nt(u[O - 1], u[O + 0], u[O + 1]), Nt(u[O + 0], u[O + 1], u[O + 2]), Nt(u[O + 1], u[O + 2], u[O + 3]), Nt(u[O + 2], u[O + 3], u[O + 4])]), w = 0; 4 > w; ++w) r(u, h + 32 * w, O, 0, O.length);
    }
    function Lp(u, h) {
      var w = u[h - 1], O = u[h - 1 + 32], B = u[h - 1 + 64], V = u[h - 1 + 96];
      ve(u, h + 0, 16843009 * Nt(u[h - 1 - 32], w, O)), ve(u, h + 32, 16843009 * Nt(w, O, B)), ve(u, h + 64, 16843009 * Nt(O, B, V)), ve(u, h + 96, 16843009 * Nt(B, V, V));
    }
    function Zi(u, h) {
      var w, O = 4;
      for (w = 0; 4 > w; ++w) O += u[h + w - 32] + u[h - 1 + 32 * w];
      for (O >>= 3, w = 0; 4 > w; ++w) i(u, h + 32 * w, O, 4);
    }
    function Zu(u, h) {
      var w = u[h - 1 + 0], O = u[h - 1 + 32], B = u[h - 1 + 64], V = u[h - 1 - 32], W = u[h + 0 - 32], Q = u[h + 1 - 32], Y = u[h + 2 - 32], Z = u[h + 3 - 32];
      u[h + 0 + 96] = Nt(O, B, u[h - 1 + 96]), u[h + 1 + 96] = u[h + 0 + 64] = Nt(w, O, B), u[h + 2 + 96] = u[h + 1 + 64] = u[h + 0 + 32] = Nt(V, w, O), u[h + 3 + 96] = u[h + 2 + 64] = u[h + 1 + 32] = u[h + 0 + 0] = Nt(W, V, w), u[h + 3 + 64] = u[h + 2 + 32] = u[h + 1 + 0] = Nt(Q, W, V), u[h + 3 + 32] = u[h + 2 + 0] = Nt(Y, Q, W), u[h + 3 + 0] = Nt(Z, Y, Q);
    }
    function Ju(u, h) {
      var w = u[h + 1 - 32], O = u[h + 2 - 32], B = u[h + 3 - 32], V = u[h + 4 - 32], W = u[h + 5 - 32], Q = u[h + 6 - 32], Y = u[h + 7 - 32];
      u[h + 0 + 0] = Nt(u[h + 0 - 32], w, O), u[h + 1 + 0] = u[h + 0 + 32] = Nt(w, O, B), u[h + 2 + 0] = u[h + 1 + 32] = u[h + 0 + 64] = Nt(O, B, V), u[h + 3 + 0] = u[h + 2 + 32] = u[h + 1 + 64] = u[h + 0 + 96] = Nt(B, V, W), u[h + 3 + 32] = u[h + 2 + 64] = u[h + 1 + 96] = Nt(V, W, Q), u[h + 3 + 64] = u[h + 2 + 96] = Nt(W, Q, Y), u[h + 3 + 96] = Nt(Q, Y, Y);
    }
    function ks(u, h) {
      var w = u[h - 1 + 0], O = u[h - 1 + 32], B = u[h - 1 + 64], V = u[h - 1 - 32], W = u[h + 0 - 32], Q = u[h + 1 - 32], Y = u[h + 2 - 32], Z = u[h + 3 - 32];
      u[h + 0 + 0] = u[h + 1 + 64] = V + W + 1 >> 1, u[h + 1 + 0] = u[h + 2 + 64] = W + Q + 1 >> 1, u[h + 2 + 0] = u[h + 3 + 64] = Q + Y + 1 >> 1, u[h + 3 + 0] = Y + Z + 1 >> 1, u[h + 0 + 96] = Nt(B, O, w), u[h + 0 + 64] = Nt(O, w, V), u[h + 0 + 32] = u[h + 1 + 96] = Nt(w, V, W), u[h + 1 + 32] = u[h + 2 + 96] = Nt(V, W, Q), u[h + 2 + 32] = u[h + 3 + 96] = Nt(W, Q, Y), u[h + 3 + 32] = Nt(Q, Y, Z);
    }
    function ql(u, h) {
      var w = u[h + 0 - 32], O = u[h + 1 - 32], B = u[h + 2 - 32], V = u[h + 3 - 32], W = u[h + 4 - 32], Q = u[h + 5 - 32], Y = u[h + 6 - 32], Z = u[h + 7 - 32];
      u[h + 0 + 0] = w + O + 1 >> 1, u[h + 1 + 0] = u[h + 0 + 64] = O + B + 1 >> 1, u[h + 2 + 0] = u[h + 1 + 64] = B + V + 1 >> 1, u[h + 3 + 0] = u[h + 2 + 64] = V + W + 1 >> 1, u[h + 0 + 32] = Nt(w, O, B), u[h + 1 + 32] = u[h + 0 + 96] = Nt(O, B, V), u[h + 2 + 32] = u[h + 1 + 96] = Nt(B, V, W), u[h + 3 + 32] = u[h + 2 + 96] = Nt(V, W, Q), u[h + 3 + 64] = Nt(W, Q, Y), u[h + 3 + 96] = Nt(Q, Y, Z);
    }
    function Tp(u, h) {
      var w = u[h - 1 + 0], O = u[h - 1 + 32], B = u[h - 1 + 64], V = u[h - 1 + 96];
      u[h + 0 + 0] = w + O + 1 >> 1, u[h + 2 + 0] = u[h + 0 + 32] = O + B + 1 >> 1, u[h + 2 + 32] = u[h + 0 + 64] = B + V + 1 >> 1, u[h + 1 + 0] = Nt(w, O, B), u[h + 3 + 0] = u[h + 1 + 32] = Nt(O, B, V), u[h + 3 + 32] = u[h + 1 + 64] = Nt(B, V, V), u[h + 3 + 64] = u[h + 2 + 64] = u[h + 0 + 96] = u[h + 1 + 96] = u[h + 2 + 96] = u[h + 3 + 96] = V;
    }
    function Fp(u, h) {
      var w = u[h - 1 + 0], O = u[h - 1 + 32], B = u[h - 1 + 64], V = u[h - 1 + 96], W = u[h - 1 - 32], Q = u[h + 0 - 32], Y = u[h + 1 - 32], Z = u[h + 2 - 32];
      u[h + 0 + 0] = u[h + 2 + 32] = w + W + 1 >> 1, u[h + 0 + 32] = u[h + 2 + 64] = O + w + 1 >> 1, u[h + 0 + 64] = u[h + 2 + 96] = B + O + 1 >> 1, u[h + 0 + 96] = V + B + 1 >> 1, u[h + 3 + 0] = Nt(Q, Y, Z), u[h + 2 + 0] = Nt(W, Q, Y), u[h + 1 + 0] = u[h + 3 + 32] = Nt(w, W, Q), u[h + 1 + 32] = u[h + 3 + 64] = Nt(O, w, W), u[h + 1 + 64] = u[h + 3 + 96] = Nt(B, O, w), u[h + 1 + 96] = Nt(V, B, O);
    }
    function Ip(u, h) {
      var w;
      for (w = 0; 8 > w; ++w) r(u, h + 32 * w, u, h - 32, 8);
    }
    function Vl(u, h) {
      var w;
      for (w = 0; 8 > w; ++w) i(u, h, u[h - 1], 8), h += 32;
    }
    function Ho(u, h, w) {
      var O;
      for (O = 0; 8 > O; ++O) i(h, w + 32 * O, u, 8);
    }
    function Wa(u, h) {
      var w, O = 8;
      for (w = 0; 8 > w; ++w) O += u[h + w - 32] + u[h - 1 + 32 * w];
      Ho(O >> 4, u, h);
    }
    function kp(u, h) {
      var w, O = 4;
      for (w = 0; 8 > w; ++w) O += u[h + w - 32];
      Ho(O >> 3, u, h);
    }
    function $o(u, h) {
      var w, O = 4;
      for (w = 0; 8 > w; ++w) O += u[h - 1 + 32 * w];
      Ho(O >> 3, u, h);
    }
    function Wl(u, h) {
      Ho(128, u, h);
    }
    function Ds(u, h, w) {
      var O = u[h - w], B = u[h + 0], V = 3 * (B - O) + zp[1020 + u[h - 2 * w] - u[h + w]], W = dd[112 + (V + 4 >> 3)];
      u[h - w] = ni[255 + O + dd[112 + (V + 3 >> 3)]], u[h + 0] = ni[255 + B - W];
    }
    function Au(u, h, w, O) {
      var B = u[h + 0], V = u[h + w];
      return wi[255 + u[h - 2 * w] - u[h - w]] > O || wi[255 + V - B] > O;
    }
    function ed(u, h, w, O) {
      return 4 * wi[255 + u[h - w] - u[h + 0]] + wi[255 + u[h - 2 * w] - u[h + w]] <= O;
    }
    function td(u, h, w, O, B) {
      var V = u[h - 3 * w], W = u[h - 2 * w], Q = u[h - w], Y = u[h + 0], Z = u[h + w], ge = u[h + 2 * w], Ce = u[h + 3 * w];
      return 4 * wi[255 + Q - Y] + wi[255 + W - Z] > O ? 0 : wi[255 + u[h - 4 * w] - V] <= B && wi[255 + V - W] <= B && wi[255 + W - Q] <= B && wi[255 + Ce - ge] <= B && wi[255 + ge - Z] <= B && wi[255 + Z - Y] <= B;
    }
    function nd(u, h, w, O) {
      var B = 2 * O + 1;
      for (O = 0; 16 > O; ++O) ed(u, h + O, w, B) && Ds(u, h + O, w);
    }
    function Ji(u, h, w, O) {
      var B = 2 * O + 1;
      for (O = 0; 16 > O; ++O) ed(u, h + O * w, 1, B) && Ds(u, h + O * w, 1);
    }
    function ba(u, h, w, O) {
      var B;
      for (B = 3; 0 < B; --B) nd(u, h += 4 * w, w, O);
    }
    function Dp(u, h, w, O) {
      var B;
      for (B = 3; 0 < B; --B) Ji(u, h += 4, w, O);
    }
    function Ha(u, h, w, O, B, V, W, Q) {
      for (V = 2 * V + 1; 0 < B--; ) {
        if (td(u, h, w, V, W)) if (Au(u, h, w, Q)) Ds(u, h, w);
        else {
          var Y = u, Z = h, ge = w, Ce = Y[Z - 2 * ge], Oe = Y[Z - ge], Ne = Y[Z + 0], qe = Y[Z + ge], ke = Y[Z + 2 * ge], ye = 27 * (Be = zp[1020 + 3 * (Ne - Oe) + zp[1020 + Ce - qe]]) + 63 >> 7, we = 18 * Be + 63 >> 7, Be = 9 * Be + 63 >> 7;
          Y[Z - 3 * ge] = ni[255 + Y[Z - 3 * ge] + Be], Y[Z - 2 * ge] = ni[255 + Ce + we], Y[Z - ge] = ni[255 + Oe + ye], Y[Z + 0] = ni[255 + Ne - ye], Y[Z + ge] = ni[255 + qe - we], Y[Z + 2 * ge] = ni[255 + ke - Be];
        }
        h += O;
      }
    }
    function Di(u, h, w, O, B, V, W, Q) {
      for (V = 2 * V + 1; 0 < B--; ) {
        if (td(u, h, w, V, W)) if (Au(u, h, w, Q)) Ds(u, h, w);
        else {
          var Y = u, Z = h, ge = w, Ce = Y[Z - ge], Oe = Y[Z + 0], Ne = Y[Z + ge], qe = dd[112 + ((ke = 3 * (Oe - Ce)) + 4 >> 3)], ke = dd[112 + (ke + 3 >> 3)], ye = qe + 1 >> 1;
          Y[Z - 2 * ge] = ni[255 + Y[Z - 2 * ge] + ye], Y[Z - ge] = ni[255 + Ce + ke], Y[Z + 0] = ni[255 + Oe - qe], Y[Z + ge] = ni[255 + Ne - ye];
        }
        h += O;
      }
    }
    function Hl(u, h, w, O, B, V) {
      Ha(u, h, w, 1, 16, O, B, V);
    }
    function Go(u, h, w, O, B, V) {
      Ha(u, h, 1, w, 16, O, B, V);
    }
    function Rp(u, h, w, O, B, V) {
      var W;
      for (W = 3; 0 < W; --W) Di(u, h += 4 * w, w, 1, 16, O, B, V);
    }
    function Rs(u, h, w, O, B, V) {
      var W;
      for (W = 3; 0 < W; --W) Di(u, h += 4, 1, w, 16, O, B, V);
    }
    function Mp(u, h, w, O, B, V, W, Q) {
      Ha(u, h, B, 1, 8, V, W, Q), Ha(w, O, B, 1, 8, V, W, Q);
    }
    function $l(u, h, w, O, B, V, W, Q) {
      Ha(u, h, 1, B, 8, V, W, Q), Ha(w, O, 1, B, 8, V, W, Q);
    }
    function Gl(u, h, w, O, B, V, W, Q) {
      Di(u, h + 4 * B, B, 1, 8, V, W, Q), Di(w, O + 4 * B, B, 1, 8, V, W, Q);
    }
    function rd(u, h, w, O, B, V, W, Q) {
      Di(u, h + 4, 1, B, 8, V, W, Q), Di(w, O + 4, 1, B, 8, V, W, Q);
    }
    function Ms() {
      this.ba = new In(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new Gt(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Ql() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function Yl() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function id() {
      this.ua = 0, this.Wa = new X(), this.vb = new X(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new $(), this.yc = new L();
    }
    function Up() {
      this.xb = this.a = 0, this.l = new Ls(), this.ca = new In(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new I(), this.Pb = 0, this.wd = new I(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new id(), this.ab = 0, this.gc = o(4, Yl), this.Oc = 0;
    }
    function Us() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Ls(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function Qo(u, h, w, O, B, V, W) {
      for (u = u == null ? 0 : u[h + 0], h = 0; h < W; ++h) B[V + h] = u + w[O + h] & 255, u = B[V + h];
    }
    function Kl(u, h, w, O, B, V, W) {
      var Q;
      if (u == null) Qo(null, null, w, O, B, V, W);
      else for (Q = 0; Q < W; ++Q) B[V + Q] = u[h + Q] + w[O + Q] & 255;
    }
    function $a(u, h, w, O, B, V, W) {
      if (u == null) Qo(null, null, w, O, B, V, W);
      else {
        var Q, Y = u[h + 0], Z = Y, ge = Y;
        for (Q = 0; Q < W; ++Q) Z = ge + (Y = u[h + Q]) - Z, ge = w[O + Q] + (-256 & Z ? 0 > Z ? 0 : 255 : Z) & 255, Z = Y, B[V + Q] = ge;
      }
    }
    function Xl(u, h, w, O) {
      var B = h.width, V = h.o;
      if (t(u != null && h != null), 0 > w || 0 >= O || w + O > V) return null;
      if (!u.Cc) {
        if (u.ga == null) {
          var W;
          if (u.ga = new Us(), (W = u.ga == null) || (W = h.width * h.o, t(u.Gb.length == 0), u.Gb = a(W), u.Uc = 0, u.Gb == null ? W = 0 : (u.mb = u.Gb, u.nb = u.Uc, u.rc = null, W = 1), W = !W), !W) {
            W = u.ga;
            var Q = u.Fa, Y = u.P, Z = u.qc, ge = u.mb, Ce = u.nb, Oe = Y + 1, Ne = Z - 1, qe = W.l;
            if (t(Q != null && ge != null && h != null), Za[0] = null, Za[1] = Qo, Za[2] = Kl, Za[3] = $a, W.ca = ge, W.tb = Ce, W.c = h.width, W.i = h.height, t(0 < W.c && 0 < W.i), 1 >= Z) h = 0;
            else if (W.$a = Q[Y + 0] >> 0 & 3, W.Z = Q[Y + 0] >> 2 & 3, W.Lc = Q[Y + 0] >> 4 & 3, Y = Q[Y + 0] >> 6 & 3, 0 > W.$a || 1 < W.$a || 4 <= W.Z || 1 < W.Lc || Y) h = 0;
            else if (qe.put = Mn, qe.ac = _n, qe.bc = er, qe.ma = W, qe.width = h.width, qe.height = h.height, qe.Da = h.Da, qe.v = h.v, qe.va = h.va, qe.j = h.j, qe.o = h.o, W.$a) e: {
              t(W.$a == 1), h = jr();
              t: for (; ; ) {
                if (h == null) {
                  h = 0;
                  break e;
                }
                if (t(W != null), W.mc = h, h.c = W.c, h.i = W.i, h.l = W.l, h.l.ma = W, h.l.width = W.c, h.l.height = W.i, h.a = 0, oe(h.m, Q, Oe, Ne), !hi(W.c, W.i, 1, h, null) || (h.ab == 1 && h.gc[0].hc == 3 && pi(h.s) ? (W.ic = 1, Q = h.c * h.i, h.Ta = null, h.Ua = 0, h.V = a(Q), h.Ba = 0, h.V == null ? (h.a = 1, h = 0) : h = 1) : (W.ic = 0, h = de(h, W.c)), !h)) break t;
                h = 1;
                break e;
              }
              W.mc = null, h = 0;
            }
            else h = Ne >= W.c * W.i;
            W = !h;
          }
          if (W) return null;
          u.ga.Lc != 1 ? u.Ga = 0 : O = V - w;
        }
        t(u.ga != null), t(w + O <= V);
        e: {
          if (h = (Q = u.ga).c, V = Q.l.o, Q.$a == 0) {
            if (Oe = u.rc, Ne = u.Vc, qe = u.Fa, Y = u.P + 1 + w * h, Z = u.mb, ge = u.nb + w * h, t(Y <= u.P + u.qc), Q.Z != 0) for (t(Za[Q.Z] != null), W = 0; W < O; ++W) Za[Q.Z](Oe, Ne, qe, Y, Z, ge, h), Oe = Z, Ne = ge, ge += h, Y += h;
            else for (W = 0; W < O; ++W) r(Z, ge, qe, Y, h), Oe = Z, Ne = ge, ge += h, Y += h;
            u.rc = Oe, u.Vc = Ne;
          } else {
            if (t(Q.mc != null), h = w + O, t((W = Q.mc) != null), t(h <= W.i), W.C >= h) h = 1;
            else if (Q.ic || Ee(), Q.ic) {
              Q = W.V, Oe = W.Ba, Ne = W.c;
              var ke = W.i, ye = (qe = 1, Y = W.$ / Ne, Z = W.$ % Ne, ge = W.m, Ce = W.s, W.$), we = Ne * ke, Be = Ne * h, Ve = Ce.wc, ze = ye < Be ? en(Ce, Z, Y) : null;
              t(ye <= we), t(h <= ke), t(pi(Ce));
              t: for (; ; ) {
                for (; !ge.h && ye < Be; ) {
                  if (Z & Ve || (ze = en(Ce, Z, Y)), t(ze != null), A(ge), 256 > (ke = yn(ze.G[0], ze.H[0], ge))) Q[Oe + ye] = ke, ++ye, ++Z >= Ne && (Z = 0, ++Y <= h && !(Y % 16) && zr(W, Y));
                  else {
                    if (!(280 > ke)) {
                      qe = 0;
                      break t;
                    }
                    ke = rr(ke - 256, ge);
                    var st, Ae = yn(ze.G[4], ze.H[4], ge);
                    if (A(ge), !(ye >= (Ae = ir(Ne, Ae = rr(Ae, ge))) && we - ye >= ke)) {
                      qe = 0;
                      break t;
                    }
                    for (st = 0; st < ke; ++st) Q[Oe + ye + st] = Q[Oe + ye + st - Ae];
                    for (ye += ke, Z += ke; Z >= Ne; ) Z -= Ne, ++Y <= h && !(Y % 16) && zr(W, Y);
                    ye < Be && Z & Ve && (ze = en(Ce, Z, Y));
                  }
                  t(ge.h == G(ge));
                }
                zr(W, Y > h ? h : Y);
                break t;
              }
              !qe || ge.h && ye < we ? (qe = 0, W.a = ge.h ? 5 : 3) : W.$ = ye, h = qe;
            } else h = qr(W, W.V, W.Ba, W.c, W.i, h, it);
            if (!h) {
              O = 0;
              break e;
            }
          }
          w + O >= V && (u.Cc = 1), O = 1;
        }
        if (!O) return null;
        if (u.Cc && ((O = u.ga) != null && (O.mc = null), u.ga = null, 0 < u.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return u.nb + w * B;
    }
    function v(u, h, w, O, B, V) {
      for (; 0 < B--; ) {
        var W, Q = u, Y = h + (w ? 1 : 0), Z = u, ge = h + (w ? 0 : 3);
        for (W = 0; W < O; ++W) {
          var Ce = Z[ge + 4 * W];
          Ce != 255 && (Ce *= 32897, Q[Y + 4 * W + 0] = Q[Y + 4 * W + 0] * Ce >> 23, Q[Y + 4 * W + 1] = Q[Y + 4 * W + 1] * Ce >> 23, Q[Y + 4 * W + 2] = Q[Y + 4 * W + 2] * Ce >> 23);
        }
        h += V;
      }
    }
    function z(u, h, w, O, B) {
      for (; 0 < O--; ) {
        var V;
        for (V = 0; V < w; ++V) {
          var W = u[h + 2 * V + 0], Q = 15 & (Z = u[h + 2 * V + 1]), Y = 4369 * Q, Z = (240 & Z | Z >> 4) * Y >> 16;
          u[h + 2 * V + 0] = (240 & W | W >> 4) * Y >> 16 & 240 | (15 & W | W << 4) * Y >> 16 >> 4 & 15, u[h + 2 * V + 1] = 240 & Z | Q;
        }
        h += B;
      }
    }
    function ie(u, h, w, O, B, V, W, Q) {
      var Y, Z, ge = 255;
      for (Z = 0; Z < B; ++Z) {
        for (Y = 0; Y < O; ++Y) {
          var Ce = u[h + Y];
          V[W + 4 * Y] = Ce, ge &= Ce;
        }
        h += w, W += Q;
      }
      return ge != 255;
    }
    function he(u, h, w, O, B) {
      var V;
      for (V = 0; V < B; ++V) w[O + V] = u[h + V] >> 8;
    }
    function Ee() {
      bi = v, vn = z, bn = ie, Vn = he;
    }
    function De(u, h, w) {
      x[u] = function(O, B, V, W, Q, Y, Z, ge, Ce, Oe, Ne, qe, ke, ye, we, Be, Ve) {
        var ze, st = Ve - 1 >> 1, Ae = Q[Y + 0] | Z[ge + 0] << 16, bt = Ce[Oe + 0] | Ne[qe + 0] << 16;
        t(O != null);
        var tt = 3 * Ae + bt + 131074 >> 2;
        for (h(O[B + 0], 255 & tt, tt >> 16, ke, ye), V != null && (tt = 3 * bt + Ae + 131074 >> 2, h(V[W + 0], 255 & tt, tt >> 16, we, Be)), ze = 1; ze <= st; ++ze) {
          var Xt = Q[Y + ze] | Z[ge + ze] << 16, an = Ce[Oe + ze] | Ne[qe + ze] << 16, Ht = Ae + Xt + bt + an + 524296, zt = Ht + 2 * (Xt + bt) >> 3;
          tt = zt + Ae >> 1, Ae = (Ht = Ht + 2 * (Ae + an) >> 3) + Xt >> 1, h(O[B + 2 * ze - 1], 255 & tt, tt >> 16, ke, ye + (2 * ze - 1) * w), h(O[B + 2 * ze - 0], 255 & Ae, Ae >> 16, ke, ye + (2 * ze - 0) * w), V != null && (tt = Ht + bt >> 1, Ae = zt + an >> 1, h(V[W + 2 * ze - 1], 255 & tt, tt >> 16, we, Be + (2 * ze - 1) * w), h(V[W + 2 * ze + 0], 255 & Ae, Ae >> 16, we, Be + (2 * ze + 0) * w)), Ae = Xt, bt = an;
        }
        1 & Ve || (tt = 3 * Ae + bt + 131074 >> 2, h(O[B + Ve - 1], 255 & tt, tt >> 16, ke, ye + (Ve - 1) * w), V != null && (tt = 3 * bt + Ae + 131074 >> 2, h(V[W + Ve - 1], 255 & tt, tt >> 16, we, Be + (Ve - 1) * w)));
      };
    }
    function He() {
      xi[fd] = Wx, xi[pd] = M1, xi[F1] = Hx, xi[hd] = U1, xi[md] = B1, xi[qp] = z1, xi[I1] = $x, xi[Vp] = M1, xi[Wp] = U1, xi[gd] = B1, xi[Hp] = z1;
    }
    function ot(u) {
      return u & -16384 ? 0 > u ? 0 : 255 : u >> Gx;
    }
    function yt(u, h) {
      return ot((19077 * u >> 8) + (26149 * h >> 8) - 14234);
    }
    function jt(u, h, w) {
      return ot((19077 * u >> 8) - (6419 * h >> 8) - (13320 * w >> 8) + 8708);
    }
    function St(u, h) {
      return ot((19077 * u >> 8) + (33050 * h >> 8) - 17685);
    }
    function Wt(u, h, w, O, B) {
      O[B + 0] = yt(u, w), O[B + 1] = jt(u, h, w), O[B + 2] = St(u, h);
    }
    function Pn(u, h, w, O, B) {
      O[B + 0] = St(u, h), O[B + 1] = jt(u, h, w), O[B + 2] = yt(u, w);
    }
    function zn(u, h, w, O, B) {
      var V = jt(u, h, w);
      h = V << 3 & 224 | St(u, h) >> 3, O[B + 0] = 248 & yt(u, w) | V >> 5, O[B + 1] = h;
    }
    function Xn(u, h, w, O, B) {
      var V = 240 & St(u, h) | 15;
      O[B + 0] = 240 & yt(u, w) | jt(u, h, w) >> 4, O[B + 1] = V;
    }
    function xr(u, h, w, O, B) {
      O[B + 0] = 255, Wt(u, h, w, O, B + 1);
    }
    function ar(u, h, w, O, B) {
      Pn(u, h, w, O, B), O[B + 3] = 255;
    }
    function Ri(u, h, w, O, B) {
      Wt(u, h, w, O, B), O[B + 3] = 255;
    }
    function mi(u, h) {
      return 0 > u ? 0 : u > h ? h : u;
    }
    function Ai(u, h, w) {
      x[u] = function(O, B, V, W, Q, Y, Z, ge, Ce) {
        for (var Oe = ge + (-2 & Ce) * w; ge != Oe; ) h(O[B + 0], V[W + 0], Q[Y + 0], Z, ge), h(O[B + 1], V[W + 0], Q[Y + 0], Z, ge + w), B += 2, ++W, ++Y, ge += 2 * w;
        1 & Ce && h(O[B + 0], V[W + 0], Q[Y + 0], Z, ge);
      };
    }
    function ad(u, h, w) {
      return w == 0 ? u == 0 ? h == 0 ? 6 : 5 : h == 0 ? 4 : 0 : w;
    }
    function Zl(u, h, w, O, B) {
      switch (u >>> 30) {
        case 3:
          _a(h, w, O, B, 0);
          break;
        case 2:
          qn(h, w, O, B);
          break;
        case 1:
          Lr(h, w, O, B);
      }
    }
    function Jl(u, h) {
      var w, O, B = h.M, V = h.Nb, W = u.oc, Q = u.pc + 40, Y = u.oc, Z = u.pc + 584, ge = u.oc, Ce = u.pc + 600;
      for (w = 0; 16 > w; ++w) W[Q + 32 * w - 1] = 129;
      for (w = 0; 8 > w; ++w) Y[Z + 32 * w - 1] = 129, ge[Ce + 32 * w - 1] = 129;
      for (0 < B ? W[Q - 1 - 32] = Y[Z - 1 - 32] = ge[Ce - 1 - 32] = 129 : (i(W, Q - 32 - 1, 127, 21), i(Y, Z - 32 - 1, 127, 9), i(ge, Ce - 32 - 1, 127, 9)), O = 0; O < u.za; ++O) {
        var Oe = h.ya[h.aa + O];
        if (0 < O) {
          for (w = -1; 16 > w; ++w) r(W, Q + 32 * w - 4, W, Q + 32 * w + 12, 4);
          for (w = -1; 8 > w; ++w) r(Y, Z + 32 * w - 4, Y, Z + 32 * w + 4, 4), r(ge, Ce + 32 * w - 4, ge, Ce + 32 * w + 4, 4);
        }
        var Ne = u.Gd, qe = u.Hd + O, ke = Oe.ad, ye = Oe.Hc;
        if (0 < B && (r(W, Q - 32, Ne[qe].y, 0, 16), r(Y, Z - 32, Ne[qe].f, 0, 8), r(ge, Ce - 32, Ne[qe].ea, 0, 8)), Oe.Za) {
          var we = W, Be = Q - 32 + 16;
          for (0 < B && (O >= u.za - 1 ? i(we, Be, Ne[qe].y[15], 4) : r(we, Be, Ne[qe + 1].y, 0, 4)), w = 0; 4 > w; w++) we[Be + 128 + w] = we[Be + 256 + w] = we[Be + 384 + w] = we[Be + 0 + w];
          for (w = 0; 16 > w; ++w, ye <<= 2) we = W, Be = Q + V1[w], Mi[Oe.Ob[w]](we, Be), Zl(ye, ke, 16 * +w, we, Be);
        } else if (we = ad(O, B, Oe.Ob[0]), Xa[we](W, Q), ye != 0) for (w = 0; 16 > w; ++w, ye <<= 2) Zl(ye, ke, 16 * +w, W, Q + V1[w]);
        for (w = Oe.Gc, we = ad(O, B, Oe.Dd), Sa[we](Y, Z), Sa[we](ge, Ce), ye = ke, we = Y, Be = Z, 255 & (Oe = w >> 0) && (170 & Oe ? rc(ye, 256, we, Be) : yi(ye, 256, we, Be)), Oe = ge, ye = Ce, 255 & (w >>= 8) && (170 & w ? rc(ke, 320, Oe, ye) : yi(ke, 320, Oe, ye)), B < u.Ub - 1 && (r(Ne[qe].y, 0, W, Q + 480, 16), r(Ne[qe].f, 0, Y, Z + 224, 8), r(Ne[qe].ea, 0, ge, Ce + 224, 8)), w = 8 * V * u.B, Ne = u.sa, qe = u.ta + 16 * O + 16 * V * u.R, ke = u.qa, Oe = u.ra + 8 * O + w, ye = u.Ha, we = u.Ia + 8 * O + w, w = 0; 16 > w; ++w) r(Ne, qe + w * u.R, W, Q + 32 * w, 16);
        for (w = 0; 8 > w; ++w) r(ke, Oe + w * u.B, Y, Z + 32 * w, 8), r(ye, we + w * u.B, ge, Ce + 32 * w, 8);
      }
    }
    function Bs(u, h, w, O, B, V, W, Q, Y) {
      var Z = [0], ge = [0], Ce = 0, Oe = Y != null ? Y.kd : 0, Ne = Y ?? new Ql();
      if (u == null || 12 > w) return 7;
      Ne.data = u, Ne.w = h, Ne.ha = w, h = [h], w = [w], Ne.gb = [Ne.gb];
      e: {
        var qe = h, ke = w, ye = Ne.gb;
        if (t(u != null), t(ke != null), t(ye != null), ye[0] = 0, 12 <= ke[0] && !n(u, qe[0], "RIFF")) {
          if (n(u, qe[0] + 8, "WEBP")) {
            ye = 3;
            break e;
          }
          var we = je(u, qe[0] + 4);
          if (12 > we || 4294967286 < we) {
            ye = 3;
            break e;
          }
          if (Oe && we > ke[0] - 8) {
            ye = 7;
            break e;
          }
          ye[0] = we, qe[0] += 12, ke[0] -= 12;
        }
        ye = 0;
      }
      if (ye != 0) return ye;
      for (we = 0 < Ne.gb[0], w = w[0]; ; ) {
        e: {
          var Be = u;
          ke = h, ye = w;
          var Ve = Z, ze = ge, st = qe = [0];
          if ((tt = Ce = [Ce])[0] = 0, 8 > ye[0]) ye = 7;
          else {
            if (!n(Be, ke[0], "VP8X")) {
              if (je(Be, ke[0] + 4) != 10) {
                ye = 3;
                break e;
              }
              if (18 > ye[0]) {
                ye = 7;
                break e;
              }
              var Ae = je(Be, ke[0] + 8), bt = 1 + pe(Be, ke[0] + 12);
              if (2147483648 <= bt * (Be = 1 + pe(Be, ke[0] + 15))) {
                ye = 3;
                break e;
              }
              st != null && (st[0] = Ae), Ve != null && (Ve[0] = bt), ze != null && (ze[0] = Be), ke[0] += 18, ye[0] -= 18, tt[0] = 1;
            }
            ye = 0;
          }
        }
        if (Ce = Ce[0], qe = qe[0], ye != 0) return ye;
        if (ke = !!(2 & qe), !we && Ce) return 3;
        if (V != null && (V[0] = !!(16 & qe)), W != null && (W[0] = ke), Q != null && (Q[0] = 0), W = Z[0], qe = ge[0], Ce && ke && Y == null) {
          ye = 0;
          break;
        }
        if (4 > w) {
          ye = 7;
          break;
        }
        if (we && Ce || !we && !Ce && !n(u, h[0], "ALPH")) {
          w = [w], Ne.na = [Ne.na], Ne.P = [Ne.P], Ne.Sa = [Ne.Sa];
          e: {
            Ae = u, ye = h, we = w;
            var tt = Ne.gb;
            Ve = Ne.na, ze = Ne.P, st = Ne.Sa, bt = 22, t(Ae != null), t(we != null), Be = ye[0];
            var Xt = we[0];
            for (t(Ve != null), t(st != null), Ve[0] = null, ze[0] = null, st[0] = 0; ; ) {
              if (ye[0] = Be, we[0] = Xt, 8 > Xt) {
                ye = 7;
                break e;
              }
              var an = je(Ae, Be + 4);
              if (4294967286 < an) {
                ye = 3;
                break e;
              }
              var Ht = 8 + an + 1 & -2;
              if (bt += Ht, 0 < tt && bt > tt) {
                ye = 3;
                break e;
              }
              if (!n(Ae, Be, "VP8 ") || !n(Ae, Be, "VP8L")) {
                ye = 0;
                break e;
              }
              if (Xt[0] < Ht) {
                ye = 7;
                break e;
              }
              n(Ae, Be, "ALPH") || (Ve[0] = Ae, ze[0] = Be + 8, st[0] = an), Be += Ht, Xt -= Ht;
            }
          }
          if (w = w[0], Ne.na = Ne.na[0], Ne.P = Ne.P[0], Ne.Sa = Ne.Sa[0], ye != 0) break;
        }
        w = [w], Ne.Ja = [Ne.Ja], Ne.xa = [Ne.xa];
        e: if (tt = u, ye = h, we = w, Ve = Ne.gb[0], ze = Ne.Ja, st = Ne.xa, Ae = ye[0], Be = !n(tt, Ae, "VP8 "), bt = !n(tt, Ae, "VP8L"), t(tt != null), t(we != null), t(ze != null), t(st != null), 8 > we[0]) ye = 7;
        else {
          if (Be || bt) {
            if (tt = je(tt, Ae + 4), 12 <= Ve && tt > Ve - 12) {
              ye = 3;
              break e;
            }
            if (Oe && tt > we[0] - 8) {
              ye = 7;
              break e;
            }
            ze[0] = tt, ye[0] += 8, we[0] -= 8, st[0] = bt;
          } else st[0] = 5 <= we[0] && tt[Ae + 0] == 47 && !(tt[Ae + 4] >> 5), ze[0] = we[0];
          ye = 0;
        }
        if (w = w[0], Ne.Ja = Ne.Ja[0], Ne.xa = Ne.xa[0], h = h[0], ye != 0) break;
        if (4294967286 < Ne.Ja) return 3;
        if (Q == null || ke || (Q[0] = Ne.xa ? 2 : 1), W = [W], qe = [qe], Ne.xa) {
          if (5 > w) {
            ye = 7;
            break;
          }
          Q = W, Oe = qe, ke = V, u == null || 5 > w ? u = 0 : 5 <= w && u[h + 0] == 47 && !(u[h + 4] >> 5) ? (we = [0], tt = [0], Ve = [0], oe(ze = new I(), u, h, w), ht(ze, we, tt, Ve) ? (Q != null && (Q[0] = we[0]), Oe != null && (Oe[0] = tt[0]), ke != null && (ke[0] = Ve[0]), u = 1) : u = 0) : u = 0;
        } else {
          if (10 > w) {
            ye = 7;
            break;
          }
          Q = qe, u == null || 10 > w || !Wu(u, h + 3, w - 3) ? u = 0 : (Oe = u[h + 0] | u[h + 1] << 8 | u[h + 2] << 16, ke = 16383 & (u[h + 7] << 8 | u[h + 6]), u = 16383 & (u[h + 9] << 8 | u[h + 8]), 1 & Oe || 3 < (Oe >> 1 & 7) || !(Oe >> 4 & 1) || Oe >> 5 >= Ne.Ja || !ke || !u ? u = 0 : (W && (W[0] = ke), Q && (Q[0] = u), u = 1));
        }
        if (!u || (W = W[0], qe = qe[0], Ce && (Z[0] != W || ge[0] != qe))) return 3;
        Y != null && (Y[0] = Ne, Y.offset = h - Y.w, t(4294967286 > h - Y.w), t(Y.offset == Y.ha - w));
        break;
      }
      return ye == 0 || ye == 7 && Ce && Y == null ? (V != null && (V[0] |= Ne.na != null && 0 < Ne.na.length), O != null && (O[0] = W), B != null && (B[0] = qe), 0) : ye;
    }
    function Al(u, h, w) {
      var O = h.width, B = h.height, V = 0, W = 0, Q = O, Y = B;
      if (h.Da = u != null && 0 < u.Da, h.Da && (Q = u.cd, Y = u.bd, V = u.v, W = u.j, 11 > w || (V &= -2, W &= -2), 0 > V || 0 > W || 0 >= Q || 0 >= Y || V + Q > O || W + Y > B)) return 0;
      if (h.v = V, h.j = W, h.va = V + Q, h.o = W + Y, h.U = Q, h.T = Y, h.da = u != null && 0 < u.da, h.da) {
        if (!Ye(Q, Y, w = [u.ib], V = [u.hb])) return 0;
        h.ib = w[0], h.hb = V[0];
      }
      return h.ob = u != null && u.ob, h.Kb = u == null || !u.Sd, h.da && (h.ob = h.ib < 3 * O / 4 && h.hb < 3 * B / 4, h.Kb = 0), 1;
    }
    function ec(u) {
      if (u == null) return 2;
      if (11 > u.S) {
        var h = u.f.RGBA;
        h.fb += (u.height - 1) * h.A, h.A = -h.A;
      } else h = u.f.kb, u = u.height, h.O += (u - 1) * h.fa, h.fa = -h.fa, h.N += (u - 1 >> 1) * h.Ab, h.Ab = -h.Ab, h.W += (u - 1 >> 1) * h.Db, h.Db = -h.Db, h.F != null && (h.J += (u - 1) * h.lb, h.lb = -h.lb);
      return 0;
    }
    function zs(u, h, w, O) {
      if (O == null || 0 >= u || 0 >= h) return 2;
      if (w != null) {
        if (w.Da) {
          var B = w.cd, V = w.bd, W = -2 & w.v, Q = -2 & w.j;
          if (0 > W || 0 > Q || 0 >= B || 0 >= V || W + B > u || Q + V > h) return 2;
          u = B, h = V;
        }
        if (w.da) {
          if (!Ye(u, h, B = [w.ib], V = [w.hb])) return 2;
          u = B[0], h = V[0];
        }
      }
      O.width = u, O.height = h;
      e: {
        var Y = O.width, Z = O.height;
        if (u = O.S, 0 >= Y || 0 >= Z || !(u >= fd && 13 > u)) u = 2;
        else {
          if (0 >= O.Rd && O.sd == null) {
            W = V = B = h = 0;
            var ge = (Q = Y * W1[u]) * Z;
            if (11 > u || (V = (Z + 1) / 2 * (h = (Y + 1) / 2), u == 12 && (W = (B = Y) * Z)), (Z = a(ge + 2 * V + W)) == null) {
              u = 1;
              break e;
            }
            O.sd = Z, 11 > u ? ((Y = O.f.RGBA).eb = Z, Y.fb = 0, Y.A = Q, Y.size = ge) : ((Y = O.f.kb).y = Z, Y.O = 0, Y.fa = Q, Y.Fd = ge, Y.f = Z, Y.N = 0 + ge, Y.Ab = h, Y.Cd = V, Y.ea = Z, Y.W = 0 + ge + V, Y.Db = h, Y.Ed = V, u == 12 && (Y.F = Z, Y.J = 0 + ge + 2 * V), Y.Tc = W, Y.lb = B);
          }
          if (h = 1, B = O.S, V = O.width, W = O.height, B >= fd && 13 > B) if (11 > B) u = O.f.RGBA, h &= (Q = Math.abs(u.A)) * (W - 1) + V <= u.size, h &= Q >= V * W1[B], h &= u.eb != null;
          else {
            u = O.f.kb, Q = (V + 1) / 2, ge = (W + 1) / 2, Y = Math.abs(u.fa), Z = Math.abs(u.Ab);
            var Ce = Math.abs(u.Db), Oe = Math.abs(u.lb), Ne = Oe * (W - 1) + V;
            h &= Y * (W - 1) + V <= u.Fd, h &= Z * (ge - 1) + Q <= u.Cd, h = (h &= Ce * (ge - 1) + Q <= u.Ed) & Y >= V & Z >= Q & Ce >= Q, h &= u.y != null, h &= u.f != null, h &= u.ea != null, B == 12 && (h &= Oe >= V, h &= Ne <= u.Tc, h &= u.F != null);
          }
          else h = 0;
          u = h ? 0 : 2;
        }
      }
      return u != 0 || w != null && w.fd && (u = ec(O)), u;
    }
    var hr = 64, qs = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], Vs = 24, Ws = 32, tc = 8, Wr = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    Ue("Predictor0", "PredictorAdd0"), x.Predictor0 = function() {
      return 4278190080;
    }, x.Predictor1 = function(u) {
      return u;
    }, x.Predictor2 = function(u, h, w) {
      return h[w + 0];
    }, x.Predictor3 = function(u, h, w) {
      return h[w + 1];
    }, x.Predictor4 = function(u, h, w) {
      return h[w - 1];
    }, x.Predictor5 = function(u, h, w) {
      return fe(fe(u, h[w + 1]), h[w + 0]);
    }, x.Predictor6 = function(u, h, w) {
      return fe(u, h[w - 1]);
    }, x.Predictor7 = function(u, h, w) {
      return fe(u, h[w + 0]);
    }, x.Predictor8 = function(u, h, w) {
      return fe(h[w - 1], h[w + 0]);
    }, x.Predictor9 = function(u, h, w) {
      return fe(h[w + 0], h[w + 1]);
    }, x.Predictor10 = function(u, h, w) {
      return fe(fe(u, h[w - 1]), fe(h[w + 0], h[w + 1]));
    }, x.Predictor11 = function(u, h, w) {
      var O = h[w + 0];
      return 0 >= Ge(O >> 24 & 255, u >> 24 & 255, (h = h[w - 1]) >> 24 & 255) + Ge(O >> 16 & 255, u >> 16 & 255, h >> 16 & 255) + Ge(O >> 8 & 255, u >> 8 & 255, h >> 8 & 255) + Ge(255 & O, 255 & u, 255 & h) ? O : u;
    }, x.Predictor12 = function(u, h, w) {
      var O = h[w + 0];
      return (xe((u >> 24 & 255) + (O >> 24 & 255) - ((h = h[w - 1]) >> 24 & 255)) << 24 | xe((u >> 16 & 255) + (O >> 16 & 255) - (h >> 16 & 255)) << 16 | xe((u >> 8 & 255) + (O >> 8 & 255) - (h >> 8 & 255)) << 8 | xe((255 & u) + (255 & O) - (255 & h))) >>> 0;
    }, x.Predictor13 = function(u, h, w) {
      var O = h[w - 1];
      return (Fe((u = fe(u, h[w + 0])) >> 24 & 255, O >> 24 & 255) << 24 | Fe(u >> 16 & 255, O >> 16 & 255) << 16 | Fe(u >> 8 & 255, O >> 8 & 255) << 8 | Fe(u >> 0 & 255, O >> 0 & 255)) >>> 0;
    };
    var Bp = x.PredictorAdd0;
    x.PredictorAdd1 = Me, Ue("Predictor2", "PredictorAdd2"), Ue("Predictor3", "PredictorAdd3"), Ue("Predictor4", "PredictorAdd4"), Ue("Predictor5", "PredictorAdd5"), Ue("Predictor6", "PredictorAdd6"), Ue("Predictor7", "PredictorAdd7"), Ue("Predictor8", "PredictorAdd8"), Ue("Predictor9", "PredictorAdd9"), Ue("Predictor10", "PredictorAdd10"), Ue("Predictor11", "PredictorAdd11"), Ue("Predictor12", "PredictorAdd12"), Ue("Predictor13", "PredictorAdd13");
    var nc = x.PredictorAdd2;
    Je("ColorIndexInverseTransform", "MapARGB", "32b", function(u) {
      return u >> 8 & 255;
    }, function(u) {
      return u;
    }), Je("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(u) {
      return u;
    }, function(u) {
      return u >> 8 & 255;
    });
    var od, gi = x.ColorIndexInverseTransform, Hs = x.MapARGB, sd = x.VP8LColorIndexInverseTransformAlpha, ld = x.MapAlpha, Ga = x.VP8LPredictorsAdd = [];
    Ga.length = 16, (x.VP8LPredictors = []).length = 16, (x.VP8LPredictorsAdd_C = []).length = 16, (x.VP8LPredictors_C = []).length = 16;
    var Yo, Hr, Pr, Qa, wa, xa, $s, _a, qn, rc, Lr, yi, Gs, cd, ic, Ko, Xo, Ya, Zo, Qs, Jo, Ka, ac, vi, bi, vn, bn, Vn, tr = a(511), Na = a(2041), oc = a(225), Ys = a(767), ud = 0, zp = Na, dd = oc, ni = Ys, wi = tr, fd = 0, pd = 1, F1 = 2, hd = 3, md = 4, qp = 5, I1 = 6, Vp = 7, Wp = 8, gd = 9, Hp = 10, Px = [2, 3, 7], Lx = [3, 3, 11], k1 = [280, 256, 256, 256, 40], Tx = [0, 1, 1, 1, 0], Fx = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], Ix = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], kx = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], Dx = 8, $p = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Gp = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], sc = null, Rx = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], Mx = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], D1 = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], Ux = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], Bx = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], zx = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], qx = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], Xa = [], Mi = [], Sa = [], Vx = 1, R1 = 2, Za = [], xi = [];
    De("UpsampleRgbLinePair", Wt, 3), De("UpsampleBgrLinePair", Pn, 3), De("UpsampleRgbaLinePair", Ri, 4), De("UpsampleBgraLinePair", ar, 4), De("UpsampleArgbLinePair", xr, 4), De("UpsampleRgba4444LinePair", Xn, 2), De("UpsampleRgb565LinePair", zn, 2);
    var Wx = x.UpsampleRgbLinePair, Hx = x.UpsampleBgrLinePair, M1 = x.UpsampleRgbaLinePair, U1 = x.UpsampleBgraLinePair, B1 = x.UpsampleArgbLinePair, z1 = x.UpsampleRgba4444LinePair, $x = x.UpsampleRgb565LinePair, yd = 16, vd = 1 << yd - 1, lc = -227, Qp = 482, Gx = 6, q1 = 0, Qx = a(256), Yx = a(256), Kx = a(256), Xx = a(256), Zx = a(Qp - lc), Jx = a(Qp - lc);
    Ai("YuvToRgbRow", Wt, 3), Ai("YuvToBgrRow", Pn, 3), Ai("YuvToRgbaRow", Ri, 4), Ai("YuvToBgraRow", ar, 4), Ai("YuvToArgbRow", xr, 4), Ai("YuvToRgba4444Row", Xn, 2), Ai("YuvToRgb565Row", zn, 2);
    var V1 = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], bd = [0, 2, 8], Ax = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], e_ = 1;
    this.WebPDecodeRGBA = function(u, h, w, O, B) {
      var V = pd, W = new Ms(), Q = new In();
      W.ba = Q, Q.S = V, Q.width = [Q.width], Q.height = [Q.height];
      var Y = Q.width, Z = Q.height, ge = new Cn();
      if (ge == null || u == null) var Ce = 2;
      else t(ge != null), Ce = Bs(u, h, w, ge.width, ge.height, ge.Pd, ge.Qd, ge.format, null);
      if (Ce != 0 ? Y = 0 : (Y != null && (Y[0] = ge.width[0]), Z != null && (Z[0] = ge.height[0]), Y = 1), Y) {
        Q.width = Q.width[0], Q.height = Q.height[0], O != null && (O[0] = Q.width), B != null && (B[0] = Q.height);
        e: {
          if (O = new Ls(), (B = new Ql()).data = u, B.w = h, B.ha = w, B.kd = 1, h = [0], t(B != null), ((u = Bs(B.data, B.w, B.ha, null, null, null, h, null, B)) == 0 || u == 7) && h[0] && (u = 4), (h = u) == 0) {
            if (t(W != null), O.data = B.data, O.w = B.w + B.offset, O.ha = B.ha - B.offset, O.put = Mn, O.ac = _n, O.bc = er, O.ma = W, B.xa) {
              if ((u = jr()) == null) {
                W = 1;
                break e;
              }
              if (function(Oe, Ne) {
                var qe = [0], ke = [0], ye = [0];
                t: for (; ; ) {
                  if (Oe == null) return 0;
                  if (Ne == null) return Oe.a = 2, 0;
                  if (Oe.l = Ne, Oe.a = 0, oe(Oe.m, Ne.data, Ne.w, Ne.ha), !ht(Oe.m, qe, ke, ye)) {
                    Oe.a = 3;
                    break t;
                  }
                  if (Oe.xb = R1, Ne.width = qe[0], Ne.height = ke[0], !hi(qe[0], ke[0], 1, Oe, null)) break t;
                  return 1;
                }
                return t(Oe.a != 0), 0;
              }(u, O)) {
                if (O = (h = zs(O.width, O.height, W.Oa, W.ba)) == 0) {
                  t: {
                    O = u;
                    n: for (; ; ) {
                      if (O == null) {
                        O = 0;
                        break t;
                      }
                      if (t(O.s.yc != null), t(O.s.Ya != null), t(0 < O.s.Wb), t((w = O.l) != null), t((B = w.ma) != null), O.xb != 0) {
                        if (O.ca = B.ba, O.tb = B.tb, t(O.ca != null), !Al(B.Oa, w, hd)) {
                          O.a = 2;
                          break n;
                        }
                        if (!de(O, w.width) || w.da) break n;
                        if ((w.da || Ot(O.ca.S)) && Ee(), 11 > O.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), O.ca.f.kb.F != null && Ee()), O.Pb && 0 < O.s.ua && O.s.vb.X == null && !Se(O.s.vb, O.s.Wa.Xa)) {
                          O.a = 1;
                          break n;
                        }
                        O.xb = 0;
                      }
                      if (!qr(O, O.V, O.Ba, O.c, O.i, w.o, Xi)) break n;
                      B.Dc = O.Ma, O = 1;
                      break t;
                    }
                    t(O.a != 0), O = 0;
                  }
                  O = !O;
                }
                O && (h = u.a);
              } else h = u.a;
            } else {
              if ((u = new wp()) == null) {
                W = 1;
                break e;
              }
              if (u.Fa = B.na, u.P = B.P, u.qc = B.Sa, Hu(u, O)) {
                if ((h = zs(O.width, O.height, W.Oa, W.ba)) == 0) {
                  if (u.Aa = 0, w = W.Oa, t((B = u) != null), w != null) {
                    if (0 < (Y = 0 > (Y = w.Md) ? 0 : 100 < Y ? 255 : 255 * Y / 100)) {
                      for (Z = ge = 0; 4 > Z; ++Z) 12 > (Ce = B.pb[Z]).lc && (Ce.ia = Y * Ax[0 > Ce.lc ? 0 : Ce.lc] >> 3), ge |= Ce.ia;
                      ge && (alert("todo:VP8InitRandom"), B.ia = 1);
                    }
                    B.Ga = w.Id, 100 < B.Ga ? B.Ga = 100 : 0 > B.Ga && (B.Ga = 0);
                  }
                  xp(u, O) || (h = u.a);
                }
              } else h = u.a;
            }
            h == 0 && W.Oa != null && W.Oa.fd && (h = ec(W.ba));
          }
          W = h;
        }
        V = W != 0 ? null : 11 > V ? Q.f.RGBA.eb : Q.f.kb.y;
      } else V = null;
      return V;
    };
    var W1 = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function c(x, C) {
    for (var D = "", P = 0; P < 4; P++) D += String.fromCharCode(x[C++]);
    return D;
  }
  function d(x, C) {
    return (x[C + 0] << 0 | x[C + 1] << 8 | x[C + 2] << 16) >>> 0;
  }
  function p(x, C) {
    return (x[C + 0] << 0 | x[C + 1] << 8 | x[C + 2] << 16 | x[C + 3] << 24) >>> 0;
  }
  new l();
  var y = [0], f = [0], N = [], b = new l(), S = e, _ = function(x, C) {
    var D = {}, P = 0, L = !1, H = 0, $ = 0;
    if (D.frames = [], !/** @license
     * Copyright (c) 2017 Dominik Homberger
    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
    https://webpjs.appspot.com
    WebPRiffParser dominikhlbg@gmail.com
    */
    function(U, G, K, A) {
      for (var ee = 0; ee < A; ee++) if (U[G + ee] != K.charCodeAt(ee)) return !0;
      return !1;
    }(x, C, "RIFF", 4)) {
      var ae, ce;
      for (p(x, C += 4), C += 8; C < x.length; ) {
        var le = c(x, C), oe = p(x, C += 4);
        C += 4;
        var se = oe + (1 & oe);
        switch (le) {
          case "VP8 ":
          case "VP8L":
            D.frames[P] === void 0 && (D.frames[P] = {}), (I = D.frames[P]).src_off = L ? $ : C - 8, I.src_size = H + oe + 8, P++, L && (L = !1, H = 0, $ = 0);
            break;
          case "VP8X":
            (I = D.header = {}).feature_flags = x[C];
            var J = C + 4;
            I.canvas_width = 1 + d(x, J), J += 3, I.canvas_height = 1 + d(x, J), J += 3;
            break;
          case "ALPH":
            L = !0, H = se + 8, $ = C - 8;
            break;
          case "ANIM":
            (I = D.header).bgcolor = p(x, C), J = C + 4, I.loop_count = (ae = x)[(ce = J) + 0] << 0 | ae[ce + 1] << 8, J += 2;
            break;
          case "ANMF":
            var re, I;
            (I = D.frames[P] = {}).offset_x = 2 * d(x, C), C += 3, I.offset_y = 2 * d(x, C), C += 3, I.width = 1 + d(x, C), C += 3, I.height = 1 + d(x, C), C += 3, I.duration = d(x, C), C += 3, re = x[C++], I.dispose = 1 & re, I.blend = re >> 1 & 1;
        }
        le != "ANMF" && (C += se);
      }
      return D;
    }
  }(S, 0);
  _.response = S, _.rgbaoutput = !0, _.dataurl = !1;
  var E = _.header ? _.header : null, k = _.frames ? _.frames : null;
  if (E) {
    E.loop_counter = E.loop_count, y = [E.canvas_height], f = [E.canvas_width];
    for (var M = 0; M < k.length && k[M].blend != 0; M++) ;
  }
  var F = k[0], q = b.WebPDecodeRGBA(S, F.src_off, F.src_size, f, y);
  F.rgba = q, F.imgwidth = f[0], F.imgheight = y[0];
  for (var j = 0; j < f[0] * y[0] * 4; j++) N[j] = q[j];
  return this.width = f, this.height = y, this.data = N, this;
}
(function(e) {
  var t = function() {
    return typeof Ym == "function";
  }, n = function(y, f, N, b) {
    var S = 4, _ = o;
    switch (b) {
      case e.image_compression.FAST:
        S = 1, _ = a;
        break;
      case e.image_compression.MEDIUM:
        S = 6, _ = s;
        break;
      case e.image_compression.SLOW:
        S = 9, _ = l;
    }
    y = r(y, f, N, _);
    var E = Ym(y, { level: S });
    return e.__addimage__.arrayBufferToBinaryString(E);
  }, r = function(y, f, N, b) {
    for (var S, _, E, k = y.length / f, M = new Uint8Array(y.length + k), F = d(), q = 0; q < k; q += 1) {
      if (E = q * f, S = y.subarray(E, E + f), b) M.set(b(S, N, _), E + q);
      else {
        for (var j, x = F.length, C = []; j < x; j += 1) C[j] = F[j](S, N, _);
        var D = p(C.concat());
        M.set(C[D], E + q);
      }
      _ = S;
    }
    return M;
  }, i = function(y) {
    var f = Array.apply([], y);
    return f.unshift(0), f;
  }, a = function(y, f) {
    var N, b = [], S = y.length;
    b[0] = 1;
    for (var _ = 0; _ < S; _ += 1) N = y[_ - f] || 0, b[_ + 1] = y[_] - N + 256 & 255;
    return b;
  }, o = function(y, f, N) {
    var b, S = [], _ = y.length;
    S[0] = 2;
    for (var E = 0; E < _; E += 1) b = N && N[E] || 0, S[E + 1] = y[E] - b + 256 & 255;
    return S;
  }, s = function(y, f, N) {
    var b, S, _ = [], E = y.length;
    _[0] = 3;
    for (var k = 0; k < E; k += 1) b = y[k - f] || 0, S = N && N[k] || 0, _[k + 1] = y[k] + 256 - (b + S >>> 1) & 255;
    return _;
  }, l = function(y, f, N) {
    var b, S, _, E, k = [], M = y.length;
    k[0] = 4;
    for (var F = 0; F < M; F += 1) b = y[F - f] || 0, S = N && N[F] || 0, _ = N && N[F - f] || 0, E = c(b, S, _), k[F + 1] = y[F] - E + 256 & 255;
    return k;
  }, c = function(y, f, N) {
    if (y === f && f === N) return y;
    var b = Math.abs(f - N), S = Math.abs(y - N), _ = Math.abs(y + f - N - N);
    return b <= S && b <= _ ? y : S <= _ ? f : N;
  }, d = function() {
    return [i, a, o, s, l];
  }, p = function(y) {
    var f = y.map(function(N) {
      return N.reduce(function(b, S) {
        return b + Math.abs(S);
      }, 0);
    });
    return f.indexOf(Math.min.apply(null, f));
  };
  e.processPNG = function(y, f, N, b) {
    var S, _, E, k, M, F, q, j, x, C, D, P, L, H, $, ae = this.decode.FLATE_DECODE, ce = "";
    if (this.__addimage__.isArrayBuffer(y) && (y = new Uint8Array(y)), this.__addimage__.isArrayBufferView(y)) {
      if (y = (E = new YB(y)).imgData, _ = E.bits, S = E.colorSpace, M = E.colors, [4, 6].indexOf(E.colorType) !== -1) {
        if (E.bits === 8) {
          x = (j = E.pixelBitlength == 32 ? new Uint32Array(E.decodePixels().buffer) : E.pixelBitlength == 16 ? new Uint16Array(E.decodePixels().buffer) : new Uint8Array(E.decodePixels().buffer)).length, D = new Uint8Array(x * E.colors), C = new Uint8Array(x);
          var le, oe = E.pixelBitlength - E.bits;
          for (H = 0, $ = 0; H < x; H++) {
            for (L = j[H], le = 0; le < oe; ) D[$++] = L >>> le & 255, le += E.bits;
            C[H] = L >>> le & 255;
          }
        }
        if (E.bits === 16) {
          x = (j = new Uint32Array(E.decodePixels().buffer)).length, D = new Uint8Array(x * (32 / E.pixelBitlength) * E.colors), C = new Uint8Array(x * (32 / E.pixelBitlength)), P = E.colors > 1, H = 0, $ = 0;
          for (var se = 0; H < x; ) L = j[H++], D[$++] = L >>> 0 & 255, P && (D[$++] = L >>> 16 & 255, L = j[H++], D[$++] = L >>> 0 & 255), C[se++] = L >>> 16 & 255;
          _ = 8;
        }
        b !== e.image_compression.NONE && t() ? (y = n(D, E.width * E.colors, E.colors, b), q = n(C, E.width, 1, b)) : (y = D, q = C, ae = void 0);
      }
      if (E.colorType === 3 && (S = this.color_spaces.INDEXED, F = E.palette, E.transparency.indexed)) {
        var J = E.transparency.indexed, re = 0;
        for (H = 0, x = J.length; H < x; ++H) re += J[H];
        if ((re /= 255) === x - 1 && J.indexOf(0) !== -1) k = [J.indexOf(0)];
        else if (re !== x) {
          for (j = E.decodePixels(), C = new Uint8Array(j.length), H = 0, x = j.length; H < x; H++) C[H] = J[j[H]];
          q = n(C, E.width, 1);
        }
      }
      var I = function(U) {
        var G;
        switch (U) {
          case e.image_compression.FAST:
            G = 11;
            break;
          case e.image_compression.MEDIUM:
            G = 13;
            break;
          case e.image_compression.SLOW:
            G = 14;
            break;
          default:
            G = 12;
        }
        return G;
      }(b);
      return ae === this.decode.FLATE_DECODE && (ce = "/Predictor " + I + " "), ce += "/Colors " + M + " /BitsPerComponent " + _ + " /Columns " + E.width, (this.__addimage__.isArrayBuffer(y) || this.__addimage__.isArrayBufferView(y)) && (y = this.__addimage__.arrayBufferToBinaryString(y)), (q && this.__addimage__.isArrayBuffer(q) || this.__addimage__.isArrayBufferView(q)) && (q = this.__addimage__.arrayBufferToBinaryString(q)), { alias: N, data: y, index: f, filter: ae, decodeParameters: ce, transparency: k, palette: F, sMask: q, predictor: I, width: E.width, height: E.height, bitsPerComponent: _, colorSpace: S };
    }
  };
})(xt.API), function(e) {
  e.processGIF89A = function(t, n, r, i) {
    var a = new KB(t), o = a.width, s = a.height, l = [];
    a.decodeAndBlitFrameRGBA(0, l);
    var c = { data: l, width: o, height: s }, d = new Vh(100).encode(c, 100);
    return e.processJPEG.call(this, d, n, r, i);
  }, e.processGIF87A = e.processGIF89A;
}(xt.API), zi.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var e = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(e);
    for (var t = 0; t < e; t++) {
      var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
      this.palette[t] = { red: i, green: r, blue: n, quad: a };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, zi.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var e = "bit" + this.bitPP, t = this.width * this.height * 4;
    this.data = new Uint8Array(t), this[e]();
  } catch (n) {
    hn.log("bit decode error:" + n);
  }
}, zi.prototype.bit1 = function() {
  var e, t = Math.ceil(this.width / 8), n = t % 4;
  for (e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, i = 0; i < t; i++) for (var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++) {
      var l = this.palette[a >> 7 - s & 1];
      this.data[o + 4 * s] = l.blue, this.data[o + 4 * s + 1] = l.green, this.data[o + 4 * s + 2] = l.red, this.data[o + 4 * s + 3] = 255;
    }
    n !== 0 && (this.pos += 4 - n);
  }
}, zi.prototype.bit4 = function() {
  for (var e = Math.ceil(this.width / 2), t = e % 4, n = this.height - 1; n >= 0; n--) {
    for (var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < e; i++) {
      var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, l = 15 & a, c = this.palette[s];
      if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
      c = this.palette[l], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, zi.prototype.bit8 = function() {
  for (var e = this.width % 4, t = this.height - 1; t >= 0; t--) {
    for (var n = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++) {
      var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
      if (i < this.palette.length) {
        var o = this.palette[i];
        this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
      } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, zi.prototype.bit15 = function() {
  for (var e = this.width % 3, t = parseInt("11111", 2), n = this.height - 1; n >= 0; n--) {
    for (var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++) {
      var a = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var o = (a & t) / t * 255 | 0, s = (a >> 5 & t) / t * 255 | 0, l = (a >> 10 & t) / t * 255 | 0, c = a >> 15 ? 255 : 0, d = r * this.width * 4 + 4 * i;
      this.data[d] = l, this.data[d + 1] = s, this.data[d + 2] = o, this.data[d + 3] = c;
    }
    this.pos += e;
  }
}, zi.prototype.bit16 = function() {
  for (var e = this.width % 3, t = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--) {
    for (var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++) {
      var o = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (o & t) / t * 255 | 0, l = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / t * 255 | 0, d = i * this.width * 4 + 4 * a;
      this.data[d] = c, this.data[d + 1] = l, this.data[d + 2] = s, this.data[d + 3] = 255;
    }
    this.pos += e;
  }
}, zi.prototype.bit24 = function() {
  for (var e = this.height - 1; e >= 0; e--) {
    for (var t = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
      var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = t * this.width * 4 + 4 * n;
      this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, zi.prototype.bit32 = function() {
  for (var e = this.height - 1; e >= 0; e--) for (var t = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
    var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = t * this.width * 4 + 4 * n;
    this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
  }
}, zi.prototype.getData = function() {
  return this.data;
}, /**
* @license
* Copyright (c) 2018 Aras Abbasi
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  e.processBMP = function(t, n, r, i) {
    var a = new zi(t, !1), o = a.width, s = a.height, l = { data: a.getData(), width: o, height: s }, c = new Vh(100).encode(l, 100);
    return e.processJPEG.call(this, c, n, r, i);
  };
}(xt.API), l0.prototype.getData = function() {
  return this.data;
}, /**
* @license
* Copyright (c) 2019 Aras Abbasi
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  e.processWEBP = function(t, n, r, i) {
    var a = new l0(t), o = a.width, s = a.height, l = { data: a.getData(), width: o, height: s }, c = new Vh(100).encode(l, 100);
    return e.processJPEG.call(this, c, n, r, i);
  };
}(xt.API), xt.API.processRGBA = function(e, t, n) {
  for (var r = e.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, l = 0, c = 0; c < i; c += 4) {
    var d = r[c], p = r[c + 1], y = r[c + 2], f = r[c + 3];
    a[s++] = d, a[s++] = p, a[s++] = y, o[l++] = f;
  }
  var N = this.__addimage__.arrayBufferToBinaryString(a);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(o), data: N, index: t, alias: n, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: e.width, height: e.height };
}, xt.API.setLanguage = function(e) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[e] !== void 0 && (this.internal.languageSettings.languageCode = e, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, el = xt.API, Zd = el.getCharWidthsArray = function(e, t) {
  var n, r, i = (t = t || {}).font || this.internal.getFont(), a = t.fontSize || this.internal.getFontSize(), o = t.charSpace || this.internal.getCharSpace(), s = t.widths ? t.widths : i.metadata.Unicode.widths, l = s.fof ? s.fof : 1, c = t.kerning ? t.kerning : i.metadata.Unicode.kerning, d = c.fof ? c.fof : 1, p = t.doKerning !== !1, y = 0, f = e.length, N = 0, b = s[0] || l, S = [];
  for (n = 0; n < f; n++) r = e.charCodeAt(n), typeof i.metadata.widthOfString == "function" ? S.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(r)) + o * (1e3 / a) || 0) / 1e3) : (y = p && Yt(c[r]) === "object" && !isNaN(parseInt(c[r][N], 10)) ? c[r][N] / d : 0, S.push((s[r] || b) / l + y)), N = r;
  return S;
}, i0 = el.getStringUnitWidth = function(e, t) {
  var n = (t = t || {}).fontSize || this.internal.getFontSize(), r = t.font || this.internal.getFont(), i = t.charSpace || this.internal.getCharSpace();
  return el.processArabic && (e = el.processArabic(e)), typeof r.metadata.widthOfString == "function" ? r.metadata.widthOfString(e, n, i) / n : Zd.apply(this, arguments).reduce(function(a, o) {
    return a + o;
  }, 0);
}, a0 = function(e, t, n, r) {
  for (var i = [], a = 0, o = e.length, s = 0; a !== o && s + t[a] < n; ) s += t[a], a++;
  i.push(e.slice(0, a));
  var l = a;
  for (s = 0; a !== o; ) s + t[a] > r && (i.push(e.slice(l, a)), s = 0, l = a), s += t[a], a++;
  return l !== a && i.push(e.slice(l, a)), i;
}, o0 = function(e, t, n) {
  n || (n = {});
  var r, i, a, o, s, l, c, d = [], p = [d], y = n.textIndent || 0, f = 0, N = 0, b = e.split(" "), S = Zd.apply(this, [" ", n])[0];
  if (l = n.lineIndent === -1 ? b[0].length + 2 : n.lineIndent || 0) {
    var _ = Array(l).join(" "), E = [];
    b.map(function(M) {
      (M = M.split(/\s*\n/)).length > 1 ? E = E.concat(M.map(function(F, q) {
        return (q && F.length ? `
` : "") + F;
      })) : E.push(M[0]);
    }), b = E, l = i0.apply(this, [_, n]);
  }
  for (a = 0, o = b.length; a < o; a++) {
    var k = 0;
    if (r = b[a], l && r[0] == `
` && (r = r.substr(1), k = 1), y + f + (N = (i = Zd.apply(this, [r, n])).reduce(function(M, F) {
      return M + F;
    }, 0)) > t || k) {
      if (N > t) {
        for (s = a0.apply(this, [r, i, t - (y + f), t]), d.push(s.shift()), d = [s.pop()]; s.length; ) p.push([s.shift()]);
        N = i.slice(r.length - (d[0] ? d[0].length : 0)).reduce(function(M, F) {
          return M + F;
        }, 0);
      } else d = [r];
      p.push(d), y = N + l, f = S;
    } else d.push(r), y += f + N, f = S;
  }
  return c = l ? function(M, F) {
    return (F ? _ : "") + M.join(" ");
  } : function(M) {
    return M.join(" ");
  }, p.map(c);
}, el.splitTextToSize = function(e, t, n) {
  var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(d) {
    if (d.widths && d.kerning) return { widths: d.widths, kerning: d.kerning };
    var p = this.internal.getFont(d.fontName, d.fontStyle);
    return p.metadata.Unicode ? { widths: p.metadata.Unicode.widths || { 0: 1 }, kerning: p.metadata.Unicode.kerning || {} } : { font: p.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, n);
  r = Array.isArray(e) ? e : String(e).split(/\r?\n/);
  var o = 1 * this.internal.scaleFactor * t / i;
  a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
  var s, l, c = [];
  for (s = 0, l = r.length; s < l; s++) c = c.concat(o0.apply(this, [r[s], o, a]));
  return c;
}, function(e) {
  e.__fontmetrics__ = e.__fontmetrics__ || {};
  for (var t = "klmnopqrstuvwxyz", n = {}, r = {}, i = 0; i < t.length; i++) n[t[i]] = "0123456789abcdef"[i], r["0123456789abcdef"[i]] = t[i];
  var a = function(p) {
    return "0x" + parseInt(p, 10).toString(16);
  }, o = e.__fontmetrics__.compress = function(p) {
    var y, f, N, b, S = ["{"];
    for (var _ in p) {
      if (y = p[_], isNaN(parseInt(_, 10)) ? f = "'" + _ + "'" : (_ = parseInt(_, 10), f = (f = a(_).slice(2)).slice(0, -1) + r[f.slice(-1)]), typeof y == "number") y < 0 ? (N = a(y).slice(3), b = "-") : (N = a(y).slice(2), b = ""), N = b + N.slice(0, -1) + r[N.slice(-1)];
      else {
        if (Yt(y) !== "object") throw new Error("Don't know what to do with value type " + Yt(y) + ".");
        N = o(y);
      }
      S.push(f + N);
    }
    return S.push("}"), S.join("");
  }, s = e.__fontmetrics__.uncompress = function(p) {
    if (typeof p != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var y, f, N, b, S = {}, _ = 1, E = S, k = [], M = "", F = "", q = p.length - 1, j = 1; j < q; j += 1) (b = p[j]) == "'" ? y ? (N = y.join(""), y = void 0) : y = [] : y ? y.push(b) : b == "{" ? (k.push([E, N]), E = {}, N = void 0) : b == "}" ? ((f = k.pop())[0][f[1]] = E, N = void 0, E = f[0]) : b == "-" ? _ = -1 : N === void 0 ? n.hasOwnProperty(b) ? (M += n[b], N = parseInt(M, 16) * _, _ = 1, M = "") : M += b : n.hasOwnProperty(b) ? (F += n[b], E[N] = parseInt(F, 16) * _, _ = 1, N = void 0, F = "") : F += b;
    return S;
  }, l = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: s("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, c = { Unicode: { Courier: l, "Courier-Bold": l, "Courier-BoldOblique": l, "Courier-Oblique": l, Helvetica: l, "Helvetica-Bold": l, "Helvetica-BoldOblique": l, "Helvetica-Oblique": l, "Times-Roman": l, "Times-Bold": l, "Times-BoldItalic": l, "Times-Italic": l } }, d = { Unicode: { "Courier-Oblique": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": s("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": s("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: s("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: s("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": s("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": s("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  e.events.push(["addFont", function(p) {
    var y = p.font, f = d.Unicode[y.postScriptName];
    f && (y.metadata.Unicode = {}, y.metadata.Unicode.widths = f.widths, y.metadata.Unicode.kerning = f.kerning);
    var N = c.Unicode[y.postScriptName];
    N && (y.metadata.Unicode.encoding = N, y.encoding = N.codePages[0]);
  }]);
}(xt.API), /**
* @license
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = function(n) {
    for (var r = n.length, i = new Uint8Array(r), a = 0; a < r; a++) i[a] = n.charCodeAt(a);
    return i;
  };
  e.API.events.push(["addFont", function(n) {
    var r = void 0, i = n.font, a = n.instance;
    if (!i.isStandardFont) {
      if (a === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
      if (typeof (r = a.existsFileInVFS(i.postScriptName) === !1 ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
      (function(o, s) {
        s = /^\x00\x01\x00\x00/.test(s) ? t(s) : t(Hc(s)), o.metadata = e.API.TTFFont.open(s), o.metadata.Unicode = o.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, o.metadata.glyIdsUsed = [0];
      })(i, r);
    }
  }]);
}(xt), /** @license
* Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
*
* Permission is hereby granted, free of charge, to any person obtaining
* a copy of this software and associated documentation files (the
* "Software"), to deal in the Software without restriction, including
* without limitation the rights to use, copy, modify, merge, publish,
* distribute, sublicense, and/or sell copies of the Software, and to
* permit persons to whom the Software is furnished to do so, subject to
* the following conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
* MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
* LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
* OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
* WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
* ====================================================================
*/
function(e) {
  function t() {
    return (wt.canvg ? Promise.resolve(wt.canvg) : import("./index.es-DJ3IE5BA-C0Kj7yGU.js")).catch(function(n) {
      return Promise.reject(new Error("Could not load canvg: " + n));
    }).then(function(n) {
      return n.default ? n.default : n;
    });
  }
  xt.API.addSvgAsImage = function(n, r, i, a, o, s, l, c) {
    if (isNaN(r) || isNaN(i)) throw hn.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(a) || isNaN(o)) throw hn.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var d = document.createElement("canvas");
    d.width = a, d.height = o;
    var p = d.getContext("2d");
    p.fillStyle = "#fff", p.fillRect(0, 0, d.width, d.height);
    var y = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, f = this;
    return t().then(function(N) {
      return N.fromString(p, n, y);
    }, function() {
      return Promise.reject(new Error("Could not load canvg."));
    }).then(function(N) {
      return N.render(y);
    }).then(function() {
      f.addImage(d.toDataURL("image/jpeg", 1), r, i, a, o, l, c);
    });
  };
}(), xt.API.putTotalPages = function(e) {
  var t, n = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (t = new RegExp(e, "g"), n = this.internal.getNumberOfPages()) : (t = new RegExp(this.pdfEscape16(e, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var r = 1; r <= this.internal.getNumberOfPages(); r++) for (var i = 0; i < this.internal.pages[r].length; i++) this.internal.pages[r][i] = this.internal.pages[r][i].replace(t, n);
  return this;
}, xt.API.viewerPreferences = function(e, t) {
  var n;
  e = e || {}, t = t || !1;
  var r, i, a, o = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, s = Object.keys(o), l = [], c = 0, d = 0, p = 0;
  function y(N, b) {
    var S, _ = !1;
    for (S = 0; S < N.length; S += 1) N[S] === b && (_ = !0);
    return _;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, e === "reset" || t === !0) {
    var f = s.length;
    for (p = 0; p < f; p += 1) n[s[p]].value = n[s[p]].defaultValue, n[s[p]].explicitSet = !1;
  }
  if (Yt(e) === "object") {
    for (i in e) if (a = e[i], y(s, i) && a !== void 0) {
      if (n[i].type === "boolean" && typeof a == "boolean") n[i].value = a;
      else if (n[i].type === "name" && y(n[i].valueSet, a)) n[i].value = a;
      else if (n[i].type === "integer" && Number.isInteger(a)) n[i].value = a;
      else if (n[i].type === "array") {
        for (c = 0; c < a.length; c += 1) if (r = !0, a[c].length === 1 && typeof a[c][0] == "number") l.push(String(a[c] - 1));
        else if (a[c].length > 1) {
          for (d = 0; d < a[c].length; d += 1) typeof a[c][d] != "number" && (r = !1);
          r === !0 && l.push([a[c][0] - 1, a[c][1] - 1].join(" "));
        }
        n[i].value = "[" + l.join(" ") + "]";
      } else n[i].value = n[i].defaultValue;
      n[i].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var N, b = [];
    for (N in n) n[N].explicitSet === !0 && (n[N].type === "name" ? b.push("/" + N + " /" + n[N].value) : b.push("/" + N + " " + n[N].value));
    b.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + b.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
* @license
* jsPDF XMP metadata plugin
* Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
*
* Permission is hereby granted, free of charge, to any person obtaining
* a copy of this software and associated documentation files (the
* "Software"), to deal in the Software without restriction, including
* without limitation the rights to use, copy, modify, merge, publish,
* distribute, sublicense, and/or sell copies of the Software, and to
* permit persons to whom the Software is furnished to do so, subject to
* the following conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
* MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
* LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
* OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
* WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
* ====================================================================
*/
function(e) {
  var t = function() {
    var r = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', i = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), a = unescape(encodeURIComponent(r)), o = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), s = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), l = unescape(encodeURIComponent("</x:xmpmeta>")), c = a.length + o.length + s.length + i.length + l.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + c + " >>"), this.internal.write("stream"), this.internal.write(i + a + o + s + l), this.internal.write("endstream"), this.internal.write("endobj");
  }, n = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  e.addMetadata = function(r, i) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: r, namespaceuri: i || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", t)), this;
  };
}(xt.API), function(e) {
  var t = e.API, n = t.pdfEscape16 = function(a, o) {
    for (var s, l = o.metadata.Unicode.widths, c = ["", "0", "00", "000", "0000"], d = [""], p = 0, y = a.length; p < y; ++p) {
      if (s = o.metadata.characterToGlyph(a.charCodeAt(p)), o.metadata.glyIdsUsed.push(s), o.metadata.toUnicode[s] = a.charCodeAt(p), l.indexOf(s) == -1 && (l.push(s), l.push([parseInt(o.metadata.widthOfGlyph(s), 10)])), s == "0") return d.join("");
      s = s.toString(16), d.push(c[4 - s.length], s);
    }
    return d.join("");
  }, r = function(a) {
    var o, s, l, c, d, p, y;
    for (d = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, l = [], p = 0, y = (s = Object.keys(a).sort(function(f, N) {
      return f - N;
    })).length; p < y; p++) o = s[p], l.length >= 100 && (d += `
` + l.length + ` beginbfchar
` + l.join(`
`) + `
endbfchar`, l = []), a[o] !== void 0 && a[o] !== null && typeof a[o].toString == "function" && (c = ("0000" + a[o].toString(16)).slice(-4), o = ("0000" + (+o).toString(16)).slice(-4), l.push("<" + o + "><" + c + ">"));
    return l.length && (d += `
` + l.length + ` beginbfchar
` + l.join(`
`) + `
endbfchar
`), d += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  t.events.push(["putFont", function(a) {
    (function(o) {
      var s = o.font, l = o.out, c = o.newObject, d = o.putStream;
      if (s.metadata instanceof e.API.TTFFont && s.encoding === "Identity-H") {
        for (var p = s.metadata.Unicode.widths, y = s.metadata.subset.encode(s.metadata.glyIdsUsed, 1), f = "", N = 0; N < y.length; N++) f += String.fromCharCode(y[N]);
        var b = c();
        d({ data: f, addLength1: !0, objectId: b }), l("endobj");
        var S = c();
        d({ data: r(s.metadata.toUnicode), addLength1: !0, objectId: S }), l("endobj");
        var _ = c();
        l("<<"), l("/Type /FontDescriptor"), l("/FontName /" + rl(s.fontName)), l("/FontFile2 " + b + " 0 R"), l("/FontBBox " + e.API.PDFObject.convert(s.metadata.bbox)), l("/Flags " + s.metadata.flags), l("/StemV " + s.metadata.stemV), l("/ItalicAngle " + s.metadata.italicAngle), l("/Ascent " + s.metadata.ascender), l("/Descent " + s.metadata.decender), l("/CapHeight " + s.metadata.capHeight), l(">>"), l("endobj");
        var E = c();
        l("<<"), l("/Type /Font"), l("/BaseFont /" + rl(s.fontName)), l("/FontDescriptor " + _ + " 0 R"), l("/W " + e.API.PDFObject.convert(p)), l("/CIDToGIDMap /Identity"), l("/DW 1000"), l("/Subtype /CIDFontType2"), l("/CIDSystemInfo"), l("<<"), l("/Supplement 0"), l("/Registry (Adobe)"), l("/Ordering (" + s.encoding + ")"), l(">>"), l(">>"), l("endobj"), s.objectNumber = c(), l("<<"), l("/Type /Font"), l("/Subtype /Type0"), l("/ToUnicode " + S + " 0 R"), l("/BaseFont /" + rl(s.fontName)), l("/Encoding /" + s.encoding), l("/DescendantFonts [" + E + " 0 R]"), l(">>"), l("endobj"), s.isAlreadyPutted = !0;
      }
    })(a);
  }]), t.events.push(["putFont", function(a) {
    (function(o) {
      var s = o.font, l = o.out, c = o.newObject, d = o.putStream;
      if (s.metadata instanceof e.API.TTFFont && s.encoding === "WinAnsiEncoding") {
        for (var p = s.metadata.rawData, y = "", f = 0; f < p.length; f++) y += String.fromCharCode(p[f]);
        var N = c();
        d({ data: y, addLength1: !0, objectId: N }), l("endobj");
        var b = c();
        d({ data: r(s.metadata.toUnicode), addLength1: !0, objectId: b }), l("endobj");
        var S = c();
        l("<<"), l("/Descent " + s.metadata.decender), l("/CapHeight " + s.metadata.capHeight), l("/StemV " + s.metadata.stemV), l("/Type /FontDescriptor"), l("/FontFile2 " + N + " 0 R"), l("/Flags 96"), l("/FontBBox " + e.API.PDFObject.convert(s.metadata.bbox)), l("/FontName /" + rl(s.fontName)), l("/ItalicAngle " + s.metadata.italicAngle), l("/Ascent " + s.metadata.ascender), l(">>"), l("endobj"), s.objectNumber = c();
        for (var _ = 0; _ < s.metadata.hmtx.widths.length; _++) s.metadata.hmtx.widths[_] = parseInt(s.metadata.hmtx.widths[_] * (1e3 / s.metadata.head.unitsPerEm));
        l("<</Subtype/TrueType/Type/Font/ToUnicode " + b + " 0 R/BaseFont/" + rl(s.fontName) + "/FontDescriptor " + S + " 0 R/Encoding/" + s.encoding + " /FirstChar 29 /LastChar 255 /Widths " + e.API.PDFObject.convert(s.metadata.hmtx.widths) + ">>"), l("endobj"), s.isAlreadyPutted = !0;
      }
    })(a);
  }]);
  var i = function(a) {
    var o, s = a.text || "", l = a.x, c = a.y, d = a.options || {}, p = a.mutex || {}, y = p.pdfEscape, f = p.activeFontKey, N = p.fonts, b = f, S = "", _ = 0, E = "", k = N[b].encoding;
    if (N[b].encoding !== "Identity-H") return { text: s, x: l, y: c, options: d, mutex: p };
    for (E = s, b = f, Array.isArray(s) && (E = s[0]), _ = 0; _ < E.length; _ += 1) N[b].metadata.hasOwnProperty("cmap") && (o = N[b].metadata.cmap.unicode.codeMap[E[_].charCodeAt(0)]), o || E[_].charCodeAt(0) < 256 && N[b].metadata.hasOwnProperty("Unicode") ? S += E[_] : S += "";
    var M = "";
    return parseInt(b.slice(1)) < 14 || k === "WinAnsiEncoding" ? M = y(S, b).split("").map(function(F) {
      return F.charCodeAt(0).toString(16);
    }).join("") : k === "Identity-H" && (M = n(S, N[b])), p.isHex = !0, { text: M, x: l, y: c, options: d, mutex: p };
  };
  t.events.push(["postProcessText", function(a) {
    var o = a.text || "", s = [], l = { text: o, x: a.x, y: a.y, options: a.options, mutex: a.mutex };
    if (Array.isArray(o)) {
      var c = 0;
      for (c = 0; c < o.length; c += 1) Array.isArray(o[c]) && o[c].length === 3 ? s.push([i(Object.assign({}, l, { text: o[c][0] })).text, o[c][1], o[c][2]]) : s.push(i(Object.assign({}, l, { text: o[c] })).text);
      a.text = s;
    } else a.text = i(Object.assign({}, l, { text: o })).text;
  }]);
}(xt), /**
* @license
* jsPDF virtual FileSystem functionality
*
* Licensed under the MIT License.
* http://opensource.org/licenses/mit-license
*/
function(e) {
  var t = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  e.existsFileInVFS = function(n) {
    return t.call(this), this.internal.vFS[n] !== void 0;
  }, e.addFileToVFS = function(n, r) {
    return t.call(this), this.internal.vFS[n] = r, this;
  }, e.getFileFromVFS = function(n) {
    return t.call(this), this.internal.vFS[n] !== void 0 ? this.internal.vFS[n] : null;
  };
}(xt.API), /**
* @license
* Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
* MIT License
*/
function(e) {
  e.__bidiEngine__ = e.prototype.__bidiEngine__ = function(r) {
    var i, a, o, s, l, c, d, p = t, y = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], f = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], N = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, b = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, S = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], _ = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), E = !1, k = 0;
    this.__bidiEngine__ = {};
    var M = function(P) {
      var L = P.charCodeAt(), H = L >> 8, $ = b[H];
      return $ !== void 0 ? p[256 * $ + (255 & L)] : H === 252 || H === 253 ? "AL" : _.test(H) ? "L" : H === 8 ? "R" : "N";
    }, F = function(P) {
      for (var L, H = 0; H < P.length; H++) {
        if ((L = M(P.charAt(H))) === "L") return !1;
        if (L === "R") return !0;
      }
      return !1;
    }, q = function(P, L, H, $) {
      var ae, ce, le, oe, se = L[$];
      switch (se) {
        case "L":
        case "R":
          E = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          E && (se = "AN");
          break;
        case "AL":
          E = !0, se = "R";
          break;
        case "WS":
          se = "N";
          break;
        case "CS":
          $ < 1 || $ + 1 >= L.length || (ae = H[$ - 1]) !== "EN" && ae !== "AN" || (ce = L[$ + 1]) !== "EN" && ce !== "AN" ? se = "N" : E && (ce = "AN"), se = ce === ae ? ce : "N";
          break;
        case "ES":
          se = (ae = $ > 0 ? H[$ - 1] : "B") === "EN" && $ + 1 < L.length && L[$ + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if ($ > 0 && H[$ - 1] === "EN") {
            se = "EN";
            break;
          }
          if (E) {
            se = "N";
            break;
          }
          for (le = $ + 1, oe = L.length; le < oe && L[le] === "ET"; ) le++;
          se = le < oe && L[le] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (o && !s) {
            for (oe = L.length, le = $ + 1; le < oe && L[le] === "NSM"; ) le++;
            if (le < oe) {
              var J = P[$], re = J >= 1425 && J <= 2303 || J === 64286;
              if (ae = L[le], re && (ae === "R" || ae === "AL")) {
                se = "R";
                break;
              }
            }
          }
          se = $ < 1 || (ae = L[$ - 1]) === "B" ? "N" : H[$ - 1];
          break;
        case "B":
          E = !1, i = !0, se = k;
          break;
        case "S":
          a = !0, se = "N";
          break;
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          E = !1;
          break;
        case "BN":
          se = "N";
      }
      return se;
    }, j = function(P, L, H) {
      var $ = P.split("");
      return H && x($, H, { hiLevel: k }), $.reverse(), L && L.reverse(), $.join("");
    }, x = function(P, L, H) {
      var $, ae, ce, le, oe, se = -1, J = P.length, re = 0, I = [], U = k ? f : y, G = [];
      for (E = !1, i = !1, a = !1, ae = 0; ae < J; ae++) G[ae] = M(P[ae]);
      for (ce = 0; ce < J; ce++) {
        if (oe = re, I[ce] = q(P, G, I, ce), $ = 240 & (re = U[oe][N[I[ce]]]), re &= 15, L[ce] = le = U[re][5], $ > 0) if ($ === 16) {
          for (ae = se; ae < ce; ae++) L[ae] = 1;
          se = -1;
        } else se = -1;
        if (U[re][6]) se === -1 && (se = ce);
        else if (se > -1) {
          for (ae = se; ae < ce; ae++) L[ae] = le;
          se = -1;
        }
        G[ce] === "B" && (L[ce] = 0), H.hiLevel |= le;
      }
      a && function(K, A, ee) {
        for (var te = 0; te < ee; te++) if (K[te] === "S") {
          A[te] = k;
          for (var ne = te - 1; ne >= 0 && K[ne] === "WS"; ne--) A[ne] = k;
        }
      }(G, L, J);
    }, C = function(P, L, H, $, ae) {
      if (!(ae.hiLevel < P)) {
        if (P === 1 && k === 1 && !i) return L.reverse(), void (H && H.reverse());
        for (var ce, le, oe, se, J = L.length, re = 0; re < J; ) {
          if ($[re] >= P) {
            for (oe = re + 1; oe < J && $[oe] >= P; ) oe++;
            for (se = re, le = oe - 1; se < le; se++, le--) ce = L[se], L[se] = L[le], L[le] = ce, H && (ce = H[se], H[se] = H[le], H[le] = ce);
            re = oe;
          }
          re++;
        }
      }
    }, D = function(P, L, H) {
      var $ = P.split(""), ae = { hiLevel: k };
      return H || (H = []), x($, H, ae), function(ce, le, oe) {
        if (oe.hiLevel !== 0 && d) for (var se, J = 0; J < ce.length; J++) le[J] === 1 && (se = S.indexOf(ce[J])) >= 0 && (ce[J] = S[se + 1]);
      }($, H, ae), C(2, $, L, H, ae), C(1, $, L, H, ae), $.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(P, L, H) {
      if (function(ae, ce) {
        if (ce) for (var le = 0; le < ae.length; le++) ce[le] = le;
        s === void 0 && (s = F(ae)), c === void 0 && (c = F(ae));
      }(P, L), o || !l || c) if (o && l && s ^ c) k = s ? 1 : 0, P = j(P, L, H);
      else if (!o && l && c) k = s ? 1 : 0, P = D(P, L, H), P = j(P, L);
      else if (!o || s || l || c) {
        if (o && !l && s ^ c) P = j(P, L), s ? (k = 0, P = D(P, L, H)) : (k = 1, P = D(P, L, H), P = j(P, L));
        else if (o && s && !l && c) k = 1, P = D(P, L, H), P = j(P, L);
        else if (!o && !l && s ^ c) {
          var $ = d;
          s ? (k = 1, P = D(P, L, H), k = 0, d = !1, P = D(P, L, H), d = $) : (k = 0, P = D(P, L, H), P = j(P, L), k = 1, d = !1, P = D(P, L, H), d = $, P = j(P, L));
        }
      } else k = 0, P = D(P, L, H);
      else k = s ? 1 : 0, P = D(P, L, H);
      return P;
    }, this.__bidiEngine__.setOptions = function(P) {
      P && (o = P.isInputVisual, l = P.isOutputVisual, s = P.isInputRtl, c = P.isOutputRtl, d = P.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(r), this.__bidiEngine__;
  };
  var t = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], n = new e.__bidiEngine__({ isInputVisual: !0 });
  e.API.events.push(["postProcessText", function(r) {
    var i = r.text, a = (r.x, r.y, r.options || {}), o = (r.mutex, a.lang, []);
    if (a.isInputVisual = typeof a.isInputVisual != "boolean" || a.isInputVisual, n.setOptions(a), Object.prototype.toString.call(i) === "[object Array]") {
      var s = 0;
      for (o = [], s = 0; s < i.length; s += 1) Object.prototype.toString.call(i[s]) === "[object Array]" ? o.push([n.doBidiReorder(i[s][0]), i[s][1], i[s][2]]) : o.push([n.doBidiReorder(i[s])]);
      r.text = o;
    } else r.text = n.doBidiReorder(i);
    n.setOptions({ isInputVisual: !0 });
  }]);
}(xt), xt.API.TTFFont = function() {
  function e(t) {
    var n;
    if (this.rawData = t, n = this.contents = new Fo(t), this.contents.pos = 4, n.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    n.pos = 0, this.parse(), this.subset = new uz(this), this.registerTTF();
  }
  return e.open = function(t) {
    return new e(t);
  }, e.prototype.parse = function() {
    return this.directory = new XB(this.contents), this.head = new JB(this), this.name = new rz(this), this.cmap = new ex(this), this.toUnicode = {}, this.hhea = new AB(this), this.maxp = new iz(this), this.hmtx = new az(this), this.post = new tz(this), this.os2 = new ez(this), this.loca = new cz(this), this.glyf = new oz(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, e.prototype.registerTTF = function() {
    var t, n, r, i, a;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var o, s, l, c;
      for (c = [], o = 0, s = (l = this.bbox).length; o < s; o++) t = l[o], c.push(Math.round(t * this.scaleFactor));
      return c;
    }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (i = this.post.italic_angle), 32768 & (n = i >> 16) && (n = -(1 + (65535 ^ n))), this.italicAngle = +(n + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (a = this.familyClass) === 1 || a === 2 || a === 3 || a === 4 || a === 5 || a === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, e.prototype.characterToGlyph = function(t) {
    var n;
    return ((n = this.cmap.unicode) != null ? n.codeMap[t] : void 0) || 0;
  }, e.prototype.widthOfGlyph = function(t) {
    var n;
    return n = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * n;
  }, e.prototype.widthOfString = function(t, n, r) {
    var i, a, o, s;
    for (o = 0, a = 0, s = (t = "" + t).length; 0 <= s ? a < s : a > s; a = 0 <= s ? ++a : --a) i = t.charCodeAt(a), o += this.widthOfGlyph(this.characterToGlyph(i)) + r * (1e3 / n) || 0;
    return o * (n / 1e3);
  }, e.prototype.lineHeight = function(t, n) {
    var r;
    return n == null && (n = !1), r = n ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
  }, e;
}();
var Ki, Fo = function() {
  function e(t) {
    this.data = t ?? [], this.pos = 0, this.length = this.data.length;
  }
  return e.prototype.readByte = function() {
    return this.data[this.pos++];
  }, e.prototype.writeByte = function(t) {
    return this.data[this.pos++] = t;
  }, e.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, e.prototype.writeUInt32 = function(t) {
    return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
  }, e.prototype.readInt32 = function() {
    var t;
    return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
  }, e.prototype.writeInt32 = function(t) {
    return t < 0 && (t += 4294967296), this.writeUInt32(t);
  }, e.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, e.prototype.writeUInt16 = function(t) {
    return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
  }, e.prototype.readInt16 = function() {
    var t;
    return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
  }, e.prototype.writeInt16 = function(t) {
    return t < 0 && (t += 65536), this.writeUInt16(t);
  }, e.prototype.readString = function(t) {
    var n, r;
    for (r = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n) r[n] = String.fromCharCode(this.readByte());
    return r.join("");
  }, e.prototype.writeString = function(t) {
    var n, r, i;
    for (i = [], n = 0, r = t.length; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n) i.push(this.writeByte(t.charCodeAt(n)));
    return i;
  }, e.prototype.readShort = function() {
    return this.readInt16();
  }, e.prototype.writeShort = function(t) {
    return this.writeInt16(t);
  }, e.prototype.readLongLong = function() {
    var t, n, r, i, a, o, s, l;
    return t = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), l = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ n) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ i) + 16777216 * (255 ^ a) + 65536 * (255 ^ o) + 256 * (255 ^ s) + (255 ^ l) + 1) : 72057594037927940 * t + 281474976710656 * n + 1099511627776 * r + 4294967296 * i + 16777216 * a + 65536 * o + 256 * s + l;
  }, e.prototype.writeLongLong = function(t) {
    var n, r;
    return n = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
  }, e.prototype.readInt = function() {
    return this.readInt32();
  }, e.prototype.writeInt = function(t) {
    return this.writeInt32(t);
  }, e.prototype.read = function(t) {
    var n, r;
    for (n = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r) n.push(this.readByte());
    return n;
  }, e.prototype.write = function(t) {
    var n, r, i, a;
    for (a = [], r = 0, i = t.length; r < i; r++) n = t[r], a.push(this.writeByte(n));
    return a;
  }, e;
}(), XB = function() {
  var e;
  function t(n) {
    var r, i, a;
    for (this.scalarType = n.readInt(), this.tableCount = n.readShort(), this.searchRange = n.readShort(), this.entrySelector = n.readShort(), this.rangeShift = n.readShort(), this.tables = {}, i = 0, a = this.tableCount; 0 <= a ? i < a : i > a; i = 0 <= a ? ++i : --i) r = { tag: n.readString(4), checksum: n.readInt(), offset: n.readInt(), length: n.readInt() }, this.tables[r.tag] = r;
  }
  return t.prototype.encode = function(n) {
    var r, i, a, o, s, l, c, d, p, y, f, N, b;
    for (b in f = Object.keys(n).length, l = Math.log(2), p = 16 * Math.floor(Math.log(f) / l), o = Math.floor(p / l), d = 16 * f - p, (i = new Fo()).writeInt(this.scalarType), i.writeShort(f), i.writeShort(p), i.writeShort(o), i.writeShort(d), a = 16 * f, c = i.pos + a, s = null, N = [], n) for (y = n[b], i.writeString(b), i.writeInt(e(y)), i.writeInt(c), i.writeInt(y.length), N = N.concat(y), b === "head" && (s = c), c += y.length; c % 4; ) N.push(0), c++;
    return i.write(N), r = 2981146554 - e(i.data), i.pos = s + 8, i.writeUInt32(r), i.data;
  }, e = function(n) {
    var r, i, a, o;
    for (n = tx.call(n); n.length % 4; ) n.push(0);
    for (a = new Fo(n), i = 0, r = 0, o = n.length; r < o; r = r += 4) i += a.readUInt32();
    return 4294967295 & i;
  }, t;
}(), ZB = {}.hasOwnProperty, ya = function(e, t) {
  for (var n in t) ZB.call(t, n) && (e[n] = t[n]);
  function r() {
    this.constructor = e;
  }
  return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
};
Ki = function() {
  function e(t) {
    var n;
    this.file = t, n = this.file.directory.tables[this.tag], this.exists = !!n, n && (this.offset = n.offset, this.length = n.length, this.parse(this.file.contents));
  }
  return e.prototype.parse = function() {
  }, e.prototype.encode = function() {
  }, e.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, e;
}();
var JB = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "head", t.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.revision = n.readInt(), this.checkSumAdjustment = n.readInt(), this.magicNumber = n.readInt(), this.flags = n.readShort(), this.unitsPerEm = n.readShort(), this.created = n.readLongLong(), this.modified = n.readLongLong(), this.xMin = n.readShort(), this.yMin = n.readShort(), this.xMax = n.readShort(), this.yMax = n.readShort(), this.macStyle = n.readShort(), this.lowestRecPPEM = n.readShort(), this.fontDirectionHint = n.readShort(), this.indexToLocFormat = n.readShort(), this.glyphDataFormat = n.readShort();
  }, t.prototype.encode = function(n) {
    var r;
    return (r = new Fo()).writeInt(this.version), r.writeInt(this.revision), r.writeInt(this.checkSumAdjustment), r.writeInt(this.magicNumber), r.writeShort(this.flags), r.writeShort(this.unitsPerEm), r.writeLongLong(this.created), r.writeLongLong(this.modified), r.writeShort(this.xMin), r.writeShort(this.yMin), r.writeShort(this.xMax), r.writeShort(this.yMax), r.writeShort(this.macStyle), r.writeShort(this.lowestRecPPEM), r.writeShort(this.fontDirectionHint), r.writeShort(n), r.writeShort(this.glyphDataFormat), r.data;
  }, t;
}(), c0 = function() {
  function e(t, n) {
    var r, i, a, o, s, l, c, d, p, y, f, N, b, S, _, E, k;
    switch (this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = n + t.readInt(), p = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (l = 0; l < 256; ++l) this.codeMap[l] = t.readByte();
        break;
      case 4:
        for (f = t.readUInt16(), y = f / 2, t.pos += 6, a = function() {
          var M, F;
          for (F = [], l = M = 0; 0 <= y ? M < y : M > y; l = 0 <= y ? ++M : --M) F.push(t.readUInt16());
          return F;
        }(), t.pos += 2, b = function() {
          var M, F;
          for (F = [], l = M = 0; 0 <= y ? M < y : M > y; l = 0 <= y ? ++M : --M) F.push(t.readUInt16());
          return F;
        }(), c = function() {
          var M, F;
          for (F = [], l = M = 0; 0 <= y ? M < y : M > y; l = 0 <= y ? ++M : --M) F.push(t.readUInt16());
          return F;
        }(), d = function() {
          var M, F;
          for (F = [], l = M = 0; 0 <= y ? M < y : M > y; l = 0 <= y ? ++M : --M) F.push(t.readUInt16());
          return F;
        }(), i = (this.length - t.pos + this.offset) / 2, s = function() {
          var M, F;
          for (F = [], l = M = 0; 0 <= i ? M < i : M > i; l = 0 <= i ? ++M : --M) F.push(t.readUInt16());
          return F;
        }(), l = _ = 0, k = a.length; _ < k; l = ++_) for (S = a[l], r = E = N = b[l]; N <= S ? E <= S : E >= S; r = N <= S ? ++E : --E) d[l] === 0 ? o = r + c[l] : (o = s[d[l] / 2 + (r - N) - (y - l)] || 0) !== 0 && (o += c[l]), this.codeMap[r] = 65535 & o;
    }
    t.pos = p;
  }
  return e.encode = function(t, n) {
    var r, i, a, o, s, l, c, d, p, y, f, N, b, S, _, E, k, M, F, q, j, x, C, D, P, L, H, $, ae, ce, le, oe, se, J, re, I, U, G, K, A, ee, te, ne, ve, _e, pe;
    switch ($ = new Fo(), o = Object.keys(t).sort(function(je, Se) {
      return je - Se;
    }), n) {
      case "macroman":
        for (b = 0, S = function() {
          var je = [];
          for (N = 0; N < 256; ++N) je.push(0);
          return je;
        }(), E = { 0: 0 }, a = {}, ae = 0, se = o.length; ae < se; ae++) E[ne = t[i = o[ae]]] == null && (E[ne] = ++b), a[i] = { old: t[i], new: E[t[i]] }, S[i] = E[t[i]];
        return $.writeUInt16(1), $.writeUInt16(0), $.writeUInt32(12), $.writeUInt16(0), $.writeUInt16(262), $.writeUInt16(0), $.write(S), { charMap: a, subtable: $.data, maxGlyphID: b + 1 };
      case "unicode":
        for (L = [], p = [], k = 0, E = {}, r = {}, _ = c = null, ce = 0, J = o.length; ce < J; ce++) E[F = t[i = o[ce]]] == null && (E[F] = ++k), r[i] = { old: F, new: E[F] }, s = E[F] - i, _ != null && s === c || (_ && p.push(_), L.push(i), c = s), _ = i;
        for (_ && p.push(_), p.push(65535), L.push(65535), D = 2 * (C = L.length), x = 2 * Math.pow(Math.log(C) / Math.LN2, 2), y = Math.log(x / 2) / Math.LN2, j = 2 * C - x, l = [], q = [], f = [], N = le = 0, re = L.length; le < re; N = ++le) {
          if (P = L[N], d = p[N], P === 65535) {
            l.push(0), q.push(0);
            break;
          }
          if (P - (H = r[P].new) >= 32768) for (l.push(0), q.push(2 * (f.length + C - N)), i = oe = P; P <= d ? oe <= d : oe >= d; i = P <= d ? ++oe : --oe) f.push(r[i].new);
          else l.push(H - P), q.push(0);
        }
        for ($.writeUInt16(3), $.writeUInt16(1), $.writeUInt32(12), $.writeUInt16(4), $.writeUInt16(16 + 8 * C + 2 * f.length), $.writeUInt16(0), $.writeUInt16(D), $.writeUInt16(x), $.writeUInt16(y), $.writeUInt16(j), ee = 0, I = p.length; ee < I; ee++) i = p[ee], $.writeUInt16(i);
        for ($.writeUInt16(0), te = 0, U = L.length; te < U; te++) i = L[te], $.writeUInt16(i);
        for (ve = 0, G = l.length; ve < G; ve++) s = l[ve], $.writeUInt16(s);
        for (_e = 0, K = q.length; _e < K; _e++) M = q[_e], $.writeUInt16(M);
        for (pe = 0, A = f.length; pe < A; pe++) b = f[pe], $.writeUInt16(b);
        return { charMap: r, subtable: $.data, maxGlyphID: k + 1 };
    }
  }, e;
}(), ex = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "cmap", t.prototype.parse = function(n) {
    var r, i, a;
    for (n.pos = this.offset, this.version = n.readUInt16(), a = n.readUInt16(), this.tables = [], this.unicode = null, i = 0; 0 <= a ? i < a : i > a; i = 0 <= a ? ++i : --i) r = new c0(n, this.offset), this.tables.push(r), r.isUnicode && this.unicode == null && (this.unicode = r);
    return !0;
  }, t.encode = function(n, r) {
    var i, a;
    return r == null && (r = "macroman"), i = c0.encode(n, r), (a = new Fo()).writeUInt16(0), a.writeUInt16(1), i.table = a.data.concat(i.subtable), i;
  }, t;
}(), AB = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "hhea", t.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.ascender = n.readShort(), this.decender = n.readShort(), this.lineGap = n.readShort(), this.advanceWidthMax = n.readShort(), this.minLeftSideBearing = n.readShort(), this.minRightSideBearing = n.readShort(), this.xMaxExtent = n.readShort(), this.caretSlopeRise = n.readShort(), this.caretSlopeRun = n.readShort(), this.caretOffset = n.readShort(), n.pos += 8, this.metricDataFormat = n.readShort(), this.numberOfMetrics = n.readUInt16();
  }, t;
}(), ez = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "OS/2", t.prototype.parse = function(n) {
    if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
      var r, i;
      for (i = [], r = 0; r < 10; ++r) i.push(n.readByte());
      return i;
    }(), this.charRange = function() {
      var r, i;
      for (i = [], r = 0; r < 4; ++r) i.push(n.readInt());
      return i;
    }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), this.version > 0 && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
      var r, i;
      for (i = [], r = 0; r < 2; r = ++r) i.push(n.readInt());
      return i;
    }(), this.version > 1)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
  }, t;
}(), tz = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "post", t.prototype.parse = function(n) {
    var r, i, a;
    switch (n.pos = this.offset, this.format = n.readInt(), this.italicAngle = n.readInt(), this.underlinePosition = n.readShort(), this.underlineThickness = n.readShort(), this.isFixedPitch = n.readInt(), this.minMemType42 = n.readInt(), this.maxMemType42 = n.readInt(), this.minMemType1 = n.readInt(), this.maxMemType1 = n.readInt(), this.format) {
      case 65536:
        break;
      case 131072:
        var o;
        for (i = n.readUInt16(), this.glyphNameIndex = [], o = 0; 0 <= i ? o < i : o > i; o = 0 <= i ? ++o : --o) this.glyphNameIndex.push(n.readUInt16());
        for (this.names = [], a = []; n.pos < this.offset + this.length; ) r = n.readByte(), a.push(this.names.push(n.readString(r)));
        return a;
      case 151552:
        return i = n.readUInt16(), this.offsets = n.read(i);
      case 196608:
        break;
      case 262144:
        return this.map = (function() {
          var s, l, c;
          for (c = [], o = s = 0, l = this.file.maxp.numGlyphs; 0 <= l ? s < l : s > l; o = 0 <= l ? ++s : --s) c.push(n.readUInt32());
          return c;
        }).call(this);
    }
  }, t;
}(), nz = function(e, t) {
  this.raw = e, this.length = e.length, this.platformID = t.platformID, this.encodingID = t.encodingID, this.languageID = t.languageID;
}, rz = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "name", t.prototype.parse = function(n) {
    var r, i, a, o, s, l, c, d, p, y, f;
    for (n.pos = this.offset, n.readShort(), r = n.readShort(), l = n.readShort(), i = [], o = 0; 0 <= r ? o < r : o > r; o = 0 <= r ? ++o : --o) i.push({ platformID: n.readShort(), encodingID: n.readShort(), languageID: n.readShort(), nameID: n.readShort(), length: n.readShort(), offset: this.offset + l + n.readShort() });
    for (c = {}, o = p = 0, y = i.length; p < y; o = ++p) a = i[o], n.pos = a.offset, d = n.readString(a.length), s = new nz(d, a), c[f = a.nameID] == null && (c[f] = []), c[a.nameID].push(s);
    this.strings = c, this.copyright = c[0], this.fontFamily = c[1], this.fontSubfamily = c[2], this.uniqueSubfamily = c[3], this.fontName = c[4], this.version = c[5];
    try {
      this.postscriptName = c[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = c[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = c[7], this.manufacturer = c[8], this.designer = c[9], this.description = c[10], this.vendorUrl = c[11], this.designerUrl = c[12], this.license = c[13], this.licenseUrl = c[14], this.preferredFamily = c[15], this.preferredSubfamily = c[17], this.compatibleFull = c[18], this.sampleText = c[19];
  }, t;
}(), iz = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "maxp", t.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.numGlyphs = n.readUInt16(), this.maxPoints = n.readUInt16(), this.maxContours = n.readUInt16(), this.maxCompositePoints = n.readUInt16(), this.maxComponentContours = n.readUInt16(), this.maxZones = n.readUInt16(), this.maxTwilightPoints = n.readUInt16(), this.maxStorage = n.readUInt16(), this.maxFunctionDefs = n.readUInt16(), this.maxInstructionDefs = n.readUInt16(), this.maxStackElements = n.readUInt16(), this.maxSizeOfInstructions = n.readUInt16(), this.maxComponentElements = n.readUInt16(), this.maxComponentDepth = n.readUInt16();
  }, t;
}(), az = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "hmtx", t.prototype.parse = function(n) {
    var r, i, a, o, s, l, c;
    for (n.pos = this.offset, this.metrics = [], r = 0, l = this.file.hhea.numberOfMetrics; 0 <= l ? r < l : r > l; r = 0 <= l ? ++r : --r) this.metrics.push({ advance: n.readUInt16(), lsb: n.readInt16() });
    for (a = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
      var d, p;
      for (p = [], r = d = 0; 0 <= a ? d < a : d > a; r = 0 <= a ? ++d : --d) p.push(n.readInt16());
      return p;
    }(), this.widths = (function() {
      var d, p, y, f;
      for (f = [], d = 0, p = (y = this.metrics).length; d < p; d++) o = y[d], f.push(o.advance);
      return f;
    }).call(this), i = this.widths[this.widths.length - 1], c = [], r = s = 0; 0 <= a ? s < a : s > a; r = 0 <= a ? ++s : --s) c.push(this.widths.push(i));
    return c;
  }, t.prototype.forGlyph = function(n) {
    return n in this.metrics ? this.metrics[n] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[n - this.metrics.length] };
  }, t;
}(), tx = [].slice, oz = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "glyf", t.prototype.parse = function() {
    return this.cache = {};
  }, t.prototype.glyphFor = function(n) {
    var r, i, a, o, s, l, c, d, p, y;
    return n in this.cache ? this.cache[n] : (o = this.file.loca, r = this.file.contents, i = o.indexOf(n), (a = o.lengthOf(n)) === 0 ? this.cache[n] = null : (r.pos = this.offset + i, s = (l = new Fo(r.read(a))).readShort(), d = l.readShort(), y = l.readShort(), c = l.readShort(), p = l.readShort(), this.cache[n] = s === -1 ? new lz(l, d, y, c, p) : new sz(l, s, d, y, c, p), this.cache[n]));
  }, t.prototype.encode = function(n, r, i) {
    var a, o, s, l, c;
    for (s = [], o = [], l = 0, c = r.length; l < c; l++) a = n[r[l]], o.push(s.length), a && (s = s.concat(a.encode(i)));
    return o.push(s.length), { table: s, offsets: o };
  }, t;
}(), sz = function() {
  function e(t, n, r, i, a, o) {
    this.raw = t, this.numberOfContours = n, this.xMin = r, this.yMin = i, this.xMax = a, this.yMax = o, this.compound = !1;
  }
  return e.prototype.encode = function() {
    return this.raw.data;
  }, e;
}(), lz = function() {
  function e(t, n, r, i, a) {
    var o, s;
    for (this.raw = t, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; s = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readUInt16()), 32 & s; ) o.pos += 1 & s ? 4 : 2, 128 & s ? o.pos += 8 : 64 & s ? o.pos += 4 : 8 & s && (o.pos += 2);
  }
  return e.prototype.encode = function() {
    var t, n, r;
    for (n = new Fo(tx.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t) n.pos = this.glyphOffsets[t];
    return n.data;
  }, e;
}(), cz = function(e) {
  function t() {
    return t.__super__.constructor.apply(this, arguments);
  }
  return ya(t, Ki), t.prototype.tag = "loca", t.prototype.parse = function(n) {
    var r, i;
    return n.pos = this.offset, r = this.file.head.indexToLocFormat, this.offsets = r === 0 ? (function() {
      var a, o;
      for (o = [], i = 0, a = this.length; i < a; i += 2) o.push(2 * n.readUInt16());
      return o;
    }).call(this) : (function() {
      var a, o;
      for (o = [], i = 0, a = this.length; i < a; i += 4) o.push(n.readUInt32());
      return o;
    }).call(this);
  }, t.prototype.indexOf = function(n) {
    return this.offsets[n];
  }, t.prototype.lengthOf = function(n) {
    return this.offsets[n + 1] - this.offsets[n];
  }, t.prototype.encode = function(n, r) {
    for (var i = new Uint32Array(this.offsets.length), a = 0, o = 0, s = 0; s < i.length; ++s) if (i[s] = a, o < r.length && r[o] == s) {
      ++o, i[s] = a;
      var l = this.offsets[s], c = this.offsets[s + 1] - l;
      c > 0 && (a += c);
    }
    for (var d = new Array(4 * i.length), p = 0; p < i.length; ++p) d[4 * p + 3] = 255 & i[p], d[4 * p + 2] = (65280 & i[p]) >> 8, d[4 * p + 1] = (16711680 & i[p]) >> 16, d[4 * p] = (4278190080 & i[p]) >> 24;
    return d;
  }, t;
}(), uz = function() {
  function e(t) {
    this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return e.prototype.generateCmap = function() {
    var t, n, r, i, a;
    for (n in i = this.font.cmap.tables[0].codeMap, t = {}, a = this.subset) r = a[n], t[n] = i[r];
    return t;
  }, e.prototype.glyphsFor = function(t) {
    var n, r, i, a, o, s, l;
    for (i = {}, o = 0, s = t.length; o < s; o++) i[a = t[o]] = this.font.glyf.glyphFor(a);
    for (a in n = [], i) (r = i[a]) != null && r.compound && n.push.apply(n, r.glyphIDs);
    if (n.length > 0) for (a in l = this.glyphsFor(n)) r = l[a], i[a] = r;
    return i;
  }, e.prototype.encode = function(t, n) {
    var r, i, a, o, s, l, c, d, p, y, f, N, b, S, _;
    for (i in r = ex.encode(this.generateCmap(), "unicode"), o = this.glyphsFor(t), f = { 0: 0 }, _ = r.charMap) f[(l = _[i]).old] = l.new;
    for (N in y = r.maxGlyphID, o) N in f || (f[N] = y++);
    return d = function(E) {
      var k, M;
      for (k in M = {}, E) M[E[k]] = k;
      return M;
    }(f), p = Object.keys(d).sort(function(E, k) {
      return E - k;
    }), b = function() {
      var E, k, M;
      for (M = [], E = 0, k = p.length; E < k; E++) s = p[E], M.push(d[s]);
      return M;
    }(), a = this.font.glyf.encode(o, b, f), c = this.font.loca.encode(a.offsets, b), S = { cmap: this.font.cmap.raw(), glyf: a.table, loca: c, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(n) }, this.font.os2.exists && (S["OS/2"] = this.font.os2.raw()), this.font.directory.encode(S);
  }, e;
}();
xt.API.PDFObject = function() {
  var e;
  function t() {
  }
  return e = function(n, r) {
    return (Array(r + 1).join("0") + n).slice(-r);
  }, t.convert = function(n) {
    var r, i, a, o;
    if (Array.isArray(n)) return "[" + function() {
      var s, l, c;
      for (c = [], s = 0, l = n.length; s < l; s++) r = n[s], c.push(t.convert(r));
      return c;
    }().join(" ") + "]";
    if (typeof n == "string") return "/" + n;
    if (n != null && n.isString) return "(" + n + ")";
    if (n instanceof Date) return "(D:" + e(n.getUTCFullYear(), 4) + e(n.getUTCMonth(), 2) + e(n.getUTCDate(), 2) + e(n.getUTCHours(), 2) + e(n.getUTCMinutes(), 2) + e(n.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(n) === "[object Object]") {
      for (i in a = ["<<"], n) o = n[i], a.push("/" + i + " " + t.convert(o));
      return a.push(">>"), a.join(`
`);
    }
    return "" + n;
  }, t;
}();
const dz = {
  isFetching: !1,
  firstTab: "",
  quadrant: {
    sumOfValues: 0
  },
  subQuadrants: [],
  persona: {},
  personas: [],
  sections: [],
  threshold: null,
  error: {}
}, fz = (e = dz, t) => {
  switch (t.type) {
    case Uk:
      return {
        ...e,
        isFetching: !0
      };
    case Bk:
      return {
        ...e,
        firstTab: t.payload.sections ? t.payload.sections[0].subsections[0].label : "",
        isFetching: !1,
        ...t.payload
      };
    case zk:
      return {
        ...e,
        isFetching: !1,
        threshold: e.threshold,
        error: t.payload
      };
    case kk:
      return {
        ...e,
        threshold: t.payload
      };
    case ip:
      return {
        ...e,
        threshold: t.payload === "find" ? 110 : 0
      };
    default:
      return e;
  }
};
fi((e) => e.messageStreams, (e) => e.campaignCreator.briefsFlow, (e, t) => ({
  sections: e && e.sections ? e.sections.reduce((n, r) => [...n, ...r.subsections], []) : [],
  firstTab: e.firstTab,
  isFetching: e.isFetching
}));
fi((e) => e.messageStreams, (e) => `?personaIds=${e.personas.map((t) => t.id).join(",") || []}`);
class nx extends R.Component {
  render() {
    const {
      colour: t,
      image: n,
      title: r,
      summary: i,
      url: a,
      accessInfo: o
    } = this.props;
    return /* @__PURE__ */ m.jsxs("div", { className: "community-tile", style: {
      borderTop: `3px solid ${t}`
    }, children: [
      /* @__PURE__ */ m.jsx("div", { className: "community-tile__image-wrapper", children: /* @__PURE__ */ m.jsx("img", { className: "community-tile__image", src: n, alt: "" }) }),
      /* @__PURE__ */ m.jsxs("div", { className: "segment-tile--text", children: [
        o && o.paidSubscriber && /* @__PURE__ */ m.jsx(wn, { to: a, className: "no-underline", children: /* @__PURE__ */ m.jsx("h4", { className: "community-tile--title", children: uf(r.replace("-", " ")) }) }),
        o && !o.paidSubscriber && /* @__PURE__ */ m.jsx(Gi, { trigger: /* @__PURE__ */ m.jsx(wn, { to: "#", className: "no-underline", children: /* @__PURE__ */ m.jsx("h4", { className: "community-tile--title", children: uf(r.replace("-", " ")) }) }), position: "top center", on: "click", children: /* @__PURE__ */ m.jsxs(Gi.Content, { children: [
          "This is a paid subscriber feature. For more info please Contact Roy Morgan at",
          " ",
          /* @__PURE__ */ m.jsx("a", { href: "mailto:info@helixpersonas.com.au", children: "info@helixpersonas.com.au" })
        ] }) }),
        /* @__PURE__ */ m.jsx("div", { className: "community-tile--summary", children: uf(i) })
      ] }),
      /* @__PURE__ */ m.jsx("div", { className: "community-tile-menu", style: {
        color: t
      }, children: this.props.children })
    ] });
  }
}
function pz({
  persona: e,
  selectedPersonas: t,
  removeSelectedPersona: n,
  addSelectedPersona: r
}) {
  var i, a;
  const o = async (s) => {
    t.find((l) => l.id === s.id) ? await n(s) : await r(s);
  };
  return /* @__PURE__ */ m.jsx(
    dr,
    {
      style: {
        background: (i = e == null ? void 0 : e.acf) == null ? void 0 : i.color,
        color: (a = e == null ? void 0 : e.acf) == null ? void 0 : a.color
      },
      onClick: () => {
        o({
          id: parseInt(e.postName),
          name: e.acf.title
        });
      },
      checked: !!t.find((s) => parseInt(s.id) === parseInt(e.postName)),
      className: "community-tile--checkbox",
      "data-canonical-name": e.postName + " " + e.acf.title,
      label: /* @__PURE__ */ m.jsxs("label", { className: "community-tile--checkbox-label", children: [
        /* @__PURE__ */ m.jsx("span", { className: "community-tile-menu__number", children: e.acf.personacommunityNumber }),
        " ",
        /* @__PURE__ */ m.jsx("span", { className: "community-tile-menu__name", children: e.acf.title })
      ] })
    }
  );
}
const hz = {
  isFetching: !1,
  bySlug: {},
  order: []
}, mz = (e = hz, t) => {
  switch (t.type) {
    case Iw:
      return {
        ...e,
        isFetching: !0,
        accessInfo: {}
      };
    case Dw:
      return {
        ...e,
        isFetching: !1,
        accessInfo: t.accessInfo && t.accessInfo.content
      };
    case kw:
      return {
        ...e,
        ...t.payload,
        isFetching: !1,
        accessInfo: t.accessInfo && t.accessInfo.content
      };
    default:
      return e;
  }
}, qu = fi((e) => e.communities.bySlug, (e) => e && Object.keys(e).sort(function(t, n) {
  return e[t].postTitle === void 0 || e[n].postTitle === void 0 ? 0 : e[t].postTitle.toLowerCase() < e[n].postTitle.toLowerCase() ? -1 : e[t].postTitle.toLowerCase() > e[n].postTitle.toLowerCase() ? 1 : 0;
}).map(function(t) {
  return e[t];
}));
fi((e) => qu(e), (e) => e.map((t) => t.acf.featuredImage.sizes.medium));
const gz = fi((e) => qu(e), (e) => e.reduce((t, n) => {
  const r = n.personas.map((i) => i.postName);
  return [...t, ...r];
}, []));
let yz = class extends R.Component {
  constructor(e) {
    super(e), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "handleCheckBoxAction", () => {
      this.props.loadGroupedPersona();
    }), this.state = {
      showSidebar: !1
    };
  }
  componentDidMount() {
    this.props.briefsFlow !== "select" && (this.props.setBriefsFlow("select"), this.props.selectedPersonas.length && this.props.resetSelectedPersonas()), this.props.loadCommunitiesAndPersonas(), this.props.featureAccess();
  }
  render() {
    const {
      selectedPersonas: e,
      removeSelectedPersona: t,
      campaignCreatorAccess: n,
      communities: r,
      accessInfo: i,
      isFetchingCommunities: a,
      addSelectedPersona: o
    } = this.props;
    return a || !r ? /* @__PURE__ */ m.jsx(ga, {}) : n ? /* @__PURE__ */ m.jsxs(fr, { children: [
      /* @__PURE__ */ m.jsxs("div", { className: "creative-briefs--navigation creative-briefs--navigation__x-pad", children: [
        /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "getting-started", children: "Back" }),
        /* @__PURE__ */ m.jsx("h1", { className: "campaign-creator--title", children: "Select Your Helix Personas" }),
        /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "message-streams", children: "Next" })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "campaign-creator-page", children: [
        /* @__PURE__ */ m.jsx("div", { className: "select-segments-flex", children: r && r.map((s, l) => /* @__PURE__ */ m.jsx(
          nx,
          {
            colour: s.acf.color,
            title: `${s.acf.personacommunityNumber} - ${s.acf.title}`,
            summary: s.acf.listingSummary,
            image: s.acf.featuredImage.url,
            url: `/personas/${s.postName}`,
            accessInfo: i,
            children: s.personas && s.personas.slice(0).sort(function(c, d) {
              return d.acf.personacommunityNumber < c.acf.personacommunityNumber ? 1 : d.acf.personacommunityNumber > c.acf.personacommunityNumber ? -1 : 0;
            }).map((c, d) => /* @__PURE__ */ m.jsx(pz, { persona: c, selectedPersonas: e, addSelectedPersona: o, removeSelectedPersona: t }, d))
          },
          l
        )) }),
        /* @__PURE__ */ m.jsxs("div", { className: "creative-briefs--navigation", children: [
          /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "getting-started", children: "Back" }),
          /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "message-streams", children: "Next" })
        ] })
      ] })
    ] }) : null;
  }
};
const vz = (e, t) => {
  let {
    workflowPermission: n
  } = e.options.permissions;
  return {
    accessInfo: e.communities && e.communities.accessInfo,
    communities: e.communities && qu(e),
    isFetchingCommunities: e.communities && e.communities.isFetching,
    selectedPersonas: e.selectedPersonas.personas,
    briefsFlow: e.campaignCreator.briefsFlow,
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess
  };
}, bz = (e) => Kt({
  addSelectedPersona: zu,
  removeSelectedPersona: Es,
  featureAccess: ui,
  loadGroupedPersona: Ss,
  loadCommunitiesAndPersonas: i1,
  resetSelectedPersonas: ap,
  setBriefsFlow: d1
}, e);
Mt(vz, bz)(yz);
var rx = { exports: {} };
/* @license
Papa Parse
v5.5.2
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, t) {
  ((n, r) => {
    e.exports = r();
  })(xn, function n() {
    var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i, a = !r.document && !!r.postMessage, o = r.IS_PAPA_WORKER || !1, s = {}, l = 0, c = {};
    function d(x) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(C) {
        var D = F(C);
        D.chunkSize = parseInt(D.chunkSize), C.step || C.chunk || (D.chunkSize = null), this._handle = new b(D), (this._handle.streamer = this)._config = D;
      }).call(this, x), this.parseChunk = function(C, D) {
        var P = parseInt(this._config.skipFirstNLines) || 0;
        if (this.isFirstChunk && 0 < P) {
          let H = this._config.newline;
          H || (L = this._config.quoteChar || '"', H = this._handle.guessLineEndings(C, L)), C = [...C.split(H).slice(P)].join(H);
        }
        this.isFirstChunk && j(this._config.beforeFirstChunk) && (L = this._config.beforeFirstChunk(C)) !== void 0 && (C = L), this.isFirstChunk = !1, this._halted = !1;
        var P = this._partialLine + C, L = (this._partialLine = "", this._handle.parse(P, this._baseIndex, !this._finished));
        if (!this._handle.paused() && !this._handle.aborted()) {
          if (C = L.meta.cursor, P = (this._finished || (this._partialLine = P.substring(C - this._baseIndex), this._baseIndex = C), L && L.data && (this._rowCount += L.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), o) r.postMessage({ results: L, workerId: c.WORKER_ID, finished: P });
          else if (j(this._config.chunk) && !D) {
            if (this._config.chunk(L, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            this._completeResults = L = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(L.data), this._completeResults.errors = this._completeResults.errors.concat(L.errors), this._completeResults.meta = L.meta), this._completed || !P || !j(this._config.complete) || L && L.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), P || L && L.meta.paused || this._nextChunk(), L;
        }
        this._halted = !0;
      }, this._sendError = function(C) {
        j(this._config.error) ? this._config.error(C) : o && this._config.error && r.postMessage({ workerId: c.WORKER_ID, error: C, finished: !1 });
      };
    }
    function p(x) {
      var C;
      (x = x || {}).chunkSize || (x.chunkSize = c.RemoteChunkSize), d.call(this, x), this._nextChunk = a ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(D) {
        this._input = D, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished) this._chunkLoaded();
        else {
          if (C = new XMLHttpRequest(), this._config.withCredentials && (C.withCredentials = this._config.withCredentials), a || (C.onload = q(this._chunkLoaded, this), C.onerror = q(this._chunkError, this)), C.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !a), this._config.downloadRequestHeaders) {
            var D, P = this._config.downloadRequestHeaders;
            for (D in P) C.setRequestHeader(D, P[D]);
          }
          var L;
          this._config.chunkSize && (L = this._start + this._config.chunkSize - 1, C.setRequestHeader("Range", "bytes=" + this._start + "-" + L));
          try {
            C.send(this._config.downloadRequestBody);
          } catch (H) {
            this._chunkError(H.message);
          }
          a && C.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        C.readyState === 4 && (C.status < 200 || 400 <= C.status ? this._chunkError() : (this._start += this._config.chunkSize || C.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((D) => (D = D.getResponseHeader("Content-Range")) !== null ? parseInt(D.substring(D.lastIndexOf("/") + 1)) : -1)(C), this.parseChunk(C.responseText)));
      }, this._chunkError = function(D) {
        D = C.statusText || D, this._sendError(new Error(D));
      };
    }
    function y(x) {
      (x = x || {}).chunkSize || (x.chunkSize = c.LocalChunkSize), d.call(this, x);
      var C, D, P = typeof FileReader < "u";
      this.stream = function(L) {
        this._input = L, D = L.slice || L.webkitSlice || L.mozSlice, P ? ((C = new FileReader()).onload = q(this._chunkLoaded, this), C.onerror = q(this._chunkError, this)) : C = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var L = this._input, H = (this._config.chunkSize && (H = Math.min(this._start + this._config.chunkSize, this._input.size), L = D.call(L, this._start, H)), C.readAsText(L, this._config.encoding));
        P || this._chunkLoaded({ target: { result: H } });
      }, this._chunkLoaded = function(L) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(L.target.result);
      }, this._chunkError = function() {
        this._sendError(C.error);
      };
    }
    function f(x) {
      var C;
      d.call(this, x = x || {}), this.stream = function(D) {
        return C = D, this._nextChunk();
      }, this._nextChunk = function() {
        var D, P;
        if (!this._finished) return D = this._config.chunkSize, C = D ? (P = C.substring(0, D), C.substring(D)) : (P = C, ""), this._finished = !C, this.parseChunk(P);
      };
    }
    function N(x) {
      d.call(this, x = x || {});
      var C = [], D = !0, P = !1;
      this.pause = function() {
        d.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        d.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(L) {
        this._input = L, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        P && C.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), C.length ? this.parseChunk(C.shift()) : D = !0;
      }, this._streamData = q(function(L) {
        try {
          C.push(typeof L == "string" ? L : L.toString(this._config.encoding)), D && (D = !1, this._checkIsFinished(), this.parseChunk(C.shift()));
        } catch (H) {
          this._streamError(H);
        }
      }, this), this._streamError = q(function(L) {
        this._streamCleanUp(), this._sendError(L);
      }, this), this._streamEnd = q(function() {
        this._streamCleanUp(), P = !0, this._streamData("");
      }, this), this._streamCleanUp = q(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function b(x) {
      var C, D, P, L, H = Math.pow(2, 53), $ = -H, ae = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, ce = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, le = this, oe = 0, se = 0, J = !1, re = !1, I = [], U = { data: [], errors: [], meta: {} };
      function G(te) {
        return x.skipEmptyLines === "greedy" ? te.join("").trim() === "" : te.length === 1 && te[0].length === 0;
      }
      function K() {
        if (U && P && (ee("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + c.DefaultDelimiter + "'"), P = !1), x.skipEmptyLines && (U.data = U.data.filter(function(_e) {
          return !G(_e);
        })), A()) {
          let _e = function(pe, je) {
            j(x.transformHeader) && (pe = x.transformHeader(pe, je)), I.push(pe);
          };
          if (U) if (Array.isArray(U.data[0])) {
            for (var te = 0; A() && te < U.data.length; te++) U.data[te].forEach(_e);
            U.data.splice(0, 1);
          } else U.data.forEach(_e);
        }
        function ne(_e, pe) {
          for (var je = x.header ? {} : [], Se = 0; Se < _e.length; Se++) {
            var be = Se, X = _e[Se], X = ((Ye, Re) => ((Te) => (x.dynamicTypingFunction && x.dynamicTyping[Te] === void 0 && (x.dynamicTyping[Te] = x.dynamicTypingFunction(Te)), (x.dynamicTyping[Te] || x.dynamicTyping) === !0))(Ye) ? Re === "true" || Re === "TRUE" || Re !== "false" && Re !== "FALSE" && (((Te) => {
              if (ae.test(Te) && (Te = parseFloat(Te), $ < Te && Te < H))
                return 1;
            })(Re) ? parseFloat(Re) : ce.test(Re) ? new Date(Re) : Re === "" ? null : Re) : Re)(be = x.header ? Se >= I.length ? "__parsed_extra" : I[Se] : be, X = x.transform ? x.transform(X, be) : X);
            be === "__parsed_extra" ? (je[be] = je[be] || [], je[be].push(X)) : je[be] = X;
          }
          return x.header && (Se > I.length ? ee("FieldMismatch", "TooManyFields", "Too many fields: expected " + I.length + " fields but parsed " + Se, se + pe) : Se < I.length && ee("FieldMismatch", "TooFewFields", "Too few fields: expected " + I.length + " fields but parsed " + Se, se + pe)), je;
        }
        var ve;
        U && (x.header || x.dynamicTyping || x.transform) && (ve = 1, !U.data.length || Array.isArray(U.data[0]) ? (U.data = U.data.map(ne), ve = U.data.length) : U.data = ne(U.data, 0), x.header && U.meta && (U.meta.fields = I), se += ve);
      }
      function A() {
        return x.header && I.length === 0;
      }
      function ee(te, ne, ve, _e) {
        te = { type: te, code: ne, message: ve }, _e !== void 0 && (te.row = _e), U.errors.push(te);
      }
      j(x.step) && (L = x.step, x.step = function(te) {
        U = te, A() ? K() : (K(), U.data.length !== 0 && (oe += te.data.length, x.preview && oe > x.preview ? D.abort() : (U.data = U.data[0], L(U, le))));
      }), this.parse = function(te, ne, ve) {
        var _e = x.quoteChar || '"', _e = (x.newline || (x.newline = this.guessLineEndings(te, _e)), P = !1, x.delimiter ? j(x.delimiter) && (x.delimiter = x.delimiter(te), U.meta.delimiter = x.delimiter) : ((_e = ((pe, je, Se, be, X) => {
          var Ye, Re, Te, Ue;
          X = X || [",", "	", "|", ";", c.RECORD_SEP, c.UNIT_SEP];
          for (var T = 0; T < X.length; T++) {
            for (var fe, xe = X[T], Fe = 0, Ge = 0, Me = 0, Ie = (Te = void 0, new _({ comments: be, delimiter: xe, newline: je, preview: 10 }).parse(pe)), ct = 0; ct < Ie.data.length; ct++) Se && G(Ie.data[ct]) ? Me++ : (fe = Ie.data[ct].length, Ge += fe, Te === void 0 ? Te = fe : 0 < fe && (Fe += Math.abs(fe - Te), Te = fe));
            0 < Ie.data.length && (Ge /= Ie.data.length - Me), (Re === void 0 || Fe <= Re) && (Ue === void 0 || Ue < Ge) && 1.99 < Ge && (Re = Fe, Ye = xe, Ue = Ge);
          }
          return { successful: !!(x.delimiter = Ye), bestDelimiter: Ye };
        })(te, x.newline, x.skipEmptyLines, x.comments, x.delimitersToGuess)).successful ? x.delimiter = _e.bestDelimiter : (P = !0, x.delimiter = c.DefaultDelimiter), U.meta.delimiter = x.delimiter), F(x));
        return x.preview && x.header && _e.preview++, C = te, D = new _(_e), U = D.parse(C, ne, ve), K(), J ? { meta: { paused: !0 } } : U || { meta: { paused: !1 } };
      }, this.paused = function() {
        return J;
      }, this.pause = function() {
        J = !0, D.abort(), C = j(x.chunk) ? "" : C.substring(D.getCharIndex());
      }, this.resume = function() {
        le.streamer._halted ? (J = !1, le.streamer.parseChunk(C, !0)) : setTimeout(le.resume, 3);
      }, this.aborted = function() {
        return re;
      }, this.abort = function() {
        re = !0, D.abort(), U.meta.aborted = !0, j(x.complete) && x.complete(U), C = "";
      }, this.guessLineEndings = function(pe, _e) {
        pe = pe.substring(0, 1048576);
        var _e = new RegExp(S(_e) + "([^]*?)" + S(_e), "gm"), ve = (pe = pe.replace(_e, "")).split("\r"), _e = pe.split(`
`), pe = 1 < _e.length && _e[0].length < ve[0].length;
        if (ve.length === 1 || pe) return `
`;
        for (var je = 0, Se = 0; Se < ve.length; Se++) ve[Se][0] === `
` && je++;
        return je >= ve.length / 2 ? `\r
` : "\r";
      };
    }
    function S(x) {
      return x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function _(x) {
      var C = (x = x || {}).delimiter, D = x.newline, P = x.comments, L = x.step, H = x.preview, $ = x.fastMode, ae = null, ce = !1, le = x.quoteChar == null ? '"' : x.quoteChar, oe = le;
      if (x.escapeChar !== void 0 && (oe = x.escapeChar), (typeof C != "string" || -1 < c.BAD_DELIMITERS.indexOf(C)) && (C = ","), P === C) throw new Error("Comment character same as delimiter");
      P === !0 ? P = "#" : (typeof P != "string" || -1 < c.BAD_DELIMITERS.indexOf(P)) && (P = !1), D !== `
` && D !== "\r" && D !== `\r
` && (D = `
`);
      var se = 0, J = !1;
      this.parse = function(re, I, U) {
        if (typeof re != "string") throw new Error("Input must be a string");
        var G = re.length, K = C.length, A = D.length, ee = P.length, te = j(L), ne = [], ve = [], _e = [], pe = se = 0;
        if (!re) return Fe();
        if ($ || $ !== !1 && re.indexOf(le) === -1) {
          for (var je = re.split(D), Se = 0; Se < je.length; Se++) {
            if (_e = je[Se], se += _e.length, Se !== je.length - 1) se += D.length;
            else if (U) return Fe();
            if (!P || _e.substring(0, ee) !== P) {
              if (te) {
                if (ne = [], Ue(_e.split(C)), Ge(), J) return Fe();
              } else Ue(_e.split(C));
              if (H && H <= Se) return ne = ne.slice(0, H), Fe(!0);
            }
          }
          return Fe();
        }
        for (var be = re.indexOf(C, se), X = re.indexOf(D, se), Ye = new RegExp(S(oe) + S(le), "g"), Re = re.indexOf(le, se); ; ) if (re[se] === le) for (Re = se, se++; ; ) {
          if ((Re = re.indexOf(le, Re + 1)) === -1) return U || ve.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: ne.length, index: se }), fe();
          if (Re === G - 1) return fe(re.substring(se, Re).replace(Ye, le));
          if (le === oe && re[Re + 1] === oe) Re++;
          else if (le === oe || Re === 0 || re[Re - 1] !== oe) {
            be !== -1 && be < Re + 1 && (be = re.indexOf(C, Re + 1));
            var Te = T((X = X !== -1 && X < Re + 1 ? re.indexOf(D, Re + 1) : X) === -1 ? be : Math.min(be, X));
            if (re.substr(Re + 1 + Te, K) === C) {
              _e.push(re.substring(se, Re).replace(Ye, le)), re[se = Re + 1 + Te + K] !== le && (Re = re.indexOf(le, se)), be = re.indexOf(C, se), X = re.indexOf(D, se);
              break;
            }
            if (Te = T(X), re.substring(Re + 1 + Te, Re + 1 + Te + A) === D) {
              if (_e.push(re.substring(se, Re).replace(Ye, le)), xe(Re + 1 + Te + A), be = re.indexOf(C, se), Re = re.indexOf(le, se), te && (Ge(), J)) return Fe();
              if (H && ne.length >= H) return Fe(!0);
              break;
            }
            ve.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: ne.length, index: se }), Re++;
          }
        }
        else if (P && _e.length === 0 && re.substring(se, se + ee) === P) {
          if (X === -1) return Fe();
          se = X + A, X = re.indexOf(D, se), be = re.indexOf(C, se);
        } else if (be !== -1 && (be < X || X === -1)) _e.push(re.substring(se, be)), se = be + K, be = re.indexOf(C, se);
        else {
          if (X === -1) break;
          if (_e.push(re.substring(se, X)), xe(X + A), te && (Ge(), J)) return Fe();
          if (H && ne.length >= H) return Fe(!0);
        }
        return fe();
        function Ue(Me) {
          ne.push(Me), pe = se;
        }
        function T(Me) {
          var Ie = 0;
          return Ie = Me !== -1 && (Me = re.substring(Re + 1, Me)) && Me.trim() === "" ? Me.length : Ie;
        }
        function fe(Me) {
          return U || (Me === void 0 && (Me = re.substring(se)), _e.push(Me), se = G, Ue(_e), te && Ge()), Fe();
        }
        function xe(Me) {
          se = Me, Ue(_e), _e = [], X = re.indexOf(D, se);
        }
        function Fe(Me) {
          if (x.header && !I && ne.length && !ce) {
            var Ie = ne[0], ct = {}, at = new Set(Ie);
            let Je = !1;
            for (let $e = 0; $e < Ie.length; $e++) {
              let _t = Ie[$e];
              if (ct[_t = j(x.transformHeader) ? x.transformHeader(_t, $e) : _t]) {
                let dt, Ut = ct[_t];
                for (; dt = _t + "_" + Ut, Ut++, at.has(dt); ) ;
                at.add(dt), Ie[$e] = dt, ct[_t]++, Je = !0, (ae = ae === null ? {} : ae)[dt] = _t;
              } else ct[_t] = 1, Ie[$e] = _t;
              at.add(_t);
            }
            Je && console.warn("Duplicate headers found and renamed."), ce = !0;
          }
          return { data: ne, errors: ve, meta: { delimiter: C, linebreak: D, aborted: J, truncated: !!Me, cursor: pe + (I || 0), renamedHeaders: ae } };
        }
        function Ge() {
          L(Fe()), ne = [], ve = [];
        }
      }, this.abort = function() {
        J = !0;
      }, this.getCharIndex = function() {
        return se;
      };
    }
    function E(x) {
      var C = x.data, D = s[C.workerId], P = !1;
      if (C.error) D.userError(C.error, C.file);
      else if (C.results && C.results.data) {
        var L = { abort: function() {
          P = !0, k(C.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: M, resume: M };
        if (j(D.userStep)) {
          for (var H = 0; H < C.results.data.length && (D.userStep({ data: C.results.data[H], errors: C.results.errors, meta: C.results.meta }, L), !P); H++) ;
          delete C.results;
        } else j(D.userChunk) && (D.userChunk(C.results, L, C.file), delete C.results);
      }
      C.finished && !P && k(C.workerId, C.results);
    }
    function k(x, C) {
      var D = s[x];
      j(D.userComplete) && D.userComplete(C), D.terminate(), delete s[x];
    }
    function M() {
      throw new Error("Not implemented.");
    }
    function F(x) {
      if (typeof x != "object" || x === null) return x;
      var C, D = Array.isArray(x) ? [] : {};
      for (C in x) D[C] = F(x[C]);
      return D;
    }
    function q(x, C) {
      return function() {
        x.apply(C, arguments);
      };
    }
    function j(x) {
      return typeof x == "function";
    }
    return c.parse = function(x, C) {
      var D = (C = C || {}).dynamicTyping || !1;
      if (j(D) && (C.dynamicTypingFunction = D, D = {}), C.dynamicTyping = D, C.transform = !!j(C.transform) && C.transform, !C.worker || !c.WORKERS_SUPPORTED) return D = null, c.NODE_STREAM_INPUT, typeof x == "string" ? (x = ((P) => P.charCodeAt(0) !== 65279 ? P : P.slice(1))(x), D = new (C.download ? p : f)(C)) : x.readable === !0 && j(x.read) && j(x.on) ? D = new N(C) : (r.File && x instanceof File || x instanceof Object) && (D = new y(C)), D.stream(x);
      (D = (() => {
        var P;
        return !!c.WORKERS_SUPPORTED && (P = (() => {
          var L = r.URL || r.webkitURL || null, H = n.toString();
          return c.BLOB_URL || (c.BLOB_URL = L.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", H, ")();"], { type: "text/javascript" })));
        })(), (P = new r.Worker(P)).onmessage = E, P.id = l++, s[P.id] = P);
      })()).userStep = C.step, D.userChunk = C.chunk, D.userComplete = C.complete, D.userError = C.error, C.step = j(C.step), C.chunk = j(C.chunk), C.complete = j(C.complete), C.error = j(C.error), delete C.worker, D.postMessage({ input: x, config: C, workerId: D.id });
    }, c.unparse = function(x, C) {
      var D = !1, P = !0, L = ",", H = `\r
`, $ = '"', ae = $ + $, ce = !1, le = null, oe = !1, se = ((() => {
        if (typeof C == "object") {
          if (typeof C.delimiter != "string" || c.BAD_DELIMITERS.filter(function(I) {
            return C.delimiter.indexOf(I) !== -1;
          }).length || (L = C.delimiter), typeof C.quotes != "boolean" && typeof C.quotes != "function" && !Array.isArray(C.quotes) || (D = C.quotes), typeof C.skipEmptyLines != "boolean" && typeof C.skipEmptyLines != "string" || (ce = C.skipEmptyLines), typeof C.newline == "string" && (H = C.newline), typeof C.quoteChar == "string" && ($ = C.quoteChar), typeof C.header == "boolean" && (P = C.header), Array.isArray(C.columns)) {
            if (C.columns.length === 0) throw new Error("Option columns is empty");
            le = C.columns;
          }
          C.escapeChar !== void 0 && (ae = C.escapeChar + $), C.escapeFormulae instanceof RegExp ? oe = C.escapeFormulae : typeof C.escapeFormulae == "boolean" && C.escapeFormulae && (oe = /^[=+\-@\t\r].*$/);
        }
      })(), new RegExp(S($), "g"));
      if (typeof x == "string" && (x = JSON.parse(x)), Array.isArray(x)) {
        if (!x.length || Array.isArray(x[0])) return J(null, x, ce);
        if (typeof x[0] == "object") return J(le || Object.keys(x[0]), x, ce);
      } else if (typeof x == "object") return typeof x.data == "string" && (x.data = JSON.parse(x.data)), Array.isArray(x.data) && (x.fields || (x.fields = x.meta && x.meta.fields || le), x.fields || (x.fields = Array.isArray(x.data[0]) ? x.fields : typeof x.data[0] == "object" ? Object.keys(x.data[0]) : []), Array.isArray(x.data[0]) || typeof x.data[0] == "object" || (x.data = [x.data])), J(x.fields || [], x.data || [], ce);
      throw new Error("Unable to serialize unrecognized input");
      function J(I, U, G) {
        var K = "", A = (typeof I == "string" && (I = JSON.parse(I)), typeof U == "string" && (U = JSON.parse(U)), Array.isArray(I) && 0 < I.length), ee = !Array.isArray(U[0]);
        if (A && P) {
          for (var te = 0; te < I.length; te++) 0 < te && (K += L), K += re(I[te], te);
          0 < U.length && (K += H);
        }
        for (var ne = 0; ne < U.length; ne++) {
          var ve = (A ? I : U[ne]).length, _e = !1, pe = A ? Object.keys(U[ne]).length === 0 : U[ne].length === 0;
          if (G && !A && (_e = G === "greedy" ? U[ne].join("").trim() === "" : U[ne].length === 1 && U[ne][0].length === 0), G === "greedy" && A) {
            for (var je = [], Se = 0; Se < ve; Se++) {
              var be = ee ? I[Se] : Se;
              je.push(U[ne][be]);
            }
            _e = je.join("").trim() === "";
          }
          if (!_e) {
            for (var X = 0; X < ve; X++) {
              0 < X && !pe && (K += L);
              var Ye = A && ee ? I[X] : X;
              K += re(U[ne][Ye], X);
            }
            ne < U.length - 1 && (!G || 0 < ve && !pe) && (K += H);
          }
        }
        return K;
      }
      function re(I, U) {
        var G, K;
        return I == null ? "" : I.constructor === Date ? JSON.stringify(I).slice(1, 25) : (K = !1, oe && typeof I == "string" && oe.test(I) && (I = "'" + I, K = !0), G = I.toString().replace(se, ae), (K = K || D === !0 || typeof D == "function" && D(I, U) || Array.isArray(D) && D[U] || ((A, ee) => {
          for (var te = 0; te < ee.length; te++) if (-1 < A.indexOf(ee[te])) return !0;
          return !1;
        })(G, c.BAD_DELIMITERS) || -1 < G.indexOf(L) || G.charAt(0) === " " || G.charAt(G.length - 1) === " ") ? $ + G + $ : G);
      }
    }, c.RECORD_SEP = "", c.UNIT_SEP = "", c.BYTE_ORDER_MARK = "\uFEFF", c.BAD_DELIMITERS = ["\r", `
`, '"', c.BYTE_ORDER_MARK], c.WORKERS_SUPPORTED = !a && !!r.Worker, c.NODE_STREAM_INPUT = 1, c.LocalChunkSize = 10485760, c.RemoteChunkSize = 5242880, c.DefaultDelimiter = ",", c.Parser = _, c.ParserHandle = b, c.NetworkStreamer = p, c.FileStreamer = y, c.StringStreamer = f, c.ReadableStreamStreamer = N, r.jQuery && ((i = r.jQuery).fn.parse = function(x) {
      var C = x.config || {}, D = [];
      return this.each(function(H) {
        if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
        for (var $ = 0; $ < this.files.length; $++) D.push({ file: this.files[$], inputElem: this, instanceConfig: i.extend({}, C) });
      }), P(), this;
      function P() {
        if (D.length === 0) j(x.complete) && x.complete();
        else {
          var H, $, ae, ce, le = D[0];
          if (j(x.before)) {
            var oe = x.before(le.file, le.inputElem);
            if (typeof oe == "object") {
              if (oe.action === "abort") return H = "AbortError", $ = le.file, ae = le.inputElem, ce = oe.reason, void (j(x.error) && x.error({ name: H }, $, ae, ce));
              if (oe.action === "skip") return void L();
              typeof oe.config == "object" && (le.instanceConfig = i.extend(le.instanceConfig, oe.config));
            } else if (oe === "skip") return void L();
          }
          var se = le.instanceConfig.complete;
          le.instanceConfig.complete = function(J) {
            j(se) && se(J, le.file, le.inputElem), L();
          }, c.parse(le.file, le.instanceConfig);
        }
      }
      function L() {
        D.splice(0, 1), P();
      }
    }), o && (r.onmessage = function(x) {
      x = x.data, c.WORKER_ID === void 0 && x && (c.WORKER_ID = x.workerId), typeof x.input == "string" ? r.postMessage({ workerId: c.WORKER_ID, results: c.parse(x.input, x.config), finished: !0 }) : (r.File && x.input instanceof File || x.input instanceof Object) && (x = c.parse(x.input, x.config)) && r.postMessage({ workerId: c.WORKER_ID, results: x, finished: !0 });
    }), (p.prototype = Object.create(d.prototype)).constructor = p, (y.prototype = Object.create(d.prototype)).constructor = y, (f.prototype = Object.create(f.prototype)).constructor = f, (N.prototype = Object.create(d.prototype)).constructor = N, c;
  });
})(rx);
var wz = rx.exports;
const js = /* @__PURE__ */ ha(wz);
var fn = function() {
  return fn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, fn.apply(this, arguments);
};
function Wh(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
function tg(e, t, n) {
  if (n || arguments.length === 2) for (var r, i = 0, a = t.length; i < a; i++) !r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
  return e.concat(r || Array.prototype.slice.call(t));
}
function Tf(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : e.cancelBubble !== void 0 && e.cancelBubble;
}
function qi() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  return function(n) {
    for (var r = [], i = 1; i < arguments.length; i++) r[i - 1] = arguments[i];
    return e.some(function(a) {
      return !Tf(n) && a && a.apply(void 0, tg([n], r, !1)), Tf(n);
    });
  };
}
function Jd(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
var xz = function(e) {
  e = Array.isArray(e) && e.length === 1 ? e[0] : e;
  var t = Array.isArray(e) ? "one of ".concat(e.join(", ")) : e;
  return { code: "file-invalid-type", message: "File type must be ".concat(t) };
};
function _z(e, t) {
  var n = e.type === "application/x-moz-file" || function(r, i) {
    if (r && i) {
      var a = Array.isArray(i) ? i : i.split(","), o = r.name || "", s = (r.type || "").toLowerCase(), l = s.replace(/\/.*$/, "");
      return a.some(function(c) {
        var d = c.trim().toLowerCase();
        return d.charAt(0) === "." ? o.toLowerCase().endsWith(d) : d.endsWith("/*") ? l === d.replace(/\/.*$/, "") : s === d;
      });
    }
    return !0;
  }(e, t);
  return [n, n ? null : xz(t)];
}
function Sc(e) {
  return e != null;
}
var u0 = function(e) {
  return { code: "file-too-large", message: "File is larger than ".concat(e, " bytes") };
}, d0 = function(e) {
  return { code: "file-too-small", message: "File is smaller than ".concat(e, " bytes") };
}, Nz = { code: "too-many-files", message: "Too many files" };
function f0(e) {
  e.preventDefault();
}
var p0 = { progressBar: { borderRadius: 3, boxShadow: "inset 0 1px 3px rgba(0, 0, 0, .2)", bottom: 14, width: "100%" }, fill: { backgroundColor: "#659cef", borderRadius: 3, height: 10, transition: "width 500ms ease-in-out" } };
function Sz(e) {
  var t = e.style, n = e.className, r = e.display, i = oi(0), a = i[0], o = i[1];
  return gn(function() {
    o(e.percentage);
  }, [e.percentage]), gt.createElement("span", { style: Object.assign({}, p0.progressBar, p0.fill, t, { width: "".concat(a, "%"), display: r }), className: n });
}
function Ez(e) {
  var t = e.color, n = e.width, r = n === void 0 ? 23 : n, i = e.height, a = i === void 0 ? 23 : i;
  return gt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: r, height: a, viewBox: "0 0 512 512" }, gt.createElement("path", { fill: t, d: "M504.1 256C504.1 119 393 7.9 256 7.9S7.9 119 7.9 256 119 504.1 256 504.1 504.1 393 504.1 256z" }), gt.createElement("path", { fill: "#FFF", d: "M285 256l72.5-84.2c7.9-9.2 6.9-23-2.3-31-9.2-7.9-23-6.9-30.9 2.3L256 222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3-9.2 7.9-10.2 21.8-2.3 31L227 256l-72.5 84.2c-7.9 9.2-6.9 23 2.3 31 4.1 3.6 9.2 5.3 14.3 5.3 6.2 0 12.3-2.6 16.6-7.6l68.2-79.2 68.2 79.2c4.3 5 10.5 7.6 16.6 7.6 5.1 0 10.2-1.7 14.3-5.3 9.2-7.9 10.2-21.8 2.3-31L285 256z" }));
}
var Cz = "text/csv, .csv, application/vnd.ms-excel";
function Oz() {
  var e = function(t) {
    var n = t.children, r = t.accept, i = r === void 0 ? Cz : r, a = t.config, o = a === void 0 ? {} : a, s = t.minSize, l = s === void 0 ? 0 : s, c = t.maxSize, d = c === void 0 ? 1 / 0 : c, p = t.maxFiles, y = p === void 0 ? 1 : p, f = t.disabled, N = f !== void 0 && f, b = t.noClick, S = b !== void 0 && b, _ = t.noDrag, E = _ !== void 0 && _, k = t.noDragEventsBubbling, M = k !== void 0 && k, F = t.noKeyboard, q = F !== void 0 && F, j = t.multiple, x = j !== void 0 && j, C = t.required, D = C !== void 0 && C, P = t.preventDropOnDocument, L = P === void 0 || P, H = t.onUploadAccepted, $ = t.validator, ae = t.onUploadRejected, ce = t.onDragEnter, le = t.onDragOver, oe = t.onDragLeave, se = gr(null), J = gr(null), re = gr([]), I = og(Pz, ix), U = I[0], G = I[1], K = U.acceptedFile, A = U.displayProgressBar, ee = U.progressBarPercentage, te = U.draggedFiles, ne = U.isFileDialogActive, ve = function(Le) {
      J.current && J.current.contains(Le.target) || (Le.preventDefault(), re.current = []);
    };
    gn(function() {
      return L && (document.addEventListener("dragover", f0, !1), document.addEventListener("drop", ve, !1)), function() {
        L && (document.removeEventListener("dragover", f0), document.removeEventListener("drop", ve));
      };
    }, [J, L]);
    var _e = function(Le) {
      return N ? null : Le;
    }, pe = function(Le) {
      return E ? null : _e(Le);
    }, je = function(Le) {
      M && Le.stopPropagation();
    }, Se = function(Le) {
      Le.preventDefault(Le), Le.persist(), je(Le);
    }, be = function(Le) {
      G({ displayProgressBar: Le, type: "setDisplayProgressBar" });
    }, X = function(Le) {
      G({ progressBarPercentage: Le, type: "setProgressBarPercentage" });
    }, Ye = function(Le) {
      return gt.createElement(Sz, fn({ display: A, percentage: ee }, Le));
    }, Re = function(Le) {
      return gt.createElement(Ez, fn({}, Le));
    }, Te = Ln(function() {
      se.current && U.displayProgressBar && (G({ type: "openDialog" }), se.current.value = null, se.current.click());
    }, [G]), Ue = function() {
      ne && setTimeout(function() {
        se.current && (se.current.files.length || G({ type: "closeDialog" }));
      }, 300);
    };
    gn(function() {
      return window.addEventListener("focus", Ue, !1), function() {
        window.removeEventListener("focus", Ue, !1);
      };
    }, [se, ne]);
    var T = Ln(function() {
      var Le;
      S || (Le === void 0 && (Le = window.navigator.userAgent), function(pt) {
        return pt.indexOf("MSIE") !== -1 || pt.indexOf("Trident/") !== -1;
      }(Le) || function(pt) {
        return pt.indexOf("Edge/") !== -1;
      }(Le) ? setTimeout(Te, 0) : Te());
    }, [se, S]), fe = Ln(function(Le) {
      if (Se(Le), X(0), re.current = [], Jd(Le)) {
        if (Tf(Le) && !M) return;
        var pt = [], At = [], Ot = Le.target.files || Le.dataTransfer && Le.dataTransfer.files;
        if (Array.from(Ot).forEach(function(ut) {
          var rn = _z(ut, i), _n = rn[0], Mn = rn[1], er = function(Qt, en, jn) {
            if (Sc(Qt.size)) if (Sc(en) && Sc(jn)) {
              if (Qt.size > jn) return [!1, u0(jn)];
              if (Qt.size < en) return [!1, d0(en)];
            } else {
              if (Sc(en) && Qt.size < en) return [!1, d0(en)];
              if (Sc(jn) && Qt.size > jn) return [!1, u0(jn)];
            }
            return [!0, null];
          }(ut, l, d), ht = er[0], rr = er[1], ir = $ ? $(ut) : null;
          if (_n && ht && !ir) pt.push(ut);
          else {
            var yn = [Mn, rr];
            ir && (yn = yn.concat(ir)), At.push({ file: ut, errors: yn.filter(function(Qt) {
              return Qt;
            }) });
          }
        }), (!x && pt.length > 1 || x && y >= 1 && pt.length > y) && (pt.forEach(function(ut) {
          At.push({ file: ut, errors: [Nz] });
        }), pt.splice(0)), G({ acceptedFiles: pt, fileRejections: At, type: "setFiles" }), be("block"), At.length > 0 && ae && ae(At, Le), pt.length > 0 && H) {
          var Fn = {}, It = [], In = [], Cn = [], Gt = new window.FileReader(), mt = 0;
          pt.forEach(function(ut) {
            G({ acceptedFile: ut, type: "setFile" }), Fn = { complete: o != null && o.complete || o != null && o.step ? o.complete : function() {
              H({ data: It, errors: In, meta: Cn }, ut);
            }, step: o != null && o.step ? o.step : function(rn) {
              if (It.push(rn.data), rn.errors.length > 0 && In.push(rn.errors), rn.length > 0 && Cn.push(rn[0].meta), o && o.preview)
                mt = Math.round(It.length / o.preview * 100), It.length === o.preview && H({ data: It, errors: In, meta: Cn }, ut);
              else {
                var _n = rn.meta.cursor, Mn = Math.round(_n / ut.size * 100);
                if (Mn === mt) return;
                mt = Mn;
              }
              X(mt);
            } }, Fn = Object.assign({}, o, Fn), Gt.onload = function(rn) {
              js.parse(rn.target.result, Fn);
            }, Gt.onloadend = function() {
              setTimeout(function() {
                be("none");
              }, 2e3);
            }, Gt.readAsText(ut, o.encoding || "utf-8");
          });
        }
      }
    }, [x, i, l, d, y, $, H]), xe = Ln(function(Le) {
      je(Le);
    }, []), Fe = function(Le) {
      return q ? null : _e(Le);
    }, Ge = Ln(function(Le) {
      if (Se(Le), re.current = tg(tg([], re.current, !0), [Le.target], !1), Jd(Le)) {
        if (Tf(Le) && !M) return;
        G({ draggedFiles: te, isDragActive: !0, type: "setDraggedFiles" }), ce && ce(Le);
      }
    }, [ce, M]), Me = Ln(function(Le) {
      Se(Le);
      var pt = Jd(Le);
      if (pt && Le.dataTransfer) try {
        Le.dataTransfer.dropEffect = "copy";
      } catch {
      }
      return pt && le && le(Le), !1;
    }, [le, M]), Ie = Ln(function(Le) {
      Se(Le);
      var pt = re.current.filter(function(Ot) {
        return J.current && J.current.contains(Ot);
      }), At = pt.indexOf(Le.target);
      At !== -1 && pt.splice(At, 1), re.current = pt, pt.length > 0 || (G({ isDragActive: !1, type: "setDraggedFiles", draggedFiles: [] }), Jd(Le) && oe && oe(Le));
    }, [J, oe, M]), ct = Ln(function(Le) {
      J.current && J.current.isEqualNode(Le.target) && (Le.key !== "Space" && Le.key !== "Enter" || (Le.preventDefault(), Te()));
    }, [J, se]), at = Ln(function() {
      G({ type: "focus" });
    }, []), Je = Ln(function() {
      G({ type: "blur" });
    }, []), $e = Ld(function() {
      return function(Le) {
        Le === void 0 && (Le = {});
        var pt = Le.onClick, At = pt === void 0 ? function() {
        } : pt, Ot = Le.onDrop, Fn = Ot === void 0 ? function() {
        } : Ot, It = Le.onDragOver, In = It === void 0 ? function() {
        } : It, Cn = Le.onDragLeave, Gt = Cn === void 0 ? function() {
        } : Cn, mt = Le.onKeyDown, ut = mt === void 0 ? function() {
        } : mt, rn = Le.onFocus, _n = rn === void 0 ? function() {
        } : rn, Mn = Le.onBlur, er = Mn === void 0 ? function() {
        } : Mn, ht = Le.onDragEnter, rr = ht === void 0 ? function() {
        } : ht, ir = Wh(Le, ["onClick", "onDrop", "onDragOver", "onDragLeave", "onKeyDown", "onFocus", "onBlur", "onDragEnter"]);
        return fn({ onClick: _e(qi(At, T)), onDrop: pe(qi(Fn, fe)), onDragEnter: pe(qi(rr, Ge)), onDragOver: pe(qi(In, Me)), onDragLeave: pe(qi(Gt, Ie)), onKeyDown: Fe(qi(ut, ct)), onFocus: Fe(qi(_n, at)), onBlur: Fe(qi(er, Je)) }, ir);
      };
    }, [J, ct, at, Je, T, Ge, Me, Ie, fe, q, E, N]), _t = Ld(function() {
      return function(Le) {
        var pt;
        Le === void 0 && (Le = {});
        var At = Le.refKey, Ot = At === void 0 ? "ref" : At, Fn = Le.onChange, It = Fn === void 0 ? function() {
        } : Fn, In = Le.onClick, Cn = In === void 0 ? function() {
        } : In, Gt = Wh(Le, ["refKey", "onChange", "onClick"]), mt = ((pt = { accept: i, multiple: x, required: D, type: "file", style: { display: "none" }, onChange: _e(qi(It, fe)), onClick: _e(qi(Cn, xe)), autoComplete: "off", tabIndex: -1 })[Ot] = se, pt);
        return fn(fn({}, mt), Gt);
      };
    }, [se, i, fe, N]), dt = Ln(function(Le) {
      se.current.value = "", G({ type: "reset" }), Le.stopPropagation();
    }, []), Ut = Ld(function() {
      return function(Le) {
        Le === void 0 && (Le = {});
        var pt = Le.onClick, At = pt === void 0 ? function() {
        } : pt, Ot = Wh(Le, ["onClick"]);
        return fn({ onClick: _e(qi(At, dt)) }, Ot);
      };
    }, [dt]);
    return gt.createElement(gt.Fragment, null, gt.createElement("input", fn({}, _t())), n({ getRootProps: $e, acceptedFile: K, ProgressBar: Ye, getRemoveFileProps: Ut, Remove: Re }));
  };
  return Ld(function() {
    return e;
  }, []);
}
function jz() {
  return { CSVReader: Oz() };
}
var ix = { displayProgressBar: "none", progressBarPercentage: 0, isDragActive: !1, isFileDialogActive: !1, isFocused: !1, draggedFiles: [], acceptedFiles: [], acceptedFile: null };
function Pz(e, t) {
  switch (t.type) {
    case "openDialog":
      return fn(fn({}, e), { isFileDialogActive: !0 });
    case "closeDialog":
      return fn(fn({}, e), { isFileDialogActive: !1 });
    case "setFiles":
      return fn(fn({}, e), { acceptedFiles: t.acceptedFiles, fileRejections: t.fileRejections });
    case "setFile":
      return fn(fn({}, e), { acceptedFile: t.acceptedFile });
    case "setDisplayProgressBar":
      return fn(fn({}, e), { displayProgressBar: t.displayProgressBar });
    case "setProgressBarPercentage":
      return fn(fn({}, e), { progressBarPercentage: t.progressBarPercentage });
    case "setDraggedFiles":
      var n = t.isDragActive, r = t.draggedFiles;
      return fn(fn({}, e), { draggedFiles: r, isDragActive: n });
    case "focus":
      return fn(fn({}, e), { isFocused: !0 });
    case "blur":
      return fn(fn({}, e), { isFocused: !1 });
    case "reset":
      return fn({}, ix);
    default:
      return e;
  }
}
js.BAD_DELIMITERS;
js.RECORD_SEP;
js.UNIT_SEP;
js.WORKERS_SUPPORTED;
js.LocalChunkSize;
js.DefaultDelimiter;
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */
const {
  entries: ax,
  setPrototypeOf: h0,
  isFrozen: Lz,
  getPrototypeOf: Tz,
  getOwnPropertyDescriptor: Fz
} = Object;
let {
  freeze: Ur,
  seal: Ti,
  create: ox
} = Object, {
  apply: ng,
  construct: rg
} = typeof Reflect < "u" && Reflect;
Ur || (Ur = function(e) {
  return e;
});
Ti || (Ti = function(e) {
  return e;
});
ng || (ng = function(e, t, n) {
  return e.apply(t, n);
});
rg || (rg = function(e, t) {
  return new e(...t);
});
const Ad = li(Array.prototype.forEach), m0 = li(Array.prototype.pop), Ec = li(Array.prototype.push), mf = li(String.prototype.toLowerCase), Hh = li(String.prototype.toString), g0 = li(String.prototype.match), Cc = li(String.prototype.replace), Iz = li(String.prototype.indexOf), kz = li(String.prototype.trim), Vi = li(Object.prototype.hasOwnProperty), Fr = li(RegExp.prototype.test), Oc = Dz(TypeError);
function li(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return ng(e, t, r);
  };
}
function Dz(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return rg(e, n);
  };
}
function Dt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : mf;
  h0 && h0(e, null);
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (Lz(t) || (t[r] = a), i = a);
    }
    e[i] = !0;
  }
  return e;
}
function Rz(e) {
  for (let t = 0; t < e.length; t++)
    Vi(e, t) || (e[t] = null);
  return e;
}
function ns(e) {
  const t = ox(null);
  for (const [n, r] of ax(e))
    Vi(e, n) && (Array.isArray(r) ? t[n] = Rz(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = ns(r) : t[n] = r);
  return t;
}
function jc(e, t) {
  for (; e !== null; ) {
    const r = Fz(e, t);
    if (r) {
      if (r.get)
        return li(r.get);
      if (typeof r.value == "function")
        return li(r.value);
    }
    e = Tz(e);
  }
  function n() {
    return null;
  }
  return n;
}
const y0 = Ur(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), $h = Ur(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Gh = Ur(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Mz = Ur(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Qh = Ur(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Uz = Ur(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), v0 = Ur(["#text"]), b0 = Ur(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Yh = Ur(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), w0 = Ur(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ef = Ur(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Bz = Ti(/\{\{[\w\W]*|[\w\W]*\}\}/gm), zz = Ti(/<%[\w\W]*|[\w\W]*%>/gm), qz = Ti(/\$\{[\w\W]*}/gm), Vz = Ti(/^data-[\-\w.\u00B7-\uFFFF]+$/), Wz = Ti(/^aria-[\-\w]+$/), sx = Ti(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Hz = Ti(/^(?:\w+script|data):/i), $z = Ti(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), lx = Ti(/^html$/i), Gz = Ti(/^[a-z][.\w]*(-[.\w]+)+$/i);
var x0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Wz,
  ATTR_WHITESPACE: $z,
  CUSTOM_ELEMENT: Gz,
  DATA_ATTR: Vz,
  DOCTYPE_NAME: lx,
  ERB_EXPR: zz,
  IS_ALLOWED_URI: sx,
  IS_SCRIPT_OR_DATA: Hz,
  MUSTACHE_EXPR: Bz,
  TMPLIT_EXPR: qz
});
const Pc = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Qz = function() {
  return typeof window > "u" ? null : window;
}, Yz = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const r = "data-tt-policy-suffix";
  t && t.hasAttribute(r) && (n = t.getAttribute(r));
  const i = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(i, {
      createHTML(a) {
        return a;
      },
      createScriptURL(a) {
        return a;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, _0 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function cx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Qz();
  const t = (de) => cx(de);
  if (t.version = "3.2.3", t.removed = [], !e || !e.document || e.document.nodeType !== Pc.document)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: o,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: p,
    DOMParser: y,
    trustedTypes: f
  } = e, N = l.prototype, b = jc(N, "cloneNode"), S = jc(N, "remove"), _ = jc(N, "nextSibling"), E = jc(N, "childNodes"), k = jc(N, "parentNode");
  if (typeof o == "function") {
    const de = n.createElement("template");
    de.content && de.content.ownerDocument && (n = de.content.ownerDocument);
  }
  let M, F = "";
  const {
    implementation: q,
    createNodeIterator: j,
    createDocumentFragment: x,
    getElementsByTagName: C
  } = n, {
    importNode: D
  } = r;
  let P = _0();
  t.isSupported = typeof ax == "function" && typeof k == "function" && q && q.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: L,
    ERB_EXPR: H,
    TMPLIT_EXPR: $,
    DATA_ATTR: ae,
    ARIA_ATTR: ce,
    IS_SCRIPT_OR_DATA: le,
    ATTR_WHITESPACE: oe,
    CUSTOM_ELEMENT: se
  } = x0;
  let {
    IS_ALLOWED_URI: J
  } = x0, re = null;
  const I = Dt({}, [...y0, ...$h, ...Gh, ...Qh, ...v0]);
  let U = null;
  const G = Dt({}, [...b0, ...Yh, ...w0, ...ef]);
  let K = Object.seal(ox(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), A = null, ee = null, te = !0, ne = !0, ve = !1, _e = !0, pe = !1, je = !0, Se = !1, be = !1, X = !1, Ye = !1, Re = !1, Te = !1, Ue = !0, T = !1;
  const fe = "user-content-";
  let xe = !0, Fe = !1, Ge = {}, Me = null;
  const Ie = Dt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ct = null;
  const at = Dt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Je = null;
  const $e = Dt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), _t = "http://www.w3.org/1998/Math/MathML", dt = "http://www.w3.org/2000/svg", Ut = "http://www.w3.org/1999/xhtml";
  let Le = Ut, pt = !1, At = null;
  const Ot = Dt({}, [_t, dt, Ut], Hh);
  let Fn = Dt({}, ["mi", "mo", "mn", "ms", "mtext"]), It = Dt({}, ["annotation-xml"]);
  const In = Dt({}, ["title", "style", "font", "a", "script"]);
  let Cn = null;
  const Gt = ["application/xhtml+xml", "text/html"], mt = "text/html";
  let ut = null, rn = null;
  const _n = n.createElement("form"), Mn = function(de) {
    return de instanceof RegExp || de instanceof Function;
  }, er = function() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(rn && rn === de)) {
      if ((!de || typeof de != "object") && (de = {}), de = ns(de), Cn = // eslint-disable-next-line unicorn/prefer-includes
      Gt.indexOf(de.PARSER_MEDIA_TYPE) === -1 ? mt : de.PARSER_MEDIA_TYPE, ut = Cn === "application/xhtml+xml" ? Hh : mf, re = Vi(de, "ALLOWED_TAGS") ? Dt({}, de.ALLOWED_TAGS, ut) : I, U = Vi(de, "ALLOWED_ATTR") ? Dt({}, de.ALLOWED_ATTR, ut) : G, At = Vi(de, "ALLOWED_NAMESPACES") ? Dt({}, de.ALLOWED_NAMESPACES, Hh) : Ot, Je = Vi(de, "ADD_URI_SAFE_ATTR") ? Dt(ns($e), de.ADD_URI_SAFE_ATTR, ut) : $e, ct = Vi(de, "ADD_DATA_URI_TAGS") ? Dt(ns(at), de.ADD_DATA_URI_TAGS, ut) : at, Me = Vi(de, "FORBID_CONTENTS") ? Dt({}, de.FORBID_CONTENTS, ut) : Ie, A = Vi(de, "FORBID_TAGS") ? Dt({}, de.FORBID_TAGS, ut) : {}, ee = Vi(de, "FORBID_ATTR") ? Dt({}, de.FORBID_ATTR, ut) : {}, Ge = Vi(de, "USE_PROFILES") ? de.USE_PROFILES : !1, te = de.ALLOW_ARIA_ATTR !== !1, ne = de.ALLOW_DATA_ATTR !== !1, ve = de.ALLOW_UNKNOWN_PROTOCOLS || !1, _e = de.ALLOW_SELF_CLOSE_IN_ATTR !== !1, pe = de.SAFE_FOR_TEMPLATES || !1, je = de.SAFE_FOR_XML !== !1, Se = de.WHOLE_DOCUMENT || !1, Ye = de.RETURN_DOM || !1, Re = de.RETURN_DOM_FRAGMENT || !1, Te = de.RETURN_TRUSTED_TYPE || !1, X = de.FORCE_BODY || !1, Ue = de.SANITIZE_DOM !== !1, T = de.SANITIZE_NAMED_PROPS || !1, xe = de.KEEP_CONTENT !== !1, Fe = de.IN_PLACE || !1, J = de.ALLOWED_URI_REGEXP || sx, Le = de.NAMESPACE || Ut, Fn = de.MATHML_TEXT_INTEGRATION_POINTS || Fn, It = de.HTML_INTEGRATION_POINTS || It, K = de.CUSTOM_ELEMENT_HANDLING || {}, de.CUSTOM_ELEMENT_HANDLING && Mn(de.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (K.tagNameCheck = de.CUSTOM_ELEMENT_HANDLING.tagNameCheck), de.CUSTOM_ELEMENT_HANDLING && Mn(de.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (K.attributeNameCheck = de.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), de.CUSTOM_ELEMENT_HANDLING && typeof de.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (K.allowCustomizedBuiltInElements = de.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), pe && (ne = !1), Re && (Ye = !0), Ge && (re = Dt({}, v0), U = [], Ge.html === !0 && (Dt(re, y0), Dt(U, b0)), Ge.svg === !0 && (Dt(re, $h), Dt(U, Yh), Dt(U, ef)), Ge.svgFilters === !0 && (Dt(re, Gh), Dt(U, Yh), Dt(U, ef)), Ge.mathMl === !0 && (Dt(re, Qh), Dt(U, w0), Dt(U, ef))), de.ADD_TAGS && (re === I && (re = ns(re)), Dt(re, de.ADD_TAGS, ut)), de.ADD_ATTR && (U === G && (U = ns(U)), Dt(U, de.ADD_ATTR, ut)), de.ADD_URI_SAFE_ATTR && Dt(Je, de.ADD_URI_SAFE_ATTR, ut), de.FORBID_CONTENTS && (Me === Ie && (Me = ns(Me)), Dt(Me, de.FORBID_CONTENTS, ut)), xe && (re["#text"] = !0), Se && Dt(re, ["html", "head", "body"]), re.table && (Dt(re, ["tbody"]), delete A.tbody), de.TRUSTED_TYPES_POLICY) {
        if (typeof de.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Oc('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof de.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Oc('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        M = de.TRUSTED_TYPES_POLICY, F = M.createHTML("");
      } else
        M === void 0 && (M = Yz(f, i)), M !== null && typeof F == "string" && (F = M.createHTML(""));
      Ur && Ur(de), rn = de;
    }
  }, ht = Dt({}, [...$h, ...Gh, ...Mz]), rr = Dt({}, [...Qh, ...Uz]), ir = function(de) {
    let it = k(de);
    (!it || !it.tagName) && (it = {
      namespaceURI: Le,
      tagName: "template"
    });
    const Xe = mf(de.tagName), Bt = mf(it.tagName);
    return At[de.namespaceURI] ? de.namespaceURI === dt ? it.namespaceURI === Ut ? Xe === "svg" : it.namespaceURI === _t ? Xe === "svg" && (Bt === "annotation-xml" || Fn[Bt]) : !!ht[Xe] : de.namespaceURI === _t ? it.namespaceURI === Ut ? Xe === "math" : it.namespaceURI === dt ? Xe === "math" && It[Bt] : !!rr[Xe] : de.namespaceURI === Ut ? it.namespaceURI === dt && !It[Bt] || it.namespaceURI === _t && !Fn[Bt] ? !1 : !rr[Xe] && (In[Xe] || !ht[Xe]) : !!(Cn === "application/xhtml+xml" && At[de.namespaceURI]) : !1;
  }, yn = function(de) {
    Ec(t.removed, {
      element: de
    });
    try {
      k(de).removeChild(de);
    } catch {
      S(de);
    }
  }, Qt = function(de, it) {
    try {
      Ec(t.removed, {
        attribute: it.getAttributeNode(de),
        from: it
      });
    } catch {
      Ec(t.removed, {
        attribute: null,
        from: it
      });
    }
    if (it.removeAttribute(de), de === "is")
      if (Ye || Re)
        try {
          yn(it);
        } catch {
        }
      else
        try {
          it.setAttribute(de, "");
        } catch {
        }
  }, en = function(de) {
    let it = null, Xe = null;
    if (X)
      de = "<remove></remove>" + de;
    else {
      const Nn = g0(de, /^[\r\n\t ]+/);
      Xe = Nn && Nn[0];
    }
    Cn === "application/xhtml+xml" && Le === Ut && (de = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + de + "</body></html>");
    const Bt = M ? M.createHTML(de) : de;
    if (Le === Ut)
      try {
        it = new y().parseFromString(Bt, Cn);
      } catch {
      }
    if (!it || !it.documentElement) {
      it = q.createDocument(Le, "template", null);
      try {
        it.documentElement.innerHTML = pt ? F : Bt;
      } catch {
      }
    }
    const On = it.body || it.documentElement;
    return de && Xe && On.insertBefore(n.createTextNode(Xe), On.childNodes[0] || null), Le === Ut ? C.call(it, Se ? "html" : "body")[0] : Se ? it.documentElement : On;
  }, jn = function(de) {
    return j.call(
      de.ownerDocument || de,
      de,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Xi = function(de) {
    return de instanceof p && (typeof de.nodeName != "string" || typeof de.textContent != "string" || typeof de.removeChild != "function" || !(de.attributes instanceof d) || typeof de.removeAttribute != "function" || typeof de.setAttribute != "function" || typeof de.namespaceURI != "string" || typeof de.insertBefore != "function" || typeof de.hasChildNodes != "function");
  }, pi = function(de) {
    return typeof s == "function" && de instanceof s;
  };
  function Un(de, it, Xe) {
    Ad(de, (Bt) => {
      Bt.call(t, it, Xe, rn);
    });
  }
  const zr = function(de) {
    let it = null;
    if (Un(P.beforeSanitizeElements, de, null), Xi(de))
      return yn(de), !0;
    const Xe = ut(de.nodeName);
    if (Un(P.uponSanitizeElement, de, {
      tagName: Xe,
      allowedTags: re
    }), de.hasChildNodes() && !pi(de.firstElementChild) && Fr(/<[/\w]/g, de.innerHTML) && Fr(/<[/\w]/g, de.textContent) || de.nodeType === Pc.progressingInstruction || je && de.nodeType === Pc.comment && Fr(/<[/\w]/g, de.data))
      return yn(de), !0;
    if (!re[Xe] || A[Xe]) {
      if (!A[Xe] && ei(Xe) && (K.tagNameCheck instanceof RegExp && Fr(K.tagNameCheck, Xe) || K.tagNameCheck instanceof Function && K.tagNameCheck(Xe)))
        return !1;
      if (xe && !Me[Xe]) {
        const Bt = k(de) || de.parentNode, On = E(de) || de.childNodes;
        if (On && Bt) {
          const Nn = On.length;
          for (let ti = Nn - 1; ti >= 0; --ti) {
            const br = b(On[ti], !0);
            br.__removalCount = (de.__removalCount || 0) + 1, Bt.insertBefore(br, _(de));
          }
        }
      }
      return yn(de), !0;
    }
    return de instanceof l && !ir(de) || (Xe === "noscript" || Xe === "noembed" || Xe === "noframes") && Fr(/<\/no(script|embed|frames)/i, de.innerHTML) ? (yn(de), !0) : (pe && de.nodeType === Pc.text && (it = de.textContent, Ad([L, H, $], (Bt) => {
      it = Cc(it, Bt, " ");
    }), de.textContent !== it && (Ec(t.removed, {
      element: de.cloneNode()
    }), de.textContent = it)), Un(P.afterSanitizeElements, de, null), !1);
  }, qr = function(de, it, Xe) {
    if (Ue && (it === "id" || it === "name") && (Xe in n || Xe in _n))
      return !1;
    if (!(ne && !ee[it] && Fr(ae, it)) && !(te && Fr(ce, it))) {
      if (!U[it] || ee[it]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(ei(de) && (K.tagNameCheck instanceof RegExp && Fr(K.tagNameCheck, de) || K.tagNameCheck instanceof Function && K.tagNameCheck(de)) && (K.attributeNameCheck instanceof RegExp && Fr(K.attributeNameCheck, it) || K.attributeNameCheck instanceof Function && K.attributeNameCheck(it)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          it === "is" && K.allowCustomizedBuiltInElements && (K.tagNameCheck instanceof RegExp && Fr(K.tagNameCheck, Xe) || K.tagNameCheck instanceof Function && K.tagNameCheck(Xe)))
        ) return !1;
      } else if (!Je[it] && !Fr(J, Cc(Xe, oe, "")) && !((it === "src" || it === "xlink:href" || it === "href") && de !== "script" && Iz(Xe, "data:") === 0 && ct[de]) && !(ve && !Fr(le, Cc(Xe, oe, ""))) && Xe)
        return !1;
    }
    return !0;
  }, ei = function(de) {
    return de !== "annotation-xml" && g0(de, se);
  }, jr = function(de) {
    Un(P.beforeSanitizeAttributes, de, null);
    const {
      attributes: it
    } = de;
    if (!it || Xi(de))
      return;
    const Xe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: U,
      forceKeepAttr: void 0
    };
    let Bt = it.length;
    for (; Bt--; ) {
      const On = it[Bt], {
        name: Nn,
        namespaceURI: ti,
        value: br
      } = On, pr = ut(Nn);
      let Kn = Nn === "value" ? br : kz(br);
      if (Xe.attrName = pr, Xe.attrValue = Kn, Xe.keepAttr = !0, Xe.forceKeepAttr = void 0, Un(P.uponSanitizeAttribute, de, Xe), Kn = Xe.attrValue, T && (pr === "id" || pr === "name") && (Qt(Nn, de), Kn = fe + Kn), je && Fr(/((--!?|])>)|<\/(style|title)/i, Kn)) {
        Qt(Nn, de);
        continue;
      }
      if (Xe.forceKeepAttr || (Qt(Nn, de), !Xe.keepAttr))
        continue;
      if (!_e && Fr(/\/>/i, Kn)) {
        Qt(Nn, de);
        continue;
      }
      pe && Ad([L, H, $], (Wo) => {
        Kn = Cc(Kn, Wo, " ");
      });
      const Ps = ut(de.nodeName);
      if (qr(Ps, pr, Kn)) {
        if (M && typeof f == "object" && typeof f.getAttributeType == "function" && !ti)
          switch (f.getAttributeType(Ps, pr)) {
            case "TrustedHTML": {
              Kn = M.createHTML(Kn);
              break;
            }
            case "TrustedScriptURL": {
              Kn = M.createScriptURL(Kn);
              break;
            }
          }
        try {
          ti ? de.setAttributeNS(ti, Nn, Kn) : de.setAttribute(Nn, Kn), Xi(de) ? yn(de) : m0(t.removed);
        } catch {
        }
      }
    }
    Un(P.afterSanitizeAttributes, de, null);
  }, hi = function de(it) {
    let Xe = null;
    const Bt = jn(it);
    for (Un(P.beforeSanitizeShadowDOM, it, null); Xe = Bt.nextNode(); )
      Un(P.uponSanitizeShadowNode, Xe, null), zr(Xe), jr(Xe), Xe.content instanceof a && de(Xe.content);
    Un(P.afterSanitizeShadowDOM, it, null);
  };
  return t.sanitize = function(de) {
    let it = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Xe = null, Bt = null, On = null, Nn = null;
    if (pt = !de, pt && (de = "<!-->"), typeof de != "string" && !pi(de))
      if (typeof de.toString == "function") {
        if (de = de.toString(), typeof de != "string")
          throw Oc("dirty is not a string, aborting");
      } else
        throw Oc("toString is not a function");
    if (!t.isSupported)
      return de;
    if (be || er(it), t.removed = [], typeof de == "string" && (Fe = !1), Fe) {
      if (de.nodeName) {
        const pr = ut(de.nodeName);
        if (!re[pr] || A[pr])
          throw Oc("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (de instanceof s)
      Xe = en("<!---->"), Bt = Xe.ownerDocument.importNode(de, !0), Bt.nodeType === Pc.element && Bt.nodeName === "BODY" || Bt.nodeName === "HTML" ? Xe = Bt : Xe.appendChild(Bt);
    else {
      if (!Ye && !pe && !Se && // eslint-disable-next-line unicorn/prefer-includes
      de.indexOf("<") === -1)
        return M && Te ? M.createHTML(de) : de;
      if (Xe = en(de), !Xe)
        return Ye ? null : Te ? F : "";
    }
    Xe && X && yn(Xe.firstChild);
    const ti = jn(Fe ? de : Xe);
    for (; On = ti.nextNode(); )
      zr(On), jr(On), On.content instanceof a && hi(On.content);
    if (Fe)
      return de;
    if (Ye) {
      if (Re)
        for (Nn = x.call(Xe.ownerDocument); Xe.firstChild; )
          Nn.appendChild(Xe.firstChild);
      else
        Nn = Xe;
      return (U.shadowroot || U.shadowrootmode) && (Nn = D.call(r, Nn, !0)), Nn;
    }
    let br = Se ? Xe.outerHTML : Xe.innerHTML;
    return Se && re["!doctype"] && Xe.ownerDocument && Xe.ownerDocument.doctype && Xe.ownerDocument.doctype.name && Fr(lx, Xe.ownerDocument.doctype.name) && (br = "<!DOCTYPE " + Xe.ownerDocument.doctype.name + `>
` + br), pe && Ad([L, H, $], (pr) => {
      br = Cc(br, pr, " ");
    }), M && Te ? M.createHTML(br) : br;
  }, t.setConfig = function() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    er(de), be = !0;
  }, t.clearConfig = function() {
    rn = null, be = !1;
  }, t.isValidAttribute = function(de, it, Xe) {
    rn || er({});
    const Bt = ut(de), On = ut(it);
    return qr(Bt, On, Xe);
  }, t.addHook = function(de, it) {
    typeof it == "function" && Ec(P[de], it);
  }, t.removeHook = function(de) {
    return m0(P[de]);
  }, t.removeHooks = function(de) {
    P[de] = [];
  }, t.removeAllHooks = function() {
    P = _0();
  }, t;
}
cx();
function Kz(e) {
  const {
    CSVReader: t
  } = jz();
  return /* @__PURE__ */ m.jsx(t, { ...e });
}
function Xz({
  otherPersonaIds: e
}) {
  const t = oa((f) => f.fileUploadMeta), {
    fileName: n,
    dirtyData: r,
    duplicatePersonas: i,
    personasAdded: a,
    emptyData: o
  } = t, s = a.length, l = o.length, c = r && r.length, d = i && i.length, p = a.filter((f) => e.includes(f)), y = d || c || s === 0 ? "warning" : "check";
  return d > 0 || c > 0 || s > 0 || n ? /* @__PURE__ */ m.jsxs("div", { className: `file-upload__info-box ${y}`, children: [
    /* @__PURE__ */ m.jsx(
      $t,
      {
        className: "csv-handler__info-icon",
        name: `${y} circle`,
        size: "large"
      }
    ),
    /* @__PURE__ */ m.jsxs("div", { children: [
      /* @__PURE__ */ m.jsxs("p", { children: [
        "The uploaded file contains values for ",
        s,
        " Persona",
        s > 1 && "s",
        p.length > 0 && `, including ${p.join(", ")} Other`
      ] }),
      !!c && /* @__PURE__ */ m.jsxs("p", { children: [
        "Data for ",
        c,
        " other line",
        c > 1 ? "s" : "",
        " has been ignored"
      ] }),
      !!d && /* @__PURE__ */ m.jsxs("p", { children: [
        "Duplicated data was found for ",
        d,
        " Persona",
        d > 1 && "s",
        " (",
        i.join(", "),
        ")"
      ] }),
      !!l && /* @__PURE__ */ m.jsxs("p", { children: [
        l,
        " Persona",
        l > 1 && "s",
        " listed had a value of zero and",
        " ",
        l > 1 ? "have" : "has",
        " been excluded from the audience profile"
      ] }),
      /* @__PURE__ */ m.jsxs("p", { children: [
        /* @__PURE__ */ m.jsx("b", { children: "Uploaded file:" }),
        " ",
        n
      ] })
    ] })
  ] }) : null;
}
const Zz = 'export default "data:text/csv;base64,UGVyc29uYSxQZXJjZW50YWdlDQoxMDEgQmx1ZWNoaXAsNC41DQoxMDIgU21hcnQgTW9uZXksMi4zDQoxMDMgU29jaWFsIFByb2dyZXNzaXZlcywyLjQNCjEwNCBIYXZpbmcgSXQgQWxsLDAuOA0KMTA1IFZpc2libGUgU3VjY2VzcywyLjUNCjEwNiBTZWxmLU1hZGUgTGlmZXN0eWxlcnMsMi43DQoxMDcgRG9tZXN0aWMgQmxpc3MsNA0KMTA4IENhcmVlciBBY2hpZXZlcnMsMi45DQoxMDkgSHVtYW5pdGFyaWFucywzLjQNCjExMCBXb3JsZGx5IGFuZCBXaXNlLDIuOA0KMTExIFN1Y2Nlc3MgTWF0dGVycywwLjkNCjExMiBTYXZ2eSBTZWxmLVN0YXJ0ZXJzLDEuNw0KMTEzIEN1bHR1cmVkIEVwaWN1cmVhbnMsMS43DQoyMDEgWW91bmcgYW5kIFBsYXRpbnVtLDAuMQ0KIjIwMiBIZWFsdGh5LCBXZWFsdGh5IGFuZCBXaXNlIiwwLjcNCjIwMyBDdWx0dXJlIExlYWRlcnMsMC4xDQoyMDQgSGlnaCBMaWZlLDEuMQ0KMjA1IExpYmVydGFyaWFucywzLjgNCjIwNiBGaXQgYW5kIEZhYiwwLjENCjIwNyBTZWFzb25lZCBMaWZlc3R5bGVycywyLjENCjIwOCBGdXR1cmUgRm9jdXMsMi40DQoyMDkgU29jaWFibGUgVHJlbmRzZXR0ZXJzLDEuMw0KMjEwIEFjYWRlbWljIE9wdGltaXN0cywwDQozMDEgU2F2dnkgU2hvcHBlcnMsMC41DQozMDIgR2V0dGluZyBBaGVhZCwxLjgNCjMwMyBQcm9zcGVyb3VzIEZ1dHVyZSwxLjgNCjMwNCBMaWZlc3R5bGUgU2Vla2Vycyw1LjINCjMwNSBUcmVuZCBIdW50ZXJzLDAuMg0KMzA2IEZhZC10YXN0aWMsMC41DQozMDcgRXhwZXJpZW5jZSBTZWVrZXJzLDEuOA0KNDAxIEhvbWUgSW1wcm92ZXJzLDMuOA0KNDAyIFdvcmtpbmcgSGFyZCwyLjcNCjQwMyBSdXN0aWMgSGVhcnRsYW5kLDAuNw0KNDA0IFRyYWRpdGlvbmFsIFZhbHVlcywzLjINCjQwNSBTYWZlIGFuZCBTZWN1cmUsMS45DQo0MDYgQnVpbGRpbmcgU2VjdXJpdHksMS44DQo0MDcgSG91c2UgUHJvdWQsMy41DQo0MDggQ2F1dGlvdXMgQ29uc2VydmF0aXZlcywyLjkNCjQwOSBSZWxheGVkIExpdmluZywxLjUNCjUwMSBNYWtpbmcgRW5kcyBNZWV0LDAuNg0KNTAyIFRlY2ggTGlmZSwxLjINCjUwMyBGdW4gRmlyc3QsMC40DQo1MDQgSG9tZSBFbnRlcnRhaW5tZW50LDIuNw0KNTA1IEZhaXRoIGFuZCBXZWxsYmVpbmcsMC4xDQo1MDYgTWFraW5nIHRoZSBSZW50LDEuMg0KNTA3IEFjdGl2ZSBTb2NpYWwsMC4yDQo1MDggRnJ1Z2FsIExpdmluZywyLjYNCjYwMSBTaW1wbGUgTGl2aW5nLDEuNw0KNjAyIFRvdWdoIFRpbWVzLDEuNg0KNjAzIFF1aWV0IEhvbWVsaWZlLDMuNg0KNjA0IEJ1ZGdldCBMaXZpbmcsMC4xDQo2MDUgRmlsbGluZyBUaW1lLDINCjYwNiBCYXNpYyBMaWZlc3R5bGUsMg0KNjA3IFJhdyBEZWFsLDEuOQ=="', Jz = 'export default "data:text/csv;base64,UGVyc29uYSxQZXJjZW50YWdlCjEwMSBCbHVlY2hpcCw0LjUKMTAyIFNtYXJ0IE1vbmV5LDIuMwoxMDMgRmluYW5jaWFsIEZyZWVkb20sMi40CjEwNCBTZWxmLW1hZGUgTGlmZXN0eWxlcnMsMC44CjEwNSBXb3JsZGx5IGFuZCBXaXNlLDIuNQoxMDYgU3RhdHVzIE1hdHRlcnMsMi43CjEwNyBTYXZ2eSBTZWxmLXN0YXJ0ZXJzLDQKMTA4IEh1bWFuaXRhcmlhbnMsMi45CjEwOSBGdWxsIEhvdXNlLDMuNAoyMDEgWW91bmcgYW5kIFBsYXRpbnVtLDIuOAoiMjAyIEhlYWx0aHksIFdlYWx0aHkgJiBXaXNlIiwwLjkKMjAzIEN1bHR1cmFsIFBpb25lZXJzLDEuNwoyMDQgVXJiYW4gRW50ZXJ0YWluZXJzLDEuNwoyMDUgTmV3IEtpd2lzLDAuMQoyMDYgU29jaWFsIEFjYWRlbWljLDAuNwoyMDcgQmlnIEZ1dHVyZSwwLjEKMjA4IEZpdCBhbmQgRmFiLDEuMQoyMDkgUXVpZXQgQWNoaWV2ZXJzLDMuOAozMDEgQ2FyZWVyIFpvbmUsMC4xCjMwMiBPbiBUaGVpciBXYXksMi4xCjMwMyBQcm9zcGVyb3VzIEZ1dHVyZSwyLjQKMzA0IERvbWVzdGljIEp1Z2dsZXJzLDEuMwozMDUgQXZlcmFnZSBLaXdpLDAKMzA2IERvd24gdG8gRWFydGgsMC41CjQwMSBDb25zZXJ2YXRpdmUgTGlmZXN0eWxlLDEuOAo0MDIgRG9uZSBHb29kLDEuOAo0MDMgVHJhZGl0aW9uYWwgVmFsdWVzLDUuMgo0MDQgQ2FzdGxlIGFuZCBLaWRzLDAuMgo0MDUgQ3VsdHVyZWQgRXBpY3VyZWFucywwLjUKNDA2IEZhbWlseSBGaXJzdCwxLjgKNDA3IFJlbGF4ZWQgTGl2aW5nLDMuOAo0MDggQmFjayB0byBOYXR1cmUsMi43CjUwMSBOZXcgU2Nob29sIENvb2wsMC43CjUwMiBNYWtpbmcgdGhlIFJlbnQsMy4yCjUwMyBNYWtpbmcgRW5kcyBNZWV0LDEuOQo1MDQgRG9pbmcgaXQgVG91Z2gsMS44CjUwNSBMaWZlIFN0cml2ZXJzLDMuNQo1MDYgRnJpbmdlIER3ZWxsZXJzLDIuOQo1MDcgUXVpZXQgaG9tZSBsaWZlLDEuNQo1MDggQmV0dGVyIERheXMsMC42CjUwOSBGYWl0aCAmIEZhbWlseSwxLjIKNTEwIEZydWdhbCBMaXZpbmcsMC40CjUxMSBTaW1wbGUgTGl2aW5nLDIuNwo2MDEgQXJlYXMgaW4gVHJhbnNpdGlvbiwwLjEKNjAyIFN0aWxsIFdvcmtpbmcsMS4yCjYwMyBOZXcgQmVnaW5uaW5ncywwLjIKNjA0IFN0cnVnZ2xlc3RyZWV0LDIuNgo2MDUgQ291cG9uIENsaXBwZXJzLDEuNwo2MDYgUGVubnkgV2lzZSwxLjYKNjA3IFJlYWwgV29ya2luZyBDbGFzcywzLjYKNjA4IEJ1ZGdldCBMaXZpbmcsMC4xCg=="';
function Az({
  setSelectedPersonas: e,
  children: t
}) {
  const n = tp(), r = gr(null), [i, a] = oi(""), {
    personas: o
  } = oa((b) => b.selectedPersonas), s = oa(gz), l = kc() ? ["701", "702"] : ["701"], c = [...s, ...l], d = {
    dynamicTyping: !0,
    skipEmptyLines: "greedy"
  }, p = (b) => {
    a(null);
    try {
      let S = [], _ = [], E = [], k = [], M = [];
      b.map((C) => (Object.keys(C.data).forEach((D) => {
        (C.data[D] === null || C.data[D] === void 0) && delete C.data[D];
      }), C)).forEach((C, D) => {
        const P = C.data[0].toString().trim().includes(" ") ? C.data[0].trim().split(" ")[0] : C.data[0], L = C.data[1];
        if (c.includes(P.toString())) {
          if (k.includes(P)) {
            M.push(P);
            return;
          }
        } else {
          if (D === 0) return;
          S.push(C);
          return;
        }
        if (parseFloat(L) <= 0) {
          _.push(P);
          return;
        }
        return k.push(P), E.push({
          id: C.data[0],
          value: L
        });
      });
      const F = E.filter((C) => !isNaN(parseFloat(C.value))), q = F.reduce((C, D) => C += parseFloat(D.value), 0), j = F.map((C) => ({
        id: parseInt(C.id, 10),
        value: parseFloat(C.value) / q * 1e3 / 10
      })).filter((C) => !l.includes(C.id.toString())), x = r.current && r.current.state && r.current.state.file && r.current.state.file.name;
      n(e(j)), n(Qk({
        fileName: x,
        dirtyData: S,
        personasAdded: k,
        duplicatePersonas: M,
        emptyData: _
      }));
    } catch (S) {
      a(S.message);
    }
  }, y = (b, S, _, E) => {
    a(b);
  }, f = (b) => {
    a(null);
  }, N = () => {
    n(Qw(!0));
  };
  return /* @__PURE__ */ m.jsxs(We, { children: [
    /* @__PURE__ */ m.jsxs(We.Row, { columns: 2, children: [
      /* @__PURE__ */ m.jsxs(We.Column, { children: [
        /* @__PURE__ */ m.jsxs("div", { className: "csv-handler__info-box", children: [
          /* @__PURE__ */ m.jsx($t, { className: "csv-handler__info-icon", name: "info circle", size: "large" }),
          /* @__PURE__ */ m.jsxs("div", { children: [
            /* @__PURE__ */ m.jsx("p", { children: "Your upload file should be in CSV format, with two columns. Your column headers can be anything, but your first column must contain Helix Personas, with non-formatted values in the second column. The values can be any units, but will be used to infer a percentage distribution. You do not need to include all personas, however note that your your total addressable audience will be defined as those personas included." }),
            /* @__PURE__ */ m.jsx("p", { children: "You can download a sample file by clicking the link below." })
          ] })
        ] }),
        /* @__PURE__ */ m.jsx("h2", { children: "File Layout Example" }),
        /* @__PURE__ */ m.jsxs(Qe, { size: "small", compact: "very", celled: !0, className: "csv-handler__example-table", children: [
          /* @__PURE__ */ m.jsx(Qe.Header, { children: /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
            /* @__PURE__ */ m.jsx(Qe.HeaderCell, { children: "Persona" }),
            /* @__PURE__ */ m.jsx(Qe.HeaderCell, { children: "Percentage" })
          ] }) }),
          kc() ? /* @__PURE__ */ m.jsxs(Qe.Body, { children: [
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "101 Bluechip" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "4.5" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "102 Smart Money" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.3" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "103 Financial Freedom" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.4" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "104 Self-made Lifestylers" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "0.8" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "105 Worldly and Wise" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.5" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "106 Status Matters" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.7" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "107 Savvy Self-starters" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "4" })
            ] })
          ] }) : /* @__PURE__ */ m.jsxs(Qe.Body, { children: [
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "101 Bluechip" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "4.5" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "102 Smart Money" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.3" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "103 Social Progressives" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.4" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "104 Having It All" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "0.8" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "105 Visible Success" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.5" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "106 Self-Made Lifestylers" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "2.7" })
            ] }),
            /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "107 Domestic Bliss" }),
              /* @__PURE__ */ m.jsx(Qe.Cell, { children: "4" })
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsxs("div", { className: "csv-handler__output-wrapper", children: [
        /* @__PURE__ */ m.jsx(Xz, { otherPersonaIds: l }),
        /* @__PURE__ */ m.jsxs(
          Kz,
          {
            ref: r,
            onDrop: p,
            onError: y,
            addRemoveButton: !0,
            onRemoveFile: f,
            config: d,
            style: {
              borderRadius: "0px",
              "border-radius": "0px",
              border: "4px dashed #0f849e",
              background: "#E6E6E6"
            },
            children: [
              /* @__PURE__ */ m.jsx(h1, { name: "file", colour: "grey", className: "csv-handler__file-svg" }),
              /* @__PURE__ */ m.jsx("span", { style: {
                paddingTop: "0.5em"
              }, children: "Drag files here or click to browse" }),
              /* @__PURE__ */ m.jsx("span", { children: ".csv only" })
            ]
          }
        ),
        i && /* @__PURE__ */ m.jsx("p", { style: {
          color: "red"
        }, children: i })
      ] }) })
    ] }),
    /* @__PURE__ */ m.jsxs(We.Row, { columns: 2, children: [
      /* @__PURE__ */ m.jsxs(We.Column, { style: {
        display: "flex",
        justifyContent: "space-between"
      }, children: [
        /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "getting-started", children: "Back" }),
        /* @__PURE__ */ m.jsx("a", { className: "ui inverted button find-persona--csv-link", href: kc() ? Jz : Zz, download: "csvExample.csv", children: "Download Example File Layout" })
      ] }),
      /* @__PURE__ */ m.jsxs(We.Column, { style: {
        display: "flex",
        justifyContent: "flex-end"
      }, children: [
        /* @__PURE__ */ m.jsx(Ft, { as: wn, className: `csv-handler__preview-button ${o.length === 0 ? "disabled " : ""}`, to: "personas-distribution", onClick: N, children: "Preview Uploaded Profile" }),
        t && t
      ] })
    ] })
  ] });
}
let eq = class extends R.Component {
  constructor(e) {
    super(e), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "handleCheckBoxAction", () => {
      this.props.loadGroupedPersona();
    }), this.state = {
      showSidebar: !1
    };
  }
  componentDidMount() {
    this.props.briefsFlow !== "find" && (this.props.setBriefsFlow("find"), this.props.selectedPersonas.length && this.props.resetSelectedPersonas()), this.props.loadCommunitiesAndPersonas(), this.props.featureAccess();
  }
  render() {
    const {
      selectedPersonas: e,
      campaignCreatorAccess: t,
      communities: n,
      isFetchingCommunities: r,
      setSelectedPersonas: i
    } = this.props;
    let a = /* @__PURE__ */ m.jsx(Ft, { style: {
      marginLeft: "1em"
    }, as: wn, onClick: () => {
      this.props.setPreviewSelectedPersonas(!1);
    }, to: "message-streams", children: "Next" });
    const o = () => e.length ? a : /* @__PURE__ */ m.jsx(Gi, { position: "top right", content: "You must have uploaded a file with valid personas to proceed to the next page", trigger: /* @__PURE__ */ m.jsx("span", { style: {
      marginLeft: "1em"
    }, className: "ui button button--not-validated", children: "Next" }) });
    return r || !n ? /* @__PURE__ */ m.jsx(ga, {}) : t ? /* @__PURE__ */ m.jsxs(fr, { children: [
      /* @__PURE__ */ m.jsxs("div", { className: "creative-briefs--navigation creative-briefs--navigation__x-pad", children: [
        /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "getting-started", children: "Back" }),
        /* @__PURE__ */ m.jsx("h1", { className: "campaign-creator--title", children: "Upload Your Helix Personas Profile" }),
        /* @__PURE__ */ m.jsx(o, {})
      ] }),
      /* @__PURE__ */ m.jsx("div", { className: "campaign-creator-page", children: /* @__PURE__ */ m.jsx(Az, { setSelectedPersonas: i, children: /* @__PURE__ */ m.jsx(o, {}) }) })
    ] }) : null;
  }
};
const tq = (e, t) => {
  const n = e.options.permissions && e.options.permissions.workflowPermission;
  return {
    communities: e.communities && qu(e),
    isFetchingCommunities: e.communities && e.communities.isFetching,
    selectedPersonas: e.selectedPersonas.personas,
    briefsFlow: e.campaignCreator.briefsFlow,
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess
  };
}, nq = (e) => Kt({
  setSelectedPersonas: u1,
  resetSelectedPersonas: ap,
  featureAccess: ui,
  loadGroupedPersona: Ss,
  loadCommunitiesAndPersonas: i1,
  setBriefsFlow: d1,
  setPreviewSelectedPersonas: Qw
}, e);
Mt(tq, nq)(eq);
var L1 = {}, rq = {
  id: "en-us",
  patterns: [".ach4", ".ad4der", ".af1t", ".al3t", ".am5at", ".an5c", ".ang4", ".ani5m", ".ant4", ".an3te", ".anti5s", ".ar5s", ".ar4tie", ".ar4ty", ".as3c", ".as1p", ".as1s", ".aster5", ".atom5", ".au1d", ".av4i", ".awn4", ".ba4g", ".ba5na", ".bas4e", ".ber4", ".be5ra", ".be3sm", ".be5sto", ".bri2", ".but4ti", ".cam4pe", ".can5c", ".capa5b", ".car5ol", ".ca4t", ".ce4la", ".ch4", ".chill5i", ".ci2", ".cit5r", ".co3e", ".co4r", ".cor5ner", ".de4moi", ".de3o", ".de3ra", ".de3ri", ".des4c", ".dictio5", ".do4t", ".du4c", ".dumb5", ".earth5", ".eas3i", ".eb4", ".eer4", ".eg2", ".el5d", ".el3em", ".enam3", ".en3g", ".en3s", ".eq5ui5t", ".er4ri", ".es3", ".eu3", ".eye5", ".fes3", ".for5mer", ".ga2", ".ge2", ".gen3t4", ".ge5og", ".gi5a", ".gi4b", ".go4r", ".hand5i", ".han5k", ".he2", ".hero5i", ".hes3", ".het3", ".hi3b", ".hi3er", ".hon5ey", ".hon3o", ".hov5", ".id4l", ".idol3", ".im3m", ".im5pin", ".in1", ".in3ci", ".ine2", ".in2k", ".in3s", ".ir5r", ".is4i", ".ju3r", ".la4cy", ".la4m", ".lat5er", ".lath5", ".le2", ".leg5e", ".len4", ".lep5", ".lev1", ".li4g", ".lig5a", ".li2n", ".li3o", ".li4t", ".mag5a5", ".mal5o", ".man5a", ".mar5ti", ".me2", ".mer3c", ".me5ter", ".mis1", ".mist5i", ".mon3e", ".mo3ro", ".mu5ta", ".muta5b", ".ni4c", ".od2", ".odd5", ".of5te", ".or5ato", ".or3c", ".or1d", ".or3t", ".os3", ".os4tl", ".oth3", ".out3", ".ped5al", ".pe5te", ".pe5tit", ".pi4e", ".pio5n", ".pi2t", ".pre3m", ".ra4c", ".ran4t", ".ratio5na", ".ree2", ".re5mit", ".res2", ".re5stat", ".ri4g", ".rit5u", ".ro4q", ".ros5t", ".row5d", ".ru4d", ".sci3e", ".self5", ".sell5", ".se2n", ".se5rie", ".sh2", ".si2", ".sing4", ".st4", ".sta5bl", ".sy2", ".ta4", ".te4", ".ten5an", ".th2", ".ti2", ".til4", ".tim5o5", ".ting4", ".tin5k", ".ton4a", ".to4p", ".top5i", ".tou5s", ".trib5ut", ".un1a", ".un3ce", ".under5", ".un1e", ".un5k", ".un5o", ".un3u", ".up3", ".ure3", ".us5a", ".ven4de", ".ve5ra", ".wil5i", ".ye4", "4ab.", "a5bal", "a5ban", "abe2", "ab5erd", "abi5a", "ab5it5ab", "ab5lat", "ab5o5liz", "4abr", "ab5rog", "ab3ul", "a4car", "ac5ard", "ac5aro", "a5ceou", "ac1er", "a5chet", "4a2ci", "a3cie", "ac1in", "a3cio", "ac5rob", "act5if", "ac3ul", "ac4um", "a2d", "ad4din", "ad5er.", "2adi", "a3dia", "ad3ica", "adi4er", "a3dio", "a3dit", "a5diu", "ad4le", "ad3ow", "ad5ran", "ad4su", "4adu", "a3duc", "ad5um", "ae4r", "aeri4e", "a2f", "aff4", "a4gab", "aga4n", "ag5ell", "age4o", "4ageu", "ag1i", "4ag4l", "ag1n", "a2go", "3agog", "ag3oni", "a5guer", "ag5ul", "a4gy", "a3ha", "a3he", "ah4l", "a3ho", "ai2", "a5ia", "a3ic.", "ai5ly", "a4i4n", "ain5in", "ain5o", "ait5en", "a1j", "ak1en", "al5ab", "al3ad", "a4lar", "4aldi", "2ale", "al3end", "a4lenti", "a5le5o", "al1i", "al4ia.", "ali4e", "al5lev", "4allic", "4alm", "a5log.", "a4ly.", "4alys", "5a5lyst", "5alyt", "3alyz", "4ama", "am5ab", "am3ag", "ama5ra", "am5asc", "a4matis", "a4m5ato", "am5era", "am3ic", "am5if", "am5ily", "am1in", "ami4no", "a2mo", "a5mon", "amor5i", "amp5en", "a2n", "an3age", "3analy", "a3nar", "an3arc", "anar4i", "a3nati", "4and", "ande4s", "an3dis", "an1dl", "an4dow", "a5nee", "a3nen", "an5est.", "a3neu", "2ang", "ang5ie", "an1gl", "a4n1ic", "a3nies", "an3i3f", "an4ime", "a5nimi", "a5nine", "an3io", "a3nip", "an3ish", "an3it", "a3niu", "an4kli", "5anniz", "ano4", "an5ot", "anoth5", "an2sa", "an4sco", "an4sn", "an2sp", "ans3po", "an4st", "an4sur", "antal4", "an4tie", "4anto", "an2tr", "an4tw", "an3ua", "an3ul", "a5nur", "4ao", "apar4", "ap5at", "ap5ero", "a3pher", "4aphi", "a4pilla", "ap5illar", "ap3in", "ap3ita", "a3pitu", "a2pl", "apoc5", "ap5ola", "apor5i", "apos3t", "aps5es", "a3pu", "aque5", "2a2r", "ar3act", "a5rade", "ar5adis", "ar3al", "a5ramete", "aran4g", "ara3p", "ar4at", "a5ratio", "ar5ativ", "a5rau", "ar5av4", "araw4", "arbal4", "ar4chan", "ar5dine", "ar4dr", "ar5eas", "a3ree", "ar3ent", "a5ress", "ar4fi", "ar4fl", "ar1i", "ar5ial", "ar3ian", "a3riet", "ar4im", "ar5inat", "ar3io", "ar2iz", "ar2mi", "ar5o5d", "a5roni", "a3roo", "ar2p", "ar3q", "arre4", "ar4sa", "ar2sh", "4as.", "as4ab", "as3ant", "ashi4", "a5sia.", "a3sib", "a3sic", "5a5si4t", "ask3i", "as4l", "a4soc", "as5ph", "as4sh", "as3ten", "as1tr", "asur5a", "a2ta", "at3abl", "at5ac", "at3alo", "at5ap", "ate5c", "at5ech", "at3ego", "at3en.", "at3era", "ater5n", "a5terna", "at3est", "at5ev", "4ath", "ath5em", "a5then", "at4ho", "ath5om", "4ati.", "a5tia", "at5i5b", "at1ic", "at3if", "ation5ar", "at3itu", "a4tog", "a2tom", "at5omiz", "a4top", "a4tos", "a1tr", "at5rop", "at4sk", "at4tag", "at5te", "at4th", "a2tu", "at5ua", "at5ue", "at3ul", "at3ura", "a2ty", "au4b", "augh3", "au3gu", "au4l2", "aun5d", "au3r", "au5sib", "aut5en", "au1th", "a2va", "av3ag", "a5van", "ave4no", "av3era", "av5ern", "av5ery", "av1i", "avi4er", "av3ig", "av5oc", "a1vor", "3away", "aw3i", "aw4ly", "aws4", "ax4ic", "ax4id", "ay5al", "aye4", "ays4", "azi4er", "azz5i", "5ba.", "bad5ger", "ba4ge", "bal1a", "ban5dag", "ban4e", "ban3i", "barbi5", "bari4a", "bas4si", "1bat", "ba4z", "2b1b", "b2be", "b3ber", "bbi4na", "4b1d", "4be.", "beak4", "beat3", "4be2d", "be3da", "be3de", "be3di", "be3gi", "be5gu", "1bel", "be1li", "be3lo", "4be5m", "be5nig", "be5nu", "4bes4", "be3sp", "be5str", "3bet", "bet5iz", "be5tr", "be3tw", "be3w", "be5yo", "2bf", "4b3h", "bi2b", "bi4d", "3bie", "bi5en", "bi4er", "2b3if", "1bil", "bi3liz", "bina5r4", "bin4d", "bi5net", "bi3ogr", "bi5ou", "bi2t", "3bi3tio", "bi3tr", "3bit5ua", "b5itz", "b1j", "bk4", "b2l2", "blath5", "b4le.", "blen4", "5blesp", "b3lis", "b4lo", "blun4t", "4b1m", "4b3n", "bne5g", "3bod", "bod3i", "bo4e", "bol3ic", "bom4bi", "bon4a", "bon5at", "3boo", "5bor.", "4b1ora", "bor5d", "5bore", "5bori", "5bos4", "b5ota", "both5", "bo4to", "bound3", "4bp", "4brit", "broth3", "2b5s2", "bsor4", "2bt", "bt4l", "b4to", "b3tr", "buf4fer", "bu4ga", "bu3li", "bumi4", "bu4n", "bunt4i", "bu3re", "bus5ie", "buss4e", "5bust", "4buta", "3butio", "b5uto", "b1v", "4b5w", "5by.", "bys4", "1ca", "cab3in", "ca1bl", "cach4", "ca5den", "4cag4", "2c5ah", "ca3lat", "cal4la", "call5in", "4calo", "can5d", "can4e", "can4ic", "can5is", "can3iz", "can4ty", "cany4", "ca5per", "car5om", "cast5er", "cas5tig", "4casy", "ca4th", "4cativ", "cav5al", "c3c", "ccha5", "cci4a", "ccompa5", "ccon4", "ccou3t", "2ce.", "4ced.", "4ceden", "3cei", "5cel.", "3cell", "1cen", "3cenc", "2cen4e", "4ceni", "3cent", "3cep", "ce5ram", "4cesa", "3cessi", "ces5si5b", "ces5t", "cet4", "c5e4ta", "cew4", "2ch", "4ch.", "4ch3ab", "5chanic", "ch5a5nis", "che2", "cheap3", "4ched", "che5lo", "3chemi", "ch5ene", "ch3er.", "ch3ers", "4ch1in", "5chine.", "ch5iness", "5chini", "5chio", "3chit", "chi2z", "3cho2", "ch4ti", "1ci", "3cia", "ci2a5b", "cia5r", "ci5c", "4cier", "5cific.", "4cii", "ci4la", "3cili", "2cim", "2cin", "c4ina", "3cinat", "cin3em", "c1ing", "c5ing.", "5cino", "cion4", "4cipe", "ci3ph", "4cipic", "4cista", "4cisti", "2c1it", "cit3iz", "5ciz", "ck1", "ck3i", "1c4l4", "4clar", "c5laratio", "5clare", "cle4m", "4clic", "clim4", "cly4", "c5n", "1co", "co5ag", "coe2", "2cog", "co4gr", "coi4", "co3inc", "col5i", "5colo", "col3or", "com5er", "con4a", "c4one", "con3g", "con5t", "co3pa", "cop3ic", "co4pl", "4corb", "coro3n", "cos4e", "cov1", "cove4", "cow5a", "coz5e", "co5zi", "c1q", "cras5t", "5crat.", "5cratic", "cre3at", "5cred", "4c3reta", "cre4v", "cri2", "cri5f", "c4rin", "cris4", "5criti", "cro4pl", "crop5o", "cros4e", "cru4d", "4c3s2", "2c1t", "cta4b", "ct5ang", "c5tant", "c2te", "c3ter", "c4ticu", "ctim3i", "ctu4r", "c4tw", "cud5", "c4uf", "c4ui", "cu5ity", "5culi", "cul4tis", "3cultu", "cu2ma", "c3ume", "cu4mi", "3cun", "cu3pi", "cu5py", "cur5a4b", "cu5ria", "1cus", "cuss4i", "3c4ut", "cu4tie", "4c5utiv", "4cutr", "1cy", "cze4", "1d2a", "5da.", "2d3a4b", "dach4", "4daf", "2dag", "da2m2", "dan3g", "dard5", "dark5", "4dary", "3dat", "4dativ", "4dato", "5dav4", "dav5e", "5day", "d1b", "d5c", "d1d4", "2de.", "deaf5", "deb5it", "de4bon", "decan4", "de4cil", "de5com", "2d1ed", "4dee.", "de5if", "deli4e", "del5i5q", "de5lo", "d4em", "5dem.", "3demic", "dem5ic.", "de5mil", "de4mons", "demor5", "1den", "de4nar", "de3no", "denti5f", "de3nu", "de1p", "de3pa", "depi4", "de2pu", "d3eq", "d4erh", "5derm", "dern5iz", "der5s", "des2", "d2es.", "de1sc", "de2s5o", "des3ti", "de3str", "de4su", "de1t", "de2to", "de1v", "dev3il", "4dey", "4d1f", "d4ga", "d3ge4t", "dg1i", "d2gy", "d1h2", "5di.", "1d4i3a", "dia5b", "di4cam", "d4ice", "3dict", "3did", "5di3en", "d1if", "di3ge", "di4lato", "d1in", "1dina", "3dine.", "5dini", "di5niz", "1dio", "dio5g", "di4pl", "dir2", "di1re", "dirt5i", "dis1", "5disi", "d4is3t", "d2iti", "1di1v", "d1j", "d5k2", "4d5la", "3dle.", "3dled", "3dles.", "4dless", "2d3lo", "4d5lu", "2dly", "d1m", "4d1n4", "1do", "3do.", "do5de", "5doe", "2d5of", "d4og", "do4la", "doli4", "do5lor", "dom5iz", "do3nat", "doni4", "doo3d", "dop4p", "d4or", "3dos", "4d5out", "do4v", "3dox", "d1p", "1dr", "drag5on", "4drai", "dre4", "drea5r", "5dren", "dri4b", "dril4", "dro4p", "4drow", "5drupli", "4dry", "2d1s2", "ds4p", "d4sw", "d4sy", "d2th", "1du", "d1u1a", "du2c", "d1uca", "duc5er", "4duct.", "4ducts", "du5el", "du4g", "d3ule", "dum4be", "du4n", "4dup", "du4pe", "d1v", "d1w", "d2y", "5dyn", "dy4se", "dys5p", "e1a4b", "e3act", "ead1", "ead5ie", "ea4ge", "ea5ger", "ea4l", "eal5er", "eal3ou", "eam3er", "e5and", "ear3a", "ear4c", "ear5es", "ear4ic", "ear4il", "ear5k", "ear2t", "eart3e", "ea5sp", "e3ass", "east3", "ea2t", "eat5en", "eath3i", "e5atif", "e4a3tu", "ea2v", "eav3en", "eav5i", "eav5o", "2e1b", "e4bel.", "e4bels", "e4ben", "e4bit", "e3br", "e4cad", "ecan5c", "ecca5", "e1ce", "ec5essa", "ec2i", "e4cib", "ec5ificat", "ec5ifie", "ec5ify", "ec3im", "eci4t", "e5cite", "e4clam", "e4clus", "e2col", "e4comm", "e4compe", "e4conc", "e2cor", "ec3ora", "eco5ro", "e1cr", "e4crem", "ec4tan", "ec4te", "e1cu", "e4cul", "ec3ula", "2e2da", "4ed3d", "e4d1er", "ede4s", "4edi", "e3dia", "ed3ib", "ed3ica", "ed3im", "ed1it", "edi5z", "4edo", "e4dol", "edon2", "e4dri", "e4dul", "ed5ulo", "ee2c", "eed3i", "ee2f", "eel3i", "ee4ly", "ee2m", "ee4na", "ee4p1", "ee2s4", "eest4", "ee4ty", "e5ex", "e1f", "e4f3ere", "1eff", "e4fic", "5efici", "efil4", "e3fine", "ef5i5nite", "3efit", "efor5es", "e4fuse.", "4egal", "eger4", "eg5ib", "eg4ic", "eg5ing", "e5git5", "eg5n", "e4go.", "e4gos", "eg1ul", "e5gur", "5egy", "e1h4", "eher4", "ei2", "e5ic", "ei5d", "eig2", "ei5gl", "e3imb", "e3inf", "e1ing", "e5inst", "eir4d", "eit3e", "ei3th", "e5ity", "e1j", "e4jud", "ej5udi", "eki4n", "ek4la", "e1la", "e4la.", "e4lac", "elan4d", "el5ativ", "e4law", "elaxa4", "e3lea", "el5ebra", "5elec", "e4led", "el3ega", "e5len", "e4l1er", "e1les", "el2f", "el2i", "e3libe", "e4l5ic.", "el3ica", "e3lier", "el5igib", "e5lim", "e4l3ing", "e3lio", "e2lis", "el5ish", "e3liv3", "4ella", "el4lab", "ello4", "e5loc", "el5og", "el3op.", "el2sh", "el4ta", "e5lud", "el5ug", "e4mac", "e4mag", "e5man", "em5ana", "em5b", "e1me", "e2mel", "e4met", "em3ica", "emi4e", "em5igra", "em1in2", "em5ine", "em3i3ni", "e4mis", "em5ish", "e5miss", "em3iz", "5emniz", "emo4g", "emoni5o", "em3pi", "e4mul", "em5ula", "emu3n", "e3my", "en5amo", "e4nant", "ench4er", "en3dic", "e5nea", "e5nee", "en3em", "en5ero", "en5esi", "en5est", "en3etr", "e3new", "en5ics", "e5nie", "e5nil", "e3nio", "en3ish", "en3it", "e5niu", "5eniz", "4enn", "4eno", "eno4g", "e4nos", "en3ov", "en4sw", "ent5age", "4enthes", "en3ua", "en5uf", "e3ny.", "4en3z", "e5of", "eo2g", "e4oi4", "e3ol", "eop3ar", "e1or", "eo3re", "eo5rol", "eos4", "e4ot", "eo4to", "e5out", "e5ow", "e2pa", "e3pai", "ep5anc", "e5pel", "e3pent", "ep5etitio", "ephe4", "e4pli", "e1po", "e4prec", "ep5reca", "e4pred", "ep3reh", "e3pro", "e4prob", "ep4sh", "ep5ti5b", "e4put", "ep5uta", "e1q", "equi3l", "e4q3ui3s", "er1a", "era4b", "4erand", "er3ar", "4erati.", "2erb", "er4bl", "er3ch", "er4che", "2ere.", "e3real", "ere5co", "ere3in", "er5el.", "er3emo", "er5ena", "er5ence", "4erene", "er3ent", "ere4q", "er5ess", "er3est", "eret4", "er1h", "er1i", "e1ria4", "5erick", "e3rien", "eri4er", "er3ine", "e1rio", "4erit", "er4iu", "eri4v", "e4riva", "er3m4", "er4nis", "4ernit", "5erniz", "er3no", "2ero", "er5ob", "e5roc", "ero4r", "er1ou", "er1s", "er3set", "ert3er", "4ertl", "er3tw", "4eru", "eru4t", "5erwau", "e1s4a", "e4sage.", "e4sages", "es2c", "e2sca", "es5can", "e3scr", "es5cu", "e1s2e", "e2sec", "es5ecr", "es5enc", "e4sert.", "e4serts", "e4serva", "4esh", "e3sha", "esh5en", "e1si", "e2sic", "e2sid", "es5iden", "es5igna", "e2s5im", "es4i4n", "esis4te", "esi4u", "e5skin", "es4mi", "e2sol", "es3olu", "e2son", "es5ona", "e1sp", "es3per", "es5pira", "es4pre", "2ess", "es4si4b", "estan4", "es3tig", "es5tim", "4es2to", "e3ston", "2estr", "e5stro", "estruc5", "e2sur", "es5urr", "es4w", "eta4b", "eten4d", "e3teo", "ethod3", "et1ic", "e5tide", "etin4", "eti4no", "e5tir", "e5titio", "et5itiv", "4etn", "et5ona", "e3tra", "e3tre", "et3ric", "et5rif", "et3rog", "et5ros", "et3ua", "et5ym", "et5z", "4eu", "e5un", "e3up", "eu3ro", "eus4", "eute4", "euti5l", "eu5tr", "eva2p5", "e2vas", "ev5ast", "e5vea", "ev3ell", "evel3o", "e5veng", "even4i", "ev1er", "e5verb", "e1vi", "ev3id", "evi4l", "e4vin", "evi4v", "e5voc", "e5vu", "e1wa", "e4wag", "e5wee", "e3wh", "ewil5", "ew3ing", "e3wit", "1exp", "5eyc", "5eye.", "eys4", "1fa", "fa3bl", "fab3r", "fa4ce", "4fag", "fain4", "fall5e", "4fa4ma", "fam5is", "5far", "far5th", "fa3ta", "fa3the", "4fato", "fault5", "4f5b", "4fd", "4fe.", "feas4", "feath3", "fe4b", "4feca", "5fect", "2fed", "fe3li", "fe4mo", "fen2d", "fend5e", "fer1", "5ferr", "fev4", "4f1f", "f4fes", "f4fie", "f5fin.", "f2f5is", "f4fly", "f2fy", "4fh", "1fi", "fi3a", "2f3ic.", "4f3ical", "f3ican", "4ficate", "f3icen", "fi3cer", "fic4i", "5ficia", "5ficie", "4fics", "fi3cu", "fi5del", "fight5", "fil5i", "fill5in", "4fily", "2fin", "5fina", "fin2d5", "fi2ne", "f1in3g", "fin4n", "fis4ti", "f4l2", "f5less", "flin4", "flo3re", "f2ly5", "4fm", "4fn", "1fo", "5fon", "fon4de", "fon4t", "fo2r", "fo5rat", "for5ay", "fore5t", "for4i", "fort5a", "fos5", "4f5p", "fra4t", "f5rea", "fres5c", "fri2", "fril4", "frol5", "2f3s", "2ft", "f4to", "f2ty", "3fu", "fu5el", "4fug", "fu4min", "fu5ne", "fu3ri", "fusi4", "fus4s", "4futa", "1fy", "1ga", "gaf4", "5gal.", "3gali", "ga3lo", "2gam", "ga5met", "g5amo", "gan5is", "ga3niz", "gani5za", "4gano", "gar5n4", "gass4", "gath3", "4gativ", "4gaz", "g3b", "gd4", "2ge.", "2ged", "geez4", "gel4in", "ge5lis", "ge5liz", "4gely", "1gen", "ge4nat", "ge5niz", "4geno", "4geny", "1geo", "ge3om", "g4ery", "5gesi", "geth5", "4geto", "ge4ty", "ge4v", "4g1g2", "g2ge", "g3ger", "gglu5", "ggo4", "gh3in", "gh5out", "gh4to", "5gi.", "1gi4a", "gia5r", "g1ic", "5gicia", "g4ico", "gien5", "5gies.", "gil4", "g3imen", "3g4in.", "gin5ge", "5g4ins", "5gio", "3gir", "gir4l", "g3isl", "gi4u", "5giv", "3giz", "gl2", "gla4", "glad5i", "5glas", "1gle", "gli4b", "g3lig", "3glo", "glo3r", "g1m", "g4my", "gn4a", "g4na.", "gnet4t", "g1ni", "g2nin", "g4nio", "g1no", "g4non", "1go", "3go.", "gob5", "5goe", "3g4o4g", "go3is", "gon2", "4g3o3na", "gondo5", "go3ni", "5goo", "go5riz", "gor5ou", "5gos.", "gov1", "g3p", "1gr", "4grada", "g4rai", "gran2", "5graph.", "g5rapher", "5graphic", "4graphy", "4gray", "gre4n", "4gress.", "4grit", "g4ro", "gruf4", "gs2", "g5ste", "gth3", "gu4a", "3guard", "2gue", "5gui5t", "3gun", "3gus", "4gu4t", "g3w", "1gy", "2g5y3n", "gy5ra", "h3ab4l", "hach4", "hae4m", "hae4t", "h5agu", "ha3la", "hala3m", "ha4m", "han4ci", "han4cy", "5hand.", "han4g", "hang5er", "hang5o", "h5a5niz", "han4k", "han4te", "hap3l", "hap5t", "ha3ran", "ha5ras", "har2d", "hard3e", "har4le", "harp5en", "har5ter", "has5s", "haun4", "5haz", "haz3a", "h1b", "1head", "3hear", "he4can", "h5ecat", "h4ed", "he5do5", "he3l4i", "hel4lis", "hel4ly", "h5elo", "hem4p", "he2n", "hena4", "hen5at", "heo5r", "hep5", "h4era", "hera3p", "her4ba", "here5a", "h3ern", "h5erou", "h3ery", "h1es", "he2s5p", "he4t", "het4ed", "heu4", "h1f", "h1h", "hi5an", "hi4co", "high5", "h4il2", "himer4", "h4ina", "hion4e", "hi4p", "hir4l", "hi3ro", "hir4p", "hir4r", "his3el", "his4s", "hith5er", "hi2v", "4hk", "4h1l4", "hlan4", "h2lo", "hlo3ri", "4h1m", "hmet4", "2h1n", "h5odiz", "h5ods", "ho4g", "hoge4", "hol5ar", "3hol4e", "ho4ma", "home3", "hon4a", "ho5ny", "3hood", "hoon4", "hor5at", "ho5ris", "hort3e", "ho5ru", "hos4e", "ho5sen", "hos1p", "1hous", "house3", "hov5el", "4h5p", "4hr4", "hree5", "hro5niz", "hro3po", "4h1s2", "h4sh", "h4tar", "ht1en", "ht5es", "h4ty", "hu4g", "hu4min", "hun5ke", "hun4t", "hus3t4", "hu4t", "h1w", "h4wart", "hy3pe", "hy3ph", "hy2s", "2i1a", "i2al", "iam4", "iam5ete", "i2an", "4ianc", "ian3i", "4ian4t", "ia5pe", "iass4", "i4ativ", "ia4tric", "i4atu", "ibe4", "ib3era", "ib5ert", "ib5ia", "ib3in", "ib5it.", "ib5ite", "i1bl", "ib3li", "i5bo", "i1br", "i2b5ri", "i5bun", "4icam", "5icap", "4icar", "i4car.", "i4cara", "icas5", "i4cay", "iccu4", "4iceo", "4ich", "2ici", "i5cid", "ic5ina", "i2cip", "ic3ipa", "i4cly", "i2c5oc", "4i1cr", "5icra", "i4cry", "ic4te", "ictu2", "ic4t3ua", "ic3ula", "ic4um", "ic5uo", "i3cur", "2id", "i4dai", "id5anc", "id5d", "ide3al", "ide4s", "i2di", "id5ian", "idi4ar", "i5die", "id3io", "idi5ou", "id1it", "id5iu", "i3dle", "i4dom", "id3ow", "i4dr", "i2du", "id5uo", "2ie4", "ied4e", "5ie5ga", "ield3", "ien5a4", "ien4e", "i5enn", "i3enti", "i1er.", "i3esc", "i1est", "i3et", "4if.", "if5ero", "iff5en", "if4fr", "4ific.", "i3fie", "i3fl", "4ift", "2ig", "iga5b", "ig3era", "ight3i", "4igi", "i3gib", "ig3il", "ig3in", "ig3it", "i4g4l", "i2go", "ig3or", "ig5ot", "i5gre", "igu5i", "ig1ur", "i3h", "4i5i4", "i3j", "4ik", "i1la", "il3a4b", "i4lade", "i2l5am", "ila5ra", "i3leg", "il1er", "ilev4", "il5f", "il1i", "il3ia", "il2ib", "il3io", "il4ist", "2ilit", "il2iz", "ill5ab", "4iln", "il3oq", "il4ty", "il5ur", "il3v", "i4mag", "im3age", "ima5ry", "imenta5r", "4imet", "im1i", "im5ida", "imi5le", "i5mini", "4imit", "im4ni", "i3mon", "i2mu", "im3ula", "2in.", "i4n3au", "4inav", "incel4", "in3cer", "4ind", "in5dling", "2ine", "i3nee", "iner4ar", "i5ness", "4inga", "4inge", "in5gen", "4ingi", "in5gling", "4ingo", "4ingu", "2ini", "i5ni.", "i4nia", "in3io", "in1is", "i5nite.", "5initio", "in3ity", "4ink", "4inl", "2inn", "2i1no", "i4no4c", "ino4s", "i4not", "2ins", "in3se", "insur5a", "2int.", "2in4th", "in1u", "i5nus", "4iny", "2io", "4io.", "ioge4", "io2gr", "i1ol", "io4m", "ion3at", "ion4ery", "ion3i", "io5ph", "ior3i", "i4os", "io5th", "i5oti", "io4to", "i4our", "2ip", "ipe4", "iphras4", "ip3i", "ip4ic", "ip4re4", "ip3ul", "i3qua", "iq5uef", "iq3uid", "iq3ui3t", "4ir", "i1ra", "ira4b", "i4rac", "ird5e", "ire4de", "i4ref", "i4rel4", "i4res", "ir5gi", "ir1i", "iri5de", "ir4is", "iri3tu", "5i5r2iz", "ir4min", "iro4g", "5iron.", "ir5ul", "2is.", "is5ag", "is3ar", "isas5", "2is1c", "is3ch", "4ise", "is3er", "3isf", "is5han", "is3hon", "ish5op", "is3ib", "isi4d", "i5sis", "is5itiv", "4is4k", "islan4", "4isms", "i2so", "iso5mer", "is1p", "is2pi", "is4py", "4is1s", "is4sal", "issen4", "is4ses", "is4ta.", "is1te", "is1ti", "ist4ly", "4istral", "i2su", "is5us", "4ita.", "ita4bi", "i4tag", "4ita5m", "i3tan", "i3tat", "2ite", "it3era", "i5teri", "it4es", "2ith", "i1ti", "4itia", "4i2tic", "it3ica", "5i5tick", "it3ig", "it5ill", "i2tim", "2itio", "4itis", "i4tism", "i2t5o5m", "4iton", "i4tram", "it5ry", "4itt", "it3uat", "i5tud", "it3ul", "4itz.", "i1u", "2iv", "iv3ell", "iv3en.", "i4v3er.", "i4vers.", "iv5il.", "iv5io", "iv1it", "i5vore", "iv3o3ro", "i4v3ot", "4i5w", "ix4o", "4iy", "4izar", "izi4", "5izont", "5ja", "jac4q", "ja4p", "1je", "jer5s", "4jestie", "4jesty", "jew3", "jo4p", "5judg", "3ka.", "k3ab", "k5ag", "kais4", "kal4", "k1b", "k2ed", "1kee", "ke4g", "ke5li", "k3en4d", "k1er", "kes4", "k3est.", "ke4ty", "k3f", "kh4", "k1i", "5ki.", "5k2ic", "k4ill", "kilo5", "k4im", "k4in.", "kin4de", "k5iness", "kin4g", "ki4p", "kis4", "k5ish", "kk4", "k1l", "4kley", "4kly", "k1m", "k5nes", "1k2no", "ko5r", "kosh4", "k3ou", "kro5n", "4k1s2", "k4sc", "ks4l", "k4sy", "k5t", "k1w", "lab3ic", "l4abo", "laci4", "l4ade", "la3dy", "lag4n", "lam3o", "3land", "lan4dl", "lan5et", "lan4te", "lar4g", "lar3i", "las4e", "la5tan", "4lateli", "4lativ", "4lav", "la4v4a", "2l1b", "lbin4", "4l1c2", "lce4", "l3ci", "2ld", "l2de", "ld4ere", "ld4eri", "ldi4", "ld5is", "l3dr", "l4dri", "le2a", "le4bi", "left5", "5leg.", "5legg", "le4mat", "lem5atic", "4len.", "3lenc", "5lene.", "1lent", "le3ph", "le4pr", "lera5b", "ler4e", "3lerg", "3l4eri", "l4ero", "les2", "le5sco", "5lesq", "3less", "5less.", "l3eva", "lev4er.", "lev4era", "lev4ers", "3ley", "4leye", "2lf", "l5fr", "4l1g4", "l5ga", "lgar3", "l4ges", "lgo3", "2l3h", "li4ag", "li2am", "liar5iz", "li4as", "li4ato", "li5bi", "5licio", "li4cor", "4lics", "4lict.", "l4icu", "l3icy", "l3ida", "lid5er", "3lidi", "lif3er", "l4iff", "li4fl", "5ligate", "3ligh", "li4gra", "3lik", "4l4i4l", "lim4bl", "lim3i", "li4mo", "l4im4p", "l4ina", "1l4ine", "lin3ea", "lin3i", "link5er", "li5og", "4l4iq", "lis4p", "l1it", "l2it.", "5litica", "l5i5tics", "liv3er", "l1iz", "4lj", "lka3", "l3kal", "lka4t", "l1l", "l4law", "l2le", "l5lea", "l3lec", "l3leg", "l3lel", "l3le4n", "l3le4t", "ll2i", "l2lin4", "l5lina", "ll4o", "lloqui5", "ll5out", "l5low", "2lm", "l5met", "lm3ing", "l4mod", "lmon4", "2l1n2", "3lo.", "lob5al", "lo4ci", "4lof", "3logic", "l5ogo", "3logu", "lom3er", "5long", "lon4i", "l3o3niz", "lood5", "5lope.", "lop3i", "l3opm", "lora4", "lo4rato", "lo5rie", "lor5ou", "5los.", "los5et", "5losophiz", "5losophy", "los4t", "lo4ta", "loun5d", "2lout", "4lov", "2lp", "lpa5b", "l3pha", "l5phi", "lp5ing", "l3pit", "l4pl", "l5pr", "4l1r", "2l1s2", "l4sc", "l2se", "l4sie", "4lt", "lt5ag", "ltane5", "l1te", "lten4", "ltera4", "lth3i", "l5ties.", "ltis4", "l1tr", "ltu2", "ltur3a", "lu5a", "lu3br", "luch4", "lu3ci", "lu3en", "luf4", "lu5id", "lu4ma", "5lumi", "l5umn.", "5lumnia", "lu3o", "luo3r", "4lup", "luss4", "lus3te", "1lut", "l5ven", "l5vet4", "2l1w", "1ly", "4lya", "4lyb", "ly5me", "ly3no", "2lys4", "l5yse", "1ma", "2mab", "ma2ca", "ma5chine", "ma4cl", "mag5in", "5magn", "2mah", "maid5", "4mald", "ma3lig", "ma5lin", "mal4li", "mal4ty", "5mania", "man5is", "man3iz", "4map", "ma5rine.", "ma5riz", "mar4ly", "mar3v", "ma5sce", "mas4e", "mas1t", "5mate", "math3", "ma3tis", "4matiza", "4m1b", "mba4t5", "m5bil", "m4b3ing", "mbi4v", "4m5c", "4me.", "2med", "4med.", "5media", "me3die", "m5e5dy", "me2g", "mel5on", "mel4t", "me2m", "mem1o3", "1men", "men4a", "men5ac", "men4de", "4mene", "men4i", "mens4", "mensu5", "3ment", "men4te", "me5on", "m5ersa", "2mes", "3mesti", "me4ta", "met3al", "me1te", "me5thi", "m4etr", "5metric", "me5trie", "me3try", "me4v", "4m1f", "2mh", "5mi.", "mi3a", "mid4a", "mid4g", "mig4", "3milia", "m5i5lie", "m4ill", "min4a", "3mind", "m5inee", "m4ingl", "min5gli", "m5ingly", "min4t", "m4inu", "miot4", "m2is", "mis4er.", "mis5l", "mis4ti", "m5istry", "4mith", "m2iz", "4mk", "4m1l", "m1m", "mma5ry", "4m1n", "mn4a", "m4nin", "mn4o", "1mo", "4mocr", "5mocratiz", "mo2d1", "mo4go", "mois2", "moi5se", "4mok", "mo5lest", "mo3me", "mon5et", "mon5ge", "moni3a", "mon4ism", "mon4ist", "mo3niz", "monol4", "mo3ny.", "mo2r", "4mora.", "mos2", "mo5sey", "mo3sp", "moth3", "m5ouf", "3mous", "mo2v", "4m1p", "mpara5", "mpa5rab", "mpar5i", "m3pet", "mphas4", "m2pi", "mpi4a", "mp5ies", "m4p1in", "m5pir", "mp5is", "mpo3ri", "mpos5ite", "m4pous", "mpov5", "mp4tr", "m2py", "4m3r", "4m1s2", "m4sh", "m5si", "4mt", "1mu", "mula5r4", "5mult", "multi3", "3mum", "mun2", "4mup", "mu4u", "4mw", "1na", "2n1a2b", "n4abu", "4nac.", "na4ca", "n5act", "nag5er.", "nak4", "na4li", "na5lia", "4nalt", "na5mit", "n2an", "nanci4", "nan4it", "nank4", "nar3c", "4nare", "nar3i", "nar4l", "n5arm", "n4as", "nas4c", "nas5ti", "n2at", "na3tal", "nato5miz", "n2au", "nau3se", "3naut", "nav4e", "4n1b4", "ncar5", "n4ces.", "n3cha", "n5cheo", "n5chil", "n3chis", "nc1in", "nc4it", "ncour5a", "n1cr", "n1cu", "n4dai", "n5dan", "n1de", "nd5est.", "ndi4b", "n5d2if", "n1dit", "n3diz", "n5duc", "ndu4r", "nd2we", "2ne.", "n3ear", "ne2b", "neb3u", "ne2c", "5neck", "2ned", "ne4gat", "neg5ativ", "5nege", "ne4la", "nel5iz", "ne5mi", "ne4mo", "1nen", "4nene", "3neo", "ne4po", "ne2q", "n1er", "nera5b", "n4erar", "n2ere", "n4er5i", "ner4r", "1nes", "2nes.", "4nesp", "2nest", "4nesw", "3netic", "ne4v", "n5eve", "ne4w", "n3f", "n4gab", "n3gel", "nge4n4e", "n5gere", "n3geri", "ng5ha", "n3gib", "ng1in", "n5git", "n4gla", "ngov4", "ng5sh", "n1gu", "n4gum", "n2gy", "4n1h4", "nha4", "nhab3", "nhe4", "3n4ia", "ni3an", "ni4ap", "ni3ba", "ni4bl", "ni4d", "ni5di", "ni4er", "ni2fi", "ni5ficat", "n5igr", "nik4", "n1im", "ni3miz", "n1in", "5nine.", "nin4g", "ni4o", "5nis.", "nis4ta", "n2it", "n4ith", "3nitio", "n3itor", "ni3tr", "n1j", "4nk2", "n5kero", "n3ket", "nk3in", "n1kl", "4n1l", "n5m", "nme4", "nmet4", "4n1n2", "nne4", "nni3al", "nni4v", "nob4l", "no3ble", "n5ocl", "4n3o2d", "3noe", "4nog", "noge4", "nois5i", "no5l4i", "5nologis", "3nomic", "n5o5miz", "no4mo", "no3my", "no4n", "non4ag", "non5i", "n5oniz", "4nop", "5nop5o5li", "nor5ab", "no4rary", "4nosc", "nos4e", "nos5t", "no5ta", "1nou", "3noun", "nov3el3", "nowl3", "n1p4", "npi4", "npre4c", "n1q", "n1r", "nru4", "2n1s2", "ns5ab", "nsati4", "ns4c", "n2se", "n4s3es", "nsid1", "nsig4", "n2sl", "ns3m", "n4soc", "ns4pe", "n5spi", "nsta5bl", "n1t", "nta4b", "nter3s", "nt2i", "n5tib", "nti4er", "nti2f", "n3tine", "n4t3ing", "nti4p", "ntrol5li", "nt4s", "ntu3me", "nu1a", "nu4d", "nu5en", "nuf4fe", "n3uin", "3nu3it", "n4um", "nu1me", "n5umi", "3nu4n", "n3uo", "nu3tr", "n1v2", "n1w4", "nym4", "nyp4", "4nz", "n3za", "4oa", "oad3", "o5a5les", "oard3", "oas4e", "oast5e", "oat5i", "ob3a3b", "o5bar", "obe4l", "o1bi", "o2bin", "ob5ing", "o3br", "ob3ul", "o1ce", "och4", "o3chet", "ocif3", "o4cil", "o4clam", "o4cod", "oc3rac", "oc5ratiz", "ocre3", "5ocrit", "octor5a", "oc3ula", "o5cure", "od5ded", "od3ic", "odi3o", "o2do4", "odor3", "od5uct.", "od5ucts", "o4el", "o5eng", "o3er", "oe4ta", "o3ev", "o2fi", "of5ite", "ofit4t", "o2g5a5r", "og5ativ", "o4gato", "o1ge", "o5gene", "o5geo", "o4ger", "o3gie", "1o1gis", "og3it", "o4gl", "o5g2ly", "3ogniz", "o4gro", "ogu5i", "1ogy", "2ogyn", "o1h2", "ohab5", "oi2", "oic3es", "oi3der", "oiff4", "oig4", "oi5let", "o3ing", "oint5er", "o5ism", "oi5son", "oist5en", "oi3ter", "o5j", "2ok", "o3ken", "ok5ie", "o1la", "o4lan", "olass4", "ol2d", "old1e", "ol3er", "o3lesc", "o3let", "ol4fi", "ol2i", "o3lia", "o3lice", "ol5id.", "o3li4f", "o5lil", "ol3ing", "o5lio", "o5lis.", "ol3ish", "o5lite", "o5litio", "o5liv", "olli4e", "ol5ogiz", "olo4r", "ol5pl", "ol2t", "ol3ub", "ol3ume", "ol3un", "o5lus", "ol2v", "o2ly", "om5ah", "oma5l", "om5atiz", "om2be", "om4bl", "o2me", "om3ena", "om5erse", "o4met", "om5etry", "o3mia", "om3ic.", "om3ica", "o5mid", "om1in", "o5mini", "5ommend", "omo4ge", "o4mon", "om3pi", "ompro5", "o2n", "on1a", "on4ac", "o3nan", "on1c", "3oncil", "2ond", "on5do", "o3nen", "on5est", "on4gu", "on1ic", "o3nio", "on1is", "o5niu", "on3key", "on4odi", "on3omy", "on3s", "onspi4", "onspir5a", "onsu4", "onten4", "on3t4i", "ontif5", "on5um", "onva5", "oo2", "ood5e", "ood5i", "oo4k", "oop3i", "o3ord", "oost5", "o2pa", "ope5d", "op1er", "3opera", "4operag", "2oph", "o5phan", "o5pher", "op3ing", "o3pit", "o5pon", "o4posi", "o1pr", "op1u", "opy5", "o1q", "o1ra", "o5ra.", "o4r3ag", "or5aliz", "or5ange", "ore5a", "o5real", "or3ei", "ore5sh", "or5est.", "orew4", "or4gu", "4o5ria", "or3ica", "o5ril", "or1in", "o1rio", "or3ity", "o3riu", "or2mi", "orn2e", "o5rof", "or3oug", "or5pe", "3orrh", "or4se", "ors5en", "orst4", "or3thi", "or3thy", "or4ty", "o5rum", "o1ry", "os3al", "os2c", "os4ce", "o3scop", "4oscopi", "o5scr", "os4i4e", "os5itiv", "os3ito", "os3ity", "osi4u", "os4l", "o2so", "os4pa", "os4po", "os2ta", "o5stati", "os5til", "os5tit", "o4tan", "otele4g", "ot3er.", "ot5ers", "o4tes", "4oth", "oth5esi", "oth3i4", "ot3ic.", "ot5ica", "o3tice", "o3tif", "o3tis", "oto5s", "ou2", "ou3bl", "ouch5i", "ou5et", "ou4l", "ounc5er", "oun2d", "ou5v", "ov4en", "over4ne", "over3s", "ov4ert", "o3vis", "oviti4", "o5v4ol", "ow3der", "ow3el", "ow5est", "ow1i", "own5i", "o4wo", "oy1a", "1pa", "pa4ca", "pa4ce", "pac4t", "p4ad", "5pagan", "p3agat", "p4ai", "pain4", "p4al", "pan4a", "pan3el", "pan4ty", "pa3ny", "pa1p", "pa4pu", "para5bl", "par5age", "par5di", "3pare", "par5el", "p4a4ri", "par4is", "pa2te", "pa5ter", "5pathic", "pa5thy", "pa4tric", "pav4", "3pay", "4p1b", "pd4", "4pe.", "3pe4a", "pear4l", "pe2c", "2p2ed", "3pede", "3pedi", "pedia4", "ped4ic", "p4ee", "pee4d", "pek4", "pe4la", "peli4e", "pe4nan", "p4enc", "pen4th", "pe5on", "p4era.", "pera5bl", "p4erag", "p4eri", "peri5st", "per4mal", "perme5", "p4ern", "per3o", "per3ti", "pe5ru", "per1v", "pe2t", "pe5ten", "pe5tiz", "4pf", "4pg", "4ph.", "phar5i", "phe3no", "ph4er", "ph4es.", "ph1ic", "5phie", "ph5ing", "5phisti", "3phiz", "ph2l", "3phob", "3phone", "5phoni", "pho4r", "4phs", "ph3t", "5phu", "1phy", "pi3a", "pian4", "pi4cie", "pi4cy", "p4id", "p5ida", "pi3de", "5pidi", "3piec", "pi3en", "pi4grap", "pi3lo", "pi2n", "p4in.", "pind4", "p4ino", "3pi1o", "pion4", "p3ith", "pi5tha", "pi2tu", "2p3k2", "1p2l2", "3plan", "plas5t", "pli3a", "pli5er", "4plig", "pli4n", "ploi4", "plu4m", "plum4b", "4p1m", "2p3n", "po4c", "5pod.", "po5em", "po3et5", "5po4g", "poin2", "5point", "poly5t", "po4ni", "po4p", "1p4or", "po4ry", "1pos", "pos1s", "p4ot", "po4ta", "5poun", "4p1p", "ppa5ra", "p2pe", "p4ped", "p5pel", "p3pen", "p3per", "p3pet", "ppo5site", "pr2", "pray4e", "5preci", "pre5co", "pre3em", "pref5ac", "pre4la", "pre3r", "p3rese", "3press", "pre5ten", "pre3v", "5pri4e", "prin4t3", "pri4s", "pris3o", "p3roca", "prof5it", "pro3l", "pros3e", "pro1t", "2p1s2", "p2se", "ps4h", "p4sib", "2p1t", "pt5a4b", "p2te", "p2th", "pti3m", "ptu4r", "p4tw", "pub3", "pue4", "puf4", "pul3c", "pu4m", "pu2n", "pur4r", "5pus", "pu2t", "5pute", "put3er", "pu3tr", "put4ted", "put4tin", "p3w", "qu2", "qua5v", "2que.", "3quer", "3quet", "2rab", "ra3bi", "rach4e", "r5acl", "raf5fi", "raf4t", "r2ai", "ra4lo", "ram3et", "r2ami", "rane5o", "ran4ge", "r4ani", "ra5no", "rap3er", "3raphy", "rar5c", "rare4", "rar5ef", "4raril", "r2as", "ration4", "rau4t", "ra5vai", "rav3el", "ra5zie", "r1b", "r4bab", "r4bag", "rbi2", "rbi4f", "r2bin", "r5bine", "rb5ing.", "rb4o", "r1c", "r2ce", "rcen4", "r3cha", "rch4er", "r4ci4b", "rc4it", "rcum3", "r4dal", "rd2i", "rdi4a", "rdi4er", "rdin4", "rd3ing", "2re.", "re1al", "re3an", "re5arr", "5reav", "re4aw", "r5ebrat", "rec5oll", "rec5ompe", "re4cre", "2r2ed", "re1de", "re3dis", "red5it", "re4fac", "re2fe", "re5fer.", "re3fi", "re4fy", "reg3is", "re5it", "re1li", "re5lu", "r4en4ta", "ren4te", "re1o", "re5pin", "re4posi", "re1pu", "r1er4", "r4eri", "rero4", "re5ru", "r4es.", "re4spi", "ress5ib", "res2t", "re5stal", "re3str", "re4ter", "re4ti4z", "re3tri", "reu2", "re5uti", "rev2", "re4val", "rev3el", "r5ev5er.", "re5vers", "re5vert", "re5vil", "rev5olu", "re4wh", "r1f", "rfu4", "r4fy", "rg2", "rg3er", "r3get", "r3gic", "rgi4n", "rg3ing", "r5gis", "r5git", "r1gl", "rgo4n", "r3gu", "rh4", "4rh.", "4rhal", "ri3a", "ria4b", "ri4ag", "r4ib", "rib3a", "ric5as", "r4ice", "4rici", "5ricid", "ri4cie", "r4ico", "rid5er", "ri3enc", "ri3ent", "ri1er", "ri5et", "rig5an", "5rigi", "ril3iz", "5riman", "rim5i", "3rimo", "rim4pe", "r2ina", "5rina.", "rin4d", "rin4e", "rin4g", "ri1o", "5riph", "riph5e", "ri2pl", "rip5lic", "r4iq", "r2is", "r4is.", "ris4c", "r3ish", "ris4p", "ri3ta3b", "r5ited.", "rit5er.", "rit5ers", "rit3ic", "ri2tu", "rit5ur", "riv5el", "riv3et", "riv3i", "r3j", "r3ket", "rk4le", "rk4lin", "r1l", "rle4", "r2led", "r4lig", "r4lis", "rl5ish", "r3lo4", "r1m", "rma5c", "r2me", "r3men", "rm5ers", "rm3ing", "r4ming.", "r4mio", "r3mit", "r4my", "r4nar", "r3nel", "r4ner", "r5net", "r3ney", "r5nic", "r1nis4", "r3nit", "r3niv", "rno4", "r4nou", "r3nu", "rob3l", "r2oc", "ro3cr", "ro4e", "ro1fe", "ro5fil", "rok2", "ro5ker", "5role.", "rom5ete", "rom4i", "rom4p", "ron4al", "ron4e", "ro5n4is", "ron4ta", "1room", "5root", "ro3pel", "rop3ic", "ror3i", "ro5ro", "ros5per", "ros4s", "ro4the", "ro4ty", "ro4va", "rov5el", "rox5", "r1p", "r4pea", "r5pent", "rp5er.", "r3pet", "rp4h4", "rp3ing", "r3po", "r1r4", "rre4c", "rre4f", "r4reo", "rre4st", "rri4o", "rri4v", "rron4", "rros4", "rrys4", "4rs2", "r1sa", "rsa5ti", "rs4c", "r2se", "r3sec", "rse4cr", "rs5er.", "rs3es", "rse5v2", "r1sh", "r5sha", "r1si", "r4si4b", "rson3", "r1sp", "r5sw", "rtach4", "r4tag", "r3teb", "rten4d", "rte5o", "r1ti", "rt5ib", "rti4d", "r4tier", "r3tig", "rtil3i", "rtil4l", "r4tily", "r4tist", "r4tiv", "r3tri", "rtroph4", "rt4sh", "ru3a", "ru3e4l", "ru3en", "ru4gl", "ru3in", "rum3pl", "ru2n", "runk5", "run4ty", "r5usc", "ruti5n", "rv4e", "rvel4i", "r3ven", "rv5er.", "r5vest", "r3vey", "r3vic", "rvi4v", "r3vo", "r1w", "ry4c", "5rynge", "ry3t", "sa2", "2s1ab", "5sack", "sac3ri", "s3act", "5sai", "salar4", "sal4m", "sa5lo", "sal4t", "3sanc", "san4de", "s1ap", "sa5ta", "5sa3tio", "sat3u", "sau4", "sa5vor", "5saw", "4s5b", "scan4t5", "sca4p", "scav5", "s4ced", "4scei", "s4ces", "sch2", "s4cho", "3s4cie", "5scin4d", "scle5", "s4cli", "scof4", "4scopy", "scour5a", "s1cu", "4s5d", "4se.", "se4a", "seas4", "sea5w", "se2c3o", "3sect", "4s4ed", "se4d4e", "s5edl", "se2g", "seg3r", "5sei", "se1le", "5self", "5selv", "4seme", "se4mol", "sen5at", "4senc", "sen4d", "s5ened", "sen5g", "s5enin", "4sentd", "4sentl", "sep3a3", "4s1er.", "s4erl", "ser4o", "4servo", "s1e4s", "se5sh", "ses5t", "5se5um", "5sev", "sev3en", "sew4i", "5sex", "4s3f", "2s3g", "s2h", "2sh.", "sh1er", "5shev", "sh1in", "sh3io", "3ship", "shiv5", "sho4", "sh5old", "shon3", "shor4", "short5", "4shw", "si1b", "s5icc", "3side.", "5sides", "5sidi", "si5diz", "4signa", "sil4e", "4sily", "2s1in", "s2ina", "5sine.", "s3ing", "1sio", "5sion", "sion5a", "si2r", "sir5a", "1sis", "3sitio", "5siu", "1siv", "5siz", "sk2", "4ske", "s3ket", "sk5ine", "sk5ing", "s1l2", "s3lat", "s2le", "slith5", "2s1m", "s3ma", "small3", "sman3", "smel4", "s5men", "5smith", "smol5d4", "s1n4", "1so", "so4ce", "soft3", "so4lab", "sol3d2", "so3lic", "5solv", "3som", "3s4on.", "sona4", "son4g", "s4op", "5sophic", "s5ophiz", "s5ophy", "sor5c", "sor5d", "4sov", "so5vi", "2spa", "5spai", "spa4n", "spen4d", "2s5peo", "2sper", "s2phe", "3spher", "spho5", "spil4", "sp5ing", "4spio", "s4ply", "s4pon", "spor4", "4spot", "squal4l", "s1r", "2ss", "s1sa", "ssas3", "s2s5c", "s3sel", "s5seng", "s4ses.", "s5set", "s1si", "s4sie", "ssi4er", "ss5ily", "s4sl", "ss4li", "s4sn", "sspend4", "ss2t", "ssur5a", "ss5w", "2st.", "s2tag", "s2tal", "stam4i", "5stand", "s4ta4p", "5stat.", "s4ted", "stern5i", "s5tero", "ste2w", "stew5a", "s3the", "st2i", "s4ti.", "s5tia", "s1tic", "5stick", "s4tie", "s3tif", "st3ing", "5stir", "s1tle", "5stock", "stom3a", "5stone", "s4top", "3store", "st4r", "s4trad", "5stratu", "s4tray", "s4trid", "4stry", "4st3w", "s2ty", "1su", "su1al", "su4b3", "su2g3", "su5is", "suit3", "s4ul", "su2m", "sum3i", "su2n", "su2r", "4sv", "sw2", "4swo", "s4y", "4syc", "3syl", "syn5o", "sy5rin", "1ta", "3ta.", "2tab", "ta5bles", "5taboliz", "4taci", "ta5do", "4taf4", "tai5lo", "ta2l", "ta5la", "tal5en", "tal3i", "4talk", "tal4lis", "ta5log", "ta5mo", "tan4de", "tanta3", "ta5per", "ta5pl", "tar4a", "4tarc", "4tare", "ta3riz", "tas4e", "ta5sy", "4tatic", "ta4tur", "taun4", "tav4", "2taw", "tax4is", "2t1b", "4tc", "t4ch", "tch5et", "4t1d", "4te.", "tead4i", "4teat", "tece4", "5tect", "2t1ed", "te5di", "1tee", "teg4", "te5ger", "te5gi", "3tel.", "teli4", "5tels", "te2ma2", "tem3at", "3tenan", "3tenc", "3tend", "4tenes", "1tent", "ten4tag", "1teo", "te4p", "te5pe", "ter3c", "5ter3d", "1teri", "ter5ies", "ter3is", "teri5za", "5ternit", "ter5v", "4tes.", "4tess", "t3ess.", "teth5e", "3teu", "3tex", "4tey", "2t1f", "4t1g", "2th.", "than4", "th2e", "4thea", "th3eas", "the5at", "the3is", "3thet", "th5ic.", "th5ica", "4thil", "5think", "4thl", "th5ode", "5thodic", "4thoo", "thor5it", "tho5riz", "2ths", "1tia", "ti4ab", "ti4ato", "2ti2b", "4tick", "t4ico", "t4ic1u", "5tidi", "3tien", "tif2", "ti5fy", "2tig", "5tigu", "till5in", "1tim", "4timp", "tim5ul", "2t1in", "t2ina", "3tine.", "3tini", "1tio", "ti5oc", "tion5ee", "5tiq", "ti3sa", "3tise", "tis4m", "ti5so", "tis4p", "5tistica", "ti3tl", "ti4u", "1tiv", "tiv4a", "1tiz", "ti3za", "ti3zen", "2tl", "t5la", "tlan4", "3tle.", "3tled", "3tles.", "t5let.", "t5lo", "4t1m", "tme4", "2t1n2", "1to", "to3b", "to5crat", "4todo", "2tof", "to2gr", "to5ic", "to2ma", "tom4b", "to3my", "ton4ali", "to3nat", "4tono", "4tony", "to2ra", "to3rie", "tor5iz", "tos2", "5tour", "4tout", "to3war", "4t1p", "1tra", "tra3b", "tra5ch", "traci4", "trac4it", "trac4te", "tras4", "tra5ven", "trav5es5", "tre5f", "tre4m", "trem5i", "5tria", "tri5ces", "5tricia", "4trics", "2trim", "tri4v", "tro5mi", "tron5i", "4trony", "tro5phe", "tro3sp", "tro3v", "tru5i", "trus4", "4t1s2", "t4sc", "tsh4", "t4sw", "4t3t2", "t4tes", "t5to", "ttu4", "1tu", "tu1a", "tu3ar", "tu4bi", "tud2", "4tue", "4tuf4", "5tu3i", "3tum", "tu4nis", "2t3up.", "3ture", "5turi", "tur3is", "tur5o", "tu5ry", "3tus", "4tv", "tw4", "4t1wa", "twis4", "4two", "1ty", "4tya", "2tyl", "type3", "ty5ph", "4tz", "tz4e", "4uab", "uac4", "ua5na", "uan4i", "uar5ant", "uar2d", "uar3i", "uar3t", "u1at", "uav4", "ub4e", "u4bel", "u3ber", "u4bero", "u1b4i", "u4b5ing", "u3ble.", "u3ca", "uci4b", "uc4it", "ucle3", "u3cr", "u3cu", "u4cy", "ud5d", "ud3er", "ud5est", "udev4", "u1dic", "ud3ied", "ud3ies", "ud5is", "u5dit", "u4don", "ud4si", "u4du", "u4ene", "uens4", "uen4te", "uer4il", "3ufa", "u3fl", "ugh3en", "ug5in", "2ui2", "uil5iz", "ui4n", "u1ing", "uir4m", "uita4", "uiv3", "uiv4er.", "u5j", "4uk", "u1la", "ula5b", "u5lati", "ulch4", "5ulche", "ul3der", "ul4e", "u1len", "ul4gi", "ul2i", "u5lia", "ul3ing", "ul5ish", "ul4lar", "ul4li4b", "ul4lis", "4ul3m", "u1l4o", "4uls", "uls5es", "ul1ti", "ultra3", "4ultu", "u3lu", "ul5ul", "ul5v", "um5ab", "um4bi", "um4bly", "u1mi", "u4m3ing", "umor5o", "um2p", "unat4", "u2ne", "un4er", "u1ni", "un4im", "u2nin", "un5ish", "uni3v", "un3s4", "un4sw", "unt3ab", "un4ter.", "un4tes", "unu4", "un5y", "un5z", "u4ors", "u5os", "u1ou", "u1pe", "uper5s", "u5pia", "up3ing", "u3pl", "up3p", "upport5", "upt5ib", "uptu4", "u1ra", "4ura.", "u4rag", "u4ras", "ur4be", "urc4", "ur1d", "ure5at", "ur4fer", "ur4fr", "u3rif", "uri4fic", "ur1in", "u3rio", "u1rit", "ur3iz", "ur2l", "url5ing.", "ur4no", "uros4", "ur4pe", "ur4pi", "urs5er", "ur5tes", "ur3the", "urti4", "ur4tie", "u3ru", "2us", "u5sad", "u5san", "us4ap", "usc2", "us3ci", "use5a", "u5sia", "u3sic", "us4lin", "us1p", "us5sl", "us5tere", "us1tr", "u2su", "usur4", "uta4b", "u3tat", "4ute.", "4utel", "4uten", "uten4i", "4u1t2i", "uti5liz", "u3tine", "ut3ing", "ution5a", "u4tis", "5u5tiz", "u4t1l", "ut5of", "uto5g", "uto5matic", "u5ton", "u4tou", "uts4", "u3u", "uu4m", "u1v2", "uxu3", "uz4e", "1va", "5va.", "2v1a4b", "vac5il", "vac3u", "vag4", "va4ge", "va5lie", "val5o", "val1u", "va5mo", "va5niz", "va5pi", "var5ied", "3vat", "4ve.", "4ved", "veg3", "v3el.", "vel3li", "ve4lo", "v4ely", "ven3om", "v5enue", "v4erd", "5vere.", "v4erel", "v3eren", "ver5enc", "v4eres", "ver3ie", "vermi4n", "3verse", "ver3th", "v4e2s", "4ves.", "ves4te", "ve4te", "vet3er", "ve4ty", "vi5ali", "5vian", "5vide.", "5vided", "4v3iden", "5vides", "5vidi", "v3if", "vi5gn", "vik4", "2vil", "5vilit", "v3i3liz", "v1in", "4vi4na", "v2inc", "vin5d", "4ving", "vio3l", "v3io4r", "vi1ou", "vi4p", "vi5ro", "vis3it", "vi3so", "vi3su", "4viti", "vit3r", "4vity", "3viv", "5vo.", "voi4", "3vok", "vo4la", "v5ole", "5volt", "3volv", "vom5i", "vor5ab", "vori4", "vo4ry", "vo4ta", "4votee", "4vv4", "v4y", "w5abl", "2wac", "wa5ger", "wag5o", "wait5", "w5al.", "wam4", "war4t", "was4t", "wa1te", "wa5ver", "w1b", "wea5rie", "weath3", "wed4n", "weet3", "wee5v", "wel4l", "w1er", "west3", "w3ev", "whi4", "wi2", "wil2", "will5in", "win4de", "win4g", "wir4", "3wise", "with3", "wiz5", "w4k", "wl4es", "wl3in", "w4no", "1wo2", "wom1", "wo5ven", "w5p", "wra4", "wri4", "writa4", "w3sh", "ws4l", "ws4pe", "w5s4t", "4wt", "wy4", "x1a", "xac5e", "x4ago", "xam3", "x4ap", "xas5", "x3c2", "x1e", "xe4cuto", "x2ed", "xer4i", "xe5ro", "x1h", "xhi2", "xhil5", "xhu4", "x3i", "xi5a", "xi5c", "xi5di", "x4ime", "xi5miz", "x3o", "x4ob", "x3p", "xpan4d", "xpecto5", "xpe3d", "x1t2", "x3ti", "x1u", "xu3a", "xx4", "y5ac", "3yar4", "y5at", "y1b", "y1c", "y2ce", "yc5er", "y3ch", "ych4e", "ycom4", "ycot4", "y1d", "y5ee", "y1er", "y4erf", "yes4", "ye4t", "y5gi", "4y3h", "y1i", "y3la", "ylla5bl", "y3lo", "y5lu", "ymbol5", "yme4", "ympa3", "yn3chr", "yn5d", "yn5g", "yn5ic", "5ynx", "y1o4", "yo5d", "y4o5g", "yom4", "yo5net", "y4ons", "y4os", "y4ped", "yper5", "yp3i", "y3po", "y4poc", "yp2ta", "y5pu", "yra5m", "yr5ia", "y3ro", "yr4r", "ys4c", "y3s2e", "ys3ica", "ys3io", "3ysis", "y4so", "yss4", "ys1t", "ys3ta", "ysur4", "y3thin", "yt3ic", "y1w", "za1", "z5a2b", "zar2", "4zb", "2ze", "ze4n", "ze4p", "z1er", "ze3ro", "zet4", "2z1i", "z4il", "z4is", "5zl", "4zm", "1zo", "zo4m", "zo5ol", "zte4", "4z1z2", "z4zy", ".con5gr", ".de5riva", ".dri5v4", ".eth1y6l1", ".eu4ler", ".ev2", ".ever5si5b", ".ga4s1om1", ".ge4ome", ".ge5ot1", ".he3mo1", ".he3p6a", ".he3roe", ".in5u2t", ".kil2n3i", ".ko6r1te1", ".le6ices", ".me4ga1l", ".met4ala", ".mim5i2c1", ".mi1s4ers", ".ne6o3f", ".noe1th", ".non1e2m", ".poly1s", ".post1am", ".pre1am", ".rav5en1o", ".semi5", ".sem4ic", ".semid6", ".semip4", ".semir4", ".sem6is4", ".semiv4", ".sph6in1", ".spin1o", ".ta5pes1tr", ".te3legr", ".to6pog", ".to2q", ".un3at5t", ".un5err5", ".vi2c3ar", ".we2b1l", ".re1e4c", "a5bolic", "a2cabl", "af6fish", "am1en3ta5b", "anal6ys", "ano5a2c", "ans5gr", "ans3v", "anti1d", "an3ti1n2", "anti1re", "a4pe5able", "ar3che5t", "ar2range", "as5ymptot", "ath3er1o1s", "at6tes.", "augh4tl", "au5li5f", "av3iou", "back2er.", "ba6r1onie", "ba1thy", "bbi4t", "be2vie", "bi5d2if", "bil2lab", "bio5m", "bi1orb", "bio1rh", "b1i3tive", "blan2d1", "blin2d1", "blon2d2", "bor1no5", "bo2t1u1l", "brus4q", "bus6i2er", "bus6i2es", "buss4ing", "but2ed.", "but4ted", "cad5e1m", "cat1a1s2", "4chs.", "chs3hu", "chie5vo", "cig3a3r", "cin2q", "cle4ar", "co6ph1o3n", "cous2ti", "cri3tie", "croc1o1d", "cro5e2co", "c2tro3me6c", "1cu2r1ance", "2d3alone", "data1b", "dd5a5b", "d2d5ib", "de4als.", "de5clar1", "de2c5lina", "de3fin3iti", "de2mos", "des3ic", "de2tic", "dic1aid", "dif5fra", "3di1methy", "di2ren", "di2rer", "2d1lead", "2d1li2e", "3do5word", "dren1a5l", "drif2t1a", "d1ri3pleg5", "drom3e5d", "d3tab", "du2al.", "du1op1o1l", "ea4n3ies", "e3chas", "edg1l", "ed1uling", "eli2t1is", "e1loa", "en1dix", "eo3grap", "1e6p3i3neph1", "e2r3i4an.", "e3spac6i", "eth1y6l1ene", "5eu2clid1", "feb1rua", "fermi1o", "3fich", "fit5ted.", "fla1g6el", "flow2er.", "3fluor", "gen2cy.", "ge3o1d", "ght1we", "g1lead", "get2ic.", "4g1lish", "5glo5bin", "1g2nac", "gnet1ism", "gno5mo", "g2n1or.", "g2noresp", "2g1o4n3i1za", "graph5er.", "griev1", "g1utan", "hair1s", "ha2p3ar5r", "hatch1", "hex2a3", "hite3sid", "h3i5pel1a4", "hnau3z", "ho6r1ic.", "h2t1eou", "hypo1tha", "id4ios", "ifac1et", "ign4it", "ignit1er", "i4jk", "im3ped3a", "infra1s2", "i5nitely.", "irre6v3oc", "i1tesima", "ith5i2l", "itin5er5ar", "janu3a", "japan1e2s", "je1re1m", "1ke6ling", "1ki5netic", "1kovian", "k3sha", "la4c3i5e", "lai6n3ess", "lar5ce1n", "l3chai", "l3chil6d1", "lead6er.", "lea4s1a", "1lec3ta6b", "le3g6en2dre", "1le1noid", "lith1o5g", "ll1fl", "l2l3ish", "l5mo3nell", "lo1bot1o1", "lo2ges.", "load4ed.", "load6er.", "l3tea", "lth5i2ly", "lue1p", "1lunk3er", "1lum5bia.", "3lyg1a1mi", "ly5styr", "ma1la1p", "m2an.", "man3u1sc", "mar1gin1", "medi2c", "med3i3cin", "medio6c1", "me3gran3", "m2en.", "3mi3da5b", "3milita", "mil2l1ag", "mil5li5li", "mi6n3is.", "mi1n2ut1er", "mi1n2ut1est", "m3ma1b", "5maph1ro1", "5moc1ra1t", "mo5e2las", "mol1e5c", "mon4ey1l", "mono3ch", "mo4no1en", "moro6n5is", "mono1s6", "moth4et2", "m1ou3sin", "m5shack2", "mu2dro", "mul2ti5u", "n3ar4chs.", "n3ch2es1t", "ne3back", "2ne1ski", "n1dieck", "nd3thr", "nfi6n3ites", "4n5i4an.", "nge5nes", "ng1ho", "ng1spr", "nk3rup", "n5less", "5noc3er1os", "nom1a6l", "nom5e1no", "n1o1mist", "non1eq", "non1i4so", "5nop1oly.", "no1vemb", "ns5ceiv", "ns4moo", "ntre1p", "obli2g1", "o3chas", "odel3li", "odit1ic", "oerst2", "oke1st", "o3les3ter", "oli3gop1o1", "o1lo3n4om", "o3mecha6", "onom1ic", "o3norma", "o3no2t1o3n", "o3nou", "op1ism.", "or4tho3ni4t", "orth1ri", "or5tively", "o4s3pher", "o5test1er", "o5tes3tor", "oth3e1o1s", "ou3ba3do", "o6v3i4an.", "oxi6d1ic", "pal6mat", "parag6ra4", "par4a1le", "param4", "para3me", "pee2v1", "phi2l3ant", "phi5lat1e3l", "pi2c1a3d", "pli2c1ab", "pli5nar", "poin3ca", "1pole.", "poly1e", "po3lyph1ono", "1prema3c", "pre1neu", "pres2pli", "pro2cess", "proc3i3ty.", "pro2g1e", "3pseu2d", "pseu3d6o3d2", "pseu3d6o3f2", "pto3mat4", "p5trol3", "pu5bes5c", "quain2t1e", "qu6a3si3", "quasir6", "quasis6", "quin5tes5s", "qui3v4ar", "r1abolic", "3rab1o1loi", "ra3chu", "r3a3dig", "radi1o6g", "r2amen", "3ra4m5e1triz", "ra3mou", "ra5n2has", "ra1or", "r3bin1ge", "re2c3i1pr", "rec5t6ang", "re4t1ribu", "r3ial.", "riv1o1l", "6rk.", "rk1ho", "r1krau", "6rks.", "r5le5qu", "ro1bot1", "ro5e2las", "ro5epide1", "ro3mesh", "ro1tron", "r3pau5li", "rse1rad1i", "r1thou", "r1treu", "r1veil", "rz1sc", "sales3c", "sales5w", "5sa3par5il", "sca6p1er", "sca2t1ol", "s4chitz", "schro1ding1", "1sci2utt", "scrap4er.", "scy4th1", "sem1a1ph", "se3mes1t", "se1mi6t5ic", "sep3temb", "shoe1st", "sid2ed.", "side5st", "side5sw", "si5resid", "sky1sc", "3slova1kia", "3s2og1a1my", "so2lute", "3s2pace", "1s2pacin", "spe3cio", "spher1o", "spi2c1il", "spokes5w", "sports3c", "sports3w", "s3qui3to", "s2s1a3chu1", "ss3hat", "s2s3i4an.", "s5sign5a3b", "1s2tamp", "s2t1ant5shi", "star3tli", "sta1ti", "st5b", "1stor1ab", "strat1a1g", "strib5ut", "st5scr", "stu1pi4d1", "styl1is", "su2per1e6", "1sync", "1syth3i2", "swimm6", "5tab1o1lism", "ta3gon.", "talk1a5", "t1a1min", "t6ap6ath", "5tar2rh", "tch1c", "tch3i1er", "t1cr", "teach4er.", "tele2g", "tele1r6o", "3ter1gei", "ter2ic.", "t3ess2es", "tha4l1am", "tho3don", "th1o5gen1i", "tho1k2er", "thy4l1an", "thy3sc", "2t3i4an.", "ti2n3o1m", "t1li2er", "tolo2gy", "tot3ic", "trai3tor1", "tra1vers", "travers3a3b", "treach1e", "tr4ial.", "3tro1le1um", "trof4ic.", "tro3fit", "tro1p2is", "3trop1o5les", "3trop1o5lis", "t1ro1pol3it", "tsch3ie", "ttrib1ut1", "turn3ar", "t1wh", "ty2p5al", "ua3drati", "uad1ratu", "u5do3ny", "uea1m", "u2r1al.", "uri4al.", "us2er.", "v1ativ", "v1oir5du1", "va6guer", "vaude3v", "1verely.", "v1er1eig", "ves1tite", "vi1vip3a3r", "voice1p", "waste3w6a2", "wave1g4", "w3c", "week1n", "wide5sp", "wo4k1en", "wrap3aro", "writ6er.", "x1q", "xquis3", "y5che3d", "ym5e5try", "y1stro", "yes5ter1y", "z3ian.", "z3o1phr", "z2z3w"],
  exceptions: ["as-so-ciate", "as-so-ciates", "dec-li-na-tion", "oblig-a-tory", "phil-an-thropic", "present", "presents", "project", "projects", "reci-procity", "re-cog-ni-zance", "ref-or-ma-tion", "ret-ri-bu-tion", "ta-ble"]
}, iq = rq, aq = iq;
Object.defineProperty(L1, "__esModule", { value: !0 });
function oq(e) {
  return typeof e == "object" && "default" in e ? e.default : e;
}
var sq = oq(aq);
class lq {
  constructor() {
    this.tree = {};
  }
  insert(t, n) {
    let r = this.tree;
    for (const i of t)
      r[i] || (r[i] = {}), r = r[i];
    r[null] = n;
  }
  *getPoints(t) {
    let n = this.tree;
    for (let r of t)
      if (n = n[r], n)
        n[null] && (yield n[null]);
      else
        break;
  }
}
const yp = {
  joiner: "­",
  borderMarker: ".",
  minWordLength: 4
}, cq = (e) => ({
  chars: e.replace(/[0-9]/g, ""),
  points: e.split(/[\0- '\x2D\.A-Za-z\x7F-\xA0\xAA\xAD\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u037D\u037F-\u0383\u0386\u0388-\u03F5\u03F7-\u0481\u0483-\u0559\u0560-\u0588\u058B\u058C\u0590-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7-\u05F2\u05F5-\u0605\u0610-\u061A\u061C\u061D\u0620-\u065F\u066E-\u06D3\u06D5-\u06DD\u06DF-\u06E8\u06EA-\u06EF\u06FA-\u06FC\u06FF\u070E-\u07BF\u07CA-\u07F5\u07FA-\u07FD\u0800-\u082F\u083F-\u085D\u085F-\u0963\u0971-\u09E5\u09F0\u09F1\u09FC\u09FE-\u0A65\u0A70-\u0A75\u0A77-\u0AE5\u0AF2-\u0B65\u0B71\u0B78-\u0BE5\u0BFB-\u0C65\u0C70-\u0C76\u0C80-\u0C83\u0C85-\u0CE5\u0CF0-\u0D4E\u0D50-\u0D57\u0D5F-\u0D65\u0D7A-\u0DE5\u0DF0-\u0DF3\u0DF5-\u0E3E\u0E40-\u0E4E\u0E5C-\u0ECF\u0EDA-\u0F00\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E-\u0F84\u0F86-\u0FBD\u0FC6\u0FCD\u0FDB-\u103F\u1050-\u108F\u109A-\u109D\u10A0-\u10FA\u10FC-\u135F\u137D-\u138F\u139A-\u13FF\u1401-\u166C\u166F-\u169A\u169D-\u16EA\u16F1-\u1734\u1737-\u17D3\u17D7\u17DC-\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180B-\u180F\u181A-\u193F\u1941-\u1943\u1950-\u19CF\u19DB-\u19DD\u1A00-\u1A1D\u1A20-\u1A7F\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AA7\u1AAE-\u1B4F\u1B6B-\u1B73\u1B7D-\u1BAF\u1BBA-\u1BFB\u1C00-\u1C3A\u1C4A-\u1C4F\u1C5A-\u1C7D\u1C80-\u1CBF\u1CC8-\u1CD2\u1CD4-\u1FBC\u1FBE\u1FBF\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF-\u200F\u2028-\u202F\u205F-\u206F\u2071-\u2073\u207F\u208F-\u209F\u20C0-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2C00-\u2CE4\u2CEB-\u2CF8\u2D00-\u2D6F\u2D71-\u2DFF\u2E2F\u2E50-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u3000\u3005\u3006\u302A-\u302F\u3031-\u3035\u303B\u303C\u3040-\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u318F\u31A0-\u31BF\u31E4-\u31FF\u321F\u32FF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A-\uA672\uA674-\uA67D\uA67F-\uA6E5\uA6F0\uA6F1\uA6F8-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA82F\uA83A-\uA873\uA878-\uA8CD\uA8DA-\uA8F7\uA8FB\uA8FD-\uA8FF\uA90A-\uA92D\uA930-\uA95E\uA960-\uA9C0\uA9CE\uA9CF\uA9DA-\uA9DD\uA9E0-\uA9EF\uA9FA-\uAA4F\uAA5A\uAA5B\uAA60-\uAA76\uAA7A-\uAADD\uAAE0-\uAAEF\uAAF2-\uAB5A\uAB5C-\uABEA\uABEC-\uABEF\uABFA-\uFB28\uFB2A-\uFBB1\uFBC2-\uFD3D\uFD40-\uFDFB\uFDFE-\uFE0F\uFE1A-\uFE2F\uFE53\uFE67\uFE6C-\uFF00\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE-\u{100FF}\u{10103}-\u{10106}\u{10134}-\u{10136}\u{1018F}\u{1019C}-\u{1019F}\u{101A1}-\u{101CF}\u{101FD}-\u{102E0}\u{102FC}-\u{1031F}\u{10324}-\u{10340}\u{10342}-\u{10349}\u{1034B}-\u{1039E}\u{103A0}-\u{103CF}\u{103D6}-\u{1049F}\u{104AA}-\u{1056E}\u{10570}-\u{10856}\u{10860}-\u{10876}\u{10880}-\u{108A6}\u{108B0}-\u{108FA}\u{10900}-\u{10915}\u{1091C}-\u{1091E}\u{10920}-\u{1093E}\u{10940}-\u{109BB}\u{109BE}\u{109BF}\u{109D0}\u{109D1}\u{10A00}-\u{10A3F}\u{10A49}-\u{10A4F}\u{10A59}-\u{10A7C}\u{10A80}-\u{10A9C}\u{10AA0}-\u{10AC7}\u{10AC9}-\u{10AEA}\u{10AF7}-\u{10B38}\u{10B40}-\u{10B57}\u{10B60}-\u{10B77}\u{10B80}-\u{10B98}\u{10B9D}-\u{10BA8}\u{10BB0}-\u{10CF9}\u{10D00}-\u{10D2F}\u{10D3A}-\u{10E5F}\u{10E7F}-\u{10F1C}\u{10F27}-\u{10F50}\u{10F5A}-\u{11046}\u{1104E}-\u{11051}\u{11070}-\u{110BA}\u{110BD}\u{110C2}-\u{110EF}\u{110FA}-\u{11135}\u{11144}-\u{11173}\u{11176}-\u{111C4}\u{111C9}-\u{111CC}\u{111CE}\u{111CF}\u{111DA}\u{111DC}\u{111E0}\u{111F5}-\u{11237}\u{1123E}-\u{112A8}\u{112AA}-\u{112EF}\u{112FA}-\u{1144A}\u{1145A}\u{1145C}\u{1145E}-\u{114C5}\u{114C7}-\u{114CF}\u{114DA}-\u{115C0}\u{115D8}-\u{11640}\u{11644}-\u{1164F}\u{1165A}-\u{1165F}\u{1166D}-\u{116BF}\u{116CA}-\u{1172F}\u{11740}-\u{1183A}\u{1183C}-\u{118DF}\u{118F3}-\u{119E1}\u{119E3}-\u{11A3E}\u{11A47}-\u{11A99}\u{11A9D}\u{11AA3}-\u{11C40}\u{11C46}-\u{11C4F}\u{11C6D}-\u{11C6F}\u{11C72}-\u{11D4F}\u{11D5A}-\u{11D9F}\u{11DAA}-\u{11EF6}\u{11EF9}-\u{11FBF}\u{11FF2}-\u{11FFE}\u{12000}-\u{123FF}\u{1246F}\u{12475}-\u{16A5F}\u{16A6A}-\u{16A6D}\u{16A70}-\u{16AF4}\u{16AF6}-\u{16B36}\u{16B40}-\u{16B43}\u{16B46}-\u{16B4F}\u{16B5A}\u{16B62}-\u{16E7F}\u{16E9B}-\u{16FE1}\u{16FE3}-\u{1BC9B}\u{1BC9D}\u{1BC9E}\u{1BCA0}-\u{1CFFF}\u{1D0F6}-\u{1D0FF}\u{1D127}\u{1D128}\u{1D165}-\u{1D169}\u{1D16D}-\u{1D182}\u{1D185}-\u{1D18B}\u{1D1AA}-\u{1D1AD}\u{1D1E9}-\u{1D1FF}\u{1D242}-\u{1D244}\u{1D246}-\u{1D2DF}\u{1D2F4}-\u{1D2FF}\u{1D357}-\u{1D35F}\u{1D379}-\u{1D6C0}\u{1D6C2}-\u{1D6DA}\u{1D6DC}-\u{1D6FA}\u{1D6FC}-\u{1D714}\u{1D716}-\u{1D734}\u{1D736}-\u{1D74E}\u{1D750}-\u{1D76E}\u{1D770}-\u{1D788}\u{1D78A}-\u{1D7A8}\u{1D7AA}-\u{1D7C2}\u{1D7C4}-\u{1D7CD}\u{1DA00}-\u{1DA36}\u{1DA3B}-\u{1DA6C}\u{1DA75}\u{1DA84}\u{1DA8C}-\u{1E13F}\u{1E14A}-\u{1E14E}\u{1E150}-\u{1E2EF}\u{1E2FA}-\u{1E2FE}\u{1E300}-\u{1E8C6}\u{1E8D0}-\u{1E94F}\u{1E95A}-\u{1E95D}\u{1E960}-\u{1EC70}\u{1ECB5}-\u{1ED00}\u{1ED3E}-\u{1EEEF}\u{1EEF2}-\u{1EFFF}\u{1F02C}-\u{1F02F}\u{1F094}-\u{1F09F}\u{1F0AF}\u{1F0B0}\u{1F0C0}\u{1F0D0}\u{1F0F6}-\u{1F0FF}\u{1F10D}-\u{1F10F}\u{1F16D}-\u{1F16F}\u{1F1AD}-\u{1F1E5}\u{1F203}-\u{1F20F}\u{1F23C}-\u{1F23F}\u{1F249}-\u{1F24F}\u{1F252}-\u{1F25F}\u{1F266}-\u{1F2FF}\u{1F6D6}-\u{1F6DF}\u{1F6ED}-\u{1F6EF}\u{1F6FB}-\u{1F6FF}\u{1F774}-\u{1F77F}\u{1F7D9}-\u{1F7DF}\u{1F7EC}-\u{1F7FF}\u{1F80C}-\u{1F80F}\u{1F848}-\u{1F84F}\u{1F85A}-\u{1F85F}\u{1F888}-\u{1F88F}\u{1F8AE}-\u{1F8FF}\u{1F90C}\u{1F972}\u{1F977}-\u{1F979}\u{1F9A3}\u{1F9A4}\u{1F9AB}-\u{1F9AD}\u{1F9CB}\u{1F9CC}\u{1FA54}-\u{1FA5F}\u{1FA6E}\u{1FA6F}\u{1FA74}-\u{1FA77}\u{1FA7B}-\u{1FA7F}\u{1FA83}-\u{1FA8F}\u{1FA96}-\u{10FFFF}]/u).map((t) => parseInt(t || 0))
}), uq = (e) => ({
  key: e.replace(/\-/g, ""),
  value: e.replace(/\-/g, yp.joiner)
}), ux = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\x85/u, dq = /(?!['@_])[\t-\r -#%-\*,-\/:;\?@\[-\]_\{\}\xA0\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u3000-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFEFF\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65\u{10100}-\u{10102}\u{1039F}\u{103D0}\u{1056F}\u{10857}\u{1091F}\u{1093F}\u{10A50}-\u{10A58}\u{10A7F}\u{10AF0}-\u{10AF6}\u{10B39}-\u{10B3F}\u{10B99}-\u{10B9C}\u{10F55}-\u{10F59}\u{11047}-\u{1104D}\u{110BB}\u{110BC}\u{110BE}-\u{110C1}\u{11140}-\u{11143}\u{11174}\u{11175}\u{111C5}-\u{111C8}\u{111CD}\u{111DB}\u{111DD}-\u{111DF}\u{11238}-\u{1123D}\u{112A9}\u{1144B}-\u{1144F}\u{1145B}\u{1145D}\u{114C6}\u{115C1}-\u{115D7}\u{11641}-\u{11643}\u{11660}-\u{1166C}\u{1173C}-\u{1173E}\u{1183B}\u{119E2}\u{11A3F}-\u{11A46}\u{11A9A}-\u{11A9C}\u{11A9E}-\u{11AA2}\u{11C41}-\u{11C45}\u{11C70}\u{11C71}\u{11EF7}\u{11EF8}\u{11FFF}\u{12470}-\u{12474}\u{16A6E}\u{16A6F}\u{16AF5}\u{16B37}-\u{16B3B}\u{16B44}\u{16E97}-\u{16E9A}\u{16FE2}\u{1BC9F}\u{1DA87}-\u{1DA8B}\u{1E95E}\u{1E95F}]/u, fq = (e) => {
  const t = [];
  let n = "", r = "";
  const i = () => {
    n.length > 0 && (t.push(n), n = "");
  }, a = () => {
    r.length > 0 && (t.push(r), r = "");
  };
  for (let o = 0; o < e.length; o++) {
    const s = e.charAt(o);
    ux.test(s) ? (i(), r += s) : (a(), n += s);
  }
  return i(), a(), t;
}, pq = (e) => {
  let t = null, n;
  const r = [], i = (o) => r.push(o), a = (o) => {
    if (t !== null) {
      const s = e.slice(t, o);
      t = null, r.push(s);
    }
  };
  for (n = 0; n < e.length; n++) {
    const o = e.charAt(n);
    dq.test(o) ? (a(n), i(o)) : t === null && (t = n);
  }
  return a(e.length), r;
}, hq = (e = "") => {
  const t = [], n = fq(e);
  if (n.length) {
    let r = ux.test(n[0]);
    for (const i of n) {
      if (r)
        t.push(i);
      else {
        const a = pq(i);
        t.push(...a);
      }
      r = !r;
    }
  }
  return t;
}, mq = (e) => e % 2 === 1, gq = (e, t = []) => {
  let n = "";
  for (let r = 0; r < e.length; r++)
    n += (mq(t[r]) ? yp.joiner : "") + e.charAt(r);
  return n;
}, {
  borderMarker: N0
} = yp, yq = (e, t) => {
  const n = N0 + e.toLocaleLowerCase() + N0, r = new Array(n.length + 1).fill(0);
  for (let a = 0; a < n.length; a++) {
    const o = n.slice(a);
    for (const s of t.getPoints(o))
      for (let l = 0; l < s.length; l++)
        r[a + l] = Math.max(r[a + l], s[l]);
  }
  const i = [0, 0, ...r.slice(3, r.length - 3), 0, 0];
  return gq(e, i);
}, vq = ({
  patterns: e = [],
  exceptions: t = []
}) => {
  const n = {}, r = new lq();
  for (const i of e) {
    const {
      chars: a,
      points: o
    } = cq(i);
    r.insert(a, o);
  }
  for (const i of t) {
    const {
      key: a,
      value: o
    } = uq(i);
    n[a] = o;
  }
  return (i) => hq(i).map((a) => {
    if (a.length > yp.minWordLength) {
      if (!n[a]) {
        const o = yq(a, r);
        n[a] = o;
      }
      return n[a];
    }
    return a;
  }).join("");
}, Kh = {}, bq = {
  get(e = sq) {
    return Kh[e.id] || (Kh[e.id] = vq(e)), Kh[e.id];
  }
}, wq = (e, {
  language: t
} = {}) => bq.get(t)(e);
L1.hyphenated = wq;
var xq = L1;
function _q(e) {
  return e && typeof e == "object" && "default" in e ? e.default : e;
}
var Xh = _q(gt), dx = xq;
function Nq(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Sq(e, t) {
  if (e == null) return {};
  var n = Nq(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var Eq = function e(t) {
  var n = t.children, r = t.language;
  Cq(n, r);
  var i = Xh.Children.count(n), a = function(o) {
    if (o === null)
      return null;
    if (o.type === e)
      return o;
    if (typeof o == "string")
      return dx.hyphenated(o, {
        language: r
      });
    var s = o.props, l = s.children, c = Sq(s, ["children"]);
    return l ? Xh.cloneElement(o, c, e({
      children: l,
      language: r
    })) : o;
  };
  return i === 1 ? a(n) : Xh.Children.map(n, a);
};
function Cq(e, t) {
  e && e.props && e.props.dangerouslySetInnerHTML && (e.props.dangerouslySetInnerHTML.__html = dx.hyphenated(e.props.dangerouslySetInnerHTML.__html, {
    language: t
  }));
}
var Oq = Eq;
const jq = /* @__PURE__ */ ha(Oq);
function Pq({
  persona: e,
  selectedPersonas: t,
  removeSelectedPersona: n,
  addSelectedPersona: r,
  updateSelectedPersona: i,
  color: a
}) {
  const o = t.find((l) => parseInt(l.id) === parseInt(e.postName)), s = async (l) => {
    const c = t.find((d) => d.id === l.id);
    if (c && isNaN(l.value))
      await n(l);
    else if (c && !isNaN(l.value) && l.value && l.value.toString().replace(".", "").length <= 3) {
      const d = t.findIndex((p) => parseInt(p.id) === parseInt(l.id));
      await i(l, d);
    } else if (!isNaN(l.value))
      await r(l);
    else
      return;
  };
  return /* @__PURE__ */ m.jsx(bo, { className: "find-personas--persona-input", type: "number", disabled: !0, label: /* @__PURE__ */ m.jsxs("label", { className: "community-tile--checkbox-label", children: [
    /* @__PURE__ */ m.jsx("span", { className: "community-tile-menu__number", children: e.acf.personacommunityNumber }),
    " | ",
    /* @__PURE__ */ m.jsx(jq, { children: /* @__PURE__ */ m.jsx("span", { className: "community-tile-menu__name", children: e.acf.title }) })
  ] }), labelPosition: "left", placeholder: 0, icon: "percent", style: {
    background: a
  }, onChange: (l, {
    value: c
  }) => s({
    id: parseInt(e.postName),
    name: e.acf.title,
    value: parseFloat(c)
  }), maxLength: 3, onInput: (l) => {
    let c = l.target.value.length, d = l.target.value.includes(".") ? l.target.maxLength + 1 : l.target.maxLength;
    c > d && (l.target.value = l.target.value.slice(0, d));
  }, value: o && o.value ? o.value.toFixed(1) : "", min: 0, max: 100 });
}
class Lq extends R.Component {
  constructor(t) {
    super(t), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "handleCheckBoxAction", () => {
      this.props.loadGroupedPersona();
    }), this.state = {
      showSidebar: !1
    };
  }
  componentDidMount() {
    this.props.loadCommunitiesAndPersonas(), this.props.featureAccess();
  }
  render() {
    const {
      selectedPersonas: t,
      removeSelectedPersona: n,
      campaignCreatorAccess: r,
      communities: i,
      accessInfo: a,
      isFetchingCommunities: o,
      addSelectedPersona: s,
      updateSelectedPersona: l
      // setSelectedPersonas,
      // previewSelectedPersonas
    } = this.props;
    let c = /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "message-streams", children: "Next" });
    const d = t.length ? c : /* @__PURE__ */ m.jsx(Gi, { content: "You must have the correct percentage of selected personas/segments to proceed to the next page", trigger: /* @__PURE__ */ m.jsx("span", { className: "ui button button--not-validated", children: "Next" }) });
    return c = t.length ? c : null, o || !i ? /* @__PURE__ */ m.jsx(ga, {}) : r ? /* @__PURE__ */ m.jsxs(fr, { children: [
      /* @__PURE__ */ m.jsxs("div", { className: "creative-briefs--navigation creative-briefs--navigation__x-pad", children: [
        /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "find-personas", children: "Back" }),
        /* @__PURE__ */ m.jsx("h1", { className: "campaign-creator--title", children: "Uploaded Profile" }),
        d
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "campaign-creator-page", children: [
        /* @__PURE__ */ m.jsx("div", { className: "select-segments-flex", children: i && i.map((p, y) => /* @__PURE__ */ m.jsx(
          nx,
          {
            colour: p.acf.color,
            title: `${p.acf.personacommunityNumber} - ${p.acf.title}`,
            summary: p.acf.listingSummary,
            image: p.acf.featuredImage.url,
            url: `/personas/${p.postName}`,
            personas: p.personas,
            accessInfo: a,
            children: p.personas && p.personas.slice(0).sort(function(f, N) {
              return N.acf.personacommunityNumber < f.acf.personacommunityNumber ? 1 : N.acf.personacommunityNumber > f.acf.personacommunityNumber ? -1 : 0;
            }).map((f, N) => /* @__PURE__ */ m.jsx(Pq, { persona: f, selectedPersonas: t, addSelectedPersona: s, updateSelectedPersona: l, removeSelectedPersona: n, color: p.acf.color }, N))
          },
          y
        )) }),
        /* @__PURE__ */ m.jsxs("div", { className: "creative-briefs--navigation", children: [
          /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "find-personas", children: "Back" }),
          c
        ] })
      ] })
    ] }) : null;
  }
}
const Tq = (e, t) => {
  const n = e.options.permissions && e.options.permissions.workflowPermission;
  return {
    accessInfo: e.communities && e.communities.accessInfo,
    communities: e.communities && qu(e),
    isFetchingCommunities: e.communities && e.communities.isFetching,
    selectedPersonas: e.selectedPersonas.personas,
    briefsFlow: e.campaignCreator.briefsFlow,
    previewSelectedPersonas: e.campaignCreator.previewSelectedPersonas,
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess
  };
}, Fq = (e) => Kt({
  addSelectedPersona: zu,
  updateSelectedPersona: rD,
  removeSelectedPersona: Es,
  setSelectedPersonas: u1,
  resetSelectedPersonas: ap,
  featureAccess: ui,
  loadGroupedPersona: Ss,
  loadCommunitiesAndPersonas: i1
}, e);
Mt(Tq, Fq)(Lq);
let Iq = class extends R.Component {
  constructor() {
    super(...arguments), et(this, "handleHelperVis", () => {
      this.props.setHelperMessageVisibility("intro", !0);
    }), et(this, "handleResetSelectedPersonas", () => {
      this.props.resetSelectedPersonas();
    }), et(this, "handleResetSelectedPersonasAndFlow", () => {
      this.props.resetSelectedPersonas(), this.props.setBriefsFlow("find");
    });
  }
  componentDidMount() {
    this.props.loadSuperSegments(), this.props.featureAccess(), this.props.loadOptions();
  }
  render() {
    const {
      communityImages: e,
      isFetching: t,
      firstLandingPage: n,
      campaignCreatorAccess: r,
      imageOne: i,
      imageTwo: a
    } = this.props;
    if (t && !e)
      return /* @__PURE__ */ m.jsx(ga, {});
    const o = /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsx("p", { children: "Get started by deciding which Helix Personas you’re targeting, either by choosing the ‘select from the list’ or the ‘load Helix Personas profile’ option." }),
      /* @__PURE__ */ m.jsx("p", { children: "Selecting from the list is as easy as clicking on the Personas of interest. However if your customer records are already coded by Helix Personas, or if you subscribe to Roy Morgan Single Source or are using our Live Audience Evaluation platform, we recommend that you select the ‘load Helix Personas Profile’ option." })
    ] });
    return /* @__PURE__ */ m.jsx(R.Fragment, { children: r ? /* @__PURE__ */ m.jsx(fr, { children: /* @__PURE__ */ m.jsx(We, { children: /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsxs("div", { className: "landing-page", children: [
      /* @__PURE__ */ m.jsx("div", { className: "landing-page__title-wrapper", children: /* @__PURE__ */ m.jsxs("div", { style: {
        position: "relative"
      }, children: [
        /* @__PURE__ */ m.jsx("h1", { className: "landing-page__title landing-page__title--creative-briefs", children: n ? n.pageTitle : null }),
        /* @__PURE__ */ m.jsx(pB, { page: "intro" })
      ] }) }),
      /* @__PURE__ */ m.jsx(fB, { page: "intro", message: o }),
      /* @__PURE__ */ m.jsx("h3", { className: "landing-page__sub-title", children: n ? n.subtitle : null }),
      /* @__PURE__ */ m.jsx(We, { stackable: !0, className: "landing-page__inner-grid", children: /* @__PURE__ */ m.jsxs(We.Row, { columns: 2, children: [
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(
          cl,
          {
            onClickHandler: this.handleResetSelectedPersonas,
            to: "/creative-briefs/select-personas",
            image: i && i,
            introText: n ? n.firstImageIntroText : "",
            title: n ? n.firstImageText : ""
          }
        ) }),
        /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx(cl, { onClickHandler: this.handleResetSelectedPersonasAndFlow, to: "/creative-briefs/find-personas", image: a && a, introText: n ? n.secondImageIntroText : "", title: n ? n.secondImageText : "" }) })
      ] }) })
    ] }) }) }) }) : "" });
  }
};
const kq = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    isFetching: e.campaignCreator.options.isFetching,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage,
    helperMessageVisibility: e.campaignCreator.helperMessage.intro
    // state.campaignCreator &&
    // state.campaignCreator.options &&
  };
}, Dq = (e) => Kt({
  loadOptions: Ag,
  loadSuperSegments: zo,
  featureAccess: ui,
  setHelperMessageVisibility: a1,
  resetSelectedPersonas: ap,
  setBriefsFlow: d1
}, e);
Mt(kq, Dq)(Iq);
let Rq = class extends R.Component {
  render() {
    const {
      campaignCreatorAccess: e
    } = this.props;
    return e ? /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsx(fr, { children: /* @__PURE__ */ m.jsx(We, { children: /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsxs("div", { className: "landing-page", children: [
      /* @__PURE__ */ m.jsx("h1", { className: "landing-page__title", children: "Roy Morgan Creative Briefs" }),
      /* @__PURE__ */ m.jsxs(We, { stackable: !0, className: "landing-page__inner-grid campaign-creator-page campaign-creator-page--introduction", children: [
        /* @__PURE__ */ m.jsx(We.Row, { className: "cb-intro__title-row", children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx("h3", { className: "landing-page__sub-title landing-page__sub-title--cb", children: "Introduction" }) }) }),
        /* @__PURE__ */ m.jsx(We.Row, { className: "cb-intro__row", children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsxs("div", { className: "cb-intro__content", children: [
          /* @__PURE__ */ m.jsxs("p", { children: [
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs*" }),
            " is an automated process to identify emotionally similar people and organise them into the priority target audiences applicable to your campaign. Using Helix Personas and Values Segments*, the",
            /* @__PURE__ */ m.jsx("em", { children: " Persuasion Guru" }),
            " engine develops a creative blueprint for you to persuade each target audience differently."
          ] }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " guides and optimises your messaging and communication. Crucially, it reveals how to reach and persuade the people in each target audience differently: different messaging, different visual imagery; different media; even different physical environments."
          ] }),
          /* @__PURE__ */ m.jsx("p", { children: "When media planning, advertisers tend to focus on targeting rather than the creative messages required to persuade the target audience. This is because - until now - it has been time consuming and expensive to develop multiple creative messages." }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            "To address this challenge, Roy Morgan has worked with leading media and creative agencies as well as social scientists to develop ",
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " ",
            "as part of its ",
            /* @__PURE__ */ m.jsx("em", { children: "Persuasion Guru" }),
            " product set."
          ] }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            "Once you have identified the combination of Helix Personas you wish to target,",
            " ",
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " will provide you with a detailed set of messaging instructions to help design your marketing offer, messaging, and communications."
          ] }),
          /* @__PURE__ */ m.jsx("p", { children: "As a psychographic segmentation tool, one of the great benefits of Helix Personas is that it incorporates people’s values, beliefs, and attitudes – the best predictors of consumer behaviour." }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            "While there is already a depth of information available about each Persona in Data Explorer, as well as the “Know Me”, “Walk With Me” and “Talk To Me” sections of the website,",
            " ",
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " goes much further in its ability to leverage Helix Personas to offers, messaging and creative."
          ] }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " finds who to persuade. And how to persuade them. It’s all a piece of magic. And the bespoke results are exclusively yours. The emotional DNA of your groups can never be replicated by a competitor."
          ] })
        ] }) }) }),
        /* @__PURE__ */ m.jsx(We.Row, { className: "cb-intro__title-row", children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx("h3", { className: "landing-page__sub-title", children: "Getting Started" }) }) }),
        /* @__PURE__ */ m.jsx(We.Row, { className: "cb-intro__row", children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsxs("div", { className: "cb-intro__content", children: [
          /* @__PURE__ */ m.jsx("p", { children: "To get started, decide which Helix Personas you’re targeting. On the next page, you will need to choose ‘I’ll select from the list’ button or the ‘Load Helix Personas Profile’ button." }),
          /* @__PURE__ */ m.jsx("p", { children: "Selecting from the list is as easy as clicking on the Personas of your choice." }),
          /* @__PURE__ */ m.jsx("p", { children: "If, however, your customer records are already coded by Helix Personas, or if you subscribe to Roy Morgan Single Source, or are using our Live Audience Evaluation platform, you can upload a specific Helix Personas distribution to define an audience. As an example of this kind of targeting, you might choose to upload a distribution of the percentage of your most profitable customers for each of the Helix Personas." }),
          /* @__PURE__ */ m.jsx("p", { children: "Selecting from the list is as easy as clicking on the Personas of interest. However if your customer records are already coded by Helix Personas, or if you subscribe to Roy Morgan Single Source or are using our Live Audience Evaluation platform, you can upload a file for the specific Personas you are targeting. An example of this kind of targeting, you might be communicating with your most profitable customers, so the file you upload will contain the percentage of most profitable customers for each of the Helix Personas." }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            "Once you have selected or uploaded your Helix Personas, ",
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " will assess your audience and automatically allocate your target audience across up to four messaging streams."
          ] }),
          /* @__PURE__ */ m.jsx("p", { children: "Each stream delivers a Creative Brief which you can view and download. To keep things simple and practical, regardless of the number of Helix Personas you select, there will always be a maximum of four sets of creative that you can choose to develop." }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " reveals the percentage of your target audience to which each messaging stream applies. This enables you to prioritise streams and decide how many to utilise to get maximum impact, given your budget and any other constraints. As a rule of thumb, we suggest utilising enough messaging streams to cover around two thirds (66%) of your target audience. If that’s just one Messaging Stream, life is simple."
          ] }),
          /* @__PURE__ */ m.jsxs("p", { children: [
            "The brilliance of ",
            /* @__PURE__ */ m.jsx("strong", { children: "Creative Briefs" }),
            " is that the briefs it delivers change according to the distribution of Helix Personas in your target audience. In other words, the brief isn’t simply based on the Helix Personas you include, but their relative importance to your target audience."
          ] })
        ] }) }) }),
        /* @__PURE__ */ m.jsx(We.Row, { children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsx("p", { className: "cb-sub-footer", children: /* @__PURE__ */ m.jsx("sub", { children: "* Creative Briefs and Roy Morgan Values Segments devised by Michele Levine of Roy Morgan and Colin Benjamin of The Horizons Network" }) }) }) }),
        /* @__PURE__ */ m.jsx(We.Row, { style: {
          paddingTop: 0
        }, children: /* @__PURE__ */ m.jsx(We.Column, { className: "cb-intro__button-col", children: /* @__PURE__ */ m.jsx(Ft, { as: wn, to: "/creative-briefs/getting-started", children: "Get started" }) }) })
      ] })
    ] }) }) }) }) }) : "";
  }
};
const Mq = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess
  };
}, Uq = (e) => Kt({
  loadOptions: Ag,
  featureAccess: ui
}, e);
Mt(Mq, Uq)(Rq);
class Bq extends R.Component {
  render() {
    return /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsx(fr, { children: /* @__PURE__ */ m.jsx(We, { children: /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsxs("div", { className: "landing-page", children: [
      /* @__PURE__ */ m.jsx("h1", { className: "landing-page__title", children: "Roy Morgan Creative Briefs" }),
      /* @__PURE__ */ m.jsx("h3", { className: "landing-page__sub-title landing-page__sub-title--cb", children: "Methodology" }),
      /* @__PURE__ */ m.jsx(We, { stackable: !0, className: "landing-page__inner-grid campaign-creator-page campaign-creator-page--introduction", children: /* @__PURE__ */ m.jsx(We.Row, { className: "cb-intro__row", children: /* @__PURE__ */ m.jsx(We.Column, { children: /* @__PURE__ */ m.jsxs("div", { className: "cb-intro__content cb-intro__content--methodology", children: [
        /* @__PURE__ */ m.jsx("p", { children: "Creative Briefs group Helix Personas into up to 4 messaging streams. The distribution of the Personas into the streams is based on commonality across a number of psychographic dimensions. The dimensions are based on Roy Morgan Values Segments and are designed to group the Personas based on a common reaction to advertising messaging. The dimensions include:" }),
        /* @__PURE__ */ m.jsxs("ul", { children: [
          /* @__PURE__ */ m.jsx("li", { children: "Life satisfaction" }),
          /* @__PURE__ */ m.jsx("li", { children: "Individualism" }),
          /* @__PURE__ */ m.jsx("li", { children: "Quality expectations" }),
          /* @__PURE__ */ m.jsx("li", { children: "Price expectations" }),
          /* @__PURE__ */ m.jsx("li", { children: "Innovation" }),
          /* @__PURE__ */ m.jsx("li", { children: "Progressiveness" })
        ] }),
        /* @__PURE__ */ m.jsx("p", { children: "4 messaging streams were selected as this limited the number of advertising creatives that would need to be developed." }),
        /* @__PURE__ */ m.jsx("p", { children: "Usually 2 messaging streams cover the majority of the target audience for a product or service." }),
        /* @__PURE__ */ m.jsxs("p", { children: [
          " ",
          "The Creative Brief for a messaging stream is composed of the Personas in that stream and also the relative weights of each Persona."
        ] }),
        /* @__PURE__ */ m.jsx("p", { children: "This means each Creative Brief is virtually unique and draws on the combination of material for all the Personas weighted to the Personas importance." }),
        /* @__PURE__ */ m.jsx("p", { children: "The Creative Briefs are designed to act as a guideline for creating messaging and communications." }),
        /* @__PURE__ */ m.jsx("p", { children: "The briefs are divided into sections that together build an overall brief:" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Premise underpinning communications" }),
        /* @__PURE__ */ m.jsx("p", { children: "Broad theme that underpins overall communication with group. Note, although this is the first piece of information it becomes much clearer once the remaining content has been read and digested. Good to have upfront, and to keep in mind as the user is reading through the document." }),
        /* @__PURE__ */ m.jsx("h5", { children: "Creative Strategy" }),
        /* @__PURE__ */ m.jsx("p", { children: "Includes things to consider when designing the creative material- i.e. the setting, clear messaging, what to include in imagery etc." }),
        /* @__PURE__ */ m.jsx("h5", { children: "Value Proposition" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Brand Voice" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Key Triggers" }),
        !kc() && /* @__PURE__ */ m.jsx("h5", { children: "Creative Prerequisites" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Advertising Tone and Style" }),
        /* @__PURE__ */ m.jsx("p", { children: "Leading on from the Creative Strategy, this section is more about ‘how’ to communicate the messages- i.e. demonstrating features, recommendations, appropriate language and wording etc" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Key Drivers" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Turn Offs" }),
        /* @__PURE__ */ m.jsx("h5", { children: "Target Helix Personas" })
      ] }) }) }) })
    ] }) }) }) }) });
  }
}
const zq = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    isFetching: e.campaignCreator.options.isFetching,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage
    // state.campaignCreator &&
    // state.campaignCreator.options &&
  };
}, qq = (e) => Kt({
  loadOptions: Ag,
  featureAccess: ui
}, e);
Mt(zq, qq)(Bq);
class Vq extends R.Component {
  constructor(t) {
    super(t), et(this, "handleSetHeadline", (n) => {
      this.setState({
        currentHeadline: n
      });
    }), et(this, "handleSetDescription", (n) => {
      this.setState({
        currentDescription: n
      });
    }), this.state = {
      headlines: [],
      descriptions: [],
      currentHeadline: 0,
      currentDescription: 0,
      company: "",
      url: ""
    }, t.results && (t.results.headlines && t.results.headlines.length > 0 && (this.state.headlines = t.results.headlines), t.results.descriptions && t.results.descriptions.length > 0 && (this.state.descriptions = t.results.descriptions)), this.state.company = t.data && t.data.company ? t.data.company : "", this.state.url = t.data && t.data.url ? t.data.url : "";
  }
  render() {
    const {
      currentHeadline: t,
      currentDescription: n,
      headlines: r,
      descriptions: i,
      company: a,
      url: o
    } = this.state, s = r.length > 0 && i.length > 0, l = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], c = {
      display: "flex",
      width: "485px",
      padding: "24px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
      background: "#FFF"
    }, d = {
      color: "#202124",
      fontFamily: "Arial",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "12px"
      // You can use a string for this value
    }, p = {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }, y = {
      width: "23px",
      height: "23px",
      background: "#EDEEF0",
      borderRadius: "11.5px"
    }, f = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gape: "4px"
    }, N = {
      color: "#4D5156",
      fontFamily: "Arial",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "12px"
    }, b = {
      color: "#4D5156",
      fontFamily: "Arial",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "12px"
    }, S = {
      display: "flex",
      width: "435px",
      height: "16px",
      flexDirection: "column",
      justifyContent: "center",
      textDecoration: "none",
      overflow: "hidden",
      color: "#1A0DAB",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontFamily: "Arial",
      fontSize: "17px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "12px"
      // You can use a string for this value
    }, _ = {
      display: "flex",
      width: "435px",
      height: "30px",
      flexDirection: "column",
      justifyContent: "center",
      overflow: "hidden",
      color: "#4D5156",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontFamily: "Arial",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "15px"
      // You can use a string for this value
    }, E = {
      width: "100%"
    }, k = {
      alignSelf: "stretch",
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "25.6px"
      // You can use a string for this value
    }, M = {
      display: "flex",
      width: "236px",
      height: "26px",
      flexDirection: "column",
      justifyContent: "center",
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25.6px"
    }, F = {
      display: "block",
      marginBottom: "20px"
    }, q = {
      padding: "4px 8px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      borderRadius: "4px",
      background: "none"
    }, j = {
      padding: "4px 8px",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      borderRadius: "4px",
      background: "#00ACCA",
      color: "#fff"
    };
    return /* @__PURE__ */ m.jsx(R.Fragment, { children: s ? /* @__PURE__ */ m.jsxs("div", { className: "google-ad-mockup__wrapper", style: E, children: [
      /* @__PURE__ */ m.jsx("h2", { style: k, children: "Google MockUp" }),
      /* @__PURE__ */ m.jsxs("div", { className: "mockup-section__headline", style: F, children: [
        /* @__PURE__ */ m.jsx("p", { style: M, children: "Select Headline" }),
        /* @__PURE__ */ m.jsx("div", { className: "headline__button-list", children: l.map((x, C) => /* @__PURE__ */ m.jsx("button", { onClick: () => this.handleSetHeadline(C), style: t === C ? j : q, className: "headline__list-item", children: x }, C)) })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "mockup-section__headline", style: F, children: [
        /* @__PURE__ */ m.jsx("p", { style: M, children: "Select Description" }),
        /* @__PURE__ */ m.jsx("div", { className: "mockup-section__description", style: F, children: l.map((x, C) => /* @__PURE__ */ m.jsx("button", { onClick: () => this.handleSetDescription(C), style: n === C ? j : q, className: "description__list-item", children: x }, C)) })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { style: c, children: [
        /* @__PURE__ */ m.jsx("span", { style: d, children: "Sponsored" }),
        /* @__PURE__ */ m.jsxs("div", { style: p, children: [
          /* @__PURE__ */ m.jsx("div", { style: y }),
          /* @__PURE__ */ m.jsxs("div", { style: f, children: [
            /* @__PURE__ */ m.jsx("span", { style: N, children: a }),
            /* @__PURE__ */ m.jsx("span", { style: b, children: o })
          ] })
        ] }),
        /* @__PURE__ */ m.jsx("a", { href: o, style: S, children: r[t] }),
        /* @__PURE__ */ m.jsx("p", { style: _, children: i[n] })
      ] })
    ] }) : "" });
  }
}
const Wq = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    formLoading: e.superSegments.formLoading,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage
  };
}, Hq = (e) => Kt({
  loadSuperSegments: zo,
  featureAccess: ui
}, e), $q = Mt(Wq, Hq)(Vq);
class Gq extends gt.Component {
  constructor(t) {
    super(t), et(this, "handleSetHeadline", (n) => {
      this.setState({
        currentHeadline: n
      });
    }), et(this, "handleSetDescription", (n) => {
      this.setState({
        currentDescription: n
      });
    }), et(this, "handleSetAdCopy", (n) => {
      this.setState({
        currentAdCopy: n
      });
    }), this.state = {
      headlines: [],
      descriptions: [],
      adCopy: [],
      currentHeadline: 0,
      currentDescription: 0,
      currentAdCopy: 0,
      company: t.data.company,
      url: t.data.url
    }, t.results && (t.results.headlines && t.results.headlines.length > 0 && (this.state.headlines = t.results.headlines), t.results.descriptions && t.results.descriptions.length > 0 && (this.state.descriptions = t.results.descriptions), t.results.adCopy && t.results.adCopy.length > 0 && (this.state.adCopy = t.results.adCopy));
  }
  render() {
    const {
      currentHeadline: t,
      currentDescription: n,
      currentAdCopy: r,
      headlines: i,
      descriptions: a,
      adCopy: o,
      company: s,
      url: l
    } = this.state, c = i && a && i.length > 0 && a.length > 0 && o && o.length > 0, d = {
      // Replace with the actual URL of the favicon
      groupName: s
    }, p = {
      description: o[r]
    }, y = {
      siteUrl: l,
      heading: i[t],
      shortDescription: a[n]
    }, f = {
      width: "100%"
    }, N = {
      alignSelf: "stretch",
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "25.6px"
      // You can use a string for this value
    }, b = {
      display: "flex",
      width: "236px",
      height: "26px",
      flexDirection: "column",
      justifyContent: "center",
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25.6px",
      marginBottom: "10px"
    }, S = {
      display: "block",
      marginBottom: "10px"
    }, _ = {
      padding: "4px 8px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      borderRadius: "4px",
      background: "none"
    }, E = {
      padding: "4px 8px",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      borderRadius: "4px",
      background: "#00ACCA",
      color: "#fff"
    }, k = {
      wrapper: {
        display: "flex",
        paddingTop: "10px",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        border: "1px solid #FFF",
        background: "#FFF"
      },
      header: {
        wrapper: {
          display: "flex",
          alignItems: "center",
          gap: "245px"
        },
        inner: {
          display: "flex",
          alignItems: "center",
          gap: "6px"
        },
        right: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        },
        favicon: {
          width: "28px",
          height: "28px",
          background: "#EDEEF0",
          borderRadius: "14px"
        },
        title: {
          display: "flex",
          width: "161px",
          height: "18px",
          flexDirection: "column",
          justifyContent: "center",
          color: "#050505",
          fontFamily: "Arial",
          fontSize: "11px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "25.6px"
          // You can use a string for this value
        },
        sponsor: {
          display: "flex",
          width: "161px",
          height: "18px",
          flexDirection: "column",
          justifyContent: "center",
          color: "#75777B",
          fontFamily: "Arial",
          fontSize: "9px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "25.6px"
        }
      },
      contentStyle: {
        backgroundColor: "#fff",
        padding: "0 10px"
      },
      contentAdCopy: {
        color: "#75777B",
        fontFamily: "Arial",
        fontSize: "11px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "130%",
        // You can use a string for this value
        letterSpacing: "-0.165px",
        textAlign: "left"
      },
      contentImage: {
        height: "446px",
        border: "solid 1px lightgrey",
        background: "url(https://cms.arcadiandigital.com.au/wp-content/uploads/2023/09/adgenerator_facebook1.png)",
        backgroundSize: "cover"
      },
      contentImageText: {
        width: "161px",
        position: "relative",
        left: "151px",
        top: "200px",
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Arial",
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "25.6px"
        // You can use a string for this value
      },
      footer: {
        wrapper: {
          display: "flex",
          width: "485px",
          padding: "8px 12px",
          alignItems: "center",
          gag: "24px"
        },
        left: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px"
        },
        url: {
          display: "flex",
          width: "161px",
          height: "9px",
          flexDirection: "column",
          justifyContent: "center",
          color: "#75777B",
          leadingTrim: "both",
          textEdge: "cap",
          fontFamily: "Arial",
          fontSize: "9px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "25.6px",
          // You can use a string for this value
          textTransform: "uppercase"
        },
        headline: {
          display: "flex",
          width: "366px",
          height: "12px",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          color: "#050505",
          leadingTrim: "both",
          textEdge: "cap",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontFamily: "Arial",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "25.6px"
        },
        // You can use a string for this value},
        description: {
          display: "flex",
          width: "366px",
          height: "12px",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          color: "#75777B",
          leadingTrim: "both",
          textEdge: "cap",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontFamily: "Arial",
          fontSize: "11px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "25.6px",
          // You can use a string for this value
          letterSpacing: "-0.165px"
        },
        button: {
          display: "flex",
          padding: "0px 5px",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          borderRadius: "4px",
          background: "#E4E6EB",
          height: "26px"
        }
      },
      ui: {
        wrapper: {
          display: "flex",
          padding: "0px 16px",
          justifyContent: "space-between",
          alignItems: "flex-start",
          backgroundColor: "#fff",
          width: "485px",
          height: "29px"
        },
        left: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          color: "#75777B",
          textOverflow: "ellipsis",
          whitespace: "nowrap",
          fontFamily: "Arial",
          fontSize: "11px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "25.6px",
          letterSpacing: "-0.165px"
        },
        right: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          color: "#75777B",
          textOverflow: "ellipsis",
          whitespace: "nowrap",
          fontFamily: "Arial",
          fontSize: "11px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "25.6px",
          letterSpacing: "-0.165px"
        }
      }
    }, M = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F = [1, 2, 3, 4, 5, 6];
    return /* @__PURE__ */ m.jsx(gt.Fragment, { children: c ? /* @__PURE__ */ m.jsxs("div", { className: "google-ad-mockup__wrapper", style: f, children: [
      /* @__PURE__ */ m.jsx("h2", { style: N, children: "Facebook MockUp" }),
      /* @__PURE__ */ m.jsxs("div", { className: "mockup-section__headline", style: S, children: [
        /* @__PURE__ */ m.jsx("p", { style: b, children: "Select Headline" }),
        /* @__PURE__ */ m.jsx("div", { className: "headline__button-list", children: M.map((q, j) => /* @__PURE__ */ m.jsx("button", { onClick: () => this.handleSetHeadline(j), style: t === j ? E : _, className: "headline__list-item", children: q }, j)) })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "mockup-section__headline", style: S, children: [
        /* @__PURE__ */ m.jsx("p", { style: b, children: "Select Description" }),
        /* @__PURE__ */ m.jsx("div", { className: "mockup-section__description", style: S, children: M.map((q, j) => /* @__PURE__ */ m.jsx("button", { onClick: () => this.handleSetDescription(j), style: n === j ? E : _, className: "description__list-item", children: q }, j)) })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "mockup-section__adcopy", style: S, children: [
        /* @__PURE__ */ m.jsx("p", { style: b, children: "Select Ad Copy" }),
        /* @__PURE__ */ m.jsx("div", { className: "mockup-section__adcopy", style: S, children: F.map((q, j) => /* @__PURE__ */ m.jsx("button", { onClick: () => this.handleSetAdCopy(j), style: r === j ? E : _, className: "adcopy__list-item", children: q }, j)) })
      ] }),
      /* @__PURE__ */ m.jsxs("div", { className: "facebook-ad-post", style: k.wrapper, children: [
        /* @__PURE__ */ m.jsxs("div", { className: "facebook-ad-header", style: k.header.wrapper, children: [
          /* @__PURE__ */ m.jsxs("div", { style: k.header.inner, children: [
            /* @__PURE__ */ m.jsx("div", { className: "facebook-ad-favicon", style: k.header.favicon }),
            /* @__PURE__ */ m.jsxs("div", { style: k.header.right, children: [
              /* @__PURE__ */ m.jsx("div", { style: k.header.title, children: d.groupName }),
              /* @__PURE__ */ m.jsx("div", { style: k.header.sponsor, children: "Sponsored" })
            ] })
          ] }),
          /* @__PURE__ */ m.jsx("div", { children: "..." })
        ] }),
        /* @__PURE__ */ m.jsxs("div", { className: "facebook-ad-content", style: k.contentStyle, children: [
          /* @__PURE__ */ m.jsx("p", { style: k.contentAdCopy, className: "facebook-ad-adcopy", children: p.description }),
          /* @__PURE__ */ m.jsx("div", { style: k.contentImage, className: "facebook-ad-image", children: /* @__PURE__ */ m.jsx("div", { style: k.contentImageText, children: "Image Goes Here" }) })
        ] }),
        /* @__PURE__ */ m.jsxs("div", { className: "facebook-ad-footer", style: k.footer.wrapper, children: [
          /* @__PURE__ */ m.jsxs("div", { style: k.footer.left, children: [
            /* @__PURE__ */ m.jsx("div", { style: k.footer.url, children: y.siteUrl }),
            /* @__PURE__ */ m.jsx("div", { style: k.footer.headline, children: y.heading }),
            /* @__PURE__ */ m.jsx("div", { style: k.footer.description, children: y.shortDescription })
          ] }),
          /* @__PURE__ */ m.jsx("button", { style: k.footer.button, className: "inverted", children: "View More" })
        ] }),
        /* @__PURE__ */ m.jsxs("div", { className: "facebook-ad-ui", style: k.ui.wrapper, children: [
          /* @__PURE__ */ m.jsx("div", { style: k.ui.left, className: "facebook-ad-likes", children: "3K Likes" }),
          /* @__PURE__ */ m.jsx("div", { style: k.ui.right, className: "facebook-ad-like-button", children: "184 Comments 77 Shares" })
        ] })
      ] })
    ] }) : "" });
  }
}
const Qq = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    formLoading: e.superSegments.formLoading,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage
  };
}, Yq = (e) => Kt({
  loadSuperSegments: zo,
  featureAccess: ui
}, e), Kq = Mt(Qq, Yq)(Gq);
function S0(e) {
  const t = {
    premise: "Premise underpinning communications",
    messagePromise: "Message Promise",
    valueProposition: "Value Proposition",
    brandVoice: "Brand Voice",
    keyTriggers: "Key Triggers"
  }, n = Object.keys(t), r = Object.values(t), i = {
    premise: "",
    messagePromise: "",
    valueProposition: "",
    brandVoice: "",
    keyTriggers: ""
  };
  for (let a = 0; a < r.length; a++) {
    const o = r[a];
    for (let s = 0; s < e.length; s++)
      if (e[s] && e[s].label === o) {
        const l = e[s].messages.join(". "), c = n[a];
        i[c] = l;
      }
  }
  return i;
}
function Xq(e, t) {
  const n = Jq();
  let r = "";
  return r += n.intro, r += n.company, r += n.services, r += n.keywords, r += ` ${e.secondary}. `, r += n.cta, r += `${n.usp}: ${e.proposition}. `, t.premise && (r += `${n.premise}: ${t.premise}. `), t.messagePromise && (r += `${n.messagePromise}: ${t.messagePromise}. `), t.valueProposition && (r += `${n.valueProposition}: ${t.valueProposition}. `), t.brandVoice && (r += `${n.brandVoice}: ${t.brandVoice}. `), t.keyTriggers && (r += `${n.keyTriggers}: ${t.keyTriggers}. `), r += `${n.headlines}. `, r += n.actionOne, r += n.actionTwo, r += n.promptConfig, r = r.replaceAll("<COMPANY_NAME>", e.company), r = r.replaceAll("<BUSINESS_TYPE>", e.businessType), r = r.replaceAll("<PRIMARY>", e.primary), r = r.replaceAll("<SERVICE>", e.services), r;
}
function Zq(e, t) {
  const n = Aq();
  let r = "";
  return r += n.intro, r += n.company, r += n.services, r += `${n.headlines}. `, r += n.cta, r += `${n.usp}: ${e.proposition}. `, t.premise && (r += `${n.premise}: ${t.premise}`), t.messagePromise && (r += `${n.messagePromise}: ${t.messagePromise}`), t.valueProposition && (r += `${n.valueProposition}: ${t.valueProposition}`), t.brandVoice && (r += `${n.brandVoice}: ${t.brandVoice}`), t.keyTriggers && (r += `${n.keyTriggers}: ${t.keyTriggers}`), r += n.actionOne, r += n.actionTwo, r += n.actionThree, r += n.promptConfig, r = r.replaceAll("<COMPANY_NAME>", e.company), r = r.replaceAll("<BUSINESS_TYPE>", e.businessType), r = r.replaceAll("<PRIMARY>", e.primary), r = r.replaceAll("<SERVICE>", e.services), r;
}
function Jq() {
  return {
    intro: "Imagine you are a marketing expert, specialising in Google Ads. ",
    company: "You are creating ad copy for a client called <COMPANY_NAME>. ",
    services: "They are one of the leading <BUSINESS_TYPE> in Melbourne. This ad will focus particularly on their service <SERVICE>. We are looking to generate Google Ad headlines and descriptions for an ad group targeting keywords based on the service. ",
    headlines: "We are looking to generate Google Ad headlines for an ad group targeting roughly based on this list of primary and secondary keywords, as well as the unique callouts for this company.",
    premise: "the premise underpinning the ad copy should be",
    messagePromise: "The message promise should vary between",
    valueProposition: "The Value Proposition should vary between",
    brandVoice: "The brand voice should have",
    keyTriggers: "The key triggers in the copy should include",
    cta: "The call to action for the ads will be: Get In Touch. ",
    usp: "Some additional selling points/callouts to consider include",
    keywords: "The primary keyword of this ad group is <PRIMARY>, but the ad group is also targeting the following secondary keywords:",
    actionOne: "Create 10 ad headlines we could use for a Google Responsive Search Ad. These headlines need to be between 50 and 70 characters in length, including spaces, with each word starting with a capital letter. The headline options need to include the primary and secondary keywords, and the call to action, and some options need to have a reference to the location.",
    actionTwo: "After that, create 10 ad descriptions for the Google Responsive Search Ad. These descriptions must be between 100 and 150 characters in length, including spaces, with sentence case capitalisation. Half of the descriptions should be written to sell the expertise of <COMPANY_NAME> for the service that aligns with the intent of someone searching the keywords. They should include the primary keyword and selling points/callouts of <COMPANY_NAME>. But only include the clients name in half of the descriptions.",
    promptConfig: 'These headlines and descriptions should be written in Australian English and use a tone of voice that is professional and authoritative. Return these results as a JSON object, each one as an array of strings assigned to the response property "headlines" and "descriptions" respectively.'
  };
}
function Aq() {
  return {
    intro: "Imagine you are a marketing expert, specialising in Facebook Ads. ",
    company: "You are creating ad copy to drive brand awareness for a client called <COMPANY_NAME>. ",
    services: "They sell <SERVICES>.",
    headlines: "We are looking to generate Facebook Ad Copy, headlines and descriptions for this company. ",
    premise: "the premise underpinning the ad copy should be",
    messagePromise: "The message promise should vary between",
    valueProposition: "The Value Proposition should vary between",
    brandVoice: "The brand voice should have",
    keyTriggers: "The key triggers in the copy should include",
    cta: "The call to action for the ads will be: Get In Touch. ",
    usp: "Some additional selling points/callouts to consider include",
    actionOne: 'Create 10 ad headlines we could use. These headlines need to be between 50 and 70 characters long, including spaces, with each word starting with a capital letter. The headline options should focus on the selling points as well as statements that would appear to the audience.Some options need to have a reference to the location. Do not put emojis in the headline results.These headings need to be returned as an array of strings in the response property called "headings"',
    actionTwo: 'Create 10 ad descriptions we could use. These descriptions need to be between 75 and 90 characters in length, including spaces, with each word starting with a capital letter. The description options should have similarities with the headlines in terms of a focus on the selling points, but we want them to build on the ad headlines. Some options need to have a reference to the location. Do not put emojis in the description results. These descriptions need to be returned as an array of strings in the response property called "descriptions".',
    actionThree: 'Create 6 variations of ad copy we could use to drive awareness for <COMPANY_NAME>. These should be formatted in 2 small paragraphs, each with 2-3 sentences. The first sentence of the first paragraph should start with an attention-grabbing question or statement that the audience would relate to or resonate with. The rest of the first paragraph should include content that the audience will further resonate with. This content should include both two things: 1, the additional selling points/callouts listed and 2, general content that fits the brief of "audience will further resonate with". The second paragraph should end with the ad call to action, and the lead-in to that call to action should be further selling points/callouts that add depth to the first paragraph. Include an appropriate emoji or two in the ad copy results - these may look best at the end of the first and/or second paragraph. These ad copy variations must be in sentence case capitalisation and stored as an array of strings in the response property called "adCopy". ',
    promptConfig: 'These ad copy variations, headlines and descriptions should be written in Australian English and use a tone of voice that is friendly and authoritive and approachable.Return these results as a JSON object, each one as an array of strings assigned to the response property "headlines", "descriptions" and "adCopy" respectively.'
  };
}
class eV extends R.Component {
  constructor(t) {
    super(t), et(this, "returnToForm", () => {
      this.setState((n) => ({
        showResults: !n.showResults
      }));
    }), et(this, "handleInputChange", (n) => {
      let r = Object.assign({}, this.state.formData);
      r[n.target.name] = n.target.value, this.setState({
        formData: r
      });
    }), et(this, "generateGoogleAds", async () => {
      const n = this.state.formData, {
        sections: r
      } = this.state.streamMeta, i = S0(r), a = this.state.generatedPrompts, o = Xq(n, i);
      a.google = o, this.setState({
        generatedPrompts: a
      });
      const s = await this.sendReqest(o);
      return s !== void 0 && this.setState({
        googleResults: s
      }), !0;
    }), et(this, "generateFacebookAds", async () => {
      const n = this.state.formData, {
        sections: r
      } = this.state.streamMeta, i = S0(r), a = this.state.generatedPrompts, o = Zq(n, i);
      a.facebook = o, this.setState({
        generatedPrompts: a
      });
      const s = await this.sendReqest(o);
      return s !== void 0 && this.setState({
        facebookResults: s
      }), !0;
    }), et(this, "handleSubmit", async (n) => {
      this.state.formLoading || (this.setState({
        formData: n,
        promptType: "google",
        formLoading: !0,
        showResults: !1
      }), await this.generateGoogleAds(), await this.generateFacebookAds(), this.setState({
        formLoading: !1,
        showResults: !0
      }));
    }), et(this, "sendReqest", async (n) => {
      const r = "Bearer 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", i = {
        model: "gpt-4",
        messages: [{
          role: "user",
          content: n
        }]
      }, a = "https://api.openai.com/v1/chat/completions", o = new Headers({
        Authorization: r,
        "Content-Type": "application/json"
      }), s = await fetch(a, {
        method: "post",
        headers: o,
        body: JSON.stringify(i)
      });
      if (s.ok) {
        const l = await s.json();
        return l.choices && l.choices.length > 0 ? JSON.parse(l.choices[0].message.content) : void 0;
      }
    }), et(this, "toggleResults", (n) => {
      n === "google" ? this.setState({
        promptType: "google"
      }) : n === "facebook" && this.setState({
        promptType: "facebook"
      });
    }), et(this, "downloadResultsCSV", () => !0), this.state = {
      formLoading: !1,
      googleLoading: !1,
      facebookLoading: !1,
      showResults: !1,
      formData: {
        company: "",
        url: "",
        about: "",
        services: "",
        proposition: "",
        primary: "",
        secondary: "",
        businessType: ""
      },
      generatedPrompts: {
        google: "",
        facebook: ""
      },
      promptType: "google",
      googleResults: {
        headlines: [],
        descriptions: [],
        adCopy: []
      },
      facebookResults: {
        headlines: [],
        descriptions: [],
        adCopy: []
      },
      streamMeta: {
        sections: t.briefSections,
        personas: t.personas,
        quadrant: t.selectedQuadrant
      }
    };
  }
  render() {
    const {
      company: t,
      url: n,
      about: r,
      services: i,
      proposition: a,
      primary: o,
      secondary: s,
      businessType: l
    } = this.state.formData, {
      googleResults: c,
      facebookResults: d,
      formLoading: p,
      showResults: y,
      promptType: f
    } = this.state, {
      quadrant: N,
      personas: b
    } = this.state.streamMeta, S = {
      company: t,
      url: n
    }, _ = {
      headlines: [],
      descriptions: [],
      adCopy: []
    };
    f === "google" ? (_.headlines = c.headlines, _.descriptions = c.descriptions) : f === "facebook" && (_.headlines = d.headlines || [], _.descriptions = d.descriptions || [], _.adCopy = d.adCopy || []);
    const E = {
      display: "flex",
      width: "1200px",
      padding: "40px 64px 64px 64px",
      flexDirection: "column",
      alignItems: "center",
      borderRadius: "16px",
      background: "#FFF"
    }, k = {
      display: "flex",
      paddingTop: "24px",
      flexDirection: "column",
      alignItems: "center",
      gap: "40px",
      alignSelf: "stretch"
    }, M = {
      color: "var(--helix-black, #23211D)",
      textAlign: "center",
      fontFamily: "Proxima Nova",
      fontSize: "32px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "150%",
      // You can use a string for this value
      textTransform: "uppercase"
    }, F = {
      display: "flex"
    }, q = {
      display: "inline-flex",
      padding: "8px 16px",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
      borderRadius: "9px",
      background: "#F3F5F7",
      width: "100%"
    }, j = {
      display: "flex",
      padding: "6.51px 14.01px 7.49px 9.99px",
      alignItems: "center",
      borderRadius: "4px",
      background: "#F3F5F7"
    }, x = {
      color: "var(--helix-grey-dark, #596475)",
      fontFamily: "Proxima Nova",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "12px"
      // You can use a string for this value
    }, C = {
      width: "100%"
    }, D = {
      color: "var(--helix-grey-dark, #596475)",
      fontFamily: "Proxima Nova",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "150%",
      // You can use a string for this value
      background: "var(--helix-grey-light, #F3F5F7)"
    }, P = {
      background: "#F3F5F7",
      height: "104px"
    }, L = {
      alignSelf: "stretch",
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "25.6px",
      // You can use a string for this value
      marginTop: "20px"
    }, H = {
      color: "#27251F",
      fontFamily: "Proxima Nova",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25.6px",
      // You can use a string for this value
      alignSelf: "stretch"
    }, $ = {
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "center",
      gap: "24px",
      borderRadius: "9px",
      background: "#F3F5F7"
    }, ae = {
      display: "flex",
      padding: "4px 10px 4px 6px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      borderRadius: "4px",
      background: "#00ACCA",
      color: "#FFF"
    }, ce = {
      display: "flex",
      padding: "4px 10px 4px 6px",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      borderRadius: "4px",
      color: "#596475",
      background: "#FFF"
    };
    return /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsx(fr, { children: /* @__PURE__ */ m.jsx("div", { className: "ad-generator__page", style: E, children: y ? /* @__PURE__ */ m.jsx("div", { className: "ad-generator__page-inner", style: k, children: /* @__PURE__ */ m.jsxs(We, { children: [
      /* @__PURE__ */ m.jsx(We.Column, { width: 12, alignItems: "left", children: /* @__PURE__ */ m.jsx("button", { onClick: this.returnToForm, style: {
        float: "left"
      }, children: "< Back to Company Details" }) }),
      /* @__PURE__ */ m.jsx(We.Column, { width: 12, children: /* @__PURE__ */ m.jsxs("div", { className: "generate-ads__header", children: [
        /* @__PURE__ */ m.jsx("h2", { className: "header__title", style: M, children: "Generate Ad Copy" }),
        /* @__PURE__ */ m.jsxs("div", { className: "personas__list", style: q, children: [
          /* @__PURE__ */ m.jsx("button", { onClick: () => this.toggleResults("google"), style: f === "google" ? ae : ce, children: "Google" }),
          /* @__PURE__ */ m.jsx("button", { onClick: () => this.toggleResults("facebook"), style: f === "facebook" ? ae : ce, children: "Facebook" })
        ] })
      ] }) }),
      /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsxs("div", { className: "generate-ads__results-left-column", style: {
        gap: "32px"
      }, children: [
        /* @__PURE__ */ m.jsx("div", { className: "results__headlines", children: _.headlines && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          /* @__PURE__ */ m.jsx("h3", { style: L, children: "Your Suggested Headlines:" }),
          /* @__PURE__ */ m.jsx("div", { className: "headlines__inner", style: H, children: _.headlines.length > 0 ? _.headlines.map((le, oe) => /* @__PURE__ */ m.jsxs("div", { style: {
            marginBottom: "10px"
          }, children: [
            oe + 1,
            ". ",
            le
          ] }, oe)) : "No Results" })
        ] }) }),
        /* @__PURE__ */ m.jsx("div", { className: "results__descriptions", children: _.descriptions && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          /* @__PURE__ */ m.jsx("h3", { style: L, children: "Your Suggested Descriptions:" }),
          /* @__PURE__ */ m.jsx("div", { className: "descriptions__inner", style: H, children: _.descriptions.length > 0 ? _.descriptions.map((le, oe) => /* @__PURE__ */ m.jsxs("div", { style: {
            marginBottom: "10px"
          }, children: [
            oe + 1,
            ". ",
            le
          ] }, oe)) : "NO RESULTS" })
        ] }) }),
        /* @__PURE__ */ m.jsx("div", { className: "results__adcopy", children: _.adCopy && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
          /* @__PURE__ */ m.jsx("h3", { style: L, children: "Your Suggested Ad Copy:" }),
          /* @__PURE__ */ m.jsx("div", { className: "adcopy__inner", style: H, children: _.adCopy.length > 0 ? _.adCopy.map((le, oe) => /* @__PURE__ */ m.jsxs("div", { style: {
            marginBottom: "10px"
          }, children: [
            oe + 1,
            ". ",
            le
          ] }, oe)) : "NO RESULTS" })
        ] }) }),
        /* @__PURE__ */ m.jsx("div", { className: "results__download-csv", style: {
          marginTop: "20px"
        }, children: /* @__PURE__ */ m.jsx(Ft, { onClick: () => this.downloadResultsCSV(), type: "button", children: "Download CSV" }) })
      ] }) }),
      /* @__PURE__ */ m.jsx(We.Column, { width: 6, children: /* @__PURE__ */ m.jsx("div", { className: "generate-ads__results-right-column", children: /* @__PURE__ */ m.jsx("div", { className: "results-right-column__inner", style: $, children: f === "google" ? /* @__PURE__ */ m.jsx($q, { results: c, data: S }) : /* @__PURE__ */ m.jsx(Kq, { results: d, data: S }) }) }) })
    ] }) }) : /* @__PURE__ */ m.jsxs("div", { className: "ad-generator__page-inner", style: k, children: [
      /* @__PURE__ */ m.jsx("h2", { className: "header__title", style: M, children: "GENERATE AD" }),
      /* @__PURE__ */ m.jsx("div", { className: "personas__list", style: F, children: b && b.length > 0 && b.map((le, oe) => /* @__PURE__ */ m.jsx("div", { className: "personas__list-item", style: j, children: /* @__PURE__ */ m.jsx("span", { style: x, children: `${le.id} - ${le.name}` }) }, oe)) }),
      /* @__PURE__ */ m.jsx("div", { className: "generate-ads__ads-form", style: C, children: /* @__PURE__ */ m.jsxs(Ct, { children: [
        /* @__PURE__ */ m.jsx(Ct.Input, { label: "Company Name", placeholder: "Eg. Company A", name: "company", type: "text", required: !0, value: t, style: D, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.Input, { label: "Paste your Website URL", placeholder: "Eg. companya.com.au", name: "url", type: "text", required: !0, value: n, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.Input, { label: "What Field does this business ", placeholder: "Eg. Digital Agency", name: "businessType", type: "text", required: !0, value: l, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.TextArea, { label: "Tell us about your company in 50 words or less", placeholder: "Eg. Company A helps people explore cities differently. With our curate guidebooks you can find the best hidden local spots, not just the famous tourist sites. We have guidebooks in over 50 Locations worldwide", name: "about", type: "textarea", required: !0, value: r, style: P, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.TextArea, { label: "Tell us about the products or services you are looking to advertise", placeholder: "Eg. Our melbourne Guidebook has been launched this week. It features over 200 ideas of places to go to.", name: "services", value: i, type: "textarea", required: !0, style: P, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.TextArea, { label: "Tell us about your unique value proposition", placeholder: "Eg. Unlike ordinary travel guides, our guides weave captivating stories, time-travel narratives, and eco-conscious trails. We're not just guides; we're your gateway to the extraordinary, making every journey a memory to treasure.", name: "proposition", required: !0, type: "textarea", style: P, value: a, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.TextArea, { label: "What are your primary keywords?", placeholder: "Eg. Travel guides, city exploration, hidden gems, immersive experiences, curated maps.", name: "primary", type: "textarea", value: o, required: !0, style: P, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ct.TextArea, { label: "What are your secondary keywords?", placeholder: "Eg. Historical tales, local haunts, off-the-beaten-path, cultural treasures, culinary journeys, sustainable travel, virtual exploration.", name: "secondary", type: "textarea", required: !0, value: s, style: P, onChange: this.handleInputChange, disabled: p }),
        /* @__PURE__ */ m.jsx(Ft, { onClick: () => {
          this.handleSubmit({
            company: t,
            url: n,
            about: r,
            services: i,
            proposition: a,
            primary: o,
            secondary: s,
            businessType: l
          });
        }, type: "submit", loading: p, style: {
          padding: "8px 20px"
        }, children: "Generate Ad" })
      ] }) })
    ] }) }) }) });
  }
}
const tV = function(e) {
  let {
    workflowPermission: t
  } = e.options.permissions;
  return {
    formLoading: e.superSegments.formLoading,
    communityImages: Ml(e),
    campaignCreatorAccess: e.featureAccess.byId && e.featureAccess.byId[t] && e.featureAccess.byId[t].hasAccess,
    firstLandingPage: e.campaignCreator.options.firstLandingPage
  };
}, nV = (e) => Kt({
  loadSuperSegments: zo,
  featureAccess: ui
}, e);
Mt(tV, nV)(eV);
const E0 = {
  isFetching: !1,
  insightIds: [],
  insightSetGroupId: 3,
  insightSetId: 110,
  error: null
}, rV = (e = E0, t) => {
  switch (t.type) {
    case qk:
    case Hk:
      return {
        ...e,
        isFetching: !0,
        error: null
      };
    case Wk:
    case Gk:
      return {
        ...e,
        isFetching: !1,
        error: t.payload
      };
    case Vk:
    case $k:
      return {
        ...e,
        isFetching: !1,
        ...t.payload
      };
    case Bu:
    case di:
    case rp:
      return E0;
    default:
      return e;
  }
};
fi((e) => e.mapping, (e) => {
  let {
    insightIds: t = [],
    insightSetGroupId: n = null,
    insightSetId: r = null,
    isFetching: i
  } = e;
  return t = t.map((a) => a.id).join(","), [`&insightgroupid=${n || ""}&insightsetid=${r || ""}${t.length ? `&insightid=${t}` : ""}&insightsetmode=2`, i];
});
const C0 = {
  isFetching: !1,
  records: [],
  error: void 0
}, iV = (e = C0, t) => {
  switch (t.type) {
    case rw:
      return {
        ...e,
        isFetching: !0
      };
    case iw:
      return {
        ...e,
        error: void 0,
        // $FlowFixMe
        records: [...t.payload],
        isFetching: !1
      };
    case aw:
      return {
        ...e,
        isFetching: !1,
        records: [],
        error: t.error
      };
    case ow:
      return {
        ...e,
        error: void 0,
        isFetching: !1,
        records: []
      };
    case di:
      return C0;
    default:
      return e;
  }
}, fx = fi((e) => e.findPersonasIndividual.records, (e) => e.selectedPersonas, (e, {
  personas: t,
  isHidden: n
}) => {
  if (!e) return {};
  const r = t.map(({
    id: i
  }) => i);
  return e.reduce((i, a) => {
    var o;
    return !n || r.includes(a.segmentId) ? {
      ...i,
      [a.segmentId]: {
        segmentId: a.segmentId,
        segmentLabel: a.segmentLabel,
        answers: {
          ...(o = i[a.segmentId]) == null ? void 0 : o.answers,
          [a.answerId]: {
            questionId: a.questionId,
            questionLabel: a.questionLabel,
            answerId: a.answerId,
            answerLabel: a.answerLabel,
            target: a.target,
            multiselect: a.multiselect,
            population: a.population,
            shareOfSegment: a.shareOfSegment,
            index: a.index,
            share: a.share,
            shareOfProperty: a.shareOfProperty,
            belowSample: a.belowSample
          }
        }
      }
    } : i;
  }, {});
});
fi(fx, (e) => e.selectedCharacteristics.characteristics, (e) => e.selectedMeasure.measure, (e) => e.audienceView.view.textSingular, (e, t, n, r) => ({
  fields: [r, ...t.map(({
    answerLabel: i
  }) => i)],
  data: Object.entries(e).map(([i, {
    answers: a
  }]) => [i, ...t.map(({
    answerId: o
  }) => {
    var s;
    return (s = a[o]) == null ? void 0 : s[n];
  })])
}));
const aV = {
  isFetching: !1,
  records: {}
}, oV = (e = aV, t) => {
  switch (t.type) {
    case Pw:
      return {
        ...e,
        isFetching: !0
      };
    case Lw:
      return {
        records: {
          ...t.payload
        },
        isFetching: !1
      };
    case Tw:
      return {
        ...e,
        isFetching: !1,
        records: {}
      };
    case Fw:
    case Bu:
    case di:
      return {
        ...e,
        isFetching: !1,
        records: {}
      };
    default:
      return e;
  }
};
fi((e) => e.groupedPersona.records, (e) => ({
  data: Object.values(e).map((t) => ({
    Category: t.questionLabel,
    Attribute: t.answerLabel,
    Index: t.index,
    "Share of Audience": t.shareOfAudience,
    "Share of Attribute": t.shareOfProperty,
    Population: t.population
  }))
}));
class O0 extends gt.Component {
  constructor(t) {
    super(t), et(this, "checkHasOverFlow", () => {
      this.span.scrollHeight > this.span.clientHeight + 2 ? this.setState({
        hasOverflow: !0
      }) : this.setState({
        hasOverflow: !1
      });
    }), this.state = {
      hasOverflow: !1
    };
  }
  componentDidMount() {
    this.checkHasOverFlow();
  }
  componentDidUpdate(t, n) {
    t.value !== this.props.value && this.checkHasOverFlow();
  }
  render() {
    const {
      value: t
    } = this.props, {
      hasOverflow: n
    } = this.state;
    return /* @__PURE__ */ m.jsx(gt.Fragment, { children: n ? /* @__PURE__ */ m.jsx("div", { className: "data-workflow-table__text-has-overflow", title: t, children: /* @__PURE__ */ m.jsx(
      "span",
      {
        className: "data-workflow-table__text-container",
        ref: (r) => this.span = r,
        children: t
      }
    ) }) : /* @__PURE__ */ m.jsx(
      "span",
      {
        className: "data-workflow-table__text-container",
        ref: (r) => this.span = r,
        children: t
      }
    ) });
  }
}
function sV({
  record: e,
  maxIndex: t
}) {
  return /* @__PURE__ */ m.jsxs(Qe.Row, { className: `data-workflow-table__row ${e.belowSample ? "table__sample-small" : ""}`, children: [
    /* @__PURE__ */ m.jsx(Qe.Cell, { width: 1, children: /* @__PURE__ */ m.jsx(O0, { value: e.questionLabel }) }),
    /* @__PURE__ */ m.jsx(Qe.Cell, { width: 1, children: /* @__PURE__ */ m.jsx(O0, { value: e.answerLabel }) }),
    e.belowSample ? /* @__PURE__ */ m.jsx(Qe.Cell, { textAlign: "center", colSpan: 4, width: 10, children: "Data source sample size is below the reportable threshold." }) : /* @__PURE__ */ m.jsxs(gt.Fragment, { children: [
      /* @__PURE__ */ m.jsx(Qe.Cell, { width: 7, children: /* @__PURE__ */ m.jsx("div", { className: "data-workflow-table__index-bar", style: {
        width: e.index / t * 100 + "%"
      }, children: Math.round(e.index) }) }),
      /* @__PURE__ */ m.jsx(Qe.Cell, { width: 1, style: {
        textAlign: "center"
      }, children: zm(e.shareOfAudience) }),
      /* @__PURE__ */ m.jsx(Qe.Cell, { width: 1, style: {
        textAlign: "center"
      }, children: zm(e.shareOfProperty) }),
      /* @__PURE__ */ m.jsx(Qe.Cell, { width: 1, style: {
        textAlign: "center"
      }, children: np(e.population) })
    ] })
  ] });
}
class lV extends R.Component {
  constructor(t) {
    super(t), et(this, "handleSortChange", (n) => () => Xg(n, this)), et(this, "sort", (n, r) => Kg(n, r, this)), this.state = {
      sortColumn: "index",
      sortDirection: "descending"
    };
  }
  render() {
    const {
      groupedPersonaRecords: t,
      theme: n,
      isFetching: r,
      filters: i
    } = this.props, {
      sortColumn: a,
      sortDirection: o
    } = this.state, {
      shareOfAttribute: s,
      shareOfAudience: l,
      index: c,
      population: d
    } = i;
    if (t !== void 0 && t[0]) {
      let p = 100;
      t && (p = Qr(t, "index"));
      const y = /* @__PURE__ */ m.jsx(Qe.Header, { className: "data-workflow-table__header", children: /* @__PURE__ */ m.jsxs(Qe.Row, { style: {
        paddingTop: "20px"
      }, children: [
        /* @__PURE__ */ m.jsx(Qe.HeaderCell, { width: 3, sorted: a === "questionLabel" ? o : null, onClick: this.handleSortChange("questionLabel"), children: "Category" }),
        /* @__PURE__ */ m.jsx(Qe.HeaderCell, { width: 3, sorted: a === "answerLabel" ? o : null, onClick: this.handleSortChange("answerLabel"), children: "Attribute" }),
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { width: 3, sorted: a === "index" ? o : null, onClick: this.handleSortChange("index"), children: [
          /* @__PURE__ */ m.jsx(sl, { children: "The index is a measure of the propensity of the Audience to possess an attribute, relative to the complete universe. It is expressed as a proportional likelihood, based to 100. For instance: the Audience has an index of 200 for the row where the attribute is Smoker. This would mean that the Audience is twice as likely to smoke as the population at large." }),
          "Index"
        ] }),
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { width: 1, style: {
          textAlign: "center",
          paddingRight: "9px"
        }, sorted: a === "shareOfAudience" ? o : null, onClick: this.handleSortChange("shareOfAudience"), children: [
          /* @__PURE__ */ m.jsx(sl, { children: "Within the defined Audience, what percentage have the attribute defined by each row. For instance: what percentage of my Audience are smokers?" }),
          "Share of",
          /* @__PURE__ */ m.jsx("br", {}),
          "Audience"
        ] }),
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { width: 1, style: {
          textAlign: "center",
          paddingRight: "9px"
        }, sorted: a === "shareOfProperty" ? o : null, onClick: this.handleSortChange("shareOfProperty"), children: [
          /* @__PURE__ */ m.jsx(sl, { children: "Within the total universe defined by the attribute of each row, what portion of that universe does this Audience represent. For instance: what percentage of smokers are within my defined Audience?" }),
          "Share of",
          /* @__PURE__ */ m.jsx("br", {}),
          "Attribute"
        ] }),
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { width: 1, style: {
          textAlign: "center",
          paddingRight: "9px"
        }, sorted: a === "population" ? o : null, onClick: this.handleSortChange("population"), children: [
          /* @__PURE__ */ m.jsx(sl, { children: "The population is the number of people within the defined Audience for whom the row Attribute is true. For instance: how many smokers are there within my Audience?" }),
          "Pop."
        ] })
      ] }) });
      let f = Object.values(t).sort(this.sort);
      if (s && parseFloat(s) > 0 && (f = f.filter(
        // $FlowFixMe
        (N) => N.shareOfProperty > parseFloat(s)
      )), l && parseFloat(l) > 0 && (f = f.filter(
        // $FlowFixMe
        (N) => N.shareOfAudience > parseFloat(l)
      )), c && parseFloat(c) > 0 && (f = f.filter((N) => N.index > parseFloat(c))), d && parseFloat(d) > 0 && (f = f.filter(
        // $FlowFixMe
        (N) => N.population > parseFloat(d)
      )), n && n.length) {
        let N = n.map(function(b) {
          return b.categoryLabel;
        });
        f = f.filter((b) => N.includes(b.categoryLabel));
      }
      return r ? /* @__PURE__ */ m.jsx(ga, {}) : /* @__PURE__ */ m.jsxs(Qe, { sortable: !0, stackable: !0, striped: !0, className: "grouped-persona-table", children: [
        y,
        /* @__PURE__ */ m.jsx(Qe.Body, { children: f.length && f.map((N, b) => /* @__PURE__ */ m.jsx(sV, { record: N, maxIndex: p }, b)) || /* @__PURE__ */ m.jsx(Qe.Row, { className: "data-workflow-table__row", children: /* @__PURE__ */ m.jsx(Qe.Cell, { colSpan: 6, className: "data-workflow-table__empty-table", children: "No results available." }) }) })
      ] });
    } else
      return /* @__PURE__ */ m.jsx("h3", { className: "data-workflow-table__no-results", children: "Select personas from the menu on the left to view data" });
  }
}
function cV({
  className: e,
  panes: t,
  switchTab: n,
  activeTab: r
}) {
  return /* @__PURE__ */ m.jsxs("div", { className: e, children: [
    /* @__PURE__ */ m.jsx("div", { className: "ui attached tabular menu", children: t.map((i, a) => /* @__PURE__ */ m.jsx(Ft, { as: "a", onClick: () => n(a), className: `${a === r ? "active" : ""} item`, children: i.menuItem }, a)) }),
    t.map((i, a) => /* @__PURE__ */ m.jsx("div", { className: `ui bottom attached segment ${a === r ? "active" : ""} tab scroll-box`, children: i.pane }, a))
  ] });
}
function uV({
  filters: e,
  theme: t
}) {
  const {
    index: n,
    population: r,
    shareOfAttribute: i,
    shareOfAudience: a
  } = e;
  return t.length || n || r || i || a ? /* @__PURE__ */ m.jsx("div", { children: "Modify the filters and/or reduce thresholds, to include more attributes." }) : "";
}
class dV extends R.Component {
  constructor(t) {
    super(t), et(this, "switchTab", (n) => {
      this.setState({
        activeTab: n
      });
    }), et(this, "clearForm", () => {
      this.props.resetDataPage(), this.switchTab(0);
    }), et(this, "toggleSidebar", () => {
      this.setState({
        ...this.state,
        showSidebar: !this.state.showSidebar
      });
    }), et(this, "handleCheckBoxAction", () => {
      this.props.loadGroupedPersona();
    }), this.state = {
      showSidebar: !1,
      activeTab: 0,
      selectedPersonas: []
    };
  }
  componentDidMount() {
    const {
      isDataPage: t,
      loadSuperSegments: n,
      loadGroupedPersona: r,
      featureAccess: i,
      loadProfileCategories: a,
      minShareOfAudience: o,
      setShareOfAudience: s,
      resetDataPage: l,
      quadrantPersonas: c,
      setSelectedPersonas: d
    } = this.props;
    c && d(c), t && l(), n(), r(), i(), a(), o && s(o);
  }
  render() {
    const {
      isFetching: t,
      superSegments: n,
      groupedPersonaRecords: r,
      themesFor: i,
      isDataPage: a = !1,
      hasAccess: o,
      theme: s,
      filters: l,
      tableTitle: c
    } = this.props, {
      showSidebar: d
    } = this.state;
    if (t || !n)
      return /* @__PURE__ */ m.jsx(ga, {});
    const p = (b) => /* @__PURE__ */ m.jsx(bM, { ...b }), y = [{
      menuItem: "Audience",
      pane: /* @__PURE__ */ m.jsx(a3, { expanded: !0, handleCheckBoxAction: this.handleCheckBoxAction })
    }, {
      menuItem: "Attributes",
      pane: /* @__PURE__ */ m.jsx(p, { theme: s, filters: l, themesFor: i, groupedPersonaRecords: r })
    }], f = () => /* @__PURE__ */ m.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ m.jsx($t, { className: "grouped-personas__icon", name: "bars", size: "large", onClick: this.toggleSidebar }),
      /* @__PURE__ */ m.jsx("h2", { className: "grouped-personas__sub-title", children: "Selection" }),
      a && /* @__PURE__ */ m.jsx(r3, { resetMethod: this.clearForm })
    ] }), N = (b) => /* @__PURE__ */ m.jsx(p1, { ...b });
    return /* @__PURE__ */ m.jsx("div", { children: o ? /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsxs("div", { className: "campaign-creator-page", children: [
      /* @__PURE__ */ m.jsxs("div", { className: "grouped-personas__row", children: [
        /* @__PURE__ */ m.jsx(f1, { open: d, title: /* @__PURE__ */ m.jsx(f, {}), body: /* @__PURE__ */ m.jsx(cV, { className: "tabs grouped-personas__tabs", panes: y, switchTab: this.switchTab, activeTab: this.state.activeTab }) }),
        /* @__PURE__ */ m.jsxs("div", { className: "grouped-personas__table audience-profiling--table-row__fixed-height", children: [
          /* @__PURE__ */ m.jsx("h2", { className: "audience-profiling__title", children: c }),
          /* @__PURE__ */ m.jsx(N, { theme: s, filters: l, themesFor: i, isDataPage: a }),
          /* @__PURE__ */ m.jsx(lV, { groupedPersonaRecords: r, filters: l, theme: s, isFetching: this.props.isFetchingGroupedPersona }),
          r && Object.keys(r).length > 0 && /* @__PURE__ */ m.jsx(uV, { filters: l, theme: s })
        ] })
      ] }),
      /* @__PURE__ */ m.jsx("div", { className: "grouped-personas__row", children: /* @__PURE__ */ m.jsx(n3, { showDownload: !1 }) })
    ] }) }) : "" });
  }
}
class fV extends R.Component {
  render() {
    const {
      themesFor: t,
      setMediaShareOfAudience: n,
      setShareOfAudience: r,
      theme: i,
      mediaTheme: a,
      profilingFilters: o,
      mediaFilters: s
    } = this.props;
    let l, c, d;
    return t === "media" ? (l = n, c = a, d = s) : (l = r, c = i, d = o), /* @__PURE__ */ m.jsx(dV, { ...this.props, theme: c, filters: d, setShareOfAudience: l });
  }
}
const pV = (e, t) => {
  let {
    workflowPermission: n
  } = e.options.permissions;
  return {
    isFetchingGroupedPersona: e.groupedPersona.isFetching,
    superSegments: e.superSegments.bySlug,
    groupedPersonaRecords: e.groupedPersona.records,
    hasAccess: e.featureAccess.byId && e.featureAccess.byId[n] && e.featureAccess.byId[n].hasAccess,
    theme: e.themeFilter.value,
    mediaTheme: e.mediaThemeFilter.value,
    profilingFilters: e.profilingFilters,
    mediaFilters: e.mediaFilters,
    audienceView: e.audienceView.view.value,
    isDataPage: e.options.isDataPage.value
  };
}, hV = (e) => Kt({
  loadGroupedPersona: Ss,
  loadSuperSegments: zo,
  featureAccess: ui,
  loadProfileCategories: V9,
  setShareOfAudience: yw,
  setMediaShareOfAudience: jw,
  resetDataPage: Hw,
  setSelectedPersonas: u1
}, e);
Mt(pV, hV)(fV);
function px({
  hideUnselectedPersonas: e,
  handleHideUnselectedPersonas: t
}) {
  const n = (i) => {
    i.stopPropagation(), t();
  }, r = oa((i) => i.audienceView.view.textPlural);
  return /* @__PURE__ */ m.jsx($t, { name: "eye", title: `Show/Hide selected ${r}`, className: `eye-icon ${e ? "active" : ""}`, onClick: n });
}
class mV extends R.Component {
  constructor() {
    super(...arguments), et(this, "state", {
      sortColumn: "score",
      sortDirection: "descending"
    }), et(this, "handleSortChange", (t) => () => Xg(t, this)), et(this, "sort", (t, n) => Kg(t, n, this));
  }
  render() {
    const {
      communityColours: t,
      selectedPersonas: n,
      handleSelectPersona: r,
      hideUnselectedPersonas: i,
      handleHideUnselectedPersonas: a,
      maxScore: o,
      dataForRows: s,
      isFetching: l,
      displaySegmentIds: c,
      pluralView: d
    } = this.props, {
      sortColumn: p,
      sortDirection: y
    } = this.state, f = /* @__PURE__ */ m.jsx("span", { className: "table__sample-small", children: "One or more data sources fall below the reportable threshold." });
    if (s && s.length) {
      const N = /* @__PURE__ */ m.jsx(Qe.Header, { className: "data-workflow-table__header", children: /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { className: "data-workflow-table__lead-cell", sorted: p === "segmentId" ? y : null, onClick: this.handleSortChange("segmentId"), children: [
          /* @__PURE__ */ m.jsx(px, { hideUnselectedPersonas: i, handleHideUnselectedPersonas: a }),
          "Persona"
        ] }),
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { sorted: p === "score" ? y : null, onClick: this.handleSortChange("score"), children: [
          /* @__PURE__ */ m.jsxs(sl, { children: [
            /* @__PURE__ */ m.jsxs("p", { children: [
              "The score is calculated using a proprietary method for combining the index and share values of individual attributes. It is an indicative measure only, but can be a useful means of identifying ",
              d,
              " based on a combination of attributes."
            ] }),
            /* @__PURE__ */ m.jsx("p", { children: "Complementary attributes from the same category are treated jointly rather than independently, and account is taken of the fact that different attributes may be drawn from different data sets." })
          ] }),
          "Combined Affinity Score"
        ] })
      ] }) });
      let b = s.sort(this.sort);
      return i === !0 && (b = b.filter((S) => n.find((_) => parseInt(_.id) === parseInt(S.segmentId)))), b = b.map((S, _) => /* @__PURE__ */ m.jsxs(Qe.Row, { className: "data-workflow-table__row", children: [
        /* @__PURE__ */ m.jsx(Qe.Cell, { className: "data-workflow-table__lead-cell", collapsing: !0, children: /* @__PURE__ */ m.jsx(dr, { className: "data-workflow-table__checkbox", checked: n.filter((E) => parseInt(E.id) === parseInt(S.segmentId)).length > 0, onClick: () => r(S.segmentId, S.segmentLabel), value: S.segmentId, label: `
                  ${c ? S.segmentId : ""} ${S.segmentLabel}
                ` }) }),
        /* @__PURE__ */ m.jsx(Qe.Cell, { children: S.belowSample ? f : /* @__PURE__ */ m.jsx("div", { className: "data-workflow-table__index-bar", style: {
          width: S.score / o * 100 + "%",
          backgroundColor: t[Math.floor(S.segmentId / 100) * 100]
        } }) })
      ] }, _)), l ? /* @__PURE__ */ m.jsx(ga, {}) : /* @__PURE__ */ m.jsx(R.Fragment, { children: /* @__PURE__ */ m.jsxs(Qe, { sortable: !0, stackable: !0, striped: !0, className: "grouped-persona-table", children: [
        N,
        /* @__PURE__ */ m.jsx(Qe.Body, { children: b })
      ] }) });
    } else
      return /* @__PURE__ */ m.jsx("h3", { className: "data-workflow-table__no-results", children: "Select answers to the questions on the left to view data" });
  }
}
const gV = (e, t) => ({
  displaySegmentIds: e.options.displaySegmentIds.value,
  pluralView: e.audienceView.view.textPlural
}), yV = Mt(gV, void 0)(mV);
class vV extends R.Component {
  render() {
    const {
      selectedCharacteristics: t,
      removeSelectedCharacteristic: n
    } = this.props;
    return !t || t.characteristics.length <= 0 ? "" : /* @__PURE__ */ m.jsx(u3, { children: t && t.characteristics.map((r, i) => /* @__PURE__ */ m.jsx(es, { handleClick: () => n(r), title: r.answerLabel }, i)) });
  }
}
const bV = (e, t) => ({
  selectedCharacteristics: e.selectedCharacteristics
}), wV = (e) => Kt({
  removeSelectedCharacteristic: e1
}, e), hx = Mt(bV, wV)(vV);
let xV = class extends R.Component {
  componentDidMount() {
    const {
      tagId: e,
      selectedCharacteristics: t,
      loadGrouped: n
    } = this.props;
    t && n(e);
  }
  componentDidUpdate(e) {
    const {
      tagId: t,
      selectedCharacteristics: n,
      loadGrouped: r
    } = this.props, {
      selectedCharacteristics: i
    } = e;
    n !== i && r(t);
  }
  render() {
    const {
      hideUnselectedPersonas: e,
      communityColours: t,
      handleHideUnselectedPersonas: n,
      groupedPersonaRecords: r,
      isFetching: i,
      selectedPersonas: a,
      handleSelectPersona: o,
      filters: s,
      theme: l,
      isDataPage: c
    } = this.props;
    let d = 100;
    r && r[0] && (d = Qr(r, "score"));
    const p = r ? Object.values(r) : [];
    return /* @__PURE__ */ m.jsxs(Bo.Pane, { children: [
      !c && /* @__PURE__ */ m.jsx(hx, {}),
      !c && /* @__PURE__ */ m.jsx(p1, { filters: s, theme: l }),
      /* @__PURE__ */ m.jsx(yV, { hideUnselectedPersonas: e, selectedPersonas: a, maxScore: d, handleHideUnselectedPersonas: n, dataForRows: p, communityColours: t, handleSelectPersona: o, isFetching: i })
    ] });
  }
};
const _V = (e, t) => ({
  isFetching: e.findPersonasGrouped.isFetching,
  groupedPersonaRecords: e.findPersonasGrouped.records,
  selectedCharacteristics: e.selectedCharacteristics,
  selectedPersonas: e.findPersonasSelected.records,
  filters: e.profilingFilters,
  theme: e.themeFilter.value
}), NV = (e) => Kt({
  loadGrouped: Y9
}, e), SV = Mt(_V, NV)(xV);
function EV({
  columnStyle: e,
  sortColumn: t,
  sortDirection: n,
  characteristic: r,
  handleSortChange: i,
  removeSelectedCharacteristic: a
}) {
  const o = t === r.answerId;
  return /* @__PURE__ */ m.jsx(Qe.HeaderCell, { className: "attribute-header", style: e, title: r.answerLabel, children: /* @__PURE__ */ m.jsxs("div", { className: "attribute-header__wrapper", children: [
    /* @__PURE__ */ m.jsxs("button", { className: "attribute-header__sort-button", onClick: i(r.answerId), children: [
      /* @__PURE__ */ m.jsx("div", { className: "attribute-header__sort-label", children: r.answerLabel }),
      o && /* @__PURE__ */ m.jsx($t, { className: "attribute-header__sort-arrow", name: n === "ascending" ? "caret up" : "caret down" })
    ] }),
    /* @__PURE__ */ m.jsx("button", { className: "attribute-header__close-button", onClick: () => a(r), children: /* @__PURE__ */ m.jsx($t, { name: "close" }) })
  ] }) });
}
class CV extends R.Component {
  constructor(t) {
    super(t), et(this, "getMaxValues", () => {
      const {
        unformattedPersonas: n
      } = this.props;
      return n.length <= 0 ? {} : {
        index: zd(n, "index"),
        population: zd(n, "population"),
        shareOfSegment: zd(n, "shareOfSegment"),
        shareOfProperty: zd(n, "shareOfProperty")
      };
    }), et(this, "formatDataForCharacteristic", (n) => {
      const {
        selectedMeasure: r
      } = this.props, i = n[r];
      switch (r) {
        case "index":
          return Math.round(i);
        case "population":
          return np(i);
        case "shareOfProperty":
        case "shareOfSegment":
          return zm(i);
        default:
          return i;
      }
    }), et(this, "barStyle", (n, r, i) => {
      const {
        selectedMeasure: a,
        communityColours: o
      } = this.props, s = o[n.segmentId] ? o[n.segmentId] : o[Math.floor(n.segmentId / 100) * 100];
      return {
        width: n.answers[r.answerId][a] / i[a] * 100 + "%",
        backgroundColor: s
      };
    }), et(this, "handleSortChange", (n) => () => Xg(n, this)), et(this, "sort", (n, r) => {
      const {
        sortColumn: i
      } = this.state, {
        selectedCharacteristics: a,
        selectedMeasure: o
      } = this.props;
      return a.characteristics.filter((s) => s.answerId === i).length > 0 ? f9(n, r, o, this) : Kg(n, r, this);
    }), this.state = {
      sortColumn: "segmentId",
      sortDirection: "ascending"
    };
  }
  componentDidUpdate(t, n) {
    this.state.sortColumn !== "segmentId" && this.props.selectedCharacteristics.characteristics.filter((r) => r.answerId === this.state.sortColumn).length <= 0 && this.setState({
      sortColumn: "segmentId",
      sortDirection: "ascending"
    });
  }
  render() {
    const {
      individualPersonaRecords: t,
      selectedCharacteristics: n,
      selectedPersonas: r,
      handleSelectPersona: i,
      selectedMeasure: a,
      hideUnselectedPersonas: o,
      handleHideUnselectedPersonas: s,
      isFetching: l,
      audienceView: c,
      superSegments: d,
      removeSelectedCharacteristic: p,
      displaySegmentIds: y
    } = this.props, f = this.getMaxValues(), {
      sortColumn: N,
      sortDirection: b
    } = this.state, S = /* @__PURE__ */ m.jsx("span", { className: "table__sample-small", children: "Below reportable threshold." }), _ = c.textSingular;
    if (n && n.characteristics.length) {
      let E = {};
      n.characteristics.length > 5 && (E = {
        width: "220px"
      });
      const k = /* @__PURE__ */ m.jsx(Qe.Header, { className: "data-workflow-table__header", children: /* @__PURE__ */ m.jsxs(Qe.Row, { children: [
        /* @__PURE__ */ m.jsxs(Qe.HeaderCell, { className: "data-workflow-table__fixed-column data-workflow-table__lead-cell", sorted: N === "segmentId" ? b : null, onClick: this.handleSortChange("segmentId"), children: [
          /* @__PURE__ */ m.jsx(px, { audienceView: c, hideUnselectedPersonas: o, handleHideUnselectedPersonas: s }),
          _
        ] }),
        n.characteristics.map((F, q) => /* @__PURE__ */ m.jsx(EV, { characteristic: F, sortColumn: N, sortDirection: b, columnStyle: E, handleSortChange: this.handleSortChange, removeSelectedCharacteristic: p }, q))
      ] }) });
      let M = t ? Object.values(t).sort(this.sort) : [];
      return M = M.map((F, q) => /* @__PURE__ */ m.jsxs(Qe.Row, { className: "data-workflow-table__row", children: [
        /* @__PURE__ */ m.jsx(Qe.Cell, { collapsing: !0, className: "data-workflow-table__fixed-column data-workflow-table__lead-cell", children: /* @__PURE__ */ m.jsx(dr, { className: "data-workflow-table__checkbox", checked: r.filter((j) => parseInt(j.id) === parseInt(F.segmentId)).length > 0, onClick: () => i(F.segmentId, F.segmentLabel), value: F.segmentId, label: `${y ? F.segmentId : ""} ${c.segmentType === "supersegments" ? m9(F.segmentId, d) : F.segmentLabel}` }) }),
        n.characteristics.map((j, x) => F.answers && F.answers[j.answerId] ? /* @__PURE__ */ m.jsx(Qe.Cell, { "data-point": F.answers[j.answerId][a], children: F.answers[j.answerId].belowSample ? S : /* @__PURE__ */ m.jsxs("div", { className: "data-workflow-table__index-wrapper", children: [
          /* @__PURE__ */ m.jsx("span", { className: "data-workflow-table__index-bar", style: this.barStyle(F, j, f) }),
          /* @__PURE__ */ m.jsx("span", { className: "data-workflow-table__index-data", children: this.formatDataForCharacteristic(F.answers[j.answerId]) })
        ] }) }, x) : "")
      ] }, q)), l ? /* @__PURE__ */ m.jsx(ga, {}) : /* @__PURE__ */ m.jsxs(Qe, { sortable: !0, fixed: !0, striped: !0, className: "grouped-persona-table", children: [
        k,
        /* @__PURE__ */ m.jsx(Qe.Body, { children: M })
      ] });
    } else
      return /* @__PURE__ */ m.jsx("h3", { className: "data-workflow-table__no-results", children: "Select answers to the questions on the left to view data" });
  }
}
const OV = (e, t) => ({
  superSegments: e.superSegments.bySlug,
  // TODO: Finish off changing to superSegments
  audienceView: e.audienceView.view,
  displaySegmentIds: e.options.displaySegmentIds.value
}), jV = Mt(OV, void 0)(CV);
let PV = class extends R.Component {
  constructor() {
    super(...arguments), et(this, "state", {
      cndIsDown: !1,
      cndStartX: 0,
      cndScrollLeft: 0
    }), et(this, "handleMouseDown", (e) => {
      this.setState({
        cndIsDown: !0
      }), e.currentTarget.classList.add("active"), this.setState({
        cndStartX: e.pageX - e.currentTarget.offsetLeft
      }), this.setState({
        cndScrollLeft: e.currentTarget.scrollLeft
      });
    }), et(this, "handleMouseExit", (e) => {
      this.setState({
        cndIsDown: !1
      }), e.currentTarget.classList.remove("active");
    }), et(this, "handleMouseMove", (e) => {
      if (!this.state.cndIsDown) return;
      e.preventDefault();
      const t = (e.pageX - e.currentTarget.offsetLeft - this.state.cndStartX) * 3;
      e.currentTarget.scrollLeft = this.state.cndScrollLeft - t;
    });
  }
  componentDidMount() {
    const {
      selectedCharacteristics: e,
      loadIndividual: t,
      tagId: n
    } = this.props;
    e && t(n);
  }
  componentDidUpdate(e) {
    const {
      tagId: t,
      selectedCharacteristics: n,
      loadIndividual: r
    } = this.props, {
      selectedCharacteristics: i
    } = e, a = n.characteristics ? n.characteristics.length : 0, o = i.characteristics ? i.characteristics.length : 0;
    a > o && r(t);
  }
  render() {
    const {
      hideUnselectedPersonas: e,
      handleSelectPersona: t,
      communityColours: n,
      handleHideUnselectedPersonas: r,
      individualPersonaRecords: i,
      isFetching: a,
      selectedPersonas: o,
      selectedMeasure: s,
      selectedCharacteristics: l,
      unformattedPersonas: c,
      filters: d,
      theme: p,
      isDataPage: y,
      audienceView: f,
      removeSelectedCharacteristic: N
    } = this.props;
    return /* @__PURE__ */ m.jsxs(Bo.Pane, { className: `collapsing ${y ? "individual-table--data-explorer" : ""}`, children: [
      !y && /* @__PURE__ */ m.jsx(hx, {}),
      !y && /* @__PURE__ */ m.jsx(p1, { filters: d, theme: p }),
      /* @__PURE__ */ m.jsx("div", { className: "table-container-overflow", onMouseDown: this.handleMouseDown, onMouseLeave: this.handleMouseExit, onMouseUp: this.handleMouseExit, onMouseMove: this.handleMouseMove, children: /* @__PURE__ */ m.jsx(jV, { audienceView: f, hideUnselectedPersonas: e, handleHideUnselectedPersonas: r, individualPersonaRecords: i, communityColours: n, handleSelectPersona: t, selectedCharacteristics: l, selectedPersonas: o, selectedMeasure: s, unformattedPersonas: c, isFetching: a, removeSelectedCharacteristic: N, isDataPage: y }) })
    ] });
  }
};
const LV = (e, t) => ({
  isFetching: e.findPersonasGrouped.isFetching,
  individualPersonaRecords: fx(e),
  unformattedPersonas: e.findPersonasIndividual.records,
  selectedCharacteristics: e.selectedCharacteristics,
  selectedPersonas: e.findPersonasSelected.records,
  selectedMeasure: e.selectedMeasure.measure,
  filters: e.profilingFilters,
  theme: e.themeFilter.value,
  audienceView: e.audienceView.view.value
}), TV = (e) => Kt({
  loadIndividual: A9,
  removeSelectedCharacteristic: e1
}, e), j0 = Mt(LV, TV)(PV), P0 = {
  isFetching: !1,
  vendors: []
}, FV = (e = P0, t) => {
  switch (t.type) {
    case D9:
      return {
        ...e,
        isFetching: !0
      };
    case R9:
      return {
        vendors: t.payload,
        isFetching: !1
      };
    case "RESET_PAGE_DATA":
      return P0;
    case M9:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    default:
      return e;
  }
};
function IV(e = {}, t) {
  switch (t.type) {
    case Y4:
      return {
        ...e,
        isFetching: !0
      };
    case K4:
      return {
        ...e,
        isFetching: !1,
        ...t.payload.acf
      };
    default:
      return e;
  }
}
const kV = null, DV = (e = kV, t) => {
  switch (t.type) {
    case ip:
      return t.payload;
    default:
      return e;
  }
}, RV = !1, MV = (e = RV, t) => {
  switch (t.type) {
    case Gw:
      return t.payload;
    case ip:
      return !1;
    default:
      return e;
  }
}, UV = {
  intro: !0,
  message: !0,
  deliver: !0
}, BV = (e = UV, t) => {
  switch (t.type) {
    case Rw:
      return {
        ...e,
        [t.id]: t.payload
      };
    default:
      return e;
  }
}, zV = nu({
  options: IV,
  digitalAudiencesVendors: FV,
  briefsFlow: DV,
  previewSelectedPersonas: MV,
  helperMessage: BV
}), qV = !1, VV = (e = qV, t) => {
  switch (t.type) {
    case di:
      return !0;
    case $w:
      return !1;
    default:
      return e;
  }
}, WV = {
  isFetching: !1,
  industryData: []
}, HV = (e = {}, t) => {
  switch (t.type) {
    case qw:
      return {
        ...e,
        isFetching: !0
      };
    case Vw:
      return {
        categories: t.payload,
        isFetching: !1
      };
    case "RESET_PAGE_DATA":
      return WV;
    case Ww:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    default:
      return e;
  }
}, $V = nu({
  collapseCheckboxes: VV,
  industryData: HV
}), GV = {
  value: !1,
  optionSet: !1
}, QV = (e = GV, t) => {
  switch (t.type) {
    case fD:
      return {
        ...e,
        optionSet: !0,
        value: t.payload
      };
    default:
      return e;
  }
}, YV = {
  optionSet: !1
}, KV = (e = YV, t) => {
  switch (t.type) {
    case hD:
      return {
        ...t.payload,
        optionSet: !0
      };
    default:
      return e;
  }
}, XV = {
  findPersonasGrouped: null,
  findPersonasIndividual: null,
  findPersonasCharacteristics: null,
  characteristics: null,
  audienceProfiling: null,
  optionSet: !1
}, ZV = (e = XV, t) => {
  switch (t.type) {
    case pD:
      return {
        ...t.payload,
        optionSet: !0
      };
    default:
      return e;
  }
}, JV = {
  value: !1,
  optionSet: !1
}, AV = (e = JV, t) => {
  switch (t.type) {
    case gD:
      return {
        ...e,
        optionSet: !0,
        value: t.payload
      };
    default:
      return e;
  }
}, eW = {
  value: "",
  optionSet: !1
}, tW = (e = eW, t) => {
  switch (t.type) {
    case yD:
      return {
        optionSet: !0,
        value: t.payload
      };
    default:
      return e;
  }
}, nW = nu({
  isDataPage: QV,
  permissions: KV,
  tagIds: ZV,
  displaySegmentIds: AV,
  dataMessage: tW
}), rW = {
  isFetching: !1,
  page: {}
}, iW = (e = rW, t) => {
  switch (t.type) {
    case aD:
      return {
        ...e,
        isFetching: !0
      };
    case oD:
      return {
        page: {
          ...t.payload
        },
        isFetching: !1
      };
    case sD:
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    default:
      return e;
  }
}, aW = {
  error: !1,
  fetched: !1,
  isFetching: !1
}, oW = (e = aW, t) => {
  switch (t.type) {
    case Kw:
      return {
        ...e,
        error: !1,
        fetched: !1,
        isFetching: !1
      };
    case Xw:
      return {
        ...e,
        error: !1,
        fetched: !1,
        isFetching: !0
      };
    case Zw:
      return {
        ...e,
        ...t.payload,
        fetched: !0,
        isFetching: !1,
        error: !1
      };
    case Jw:
      return {
        ...e,
        fetched: !0,
        isFetching: !1,
        error: !0
      };
    default:
      return e;
  }
}, L0 = {
  population: 0,
  resetPopulation: !1,
  shareOfAudience: 0,
  resetShareOfAudience: !1,
  shareOfAttribute: 0,
  resetShareOfAttribute: !1,
  index: 0,
  resetIndex: !1
}, sW = (e = L0, t) => {
  switch (t.type) {
    case mw:
      return {
        ...e,
        resetPopulation: !1,
        population: t.payload
      };
    case gw:
      return {
        ...e,
        resetPopulation: !0,
        population: 0
      };
    case pw:
      return {
        ...e,
        resetShareOfAudience: !1,
        shareOfAudience: t.payload
      };
    case cw:
      return {
        ...e,
        resetShareOfAudience: !0,
        shareOfAudience: 0
      };
    case fw:
      return {
        ...e,
        resetShareOfAttribute: !1,
        shareOfAttribute: t.payload
      };
    case lw:
      return {
        ...e,
        resetShareOfAttribute: !0,
        shareOfAttribute: 0
      };
    case dw:
      return {
        ...e,
        resetIndex: !1,
        index: t.payload
      };
    case di:
      return L0;
    case sw:
      return {
        ...e,
        resetIndex: !0,
        index: 0
      };
    default:
      return e;
  }
}, lW = {
  characteristics: []
}, cW = (e = lW, t) => {
  switch (t.type) {
    case X4:
      return {
        ...e,
        characteristics: [...e.characteristics, t.payload]
      };
    case Z4:
      let n = e.characteristics;
      return n = n.filter((r) => r.answerId !== t.payload.answerId), {
        ...e,
        characteristics: [...n]
      };
    case "RESET_PAGE_DATA":
      return {
        ...e,
        characteristics: []
      };
    default:
      return e;
  }
}, T0 = {
  measure: "index"
}, uW = (e = T0, t) => {
  switch (t.type) {
    case J4:
      return {
        ...e,
        measure: t.payload
      };
    case "RESET_PAGE_DATA":
      return T0;
    default:
      return e;
  }
}, F0 = {
  personas: [],
  isHidden: !1
}, dW = (e = F0, t) => {
  switch (t.type) {
    case o1:
      return {
        ...e,
        personas: [...e.personas, t.payload]
      };
    case l1:
      return {
        // add
        ...e,
        // $FlowFixMe
        personas: [...e.personas.slice(0, t.index), ...t.payload, ...e.personas.slice(t.index + 1)]
      };
    case s1:
      let n = e.personas;
      return n = n.filter((r) => r.id !== t.payload.id), {
        ...e,
        personas: [...n]
      };
    case c1:
      return {
        ...e,
        personas: [...t.payload]
      };
    case di:
    case Bu:
    case rp:
      return {
        ...e,
        ...F0
      };
    case Yw:
      return {
        ...e,
        isHidden: t.payload
      };
    default:
      return e;
  }
}, fW = {
  value: [],
  reset: !1,
  isFetching: !1,
  isModified: !1
}, pW = (e = fW, t) => {
  switch (t.type) {
    case hw:
      return {
        ...e,
        reset: !1,
        value: t.payload,
        isFetching: !1,
        isModified: !0
      };
    case n1:
      return {
        ...e,
        reset: !1,
        value: t.payload ? t.payload.filter((r) => r.isDefault) : [],
        isFetching: !1
      };
    case uw:
      var n = e.value.map((r) => r.categoryId).indexOf(t.payload);
      return {
        ...e,
        value: [...e.value.slice(0, n), ...e.value.slice(n + 1)],
        isFetching: !1
      };
    case t1:
      return {
        ...e,
        isFetching: !0
      };
    case r1:
      return {
        ...e,
        isFetching: !1
      };
    case di:
      return {
        ...e,
        value: t.payload
      };
    default:
      return e;
  }
}, hW = {
  isFetching: !1,
  results: [],
  error: {}
}, mW = (e = hW, t) => {
  switch (t.type) {
    case Ek:
      return {
        ...e,
        isFetching: !0
      };
    case Ck:
      return {
        isFetching: !1,
        results: t.payload
      };
    case Ok:
      return {
        isFetching: !1,
        error: t.accessInfo
      };
    default:
      return e;
  }
}, gW = {
  isFetching: !1,
  byId: {},
  order: [],
  error: void 0
}, yW = (e = gW, t) => {
  switch (t.type) {
    case "FEATURE_ACCESS_FAILURE":
      return {
        ...e,
        isFetching: !1,
        error: t.error
      };
    case "FEATURE_ACCESS_REQUEST":
      return {
        ...e,
        isFetching: !0,
        error: void 0
      };
    case "FEATURE_ACCESS_SUCCESS":
      return {
        ...e,
        isFetching: !1,
        ...t.payload,
        error: void 0
      };
    default:
      return e;
  }
}, mx = 1, vW = {
  isFetching: !1,
  results: [],
  error: null,
  currentUniverse: mx
}, bW = (e = vW, t) => {
  switch (t.type) {
    case vk:
      return {
        ...e,
        isFetching: !0
      };
    case bk:
      return {
        ...e,
        isFetching: !1,
        results: t.payload
        // TODO: Determine if this line can go
        // currentUniverse: state.currentUniverse
      };
    case wk:
    case Pk:
      return {
        ...e,
        isFetching: !1,
        error: t.payload
      };
    case jk:
      return {
        ...e,
        currentUniverse: t.payload
      };
    case di:
      return {
        ...e,
        currentUniverse: mx
      };
    default:
      return e;
  }
}, wW = {
  isFetching: !1,
  categories: [],
  mediaCategories: []
}, xW = (e = wW, t) => {
  switch (t.type) {
    case w9:
      return {
        ...e,
        isFetching: !0
      };
    case x9:
      return {
        ...e,
        isFetching: !1
      };
    case H4:
      return {
        ...e,
        isFetching: !1,
        categories: t.payload,
        mediaCategories: t.payload && t.payload.filter((n) => n.categoryLabel.match(/media|app/i))
      };
    default:
      return e;
  }
}, I0 = {
  isFetching: !1,
  records: {},
  error: void 0
}, _W = (e = I0, t) => {
  switch (t.type) {
    case A4:
      return {
        ...e,
        isFetching: !0
      };
    case ew:
      return {
        records: {
          ...t.payload
        },
        isFetching: !1,
        error: void 0
      };
    case tw:
      return {
        ...e,
        isFetching: !1,
        records: {},
        error: t.error
      };
    case nw:
      return {
        ...e,
        isFetching: !1,
        error: void 0,
        records: {}
      };
    case di:
      return I0;
    default:
      return e;
  }
}, k0 = {
  records: []
}, NW = (e = k0, t) => {
  switch (t.type) {
    case o1:
      return {
        // add
        ...e,
        // $FlowFixMe
        records: [...e.records, t.payload]
      };
    case l1:
      return {
        // add
        ...e,
        records: [
          // $FlowFixMe
          ...e.records.slice(0, t.index),
          // $FlowFixMe
          ...t.payload,
          // $FlowFixMe
          ...e.records.slice(t.index + 1)
        ]
      };
    case c1:
      return {
        ...e,
        // $FlowFixMe
        records: [...t.payload]
      };
    case s1:
      return {
        ...e,
        records: e.records.filter(
          // $FlowFixMe
          (n) => n.id !== t.payload.id
        )
      };
    case di:
      return k0;
    default:
      return e;
  }
}, SW = {
  value: [],
  reset: !1,
  isFetching: !1,
  isModified: !1
}, EW = (e = SW, t) => {
  switch (t.type) {
    case Ow:
      return {
        ...e,
        reset: !1,
        value: t.payload,
        isFetching: !1,
        isModified: !0
      };
    case n1:
      return {
        ...e,
        reset: !1,
        value: t.payload && t.payload.filter((r) => r.categoryLabel.match(/media|app/i)),
        isFetching: !1
      };
    case Sw:
      var n = e.value.map((r) => r.categoryId).indexOf(t.payload);
      return {
        ...e,
        // reset: true,
        value: [...e.value.slice(0, n), ...e.value.slice(n + 1)],
        isFetching: !1
      };
    case t1:
      return {
        ...e,
        isFetching: !0
      };
    case r1:
      return {
        ...e,
        isFetching: !1
      };
    default:
      return e;
  }
}, CW = {
  population: 0,
  resetPopulation: !1,
  shareOfAudience: 0,
  resetShareOfAudience: !1,
  shareOfAttribute: 0,
  resetShareOfAttribute: !1,
  index: 0,
  resetIndex: !1
}, OW = (e = CW, t) => {
  switch (t.type) {
    case Cw:
      return {
        ...e,
        resetPopulation: !1,
        population: t.payload
      };
    case xw:
      return {
        ...e,
        resetPopulation: !0,
        population: 0
      };
    case bw:
      return {
        ...e,
        resetShareOfAudience: !1,
        shareOfAudience: t.payload
      };
    case Nw:
      return {
        ...e,
        resetShareOfAudience: !0,
        shareOfAudience: 0
      };
    case vw:
      return {
        ...e,
        resetShareOfAttribute: !1,
        shareOfAttribute: t.payload
      };
    case _w:
      return {
        ...e,
        resetShareOfAttribute: !0,
        shareOfAttribute: 0
      };
    case Ew:
      return {
        ...e,
        resetIndex: !1,
        index: t.payload
      };
    case ww:
      return {
        ...e,
        resetIndex: !0,
        index: 0
      };
    default:
      return e;
  }
}, jW = {
  options: [],
  view: {},
  optionSet: !1
}, PW = (e = jW, t) => {
  switch (t.type) {
    case mD:
      return {
        ...e,
        options: t.payload,
        view: t.payload[0],
        optionSet: !0
      };
    case Bu:
      return {
        ...e,
        view: t.payload
      };
    case di:
    case tD:
      return {
        ...e,
        view: e.options[0]
      };
    default:
      return e;
  }
}, LW = [{
  percentage: 0,
  id: 1,
  name: "Stream P1"
}, {
  percentage: 0,
  id: 2,
  name: "Stream P2"
}, {
  percentage: 0,
  id: 3,
  name: "Stream P3"
}, {
  percentage: 0,
  id: 4,
  name: "Stream P4"
}], TW = {
  isFetching: !1,
  current: null,
  quadrants: LW,
  audienceTotal: 0,
  audienceSize: 0,
  threshold: "",
  error: {}
}, FW = (e = TW, t) => {
  switch (t.type) {
    case Ik:
      return {
        ...e,
        current: t.payload
      };
    case Dk:
      return {
        ...e,
        isFetching: !0
      };
    case Rk:
      return {
        ...e,
        ...t.payload,
        isFetching: !1
      };
    case Mk:
      return {
        isFetching: !1,
        error: t.payload
      };
    default:
      return e;
  }
}, D0 = {
  fileName: "",
  dirtyData: [],
  duplicatePersonas: [],
  personasAdded: [],
  emptyData: []
}, IW = (e = D0, t) => {
  switch (t.type) {
    case Mw:
      return {
        ...e,
        ...t.payload
      };
    case di:
    case Bu:
    case rp:
      return D0;
    default:
      return e;
  }
};
nu({
  campaignCreator: zV,
  dataPages: $V,
  characteristics: eR,
  superSegments: OM,
  digitalAudiences: iW,
  contact: oW,
  groupedPersona: oV,
  profilingFilters: sW,
  selectedCharacteristics: cW,
  selectedMeasure: uW,
  selectedPersonas: dW,
  themeFilter: pW,
  population: mW,
  featureAccess: yW,
  universes: bW,
  categories: xW,
  findPersonasGrouped: _W,
  findPersonasSelected: NW,
  findPersonasIndividual: iV,
  mediaThemeFilter: EW,
  mediaFilters: OW,
  audienceView: PW,
  communities: mz,
  options: nW,
  messageStreams: fz,
  quadrants: FW,
  mapping: rV,
  fileUploadMeta: IW
});
class Oi extends R.Component {
  render() {
    const {
      name: t,
      colour: n = "cyan"
    } = this.props;
    let r;
    switch (n) {
      case "cyan":
        r = "#00aec7";
        break;
      case "deepCyan":
        r = "#0f849e";
        break;
      case "teal":
        r = "#00b398";
        break;
      case "blue":
        r = "#004b87";
        break;
      case "white":
        r = "#ffffff";
        break;
      case "lightCyan":
        r = "#7FD1E3";
        break;
      case "grey":
        r = "#646F80";
        break;
      default:
        r = "#00aec7";
    }
    switch (t) {
      case "gear":
        return /* @__PURE__ */ me.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ me.jsx("path", { d: "M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z", fill: r }) });
      case "logout":
        return /* @__PURE__ */ me.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ me.jsx("path", { d: "M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z", fill: r }) });
      case "nineDot":
        return /* @__PURE__ */ me.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "38", height: "38", viewBox: "0 0 38 38", children: /* @__PURE__ */ me.jsxs("g", { fill: "none", fillRule: "evenodd", children: [
          /* @__PURE__ */ me.jsx("rect", { width: "38", height: "38", fill: "#646F80", rx: "2" }),
          /* @__PURE__ */ me.jsx("path", { stroke: "#FFF", strokeLinecap: "square", strokeWidth: "3", d: "M12 1.49642875L12 36.5M26 .496621776L26 37.5M36.5033332 26L.496528267 26M36.5034717 13L.496666815 13", fill: r })
        ] }) });
      case "userIcon":
        return /* @__PURE__ */ me.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", children: /* @__PURE__ */ me.jsx("path", { d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z", fill: r }) });
      case "dropDownArrow":
        return /* @__PURE__ */ me.jsx("svg", { className: this.props.className, xmlns: "http://www.w4.org/2000/svg", width: "16", height: "8", viewBox: "0 0 16 8", children: /* @__PURE__ */ me.jsx("polygon", { fill: "#D0D5DC", fillRule: "evenodd", points: "1565 59 1573 67 1557 67", transform: "matrix(-1 0 0 1 1573 -59)" }) });
      default:
        return /* @__PURE__ */ me.jsxs("strong", { children: [
          "Error: no case in InlineSVG for ",
          t
        ] });
    }
  }
}
var kW = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [r, i] = n.split(/ ?: ?/).map((a, o) => o === 0 ? a.replace(/\s+/g, "") : a.trim());
  if (r && i) {
    const a = r.replace(/(\w)-(\w)/g, (s, l, c) => `${l}${c.toUpperCase()}`);
    let o = i.trim();
    Number.isNaN(Number(i)) || (o = Number(i)), t[r.startsWith("-") ? r : a] = o;
  }
  return t;
}, {});
function DW(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var RW = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], R0 = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function MW(e, t) {
  var a;
  const { key: n, level: r, ...i } = t;
  switch (e.nodeType) {
    case 1:
      return R.createElement(
        BW(e.nodeName),
        UW(e, n),
        M0(e.childNodes, r, i)
      );
    case 3: {
      const o = ((a = e.nodeValue) == null ? void 0 : a.toString()) ?? "";
      if (!i.allowWhiteSpaces && /^\s+$/.test(o) && !/[\u00A0\u202F]/.test(o))
        return null;
      if (!e.parentNode)
        return o;
      const s = e.parentNode.nodeName.toLowerCase();
      return RW.includes(s) ? (/\S/.test(o) && console.warn(
        `A textNode is not allowed inside '${s}'. Your text "${o}" will be ignored`
      ), null) : o;
    }
    case 8:
      return null;
    case 11:
      return M0(e.childNodes, r, t);
    /* c8 ignore next 3 */
    default:
      return null;
  }
}
function UW(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const r = e.getAttribute("class");
    r && (n.className = r), [...e.attributes].forEach((i) => {
      switch (i.name) {
        // this is manually handled above, so break;
        case "class":
          break;
        case "style":
          n[i.name] = kW(i.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[R0[i.name] || i.name] = !0;
          break;
        default:
          n[R0[i.name] || i.name] = i.value;
      }
    });
  }
  return n;
}
function M0(e, t, n) {
  const r = [...e].map(
    (i, a) => Ff(i, {
      ...n,
      index: a,
      level: t + 1
    })
  ).filter(Boolean);
  return r.length ? r : null;
}
function BW(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function gx(e, t = {}) {
  return typeof e == "string" ? zW(e, t) : e instanceof Node ? Ff(e, t) : null;
}
function Ff(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: r = 0, level: i = 0, randomKey: a } = t;
  let o = e, s = `${i}-${r}`;
  const l = [];
  return a && i === 0 && (s = `${DW()}-${s}`), Array.isArray(n) && n.forEach((c) => {
    c.condition(o, s, i) && (typeof c.pre == "function" && (o = c.pre(o, s, i), o instanceof Node || (o = e, process.env.NODE_ENV !== "production" && console.warn(
      "The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)"
    ))), typeof c.post == "function" && l.push(c.post(o, s, i)));
  }), l.length ? l : MW(o, { key: s, level: i, ...t });
}
function zW(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: r = !1,
    selector: i = "body > *",
    type: a = "text/html"
  } = t;
  try {
    const s = new DOMParser().parseFromString(e, a);
    if (n) {
      const { childNodes: c } = s.body;
      return r ? c : [...c].map((d) => Ff(d, t));
    }
    const l = s.querySelector(i) || s.body.childNodes[0];
    if (!(l instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? l : Ff(l, t);
  } catch (o) {
    process.env.NODE_ENV !== "production" && console.error(o);
  }
  return null;
}
var qW = Object.defineProperty, VW = (e, t, n) => t in e ? qW(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, tf = (e, t, n) => VW(e, typeof t != "symbol" ? t + "" : t, n), U0 = "react-inlinesvg", B0 = 10, un = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function WW(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function gf() {
  var e;
  return !!(typeof window < "u" && ((e = window.document) != null && e.createElement));
}
function HW() {
  return YW() && typeof window < "u" && window !== null;
}
function $W(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
function GW(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", r = `${t}${t.toUpperCase()}1234567890`;
  let i = "";
  for (let a = 0; a < e; a++)
    i += WW(r);
  return i;
}
async function yx(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [i] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((a) => i.includes(a)))
    throw new Error(`Content type isn't valid: ${i}`);
  return n.text();
}
function QW(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function YW() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
var KW = class {
  constructor() {
    tf(this, "cacheApi"), tf(this, "cacheStore"), tf(this, "subscribers", []), tf(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = U0, t = !1;
    gf() && (e = window.REACT_INLINESVG_CACHE_NAME ?? U0, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n;
    }).catch((n) => {
      console.error(`Failed to open cache: ${n.message}`);
    }).finally(() => {
      this.isReady = !0, this.subscribers.forEach((n) => n());
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === un.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === un.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: un.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: un.LOADING });
      try {
        const r = await yx(e, t);
        this.cacheStore.set(e, { content: r, status: un.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: un.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var i, a, o;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === un.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === un.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: un.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: un.LOADING });
    const r = await ((i = this.cacheApi) == null ? void 0 : i.match(e));
    if (r) {
      const s = await r.text();
      this.cacheStore.set(e, { content: s, status: un.LOADED });
      return;
    }
    try {
      await ((a = this.cacheApi) == null ? void 0 : a.add(new Request(e, t)));
      const s = await ((o = this.cacheApi) == null ? void 0 : o.match(e)), l = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: l, status: un.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: un.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var r;
    let n = 0;
    for (; ((r = this.cacheStore.get(e)) == null ? void 0 : r.status) === un.LOADING && n < B0; )
      await QW(0.1), n += 1;
    n >= B0 && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function z0(e) {
  const t = gr(void 0);
  return gn(() => {
    t.current = e;
  }), t.current;
}
function XW(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: i,
    hash: a,
    preProcessor: o,
    title: s,
    uniquifyIDs: l = !1
  } = e;
  try {
    const c = ZW(n, o), d = gx(c, { nodeOnly: !0 });
    if (!d || !(d instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const p = vx(d, { baseURL: t, hash: a, uniquifyIDs: l });
    if (r) {
      const y = p.querySelector("desc");
      y != null && y.parentNode && y.parentNode.removeChild(y);
      const f = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      f.innerHTML = r, p.prepend(f);
    }
    if (typeof s < "u") {
      const y = p.querySelector("title");
      if (y != null && y.parentNode && y.parentNode.removeChild(y), s) {
        const f = document.createElementNS("http://www.w3.org/2000/svg", "title");
        f.innerHTML = s, p.prepend(f);
      }
    }
    return p;
  } catch (c) {
    return i(c);
  }
}
function ZW(e, t) {
  return t ? t(e) : e;
}
function vx(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: i } = t, a = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], o = ["href", "xlink:href"], s = (l, c) => o.includes(l) && (c ? !c.includes("#") : !1);
  return i && [...e.children].forEach((l) => {
    var c;
    if ((c = l.attributes) != null && c.length) {
      const d = Object.values(l.attributes).map((p) => {
        const y = p, f = /url\((.*?)\)/.exec(p.value);
        return f != null && f[1] && (y.value = p.value.replace(f[0], `url(${n}${f[1]}__${r})`)), y;
      });
      a.forEach((p) => {
        const y = d.find((f) => f.name === p);
        y && !s(p, y.value) && (y.value = `${y.value}__${r}`);
      });
    }
    return l.children.length ? vx(l, t) : l;
  }), e;
}
var dl;
function JW(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: i,
    innerRef: a,
    loader: o = null,
    onError: s,
    onLoad: l,
    src: c,
    title: d,
    uniqueHash: p
  } = e, [y, f] = og(
    ($, ae) => ({
      ...$,
      ...ae
    }),
    {
      content: "",
      element: null,
      isCached: t && dl.isCached(e.src),
      status: un.IDLE
    }
  ), { content: N, element: b, isCached: S, status: _ } = y, E = z0(e), k = z0(y), M = gr(p ?? GW(8)), F = gr(!1), q = gr(!1), j = Ln(
    ($) => {
      F.current && (f({
        status: $.message === "Browser does not support SVG" ? un.UNSUPPORTED : un.FAILED
      }), s == null || s($));
    },
    [s]
  ), x = Ln(($, ae = !1) => {
    F.current && f({
      content: $,
      isCached: ae,
      status: un.LOADED
    });
  }, []), C = Ln(async () => {
    const $ = await yx(c, i);
    x($);
  }, [i, x, c]), D = Ln(() => {
    try {
      const $ = XW({ ...e, handleError: j, hash: M.current, content: N }), ae = gx($);
      if (!ae || !X0(ae))
        throw new Error("Could not convert the src to a React element");
      f({
        element: ae,
        status: un.READY
      });
    } catch ($) {
      j(new Error($.message));
    }
  }, [N, j, e]), P = Ln(async () => {
    const $ = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let ae;
    if ($ ? ae = $[1] ? window.atob($[2]) : decodeURIComponent($[2]) : c.includes("<svg") && (ae = c), ae) {
      x(ae);
      return;
    }
    try {
      if (t) {
        const ce = await dl.get(c, i);
        x(ce, !0);
      } else
        await C();
    } catch (ce) {
      j(ce);
    }
  }, [t, C, i, j, x, c]), L = Ln(async () => {
    F.current && f({
      content: "",
      element: null,
      isCached: !1,
      status: un.LOADING
    });
  }, []);
  gn(
    () => {
      if (F.current = !0, !gf() || q.current)
        return () => {
        };
      try {
        if (_ === un.IDLE) {
          if (!HW())
            throw new Error("Browser does not support SVG");
          if (!c)
            throw new Error("Missing src");
          L();
        }
      } catch ($) {
        j($);
      }
      return q.current = !0, () => {
        F.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), gn(() => {
    if (gf() && E)
      if (E.src !== c) {
        if (!c) {
          j(new Error("Missing src"));
          return;
        }
        L();
      } else (E.title !== d || E.description !== r) && D();
  }, [r, D, j, L, E, c, d]), gn(() => {
    k && (k.status !== un.LOADING && _ === un.LOADING && P(), k.status !== un.LOADED && _ === un.LOADED && D(), k.status !== un.READY && _ === un.READY && (l == null || l(c, S)));
  }, [P, D, S, l, k, c, _]);
  const H = $W(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return gf() ? b ? ag(b, {
    ref: a,
    ...H
  }) : [un.UNSUPPORTED, un.FAILED].includes(_) ? n : o : o;
}
function AW(e) {
  dl || (dl = new KW());
  const { loader: t } = e, n = gr(!1), [r, i] = oi(dl.isReady);
  return gn(() => {
    n.current || (dl.onReady(() => {
      i(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ gt.createElement(JW, { ...e }) : t;
}
class bx extends R.Component {
  render() {
    const {
      src: t,
      colour: n,
      alt: r,
      title: i
    } = this.props;
    if (!t)
      return null;
    switch (t.split(".").pop()) {
      case "svg":
        return /* @__PURE__ */ me.jsx("span", { style: {
          fill: n,
          stroke: n
        }, children: /* @__PURE__ */ me.jsx(AW, { src: t.replace(/%20/gi, "+"), "aria-label": r }) });
      case "png":
      case "jpg":
      case "jpeg":
        return /* @__PURE__ */ me.jsx("img", { src: t, alt: r, title: i });
      default:
        return null;
    }
  }
}
class eH extends gt.Component {
  constructor(n) {
    super(n);
    Wn(this, "onNineDotClick", () => {
      this.setState({
        nineDotMouseOut: !1
      }), this.state.nineDotMouseOut === !1 && this.setState({
        nineDotMenuOpen: !0
      });
    });
    Wn(this, "onNineDotMouseOver", () => {
      this.setState({
        nineDotMouseOut: !1
      });
    });
    Wn(this, "onNineDotMouseLeave", () => {
      this.setState({
        nineDotMouseOut: !0
      }), setTimeout((function() {
        this.state.nineDotMouseOut === !0 && this.setState({
          nineDotMenuOpen: !1
        });
      }).bind(this), 300);
    });
    Wn(this, "getCookie", (n) => {
      var r = "; " + document.cookie, i = r.split("; " + n + "=");
      if (i.length === 2) return i.pop().split(";").shift();
    });
    Wn(this, "switchToClick", (n, r, i) => {
      const {
        switchTo: a
      } = this.props;
      a(n, r, i).then((o) => window.location.replace("/"));
    });
    this.state = {
      nineDotMenuOpen: !1,
      nineDotMouseOut: !0
    };
  }
  render() {
    const {
      products: n = []
    } = this.props;
    var r = this.getCookie("switchFromToken"), i = this.getCookie("switchFromEmail");
    return /* @__PURE__ */ me.jsxs("div", { className: "nine-dot", children: [
      /* @__PURE__ */ me.jsxs("a", { className: "nine-dot__icon", onClick: this.onNineDotClick, onFocus: this.onNineDotClick, onMouseOut: this.onNineDotMouseLeave, onMouseOver: this.onNineDotMouseOver, onBlur: this.onNineDotMouseLeave, children: [
        /* @__PURE__ */ me.jsx(Oi, { name: "nineDot" }),
        /* @__PURE__ */ me.jsx(Oi, { name: "dropDownArrow", className: `dropdown-arrow ${this.state.nineDotMenuOpen ? "dropdown-arrow--open" : ""}` })
      ] }),
      /* @__PURE__ */ me.jsx("div", { className: `nine-dot__menu ${this.state.nineDotMenuOpen ? "nine-dot__menu--open" : ""}`, onFocus: this.onNineDotClick, onMouseOut: this.onNineDotMouseLeave, onMouseOver: this.onNineDotMouseOver, onBlur: this.onNineDotMouseLeave, children: /* @__PURE__ */ me.jsx(il, { columns: 3, children: /* @__PURE__ */ me.jsxs(il.Row, { children: [
        n.map((a) => {
          let o = "nine-dot__item";
          return a.hasAccess || (o += " nine-dot__item--disabled"), /* @__PURE__ */ me.jsx(il.Column, { children: /* @__PURE__ */ me.jsxs("a", { className: o, href: a.url, rel: "noopener noreferrer", target: "_blank", children: [
            /* @__PURE__ */ me.jsx("div", { className: "nine-dot-menu__icon", children: /* @__PURE__ */ me.jsx(bx, { colour: "#00a3c7", src: a.iconLogoLocation, alt: a.name }) }),
            a.name
          ] }) }, a.id);
        }),
        r && // TODO: Fix this
        /* eslint-disable eqeqeq */
        // $FlowFixMe
        r != 0 && i && // eslint-disable-next-line eqeqeq
        // $FlowFixMe
        i != 0 && /* eslint-enable eqeqeq */
        /* @__PURE__ */ me.jsx(il.Column, { children: /* @__PURE__ */ me.jsx("button", { className: "switch-to back", onClick: () => this.switchToClick(i, i, r), children: "Switch Back" }) })
      ] }) }) })
    ] });
  }
}
const q0 = (e, t = "en-US", n = "USD", r = 2) => isNaN(e) ? e : e.toLocaleString(t, {
  style: "currency",
  currency: n,
  minimumFractionDigits: r
});
class If extends R.Component {
  render() {
    const {
      cartItems: t,
      cartIcon: n,
      displayForMobile: r
    } = this.props;
    let i = 0;
    t.forEach(function(o) {
      o.price === void 0 ? i += 999 : i += o.price;
    });
    const a = {
      padding: "0 20px",
      textAlign: "right",
      background: "transparent"
    };
    return /* @__PURE__ */ me.jsxs(Ni.Item, { className: `online-store__cart-header-wrapper ${r ? "mobile" : ""}`, children: [
      /* @__PURE__ */ me.jsx("p", { className: "mobile-cart-header", children: "Cart Items" }),
      /* @__PURE__ */ me.jsxs("div", { className: "online-store__cart-header", children: [
        /* @__PURE__ */ me.jsx(
          J0,
          {
            src: n,
            as: wn,
            to: "/checkout",
            className: "online-store__cart-header-icon am_shopping_cart",
            onClick: this.onNavigate
          }
        ),
        /* @__PURE__ */ me.jsx("span", { className: "online-store__cart-header-items-count", children: t ? t.length : 0 }),
        /* @__PURE__ */ me.jsx("div", { className: "online-store__cart-header-items", children: /* @__PURE__ */ me.jsxs("div", { className: "online-store__cart-header-items-inner", children: [
          t && /* @__PURE__ */ me.jsx("div", { className: "online-store__cart-header-items-inner-list", children: t && t.map((o, s) => /* @__PURE__ */ me.jsxs("div", { className: "row", children: [
            /* @__PURE__ */ me.jsx("div", { className: "product-name-col", children: /* @__PURE__ */ me.jsx(wn, { to: o && "/product/" + o.slug, children: o && o.name }) }),
            /* @__PURE__ */ me.jsx("div", { className: "price-col", children: o && o.price ? q0(o.price) : "$999.00" }),
            /* @__PURE__ */ me.jsx("div", { className: "remove-item", children: /* @__PURE__ */ me.jsx(Ah, { onClick: (l) => (
              // $FlowFixMe
              this.props.removeFromCart(l, o)
            ), children: /* @__PURE__ */ me.jsx("i", { className: "minus circle icon" }) }) })
          ] }, s)) }),
          /* @__PURE__ */ me.jsxs("div", { className: "cart-total-price", style: a, children: [
            "TOTAL incl GST",
            " ",
            /* @__PURE__ */ me.jsx("span", { className: "bold", children: q0(i) })
          ] }),
          t && t.length !== 0 && /* @__PURE__ */ me.jsx("div", { className: "cart-button-checkout", children: /* @__PURE__ */ me.jsx(wn, { className: "ui button", to: "/checkout", children: "Checkout" }) }),
          !t || t.length === 0 && /* @__PURE__ */ me.jsx("div", { className: "empty-cart", children: "Cart is Empty" })
        ] }) })
      ] })
    ] });
  }
}
class tH extends R.Component {
  render() {
    const {
      products: t = []
    } = this.props;
    return /* @__PURE__ */ me.jsxs(ih, { trigger: /* @__PURE__ */ me.jsx("button", { className: "mobile-nine-dot-button", children: /* @__PURE__ */ me.jsx(Oi, { name: "nineDot" }) }), closeIcon: /* @__PURE__ */ me.jsx("button", { className: "modal__close", children: "Close" }), children: [
      /* @__PURE__ */ me.jsx(ih.Header, { children: "Products" }),
      /* @__PURE__ */ me.jsx(ih.Content, { children: /* @__PURE__ */ me.jsx(il, { columns: 3, className: "mobile-nine-dot-menu", children: t.map((n) => {
        let r = "";
        return n.hasAccess || (r += " nine-dot__item--disabled"), /* @__PURE__ */ me.jsx(il.Column, { children: /* @__PURE__ */ me.jsxs("a", { href: n.url, rel: "noopener noreferrer", target: "_blank", className: r, children: [
          /* @__PURE__ */ me.jsx("div", { className: "mobile-nine-dot-menu__icon", children: /* @__PURE__ */ me.jsx(bx, { colour: "#00a3c7", src: n.iconLogoLocation, alt: n.name }) }),
          /* @__PURE__ */ me.jsx("span", { children: n.name })
        ] }) }, n.id);
      }) }) })
    ] });
  }
}
let V0 = class extends gt.Component {
  constructor(n) {
    super(n);
    Wn(this, "onContextClick", () => {
      this.setState({
        contextMouseOut: !1
      }), this.state.contextMouseOut === !1 && this.setState({
        contextMenuOpen: !0
      });
    });
    Wn(this, "onContextMouseLeave", () => {
      this.setState({
        contextMouseOut: !0
      }), setTimeout((function() {
        this.state.contextMouseOut === !0 && this.setState({
          contextMenuOpen: !1
        });
      }).bind(this), 300);
    });
    Wn(this, "onContextMouseOver", () => {
      this.setState({
        contextMouseOut: !1
      });
    });
    Wn(this, "handleSearchInput", (n) => {
      this.setState({
        filterValue: n.target.value
      });
    });
    this.state = {
      contextMenuOpen: !1,
      contextMouseOut: !0,
      filterValue: ""
    };
  }
  render() {
    const {
      handleItemChange: n,
      contextType: r,
      items: i,
      currentItem: a
    } = this.props, o = parseInt(a), s = i.find((d) => d.id === o), l = this.state.filterValue || "", c = i.map(function(d) {
      const p = d.name.toLowerCase(), y = l.toLowerCase();
      if (p === y || p.includes(y) || y === "")
        return /* @__PURE__ */ me.jsx("li", { id: d.id, onClick: async () => {
          await n(d.id);
        }, children: d.name }, d.id);
    });
    return /* @__PURE__ */ me.jsxs("div", { onMouseOut: this.onContextMouseLeave, onMouseOver: this.onContextMouseOver, onBlur: this.onContextMouseLeave, className: `context-menu ${this.state.contextMenuOpen ? "context-menu--open" : ""}`, children: [
      /* @__PURE__ */ me.jsxs("div", { className: "context-menu__item", onClick: this.onContextClick, onFocus: this.onContextClick, children: [
        /* @__PURE__ */ me.jsxs("div", { className: "context-menu__item-text", children: [
          /* @__PURE__ */ me.jsx("div", { className: "context-menu__context-text", children: this.props.contextType }),
          /* @__PURE__ */ me.jsx("div", { className: "context-menu__selected-text", children: s ? s.name : "" })
        ] }),
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__item-icon", children: /* @__PURE__ */ me.jsx(Oi, { name: "dropDownArrow", className: `context-dropdown-arrow ${this.state.contextMenuOpen ? "context-dropdown-arrow--open" : ""}` }) })
      ] }),
      /* @__PURE__ */ me.jsxs("div", { className: `context-menu__dropdown ${this.state.contextMenuOpen ? "context-menu__dropdown--open" : ""}`, onMouseOver: this.onContextClick, onFocus: this.onContextClick, onMouseOut: this.onContextMouseLeave, onBlur: this.onContextMouseLeave, children: [
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__search-container", children: /* @__PURE__ */ me.jsx(A0, { className: "context-menu__search", iconPosition: "left", placeholder: `Filter ${r}...`, onChange: this.handleSearchInput, icon: "search" }) }),
        /* @__PURE__ */ me.jsxs("ul", { className: "context-menu__list", children: [
          c,
          typeof c[0] === void 0 && /* @__PURE__ */ me.jsx("li", { children: /* @__PURE__ */ me.jsx("em", { children: "No results" }) })
        ] })
      ] })
    ] });
  }
};
class wx extends R.Component {
  render() {
    const {
      onlineStoreAccountURL: t
    } = this.props;
    return /* @__PURE__ */ me.jsxs(R.Fragment, { children: [
      t && /* @__PURE__ */ me.jsxs(wn, { className: "profile__menu-item", to: t, children: [
        /* @__PURE__ */ me.jsx(Oi, { name: "gear", colour: "lightCyan" }),
        /* @__PURE__ */ me.jsx("span", { className: "profile__menu-item-name", children: "My Account" })
      ] }),
      !t && /* @__PURE__ */ me.jsxs(wn, { className: "profile__menu-item", to: "/settings", children: [
        /* @__PURE__ */ me.jsx(Oi, { name: "gear", colour: "lightCyan" }),
        /* @__PURE__ */ me.jsx("span", { className: "profile__menu-item-name", children: "Settings" })
      ] }),
      /* @__PURE__ */ me.jsxs(wn, { className: "profile__menu-item", to: "/logout", children: [
        /* @__PURE__ */ me.jsx(Oi, { name: "logout", colour: "lightCyan" }),
        /* @__PURE__ */ me.jsx("span", { className: "profile__menu-item-name", children: "Log Out" })
      ] })
    ] });
  }
}
class kf extends gt.Component {
  constructor(n) {
    super(n);
    Wn(this, "onContextClick", () => {
      this.setState({
        ...this.state,
        menuOpen: !this.state.menuOpen
      });
    });
    Wn(this, "handleSearchInput", (n) => {
      this.setState({
        filterValue: n.target.value
      });
    });
    this.state = {
      menuOpen: !1,
      filterValue: ""
    };
  }
  render() {
    const {
      handleItemChange: n,
      contextType: r,
      items: i,
      currentItem: a
    } = this.props, {
      menuOpen: o,
      filterValue: s
    } = this.state, l = r || "", c = parseInt(a), d = i.find((f) => f.id === c), p = s || "", y = i.map(function(f) {
      const N = f.name.toLowerCase(), b = p.toLowerCase();
      if (N === b || N.includes(b) || b === "")
        return /* @__PURE__ */ me.jsx("li", { id: f.id, onClick: async () => {
          await n(f.id);
        }, children: f.name }, f.id);
    });
    return /* @__PURE__ */ me.jsxs("div", { className: `context-menu ${o ? "context-menu--open" : ""}`, children: [
      i && i.length > 1 ? /* @__PURE__ */ me.jsxs("button", { className: "context-menu__item", onClick: this.onContextClick, children: [
        /* @__PURE__ */ me.jsxs("div", { className: "context-menu__item-text", children: [
          /* @__PURE__ */ me.jsx("div", { className: "context-menu__context-text", children: l }),
          /* @__PURE__ */ me.jsx("div", { className: "context-menu__selected-text", children: d ? d.name : "" })
        ] }),
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__item-icon", children: /* @__PURE__ */ me.jsx(Oi, { name: "dropDownArrow", className: `context-dropdown-arrow ${o ? "context-dropdown-arrow--open" : ""}` }) })
      ] }) : /* @__PURE__ */ me.jsx("div", { className: "context-menu__item context-menu__item--disabled", children: /* @__PURE__ */ me.jsxs("div", { className: "context-menu__item-text", children: [
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__context-text", children: l }),
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__selected-text", children: d ? d.name : "" })
      ] }) }),
      /* @__PURE__ */ me.jsxs("div", { className: `context-menu__dropdown ${o ? "context-menu__dropdown--open" : ""}`, children: [
        /* @__PURE__ */ me.jsx("div", { className: "context-menu__search-container", children: /* @__PURE__ */ me.jsx(A0, { className: "context-menu__search", iconPosition: "left", placeholder: `Filter ${l}...`, onChange: this.handleSearchInput, icon: "search" }) }),
        /* @__PURE__ */ me.jsxs("ul", { className: "context-menu__list", children: [
          y,
          typeof y[0] === void 0 && /* @__PURE__ */ me.jsx("li", { children: /* @__PURE__ */ me.jsx("em", { children: "No results" }) })
        ] })
      ] })
    ] });
  }
}
class nH extends gt.Component {
  constructor(n) {
    super(n);
    Wn(this, "onProfileClick", () => {
      this.setState({
        profileMouseOut: !1,
        profileMenuOpen: !0
      });
    });
    Wn(this, "onProfileMouseOver", () => {
      this.setState({
        profileMouseOut: !1
      });
    });
    Wn(this, "onProfileMouseLeave", () => {
      this.setState({
        profileMouseOut: !0
      }), setTimeout((function() {
        this.state.profileMouseOut === !0 && this.setState({
          profileMenuOpen: !1
        });
      }).bind(this), 300);
    });
    this.state = {
      profileMenuOpen: !1,
      profileMouseOut: !0
    };
  }
  render() {
    const {
      authUserName: n,
      onlineStoreAccountURL: r,
      organisations: i,
      teams: a,
      currentOrganisation: o,
      organisationChange: s,
      currentTeam: l,
      teamChange: c
    } = this.props;
    return /* @__PURE__ */ me.jsxs("div", { className: "profile", children: [
      /* @__PURE__ */ me.jsxs("div", { className: "profile__icon", onMouseOver: this.onProfileMouseOver, onFocus: this.onProfileMouseOver, onClick: this.onProfileClick, onMouseOut: this.onProfileMouseLeave, onBlur: this.onProfileMouseLeave, children: [
        i && i.length > 1 || a && a.length > 1 ? /* @__PURE__ */ me.jsx("span", { className: "profile__icon-text", children: /* @__PURE__ */ me.jsx("strong", { children: n }) }) : null,
        /* @__PURE__ */ me.jsx(Oi, { name: "userIcon", colour: "grey" }),
        /* @__PURE__ */ me.jsx(Oi, { name: "dropDownArrow", className: `dropdown-arrow ${this.state.profileMenuOpen ? "dropdown-arrow--open" : ""}` })
      ] }),
      /* @__PURE__ */ me.jsxs("div", { className: `profile__menu ${this.state.profileMenuOpen ? "profile__menu--open" : ""} ${i && i.length === 1 || a && a.length === 1 ? "profile__menu--org-team" : ""}`, onMouseOver: this.onProfileMouseOver, onFocus: this.onProfileMouseOver, onMouseOut: this.onProfileMouseLeave, onBlur: this.onProfileMouseLeave, children: [
        i && i.length <= 1 && a && a.length <= 1 ? /* @__PURE__ */ me.jsx("div", { className: "profile-menu__name", children: n }) : null,
        i && i.length === 1 ? /* @__PURE__ */ me.jsx(kf, { contextType: "Organisation", items: i, currentItem: o, handleItemChange: s }) : null,
        a && a.length === 1 ? /* @__PURE__ */ me.jsx(kf, { contextType: "Team", items: a, currentItem: l, handleItemChange: c }) : null,
        /* @__PURE__ */ me.jsx(wx, { onlineStoreAccountURL: r })
      ] })
    ] });
  }
}
class rH extends R.Component {
  render() {
    const {
      organisations: t,
      currentOrganisation: n,
      teams: r,
      currentTeam: i,
      organisationChange: a,
      teamChange: o,
      authUser: s,
      onlineStoreAccountURL: l
    } = this.props, c = s && s.name ? s.name : "";
    return /* @__PURE__ */ me.jsxs("div", { className: "user-menu", children: [
      t && t.length > 1 ? /* @__PURE__ */ me.jsx(V0, { contextType: "Organisation", items: t, currentItem: n, handleItemChange: a }) : null,
      r && r.length > 1 ? /* @__PURE__ */ me.jsx(V0, { contextType: "Team", items: r, currentItem: i, handleItemChange: o }) : null,
      /* @__PURE__ */ me.jsx(nH, { authUserName: c, onlineStoreAccountURL: l, organisations: t, teams: r, currentOrganisation: n, organisationChange: a, currentTeam: i, teamChange: o })
    ] });
  }
}
const iH = (e) => {
  const t = gr(null);
  return gn(() => {
    const n = (r) => {
      r.target instanceof Node && t.current && !t.current.contains(r.target) && e();
    };
    return document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [e]), t;
}, aH = (e) => {
  const [t, n] = R.useState(!1), r = R.useCallback(() => {
    n(!1);
  }, []), i = iH(r), a = () => {
    n(!t);
  }, {
    organisations: o,
    currentOrganisation: s,
    teams: l,
    currentTeam: c,
    organisationChange: d,
    teamChange: p,
    authUser: y,
    onlineStoreAccountURL: f
  } = e, N = y && y.name ? y.name : "";
  return /* @__PURE__ */ me.jsxs("div", { className: "compact-user-menu", ref: i, children: [
    /* @__PURE__ */ me.jsxs("button", { className: "compact-user-menu__icon", onClick: a, children: [
      /* @__PURE__ */ me.jsx(Oi, { name: "userIcon", colour: "grey" }),
      /* @__PURE__ */ me.jsx(Oi, { name: "dropDownArrow", className: `dropdown-arrow ${t ? "dropdown-arrow--open" : ""}` })
    ] }),
    /* @__PURE__ */ me.jsxs("div", { className: `compact-user-menu__dropdown ${t ? "compact-user-menu__dropdown--open" : ""}`, children: [
      /* @__PURE__ */ me.jsx("div", { className: "compact-user-menu__name", children: N }),
      o && o.length > 0 ? /* @__PURE__ */ me.jsx(kf, { contextType: "Organisation", items: o, currentItem: s, handleItemChange: d }) : null,
      l && l.length > 0 ? /* @__PURE__ */ me.jsx(kf, { contextType: "Team", items: l, currentItem: c, handleItemChange: p }) : null,
      /* @__PURE__ */ me.jsx(wx, { onlineStoreAccountURL: f })
    ] })
  ] });
}, T1 = (e = 1e3) => {
  const [t, n] = oi(!1);
  return gn(() => {
    const r = window.matchMedia(`(max-width: ${e}px)`);
    n(r.matches);
    const i = (a) => {
      n(a.matches);
    };
    return r.addEventListener("change", i), () => {
      r.removeEventListener("change", i);
    };
  }, [e]), t;
}, W0 = ({
  userMenuBreakpoint: e = 1100,
  organisations: t,
  teams: n,
  ...r
}) => {
  const i = T1(e);
  let a = e;
  const o = 170;
  return t && t.length <= 1 && (a -= o), n && n.length <= 1 && (a -= o), /* @__PURE__ */ me.jsx(me.Fragment, { children: i ? /* @__PURE__ */ me.jsx(aH, { organisations: t, teams: n, userMenuBreakpoint: a, ...r }) : /* @__PURE__ */ me.jsx(rH, { organisations: t, teams: n, userMenuBreakpoint: a, ...r }) });
};
function Df({
  logoUrl: e,
  onNavigate: t
}) {
  return /* @__PURE__ */ me.jsx(R.Fragment, { children: /* @__PURE__ */ me.jsx(J0, { src: e || "/src/assets/images/logos/rmr_live_logo_0,25x.png", as: wn, to: "/", className: "nav-menu__logo-link", onClick: t }) });
}
class xx extends R.Component {
  render() {
    const {
      headerRight: t,
      headerCenter: n,
      items: r,
      footer: i,
      onNavigate: a,
      onToggleNavMenu: o,
      navMenuOpen: s
    } = this.props;
    return /* @__PURE__ */ me.jsxs("nav", { className: `mobile-menu ${s ? "open" : ""}`, children: [
      /* @__PURE__ */ me.jsxs("header", { className: "mobile-menu__header", children: [
        /* @__PURE__ */ me.jsx("button", { className: `mobile-menu__button ${s ? "open" : ""}`, onClick: o, children: /* @__PURE__ */ me.jsx("span", {}) }),
        n,
        t
      ] }),
      /* @__PURE__ */ me.jsxs("div", { className: `mobile-menu__dropdown ${s ? "open" : ""}`, children: [
        /* @__PURE__ */ me.jsx("div", { onClick: a, children: r }),
        i
      ] })
    ] });
  }
}
var nf = {}, H0;
function oH() {
  if (H0) return nf;
  H0 = 1, nf.match = a, nf.parse = o;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, t = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, n = /^(?:(min|max)-)?(.+)/, r = /(em|rem|px|cm|mm|in|pt|pc)?$/, i = /(dpi|dpcm|dppx)?$/;
  function a(d, p) {
    return o(d).some(function(y) {
      var f = y.inverse, N = y.type === "all" || p.type === y.type;
      if (N && f || !(N || f))
        return !1;
      var b = y.expressions.every(function(S) {
        var _ = S.feature, E = S.modifier, k = S.value, M = p[_];
        if (!M)
          return !1;
        switch (_) {
          case "orientation":
          case "scan":
            return M.toLowerCase() === k.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            k = c(k), M = c(M);
            break;
          case "resolution":
            k = l(k), M = l(M);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            k = s(k), M = s(M);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            k = parseInt(k, 10) || 1, M = parseInt(M, 10) || 0;
            break;
        }
        switch (E) {
          case "min":
            return M >= k;
          case "max":
            return M <= k;
          default:
            return M === k;
        }
      });
      return b && !f || !b && f;
    });
  }
  function o(d) {
    return d.split(",").map(function(p) {
      p = p.trim();
      var y = p.match(e), f = y[1], N = y[2], b = y[3] || "", S = {};
      return S.inverse = !!f && f.toLowerCase() === "not", S.type = N ? N.toLowerCase() : "all", b = b.match(/\([^\)]+\)/g) || [], S.expressions = b.map(function(_) {
        var E = _.match(t), k = E[1].toLowerCase().match(n);
        return {
          modifier: k[1],
          feature: k[2],
          value: E[2]
        };
      }), S;
    });
  }
  function s(d) {
    var p = Number(d), y;
    return p || (y = d.match(/^(\d+)\s*\/\s*(\d+)$/), p = y[1] / y[2]), p;
  }
  function l(d) {
    var p = parseFloat(d), y = String(d).match(i)[1];
    switch (y) {
      case "dpcm":
        return p / 2.54;
      case "dppx":
        return p * 96;
      default:
        return p;
    }
  }
  function c(d) {
    var p = parseFloat(d), y = String(d).match(r)[1];
    switch (y) {
      case "em":
        return p * 16;
      case "rem":
        return p * 16;
      case "cm":
        return p * 96 / 2.54;
      case "mm":
        return p * 96 / 2.54 / 10;
      case "in":
        return p * 96;
      case "pt":
        return p * 72;
      case "pc":
        return p * 72 / 12;
      default:
        return p;
    }
  }
  return nf;
}
var Zh, $0;
function sH() {
  if ($0) return Zh;
  $0 = 1;
  var e = oH().match, t = typeof window < "u" ? window.matchMedia : null;
  function n(i, a, o) {
    var s = this, l;
    t && !o && (l = t.call(window, i)), l ? (this.matches = l.matches, this.media = l.media, l.addListener(p)) : (this.matches = e(i, a), this.media = i), this.addListener = c, this.removeListener = d, this.dispose = y;
    function c(f) {
      l && l.addListener(f);
    }
    function d(f) {
      l && l.removeListener(f);
    }
    function p(f) {
      s.matches = f.matches, s.media = f.media;
    }
    function y() {
      l && l.removeListener(p);
    }
  }
  function r(i, a, o) {
    return new n(i, a, o);
  }
  return Zh = r, Zh;
}
var lH = sH();
const cH = /* @__PURE__ */ x_(lH);
var uH = /[A-Z]/g, dH = /^ms-/, Jh = {};
function fH(e) {
  return "-" + e.toLowerCase();
}
function _x(e) {
  if (Jh.hasOwnProperty(e))
    return Jh[e];
  var t = e.replace(uH, fH);
  return Jh[e] = dH.test(t) ? "-" + t : t;
}
function pH(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  const n = Object.keys(e), r = Object.keys(t), i = n.length;
  if (r.length !== i)
    return !1;
  for (let a = 0; a < i; a++) {
    const o = n[a];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
const Ir = Zt.oneOfType([Zt.string, Zt.number]), Nx = {
  all: Zt.bool,
  grid: Zt.bool,
  aural: Zt.bool,
  braille: Zt.bool,
  handheld: Zt.bool,
  print: Zt.bool,
  projection: Zt.bool,
  screen: Zt.bool,
  tty: Zt.bool,
  tv: Zt.bool,
  embossed: Zt.bool
}, hH = {
  orientation: Zt.oneOf(["portrait", "landscape"]),
  scan: Zt.oneOf(["progressive", "interlace"]),
  aspectRatio: Zt.string,
  deviceAspectRatio: Zt.string,
  height: Ir,
  deviceHeight: Ir,
  width: Ir,
  deviceWidth: Ir,
  color: Zt.bool,
  colorIndex: Zt.bool,
  monochrome: Zt.bool,
  resolution: Ir,
  type: Object.keys(Nx)
}, { ...mH } = hH, gH = {
  minAspectRatio: Zt.string,
  maxAspectRatio: Zt.string,
  minDeviceAspectRatio: Zt.string,
  maxDeviceAspectRatio: Zt.string,
  minHeight: Ir,
  maxHeight: Ir,
  minDeviceHeight: Ir,
  maxDeviceHeight: Ir,
  minWidth: Ir,
  maxWidth: Ir,
  minDeviceWidth: Ir,
  maxDeviceWidth: Ir,
  minColor: Zt.number,
  maxColor: Zt.number,
  minColorIndex: Zt.number,
  maxColorIndex: Zt.number,
  minMonochrome: Zt.number,
  maxMonochrome: Zt.number,
  minResolution: Ir,
  maxResolution: Ir,
  ...mH
}, yH = { ...Nx, ...gH };
var vH = {
  all: yH
};
const bH = (e) => `not ${e}`, wH = (e, t) => {
  const n = _x(e);
  return typeof t == "number" && (t = `${t}px`), t === !0 ? n : t === !1 ? bH(n) : `(${n}: ${t})`;
}, xH = (e) => e.join(" and "), _H = (e) => {
  const t = [];
  return Object.keys(vH.all).forEach((n) => {
    const r = e[n];
    r != null && t.push(wH(n, r));
  }), xH(t);
}, NH = g_(void 0), SH = (e) => e.query || _H(e), G0 = (e) => e ? Object.keys(e).reduce((n, r) => (n[_x(r)] = e[r], n), {}) : void 0, Sx = () => {
  const e = gr(!1);
  return gn(() => {
    e.current = !0;
  }, []), e.current;
}, EH = (e) => {
  const t = m_(NH), n = () => G0(e) || G0(t), [r, i] = oi(n);
  return gn(() => {
    const a = n();
    pH(r, a) || i(a);
  }, [e, t]), r;
}, CH = (e) => {
  const t = () => SH(e), [n, r] = oi(t);
  return gn(() => {
    const i = t();
    n !== i && r(i);
  }, [e]), n;
}, OH = (e, t) => {
  const n = () => cH(e, t || {}, !!t), [r, i] = oi(n), a = Sx();
  return gn(() => {
    if (a) {
      const o = n();
      return i(o), () => {
        o && o.dispose();
      };
    }
  }, [e, t]), r;
}, jH = (e) => {
  const [t, n] = oi(e.matches);
  return gn(() => {
    const r = (i) => {
      n(i.matches);
    };
    return e.addListener(r), n(e.matches), () => {
      e.removeListener(r);
    };
  }, [e]), t;
}, PH = (e, t, n) => {
  const r = EH(t), i = CH(e);
  if (!i)
    throw new Error("Invalid or missing MediaQuery!");
  const a = OH(i, r), o = jH(a), s = Sx();
  return gn(() => {
    s && n && n(o);
  }, [o]), gn(() => () => {
    a && a.dispose();
  }, []), o;
}, Q0 = ({ children: e, device: t, onChange: n, ...r }) => {
  const i = PH(r, t, n);
  return typeof e == "function" ? e(i) : i ? e : null;
}, LH = (e) => {
  if (!e || e.startsWith("/")) return !1;
  try {
    return new URL(e).origin !== window.location.origin;
  } catch {
    return !1;
  }
}, ig = ({
  menuItem: e
}) => {
  const t = `nav-menu__nav-link ${e.parent && e.parent > 0 ? "nav-menu__nav-link-child" : ""}`;
  return LH(e.url) ? /* @__PURE__ */ me.jsx("a", { href: e.url, className: `item ${t}`, "data-testid": "link-external", target: e.target, children: e.title }) : /* @__PURE__ */ me.jsx(Ni.Item, { as: $c, to: e.url, target: e.target, name: e.title, className: t, activeClassName: "nav-menu__nav-link--active", exact: !0, "data-testid": "link-internal" });
}, TH = 50, FH = ({
  menuItem: e,
  onNavLinkClick: t,
  linkClassName: n
}) => {
  const r = sg(), [i, a] = R.useState(!0), o = (c) => {
    const d = document.getElementById(c);
    d && window.scroll({
      top: d.offsetTop - TH,
      left: 0,
      behavior: "instant"
    });
  };
  R.useEffect(() => {
    if (i && r.hash) {
      const c = r.hash.slice(1), d = new MutationObserver((p, y) => {
        document.getElementById(c) && (o(c), a(!1), y.disconnect());
      });
      return document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => {
        document.body && d.observe(document.body, {
          childList: !0,
          subtree: !0
        });
      }) : document.body && d.observe(document.body, {
        childList: !0,
        subtree: !0
      }), () => {
        d.disconnect();
      };
    }
  }, [r.hash, i]);
  const s = (c) => {
    if (!c || c.startsWith("/")) return !1;
    try {
      return new URL(c).origin !== window.location.origin;
    } catch {
      return !1;
    }
  }, l = (c) => {
    t(c);
    const d = e.url.split("#").pop();
    d && o(d);
  };
  return s(e.url) ? /* @__PURE__ */ me.jsx("a", { href: e.url, target: "_blank", rel: "noopener noreferrer", "data-testid": "link-external", className: n, children: e.title }) : e.url.includes("#") ? /* @__PURE__ */ me.jsx(wn, { to: e.url, onClick: l, "data-testid": "link-hash", className: n, children: e.title }) : /* @__PURE__ */ me.jsx(wn, { to: e.url, onClick: t, "data-testid": "link-no-hash", className: n, children: e.title });
}, Ex = ({
  menuItem: e,
  pathname: t,
  child: n = !1,
  mobileBreakpoint: r
}) => {
  const i = Ol(), [a, o] = R.useState(!1), s = () => o(!0), l = () => o(!1), c = (f, N) => {
    f.stopPropagation(), l();
  }, d = () => {
    l(), i(e.url);
  }, p = w_({
    "nav-menu__dropdown": n === !1,
    "nav-menu__dropdown--link": n,
    "nav-menu__dropdown--active": t.lastIndexOf(e.url, 0) === 0
  }), y = (f, N) => f.children ? /* @__PURE__ */ me.jsx(Ex, { menuItem: f, pathname: t, child: !0, mobileBreakpoint: r }, `menuChildItem_${N}`) : f.url.includes("#") ? /* @__PURE__ */ me.jsx(FH, { menuItem: f, onNavLinkClick: c, linkClassName: `nav-menu__nav-link ${f.parent && f.parent > 0 ? "nav-menu__nav-link-child" : ""}` }, `menuChildItem_${N}`) : /* @__PURE__ */ me.jsx(ig, { menuItem: f }, `menuChildItem_${N}`);
  return /* @__PURE__ */ me.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ me.jsx(Q0, { minWidth: r, children: /* @__PURE__ */ me.jsx(ah, { item: !0, className: p, open: a, onMouseEnter: s, onMouseLeave: l, onClick: d, text: e.title, children: /* @__PURE__ */ me.jsx(ah.Menu, { onClick: (f, N) => f.stopPropagation(), children: e.children && e.children.map((f, N) => /* @__PURE__ */ me.jsx(ah.Item, { children: y(f, N) }, `menuChildItem_${N}`)) }) }) }),
    /* @__PURE__ */ me.jsxs(Q0, { maxWidth: r - 1, children: [
      /* @__PURE__ */ me.jsx(ig, { menuItem: e }),
      e.children && e.children.map((f, N) => y(f, N))
    ] })
  ] });
};
function Y0({
  authUser: e,
  loadedMenu: t,
  pathname: n,
  history: r,
  mobileBreakpoint: i
}) {
  return /* @__PURE__ */ me.jsx(gt.Fragment, { children: e ? /* @__PURE__ */ me.jsx(Ni.Menu, { children: t && t.items && t.items.map((a, o) => /* @__PURE__ */ me.jsx(gt.Fragment, { children: a.children && n ? /* @__PURE__ */ me.jsx(Ex, { menuItem: a, pathname: n, mobileBreakpoint: i }) : /* @__PURE__ */ me.jsx(ig, { menuItem: a }) }, a.id)) }) : "" });
}
function IH({
  authUser: e,
  organisations: t,
  teams: n,
  currentTeam: r,
  currentOrganisation: i,
  organisationChange: a,
  teamChange: o,
  products: s,
  cartItems: l,
  cartIcon: c,
  onlineStoreAccountURL: d,
  switchTo: p,
  productFamilyId: y,
  onToggleNavMenu: f,
  onMenuMouseOver: N,
  onMenuMouseLeave: b,
  navMenuOpen: S,
  megaMenuOpen: _,
  logoUrl: E,
  onNavigate: k,
  removeFromCart: M,
  children: F,
  userMenuBreakpoint: q,
  mobileBreakpoint: j = 1e3,
  loadedMenu: x,
  pathname: C,
  history: D
}) {
  const P = () => /* @__PURE__ */ me.jsxs("div", { className: "mobile-menu__header-right", children: [
    /* @__PURE__ */ me.jsx(W0, { organisations: t, userMenuBreakpoint: q, currentOrganisation: i, teams: n, currentTeam: r, organisationChange: a, teamChange: o, authUser: e, onlineStoreAccountURL: d }),
    /* @__PURE__ */ me.jsx(tH, { products: s })
  ] }), L = () => /* @__PURE__ */ me.jsx(Df, { logoUrl: E, onNavigate: k, mobileBreakpoint: j }), H = () => /* @__PURE__ */ me.jsxs(gt.Fragment, { children: [
    /* @__PURE__ */ me.jsx(Y0, { loadedMenu: x, pathname: C, history: D, authUser: e, mobileBreakpoint: j }),
    F
  ] }), $ = () => /* @__PURE__ */ me.jsx(gt.Fragment, { children: l ? /* @__PURE__ */ me.jsx(If, { cartItems: l, cartIcon: c, removeFromCart: M, displayForMobile: !0, onNavigate: k }) : null }), ae = T1(j);
  return /* @__PURE__ */ me.jsx("div", { "data-testid": "authenticated-menu", children: ae ? /* @__PURE__ */ me.jsx(xx, { navMenuOpen: S, onToggleNavMenu: f, onNavigate: k, headerCenter: /* @__PURE__ */ me.jsx(L, {}), headerRight: /* @__PURE__ */ me.jsx(P, {}), items: /* @__PURE__ */ me.jsx(H, {}), footer: /* @__PURE__ */ me.jsx($, {}) }) : /* @__PURE__ */ me.jsxs(Ni, { borderless: !0, stackable: !0, fixed: "top", onMouseOver: N, onFocus: N, onMouseLeave: b, onBlur: b, className: `nav-menu nav-menu--small ${S ? "nav-menu--open" : ""} ${_ ? "nav-menu--mega-menu-open" : ""}`, children: [
    /* @__PURE__ */ me.jsx(Ni.Item, { header: !0, fitted: !0, className: "nav-menu__header", children: /* @__PURE__ */ me.jsx(Df, { onToggleNavMenu: f, logoUrl: E, onNavigate: k }) }),
    /* @__PURE__ */ me.jsx(Y0, { loadedMenu: x, pathname: C, history: D, authUser: e, mobileBreakpoint: j }),
    F,
    /* @__PURE__ */ me.jsxs(Ni.Menu, { position: "right", children: [
      l && /* @__PURE__ */ me.jsx(If, { cartItems: l, cartIcon: c, removeFromCart: M, displayForMobile: !1 }),
      /* @__PURE__ */ me.jsx(Ni.Item, { as: W0, organisations: t, userMenuBreakpoint: q, currentOrganisation: i, teams: n, currentTeam: r, organisationChange: a, teamChange: o, authUser: e, onlineStoreAccountURL: d }),
      /* @__PURE__ */ me.jsx(Ni.Item, { as: eH, products: s, switchTo: p })
    ] })
  ] }) });
}
function kH({
  showLogin: e,
  publicNav: t,
  navMenuOpen: n,
  megaMenuOpen: r,
  cartItems: i,
  cartIcon: a,
  logoUrl: o,
  children: s,
  removeFromCart: l,
  onToggleNavMenu: c,
  onNavigate: d,
  mobileBreakpoint: p = 1e3
}) {
  const y = () => e ? /* @__PURE__ */ me.jsx(Ah, { as: wn, to: "/login", className: "mobile-menu__login am_banner_login", children: "Log In" }) : /* @__PURE__ */ me.jsx("div", {}), f = () => /* @__PURE__ */ me.jsx(Df, { onToggleNavMenu: c, logoUrl: o, onNavigate: d, mobileBreakpoint: p }), N = () => /* @__PURE__ */ me.jsx(R.Fragment, { children: s }), b = () => /* @__PURE__ */ me.jsx(R.Fragment, { children: i ? /* @__PURE__ */ me.jsx(If, { cartItems: i, cartIcon: a, removeFromCart: l, displayForMobile: !0 }) : null }), S = T1(p);
  return /* @__PURE__ */ me.jsxs("div", { "data-testid": "unauthenticated-menu", children: [
    S ? /* @__PURE__ */ me.jsx(xx, { navMenuOpen: n, onNavigate: d, onToggleNavMenu: c, headerCenter: /* @__PURE__ */ me.jsx(f, {}), headerRight: /* @__PURE__ */ me.jsx(y, {}), items: /* @__PURE__ */ me.jsx(N, {}), footer: /* @__PURE__ */ me.jsx(b, {}) }) : null,
    /* @__PURE__ */ me.jsxs(Ni, { borderless: !0, fixed: "top", stackable: !0, className: `nav-menu nav-menu--small ${n ? "nav-menu--open" : ""} ${r ? "nav-menu--mega-menu-open" : ""}`, children: [
      /* @__PURE__ */ me.jsx(Ni.Item, { header: !0, fitted: !0, className: "nav-menu__header", children: /* @__PURE__ */ me.jsx(Df, { onToggleNavMenu: c, logoUrl: o, onNavigate: d }) }),
      t && s,
      /* @__PURE__ */ me.jsxs(Ni.Menu, { position: "right", children: [
        i && /* @__PURE__ */ me.jsx(If, { cartItems: i, cartIcon: a, removeFromCart: l, displayForMobile: !1 }),
        /* @__PURE__ */ me.jsx(Ni.Item, { children: e && /* @__PURE__ */ me.jsx(Ah, { as: wn, to: "/login", className: "show-for-small am_banner_login", children: "Log In" }) })
      ] })
    ] })
  ] });
}
const DH = process.env.REACT_APP_RM_ENV && process.env.REACT_APP_RM_ENV === "prod" ? "https://livecms.roymorgan.com" : process.env.REACT_APP_RM_ENV && process.env.REACT_APP_RM_ENV === "uat" ? "https://livecms.roymorganuat.com" : "https://livecms.roymorgandev.com", RH = async ({
  method: e,
  targetUrl: t,
  token: n,
  headers: r,
  body: i
}) => {
  const a = await fetch(t, {
    method: e,
    headers: r,
    body: JSON.stringify(i)
  });
  if (!a.ok) {
    const s = await a.json(), l = Error("Invalid API Response");
    throw l.msg = s.errors ? s.errors[0].message : s.statusMessage ? s.statusMessage : "API Error", l;
  }
  return await a.json();
}, Cx = "MENU_REQUEST", Ox = "MENU_SUCCESS", jx = "MENU_FAILURE", MH = () => ({
  type: Cx
}), UH = (e) => ({
  type: Ox,
  payload: e
}), BH = (e) => ({
  type: jx,
  error: e
}), zH = (e) => async (t, n) => {
  try {
    const r = {}, i = Yn();
    t(MH());
    const a = await RH({
      method: "GET",
      targetUrl: `${DH}/wp-json/wp-api-menus/v2/menus/${e}`,
      token: i,
      headers: r
    });
    if (a instanceof Error)
      throw a;
    t(UH(a));
  } catch (r) {
    t(BH(r));
  }
};
class qH extends R.Component {
  constructor(n) {
    super(n);
    Wn(this, "onToggleNavMenu", () => {
      this.setState({
        navMenuOpen: !this.state.navMenuOpen
      });
    });
    Wn(this, "onNavigate", () => {
      this.setState({
        navMenuOpen: !1,
        megaMenuOpen: !1,
        productsMouseOut: !0,
        menuMouseOut: !0
      });
    });
    Wn(this, "onProductsMouseOver", () => {
      this.setState({
        productsMouseOut: !1
      }), setTimeout((function() {
        this.state.productsMouseOut === !1 && this.setState({
          megaMenuOpen: !0
        });
      }).bind(this), 300);
    });
    Wn(this, "onMenuMouseOver", () => {
      this.setState({
        menuMouseOut: !1
      });
    });
    Wn(this, "onProductsMouseLeave", () => {
      this.setState({
        productsMouseOut: !0
      });
    });
    Wn(this, "onMenuMouseLeave", () => {
      this.setState({
        menuMouseOut: !0
      }), setTimeout((function() {
        this.state.menuMouseOut === !0 && this.setState({
          megaMenuOpen: !1
        });
      }).bind(this), 300);
    });
    this.state = {
      navMenuOpen: !1,
      megaMenuOpen: !1,
      productsMouseOut: !0,
      menuMouseOut: !0,
      loadedMenu: {}
    };
  }
  componentDidMount() {
    this.props.loadMenu(this.props.managedMenuSlug);
  }
  componentDidUpdate(n) {
    this.props.pathname !== n.pathname && this.setState({
      navMenuOpen: !1,
      megaMenuOpen: !1
    });
  }
  render() {
    const {
      authUser: n
    } = this.props, r = {
      ...this.props,
      ...this.state,
      loadedMenu: this.props.loadedMenu,
      onToggleNavMenu: this.onToggleNavMenu,
      onNavigate: this.onNavigate,
      organisationChange: this.props.organisationChange || (() => {
      }),
      teamChange: this.props.teamChange || (() => {
      })
    };
    return n && n.id ? /* @__PURE__ */ me.jsx("div", { children: /* @__PURE__ */ me.jsx(IH, { ...r, authUser: n, onMenuMouseOver: this.onMenuMouseOver, onMenuMouseLeave: this.onMenuMouseLeave }) }) : /* @__PURE__ */ me.jsx("div", { children: /* @__PURE__ */ me.jsx(kH, { ...r }) });
  }
}
const VH = (e, t) => ({
  loadedMenu: e.header.managedMenu.menu
}), WH = (e) => jN({
  loadMenu: zH
}, e), e$ = vN(VH, WH)(qH), HH = {
  isFetching: !1
}, $H = (e = HH, t) => {
  switch (t.type) {
    case Cx:
      return {
        ...e,
        isFetching: !0
      };
    case Ox:
      return {
        menu: {
          ...t.payload
        },
        isFetching: !1
      };
    case jx:
      return {
        ...e,
        menu: {},
        isFetching: !1,
        error: t.error
      };
    default:
      return e;
  }
}, t$ = ON({
  managedMenu: $H
});
export {
  OF as $,
  Ex as M,
  e$ as N,
  ha as d,
  t$ as h,
  xn as m
};
